import {
  Component,
  OnInit,
  ElementRef,
  Input,
  Injector,
  ViewChild,
  HostListener,
  Renderer2,
  ChangeDetectorRef,
  QueryList,
  OnDestroy,
} from '@angular/core';
import { TaskService } from 'src/app/services/task.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CollectionPopupComponent } from '../shared';
import * as JSZipUtils from '../../../assets/script/jszip-utils.js';
import * as JSZip from 'jszip';
import { saveAs } from 'file-saver';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
var turf = require('@turf/turf');
import { environment } from 'src/environments/environment';
import { ApiService } from 'src/app/services/api.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatSelect } from '@angular/material/select';
import { PopupService } from 'src/app/services/popup.service';
import { DownloadService, DownloadTarget } from 'src/app/services/download.service';
import {
  ObservationVesselService,
  VesselObservationResult,
} from 'src/app/services/observation-vessel.service';
import {
  EMPTY,
  Observable,
  Subject,
  ReplaySubject,
  merge,
  Subscription,
  catchError,
  finalize,
  firstValueFrom,
  forkJoin,
  map,
  of,
  switchMap,
  take,
  takeUntil,
  tap,
  timeout,
} from 'rxjs';
import {
  DEFAULT_ZOOMLEVEL,
  OPERATORS,
  ZOOM_SCALES,
  feedsConfig,
  ASSOCIATED_FEED_LIGHT_MAGENTA,
  ANNOTATION,
  POINT_TASKING,
  VESSEL_PREDICTION,
  SOIL_MOISTURE_SAR_CLASS_MAP, VESSEL_CLASS_COLOR_MAP, VEHICLE_CLASS_COLOR_MAP,
  PDF_REPORT,FLOOD_INUNDATION_DEPTH_CLASS_MAP,
  PREDICTION_FEED_TYPES, PREDICTION_FILTER_TYPES, getPredictionFeedMeta, isPredictionFeedType, isPredictionFilterType,
  IMAGE_ATTRIBUTION_SUPPLIERS
} from 'src/app/services/constants';
import { BehaviorSubject } from 'rxjs';
import { DatePipe, formatDate } from '@angular/common';
import { ReturnRefundComponent } from '../collections/return-refund/return-refund.component';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { PredictionDriftController } from './prediction-drift/prediction-drift.controller';
import { PredictionDriftHost } from './prediction-drift/prediction-drift.types';
import { DataService } from 'src/app/services/data.service';
import { ThemeService } from 'src/app/services/theme.service';
import { FilterPopupComponent } from '../collections/filter-popup/filter-popup.component';
import { baseLayers, overlays } from '../../config/baseLayer';
import * as L from 'leaflet';
import 'leaflet-draw';
import 'proj4';
import { SplitMap } from 'src/lib/leaflet-compare';
import parseGeoRaster from 'georaster';
import GeoRasterLayer from 'georaster-layer-for-leaflet';
import chroma from 'chroma-js';
import { AuthService } from 'src/app/services/auth.service';
import { GeoSearchControl, OpenStreetMapProvider } from 'leaflet-geosearch';
import { CreateTaskConfirmDialog } from '../collections/confirm-dialog/confirmdialog';
import { UserService } from 'src/app/services/user.service';
import { WarningPopupComponent } from '../collections/warning-popup/warning-popup.component';
import { UtilsService } from 'src/app/services/utils.service';
import { HelperService, FeedLine, FeedSection } from 'src/app/services/helper.service';
import { FeedFilterService } from 'src/app/services/feed-filter.service';
import { MgrsHelperService } from 'src/app/services/mgrs-helper.service';
import { MapResolutionZoomService } from 'src/app/services/map-resolution-zoom.service';
import { WeatherExMapController } from './weatherex/weatherex-map.controller';
import { WeatherExHost } from './weatherex/weatherex-map.types';
import { ChangeDetectionController } from './changedetection/change-detection.controller';
import {
  ChangeDetectionHost,
  ViewportGeojsonHost,
  ViewportGeojsonSession,
} from './changedetection/change-detection.types';
import {
  ViewportGeojsonController,
} from './changedetection/viewport-geojson.controller';
import {
  ViewportWfsService,
} from './changedetection/viewport-wfs.service';
import { ObservationViewportController } from './changedetection/observation-viewport.controller';
import {
  buildObservationTooltipContent,
  renderThermalObservation,
} from './thermal-observation.helper';
import {
  COLORISATION_LEGEND,
  isColorisationDisabled,
  toggleColorisationLayer,
} from './sar-colorisation.helper';
import { getWmsReadiness } from '../../shared/map/wms-readiness';
import { QuestionWmsHandoffController } from './question-wms-handoff.controller';
import { isWmsReady } from '../../shared/map/wms-readiness';
import { FeedLegendController, FeedLegendPane } from './changedetection/feed-legend.controller';
import { MatCheckbox } from '@angular/material/checkbox';
import type {
  FeatureCollection,
  Feature,
  Geometry,
  GeoJsonProperties,
} from 'geojson';
import { attachVesselHoverPopup, attachForecastPointHoverPopup } from '../../services/map-tooltip-helper.service';
import { STRINGCONSTANTS } from '../../shared/constants/app-strings.constants';
import { bearingDeg } from 'src/app/shared/utils/geo.utils';
import {
  PredictionMarker,
  ProjectInfo,
} from '../../shared/models/collection.models';
import {
  cwsiCategories,
  mbsiCategories,
  ncciCategories,
  osiCategories,
  ndtiCategories,
  ndmiCategories,
  ndreCategories,
  ndviCategories,
  tvdiCategories,
} from 'src/app/shared/constants/indices-color.constants';
import { getIndicesColor } from 'src/app/shared/utils/indicies-color-picker';
import { IndicesDownloadService } from 'src/app/shared/service/download-indices.service';
import { OperationManagerService } from 'src/app/shared/service/operation-manager.service';
import { WarningPopup } from '../shared/warning-popup/warning-popup';
import { tiffLayerModel } from 'src/app/shared/models/tif-layer.model';
import { SoilMoistureSarClassMap } from 'src/app/shared/models/soil-moisture-model';
import { createNavigationGlobalIcon } from 'src/app/shared/service/icon.service';
import { BandSelectorComponent } from '../shared/band-selector/band-selector.component';
import { ActivatedRoute, Router } from '@angular/router';
import { CollectionReportDialogComponent } from './collection-report-dialog/collection-report-dialog.component';
import {
  captureElementAsJpegBlob,
  captureLeafletCompareElementAsJpegBlob,
} from './collection-report/collection-report.utils';
import { buildCollectionReportSelectionsSummaryText } from './collection-report/collection-report.builder';
import { AisstreamPlaybackController } from './ais/aisstream/aisstream-playback.controller';
import {
  PlaybackDaterangeModalComponent,
  PlaybackDaterangeResult,
} from './ais/shared/toolbar/playback-daterange-modal/playback-daterange-modal.component';
import { PlaybackLoadingComponent } from './ais/shared/toolbar/playback-loading/playback-loading.component';
import {
  SENSOR_TOOLBAR_CONFIGS,
  SensorToolbarConfig,
} from './ais/shared/contracts/toolbar-control.tokens';
import { VoyageRadarPlaybackController } from './ais/voyage-radar/voyage-radar-playback.controller';
import { buildVesselPopup } from './ais/voyage-radar/vessel-popup';
import {
  toVoyageVesselFeature,
  toVoyageVesselList,
} from './ais/voyage-radar/gateways/vr-vessel-geojson';
import { VoyageMapController } from './ais/voyage-radar/voyage-map.controller';

import {
  VoyageHistoryBrowserComponent,
  VoyageHistoryBrowserResult,
} from './ais/voyage-radar/panels/history-browser/voyage-history-browser.component';
import {
  resolveVesselIdentity,
  voyageTrackFileName,
} from './ais/voyage-radar/panels/track-history/voyage-track-history.model';
import {
  isVoyageToiNotStarted,
  VOYAGE_TOI_NOT_STARTED_MESSAGE,
  VoyageRefreshState,
} from './ais/voyage-radar/panels/sensor-row/voyage-sensor-row.model';
import { AisObservationFocus } from './ais/shared/panels/ais-observations/ais-observations.component';
import {
  AIS_OBSERVATION_TOLERANCE_M,
  AisObservationView,
  buildAisObservations,
  matchedAisObservationFeatures,
} from './ais/shared/models/ais-observations.model';
import { normalizeVoyageHistory } from './ais/voyage-radar/panels/refresh-history/voyage-refresh-history.model';
import {
  canRequestVoyageRefund as canRequestVoyageRefundRule,
  hasVoyageToiFinished,
  syncWalletFromError,
  voyageCreditsRemaining,
  voyageSpendErrorMessage,
  VOYAGE_TOI_ENDED_MESSAGE,
} from './ais/voyage-radar/voyage-credits.model';
import {
  actionsForTarget,
  canAfford,
  isPoiSensor,
  minActionCredits,
  normalizeCreditActions,
  refreshActionKey,
  refreshCredits,
} from 'src/app/services/operators/voyageradar-credit-actions';
import { VoyageCreditRefundComponent } from './ais/voyage-radar/panels/credit-refund/voyage-credit-refund.component';
import { VoyageTrackController } from './ais/voyage-radar/toolbar/track.controller';
import { VoyageVesselController } from './ais/voyage-radar/toolbar/located-vessels.controller';
import { VoyagePortCallsService } from './ais/voyage-radar/services/port-calls.service';
import { VoyageNearbyService } from './ais/voyage-radar/services/nearby.service';
import { VoyageSearchService } from './ais/voyage-radar/services/vessel-search.service';
import { ToolbarDrawerService } from './ais/shared/toolbar/toolbar-drawer.service';
import { AisMapHost } from './ais/shared/contracts/ais-map.host';
import { VesselFinderMapController, VesselFinderVesselRow } from './ais/vesselfinder/vesselfinder-map.controller';
import { VfLocatedLayer } from './ais/vesselfinder/vf-located-layer';
import {
  applyVesselFinderCreditSpend,
  canRequestVesselFinderRefund as canRequestVesselFinderRefundRule,
  hasVesselFinderToiFinished as hasVesselFinderToiFinishedRule,
  isVesselFinderToiNotStarted as isVesselFinderToiNotStartedRule,
  VESSEL_FINDER_TOI_ENDED_MESSAGE,
  VESSEL_FINDER_TOI_NOT_STARTED_MESSAGE,
  vesselFinderCreditsRemaining,
  vesselFinderSpendRefusal,
} from './ais/vesselfinder/vf-credits.model';
import {
  minActionCredits as minVesselFinderActionCredits,
  normalizeCreditActions as normalizeVesselFinderCreditActions,
  actionCredits as vesselFinderActionCredits,
} from 'src/app/services/operators/vesselfinder-credit-actions';
import { VesselFinderCreditRefundComponent } from './ais/vesselfinder/panels/credit-refund/vesselfinder-credit-refund.component';
import {
  buildPredictionLegendGroupsFromResults,
  isEmptyPredictionFeedResult,
  isUnclassifiedDetection,
  PredictionLegendGroup,
} from './prediction-legend/prediction-legend.model';
import { PredictionFeedController } from './prediction-feed.controller';
import {
  matchingFeedShapes,
  predictionFeaturesAtHours,
  shapeLayerName,
} from './prediction-feed.model';

type FeatureProps = GeoJsonProperties & { _color?: string };
type FeedCache = {
  fc: FeatureCollection<Geometry, FeatureProps>;
  type?: string;
  color?: string;
  title: string;
  feed_results?: any;
};
type PredictionForecastDetail = {
  forecast_h: string | number;
  fcst_t_utc: string;
};
type PredictionTimeseriesContext = {
  feedKey: string;
  feed: any;
  layer: L.GeoJSON;
  fullCollection: FeatureCollection<Geometry, FeatureProps>;
  forecastDetails: PredictionForecastDetail[];
};
interface SensorScopedFilterState {
  selectedFilterType: string | null;
  filtersByType: Map<string, { feedKeys: string[]; value: any; isGreater?: boolean }>;
}

interface AvailableFeedFilterType {
  type: string;
  label: string;
  feedKeys: string[];
  colorMap?: any;
  isVesselLength?: boolean;
  isPrediction?: boolean;
  tooltipLabel?: string;
  popupLabel?: string;
  placeholderLabel?: string;
}

interface LegendItem {
  color: string;
  value?: number;
}

interface LegendData {
  minValue: number;
  maxValue: number;
  items: LegendItem[];
}
interface CustomGeoJsonLayer extends L.GeoJSON {
  sensorId?: string;
  sceneId?: string;
  refreshId?: string;
  name?: string;
  type?: string;
}

interface CustomWMSOptions extends L.WMSOptions {
  env?: string;
  styles?: string;
  CQL_FILTER?: string;
}
interface FilterCriteria {
  destination?: string;
  flag?: string;
  length?: number;
  isGreater?: boolean;
  vesselType?: string;
  vesselSpeed?: number;
  isSpeedGreater?: boolean;
  vesselName?: string;
  MMSI?: string;
  IMO?: string;
}
type FeedPanel = {
  title: string;
  color?: string | SoilMoistureSarClassMap;
  sections: FeedSection[];
  predictionLegendGroups?: PredictionLegendGroup[];
};
type ComparePaneSide = 'left' | 'right';
type CompareFeedCache = {
  side: ComparePaneSide;
  fc: FeatureCollection<Geometry, FeatureProps>;
  config: any;
  color: any;
  paneName: string;
  feedName: string;
};

@Component({
  selector: 'app-leaflet-newcollections',
  templateUrl: './leaflet-newcollections.component.html',
  styleUrls: ['./leaflet-newcollections.component.scss'],
  providers: [
    AisstreamPlaybackController,
    VoyageRadarPlaybackController,
    VoyageTrackController,
    // These two MUST be listed here, next to `VoyageTrackController`, even
    // though both are also marked `providedIn: 'root'`.
    //
    // Each subscribes to `VoyageTrackController.state$` in its constructor —
    // that subscription is the ONLY way a map selection becomes the drawer's
    // subject. A `providedIn: 'root'` service is instantiated by the ROOT
    // injector and resolves its own dependencies there, where this component's
    // element-level providers are invisible. So they were each handed a SECOND,
    // freshly-built `VoyageTrackController` that nothing ever calls
    // `setActiveVessel` on, while `activateVessel` wrote to the component's.
    // The result was both drawers reading "Select a vessel on the map" with a
    // vessel plainly selected, the halo drawn and the Trace button up.
    //
    // The popup's own port-calls and nearby buttons never showed it, because
    // they pass the MMSI explicitly off the clicked card and never consult the
    // selection — which is why the fault survived the release that added them.
    //
    // Naming them here puts all three in one injector. The `providedIn: 'root'`
    // on each stays as the fallback for a unit test that injects one bare, but
    // anything that injects them OUTSIDE this component's view gets its own
    // pair, silently — the trap that caused this. There is nothing else in the
    // app that does, and this list is what keeps that true.
    VoyagePortCallsService,
    VoyageNearbyService,
    // Here for a DIFFERENT reason from the two above: it has no
    // `VoyageTrackController` dependency to get wrong. It is listed because a
    // root-only instance would be shared with any other collection this app
    // opens, and its `_cache` holds worldwide results bought against ONE
    // sensor's wallet — a component-scoped instance dies with the map it was
    // filled for.
    VoyageSearchService,
    // Same reason as the search cache, and it was missed here — which is the
    // whole of the bug this line fixes. Its state is `locatedVessels`, and
    // every one of those rows is a claim about THIS map: the drawer says "n on
    // the map" and offers to recentre on them. Left in the root injector, the
    // list outlived the map it described, so opening a collection showed the
    // previous visit's vessels — a Watched Vessels button on a map with
    // nothing watched, whose Center button pointed at a marker that no longer
    // existed. `VoyageMapController.reset()` clears it on a task switch, but a
    // route away and back never runs that; a controller that dies with the map
    // cannot outlive it in the first place.
    VoyageVesselController,
    // Same reasoning as `VoyageVesselController` just above: `providedIn:
    // 'root'` would let this controller's `locatedVessels`/`searchResults`
    // outlive the map they were filled for, so a route away and back would
    // show the previous task's search results on a sensor that never
    // searched for them. Component-scoped, it dies with the map.
    VesselFinderMapController,
    // Shared by `VfSearchControlComponent` (which fetches) and
    // `VfPortCallControlComponent` (which reads) via the same parent
    // injector — must be listed here, not just `providedIn: 'root'`, for the
    // identical reason `VoyagePortCallsService` is listed above.
  ],
})
export class LeafletNewcollectionsComponent implements OnInit, OnDestroy, AisMapHost {
  @ViewChild(MatCheckbox) checkboxes!: QueryList<MatCheckbox>;
  map: L.Map;
  private measureDrawControl?: any;
  private measurementLayers = new L.FeatureGroup();
  private measurementTooltipElement?: HTMLElement;
  private isMeasurementDrawing = false;
  private readonly measurementPaneName = 'measurementPane';
  private measurementOverlayPreviousZIndex?: string;
  private shapeVectorOverlay?: L.GeoJSON;
  private dotRenderer = L.canvas({ padding: 0.5 });
  private feedPanels = new Map<string, FeedPanel>();

  // ── WeatherEx forecast — all state & logic live in the controller ──────
  // The cast is safe: the component satisfies WeatherExHost at runtime;
  // TypeScript cannot verify this because DI-injected constructor services are private.
  readonly weatherEx = new WeatherExMapController(this as unknown as WeatherExHost);
  readonly changeDetection = new ChangeDetectionController(
    this as unknown as ChangeDetectionHost
  );
  private viewportWfsService!: ViewportWfsService;
  private viewportGeojson!: ViewportGeojsonController;
  /** storageKey -> how a viewport refresh must re-render that layer. */
  private readonly viewportGeojsonRender = new Map<
    string,
    { geoKey: string; filterKey?: string; layer?: L.GeoJSON; viewport?: FeatureCollection; feedType?: string; feedResults?: any; detach?: () => void;
      legendArgs?: { layerName: string; baseCql: string | null; wmsLayer?: L.Layer } }
  >();
  private readonly viewportGeojsonCancel$ = new Subject<void>();
  private viewportGeojsonLoadErrorShown = false;
  private readonly tiffWfsLoads = new Map<string, ReplaySubject<void>>();
  private readonly questionWmsHandoff = new QuestionWmsHandoffController();
  private observationViewport?: ObservationViewportController;

  private beginTiffWfsLoad(key: string): ReplaySubject<void> {
    this.cancelTiffWfsLoads((activeKey) => activeKey === key);
    const cancel$ = new ReplaySubject<void>(1);
    this.tiffWfsLoads.set(key, cancel$);
    return cancel$;
  }

  private cancelTiffWfsLoads(matches: (key: string) => boolean = () => true): void {
    for (const [key, cancel$] of this.tiffWfsLoads) {
      if (!matches(key)) continue;
      cancel$.next();
      cancel$.complete();
      this.tiffWfsLoads.delete(key);
    }
  }

  private finishTiffWfsLoad(key: string, cancel$: ReplaySubject<void>): void {
    if (this.tiffWfsLoads.get(key) === cancel$) this.tiffWfsLoads.delete(key);
    cancel$.complete();
  }

  private isEmptyWfsDataset(geojson: any): boolean {
    return !geojson?.features?.length &&
      (!geojson?._viewportGeojson || geojson._viewportGeojsonMatchedCount === 0);
  }

  private async isEntireTiffFeedEmpty(
    geojson: any,
    layerName: string,
    baseCql: string | null,
    cancel$: Observable<unknown>
  ): Promise<boolean> {
    if (this.isEmptyWfsDataset(geojson)) return true;
    if (geojson?.features?.length || !geojson?._viewportGeojson) return false;

    try {
      const hasMatch = await firstValueFrom(
        this.viewportWfsService.hasAnyMatchingFeature(layerName, baseCql).pipe(
          takeUntil(merge(this.viewportGeojsonCancel$, this.destroy$, cancel$))
        )
      );
      return !hasMatch;
    } catch (error) {
      if ((error as any)?.name !== 'EmptyError') this.notifyViewportGeojsonLoadError(error);
      // A failed or cancelled check cannot establish that the feed is empty.
      return false;
    }
  }

  // ── Prediction Drift — all state & logic live in the controller ──────────
  readonly predictionDrift = new PredictionDriftController(this as unknown as PredictionDriftHost);
  readonly predictionFeedController = new PredictionFeedController(this);
  predictionDriftChecked = false;
  private readonly refundedPredictionDriftSensors = new WeakSet<object>();
  // Convenience getters so the existing HTML bindings keep working unchanged.
  get weatherExActive()              { return this.weatherEx.active; }
  get weatherExIsPoi()               { return this.weatherEx.isPoi; }
  get weatherExTimes()               { return this.weatherEx.times; }
  get weatherExVariables()           { return this.weatherEx.variables; }
  get weatherExUnits()               { return this.weatherEx.units; }
  get weatherExDates()               { return this.weatherEx.dates; }
  get weatherExSelectedDate()        { return this.weatherEx.selectedDate; }
  get weatherExSelectedTimeIndex()   { return this.weatherEx.selectedTimeIndex; }
  get weatherExWmsLayers()           { return this.weatherEx.wmsLayers; }
  get weatherExActiveVariables()     { return this.weatherEx.activeVariables; }
  get weatherExActiveVariablesList() { return this.weatherEx.activeVariablesList; }
  get weatherExWmsWorkspace()        { return this.weatherEx.wmsWorkspace; }
  get weatherExWmsPointValues()      { return this.weatherEx.wmsPointValues; }
  get weatherExCollectionMode()      { return this.weatherEx.collectionMode; }
  get weatherExRendering()           { return this.weatherEx.rendering; }
  get weatherExPointLoading()        { return this.weatherEx.pointLoading; }
  get weatherExActiveFeature()       { return this.weatherEx.activeFeature; }
  get weatherExTooltipVisible()      { return this.weatherEx.tooltipVisible; }
  get weatherExTooltipPixelPos()     { return this.weatherEx.tooltipPixelPos; }
  get weatherExTooltipPlacement()    { return this.weatherEx.tooltipPlacement; }
  get weatherExTooltipMaxHeight()    { return this.weatherEx.tooltipMaxHeight; }
  get weatherExTimeSlots()           { return this.weatherEx.timeSlots; }
  get weatherExSliderPosition()      { return this.weatherEx.sliderPosition; }
  readonly weatherExVariableMeta     = this.apiService.weatherVariables;
  @ViewChild('map', { static: true }) mapContainer!: ElementRef;
  @ViewChild('reportCaptureRoot') reportCaptureRoot?: ElementRef<HTMLElement>;
  private mapContainerResizeObserver?: ResizeObserver;
  @ViewChild('layerToggleButton', { static: true }) layerBtn!: ElementRef;
  @ViewChild('homeButton', { static: true }) homeButton!: ElementRef;
  @ViewChild('layerToggle', { static: true }) layerToggle!: ElementRef;
  @ViewChild('leftLayerLabel', { static: false }) leftLayerLabel!: ElementRef;
  @ViewChild('rightLayerLabel', { static: false }) rightLayerLabel!: ElementRef;
  @ViewChild('fileInput') fileInput: ElementRef;
  @ViewChild('bandSelect') bandSelect: MatSelect;
  zoomLevel = 3;
  mapDistance = 0;
  latLngDMS = '';
  isCoordinateSearchActive = false;
  searchedCoordinate: { lat: number; lng: number } | null = null;
  isCompare = false;
  isCompareClicked = false;
  pointerEvent = 'auto';
  isNoScenes = false;
  leftData: any[] = [];
  rightData: any[] = [];
  offset = 0.01;
  mapFontColor = 'white';
  opportunityId: any;
  feasibilityArray: any = [];
  currentDownloadingSR: any;
  selectedSites: any[] = [];
  projectSelected: any;
  dateRange: boolean = false;
  metaDataTooltip: any;
  taskSelected: boolean = false;
  RF: boolean = false;
  sceneBands: any;
  bandSelected: string = 'both';
  selectedStartDate: any;
  selectedEndDate: any;
  recurrentTask: boolean = false;
  recurrencyDownload: boolean = false;
  isInIframe: boolean;
  sensorsIS: boolean = true;
  sceneSelected: any;
  selectedSceneNew: any;
  sceneId: any;
  leftBand: boolean = false;
  rightBand: boolean = false;
  taskCreatedDate: any;
  displayedIS: any;
  imageType: string = 'png';

  private collectionReportDialogOpening = false;
  metric = 'kg';
  vesselPolygon: any;
  ghgEmissionMsg = '';
  selectvdap: string;
  enableBand: any = false;
  annotationContent = '';
  filterData: any = [];
  filterVesselDataValue: boolean = false;
  filterVesselData: boolean = false;
  lastVisibleEntities: any = [];
  displayedVesselData: any;
  vesselJsonData: any;
  vesselSensorId: any;
  spireLayerRef: L.GeoJSON | null = null;
  filterObject: any;
  // Type-centric filter state: tracks filters by type (not by feed)
  filtersByType = new Map<string, { feedKeys: string[]; value: any; isGreater?: boolean }>(); // {type -> {feedKeys, value, isGreater}}
  selectedFilterType: string | null = null; // Currently selected filter type for UI display
  private spireGroup: L.LayerGroup;
  sceneFilterData: boolean = false;
  private geoByFeed = new Map<string, FeedCache>();
  private legendController?: FeedLegendController;

  private get legends(): FeedLegendController {
    return this.legendController ??= new FeedLegendController(
      this.viewportWfsService, this.feedFilterService, this.helperService,
      {
        getContext: (storageKey, geoKey) => {
          const cached = this.geoByFeed.get(geoKey);
          const config = feedsConfig[geoKey] ?? Object.values(feedsConfig).find((entry: any) => entry.type === cached?.type);
          const render = this.viewportGeojsonRender.get(storageKey);
          // A pane owns its snapshot, even when metadata is missing.
          // Never borrow a newer scene's or the other pane's metadata.
          const originalResults = render
            ? render.feedResults ?? {}
            : cached?.feed_results ?? (cached?.fc as any)?.feed_results ?? {};
          return { config, originalResults };
        },
        getColor: (key) => this.geoByFeed.get(key)?.color,
        getFilters: (key) => this.getActiveFiltersForFeed(key),
        publish: (key, pane) => this.publishLegendSummary(key, pane),
      }
    );
  }

  private registerLegendSummary(storageKey: string, geoKey: string, layerName: string, baseCql: string | null, filterKey?: string, wmsLayer?: L.Layer): void {
    this.legends.register(storageKey, geoKey, layerName, baseCql, filterKey, wmsLayer);
  }

  private legendSections(key: string, pane: FeedLegendPane, sections: FeedSection[]): FeedSection[] {
    return this.legendController?.sections(key, pane, sections) ?? sections;
  }

  private publishLegendSummary(key: string, pane: FeedLegendPane): void {
    const panels = pane === 'left' ? this.leftFeedPanels : pane === 'right' ? this.rightFeedPanels : this.feedPanels;
    const panel = panels.get(key);
    if (!panel) return; // Never resurrect a removed panel on an asynchronous response.
    const next = new Map(panels);
    next.set(key, { ...panel, sections: this.legendSections(key, pane, panel.sections) });
    if (pane === 'left') this.leftFeedPanels = next;
    else if (pane === 'right') this.rightFeedPanels = next;
    else { this.feedPanels = next; this.rebuildCombined(); }
  }

  /** Recover missing registrations from the session's original metadata snapshot. */
  private ensureLegendSummaries(): void {
    this.viewportGeojsonRender.forEach((render, key) => {
      if (this.legendController?.has(key) || !render.legendArgs) return;
      const { layerName, baseCql, wmsLayer } = render.legendArgs;
      this.registerLegendSummary(key, render.geoKey, layerName, baseCql, render.filterKey, wmsLayer);
    });
  }

  private refreshLegendSummaries(): void {
    this.ensureLegendSummaries();
    this.legendController?.refresh();
  }

  private removeLegendSummaries(feedKey: string, pane?: FeedLegendPane): void {
    this.legendController?.removeFeed(feedKey, pane);
  }
  private destroy$ = new Subject<void>();
  private pngGeoJsonCancelByScope = new Map<string, Subject<void>>();
  private pngGeoJsonRequestByUrl = new Map<
    string,
    {
      cancel$: Subject<void>;
      consumers: Set<number>;
      promise: Promise<any>;
    }
  >();
  private activePngGeoJsonLoadIds = new Set<number>();
  private pngGeoJsonLoadSeq = 0;
  private currentFilteredLayers: { [feedKey: string]: L.Layer } = {};
  private predictionSubscription: Subscription | null = null;
  private vesselMarkerCache = new Map<string, L.Marker>();
  groupedVessels: { [key: string]: any[] } = {};
  prediction: boolean = false;
  filterInfoVisible: boolean = false;
  vehicleFilterMessageShown: boolean = false;
  landUseFilterMessageShown: boolean = false;
  classBasedFilterMessageShown: boolean = false;
  predictionLayers: { [date: string]: L.LayerGroup } = {};
  predictionPathLayers: { [date: string]: L.Polyline } = {};
  pastPredictedPathLayers: { [date: string]: L.Polyline } = {};
  private readonly predictionPaneZIndex = '100001';
  private readonly hoverTooltipPaneZIndex = '100006';
  lastPredictionLatLng: L.LatLng | null = null;
  predictedVesselData: any;
  progressing: boolean = false;
  selectedPredictionId: string | null = null;
  predictionLastPoint: { lat: number; lng: number } | null = null;
  private sensorFilterStates = new Map<string, SensorScopedFilterState>();
  private activeFilterScopeKey: string | null = null;
  nonVesselFeed: any[] = [
    { name: 'Flood detection', color: 'rgb(205 0 0 / 66%)' },
    { name: 'Tree crown detection and count', color: '' },
    { name: 'Deforestation detection and area', color: '#765341' },
    { name: 'Oil spill detection', color: 'magenta' },
    { name: 'Land use/land cover detection', color: '#228B22' },
    { name: 'Flood Inundation', color: '#2E86C1' },
  ];
  pastPrediction: boolean = false;
  vessel: boolean = false;
  feedInfo: boolean = false;
  legendCollapsed: boolean = false;
  combinedFeedSections: FeedSection[] = [];
  predictionLegendGroups: PredictionLegendGroup[] = [];
  // Forecast hour of the prediction polygon under the cursor; the legend shows that hour's total area.
  hoveredPredictionForecastHour: number | null = null;
  dynamicLayers: any = [];
  feedSections: FeedSection[] = [];
  ecursSensorObject: any;
  private getCollectionSub?: Subscription;
  // TODO: Replace 'any' with the correct type definition for FeedUI if available
  feedUi?: any;
  expandedAssociatedFeedIds = new Set<string>();

  toggleOptions(select: MatSelect): void {
    select.open();
  }
  isFirst = true;
  displayedColumns: string[] = ['position', 'name', 'weight', 'symbol'];
  dataSource: any[] = [];
  tableDataLength = 0;
  color = '#1059a9';
  CARTDATA: any[] = [];
  isVisible = false;
  expandedElement: any | null;
  currentUser: any;
  NAVLISTRT: any;
  tasktabs: any;
  tasksCount: any;
  userid: any;
  selectedSensors: any = [];
  selectedCost = 0;
  length = 0;
  pageSize = 10;
  pageIndex = 0;
  pageSizeOptions = [10, 20, 50];
  showFirstLastButtons = true;
  interval: any;
  refreshCount = 0;
  roll: any = 0;
  leftLayer: any;
  rightLayer: any;
  layer = 0;
  hs: any;
  baseLayers: any = [];
  sliderLayers: any = [];
  showMe = true;
  isDisableIS = true;
  @Input() accept = '.topojson, .geojson, .kml';
  fileAttr = 'Choose File';
  acceptFile = '.topojson, .geojson, .kml';
  selectedItems = 0;
  selectedSubDailyItems: any = [];
  selectedSubDailyItemsNew: any[] = [];
  selectedSubDailyItemValue = 1;
  collections: any;
  checked = true;
  scene: any;
  compassOverlay: any;
  sliderOverlay: any;
  acc: any;
  datafile: any;
  dataForm: FormGroup | any;
  options: any;
  selectedLeft: string;
  selectedRight: string;
  baseAlpha: any;
  FP: any;
  metadata: any;
  loadTiff: boolean = false;
  jump = false;
  panelOpenState = false;
  isExpanded: boolean[] = [];
  previousSelectionText: any = null;
  previousEndText: any = null;
  subDailyCount: any = null;
  previousSelection: any = null;
  previousSelectedProject: any = null;
  previousSelectedTask: any = null;
  downloadedScene: any = [];
  refundRequestScenes: any = [];
  scnLyr: any = [];
  scnLyr2: any = [];
  collectionsData: any = undefined;
  collection: any;
  subDailyArray: any = [];
  subDailyFinalArray: any[] = [];
  sensorList: any;
  collectionIndex: any;
  taskName: any;
  taskid: any;
  taskUuid: any;
  overlay: any = [100, 100];
  baseOverlay: any = 100;
  projectData: any;
  projectName: any;
  fail: number = 0;
  recurrencyOption: any;
  progress: any = 0;
  progressSubscription: Subscription;
  disable: boolean = true;
  freeze: boolean = false;
  mapLoad: boolean = false;
  viewportGeojsonLoading = false;
  fullCollection: any;
  filteredCollection: any = [];
  defaultSubdailyCount = 1;
  subDailyCountarray: any[] = [];
  OPERATOR: any;
  ZOOM_SCALES: any;
  downloadObj: any;
  downloadClick: boolean;
  operatorArray: any = [];
  showDailyRecurrencyCheckboxes: boolean = false;
  maxSelections = 2;
  recurrencyArray: any = [];
  selectedValueSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  selectedSensorSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  selectedcompareSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  selectedValue$ = this.selectedValueSubject.asObservable();
  selectedSensor$ = this.selectedSensorSubject.asObservable();
  selectedcompare$ = this.selectedcompareSubject.asObservable();
  selectedCheckboxes: any = [];
  SensorIndex: any = 0;
  selectionChange = new BehaviorSubject<any>('');
  subSelectionSelectionChange = new BehaviorSubject<any>('');
  selection: string = '14/06/2023 - 20/06/2023';
  selectionLabel: any = null;
  selectionLabelEnd: any = null;
  selectionLabels: any = '14/06/2023 - 20/06/2023';
  selectedSubdaily: any;
  selectedIndex: any = 0;
  isDragging = false;
  public emissionMessage: string = '';
  showSubDailyList = false;
  splitRightPostion = false;
  splitLeftPostion = false;
  taskCollection: any;
  selectedIS: boolean[] = [];
  selectedBand = 'all';
  legendData: LegendData;
  ghglegend: string;
  scaleArray: any = [];
  legendColor: string;
  currentTaskId: string;
  restoreRequestedSensors: any = [];
  darkTheme: boolean;
  tooltipImagePath: string;
  downloadImage: string;
  refundImage: string;
  feedLoaded: boolean = false;
  timeseries: boolean = false;
  sliderView = false;
  sliderShow = false;
  sliderDateRangeArray: any[] = [];
  predictionForecastDetails: PredictionForecastDetail[] = [];
  predictionTimeseriesActive = false;
  private predictionTimeseriesContext: PredictionTimeseriesContext | null = null;
  private predictionTimeseriesViewportPending = false;
  /** Per-operator pluggable-toolbar config (resolved lazily from DI). */
  private _toolbarConfigs: SensorToolbarConfig[] | null = null;
  groupedScenes: any;
  currentSliderValue = 0;
  usl = false;
  spire = false;
  lband = false;
  ISGeojsonLayer: any;
  indicesLayer: any;
  superResolutionLayer: any;
  superResolutionFootprintLayer: any;
  indicesLegendLayer: any;
  indicesFootprintLayer: any;
  indicesLayers: any[] = [];
  private readonly indicesViewportLayers = new Map<string, L.GeoJSON>();
  ISMarkers: any[] = [];
  historicalVesselData: any[] = [];
  dateDisable = false;
  lattitude = 41.2;
  longitude = 74.66;
  downloadedImage: string;
  downloadedSensor: any = [];
  currentDownloadingVADP: any;
  failScene = 0;
  scenes: any[] = [];
  sensors: any[] = [];
  scenesNew: any[] = [];
  sensorsNew: any[] = [];
  compare: any;
  leftImageNew: any;
  rightImageNew: any;
  legendScale: any;
  ghgLayers: any[] = [];
  annotaionMarker: any;
  collectionTaskMarker: any;
  isAnnotationSaved = false;
  annotatedLat: any;
  annotatedLng: any;
  filterSiteData: any = [];
  filterDateData: any = [];
  spireMarkers: any[] = [];
  spireBBox: any;
  annotateClicked = false;
  newTaskButtonClicked = false;
  isSitechanged = false;
  selectedSceneIndex = 0;
  signalSelected: any = 'All';
  signalLayers: any[] = [];
  audioAvailable: boolean = false;
  isClydeHistorical = false;
  refundRequestVADP: any = [];
  refundRequestSR: any = [];
  selectedOptions: any[] = [];
  infoserviceModelType = 'feature extraction';
  tooltipDisabled = false;
  downloadTooltip: any = '';
  filterStart: any;
  filterEnd: any;
  sensorSelected: any;
  clydeData: any;
  spireData: any;
  isFullscreen = false;
  clydeHistoricalLayer: any[] = [];
  spireHistoricalLayer: any[] = [];
  spirePredictionLayer: any[] = [];
  /**
   * Two vessel slots and two AOI slots, and the split is NOT one-per-operator:
   * ClydeSpace has its own because it renders with its own cross icon, and
   * everything else that draws AIS vessels — Spire AND Voyage Radar — shares
   * the other. Both pairs can be on the map at once, which is why they are not
   * one field.
   *
   * Named for what they hold rather than for an operator on purpose. These were
   * `spireVesselLayer` / `spirevesselfootprintlayer`, which read as Spire's and
   * are written by three operators — the reason an "only Spire" edit to the
   * shared recall path silently changed Voyage Radar and ClydeSpace too.
   */
  clydeVesselLayer: any;
  aisVesselLayer: any;
  clydeAoiFootprintLayer: any;
  aoiFootprintLayer: any;
  HistoricalLayer: any[] = [];
  trendLinecordinates: any[] = [];
  indiceType = 'display';
  isTextareaDisabled = true;
  feedData = '';
  vesselData: any;
  dateRangeArray: any[] = [];
  mapPane = '';
  selectedCheckboxesNew: any[] = [];
  cloneselectedCheckboxesNew: any[] = [];
  changeDetectionHistorySelections: any[] = [];
  readonly CHANGE_HISTORY_DEFAULT_OPACITY = 70;
  readonly THERMAL_OBSERVATION_DEFAULT_OPACITY = 30;
  sceneOverlayOpacity = 100;
  private thermalObservationOpacityApplied = false;
  // Days-frequency recurrency state
  selectedDaysWeek: string = '';
  selectedDaysDay: string = '';
  daysWeekOptions: { key: string; label: string; weekStart: string; weekEnd: string; days: any[] }[] = [];
  daysDayOptions: { key: string; day_start_date: string; sensors: any[] }[] = [];
  _daysRecurrencyIndexMap: { [dayKey: string]: number } = {};
  overlayVessel: any;
  overlayClydeVessel: any;
  overlaySpireVessel: any;
  overlayVoyageVessel: any;
  clickedAIS: any = '';
  clickedMarker: any;
  sensorLength = 0;
  selectedOperator: any;
  shipTypes: { type: string; color: string }[];
  shipColor: string;
  refreshData: boolean;
  previousMmsi: any;
  taskScene: any;
  currentHistoryIndex = 0;
  annotationMarkers: any[] = [];
  refreshFilterObject: any;
  currentEvent: { checked: boolean };
  private currentTooltip: L.Tooltip | null = null;
  private currentTooltipOwner: L.Layer | null = null;
  vesselLength: any;
  selectedHistory: any = {};
  observationChecked: boolean = false;
  observationEnabled: boolean = false;
  vesselIsGreater: any = null;
  feedLayers: { [feedKey: string]: L.Layer } = {};
  info: any;
  private activeFeedKeys = new Set<string>();
  lastPointByIndex: { [index: number]: L.LatLng } = {};
  pastpreditedVesselData: any;
  combinedScenes: boolean = false;
  isMutltiscenSingleFeed: boolean = false;
  isScenSelected: boolean = false;
  isVadapSelected: boolean = false;
  isData:boolean = false;
  scenIdList: any[] = [];
  leftComparisonObjectLayer : any;
  rightComparisonObjectLayer : any;
  isCompareRecurrency: boolean = false;
  leftFeedPanels = new Map<string, FeedPanel>();
  rightFeedPanels = new Map<string, FeedPanel>();
  isLoadFeedComapre: boolean = false;
  private needsCompareResetToCenter = true;
  lastSliderValue = 0;
  hideLeftCompareLegend = false;
  hideRightCompareLegend = false;
  private compareFeedCache: Partial<Record<ComparePaneSide, CompareFeedCache>> = {};
  private compareRenderFrameId: number | null = null;
  private pendingCompareDividerX: number | null = null;

  isBandSelectorOpen: boolean = false;
  selectedBands: number[] = [];
  isBandApplied: boolean = false;
  isFeedTasking: boolean = false;
  recurrrencyIndexValue: any;
  colorCode = {
    ClydeSpace: 'Orange',
    USL: 'Red',
    Spire: 'Red',
    'Spire-RF': 'Yellowgreen',
  };

  recurrentColorCode = {
    0: 'YELLOWGREEN',
    1: 'ROSYBROWN',
  };
  refreshHistoryColor = {
    ClydeSpace: 'Orange',
    Spire: 'Red',
  };
  /**
   * Everything Voyage Radar draws on the map: the live vessel layer, snapshot
   * playback, the ship-type filter, and vessel track mode.
   *
   * PLAIN `this`, no cast. It used to read `this as unknown as AisMapHost`, and
   * a double cast turns structural checking OFF entirely — `AisMapHost` could
   * grow a nineteenth member and this line would still compile, failing at
   * runtime instead. The class now declares `implements AisMapHost`, so the
   * contract is checked where it is DECLARED rather than asserted where it is
   * used. It cost four access modifiers (`apiService`, `httpClient`, `dialog`,
   * `popupService`, all already present and merely private): the component
   * satisfied the whole contract already, nothing was verifying it.
   */
  readonly voyage = new VoyageMapController(this);
  nonImageryKey: string[] = ['Spire-RF', 'USL', 'Spire', 'ClydeSpace'];

  currentDownloadingIndices: any;
  oilSpil: boolean;
  displayedScene: any;
  displayedUrl: any;
  displayedSensorId: any;
  shapeOverlay: any;
  shapeLayerName: any;
  responseResult: any;
  blankspot: boolean = false;
  blankspotCount: any;
  blankspotArea: any;
  treeCounting: any;
  vesselCount: any;
  deforestationArea: any;
  tifPopupShown: number = 1;
  private _hoverMove?: (e: L.LeafletMouseEvent) => void;
  private _hoverOut?: () => void;
  private baseShapeCql = '';
  currentShapeLayerName: any;
  currentSelectedConfig: any;
  checkedObservation: boolean = false;
  private observationMarkerEntity: L.Layer | null = null;
  private thermalObservationLayer: L.Layer | null = null;
  private thermalTooltipDiv: HTMLDivElement | null = null;
  private colorLegendControl:
    | L.Control.Layers
    | L.Control.Zoom
    | L.Control
    | null = null;
  private colorisationLegendControl: L.Control | null = null;
  private observationVesselService: ObservationVesselService;
  suppressSubDailyCheckbox = false;
  isAllRecurrencyDisabled :boolean = false;
  isShowSubDailyLegend: boolean = true;
  taskMode: string | null = null;
  selectedChangeDetectionTab: string[] = [];

  constructor(
    public httpClient: HttpClient,
    private taskService: TaskService,
    public apiService: ApiService,
    private el: ElementRef,
    private fb: FormBuilder,
    private spinnerService: NgxSpinnerService,
    public popupService: PopupService,
    private downloadService: DownloadService,
    private renderer: Renderer2,
    private datePipe: DatePipe,
    private matdialog: MatDialog,
    private localStorageService: DataService,
    private themeService: ThemeService,
    private changDetectionRef: ChangeDetectorRef,
    private authService: AuthService,
    private userService: UserService,
    public dialog: MatDialog,
    private http: HttpClient,
    private helperService: HelperService,
    private feedFilterService: FeedFilterService,
    private mgrsHelperService: MgrsHelperService,
    private mapResolutionZoomService: MapResolutionZoomService,
    private utilsService: UtilsService,
    private downloadIndicesService: IndicesDownloadService,
    private opManager: OperationManagerService,
    private route: ActivatedRoute,
    public router: Router,
    private injector: Injector,
    readonly snackBar: MatSnackBar,
    public aisstreamLayer: AisstreamPlaybackController,
    public playback: VoyageRadarPlaybackController,
    public track: VoyageTrackController,
    public locatedVessels: VoyageVesselController,
    public portCalls: VoyagePortCallsService,
    public nearby: VoyageNearbyService,
    public vesselSearch: VoyageSearchService,
    public toolbarDrawer: ToolbarDrawerService,
    public vf: VesselFinderMapController,
  ) {
    this.observationVesselService = this.injector.get(ObservationVesselService);
    this.viewportWfsService = this.injector.get(ViewportWfsService);
    this.viewportGeojson = new ViewportGeojsonController(
      this as unknown as ViewportGeojsonHost,
      this.viewportWfsService
    );
    this.authService.getCurrentUser();
    this.OPERATOR = OPERATORS;
    // Let the pluggable toolbar's history/date-range controls reuse the existing
    // collection-aware date picker (TOI window lives on the component).
    this.aisstreamLayer.onRequestHistory = () => this.openAisstreamPlayback();
    // VoyageRadar owns its own map layers and toolbar callbacks — snapshot
    // playback and vessel track mode both live in VoyageMapController, which
    // wires itself to both toolbar controllers here.
    this.voyage.attach();

    // VesselFinder's marker layer — searched/located hulls, drawn straight
    // from `vf.state$` (no snapshot/display/selection ports to go through,
    // unlike Voyage Radar's `LocatedLayer` — see that class's own header for
    // why it needs a full `AisMapContext` and this one deliberately does not).
    this.vf.onCenterVessel = (mmsi) => this.vfLayer.centerVessel(mmsi);
    this.vf.onActivateAll = (keys) => this.vfLayer.activateAll(keys);
    this.vf.onTakeOffMap = (mmsi) => {
      this.vfLayer.removeMarker(mmsi);
      this.vf.removeLocatedVessel(mmsi);
    };
    this.vf.onClearAll = () => {
      this.vfLayer.clear();
      this.vf.setLocatedVessels([]);
    };
    this.vf.onIsOnMap = (mmsi) => this.vfLayer.hasMarker(mmsi);
    this.vf.state$.pipe(takeUntil(this.destroy$)).subscribe((s) => {
      this.vfLayer.sync(s.searchResults ?? [], s.locatedVessels ?? []);
    });

    this.ZOOM_SCALES = ZOOM_SCALES;
    this.spinnerService.hide();
    this.disable = true;
    this.downloadObj = this.downloadService.getProgress();
    if (this.downloadObj?.progress && this.downloadObj?.downloadClick) {
      this.progress = this.downloadObj?.progress;
      this.downloadProgress(this.downloadObj);
    }
    this.progressSubscription = this.downloadService
      .getProgressObservable()
      .subscribe((progress) => {
        this.progress = progress?.progress;
        this.downloadProgress(progress);
      });
    localStorage.removeItem('refund-request');
    localStorage.removeItem('scene-downloaded');
    localStorage.removeItem('restore-request');
    this.isInIframe = this.themeService.isInIframe();
    this.localStorageService.darkTheme.subscribe((newValue) => {
      this.darkTheme = newValue;
      this.tooltipImagePath = this.darkTheme
        ? '../../../assets/images/union-dark.svg'
        : '../../../assets/images/union.svg';
      this.downloadImage = this.darkTheme
        ? '../../../assets/images/icon-dark.svg'
        : '../../../assets/images/icon-img.svg';
      this.refundImage = this.darkTheme
        ? '../../../assets/images/refund-dark.png'
        : '../../../assets/images/refund.png';
      this.downloadedImage = this.darkTheme
        ? '../../../assets/images/cloud_done_dark.svg'
        : '../../../assets/images/cloud_done.svg';
    });
  }

  fullscreenIncon = '../../../assets/images/download.svg';

  toggleFullscreen() {
    const elem = this.mapContainer.nativeElement;
    if (!document.fullscreenElement) {
      this.fullscreenIncon = '../../../assets/images/download-3.svg';
      if (elem.requestFullscreen) {
        elem.requestFullscreen().then(() => {
          this.map.invalidateSize();
        });
      } else if (elem.mozRequestFullScreen) {
        elem.mozRequestFullScreen().then(() => {
          this.map.invalidateSize();
        });
      } else if (elem.webkitRequestFullscreen) {
        elem.webkitRequestFullscreen().then(() => {
          this.map.invalidateSize();
        });
      } else if (elem.msRequestFullscreen) {
        elem.msRequestFullscreen().then(() => {
          this.map.invalidateSize();
        });
      }
    } else {
      this.fullscreenIncon = '../../../assets/images/download.svg';
      if (document.exitFullscreen) {
        document.exitFullscreen().then(() => {
          this.map.invalidateSize();
        });
      }
    }
  }

  async openCollectionReportDialog(): Promise<void> {
    if (this.collectionReportDialogOpening) return;

    const taskId = this.collection?.taskId || this.taskid || this.collection?.id;
    if (!taskId) {
      this.popupService.openPopup(CollectionPopupComponent, 'Task is not selected.', '', '40%');
      return;
    }

    const taskName =
      (typeof this.taskName === 'string' && this.taskName.trim() ? this.taskName.trim() : '') ||
      (typeof this.collection?.taskname === 'string' && this.collection.taskname.trim() ? this.collection.taskname.trim() : '') ||
      '';

    const selectionsSummaryText = buildCollectionReportSelectionsSummaryText({
      collection: this.collection,
      currentUser: this.currentUser,
      isFeedTasking: this.isFeedTasking,
      isCompare: this.isCompare,
      selectedValue: this.selectedValue,
      selectionLabel: this.selectionLabel,
      defaultSubdailyCount: this.defaultSubdailyCount,
      selectedSubDailyItemsNew: this.selectedSubDailyItemsNew,
      subDailyFinalArray: this.subDailyFinalArray,
      selectedCheckboxesNew: this.selectedCheckboxesNew,
      selectedSceneNew: this.selectedSceneNew,
      selectedHistory: this.selectedHistory,
      scenesNew: this.scenesNew,
      filteredCollection: this.filteredCollection,
      leftData: this.leftData,
      rightData: this.rightData,
      leftFeedPanels: this.leftFeedPanels,
      rightFeedPanels: this.rightFeedPanels,
      pastPrediction: this.pastPrediction,
    });

    this.collectionReportDialogOpening = true;

    try {
      this.dialog.open(CollectionReportDialogComponent, {
        width: '700px',
        disableClose: true,
        data: {
          taskId,
          taskName,
          selectionsSummaryText,
          aoiTarget: (this.collection as any)?.target,
          captureMap: (options = {}) => {
            const captureRoot =
              this.reportCaptureRoot?.nativeElement ??
              (this.mapContainer?.nativeElement as HTMLElement | undefined);
            if (!captureRoot) {
              throw new Error('Map is not available for screenshot.');
            }

            if (this.isCompare && this.compare) {
              const dividerX =
                typeof (this.compare as any)?.getPosition2 === 'function'
                  ? (this.compare as any).getPosition2()
                  : this.lastSliderValue === 0
                    ? this.map.getSize().x / 2
                    : this.lastSliderValue;
              return captureLeafletCompareElementAsJpegBlob({ el: captureRoot, dividerX, options });
            }

            return captureElementAsJpegBlob(captureRoot, options);
          },
        },
      });
    } finally {
      this.collectionReportDialogOpening = false;
    }
  }

  async loadUserDetails(userId, isHomeClicked = false) {
    if (userId) {
      const defaultLocation: [number, number] = [20.5937, 78.9629];
      
      this.userService.personalInfo(userId)
        .pipe(
          take(1),
          switchMap((res: any) => {
            this.currentUser = res;
            if(!isHomeClicked) {
              this.getProjects(res?.id);
            }
            const url = `https://nominatim.openstreetmap.org/search?format=json&q=${this.currentUser?.country}`;
            return this.httpClient.get<any[]>(url).pipe(
              take(1),
              timeout(5000),
              catchError((error) => {
                return of([{ lat: defaultLocation[0], lon: defaultLocation[1] }]);
              })
            );
          }),
          catchError((error) => {
            return of([{ lat: defaultLocation[0], lon: defaultLocation[1] }]);
          })
        )
        .subscribe({
          next: (data: any) => {
            // If this is a WeatherEx task and its target polygon has already
            // been fitted to the map (getCollections resolved before nominatim),
            // skip the country-level pan so it does not overwrite the task view.
            const isWeatherExTask = this.collection?.sensors?.some(
              (s: any) => s.operatorKey === OPERATORS.WEATHEREX
            );
            if (isWeatherExTask && this.weatherEx.getTargetBounds()) return;
            // Same for a Voyage Radar task, which `showAoi` has framed on its own
            // AOI by now. This request carries a 5s timeout, so without the guard
            // it can land long after the fit and undo it.
            if (this.voyage.aoiBounds()) return;
            if (data && data.length > 0) {
              const lat = data[0].lat;
              const lon = data[0].lon;
              this.map.setView([lat, lon], 9);
              setTimeout(() => {
                this.map.invalidateSize();
              }, 100);
            } else {
              this.map.setView(defaultLocation, 9);
              setTimeout(() => {
                this.map.invalidateSize();
              }, 100);
            }
          },
          error: (error) => {
            const isWeatherExTask = this.collection?.sensors?.some(
              (s: any) => s.operatorKey === OPERATORS.WEATHEREX
            );
            if (isWeatherExTask && this.weatherEx.getTargetBounds()) return;
            if (this.voyage.aoiBounds()) return;
            this.map.setView(defaultLocation, 9);
            setTimeout(() => {
              this.map.invalidateSize();
            }, 100);
          }
        });
    }
  }

  onFullscreenChange() {
    this.isFullscreen = !!document.fullscreenElement;
    this.isFullscreen
      ? (this.fullscreenIncon = '../../../assets/images/download-3.svg')
      : (this.fullscreenIncon = '../../../assets/images/download.svg');
    this.map.invalidateSize();
  }

  locateTaskonMap(event: any) {
    this.jump = event.checked;
  }

  formatDates(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}Z`;
  }

  filterByDate() {
    const dialogRef = this.matdialog.open(FilterPopupComponent, {
      width: '35%',
      backdropClass: 'blurr',
      disableClose: true,
      data: {
        type: 'date',
        startDate: this.collection?.openWindow,
        endDate: this.collection?.closeWindow,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.dateRangeArray = [];
        this.sliderDateRangeArray = [];
        this.resetMapNew();
        this.currentSliderValue = 0;
        this.previousIndex = -1;
        this.filterStart = this.formatDates(result.start);
        this.filterEnd = this.formatDates(result.end);
        let checkedSensors: any[] = this.collection.sensors.filter(
          (sensor) => sensor.checked == true
        );

        if (checkedSensors.length > 0) {
          this.sensorSelected = this.collection.sensors[0].id;
          this.groupedScenes = this.groupCollections();
        }
      }
    });
  }

  get isTimeseriesDisabled(): boolean {
    if (this.hasActivePredictionFilter) return true;
    // Keep an active Oil Spill slider switchable off while its new viewport is loading.
    if (this.predictionTimeseriesActive) return false;
    if (this.hasPredictionFilter) {
      return true;
    }
    if (this.isPredictionTimeseriesReady) {
      return false;
    }

    if (this.isCompare || this.collection?.repeatFrequency === 'Days') {
      return true;
    }

    return this.hasPredictionFeed &&
      !this.hasStandardTimeseriesOption &&
      !this.isPredictionTimeseriesReady;
  }

  private get hasActivePredictionFilter(): boolean {
    const mergedFilters = this.getMergedFiltersByType();
    return PREDICTION_FILTER_TYPES.some((type) => {
      const filter = mergedFilters.get(type);
      return !!filter?.value?.detectionClass &&
        (filter.feedKeys ?? []).some((key) => this.activeFeedKeys.has(String(key)));
    });
  }

  private get hasPredictionFilter(): boolean {
    const mergedFilters = this.getMergedFiltersByType();
    return PREDICTION_FILTER_TYPES.some((type) => mergedFilters.has(type));
  }

  get hasStandardTimeseriesOption(): boolean {
    return (
      (Number(this.collection?.frequency) === 2 && this.spire) ||
      (this.collection?.recurrencyArray?.length > 1 && !this.usl)
    );
  }

  get hasPredictionFeed(): boolean {
    return (this.collection?.sensors ?? []).some((sensor: any) =>
      this.getCombinedFeedsForSensor(sensor).some((feed: any) =>
        this.isPredictionFeed(feed)
      )
    );
  }

  get isPredictionTimeseriesReady(): boolean {
    const context = this.predictionTimeseriesContext;
    return !!(
      !this.predictionTimeseriesViewportPending &&
      context?.forecastDetails?.length &&
      this.map?.hasLayer(context.layer)
    );
  }

  toggleTimeSeries(event: any) {
    if (event.checked && this.hasActivePredictionFilter) return;
    if (event.checked && this.hasPredictionFilter) {
      return;
    }
    if (event.checked && this.isPredictionTimeseriesReady) {
      this.activatePredictionTimeseries();
      return;
    }

    if (!event.checked && this.predictionTimeseriesActive) {
      this.clearPredictionTimeseries(true);
      return;
    }

    if (this.collection?.repeatFrequency === 'Days') {
      this.resetTimeSeries();
      return;
    }

    this.annotateClicked = false;
    this.newTaskButtonClicked = false;
    this.overlayClydeVessel = null;
    this.overlaySpireVessel = null;
    this.overlayVoyageVessel = null;
    this.dateRangeArray = [];
    for (const [sensorIndex, sensor] of this.collection.sensors.entries()) {
      sensor.checked = false;
      for (const [sceneIndex, scene] of sensor.scenes.entries()) {
        scene.checked = false;
      }
    }
    this.sliderView = event.checked;
    this.sliderShow = false;
    this.sliderDateRangeArray = [];
    this.resetMapNew();
    this.currentSliderValue = 0;
    this.currentHistoryIndex = 0;
    this.showDailyRecurrencyCheckboxes = false;
    this.previousIndex = -1;
    this.isCompare = false;
    this.isCompareClicked = false;
    this.filterStart = null;
    this.filterEnd = null;

    if (this.collection?.sensors[0]?.operatorKey == OPERATORS.GHG) {
      this.defaultSubdailyCount = 1;
      this.metric = 'kg';
      this.getCollections(
        this.previousSelectedProject?.projectid
          ? this.previousSelectedProject?.projectid
          : this.projectSelected,
        this.collectionIndex
      );
      this.selectionChange.next(this.collection.recurrencyArray[0]);
    }

    if (!this.timeseries) {
      this.isSitechanged = false;
    }
    this.timeseries = event.checked;
    this.sliderView = event.checked;

    // AISstream uses the dedicated Historical Playback toolbar (clock control), not this slider.

    // VoyageRadar no longer uses this Timeseries toggle — its playback is driven
    // by the on-map toolbar's "Playback history" control (the toggle is hidden
    // for VoyageRadar sensors).
  }

  resetTimeSeries() {
    if (this.predictionTimeseriesActive) {
      this.clearPredictionTimeseries(true);
      return;
    }

    this.sliderView = false;
    this.timeseries = false;
    this.sliderShow = false;
    this.sliderDateRangeArray = [];
    this.currentSliderValue = 0;
    this.currentHistoryIndex = 0;
    this.previousIndex = -1;
    this.isSitechanged = false;
  }

  // ── AISstream historical playback ──────────────────────────────────────────

  get isAisstreamCollection(): boolean {
    return this.collection?.sensors?.[0]?.operatorKey === OPERATORS.AISSTREAM;
  }

  /** True only while the AISstream sensor feed is checked/enabled. */
  get isAisstreamSensorActive(): boolean {
    return !!this.collection?.sensors?.some(
      (s) => s?.operatorKey === OPERATORS.AISSTREAM && s?.checked,
    );
  }

  /** AISstream's pluggable-toolbar composition (resolved from DI, cached). */
  get aisstreamToolbarConfig(): SensorToolbarConfig | null {
    if (!this._toolbarConfigs) {
      this._toolbarConfigs = this.injector.get(SENSOR_TOOLBAR_CONFIGS, [] as SensorToolbarConfig[]);
    }
    return this._toolbarConfigs.find((c) => c.operatorKey === OPERATORS.AISSTREAM) ?? null;
  }

  /** VoyageRadar's pluggable-toolbar composition (resolved from DI, cached). */
  get voyageRadarToolbarConfig(): SensorToolbarConfig | null {
    if (!this._toolbarConfigs) {
      this._toolbarConfigs = this.injector.get(SENSOR_TOOLBAR_CONFIGS, [] as SensorToolbarConfig[]);
    }
    return this._toolbarConfigs.find((c) => c.operatorKey === OPERATORS.VOYAGERADAR) ?? null;
  }

  /**
   * The track bar shares VoyageRadar's single toolbar config object — the host
   * only re-resolves in ngOnChanges, so the binding must stay reference-stable.
   */
  get voyageTrackToolbarConfig(): SensorToolbarConfig | null {
    return this.voyageRadarToolbarConfig;
  }

  // ── VesselFinder ─────────────────────────────────────────────────────────────
  // Simpler than VoyageRadar: no scenes, no AOI/target, no snapshot archive —
  // one search control on the map's "live" bar, gated by the same sensor
  // checkbox idiom. See `vesselfinder.module.ts`'s header for what this
  // operator deliberately does not have yet (a map facade/marker placement).

  /** The first VesselFinder sensor on the open collection, or null. */
  get vesselFinderSensor(): any | null {
    return (
      this.collection?.sensors?.find((s: any) => s?.operatorKey === OPERATORS.VESSELFINDER) ?? null
    );
  }

  /**
   * True while the VesselFinder sensor's checkbox is ticked AND its TOI has
   * opened — the gate for its search bar.
   *
   * The TOI term is on the GETTER rather than only on the checkbox because
   * `checked` has more than one writer: `ensureVesselFinderSensorChecked` sets
   * it from the Watched Vessels sidebar, and a sensor can be left ticked from a
   * task whose window had not opened. The bar's controls all spend, and there is
   * nothing to buy before the operator starts collecting, so the one condition
   * that must hold is asserted where the bar is decided, not where it is
   * toggled. The checkbox is disabled for the same reason — that is the
   * explanation; this is the guarantee.
   */
  get isVesselFinderSensorChecked(): boolean {
    return !!this.collection?.sensors?.some(
      (s: any) =>
        s?.operatorKey === OPERATORS.VESSELFINDER &&
        s?.checked &&
        !isVesselFinderToiNotStartedRule(s),
    );
  }

  /**
   * VesselFinder's pluggable-toolbar composition (resolved from DI, cached),
   * with the open sensor stamped onto its controls' `options` — the DI config
   * is a static singleton, so the per-task sensor cannot live there.
   * `VfSearchControlComponent`/`VfPortCallControlComponent` read
   * `context.options.sensor`.
   *
   * Memoized on `base`/`sensor` identity — NOT rebuilt on every call. This
   * getter re-runs every change-detection cycle, and `ToolbarHostComponent`
   * rebuilds `resolved` (a fresh `Injector` per control) whenever `[config]`'s
   * REFERENCE changes; `*ngComponentOutlet`'s `injector` input then tears down
   * and recreates the control on any reference change. A literal returned
   * fresh each call destroyed/recreated `VfSearchControlComponent` on every
   * tick, silently resetting `open` right after a click set it true — this was
   * the search button "doing nothing" bug. `voyageRadarToolbarConfig`/
   * `aisstreamToolbarConfig` never had this problem: they return the same
   * cached object straight from `_toolbarConfigs.find()`.
   */
  private _vfToolbarConfigCache: { base: SensorToolbarConfig; sensor: any; config: SensorToolbarConfig } | null = null;
  get vesselFinderToolbarConfig(): SensorToolbarConfig | null {
    if (!this._toolbarConfigs) {
      this._toolbarConfigs = this.injector.get(SENSOR_TOOLBAR_CONFIGS, [] as SensorToolbarConfig[]);
    }
    const base = this._toolbarConfigs.find((c) => c.operatorKey === OPERATORS.VESSELFINDER) ?? null;
    if (!base) return null;
    const sensor = this.vesselFinderSensor;
    const cache = this._vfToolbarConfigCache;
    if (cache && cache.base === base && cache.sensor === sensor) {
      return cache.config;
    }
    const config: SensorToolbarConfig = {
      ...base,
      live: (base.live ?? []).map((c) => ({
        ...c,
        options: { ...(c.options ?? {}), sensor },
      })),
    };
    this._vfToolbarConfigCache = { base, sensor, config };
    return config;
  }


  /** Keeps the controller's taskid/sensorId in step with the open collection — every paid action needs both. */
  private _attachVesselFinder(): void {
    const sensor = this.vesselFinderSensor;
    if (!sensor) return;
    this.vf.attach(this.taskid, sensor.sensor_uuid ?? sensor.id);
  }

  /** Markers for VesselFinder's searched/located hulls — same "lives here, not on `vf`" reasoning. */
  readonly vfLayer = new VfLocatedLayer(this, {
    actionsFor: (row) => this.vesselFinderPopupActionsFor(row),
    onAction: (action, row) => this.vesselFinderPopupAction(action, row),
    // A marker was clicked (or a list row picked it) — offer that hull to the
    // Port Calls drawer's identifier box. This is a PREFILL, not the old
    // subject: that version decided what the drawer charged for, this one only
    // saves the user typing a number they can already see on the map.
    onActivate: (row) => this.vf.setActiveVessel(row),
  });



  /** Prices (and kept-ness) for one row's popup card — mirrors the search control's own cost getters. */
  private vesselFinderPopupActionsFor(row: any): { masterCredits: number; voyageCredits: number; kept: boolean } {
    const sensor = this.vesselFinderSensor;
    return {
      masterCredits: vesselFinderActionCredits(sensor, 'master'),
      voyageCredits: vesselFinderActionCredits(sensor, 'voyage'),
      kept: !!row?.kept,
    };
  }

  /**
   * A marker popup's card button was clicked — Master/Voyage/Port
   * calls/Watch all dispatch through here now (the search drawer's rows lost
   * their own copies of these once the popup became the one place a hull's
   * actions live, matching Voyage Radar's own popup-owns-the-actions shape).
   */
  private vesselFinderPopupAction(action: string, row: any): void {
    const taskid = this.vf.taskid;
    const sensorId = this.vf.sensorId;
    if (!taskid || !sensorId) return;
    const key = row.mmsi ?? row.imo ?? '';
    const ident = row.mmsi ? { mmsi: row.mmsi } : row.imo ? { imo: row.imo } : {};

    if (action === 'master' || action === 'voyage') {
      const label = action === 'master' ? 'Master data' : 'Voyage data';
      const refusal = vesselFinderSpendRefusal(this.vesselFinderSensor, action);
      if (refusal) {
        this.popupService.openPopup(CollectionPopupComponent, refusal, '', '40%');
        return;
      }
      this.vfLayer.setNote(key, `Loading ${label.toLowerCase()}…`);
      const call =
        action === 'master'
          ? this.apiService.getVesselFinderMasterData({ taskid, sensorId, ...ident })
          : this.apiService.getVesselFinderVoyageData({ taskid, sensorId, ...ident });
      call.subscribe({
        next: (res: any) => {
          // Before the empty check, not after: the provider bills a lookup that
          // resolved nothing (see `handleDatasetFetch` in
          // `eetaskapi/routes/vesselFinder.route.js`), and the response carries
          // the real `apiCreditsRemaining` for both outcomes. Returning early
          // without applying it left the card's credit counts overstated until
          // the next reload.
          applyVesselFinderCreditSpend(
            this.vesselFinderSensor,
            res,
            vesselFinderActionCredits(this.vesselFinderSensor, action),
          );
          if (!res?.vessel) {
            // An empty answer IS the answer, it was PAID for, and it belongs
            // in the card rather than in a note that wipes itself off the
            // marker six seconds later. (The Port-calls action used to set the
            // example here; it has since moved off the card entirely, into its
            // own drawer.) `{}` is what marks the dataset bought — from it
            // `dataSection` renders "Not reported for this vessel.", which is
            // exactly what that function's own header says it exists to do.
            //
            // Before this, the early return left `row.master`/`row.voyage`
            // undefined, so the section never rendered and the icon still
            // looked unbought — the obvious next move was to click it and pay
            // a second time for the same nothing.
            //
            // NOT kept, unlike the success path below: `handleDatasetFetch`
            // persists no vesselHistory record for an unmatched hull, so
            // auto-keeping here would put a row in Watched Vessels that the
            // server has never heard of.
            this.vfLayer.setNote(key, null);
            this.vf.upsertLocatedVessel({ ...row, [action]: {} });
            this.vfLayer.ensurePopupOpen(key);
            this.vfLayer.revealSection(key, label);
            return;
          }
          // `vessel.name` is the backend's fetch stamp, and `key`/`vesselId` are
          // its own record ids — none of the three describe this hull.
          const { name: _fetchedAt, key: _recordKey, vesselId: _vesselId, master, voyage, ...ais } = res.vessel;
          const dataset = action === 'master' ? master : voyage;
          this.vfLayer.setNote(key, null);
          // `?? {}` marks the dataset as bought even when it came back empty, so
          // the popup can say so instead of rendering nothing.
          this.vf.upsertLocatedVessel({ ...row, ...ais, [action]: dataset ?? {}, kept: true });
          // The upsert re-syncs this hull, which can take its own card down —
          // the bought data has to land in the card the click was made in.
          this.vfLayer.ensurePopupOpen(key);
          // …and be VISIBLE in it: the section renders below the hull's rows,
          // past the fold of a card this tall. Last, after the repaints above.
          this.vfLayer.revealSection(key, label);
          // The fetch persists a vesselHistory record server-side, so the sidebar
          // panel has to be told — it reads `sensor.vesselHistory`, not `vf`.
          this.vfMergeHistoryRecord(res.vessel, row);
        },
        error: () => {
          this.vfLayer.setNote(key, `Could not load ${label.toLowerCase()}. Please try again.`, { autoClear: true });
        },
      });
      return;
    }
    if (action === 'save' || action === 'remove') {
      const sensor = this.vesselFinderSensor;
      // `portCalls` is dropped on the way out: a row restored from
      // `vesselHistory` can still carry one, but a berth history is not part of
      // what watching a hull persists — the backend keeps its own copy under
      // `portCallHistory`, which is what the Port Calls drawer now writes.
      const { portCalls: _portCalls, ...vessel } = row ?? {};
      const call = row.kept
        ? this.apiService.removeVesselFinderVessel({ taskid, sensorId, ...ident })
        : this.apiService.saveVesselFinderVessel({ taskid, sensorId, ...ident, vessel });
      call.subscribe({
        next: (res: any) => {
          if (row.kept) {
            this.vf.removeLocatedVessel(key);
            if (sensor) sensor.vesselHistory = (sensor.vesselHistory ?? []).filter((r: any) => r.key !== key);
          } else {
            this.vf.upsertLocatedVessel({ ...row, kept: true });
            // Mutated in place, not reloaded — same pattern Voyage Radar's own
            // sidebar panel relies on for the row to appear immediately (see
            // that component's own header). `res.vessel` is the exact record
            // `saveVesselFinderVessel` persisted to `sensor.vesselHistory`.
            if (sensor && res?.vessel) {
              const list = Array.isArray(sensor.vesselHistory)
                ? sensor.vesselHistory.filter((r: any) => r.key !== res.vessel.key)
                : [];
              sensor.vesselHistory = [...list, res.vessel];
            }
          }
        },
        // Without this the card just sat there on a failed write: the UI flip
        // lives in `next`, so a rejected save left the button still offering
        // "Watch vessel" with no hint that the last press went nowhere.
        error: () => {
          this.vfLayer.setNote(
            key,
            row.kept ? 'Could not remove this vessel. Please try again.' : 'Could not watch this vessel. Please try again.',
            { autoClear: true },
          );
        },
      });
    }
  }

  // ── VesselFinder "Watched Vessels" sidebar panel → map/API ─────────────────
  /**
   * Fold a persisted Master/Voyage record into the sensor's own history list.
   * The snapshot is carried from the row because these two responses return the
   * dataset alone — without it a hull auto-kept by a purchase would list with no
   * name and no position.
   */
  private vfMergeHistoryRecord(record: any, row: any): void {
    const sensor = this.vesselFinderSensor;
    const key = String(record?.key ?? '').trim();
    if (!sensor || !key) return;

    const list: any[] = Array.isArray(sensor.vesselHistory) ? [...sensor.vesselHistory] : [];
    const existing = list.find((r) => String(r?.key ?? '') === key);
    const prev = existing?.snapshot ?? {};
    const snapshot = {
      ...prev,
      name: row?.name ?? record?.snapshot?.name ?? prev.name ?? null,
      callSign: row?.callSign ?? record?.snapshot?.callSign ?? prev.callSign ?? null,
      shipType: row?.shipType ?? record?.snapshot?.shipType ?? prev.shipType ?? null,
      flag: row?.flag ?? record?.snapshot?.flag ?? prev.flag ?? null,
      destination: row?.destination ?? record?.snapshot?.destination ?? prev.destination ?? null,
      latitude: row?.latitude ?? record?.snapshot?.latitude ?? prev.latitude ?? null,
      longitude: row?.longitude ?? record?.snapshot?.longitude ?? prev.longitude ?? null,
      course: row?.course ?? record?.snapshot?.course ?? prev.course ?? null,
      speed: row?.speed ?? record?.snapshot?.speed ?? prev.speed ?? null,
      heading: row?.heading ?? record?.snapshot?.heading ?? prev.heading ?? null,
    };

    const merged = { ...(existing ?? {}), ...record, snapshot };
    sensor.vesselHistory = [...list.filter((r) => String(r?.key ?? '') !== key), merged];
  }

  /** Bound as a function input so the panel can tag rows that are drawn. */
  vfHistoryOnMap = (key: string): boolean => this.vfLayer.hasMarker(key);
  /** Key of the in-flight Refresh, or null — spins that row's icon. */
  vfHistoryLoadingKey: string | null = null;

  private vfRowFromHistoryRecord(record: any): VesselFinderVesselRow | null {
    const key = String(record?.key ?? '').trim();
    if (!key) return null;
    const snap = record?.snapshot ?? {};
    return {
      mmsi: record?.mmsi ?? null,
      imo: record?.imo ?? null,
      name: snap.name ?? record?.vesselName ?? null,
      timeUtc: snap.timestamp ?? snap.timeUtc ?? record?.timestamp ?? null,
      timestamp: snap.timestamp ?? snap.timeUtc ?? record?.timestamp ?? null,
      stale: false,
      kept: true,
      // Datasets already bought for this hull, so re-locating it from Watched
      // Vessels brings them back rather than looking unbought.
      master: record?.master ?? null,
      voyage: record?.voyage ?? null,
      portCalls: record?.portCalls ?? null,
      latitude: snap.latitude ?? null,
      longitude: snap.longitude ?? null,
      course: snap.course ?? null,
      speed: snap.speed ?? null,
      heading: snap.heading ?? null,
      destination: snap.destination ?? null,
      callSign: snap.callSign ?? null,
      shipType: snap.shipType ?? null,
      flag: snap.flag ?? null,
    };
  }

  vfHistoryLocate(record: any): void {
    const row = this.vfRowFromHistoryRecord(record);
    if (!row) return;
    // A record persisted by a Master/Voyage fetch carries no snapshot, so its
    // position (and name) has to come from the row this session already holds.
    const key = String(row.mmsi ?? row.imo ?? '');
    if (row.latitude == null || row.longitude == null) {
      const live = (this.vf.snapshot().locatedVessels ?? []).find(
        (r) => String(r.mmsi ?? r.imo ?? '') === key,
      );
      if (live) {
        row.latitude = row.latitude ?? live.latitude ?? null;
        row.longitude = row.longitude ?? live.longitude ?? null;
        row.name = row.name ?? live.name ?? null;
        row.course = row.course ?? live.course ?? null;
        row.heading = row.heading ?? live.heading ?? null;
      }
    }
    // The sidebar panel is reachable with the sensor unticked (unlike the
    // on-map toolbar's own Watched Vessels drawer, gated on the checkbox) —
    // putting a hull back on the map has to turn the sensor on with it, or
    // the marker appears with no target ring/toolbar to go with it.
    this.ensureVesselFinderSensorChecked();
    this.vf.upsertLocatedVessel(row);
    if (key) this.vfLayer.centerVessel(key);
  }

  /** Marker off, row kept — the reversible one, mirrors `voyageHistoryTakeOffMap`. */
  vfHistoryTakeOffMap(record: any): void {
    const key = String(record?.key ?? '').trim();
    if (key) {
      this.vfLayer.removeMarker(key);
      this.vf.removeLocatedVessel(key);
    }
  }

  /** Ticks the sensor checkbox and enables its toolbar if it is not already selected. */
  private ensureVesselFinderSensorChecked(): void {
    const sensor = this.vesselFinderSensor;
    if (!sensor || sensor.checked) return;
    sensor.checked = true;
    this.vesselFinderSensorToggled(true);
  }

  /** Re-run a fresh (paid) lookup for one row — the sidebar's "Refresh". */
  vfHistoryRefresh(sensor: any, record: any): void {
    const key = String(record?.key ?? '').trim();
    const taskid = this.vf.taskid;
    const sensorId = this.vf.sensorId;
    if (!key || !taskid || !sensorId || this.vfHistoryLoadingKey) return;
    const refusal = vesselFinderSpendRefusal(sensor, 'search');
    if (refusal) {
      this.popupService.openPopup(CollectionPopupComponent, refusal, '', '40%');
      return;
    }
    this.ensureVesselFinderSensorChecked();
    const mmsi = record?.mmsi ? [String(record.mmsi)] : [];
    const imo = record?.imo ? [String(record.imo)] : [];
    if (!mmsi.length && !imo.length) return;

    this.vfHistoryLoadingKey = key;
    this.apiService.searchVesselFinderVessels({ taskid, sensorId, mmsi, imo, satellite: false }).subscribe({
      next: (res: any) => {
        this.vfHistoryLoadingKey = null;
        applyVesselFinderCreditSpend(
          sensor,
          res,
          vesselFinderActionCredits(sensor, 'search'),
        );
        const v = (res?.data ?? [])[0];
        if (!v) return;
        const snapshot = {
          name: v.name ?? null,
          callSign: v.callSign ?? null,
          shipType: v.shipType ?? null,
          flag: v.flag ?? null,
          destination: v.destination ?? null,
          latitude: v.latitude ?? null,
          longitude: v.longitude ?? null,
          course: v.course ?? null,
          speed: v.speed ?? null,
          heading: v.heading ?? null,
        };
        if (sensor) {
          const list: any[] = Array.isArray(sensor.vesselHistory) ? [...sensor.vesselHistory] : [];
          const idx = list.findIndex((r) => r.key === key);
          if (idx !== -1) {
            list[idx] = { ...list[idx], name: new Date().toISOString(), snapshot, stale: false };
          }
          sensor.vesselHistory = list;
        }
        this.vf.upsertLocatedVessel({
          mmsi: record?.mmsi ?? null,
          imo: record?.imo ?? null,
          kept: true,
          stale: false,
          timeUtc: v.timestamp ?? null,
          timestamp: v.timestamp ?? null,
          ...snapshot,
        });
        if (key) this.vfLayer.centerVessel(key);
        this.apiService.saveVesselFinderVessel({
          taskid,
          sensorId,
          ...(record?.mmsi ? { mmsi: String(record.mmsi) } : {}),
          ...(record?.imo ? { imo: String(record.imo) } : {}),
          vessel: snapshot as any,
        }).subscribe();
      },
      error: () => {
        this.vfHistoryLoadingKey = null;
      },
    });
  }

  /** Out of Watched Vessels for good, and off the map with it — mirrors `voyageHistoryRemove`. */
  vfHistoryRemove(sensor: any, record: any): void {
    const key = String(record?.key ?? '').trim();
    const taskid = this.vf.taskid;
    const sensorId = this.vf.sensorId;
    if (!key || !taskid || !sensorId) return;
    const ident = record?.mmsi ? { mmsi: record.mmsi } : record?.imo ? { imo: record.imo } : {};
    this.apiService.removeVesselFinderVessel({ taskid, sensorId, ...ident }).subscribe({
      next: () => {
        if (sensor) sensor.vesselHistory = (sensor.vesselHistory ?? []).filter((r: any) => r.key !== key);
        this.vf.removeLocatedVessel(key);
        this.vfLayer.removeMarker(key);
      },
    });
  }

  /** The VesselFinder sensor checkbox only controls its toolbar and transient vessel state. */
  vesselFinderSensorToggled(checked: boolean): void {
    if (checked) return;
    this.vf.close();
    this.vfLayer.clear();
  }

  /** API credits left in a VesselFinder sensor's wallet, for the sensor row's credits pill. */
  vesselFinderCreditsLeft(sensor: any): number | null {
    return vesselFinderCreditsRemaining(sensor);
  }

  /** A wallet too small for ANY catalogue action is stranded, not healthy — mirrors `voyageCreditsStranded`. */
  vesselFinderCreditsStranded(sensor: any): boolean {
    const left = vesselFinderCreditsRemaining(sensor);
    return left != null && left < minVesselFinderActionCredits(normalizeVesselFinderCreditActions(sensor?.apiCreditActions));
  }

  /** Is the refund icon live for this VesselFinder sensor? Mirrors `canRequestVoyageRefund`. */
  canRequestVesselFinderRefund(sensor: any): boolean {
    return canRequestVesselFinderRefundRule(sensor);
  }

  /** Why the refund icon is inert — mirrors `voyageRefundTooltip`. */
  vesselFinderRefundTooltip(sensor: any): string {
    if (sensor?.returnRefundAccept) return 'Refund approved';
    if (sensor?.returnRefundReject) return 'Refund declined';
    if (sensor?.refundRequest) return 'Refund already requested';
    return 'No credits to refund';
  }

  /** Has the TOI ended for this VesselFinder sensor? Mirrors `hasVoyageToiFinished`. */
  hasVesselFinderToiFinished(sensor: any): boolean {
    return hasVesselFinderToiFinishedRule(sensor);
  }

  /** Has the TOI not opened yet for this VesselFinder sensor? Mirrors `isVoyageToiNotStarted`. */
  isVesselFinderToiNotStarted(sensor: any): boolean {
    return isVesselFinderToiNotStartedRule(sensor);
  }

  readonly vesselFinderToiEndedTooltip = VESSEL_FINDER_TOI_ENDED_MESSAGE;
  readonly vesselFinderToiNotStartedTooltip = VESSEL_FINDER_TOI_NOT_STARTED_MESSAGE;

  /**
   * VesselFinder credit usage + refund — opened from the refund icon. Same
   * pre-check/dialog shape as `openVoyageCreditRefund`, keyed by product
   * 'VesselFinder' (`tasks.route.js`'s matching branch).
   */
  openVesselFinderCreditRefund(collectionIndex: number, sensorIndex: number): void {
    const sensor = this.collections[collectionIndex]?.sensors?.[sensorIndex];
    const taskId = this.collections[collectionIndex]?.taskId;
    if (!sensor || !taskId) return;

    const statusReq = {
      taskId,
      sensorId: sensor?.id,
      sceneId: undefined,
      product: 'VesselFinder',
      feedId: undefined,
    };

    this.apiService.returnRefundStatus(statusReq).subscribe((res: any) => {
      if (this.isPartialDelivery(res)) return;
      if (res?.returnRefundAccept || res?.returnRefundReject) {
        const message = res?.returnRefundReject
          ? 'return-refund-rejected'
          : 'return-refund-accepted';
        this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
        return;
      }
      if (res?.refundRequest) {
        this.popupService.openPopup(
          CollectionPopupComponent,
          'return-refund',
          { msg: 'VesselFinder' },
          '40%'
        );
        return;
      }

      const dialog = this.matdialog.open(VesselFinderCreditRefundComponent, {
        minWidth: '50%',
        maxHeight: '90vh',
        data: { taskId, sensorId: sensor?.id, sensor },
        backdropClass: 'blurred',
        disableClose: true,
      });
      dialog.afterClosed().subscribe((result) => {
        if (result?.refundRequested) {
          sensor.refundRequest = true;
          this.popupService.openPopup(
            CollectionPopupComponent,
            'return-refund-success',
            '',
            '40%'
          );
        }
      });
    });
  }

  // ── VoyageRadar refresh history (single-select snapshot timeline) ───────────
  //
  // Voyage Radar shows exactly ONE refresh snapshot at a time. The old checkbox
  // table let several be ticked, which stacked several Leaflet layers while
  // `voyage.liveLayer` / `voyage.currentFeatures` / the toolbar's "Updated …"
  // stamp all described only whichever finished last. Selection now lives here
  // instead of on each row's `checked` flag, and the row toggles rather than
  // accumulates.
  //
  // The row chrome, day grouping and collapsed/expanded state belong to
  // <app-voyage-refresh-history>. What stays here is only what needs the map:
  // which snapshot is drawn, and what selecting one does.

  /** refreshId of the snapshot currently drawn on the map, or null for none. */
  voyageActiveRefreshId: string | null = null;
  /** Row the panel should highlight after "Jump to a date" resolves to one. */
  voyageFlashRefreshId: string | null = null;
  private _voyageFlashTimer: any = null;

  /**
   * Single-select entry point for a refresh-history ROW. Re-selecting the row
   * that is already on the map clears it — that toggle replaces "untick the
   * checkbox" and is the only way back to an empty map from the list.
   *
   * Only the panel's rows toggle. Anything that means "go to this snapshot"
   * (the archive modal, stepping) must use `showVoyageSnapshot` instead, or
   * asking for the snapshot already displayed would take it off the map.
   */
  async selectVoyageSnapshot(sensor: any, record: any): Promise<void> {
    // Re-selecting only toggles OFF when the archive is what owns the map. In
    // observations mode the same refreshId is drawn filtered, so this row is
    // "show me all of it", not "take it off" — otherwise the row that matches
    // the snapshot the observations were read from would be the one row in the
    // list that empties the map instead of filling it.
    if (
      this.voyageMapSource === 'history' &&
      this.voyageActiveRefreshId === record?.refreshId
    ) {
      this.clearVoyageSnapshot();
      return;
    }
    // Before the draw, and before `showVoyageSnapshot`'s swap-clear: this is
    // what hands the map from Observations to the archive.
    this.voyageMapSource = 'history';
    await this.showVoyageSnapshot(sensor, record);
  }

  // The search box's "Load latest snapshot" and "Refresh AOI" rows are gone,
  // and their handlers with them. Both acts already had a home: the sensor
  // row's Refresh button owns the paid pull and its entitlement guards, and the
  // Refresh History section owns loading a saved snapshot. The box now says so
  // in one line instead of offering a second copy of each control.

  /**
   * True while the Voyage Radar sensor's checkbox is ticked — the gate for
   * VR's map chrome (search box, located-vessel pill). The checkbox is free
   * to drive this: for VR it toggles nothing else (the paid pull lives on the
   * sensor row's Refresh button), and a successful refresh ticks it itself.
   */
  get isVoyageRadarSensorChecked(): boolean {
    return !!this.collection?.sensors?.some(
      (s: any) => s?.operatorKey === OPERATORS.VOYAGERADAR && s?.checked,
    );
  }

  /**
   * VoyageRadar has no scenes to point-task against, so a checked sensor stands in for one.
   *
   * The measurement tool is mutually exclusive with point tasking the same way
   * annotation is — both own the map click — so it disables the button here
   * rather than in the template, keeping the one rule in one place.
   */
  get canCreateNewTaskPoint(): boolean {
    return (
      (this.scenesNew.length > 0 || this.isVoyageRadarSensorChecked || this.isVesselFinderSensorChecked) &&
      !this.timeseries &&
      !this.annotateClicked &&
      !this.measurementModeActive
    );
  }

  /**
   * The Voyage Radar sensor checkbox is dead until the TOI opens.
   *
   * Everything the tick puts on the map is downstream of a window the operator
   * has not opened: the Refresh button beside it already reads "Not started"
   * and refuses the pull, the four sections below have nothing in them, and the
   * search box the tick reveals sells a WORLDWIDE lookup out of the same wallet
   * — a spend against a task that cannot yet return anything. Leaving the box
   * live offered chrome for a sensor with nothing behind it.
   *
   * Same guard, same scene and same sentence as the Refresh button's
   * `not-started` branch (`voyage-sensor-row.model.ts`), so the row cannot
   * disable one control and enable the other. TOI *ended* is deliberately not
   * here: the seven days of historical access are exactly when the archive in
   * Refresh History is worth putting back on the map.
   */
  voyageToiNotStarted(sensor: any): boolean {
    return isVoyageToiNotStarted(sensor);
  }

  /** Says which of the two it is, rather than leaving a dead box unexplained. */
  voyageSensorCheckTooltip(sensor: any): string {
    return isVoyageToiNotStarted(sensor)
      ? VOYAGE_TOI_NOT_STARTED_MESSAGE
      : 'Enable sensor controls on the map';
  }

  /**
   * Ticks that checkbox whenever the PANEL puts something on the map — a
   * snapshot, a track, a located saved vessel, or playback.
   *
   * The sections below the sensor row stay usable while the box is clear, so
   * every one of those actions could draw vessels onto a map with no Voyage
   * Radar chrome on it: no search box, no located-vessel pill, nothing to take
   * them off with. A refresh has always ticked the flag for exactly this reason
   * (see `VoyageMapController.refreshSensor`); these paths are the same act
   * through another door, so they tick it too.
   *
   * Only ever sets. Clearing stays with `clearVoyageSnapshot`, which owns the
   * other end of the flag's lifecycle.
   *
   * The sensor is passed in where the caller has one (the snapshot paths run
   * per-sensor); the rest resolve the collection's Voyage Radar sensor, which is
   * the same object the controller is bound to.
   */
  private _showVoyageChrome(sensor?: any): void {
    const target = sensor ?? this.voyage.sensor;
    if (target && !target.checked) target.checked = true;
    // The tasked target is part of that chrome, so it goes up here too rather
    // than only on a manual tick — otherwise the box could read "on" over a map
    // with no target on it, which is the same contradiction the flag exists to
    // prevent. Idempotent, and deliberately WITHOUT a fit: each caller frames
    // its own result (a snapshot its vessels, a track its path), and re-framing
    // the AOI over that would throw away the view that was asked for.
    this.voyage.showTarget();
    // The observed AREA has the target's lifetime for the target's reason — it
    // is drawn from the TASK, not from any snapshot — so it goes up on the same
    // paths and comes down on the same sweep.
    this.ensureVoyageObservationAreas(target);
  }

  /**
   * Puts the tasked target back after the shared `resetMapNew` sweep, which
   * strips every non-tile layer for reasons that have nothing to do with this
   * sensor. Gated on the checkbox, which is what owns the target's lifecycle —
   * on a task switch that is the NEW task's sensor, and the controller has
   * already dropped the old task's layer.
   *
   * The WeatherEx and AISstream twins are called from the same place.
   */
  private _ensureVoyageTargetOnMap(): void {
    if (this.isVoyageRadarSensorChecked) this.voyage.showTarget();
  }

  /**
   * The Voyage Radar sensor checkbox changed.
   *
   * Unticked, it clears the map — every Voyage Radar layer, not just the
   * snapshot. The flag already meant "this sensor has something on the map",
   * and now that ANY panel action ticks it (`_showVoyageChrome`), leaving the
   * layers up while the box says otherwise is the same contradiction in
   * reverse: a hidden search box over vessels the user can still see, with no
   * single control left that takes them all down.
   *
   * Ticking draws the tasked TARGET — the AOI ring, or a POI task's reticle and
   * radius disc — and frames it. That is the one thing the box can put on the
   * map without guessing: the target is a property of the task, the same every
   * time, and it is the answer to "where am I looking" that the chrome above it
   * is otherwise floating over. It is NOT the inverse of unticking, and
   * deliberately so: redrawing the DATA would have to guess which snapshot,
   * which track and which of fifty saved-vessel rows the user meant, and every one
   * of those choices is a click away in the sections below.
   *
   * The target then stays put — through a refresh, a snapshot swap, a step
   * through history, a map sweep — until this box is unticked, which is the
   * only thing that takes it down. It used to be a side-effect of whichever
   * render path last ran, so it appeared on a snapshot click and not on a tick.
   *
   * Order is top layer down, which is also the order the ON MAP bar stacks
   * them: playback owns the map while it runs, a track is drawn over the
   * snapshot, and located markers sit above both.
   */
  voyageSensorToggled(checked: boolean, sensor?: any): void {
    if (checked) {
      this.voyage.showTarget({ fit: true });
      // The observed AREA goes up with the target, and for the same reason: it
      // is a property of the TASK, so there is nothing to guess and no click
      // worth charging for a look at the question the task is asking.
      this.ensureVoyageObservationAreas(sensor);
      // ...and then its ANSWER, from the archive the task has already paid for.
      // The one exception to "ticking does not redraw the DATA": every other
      // layer needs a choice made (which snapshot, which track, which of fifty
      // saved vessels) and this one does not — a tip-and-cue task has exactly
      // one question and its newest answer is the newest snapshot. Free: the
      // recall is a stored artifact, not a pull.
      //
      // Guarded on the sensor actually carrying observations, so a plain Voyage
      // Radar task still opens on a bare target the way it always has.
      if ((sensor ?? this.voyage.sensor)?.Observation?.length) {
        void this.showVoyageObservations(sensor);
      }
      return;
    }
    if (this.playback.mode === 'playback') {
      // The same exit the ON MAP bar's X uses — it restores the live layer,
      // which `clearVoyageSnapshot` below then takes off properly.
      this.playback.resumeLive();
    }
    // Guarded: `resumeLive` also fires the track controller's exit hook, which
    // has work to undo only when a path was actually drawn.
    if (this.track.hasTrack) this.stopVoyageTrack();
    this.voyage.takeAllLocatedOffMap();
    this.clearVoyageSnapshot();
    // Last: every layer path above leaves the target alone. Unticking is what
    // ends its life — `clearVoyageSnapshot` has one more of these, but only for
    // the case where its own sweep unticked the box, so the rule holds.
    this.voyage.clearTarget();
  }

  // ── Vessel Search History panel section → map controller ──────────────────
  /** Bound as a function input so the section can tag rows that are drawn. */
  voyageHistoryOnMap = (mmsi: string): boolean => this.voyage.isLocatedOnMap(mmsi);

  voyageHistoryLocate(record: any): void {
    this._showVoyageChrome();
    this.voyage.locateHistoryRecord(record);
  }

  voyageHistoryRefresh(record: any): void {
    const mmsi = String(record?.mmsi ?? '').trim();
    if (mmsi) this.voyage.refreshVesselLookup(mmsi);
  }

  /** Marker off, row kept — the reversible one. */
  voyageHistoryTakeOffMap(record: any): void {
    const mmsi = String(record?.mmsi ?? '').trim();
    if (mmsi) this.voyage.takeLocatedOffMap(mmsi);
  }

  /** Out of Saved Vessels for good, and off the map with it. */
  voyageHistoryRemove(record: any): void {
    const mmsi = String(record?.mmsi ?? '').trim();
    if (mmsi) this.voyage.removeLocatedVessel(mmsi);
  }

  // ── Observations panel section → map ──────────────────────────────────────
  /**
   * THE OBSERVATION IS THE TASK'S TRIGGER, and on a tip-and-cue task it is also
   * the DEFAULT VIEW. Ticking the sensor draws three things, in the order a
   * reader needs them: the tasked target (where), the observed area (what is
   * being asked), and the newest snapshot filtered to the vessels that answer it
   * (what was found). None of the three needs a choice made, which is why the
   * checkbox can draw them and cannot draw a track or a saved vessel.
   *
   * The host jobs below are therefore: own the exclusion between this section
   * and the snapshot archive (`voyageMapSource`), keep the observed areas up for
   * the sensor's lifetime, centre on one, and centre on a matched row.
   *
   * The section itself is AIS-shared and names no provider; everything here is
   * Voyage Radar's ANSWER to it. Wiring a second AIS operator means another set
   * of these — its own "what is drawn", its own exclusion rule and its own
   * "centre on this vessel" — and nothing inside the component.
   *
   * Deliberately NOT routed through `onObservationToggle` / `renderObservation`:
   * those are the shared imagery path (vessel-length overlays, feed panels,
   * blocking dialogs) that every other operator still uses, and the one flag
   * they hang state on — `checkedObservation` — is a single boolean shared by
   * every row. Voyage Radar's needs are a fly-to and a polygon.
   */

  /**
   * Every observed area currently drawn, by observation id.
   *
   * A map rather than a list so the header's centre button can frame the shape
   * it was handed. `L.Circle.getBounds()` projects through `_map` and throws on
   * a layer that was never added, so a lone point's disc cannot be re-derived on
   * demand — the drawn layer is the only thing that can answer for it.
   */
  private voyageObservationAreaLayers = new Map<string, any>();
  /** Memo for the snapshot label — the template asks once per change detection. */
  private _voyageObsLabelFor: string | null = null;
  private _voyageObsLabel: string | null = null;

  /**
   * WHICH SECTION OWNS THE VESSELS ON THE MAP — the panel's one exclusion rule.
   *
   * Observations and Refresh History both put hulls on screen and only one of
   * them may: two GeoJSON layers over the same AOI stack markers on identical
   * positions, and neither section could then honestly say what is drawn.
   *
   *   'observations' — the latest snapshot, FILTERED to what the observations
   *                    match. The default once the sensor is ticked.
   *   'history'      — a snapshot the user picked, drawn whole.
   *   null           — nothing of either is drawn.
   *
   * Set BEFORE the draw, because it is what the draw paths read to decide
   * whether to filter (`fetchRecalledSnapshot`, and the live-pull branch of
   * `addAisVesselsToMap`). Cleared only by the real clear — `clearVoyageSnapshot`
   * with `resetFilters`, which is "take it off the map"; the swap paths pass
   * false and keep the mode across the exchange, which is exactly how stepping
   * through history stays in history and a refresh stays in observations.
   */
  voyageMapSource: 'observations' | 'history' | null = null;

  /**
   * The UNFILTERED snapshot observations mode searched.
   *
   * Kept apart from `voyage.currentFeatures` because in this mode those two are
   * deliberately different: the map holds the matches, the panel is answering
   * "checked all 143 vessels and found one", and a panel fed the filtered set
   * would report having searched its own answer.
   */
  private voyageObservationSource: any[] = [];

  /** True while the Observations section is what the map is drawing. */
  get voyageObservationsOnMap(): boolean {
    return this.voyageMapSource === 'observations';
  }

  /**
   * The features the panel searches — the snapshot behind what is drawn.
   *
   * In observations mode that is the source set above, not the filtered layer;
   * in history mode the drawn snapshot IS the searched set.
   */
  get voyageObservationFeatures(): any[] {
    if (this.voyageMapSource === 'observations') return this.voyageObservationSource;
    return this.voyage.currentFeatures ?? [];
  }

  /**
   * The subset of `features` this sensor's observations answer to — what
   * observations mode draws.
   *
   * The rule lives in the shared AIS model, matched against the same predicates
   * the panel lists rows with, so the map and the list can never disagree about
   * which hulls answer the trigger.
   */
  private voyageObservationMatches(sensor: any, features: any[]): any[] {
    const views = buildAisObservations(sensor?.Observation);
    // No observation to filter BY is not "nothing matches" — it is nothing to
    // filter, and answering with an empty map would have the section reporting
    // a snapshot the user cannot see. Unreachable through the UI (the section
    // and its toggle both require observations) and the honest degradation if a
    // record ever stops parsing.
    if (!views.length) return features;
    return matchedAisObservationFeatures(views, features);
  }

  /**
   * Takes the non-matching markers off an ALREADY-BUILT vessel layer and hands
   * back the matching features.
   *
   * The live-pull path builds its layer in the shared `getVesselsGeojson` before
   * Voyage Radar gets a say, so unlike the recall path there is no list left to
   * filter before drawing — the choice is to prune or to re-render, and pruning
   * keeps the popups, colours and click handlers the shared builder already
   * wired.
   *
   * THE LAYER AND THE LIST ARE TWO SHAPES OF ONE SNAPSHOT, which is the whole
   * reason this is written the way it is. `getVesselsGeojson` is handed
   * `convertToGeoJSONNew(data, type)` — the MAPPED features — while the branch
   * that adopts the result passes `data.features`, the RAW ones. That split is
   * long-standing and deliberate (the matcher and the vessel index both read
   * either spelling), but it means the two arrays share no objects: matching the
   * layer by identity against the list would find nothing in common and prune
   * every marker on the map. Each side is therefore matched against ITSELF, and
   * the predicates — being the same predicates — agree on which hulls those are.
   */
  private pruneVoyageLayerToObservations(layer: any, sensor: any, features: any[]): any[] {
    const views = buildAisObservations(sensor?.Observation);
    // Nothing to filter by — see `voyageObservationMatches`. Returns early
    // rather than pruning to nothing, so the layer and the list still agree.
    if (!views.length) return features;

    if (layer?.eachLayer && layer?.removeLayer) {
      const drawn: any[] = [];
      layer.eachLayer((sub: any) => {
        if (sub?.feature) drawn.push(sub.feature);
      });
      const keep = new Set<any>(matchedAisObservationFeatures(views, drawn));
      // Collected before removing: `removeLayer` mutates the very collection
      // `eachLayer` is walking. A sublayer carrying no `feature` is left alone
      // rather than swept — it is not a vessel this pass has an opinion about.
      const doomed: any[] = [];
      layer.eachLayer((sub: any) => {
        if (sub?.feature && !keep.has(sub.feature)) doomed.push(sub);
      });
      for (const sub of doomed) layer.removeLayer(sub);
    }

    return matchedAisObservationFeatures(views, features);
  }

  /**
   * "11:54 UTC" — which snapshot the panel searched, so its answer is
   * checkable against Refresh History. Null when nothing is drawn, which is
   * also what puts the section into its "nothing to search yet" state.
   *
   * The playback frame outranks the selected snapshot: during a replay the
   * frame on screen IS what the panel is searching.
   */
  voyageObservationSnapshotLabel(sensor: any): string | null {
    // The SEARCHED set, not the drawn one. In observations mode the map holds
    // only the matches, so a snapshot that answered nothing draws nothing —
    // reading `currentFeatures` here would drop the label at exactly the moment
    // "checked all 143 vessels in the 11:54 snapshot" is the whole answer.
    if (!this.voyageObservationFeatures.length) return null;
    const refreshId =
      (this.playback.mode === 'playback'
        ? this.playback.snapshot().playbackRefreshId
        : this.voyageActiveRefreshId) ?? null;
    if (!refreshId) return null;
    if (refreshId === this._voyageObsLabelFor) return this._voyageObsLabel;

    const entry = normalizeVoyageHistory(sensor?.refreshHistory).find(
      (e) => e.refreshId === refreshId
    );
    const d = entry ? new Date(entry.timeMs) : null;
    const pad = (n: number) => String(n).padStart(2, '0');
    this._voyageObsLabelFor = refreshId;
    this._voyageObsLabel = d
      ? `${pad(d.getUTCHours())}:${pad(d.getUTCMinutes())} UTC`
      : null;
    return this._voyageObsLabel;
  }

  /**
   * A row was picked: centre the map on that vessel and select it.
   *
   * `locateLoadedVessel` rather than a private fly-to — it is the search
   * drawer's own pick, so a hull found here and the same hull found by typing
   * its MMSI end in exactly the same place, with the same popup open.
   */
  voyageObservationFocus(event: AisObservationFocus): void {
    const match = event?.match;
    if (!match?.mmsi) return;
    this._showVoyageChrome();
    this.voyage.locateLoadedVessel({
      mmsi: match.mmsi,
      name: match.name,
      shipType: match.shipType,
      lat: match.lat,
      lng: match.lng,
      // The rows come from the drawn snapshot by construction, which is what
      // `live` means to the pick — it looks for the marker already on the map
      // before it considers the saved list.
      source: 'live',
      frameTime: null,
      kept: false,
    });
  }

  /**
   * Draws every observed AREA the task carries — the shape a `vessel_location`
   * observation watches — and leaves it up for the sensor's lifetime.
   *
   * NO LONGER A TOGGLE. It used to be a per-observation button in the section
   * body, which put the one thing on the map the vessels cannot show — the
   * QUESTION being asked of them — behind a click that most tasks never got.
   * The area is a property of the task, the same every time and never wrong, so
   * it goes up with the tasked target and for the target's reasons: it survives
   * every snapshot swap and comes down only when the sensor is unticked.
   *
   * Idempotent, and deliberately WITHOUT a fit — it runs inside
   * `_showVoyageChrome`, which every panel action passes through, and re-framing
   * the observed area over a result the user just asked for would throw away the
   * view they wanted. The header's centre button is the deliberate look at it.
   *
   * ALL geometry observations, not the first: the header's centre button has one
   * slot and picks, but the map has no reason to draw only half an answer.
   */
  private ensureVoyageObservationAreas(sensor?: any): void {
    if (this.voyageObservationAreaLayers.size || !this.map) return;
    const target = sensor ?? this.voyage.sensor;
    const views = buildAisObservations(target?.Observation).filter((v) => v.hasGeometry);
    if (!views.length) return;

    for (const view of views) {
      const layer = this.buildVoyageObservationAreaLayer(view);
      if (!layer) continue;
      layer.addTo(this.map);
      this.voyageObservationAreaLayers.set(view.id, layer);
    }
  }

  /** The observed area as a Leaflet layer — a ring as drawn, a lone point as its tolerance disc. */
  private buildVoyageObservationAreaLayer(view: AisObservationView): any {
    if (view.ring) {
      return L.polygon(
        view.ring.map(([lng, lat]) => [lat, lng] as [number, number]),
        { color: '#1059A9', weight: 2, fillColor: '#1059A9', fillOpacity: 0.14, pane: 'voyageObservationAreaPane' }
      );
    }
    if (view.point) {
      return L.circle([view.point[1], view.point[0]], {
        // The tolerance the MATCHER applies, drawn to scale off the same
        // constant — a pin would say "here" where the rule says "within
        // 500 m of here", and a hardcoded radius here could drift from it.
        radius: AIS_OBSERVATION_TOLERANCE_M,
        color: '#1059A9',
        weight: 2,
        fillColor: '#1059A9',
        fillOpacity: 0.14,
        pane: 'voyageObservationAreaPane',
      });
    }
    return null;
  }

  /**
   * The header's centre button: frame the observed area.
   *
   * `_showVoyageChrome` first, which redraws the areas if a map sweep took them
   * off — the button has to be able to show what it claims to be centring on,
   * and a fit onto a shape that is not there is the click that silently does
   * nothing.
   */
  voyageObservationCentre(view: AisObservationView): void {
    this._showVoyageChrome();
    const bounds = this.voyageObservationAreaLayers.get(view?.id)?.getBounds?.();
    if (bounds?.isValid?.()) this.map.fitBounds(bounds, { padding: [20, 20] });
  }

  /**
   * The header's on-map toggle: put the matched vessels up, or take them off.
   *
   * ON is a load, not a filter of what is already drawn — the mode has to be
   * able to answer from an empty map (the section is usable before any snapshot
   * has been picked), and the snapshot it answers from is always the LATEST,
   * which is the one the task's own tip sweep would have run against.
   *
   * OFF clears the map outright rather than falling back to the snapshot
   * underneath: there is no snapshot underneath. The two sections are exclusive,
   * so whatever history row was drawn came off when observations took over, and
   * silently restoring it would be a second thing this button does.
   */
  async voyageObservationToggleOnMap(sensor: any): Promise<void> {
    if (this.voyageMapSource === 'observations') {
      this.clearVoyageSnapshot();
      // The toggle takes this section's VESSELS off, not the sensor. When the
      // matches came from a live pull, `clearVoyageSnapshot`'s sweep also unticks
      // the box and drops the target with it — correct for the ON MAP bar's X,
      // which is a clear-everything control, and wrong for a section toggle. The
      // chrome is re-asserted rather than the sweep narrowed, so the one place
      // that decides what a cleared map looks like stays one place.
      this._showVoyageChrome(sensor);
      return;
    }
    await this.showVoyageObservations(sensor);
  }

  /**
   * Puts the observation's answer on the map: the latest snapshot, filtered to
   * the vessels that match.
   *
   * THE DEFAULT VIEW OF A TIP-AND-CUE TASK. Ticking the sensor lands here, which
   * is why the section no longer opens on "nothing to search yet" for a task
   * that has been refreshing all day — the answer to "did anything match" was
   * always one archive click away and never shown.
   *
   * The latest refresh rather than a re-pull: the snapshot is already bought and
   * stored, and a pull would spend a credit to re-ask a question the archive
   * already answers. Nothing to load is not a failure — the mode still engages
   * and the section states which of its empty cases this is.
   */
  async showVoyageObservations(sensor: any): Promise<void> {
    const target = sensor ?? this.voyage.sensor;
    this._showVoyageChrome(target);
    const latest = normalizeVoyageHistory(target?.refreshHistory)[0];
    if (!latest) {
      // No archive yet. Take whatever the OTHER section had off the map anyway —
      // the toggle reads "on", and leaving a history snapshot drawn under it is
      // the exact confusion the exclusion rule exists to prevent.
      this.clearVoyageSnapshot();
      // Same re-assert as the toggle's off branch — the sweep can untick the
      // sensor, and this path is on its way to turning the section ON.
      this._showVoyageChrome(target);
      this.voyageMapSource = 'observations';
      this.voyageObservationSource = [];
      return;
    }
    // Before the draw: `fetchRecalledSnapshot` reads this to decide whether to
    // filter, and the recall is async.
    this.voyageMapSource = 'observations';
    await this.showVoyageSnapshot(target, latest.data);
  }

  /**
   * Takes every observed area off the map. Called by the sensor checkbox's sweep
   * and by the task-switch reset — like the tasked target it is a property of
   * the TASK, so it outlives a snapshot swap and dies only when the sensor's
   * layers do.
   */
  private clearVoyageObservationArea(): void {
    if (this.map) {
      for (const layer of this.voyageObservationAreaLayers.values()) {
        this.map.removeLayer(layer);
      }
    }
    this.voyageObservationAreaLayers.clear();
  }

  /**
   * Draws a snapshot, whatever was drawn before. The single selection path —
   * the panel's rows, the archive modal and the step controls all end up here,
   * so the two views can never disagree about what is on the map.
   */
  async showVoyageSnapshot(sensor: any, record: any): Promise<void> {
    // A caller that means Observations sets the mode first; everything else
    // arriving here is asking for a snapshot whole, which is the archive.
    // Assigned BEFORE the swap-clear below so the draw path reads a settled
    // answer, and unconditionally so a stale 'observations' can never leak into
    // an archive pick.
    if (this.voyageMapSource !== 'observations') this.voyageMapSource = 'history';
    // Swapping, not clearing — the vessel-type selection carries over so
    // stepping through history with a filter on stays filtered.
    this.clearVoyageSnapshot(false);
    // The searched set describes the OUTGOING snapshot and the recall below is
    // async — left standing it would have the section reporting the previous
    // snapshot's matches while the next one loads. The draw path refills it.
    this.voyageObservationSource = [];
    if (!record?.refreshId) return;

    this._showVoyageChrome(sensor);
    this.voyageActiveRefreshId = record.refreshId;
    await this.displayChangeData(
      { checked: true },
      sensor?.scenes?.[0],
      sensor,
      'display',
      record
    );
  }

  // `stepVoyageSnapshot` lived here: prev/next across the whole refresh history,
  // driven by the < > buttons on the ON MAP summary cards. It went with them —
  // nothing else ever called it. Picking a snapshot in Refresh History reaches
  // the same records by a different gesture; what is gone is walking the archive
  // WITHOUT opening that list, which the cards could do because they always knew
  // which snapshot was drawn. `stepVoyageSnapshot` in
  // voyage-refresh-history.model.ts is the resolver it used and is now unused
  // too, kept because it is pure, tested, and the whole of what a restored
  // control would need.

  /**
   * Opens the "Browse snapshots" archive — the far half of the snapshot UI.
   *
   * The modal opens on the day of whatever is currently drawn, so this one
   * entry point serves both the panel footer's "Browse all" and the ON MAP
   * bar's "locate". It resolves a record and hands it back; it never clears the
   * map, so there is no way for it to undo a selection by accident.
   */
  openVoyageHistoryBrowser(sensor: any, collectionIndex: any, sensorIndex: any): void {
    const ref = this.matdialog.open(VoyageHistoryBrowserComponent, {
      panelClass: 'vr-modal-panel',
      autoFocus: false,
      backdropClass: 'blurr',
      data: {
        history: sensor?.refreshHistory,
        activeRefreshId: this.voyageActiveRefreshId,
        timezone: this.utilsService.getUserTimezone(this.currentUser),
        // Downloading needs the collection/sensor indices, which only the host
        // has — so the work is handed down rather than the modal reaching for a
        // service. Keeps the dialog open, unlike a close-with-an-action result.
        onDownload: (record: any) =>
          this.download(collectionIndex, sensorIndex, undefined, record),
      },
    });

    ref.afterClosed().subscribe(async (result: VoyageHistoryBrowserResult | undefined) => {
      if (!result?.record) return;
      // The archive is the archive whichever door it was opened from — including
      // the Observations section's own "browse" links, which are how a user asks
      // to see a whole snapshot instead of just its answer. Set explicitly
      // rather than left to `showVoyageSnapshot`'s default, which preserves an
      // active observations mode.
      this.voyageMapSource = 'history';
      await this.showVoyageSnapshot(sensor, result.record);
      this._flashVoyageSnapshot(result.record.refreshId);
    });
  }

  /**
   * Takes the active snapshot off the map. Sweeps EVERY Voyage Radar sensor in
   * the collection, not just one, so a mixed task can never end up with two
   * snapshot layers drawn at once.
   *
   * The active snapshot may be the LIVE pull (drawn in `aisVesselLayer` and
   * tagged with its refreshId) rather than a recalled history layer. The sweep
   * removes it either way; the extra step below also unchecks the sensor, so
   * the checkbox honestly reads "nothing shown" and re-checking it pulls again.
   *
   * `resetFilters` separates the two things this method is used for. Clearing
   * the map (the ON MAP bar's button, a task switch) also drops the vessel-type
   * selection — the categories it was chosen from are gone. Making way for the
   * next snapshot does not: stepping through history or refreshing keeps the
   * filter, which is the whole point of `adoptLiveLayer` re-applying it.
   */
  clearVoyageSnapshot(resetFilters = true): void {
    // A POI refresh's nearby LIST is a snapshot in every sense that matters
    // here — it came from a refresh row and exactly one may be shown — but it
    // lives in the controller as a popup, not in a refreshId-tagged GeoJSON
    // layer, so the sweep below cannot reach it.
    //
    // This takes the list off and leaves the reticle and disc standing: those
    // are the tasked TARGET, and the target belongs to the sensor checkbox, not
    // to whichever refresh happens to be drawn.
    this.voyage.clearPoiNearby();
    const liveLayer: any = this.aisVesselLayer;
    const liveWasActive = !!(
      liveLayer?.refreshId &&
      this.voyageActiveRefreshId &&
      liveLayer.refreshId === this.voyageActiveRefreshId
    );

    const sensors = Array.isArray(this.collection?.sensors) ? this.collection.sensors : [];
    for (const s of sensors) {
      if (s?.operatorKey !== OPERATORS.VOYAGERADAR) continue;
      const history = Array.isArray(s.refreshHistory) ? s.refreshHistory : [];
      for (const h of history) {
        if (!h?.checked && h?.refreshId !== this.voyageActiveRefreshId) continue;
        h.checked = false;
        this.removeDataSourceById(h.refreshId);
      }
      if (liveWasActive) {
        s.checked = false;
        (s.scenes ?? []).forEach((scene: any) => (scene.checked = false));
      }
    }

    if (liveWasActive) {
      // The sweep already took the layer off the map (it matches by refreshId);
      // this drops the footprint + stale references through the canonical path.
      this.removeVesselLayer();
    }

    // Nothing is on the map now, so the vessel-type selection has nothing left
    // to filter. `releaseLiveLayer` has already dropped the categories.
    //
    // Same for the VESSEL selection — its hull left with the snapshot, so the
    // halo, the trace drawer and the track bar's pill go with it. Only on this
    // branch: a swap (`resetFilters` false) hands the selection to the layer
    // that lands next, which is what `reanchorActiveVessel` is for.
    if (resetFilters) {
      this.playback.resetTypeFilter();
      this.voyage.dropSelectionWithMap();
    }

    this.filterData = [];
    this.voyageActiveRefreshId = null;

    // The mode is the answer to "which section owns the map", so it survives a
    // SWAP (one section handing itself a different snapshot) and dies with the
    // clear. `resetFilters` is already exactly that distinction — see the note
    // on the parameter — so the two share it rather than growing a second flag
    // that could disagree with it.
    if (resetFilters) {
      this.voyageMapSource = null;
      this.voyageObservationSource = [];
    }

    // The sweep above unticks the sensor whenever the LIVE pull was what came
    // off, which is the ON MAP bar's X clearing the map. The target follows the
    // box, so it goes too — otherwise the outline would outlive the control
    // that owns it. A check rather than an unconditional clear because the SWAP
    // paths come through here as well, and they re-tick and redraw a line
    // later: taking the target down between two snapshots would be the flicker
    // this whole change exists to remove.
    // The observed AREA has the target's lifetime, for the target's reason: it
    // is drawn from the TASK, not from any snapshot, so it survives every swap
    // and comes down on the same sweep the outline does.
    if (!this.isVoyageRadarSensorChecked) {
      this.voyage.clearTarget();
      this.clearVoyageObservationArea();
    }
  }

  /**
   * "Playback history" in the Refresh History section: replay every saved
   * refresh on the map. Same call the map toolbar's copy makes, but reachable
   * with an empty map — the toolbar only exists while vessels are drawn, so
   * without this the free replay used to cost a refresh to reach.
   *
   * Guarded on both loads a Voyage Radar sensor can be in the middle of. A
   * refresh in flight is about to replace the very layer a replay would hide,
   * and a replay already loading must not have a second one started over it —
   * the controller refuses that anyway, but a click that silently does nothing
   * is worth not making. The pill disables itself off the same two flags.
   */
  startVoyagePlayback(): void {
    const state = this.playback.snapshot();
    if (state.loading || state.playbackLoading) return;
    this._showVoyageChrome();
    // A replay is the archive playing itself, so it takes the map off
    // Observations the same way picking one row does. The panel keeps searching
    // — `voyageObservationFeatures` falls back to the drawn features, which
    // during a replay are the frame on screen — it just stops claiming to own
    // what is drawn.
    this.voyageMapSource = 'history';
    this.voyageObservationSource = [];
    this.playback.enterHistoryPlayback();
  }

  /**
   * Voyage Radar sensor row → pull a fresh AOI snapshot.
   *
   * Replaces the sensor checkbox for this operator. The checkbox spent a refresh
   * credit on a tick and could not give it back, so the action now says its price
   * on the button instead — see `resolveVoyageRefreshState`.
   *
   * Only the LAST credit confirms. Confirming every refresh would nag, but the
   * last one is the only click here that cannot be worked around afterwards, and
   * it is the same courtesy the paid track fetch already extends.
   */
  /**
   * API credits left in a Voyage Radar sensor's wallet, for the sensor row's
   * credits pill. Null means the wallet is unknown, and the pill hides —
   * see `voyageCreditsRemaining`.
   */
  voyageCreditsLeft(sensor: any): number | null {
    return voyageCreditsRemaining(sensor);
  }

  /**
   * A wallet too small for ANY catalogue action is stranded, not healthy —
   * the pill turns red below the cheapest action, not only at zero.
   */
  voyageCreditsStranded(sensor: any): boolean {
    const left = voyageCreditsRemaining(sensor);
    // Measured against the actions THIS target shape can reach: the area
    // refresh is unreachable from a point task, so counting it would rate a
    // wallet healthy on the strength of a call the task can never make. That
    // is the only row the narrowing still removes, and only in that direction
    // — `nearby` carries no target because it prices an endpoint that is about
    // to serve a second caller, the per-vessel search of plan steps 4-8 (not
    // built yet), so an area task is not filtered out of that row and this
    // floor counts it rather than dropping it. The threshold does not actually
    // move either way today: search, lookup and port calls are 1 credit apiece
    // and are the cheapest actions on both shapes. The
    // narrowing stays because the catalogue is re-priced in ee-admin, and the
    // day a refresh becomes the cheapest action it must not be an unreachable
    // one that rates the wallet healthy.
    const reachable = actionsForTarget(
      normalizeCreditActions(sensor?.apiCreditActions),
      isPoiSensor(sensor),
    );
    return left != null && left < minActionCredits(reachable);
  }

  refreshVoyageSensor(sensor: any, state: VoyageRefreshState): void {
    if (!sensor || state?.disabled) return;

    if (!state?.confirms) {
      this.voyage.refreshSensor(sensor);
      return;
    }

    const remaining = state?.remaining;
    // `state.cost` is already the doc-resolved price for THIS sensor's target
    // shape — the same number the button prints and the server will charge.
    // Re-deriving it from a constant here is how the confirmation used to
    // quote one price while the wallet was debited another.
    const cost = state.cost;
    const afterSpend = remaining != null ? Math.max(0, remaining - cost) : null;
    const ref = this.dialog.open(WarningPopup, {
      width: '42%',
      data: {
        showCancelButton: true,
        buttonLabel: `Use ${cost} credits`,
        message:
          `This refresh costs ${cost} credits` +
          (afterSpend != null ? ` and will leave you with ${afterSpend}` : '') +
          ', which is not enough for another action. To continue afterwards ' +
          'you would need to re-task. Continue?',
      },
    });
    ref.afterClosed().subscribe((result) => {
      if (result === 1) this.voyage.refreshSensor(sensor);
    });
  }

  /**
   * Is the refund icon live for this Voyage Radar sensor?
   *
   * Mirrors VoyageCreditRefundComponent.canRequestRefund so the icon and the
   * dialog cannot disagree; the server checks again on submit.
   */
  canRequestVoyageRefund(sensor: any): boolean {
    return canRequestVoyageRefundRule(sensor);
  }

  /** Why the refund icon is inert — an unlabelled disabled icon explains nothing. */
  voyageRefundTooltip(sensor: any): string {
    if (sensor?.returnRefundAccept) return 'Refund approved';
    if (sensor?.returnRefundReject) return 'Refund declined';
    if (sensor?.refundRequest) return 'Refund already requested';
    // A spent wallet and an absent one read the same to the user: either way
    // there is nothing left to ask back.
    return 'No credits to refund';
  }

  /**
   * Voyage Radar credit usage + refund — opened from the refund icon.
   *
   * The WeatherEx flow with a wallet: pre-check via returnRefundStatus
   * (product 'VoyageRadar'), then one dialog carrying both the usage ledger and
   * the request form. Eligibility is the remaining balance alone (server-checked
   * too) and the wallet is NOT frozen while a request is pending.
   */
  openVoyageCreditRefund(collectionIndex: number, sensorIndex: number): void {
    const sensor = this.collections[collectionIndex]?.sensors?.[sensorIndex];
    const taskId = this.collections[collectionIndex]?.taskId;
    if (!sensor || !taskId) return;

    const statusReq = {
      taskId,
      sensorId: sensor?.id,
      sceneId: undefined,
      product: 'VoyageRadar',
      feedId: undefined,
    };

    this.apiService.returnRefundStatus(statusReq).subscribe((res: any) => {
      if (this.isPartialDelivery(res)) return;
      if (res?.returnRefundAccept || res?.returnRefundReject) {
        const message = res?.returnRefundReject
          ? 'return-refund-rejected'
          : 'return-refund-accepted';
        this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
        return;
      }
      if (res?.refundRequest) {
        this.popupService.openPopup(
          CollectionPopupComponent,
          'return-refund',
          { msg: 'VoyageRadar' },
          '40%'
        );
        return;
      }

      // The dialog derives the whole ledger from the sensor, so it is passed
      // whole rather than pre-summarised — one source, nothing to keep in sync.
      const dialog = this.matdialog.open(VoyageCreditRefundComponent, {
        minWidth: '50%',
        // The dialog keeps its own body scrollable; this stops the pane itself
        // from growing past the window on a short viewport.
        maxHeight: '90vh',
        data: { taskId, sensorId: sensor?.id, sensor },
        backdropClass: 'blurred',
        disableClose: true,
      });
      dialog.afterClosed().subscribe((result) => {
        if (result?.refundRequested) {
          // Flip the flag locally so the refund icon reads "pending" without a
          // reload — the server has already persisted it.
          sensor.refundRequest = true;
          this.popupService.openPopup(
            CollectionPopupComponent,
            'return-refund-success',
            '',
            '40%'
          );
        }
      });
    });
  }

  // ── Voyage Radar: vessel tracks ─────────────────────────────────────────────
  // The Vessel Tracks section is presentational; what stays here is the part
  // that needs the map, the API or the download plumbing. Which track is drawn
  // is NOT held here — it lives on `track`'s state as `activeTrackId`, so
  // the section and the ON MAP bar read one source and cannot disagree.

  /**
   * Replay a purchased track. Free — the positions are recalled from S3 by id,
   * so no operator call and no credit is involved.
   */
  playVoyageTrack(record: any): void {
    if (!record?.trackId) return;
    this._showVoyageChrome();
    this.voyage.replaySavedTrack(record.trackId);
  }

  /** Take the drawn track off the map, leaving the vessel selected. */
  stopVoyageTrack(): void {
    this.track.resumeLive();
  }

  /**
   * Download a purchased track as JSON.
   *
   * Deliberately not routed through `download()`: that builds its key from a
   * refreshId/predictionId and ends in the zip branch of /tasks/getHistory,
   * which has no meaning for a track. The signed URL from `getVoyageRadarTrack`
   * — which resolves the track by its stored s3Key on /getVoyageRadarSnapshot —
   * is fetched and saved directly instead, under a name built from the vessel's
   * resolved identity so an unnamed hull yields "MMSI636092371_…" rather than
   * the "null_…" a naive template would produce.
   */
  async downloadVoyageTrack(sensor: any, record: any): Promise<void> {
    if (!record?.trackId) return;
    if (this.freeze) {
      this.popupService.openPopup(
        CollectionPopupComponent,
        'A download is in progress. Please wait until the current download finishes to continue downloading others.',
        '',
        '40%'
      );
      return;
    }

    const identity = resolveVesselIdentity(
      record,
      this.voyage.liveVessels.get(String(record.mmsi))?.name
    );
    const fileName = voyageTrackFileName(record, identity);

    try {
      const res: any = await firstValueFrom(
        this.apiService
          .getVoyageRadarTrack({
            taskid: this.collection?.taskId,
            sensorId: sensor?.id,
            trackId: record.trackId,
          })
          .pipe(takeUntil(this.destroy$))
      );
      const url = res?.result?.imageUrl;
      if (!url) throw new Error('missing track url');

      const downloadTarget = await this.resolveDownloadTarget(fileName);
      if (!downloadTarget) return;

      const response = await fetch(url);
      if (!response.ok) {
        this.showDownloadError();
        return;
      }

      const saveResult = await this.downloadService.saveBlob(
        await response.blob(),
        fileName,
        downloadTarget
      );
      if (saveResult.status === 'cancelled') {
        this.resetDownload();
        return;
      }
      if (saveResult.status !== 'saved') {
        this.popupService.openPopup(CollectionPopupComponent, saveResult.message, '', '40%');
        this.resetDownload();
      }
    } catch {
      this.popupService.openPopup(
        CollectionPopupComponent,
        'That track could not be downloaded. Please try again.',
        '',
        '40%'
      );
    }
  }

  /** Briefly highlights a row — used when "Jump to a date" resolves to one. */
  private _flashVoyageSnapshot(refreshId: string): void {
    if (this._voyageFlashTimer) clearTimeout(this._voyageFlashTimer);
    this.voyageFlashRefreshId = refreshId;
    this._voyageFlashTimer = setTimeout(() => {
      this.voyageFlashRefreshId = null;
      this._voyageFlashTimer = null;
      this.changDetectionRef.detectChanges();
    }, 1400);
  }

  /** Resets all VoyageRadar on-map toolbar state (path, playback, flags).
   *  Called from the shared resetMapNew — kept VR-only so it can't touch others. */
  private _resetVoyageRadarToolbar(): void {
    // Snapshot playback, track mode and their layers all belong to the controller.
    this.voyage.reset();
    // The refresh-history timeline is per-collection. Drop the LAYER as well as
    // the selection: resetMapNew's removeLayers() only walks `scenesNew` and
    // knows nothing about refreshDataSource layers, so leaving this to it would
    // open the next task with the previous one's vessels still drawn under an
    // "ON MAP" bar that says nothing is.
    const outgoingSnapshotId = this.voyageActiveRefreshId;
    this.clearVoyageSnapshot();
    // clearVoyageSnapshot() sweeps `this.collection`, which on a task switch is
    // already the NEW task — so also remove the outgoing layer by id. No-op when
    // it has gone already.
    if (outgoingSnapshotId) this.removeDataSourceById(outgoingSnapshotId);
    this.voyageFlashRefreshId = null;
    // resetMapNew's sweep takes the observed area off the map with everything
    // else, so the flag that says it is drawn has to go too — otherwise the
    // next task opens with its Observations section offering to hide a shape
    // that is not there.
    this.clearVoyageObservationArea();
    // The panel's own expanded/collapsed state needs no reset here — the sensor
    // rows are re-created by *ngFor on a task switch, and with them the panel.
  }

  /** Resets VesselFinder on-map toolbar state and clears markers on task/project switch. */
  private _resetVesselFinderToolbar(): void {
    this.vf.reset();
    this.vfLayer.clear();
    // `vf.reset()` above fires `onResetPortCalls`, which the Port Calls drawer
    // registers — its paid results and its form belong to the outgoing task,
    // and the drawer holds both itself now that it has no service behind it.
    // A Watched Vessels refresh caught in flight by the switch never clears this
    // (its response is keyed to the outgoing task), leaving that row spinning.
    this.vfHistoryLoadingKey = null;
  }

  /** Open the date-range modal → loading spinner → load history → show playback toolbar. */
  openAisstreamPlayback(): void {
    const openWindow  = this.collection?.openWindow;
    const closeWindow = this.collection?.closeWindow;
    const maxMs = Math.min(new Date(closeWindow).getTime(), Date.now());
    const maxIso = new Date(maxMs).toISOString();

    const ref = this.matdialog.open(PlaybackDaterangeModalComponent, {
      panelClass: 'pb-modal-panel',
      autoFocus: false,
      data: {
        title: 'Historical Playback',
        minDate: openWindow,
        maxDate: maxIso,
        defaultFrom: openWindow,
        defaultTo: maxIso,
      },
    });

    ref.afterClosed().subscribe((result: PlaybackDaterangeResult | undefined) => {
      if (!result) return;
      this._loadAisstreamPlayback(result.from, result.to);
    });
  }

  private _loadAisstreamPlayback(fromIso: string, toIso: string): void {
    const loadingRef = this.matdialog.open(PlaybackLoadingComponent, {
      disableClose: true,
      panelClass: 'pb-modal-panel',
    });
    const taskId = this.collection?.taskId;
    this.aisstreamLayer
      .loadHistory(taskId, fromIso, toIso)
      .then((count) => {
        loadingRef.close();
        // The toolbar host renders from aisstreamLayer.state$, so entering
        // playback needs nothing more than starting the clock. An empty result
        // still shows the bar, with an empty timeline.
        if (count > 0) this.aisstreamLayer.play();
      })
      .catch(() => loadingRef.close());
  }

  previousIndex = -1;

sliderRecurrentData(sliderIndex: number) {
  const index = sliderIndex - 1;

  if (sliderIndex === 0 || index < 0) {
    this.clearAllMapLayers();
    this.previousIndex = -1;
    return;
  }

  const taskId = this.collection?.taskId;
  const selectedRange = this.sliderDateRangeArray[index];
  const rangeKey = `${selectedRange.start} to ${selectedRange.end}`;
  const selectedScenes = this.groupedScenes[rangeKey];

 const isGhg = selectedScenes?.length > 0 && selectedScenes[0].operatorKey === OPERATORS.GHG;

  if (!isGhg) {
    this.clearAllMapLayers();
  } else if (this.previousIndex > index) {
    const currentEndDate = selectedRange.end;
    const retainedScenes = this.scenesNew.filter((scene) => {
      const renderedPredictedDate =
        scene.renderedPredictedDate ??
        scene.scene?.predicted_date?.split('T')[0];

      return renderedPredictedDate <= currentEndDate;
    });
    const scenesToRemove = this.scenesNew.filter((scene) => {
      const renderedPredictedDate =
        scene.renderedPredictedDate ??
        scene.scene?.predicted_date?.split('T')[0];

      return renderedPredictedDate > currentEndDate;
    });

    scenesToRemove.forEach((scene) => {
      this.removeLayerByScene(scene);
    });

    this.ghgLayers = this.ghgLayers.filter((ghg) => {
      const renderedPredictedDate =
        ghg.renderedPredictedDate ??
        ghg.scene?.renderedPredictedDate ??
        ghg.scene?.scene?.predicted_date?.split('T')[0];

      if (renderedPredictedDate > currentEndDate) {
        this.removeGHGLayerByScene(ghg);
        return false;
      }

      return true;
    });

    this.scenesNew = this.scenesNew.filter((scene) => {
      const renderedPredictedDate =
        scene.renderedPredictedDate ??
        scene.scene?.predicted_date?.split('T')[0];

      return renderedPredictedDate <= currentEndDate;
    });

    this.ghgLayers.forEach((ghg) => {
      this.removeGHGLayerByScene(ghg);
    });
    this.ghgLayers = [];
    this.trendLinecordinates = [];

    retainedScenes
      .sort((leftScene: any, rightScene: any) => {
        const leftDate =
          leftScene.renderedPredictedDate ??
          leftScene.scene?.predicted_date?.split('T')[0] ?? '';
        const rightDate =
          rightScene.renderedPredictedDate ??
          rightScene.scene?.predicted_date?.split('T')[0] ?? '';

        return leftDate.localeCompare(rightDate);
      })
      .forEach((scene) => {
        this.showMetric(this.metric, scene);
      });
  }

  this.feedPanels = new Map();
  this.rebuildCombined();

  if (!selectedScenes?.length) return;

  for (const scn of selectedScenes) {
    const renderedPredictedDate = scn?.predicted_date?.split('T')[0];

    if (
      !scn?.id ||
      scn?.status === 'failed' ||
      (scn.siteId && scn.siteId !== this.defaultSubdailyCount)
    ) {
      continue;
    }

    if (!scn.footprint) continue;
      if (
      isGhg &&
      this.scenesNew.some(
        (scene) =>
          scene.id === scn.id &&
          (scene.renderedPredictedDate ??
            scene.scene?.predicted_date?.split('T')[0]) ===
            renderedPredictedDate
      )
    ) {
      continue;
    }

    const sensorId = this.sensorSelected?.id ?? this.sensorSelected;

    this.mapLoad = true;
    this.spinnerService.show();
    this.mapLoad = true;

    const sensorObj =
      this.imageType === 'tif'
        ? {
            sensorId,
            sceneId: scn.id,
            action: 'scene',
            fileType: this.imageType,
          }
        : {
            sensorId,
            sceneId: scn.id,
            action: 'scene',
            type: this.imageType,
          };

    this.apiService.getCollectionImage(taskId, sensorObj).subscribe({
      next: (res: any) => {
        this.DisplayPopupsBasedOnResponse(res);

        scn.thumbnailUrl = res.result?.COGUrl ?? res.result?.imageUrl;
        this.imageType === 'tif'
          ?
            this.displayFootprintImageNew(
                scn,
                res.result,
                sensorObj.sensorId,
                'image',
                taskId
              ) :
        this.displayFootprintImageTimeseriesNew(
          scn,
          res.result,
          sensorId
        );

        this.spinnerService.hide();
        this.mapLoad = false;
      },
      error: () => {
        this.spinnerService.hide();
        this.mapLoad = false;
      },
    });
  }

  if (this.collection.recurrencyArray?.length > 0) {
    this.loadTimeSeriesDataObject(this.collection, index);
  }

  this.previousIndex = index;
}

clearAllMapLayers() {
  this.resetPredictionDriftPanel();
  this.resetWeatherExForecastSelection();
  this.scenesNew.forEach((scene) => {
    this.removeLayerByScene(scene);
  });
  this.scenesNew = [];

  this.ghgLayers.forEach((ghg) => {
    this.removeGHGLayerByScene(ghg);
  });
  this.ghgLayers = [];
  this.trendLinecordinates = [];

  Object.values(this.feedLayers || {}).forEach((layer: any) => {
    if (this.map.hasLayer(layer)) {
      this.removeVesselLabelLayer(layer);
      this.map.removeLayer(layer);
    }
  });
  this.feedLayers = {};
}

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    const container = this.el.nativeElement.querySelector(
      '.leaflet-control-layers-expanded'
    );
    if (container && this.layerBtn) {
      this.renderer.removeClass(
        this.layerBtn.nativeElement,
        'highlight-border'
      );
      this.renderer.removeClass(container, 'leaflet-control-layers-expanded');
      this.renderer.setStyle(this.layerBtn.nativeElement, 'top', '0px');
    }
  }
  public getMap(): any {
    return this.map;
  }
  ngOnInit(): void {
    this.selectionChange.subscribe((selectedValue: any) => {
      if (selectedValue && selectedValue?.start) {
        const start = this.formatDate(new Date(selectedValue?.start));
        const end = this.formatDate(new Date(selectedValue?.end));
        const combinedDate = `${start} - ${end}`;
        this.selectionLabel = new Date(selectedValue?.start);
        this.selectionLabelEnd = new Date(selectedValue?.end);
        this.selectionLabels = combinedDate;
      }
    });
    this.subSelectionSelectionChange.subscribe((selectedValue: any) => {
      this.selectedSubDailyItemValue = selectedValue;
    });
    this.taskMode = this.route.snapshot.queryParamMap.get('mode') ?? null;
    this.isFeedTasking = this.taskMode === 'feed';
    localStorage.removeItem('taskData');
    this.compassOverlay = document.getElementById('compass');
    this.baseLayers = [];
    this.baseAlpha = 1;
    this.dataForm = this.fb.group({
      datafile: ['', [Validators.required]],
    });
    this.sliderOverlay = document.getElementById('slider');
    this.acc = document.getElementsByClassName('accordion');
  }

  ngAfterViewChecked() {
    this.changDetectionRef.detectChanges();
  }

  ngOnDestroy(): void {
    // The toolbar drawer is a body-level CDK overlay, so it outlives the map
    // unless it is explicitly disposed.
    this.toolbarDrawer.close();
    this.mapContainerResizeObserver?.disconnect();
    this.map.off('popupopen', this.handleMeasurementPopupOpen);
    this.map.off((L as any).Draw.Event.CREATED, this.onMeasurementCreated);
    this.map.off((L as any).Draw.Event.DRAWSTART, this.onMeasurementDrawStart);
    this.map.off('draw:drawvertex', this.onMeasurementDrawVertex);
    this.map.off('draw:drawstop', this.onMeasurementDrawStop);
    this.clearMeasurementInteraction();
    this.removeObservationMarker();
    this.cancelTiffWfsLoads();
    this.viewportGeojson.destroy();
    this.viewportGeojsonRender.clear();
    this.legendController?.clear();
    this.map.remove();
    this.selectionChange.unsubscribe();
    this.stopHover();
    this.cancelAllPngGeoJsonLoads();
    this.pngGeoJsonCancelByScope.clear();
    this.pngGeoJsonRequestByUrl.forEach((request) => {
      request.cancel$.next();
      request.cancel$.complete();
    });
    this.pngGeoJsonRequestByUrl.clear();
    this.activePngGeoJsonLoadIds.clear();
    this.viewportGeojsonCancel$.next();
    this.viewportGeojsonCancel$.complete();
    this.questionWmsHandoff.destroy();
    this.destroy$.next();
    this.destroy$.complete();
    this.getCollectionSub?.unsubscribe();
    // Would otherwise fire detectChanges() on a destroyed view.
    if (this._voyageFlashTimer) clearTimeout(this._voyageFlashTimer);
  }
  getProjects(userId) {
    this.apiService.getProjectName().subscribe((res: any) => {
      this.projectData = res.result;
      const firstProject = res.result?.find((p: any) => p?.projectid);
      this.projectName = firstProject?.project ?? this.projectData[0]?.project;
      this.getCollections(firstProject?.projectid, 0);
      this.projectSelected = firstProject?.projectid;
      this.collectionIndex = 0;
    });
  }

  selectedValue: any;
  selectedSite: any;
  getCollectionData(userId: any) {
    this.tableDataLength = 0;
    this.taskService.getCollections(userId).subscribe(
      (result: any) => {
        this.tableDataLength =
          result.results.length > 0 ? result.results.length : 0;
        this.dataSource = result.results;
        if (result.results.length > 0) {
          this.collectionsData = result.results;
          this.collections = [];
          result.results.forEach((item, index) => {
            const project = item.project;
            const taskname = item.taskname;
            const taskUuid = item.sensors[0]?.sensor_uuid;
            const taskId = item.id;
            const questionId = item.questionId;
            let sensorName = item?.sensors?.[0]?.sensor;
            const target = JSON.parse(item.target);
            const sensors: any = [];
            item.sensors.forEach((sensor, i) => {
              const scenes: any = [];
              if (sensor?.scenes?.length > 0) {
                sensor?.scenes?.forEach((scene, index) => {
                  scene.checked = false;
                  let thumbnailUrl;
                  if (scene?.id != null) {
                    sensor.scenes[index] = scene;
                    thumbnailUrl =
                      environment.eeTaskServer + '/' + scene.thumbnailUrl || '';
                    const exists = scenes.find(
                      (sn: any) => sn.id === scene?.id
                    );
                    if (!exists) {
                      scenes.push({
                        id: scene.id,
                        name: `Scene ${index + 1}`,
                        sceneIdx: index + 1,
                        footprint: scene.footprint,
                        metadata: scene.metadata,
                        metadata_tooltip: scene?.metadata_tooltip,
                        thumbnailUrl: thumbnailUrl,
                        previewUrl: scene.previewUrl,
                        downloadUrl: scene.downloadUrl,
                        checked: false,
                        color: 'primary',
                        scene_id: scene?.scene_id,
                        operatorKey: sensor?.operatorKey,
                        isName: scene?.isName,
                        png_footprint: scene?.png_footprint,
                        tif_footprint: scene?.tif_footprint,
                        legendScale: scene?.legendScale,
                        legend_min: scene?.legend_min,
                        legend_max: scene?.legend_max,
                        legend_long: scene?.legend_long,
                        legend_lat: scene?.legend_lat,
                        min: scene?.min,
                        max: scene?.max,
                        rawIQDownloaded: scene?.raw_iq_downloaded,
                        rawIQIncluded: scene?.raw_iq_included,
                      });
                    }
                  }
                });
                if (scenes.length > 0) {
                  sensors.push({
                    name: sensor.sensor,
                    scenes,
                    checked: false,
                    id: sensor?.sensor_uuid,
                    operatorKey: sensor?.operatorKey,
                    sensorType: sensor?.sensorType ?? sensor?.sensortype ?? sensor?.sensor,
                    downloadUrl: sensor?.downloadUrl,
                    questionName: sensor?.questionName,
                    questionId: sensor?.questionId,
                    currentSensorData: typeof sensor?.currentSensorData === 'object' && sensor?.currentSensorData !== null
                      ? sensor.currentSensorData
                      : {},
                    historicalData: Array.isArray(sensor?.historicalData)
                      ? sensor.historicalData
                      : [],
                  });
                }
              }
            });
            let taskCollection = item?.taskcollection;
            let captures = item?.captures;
            let sensorsName = item?.sensorsName;
            let info = item?.info;
            if (sensors.length > 0) {
              this.collections.push({
                project,
                taskname,
                target,
                sensors,
                taskId,
                taskStrategy: item?.taskStrategy,
                sensorName,
                taskCollection,
                captures,
                sensorsName,
                info,
                questionId
              });
              this.collection = this.collections[0];
              this.collectionIndex = 0;
              this.taskName = this.collections[0].taskname;
              this.taskid = this.collections[0].taskId;
              this.selectionChange.next(this.collection.recurrencyArray[0]);
              this._attachVesselFinder();

             
            }
          });
        } else {
          this.collectionsData = [];
        }
      },
      (err) => {
        return false;
      }
    );
  }

  private isChangeDetectionTask(taskStrategy: any): boolean {
    return this.changeDetection.isChangeDetectionTask(taskStrategy);
  }

  private cancelViewportGeojsonLoads(): void {
    this.cancelTiffWfsLoads();
    this.viewportGeojsonCancel$.next();
    this.viewportGeojson.resetLoading();
  }

  /**
   * Fetches only the features intersecting the current viewport, paged so GeoServer
   * never has to encode the whole feed layer in one response.
   */
  private async loadViewportGeojson(
    layerName: string,
    baseCql: string | null,
    wmsLayer?: L.Layer,
    cancel$?: Observable<unknown>,
    renderMode: 'immediate' | 'afterWmsLoad' = 'afterWmsLoad',
    originalFeedCount: number | null = null,
    sources?: ViewportGeojsonSession['sources']
  ): Promise<any> {
    this.viewportGeojson.beginLoad();
    try {
      return await firstValueFrom(this.viewportGeojson.loadInitialFeatures({
        storageKey: layerName,
        layerName,
        baseCql: baseCql || null,
        sources,
        renderMode: wmsLayer instanceof L.ImageOverlay ? 'immediate' : renderMode,
        wmsLayer,
      }).pipe(
        map((features) => ({
          ...features,
          _viewportGeojson: { layerName, baseCql: baseCql || null, sources, renderMode },
          _viewportGeojsonMatchedCount: originalFeedCount,
        })),
        takeUntil(merge(this.viewportGeojsonCancel$, this.destroy$, cancel$ ?? EMPTY))
      ));
    } finally {
      this.viewportGeojson.endLoad();
    }
  }

  private getActiveFeedWmsLayer(compareOptions?: {
    isCompare?: boolean;
    pane?: 'left' | 'right';
  }): L.Layer | undefined {
    if (compareOptions?.isCompare && compareOptions?.pane === 'right') {
      return this.rightImageNew;
    }

    if (compareOptions?.isCompare && compareOptions?.pane === 'left') {
      return this.leftImageNew;
    }

    if (this.mapPane === 'right' && this.rightImageNew) {
      return this.rightImageNew;
    }

    return this.leftImageNew ?? this.rightImageNew;
  }

  private registerViewportGeojsonSession(
    storageKey: string,
    geoKey: string,
    layerName: string,
    baseCql: string | null,
    filterKey?: string,
    wmsLayer?: L.Layer,
    sources?: ViewportGeojsonSession['sources'],
    renderMode: 'immediate' | 'afterWmsLoad' = 'afterWmsLoad'
  ): void {
    if (!layerName) return;
    const previous = this.viewportGeojsonRender.get(storageKey);
    previous?.detach?.();
    this.legendController?.remove(storageKey);
    const layer = (this.feedLayers?.[storageKey] ?? this.currentFilteredLayers?.[storageKey]) as L.GeoJSON | undefined;
    if (previous?.layer && previous.layer !== layer && this.map.hasLayer(previous.layer)) this.map.removeLayer(previous.layer);
    const cached = this.geoByFeed.get(geoKey);
    const removed = () => this.viewportGeojson.endSession(storageKey);
    wmsLayer?.on('remove', removed);
    this.viewportGeojsonRender.set(storageKey, {
      geoKey, filterKey, layer, feedType: cached?.type,
      feedResults: JSON.parse(JSON.stringify(cached?.feed_results ?? (cached?.fc as any)?.feed_results ?? null)),
      legendArgs: { layerName, baseCql: baseCql || null, wmsLayer },
      detach: () => wmsLayer?.off('remove', removed),
    });
    this.viewportGeojson.startSession({
      storageKey,
      layerName,
      baseCql: baseCql || null,
      sources,
      renderMode: wmsLayer instanceof L.ImageOverlay ? 'immediate' : renderMode,
      wmsLayer,
    });
    this.registerLegendSummary(storageKey, geoKey, layerName, baseCql, filterKey, wmsLayer);
    if (cached?.fc) this.applyViewportGeojsonFeatures(storageKey, cached.fc);
  }

  private registerViewportGeojsonSessionFromSource(
    storageKey: string,
    geoKey: string,
    source: any,
    filterKey?: string,
    wmsLayer?: L.Layer
  ): void {
    const descriptor = source?._viewportGeojson;
    if (!descriptor?.layerName) return;
    // The history comparison's initial WFS load can run before imagery is ready.
    // Subsequent viewport refreshes must wait for the WMS tiles in their own pane.
    const gateCompareRefresh =
      storageKey.includes('::compare::') &&
      descriptor.renderMode === 'immediate' &&
      !!wmsLayer &&
      !!getWmsReadiness(wmsLayer) &&
      !!this.map?.hasLayer(wmsLayer);
    this.registerViewportGeojsonSession(
      storageKey,
      geoKey,
      descriptor.layerName,
      descriptor.baseCql ?? null,
      filterKey,
      descriptor.renderMode === 'immediate' && !gateCompareRefresh ? undefined : wmsLayer,
      descriptor.sources,
      gateCompareRefresh ? 'afterWmsLoad' : descriptor.renderMode ?? 'afterWmsLoad'
    );
  }

  clearViewportGeojsonFeatures(storageKey: string): void {
    const render = this.viewportGeojsonRender.get(storageKey);
    if (!render) return;
    // A filter change while WMS/WFS is pending must not restore the old viewport.
    render.viewport = undefined;
    const layer = render.layer;
    if (isPredictionFeedType(render.feedType) && this.predictionTimeseriesContext?.layer === layer) {
      this.predictionTimeseriesViewportPending = true;
    }
    if (!layer?.clearLayers) return;
    layer.clearLayers();
  }

  /** Swaps the rendered features in place so styling, tooltips and panes survive untouched. */
  applyViewportGeojsonFeatures(
    storageKey: string,
    featureCollection: FeatureCollection
  ): void {
    const render = this.viewportGeojsonRender.get(storageKey);
    if (!render) return;
    const layer = render.layer;
    if (!layer?.clearLayers || !layer?.addData) return;

    const cached = render?.geoKey ? this.geoByFeed.get(render.geoKey) : null;
    const baseFiltered = render?.filterKey
      ? this.getFilteredData(featureCollection, render.filterKey)
      : featureCollection;
    render.viewport = baseFiltered;
    const activeFilters = this.getActiveFiltersForFeed(render?.geoKey ?? storageKey);
    const filtered = this.applyActiveFeedFiltersToFeatureCollection(
      baseFiltered,
      render.feedType ?? cached?.type,
      activeFilters
    );
    const rendered = this.orderMiningChangeFeatures(filtered, cached?.type);

    layer.clearLayers();
    if (rendered?.features?.length) {
      layer.addData(rendered as any);
    }

    if (isPredictionFeedType(render.feedType) && cached) {
      const config = feedsConfig[render.geoKey] ?? Object.values(feedsConfig).find(
        (entry: any) => entry.type === render.feedType
      );
      const pane = storageKey.endsWith('::compare::left') ? 'left'
        : storageKey.endsWith('::compare::right') ? 'right' : 'normal';
      const panel = pane === 'left' ? this.leftFeedPanels.get(render.geoKey)
        : pane === 'right' ? this.rightFeedPanels.get(render.geoKey)
        : this.feedPanels.get(render.geoKey);
      if (config && panel) {
        const results = this.predictionFeedController.buildFeedResultsForSections(
          render.feedResults
        );
        const selection = activeFilters.predictionFilter;
        const selectedHour = selection?.forecastHour == null ? null : Number(selection.forecastHour);
        const displayedResults = selection ? {
          ...results,
          forecast_classes: isUnclassifiedDetection(selection.detectionClass)
            ? []
            : [selection.detectionClass],
          selected_detection: this.predictionFeedController.detectionLabel(selection.detectionClass),
          selected_forecast_hour: selection.forecastHour ? `${selection.forecastHour}h` : 'All hours',
          ...(selectedHour != null && Number.isFinite(selectedHour) ? {
            forecast_hours: [selectedHour],
          } : {}),
        } : results;
        const sections = this.helperService.buildFeedSections(config, displayedResults, cached.color).sections;
        if (pane === 'left') this.addLeftFeedPanel(render.geoKey, panel.title, cached.color, sections);
        else if (pane === 'right') this.addRightFeedPanel(render.geoKey, panel.title, cached.color, sections);
        else this.addFeedPanel(render.geoKey, panel.title, cached.color, sections,
          buildPredictionLegendGroupsFromResults(render.feedResults, config, String(cached.color ?? '#FF00FF'),
            render.geoKey, selection));
      }
      if (pane === 'normal') {
        // Another Oil Spill feed finishing first must not release this slider's viewport wait.
        if (!this.predictionTimeseriesActive ||
            !this.predictionTimeseriesContext ||
            this.predictionTimeseriesContext.feedKey === render.geoKey) {
          const restoreSelectedHours = this.predictionTimeseriesActive &&
            this.predictionTimeseriesContext?.feedKey === render.geoKey &&
            this.predictionTimeseriesContext.layer === layer;
          const selectedHours = this.currentSliderValue;
          this.registerPredictionTimeseries(
            render.geoKey,
            cached,
            rendered as FeatureCollection<Geometry, FeatureProps>,
            layer
          );
          if (this.predictionTimeseriesContext?.layer === layer) {
            this.predictionTimeseriesViewportPending = false;
          }
          if (restoreSelectedHours) this.showPredictionForecastForSelectedTime(selectedHours);
        }
      }
    }

    if (cached) {
      cached.feed_results ??= (cached.fc as any)?.feed_results;
      cached.fc = this.orderMiningChangeFeatures(
        { ...(cached.fc as any), ...baseFiltered, feed_results: cached.feed_results } as FeatureCollection & { feed_results: any },
        cached?.type
      ) as FeatureCollection<Geometry, FeatureProps>;
    }
  }

  releaseViewportGeojsonSession(storageKey: string): void {
    const render = this.viewportGeojsonRender.get(storageKey);
    if (!render) return;
    render.detach?.();
    this.legendController?.remove(storageKey);
    this.viewportGeojsonRender.delete(storageKey);
    if (render.layer && this.map?.hasLayer(render.layer)) this.map.removeLayer(render.layer);
    if (this.feedLayers?.[storageKey] === render.layer) delete this.feedLayers[storageKey];
    if (this.currentFilteredLayers?.[storageKey] === render.layer) delete this.currentFilteredLayers[storageKey];
  }

  /**
   * For a new feed filter, read its selection in getActiveFiltersForFeed and apply it in
   * applyActiveFeedFiltersToFeatureCollection. Keep the registered viewport layer attached;
   * if filtering needs fresh WFS data, refresh its session through the WMS gate here.
   */
  private refreshViewportFeedFilters(): Set<string> {
    const managed = new Set<string>();
    this.viewportGeojsonRender.forEach((render, key) => {
      if (this.indicesViewportLayers.has(key)) return;
      managed.add(render.geoKey);
      if (isPredictionFeedType(render.feedType)) {
        const wmsLayer = render.legendArgs?.wmsLayer;
        if (render.viewport && (wmsLayer instanceof L.ImageOverlay || isWmsReady(wmsLayer))) {
          this.applyViewportGeojsonFeatures(key, render.viewport);
        } else {
          this.clearViewportGeojsonFeatures(key);
          this.viewportGeojson.refreshSession(key);
        }
        return;
      }
      if (render.viewport) this.applyViewportGeojsonFeatures(key, render.viewport);
      // Count summaries own their legends; other feeds retain their original area/percentage metadata.
      if (this.legendController?.has(key)) return;
      const pane = key.endsWith('::compare::left') ? 'leftFeedPanels'
        : key.endsWith('::compare::right') ? 'rightFeedPanels' : 'feedPanels';
      const panel = this[pane].get(render.geoKey);
      if (!panel) return;
      const cached = this.geoByFeed.get(render.geoKey);
      const config = feedsConfig[render.geoKey] ?? Object.values(feedsConfig).find((entry: any) => entry.type === render.feedType);
      if (!config) return;
      const filters = this.getActiveFiltersForFeed(render.geoKey);
      const sections = this.helperService.buildFeedSections(config, render.feedResults, cached?.color,
        filters.classFilter ? { type: 'classBasedFilter', value: String(filters.classFilter.value).trim() } : undefined
      ).sections;
      this[pane] = new Map(this[pane]).set(render.geoKey, { ...panel, sections });
    });
    if (managed.size) this.rebuildCombined();
    return managed;
  }

  private applyActiveFeedFiltersToFeatureCollection(
    featureCollection: FeatureCollection,
    feedType?: string,
    filters?: {
      classFilter?: { type: string; value: any };
      vesselLengthFilter?: { value: number; isGreater: boolean };
      predictionFilter?: { detectionClass?: string | number; forecastHour?: string | number | null };
    }
  ): FeatureCollection {
    const features = Array.isArray(featureCollection?.features)
      ? featureCollection.features
      : [];

    if (!filters?.classFilter && !filters?.vesselLengthFilter && !filters?.predictionFilter) {
      return featureCollection;
    }

    const filtered = this.feedFilterService.filterFeatures(
      features,
      feedType,
      filters?.classFilter,
      filters?.vesselLengthFilter
    );

    return {
      ...featureCollection,
      features: filters?.predictionFilter && isPredictionFeedType(feedType)
        ? this.predictionFeedController.filterFeatures(filtered, filters.predictionFilter) as any
        : filtered as any,
    };
  }

  private getActiveFiltersForFeed(feedKey: string): {
    classFilter?: { type: string; value: any };
    vesselLengthFilter?: { value: number; isGreater: boolean };
    predictionFilter?: { detectionClass?: string | number; forecastHour?: string | number | null };
  } {
    const key = String(feedKey);
    let classFilter: { type: string; value: any } | undefined;
    let vesselLengthFilter: { value: number; isGreater: boolean } | undefined;
    let predictionFilter: { detectionClass?: string | number; forecastHour?: string | number | null } | undefined;

    for (const [type, filterState] of this.getMergedFiltersByType().entries()) {
      if (!filterState || filterState.value == null) continue;
      const appliesToFeed = (filterState.feedKeys || [])
        .map((feed) => String(feed))
        .includes(key);
      if (!appliesToFeed) continue;

      if (isPredictionFilterType(type)) {
        predictionFilter = filterState.value;
        continue;
      }

      if (type === 'vesselLength' || type === 'aircraftLength') {
        const value = Number(filterState.value);
        if (!Number.isNaN(value)) {
          vesselLengthFilter = {
            value,
            isGreater: !!filterState.isGreater,
          };
        }
        continue;
      }

      classFilter = { type, value: filterState.value };
    }

    return { classFilter, vesselLengthFilter, predictionFilter };
  }

  notifyViewportGeojsonLoadError(error: any): void {
    const context = error?.context ?? {};
    console.error('[ViewportWFS] GeoJSON load failed', {
      layerName: context.layerName,
      bbox: context.bbox,
      startIndex: context.startIndex,
      count: context.count,
      zoom: context.zoom,
      status: context.status,
      geoServerMessage: context.geoServerMessage,
    });

    this.mapLoad = false;
    this.viewportGeojson.resetLoading();
    if (this.viewportGeojsonLoadErrorShown) return;
    this.viewportGeojsonLoadErrorShown = true;
    this.popupService.openPopup(
      CollectionPopupComponent,
      'Unable to load the feed data for the current map view. Please try again.',
      '',
      '40%'
    );
  }

  private normalizeSensorTaskData(sensor: any): {
    currentSensorData: any;
    historicalData: any[];
  } {
    return {
      currentSensorData:
        typeof sensor?.currentSensorData === 'object' &&
        sensor?.currentSensorData !== null
          ? sensor.currentSensorData
          : {},
      historicalData: Array.isArray(sensor?.historicalData)
        ? sensor.historicalData
        : [],
    };
  }

  getDynamicTabNames(sensor: any): string[] {
    return this.changeDetection.getDynamicTabNames(sensor);
  }

  isChangeDetectionTabSelected(tabName: string): boolean {
    return this.selectedChangeDetectionTab.includes(tabName);
  }

  getCurrentWeekCaptureDate(sensor: any): any {
    const currentSensorData = sensor?.currentSensorData;
    if (!currentSensorData || typeof currentSensorData !== 'object') {
      return null;
    }

    for (const tabName of this.getDynamicTabNames(sensor)) {
      const firstItem = currentSensorData?.[tabName]?.[0];
      const captureDate =
        firstItem?.capture_date ??
        firstItem?.captureDate ??
        firstItem?.scene?.capture_date ??
        firstItem?.scene?.captureDate;

      if (captureDate) {
        return captureDate;
      }
    }

    return null;
  }

  hasCurrentWeekData(sensor: any): boolean {
    const currentSensorData = sensor?.currentSensorData;
    if (!currentSensorData || typeof currentSensorData !== 'object') {
      return false;
    }

    return this.getDynamicTabNames(sensor).some((tabName) => {
      const currentWeekItems = currentSensorData?.[tabName];
      return Array.isArray(currentWeekItems)
        ? currentWeekItems.length > 0
        : !!currentWeekItems;
    });
  }

  canDownloadSensor(collection: any, sensor: any): boolean {
    if (this.isChangeDetectionTask(collection?.taskStrategy)) {
      return this.hasCurrentWeekData(sensor);
    }

    const isDownloadableStatus =
      sensor?.status === 'completed' ||
      (sensor?.status === 'restored' && sensor?.restoreOption === 'both');

    if (!isDownloadableStatus) {
      return false;
    }

    return (sensor?.scenesList?.length ?? 0) > 0;
  }

  selectChangeDetectionTab(
    collection: any,
    collectionIndex: number,
    sensorIndex: number,
    sensor: any,
    tabName: string
  ): void {
    if (!sensor?.checked) {
      return;
    }

    if (
      this.shouldPromptBandSelectorForChangeDetection(collection, sensor, tabName)
    ) {
      this.openBandSelectorForChangeDetectionTab(
        collection,
        collectionIndex,
        sensorIndex,
        sensor,
        tabName
      );
      return;
    }

    if (!this.isChangeDetectionTabSelected(tabName)) {
      this.prepareChangeDetectionCurrentWeekSensor(sensor);
    }
    this.changeDetection.selectChangeDetectionTab(
      collection,
      collectionIndex,
      sensorIndex,
      sensor,
      tabName
    );
  }

  private shouldPromptBandSelectorForChangeDetection(
    collection: any,
    sensor: any,
    tabName: string
  ): boolean {
    if (!this.isChangeDetectionTask(collection?.taskStrategy)) {
      return false;
    }
    if (this.isChangeDetectionTabSelected(tabName)) {
      return false;
    }
    return this.isTiffModeActive();
  }

  private isTiffModeActive(): boolean {
    return this.loadTiff || this.imageType === 'tif' || this.imageType === 'tiff';
  }

  private openBandSelectorForChangeDetectionTab(
    collection: any,
    collectionIndex: number,
    sensorIndex: number,
    sensor: any,
    tabName: string
  ): void {
    if (!this.isChangeDetectionTabSelected(tabName)) {
      this.clearSelectedBandState();
    }

    const dialogRef = this.dialog.open(BandSelectorComponent, {
      width: '500px',
      maxHeight: '80vh',
      disableClose: true,
      data: {
        selectedBands: this.selectedBands,
        operatorKey: this.getBandSelectorOperatorKey(sensor),
        sensorType: this.getBandSelectorSensorType(sensor, tabName),
        minSelection: this.isSarChangeDetectionTab(tabName) ? 1 : 3,
        maxSelection: this.isSarChangeDetectionTab(tabName) ? 2 : 3,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result === 'cancel') {
        return;
      }

      if (result === 'clear_bands') {
        this.selectedBands = [];
        return;
      }

      this.selectedBands = result ?? [];
      this.prepareChangeDetectionCurrentWeekSensor(sensor);
      this.changeDetection.forceSelectChangeDetectionTab(
        collection,
        collectionIndex,
        sensorIndex,
        sensor,
        tabName
      );
    });
  }

  private isSarChangeDetectionTab(tabName: string): boolean {
    return `${tabName ?? ''}`.trim().toLowerCase() === 'sar';
  }

  private clearSelectedBandState(): void {
    this.selectedBands = [];
    this.isBandApplied = false;
  }

  private prepareChangeDetectionCurrentWeekSensor(sensor: any): void {
    // Change history compare owns the compare state; the Latest Change tab must not touch it.
    if (this.changeDetectionHistorySelections.length > 0) {
      return;
    }

    this.sensorsNew = sensor ? [sensor] : [];
    this.selectedCheckboxesNew = [];
    this.isCompare = false;
    this.isCompareRecurrency = false;
    this.isCompareClicked = false;
  }

  private clearCurrentWeekTabForSensor(sensor: any): void {
    if (
      !this.isChangeDetectionTask(this.collection?.taskStrategy) ||
      this.selectedChangeDetectionTab.length === 0
    ) {
      return;
    }

    const hasCurrentWeekLayer = this.scenesNew.some(
      (sceneNew: any) =>
        sceneNew?.sensorId === sensor?.id &&
        sceneNew?.scene?.isChangeDetectionCurrentWeekTab
    );

    if (!hasCurrentWeekLayer) {
      return;
    }

    this.selectedChangeDetectionTab = [];
    this.clearSelectedBandState();
    this.clearChangeDetectionTabLayers();
  }

  private getBandSelectorOperatorKey(sensor: any): string {
    return sensor?.operatorKey ?? sensor?.operator?.key ?? sensor?.key ?? sensor?.operator ?? '';
  }

  private getBandSelectorSensorType(sensor: any, fallbackSensorType?: string): string {
    return (
      fallbackSensorType ??
      sensor?.sensorType ??
      sensor?.sensortype ??
      ''
    );
  }

  private loadChangeDetectionRowData(
    collection: any,
    sensor: any,
    sceneId: string,
    sceneData?: any,
    options?: {
      pane?: 'left' | 'right';
      compareKey?: string;
    }
  ): void {
    this.changeDetection.loadChangeDetectionRowData(
      collection,
      sensor,
      sceneId,
      sceneData,
      options
    );
  }

  private resetChangeDetectionCompareDisplayState(): void {
    this.leftData = [];
    this.rightData = [];
    this.sensorsNew = [];
    this.hideLeftCompareLegend = false;
    this.hideRightCompareLegend = false;
  }

  private clearChangeDetectionHistoryForNavigation(): void {
    this.collection?.sensors?.forEach((sensor: any) =>
      this.clearChangeHistoryForSensor(sensor)
    );
    this.changeDetectionHistorySelections = [];
    this.selectedChangeDetectionTab = [];
    this.resetChangeDetectionCompareDisplayState();
  }

  private clearChangeHistoryForSensor(sensor: any): void {
    const historyLists = [
      sensor?.historicalData,
      sensor?.changeHistory,
    ].filter(Array.isArray);

    historyLists.forEach((historyList: any[]) => {
      historyList.forEach((history: any) => {
        history.checked = false;
        delete history._changeDetectionComparePane;
      });
    });
  }

  private clearChangeDetectionForSensorUncheck(sensor: any): void {
    if (!this.isChangeDetectionTask(this.collection?.taskStrategy)) {
      return;
    }

    this.clearChangeDetectionTabLayers();
    this.selectedChangeDetectionTab = [];
    this.clearSelectedBandState();
    this.sceneOverlayOpacity = 100;

    [...(sensor?.historicalData ?? []), ...(sensor?.changeHistory ?? [])].forEach(
      (history: any) => {
        const historyFeed = this.getChangeDetectionHistoryFeed(history, sensor);
        const historyFeedKey = this.getChangeDetectionHistoryFeedKey(history, historyFeed);
        const scopedHistoryFeed = {
          ...historyFeed,
          _changeDetectionHistoryFeedKey: historyFeedKey,
        };

        this.removeDataLayer(scopedHistoryFeed);
        if (historyFeedKey) {
          this.removeFeedPanel(historyFeedKey);
          this.activeFeedKeys.delete(historyFeedKey);
          this.leftFeedPanels.delete(historyFeedKey);
          this.rightFeedPanels.delete(historyFeedKey);
        }
      }
    );
    this.clearChangeHistoryForSensor(sensor);
    this.changeDetectionHistorySelections = [];
    this.clearChangeDetectionHistoryCompareLayers();
    this.resetChangeDetectionCompareDisplayState();
    this.removeCompareControlSafely();
    this.clearSplitMapArtifacts();
    this.isCompare = false;
    this.isCompareRecurrency = false;
    this.isCompareClicked = false;
    this.needsCompareResetToCenter = false;
  }

  private getChangeDetectionHistorySceneId(history: any): string | null {
    return (
      history?.insightDatas?.[0]?.sceneId ??
      history?.sceneId ??
      history?.id ??
      history?.scene?.id ??
      null
    );
  }

  private getChangeDetectionRequestSceneId(
    sensor: any,
    history: any
  ): string | null {
    return (
      history?.insightDatas?.[0]?.sceneId ??
      sensor?.scenes?.[0]?.id ??
      sensor?.scenes?.[0]?.scene_id ??
      this.getChangeDetectionHistorySceneId(history)
    );
  }

  private getChangeDetectionHistoryFeed(history: any, sensor: any): any {
    const matchedFeed = sensor?.InfoServices?.find(
      (info: any) => info?._id === history?._id
    );

    return {
      ...(matchedFeed ?? {}),
      ...history,
      _id: history?._id,
      feedName:
        history?.feedName ??
        history?.name ??
        matchedFeed?.feedName ??
        matchedFeed?.name,
      name:
        history?.name ??
        history?.feedName ??
        matchedFeed?.name ??
        matchedFeed?.feedName,
      sensorId: history?.sensorId ?? matchedFeed?.sensorId ?? sensor?.id,
      insightDatas: history?.insightDatas ?? matchedFeed?.insightDatas ?? [],
      modelType: history?.modelType ?? matchedFeed?.modelType,
    };
  }

  downloadChangeDetectionHistory(
    collectionIndex: any,
    sensorIndex: any,
    history: any
  ): void {
    const sensor = this.collections?.[collectionIndex]?.sensors?.[sensorIndex];
    const sceneId = this.getChangeDetectionHistorySceneId(history);

    if (!sceneId) {
      this.popupService.openPopup(
        CollectionPopupComponent,
        'Unable to download this change detection history because the scene id is missing.',
        '',
        '40%'
      );
      return;
    }

    const historyFeed = {
      ...this.getChangeDetectionHistoryFeed(history, sensor),
      _changeDetectionHistoryDownload: true,
      _downloadSceneId: sceneId,
    };

    this.download(collectionIndex, sensorIndex, undefined, historyFeed);
  }

  private cacheChangeDetectionHistoryInsight(
    history: any,
    insightFootprint: any
  ): void {
    if (!history || !insightFootprint) {
      return;
    }

    history._changeDetectionHistoryCompareCache = insightFootprint;
  }

  private getChangeDetectionHistoryFeedResults(
    history: any,
    insightFootprint?: any,
    fallback?: any
  ): any {
    return (
      history?.feed_results ??
      history?.insightDatas?.[0]?.insightFootprint?.feed_results ??
      insightFootprint?.feed_results ??
      fallback
    );
  }
  
  private getChangeDetectionHistoryKey(history: any): string {
    const sceneId = this.getChangeDetectionHistorySceneId(history) ?? 'unknown-scene';
    const historyDate =
      history?.date ?? history?.name ?? history?.predictedDate ?? history?.predicted_date ?? '';

    return `${sceneId}::${historyDate}`;
  }

  private getChangeDetectionHistoryFeedKey(history: any, feed?: any): string {
    const feedId = feed?._id ?? feed?.isInfo?._id ?? history?._id;
    const historyKey = this.getChangeDetectionHistoryKey(history);

    return feedId ? `${feedId}::history::${historyKey}` : historyKey;
  }

  private getChangeDetectionHistoryDisplayDate(history: any): string | null {
    return history?.date ?? history?.predictedDate ?? history?.predicted_date ?? null;
  }

  private isActiveChangeDetectionHistorySelection(
    historyOrKey: any,
    pane?: 'left' | 'right'
  ): boolean {
    const key =
      typeof historyOrKey === 'string'
        ? historyOrKey
        : this.getChangeDetectionHistoryKey(historyOrKey);

    return this.changeDetectionHistorySelections.some(
      (selection: any) =>
        selection.key === key && (!pane || selection.pane === pane)
    );
  }

  private getChangeDetectionHistoryFeedSceneKeys(feed: any, sceneId: any): string[] {
    const feedId = feed?._id;

    if (!feedId) {
      return [];
    }

    const sceneIds = [feed?.insightDatas?.[0]?.sceneId, sceneId].filter(Boolean);
    return Array.from(new Set(sceneIds)).map(
      (targetSceneId: any) => `${feedId}_${targetSceneId}`
    );
  }

  private findChangeDetectionHistoryShape(
    shapeList: any[],
    feed: any,
    sceneId: any
  ): any {
    const combinedSceneKeys = this.getChangeDetectionHistoryFeedSceneKeys(
      feed,
      sceneId
    );

    for (const combinedSceneKey of combinedSceneKeys) {
      const matchedCombinedShape = shapeList.find(
        (shape: any) => shape?.id === combinedSceneKey
      );

      if (matchedCombinedShape) {
        return matchedCombinedShape;
      }
    }

    return (
      shapeList.find((shape: any) => shape?.sceneId === sceneId) ??
      shapeList.find((shape: any) => shape?.id === feed?._id)
    );
  }

  private findChangeDetectionHistoryInsightData(
    insightDatas: any[],
    feed: any,
    sceneId: any
  ): any {
    const combinedSceneKeys = this.getChangeDetectionHistoryFeedSceneKeys(
      feed,
      sceneId
    );

    for (const combinedSceneKey of combinedSceneKeys) {
      const matchedCombinedInsight = insightDatas.find(
        (data: any) => data?.sceneId === combinedSceneKey
      );

      if (matchedCombinedInsight) {
        return matchedCombinedInsight;
      }
    }

    return insightDatas.find((data: any) => data?.sceneId === sceneId);
  }

  private getChangeDetectionHistoryScopedFeed(
    feed: any,
    history: any,
    insightFootprint?: any,
    insightData?: any
  ): any {
    const sceneId = this.getChangeDetectionHistorySceneId(history);
    const historyFeedResults = this.getChangeDetectionHistoryFeedResults(
      history,
      insightFootprint,
      insightData?.insightFootprint?.feed_results
    );
    const scopedInsightData =
      insightData ??
      (insightFootprint
        ? {
            sceneId,
            insightFootprint: {
              ...insightFootprint,
              feed_results: historyFeedResults ?? insightFootprint?.feed_results,
            },
          }
        : null);

    return {
      ...feed,
      _changeDetectionHistoryFeedKey: this.getChangeDetectionHistoryFeedKey(history, feed),
      _changeDetectionHistoryFeedResults: historyFeedResults,
      insightDatas: scopedInsightData ? [scopedInsightData] : [],
    };
  }

  private addChangeDetectionHistoryCompareFeedPanel(
    feed: any,
    sensor: any,
    config: any,
    feedResults: any,
    pane?: 'left' | 'right',
    isCompare: boolean = false
  ): void {
    if (!isCompare || !pane) {
      return;
    }

    const color = this.getFeedDisplayColor(sensor, feed, config);
    const vm = this.helperService.buildFeedSections(config, feedResults ?? 0, color);
    const title = this.feedTitleOf(config, feed?.feedName || feed?.name);
    const key = this.getFeedKey(feed, config);

    if (pane === 'left') {
      this.addLeftFeedPanel(key, title, color, vm.sections);
      return;
    }

    this.addRightFeedPanel(key, title, color, vm.sections);
  }

  private async loadChangeDetectionHistoryTiffFeed(
    collection: any,
    sensor: any,
    history: any,
    feed: any,
    config: any,
    pane?: 'left' | 'right',
    isCompare: boolean = false
  ): Promise<void> {
    if (!this.map) return;
    const feedKey = this.getChangeDetectionHistoryFeedKey(history, feed);
    const storageKey = isCompare && pane ? `${feedKey}::compare::${pane}` : feedKey;
    const cancel$ = this.beginTiffWfsLoad(storageKey);
    this.mapLoad = true;
    this.spinnerService.show();
    try {
      const sceneId = this.getChangeDetectionHistorySceneId(history);
      const requestSceneId = this.getChangeDetectionRequestSceneId(sensor, history);
      const feedId = history?._id;
      const sensorId = history?.sensorId ?? sensor?.id;
      if (!sceneId || !requestSceneId || !feedId || !sensorId) return;

      const sensorObj = {
        sensorId,
        sceneId: requestSceneId,
        action: 'scene',
        fileType: history?.imageType ?? this.imageType,
      };
      this.tifPopupShown = 0;

      const result = await this.getCollectionImageResult(collection, sensorObj);
      if (cancel$.isStopped) return;
      if (isCompare && !this.isActiveChangeDetectionHistorySelection(history, pane)) {
        return;
      }
      if (!result?.layer) return;

      const shapeList = result?.layer?.shapes;
      if (!shapeList?.length) return;

      const matchedShape = this.findChangeDetectionHistoryShape(
        shapeList,
        feed,
        sceneId
      );
      if (!matchedShape) return;

      const classFilter = this.helperService.classCqlStrict(config?.class, 'class');
      const baseCql = this.helperService.combineFilters(matchedShape.cql, classFilter);
      const layerName = matchedShape.layerName ?? matchedShape.layername;
      const historyInsightData = this.findChangeDetectionHistoryInsightData(
        feed?.insightDatas ?? [],
        feed,
        sceneId
      );
      let historyFeedResults = this.getChangeDetectionHistoryFeedResults(
        history,
        historyInsightData?.insightFootprint
      );
      let geojson: any;
      try {
        const wmsLayer = isCompare ? undefined : this.getActiveFeedWmsLayer({ isCompare, pane });
        geojson = await this.loadViewportGeojson(
          layerName,
          baseCql,
          wmsLayer,
          cancel$,
            isCompare ? 'immediate' : 'afterWmsLoad',
          this.helperService.getFeedResultCount(historyFeedResults, config?.type)
        );
      } catch (error) {
        if (cancel$.isStopped || (error as any)?.name === 'EmptyError') {
          this.spinnerService.hide();
          this.mapLoad = false;
          return;
        }
        this.notifyViewportGeojsonLoadError(error);
        this.spinnerService.hide();
        this.mapLoad = false;
        return;
      }
      if (cancel$.isStopped) return;
      const isEmptyFeed = await this.isEntireTiffFeedEmpty(geojson, layerName, baseCql, cancel$);
      if (cancel$.isStopped || (isCompare && !this.isActiveChangeDetectionHistorySelection(history, pane))) return;
      if (isEmptyFeed) {
        this.feedLoaded = false;
        this.uncheckFeedAfterEmptyResult(feed);
        this.showNoInformationExtractedPopup();
        this.spinnerService.hide();
        this.mapLoad = false;
        return;
      }

      historyFeedResults = historyFeedResults ?? geojson?.features?.length ?? 0;
      geojson.feed_results = historyFeedResults;
      this.cacheChangeDetectionHistoryInsight(history, geojson);
      const scopedFeed = this.getChangeDetectionHistoryScopedFeed(
        feed,
        history,
        geojson,
        historyInsightData
      );
      this.addChangeDetectionHistoryCompareFeedPanel(
        scopedFeed,
        sensor,
        config,
        historyFeedResults,
        pane,
        isCompare
      );

      this.displayISNew(
        {
          insightFootprint: geojson,
          isInfo: scopedFeed,
          sensor,
          _changeDetectionHistoryFeedResults: historyFeedResults,
        },
        scopedFeed,
        sensor,
        isCompare,
        pane
      );
    } finally {
      this.finishTiffWfsLoad(storageKey, cancel$);
      this.spinnerService.hide();
      this.mapLoad = false;
    }
  }

  private loadChangeDetectionHistoryPngFeed(
    collection: any,
    sensor: any,
    history: any,
    feed: any,
    pane?: 'left' | 'right',
    isCompare: boolean = false
  ): void {
    const sceneId = this.getChangeDetectionHistorySceneId(history);
    const requestSceneId = history?.insightDatas?.[0]?.sceneId ?? sceneId;
    const feedId = history?._id;
    const sensorId = history?.sensorId ?? sensor?.id;
    if (!sceneId || !requestSceneId || !feedId || !sensorId) return;

    if (feed?.modelType === this.infoserviceModelType) {
      const payload = {
        action: 'ISDisplay',
        feedId,
        type: 'json',
        sceneId: requestSceneId,
        sensorId,
      };

      this.apiService
        .getCollectionImage(collection?.taskId ?? this.currentTaskId, payload)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (res: any) => {
            if (isCompare && !this.isActiveChangeDetectionHistorySelection(history, pane)) {
              this.spinnerService.hide();
              this.mapLoad = false;
              return;
            }
            this.fetchAndCombineGeoJson(
              res?.result?.feedData,
              this.getChangeDetectionHistoryScopedFeed(feed, history),
              sensor,
              {
                isCompare,
                pane,
                cacheHistory: history,
              }
            );
          },
          error: () => {
            this.spinnerService.hide();
            this.mapLoad = false;
          },
        });
      return;
    }

    const cachedInsightData = this.findChangeDetectionHistoryInsightData(
      feed?.insightDatas ?? [],
      feed,
      sceneId
    );
    if (cachedInsightData?.insightFootprint) {
      const historyFeedResults = this.getChangeDetectionHistoryFeedResults(
        history,
        cachedInsightData.insightFootprint
      );
      cachedInsightData.insightFootprint.feed_results = historyFeedResults;
      this.cacheChangeDetectionHistoryInsight(
        history,
        cachedInsightData.insightFootprint
      );
      const scopedFeed = this.getChangeDetectionHistoryScopedFeed(
        feed,
        history,
        cachedInsightData.insightFootprint,
        cachedInsightData
      );
      this.addChangeDetectionHistoryCompareFeedPanel(
        scopedFeed,
        sensor,
        feedsConfig[feed?._id],
        historyFeedResults,
        pane,
        isCompare
      );
      this.displayISNew(
        {
          ...cachedInsightData,
          isInfo: scopedFeed,
          sensor,
          _changeDetectionHistoryFeedResults: historyFeedResults,
        },
        scopedFeed,
        sensor,
        isCompare,
        pane
      );
      return;
    }

    const payload = {
      customerid: this.currentUser?.id,
      feedId,
      taskId: collection?.taskId ?? this.currentTaskId,
      sensorId,
    };

    this.apiService
      .getObjectDetectionData(payload)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res: any) => {
          if (isCompare && !this.isActiveChangeDetectionHistorySelection(history, pane)) {
            this.spinnerService.hide();
            this.mapLoad = false;
            return;
          }
          const feedData = res?.result?.feedData;
          if (!feedData) {
            this.spinnerService.hide();
            this.mapLoad = false;
            return;
          }
          const historyFeedResults = this.getChangeDetectionHistoryFeedResults(
            history,
            feedData
          );
          feedData.feed_results = historyFeedResults;
          this.cacheChangeDetectionHistoryInsight(history, feedData);
          const scopedFeed = this.getChangeDetectionHistoryScopedFeed(
            feed,
            history,
            feedData
          );
          this.addChangeDetectionHistoryCompareFeedPanel(
            scopedFeed,
            sensor,
            feedsConfig[feed?._id],
            historyFeedResults,
            pane,
            isCompare
          );
          this.displayISNew(
            {
              insightFootprint: feedData,
              isInfo: scopedFeed,
              sensor,
              _changeDetectionHistoryFeedResults: historyFeedResults,
            },
            scopedFeed,
            sensor,
            isCompare,
            pane
          );
        },
        error: () => {
          this.spinnerService.hide();
          this.mapLoad = false;
        },
      });
  }

  private loadChangeDetectionHistoryFeed(
    collection: any,
    sensor: any,
    history: any,
    pane?: 'left' | 'right',
    isCompare: boolean = false
  ): void {
    const feedId = history?._id;
    const sceneId = this.getChangeDetectionHistorySceneId(history);
    const config = feedsConfig[feedId];
    if (!feedId || !sceneId || !config) return;
    if (isCompare && !this.isActiveChangeDetectionHistorySelection(history, pane)) {
      return;
    }

    const feed = this.getChangeDetectionHistoryFeed(history, sensor);
    const shouldLoadTiff =
      this.loadTiff || this.imageType === 'tif' || this.imageType === 'tiff';

    this.spinnerService.show();
    this.mapLoad = true;

    if (shouldLoadTiff) {
      this.loadChangeDetectionHistoryTiffFeed(
        collection,
        sensor,
        history,
        feed,
        config,
        pane,
        isCompare
      )
        .catch(() => {
          this.spinnerService.hide();
          this.mapLoad = false;
        })
        .finally(() => {
          this.spinnerService.hide();
          this.mapLoad = false;
        });
      return;
    }

    this.loadChangeDetectionHistoryPngFeed(
      collection,
      sensor,
      history,
      feed,
      pane,
      isCompare
    );
  }

  private syncChangeDetectionHistoryCompareState(): void {
    const toDisplaySelection = (selection: any) => {
      const displayDate = this.getChangeDetectionHistoryDisplayDate(selection?.data);
      return {
        ...(selection?.data ?? {}),
        ...selection,
        start: displayDate,
        date: displayDate,
      };
    };

    this.leftData = this.changeDetectionHistorySelections
      .filter((selection: any) => selection.pane === 'left')
      .map(toDisplaySelection);
    this.rightData = this.changeDetectionHistorySelections
      .filter((selection: any) => selection.pane === 'right')
      .map(toDisplaySelection);
    this.sensorsNew = this.changeDetectionHistorySelections.map(
      (selection: any) => {
        const displayDate = this.getChangeDetectionHistoryDisplayDate(selection?.data);
        return {
          checked: true,
          pane: selection.pane,
          start: displayDate,
          date: displayDate,
          isChangeDetectionHistoryCompare: true,
        };
      }
    );
  }

  private syncChangeDetectionHistoryCompareMode(): void {
    const isComparing = this.changeDetectionHistorySelections.length > 1;
    this.isCompare = isComparing;
    this.isCompareRecurrency = isComparing;
    this.isCompareClicked = isComparing;
    if (isComparing) {
      this.needsCompareResetToCenter = true;
    } else {
      this.removeCompareWhenSinglePaneRemains();
    }
  }

  private removeCompareWhenSinglePaneRemains(): void {
    const hasLeftPane = !!(this.leftComparisonObjectLayer || this.leftImageNew);
    const hasRightPane = !!(this.rightComparisonObjectLayer || this.rightImageNew);

    if (hasLeftPane && hasRightPane) {
      return;
    }

    this.removeCompareControlSafely();
  }

  private clearComparisonObjectLayer(pane: 'left' | 'right'): void {
    this.clearCompareFeedCache(pane);
    const layer =
      pane === 'left'
        ? this.leftComparisonObjectLayer
        : this.rightComparisonObjectLayer;

    if (layer && this.map?.hasLayer(layer)) {
      this.map.removeLayer(layer);
    }

    this.removeTrackedComparisonLayersForPane(pane);

    if (pane === 'left') {
      this.leftComparisonObjectLayer = null;
      this.leftFeedPanels.clear();
      return;
    }

    this.rightComparisonObjectLayer = null;
    this.rightFeedPanels.clear();
  }

  private removeTrackedComparisonLayersForPane(pane: 'left' | 'right'): void {
    const paneName = `${pane}-objects`;
    const removeMatchingLayer = (layer: any): boolean => {
      const layerPane = layer?._changeDetectionComparePane ?? layer?.options?.pane;
      const shouldRemove = layerPane === pane || layerPane === paneName;

      if (shouldRemove && layer && this.map?.hasLayer(layer)) {
        this.removeVesselLabelLayer(layer);
        this.map.removeLayer(layer);
      }

      return shouldRemove;
    };

    Object.entries(this.feedLayers || {}).forEach(([key, layer]) => {
      if (removeMatchingLayer(layer)) {
        delete this.feedLayers[key];
      }
    });

    Object.entries(this.currentFilteredLayers || {}).forEach(([key, layer]) => {
      if (removeMatchingLayer(layer)) {
        delete this.currentFilteredLayers[key];
      }
    });
  }

  private clearAllComparisonObjectLayers(): void {
    this.clearComparisonObjectLayer('left');
    this.clearComparisonObjectLayer('right');
  }

  private clearSplitMapArtifacts(): void {
    if (!this.map) {
      return;
    }

    const container = this.map.getContainer?.() as HTMLElement | undefined;
    if (container) {
      container
        .querySelectorAll('.leaflet-sbs, .leaflet-sbs-divider, .leaflet-sbs-range')
        .forEach((element) => element.remove());
    }

    const panes = (this.map as any).getPanes?.();
    if (panes) {
      Object.values(panes).forEach((pane: any) => {
        if (pane?.style) {
          pane.style.clip = '';
        }
      });
    }
  }

  private removeCompareControlSafely(): void {
    if (this.compare) {
      const compareControl: any = this.compare;
      const sanitizeLayers = (layers: any): any[] => {
        if (!Array.isArray(layers)) {
          return [];
        }
        return layers.filter(
          (layer: any) => layer && typeof layer.getPane === 'function'
        );
      };

      compareControl._leftLayers = sanitizeLayers(compareControl._leftLayers);
      compareControl._rightLayers = sanitizeLayers(compareControl._rightLayers);

      try {
        this.map.removeControl(this.compare);
      } catch {
        try {
          compareControl.remove?.();
        } catch {
          // Ignore teardown errors from stale compare internals and continue cleanup.
        }
      } finally {
        this.compare = null;
        this.clearSplitMapArtifacts();
      }
    } else {
      this.clearSplitMapArtifacts();
    }
  }

  private ensureChangeDetectionHistorySplitMap(): void {
    if (
      this.changeDetectionHistorySelections.length < 1 ||
      !this.leftComparisonObjectLayer ||
      !this.rightComparisonObjectLayer ||
      this.compare
    ) {
      return;
    }

    this.clearSplitMapArtifacts();

    this.compare = new SplitMap(
      this.leftComparisonObjectLayer,
      this.rightComparisonObjectLayer
    ).addTo(this.map);
    this.compare.on('dividermove', (event: any) => {
      this.updateObjectVisibility(event.x);
    });

    const mapWidth = this.map.getSize().x;
    this.updateObjectVisibility(
      this.lastSliderValue === 0 ? mapWidth / 2 : this.lastSliderValue
    );
  }

private getChangeDetectionInformationFeedComparePane():| 'left'| 'right'| undefined {

  if (!this.isChangeDetectionTask(this.collection?.taskStrategy)) {
    return undefined;
  }

  if (this.leftComparisonObjectLayer) {
    return 'right';
  }

  if (this.rightComparisonObjectLayer) {
    return 'left';
  }

  return 'left';
}

private getActiveChangeDetectionInformationFeedPane():
  | 'left'
  | 'right'
  | undefined {
  const sensors = this.getChangeDetectionCompareFeedRows();

  for (const sensor of sensors) {
    const feeds = [
      ...(sensor?.InfoServices ?? []),
      ...(sensor?.AssociatedFeeds ?? []),
    ];
    const activeFeed = feeds.find(
      (feed: any) =>
        feed?._changeDetectionComparePane === 'left' ||
        feed?._changeDetectionComparePane === 'right'
    );

    if (activeFeed) {
      return activeFeed._changeDetectionComparePane;
    }
  }

  return undefined;
}

private getChangeDetectionCompareFeedRows(): any[] {
  const rows = [
    ...(this.collection?.sensors ?? []),
    ...(this.collection?.recurrencyArray ?? []),
    ...(this.selectedCheckboxesNew ?? []),
  ];

  return rows.filter(
    (row: any, index: number, items: any[]) =>
      !!row && items.indexOf(row) === index
  );
}

private getCheckedChangeDetectionCompareFeeds(): Array<{
  row: any;
  feed: any;
  sceneId: string | null;
}> {
  const activeFeeds: Array<{ row: any; feed: any; sceneId: string | null }> = [];

  for (const row of this.getChangeDetectionCompareFeedRows()) {
    const feeds = [
      ...(row?.InfoServices ?? []),
      ...(row?.AssociatedFeeds ?? []),
    ];

    feeds.forEach((feed: any) => {
      if (!feed?.checked) {
        return;
      }

      activeFeeds.push({
        row,
        feed,
        sceneId:
          row?.scenes?.[0]?.id ??
          row?.scenes?.[0]?.scene_id ??
          feed?.insightDatas?.[0]?.sceneId ??
          null,
      });
    });
  }

  return activeFeeds;
}

  private reloadSingleChangeDetectionHistorySelection(
    collection: any,
    sensor: any,
    selection: any
  ): void {
    if (!selection) {
      return;
    }

     const activeFeeds =
    this.getCheckedChangeDetectionCompareFeeds();
    this.loadChangeDetectionHistoryFeed(collection, sensor, selection.data, activeFeeds.length !== 1?'left': 'right', activeFeeds.length === 1);
  }

private reloadSingleChangeDetectionFeedSelection(): boolean {

  const activeFeeds =
    this.getCheckedChangeDetectionCompareFeeds();

  if (activeFeeds.length !== 1) {
    return false;
  }

  // We are no longer comparing.
  this.isCompare = false;
  this.isCompareRecurrency = false;
  this.isCompareClicked = false;
  this.needsCompareResetToCenter = false;

  const { row, feed, sceneId } = activeFeeds[0];

  delete feed._changeDetectionComparePane;

  const insightData =
    feed?.insightDatas?.find(
      (item: any) => item?.sceneId === sceneId
    ) ??
    feed?.insightDatas?.[0];

  if (!insightData) {
    return false;
  }

  this.displayISNew(
    insightData,
    feed,
    row,
    false,
    'left'
  );

  this.updateFeedInfo(
    row,
    { checked: true },
    this.getFeedKey(
      feed,
      feedsConfig[feed?._id]
    )
  );

  return true;
}

private restoreSingleChangeDetectionSelection(
  collection: any,
  sensor: any
): void {
  this.clearChangeDetectionHistoryCompareLayers();
  this.isCompare = false;
  this.isCompareRecurrency = false;
  this.isCompareClicked = false;
  this.needsCompareResetToCenter = false;
  this.resetChangeDetectionCompareDisplayState();

  // =========================================================
  // 9. RESTORE THE ONE REMAINING SELECTION
  // =========================================================

  // ---------------------------------------------------------
  // CASE 1:
  // One Change History item remains
  // ---------------------------------------------------------

  if (this.changeDetectionHistorySelections.length === 1) {

    const remainingHistory =
      this.changeDetectionHistorySelections[0];

    this.reloadSingleChangeDetectionHistorySelection(
      collection,
      sensor,
      remainingHistory
    );

    return;
  }

  // ---------------------------------------------------------
  // CASE 2:
  // One Information Feed remains
  // ---------------------------------------------------------

  this.reloadSingleChangeDetectionFeedSelection();
}

  private loadChangeDetectionHistorySelection(
    collection: any,
    sensor: any,
    selection: any
  ): void {
    this.loadChangeDetectionHistoryFeed(
      collection,
      sensor,
      selection.data,
      selection.pane,
      true
    );
  }

  private clearChangeDetectionHistoryCompareLayers(): void {
    this.cancelViewportGeojsonLoads();
    this.cancelAllPngGeoJsonLoads();

    const historyScenes = this.scenesNew.filter(
      (sceneNew: any) => sceneNew?.scene?.isChangeDetectionHistoryCompare
    );

    historyScenes.forEach((sceneNew: any) => {
      this.removeLayerByScene(sceneNew, { paneSpecific: true });
      if (sceneNew?.legendScale) {
        this.map.removeLayer(sceneNew.legendScale);
      }
    });

    this.scenesNew = this.scenesNew.filter(
      (sceneNew: any) => !sceneNew?.scene?.isChangeDetectionHistoryCompare
    );

    this.removeCompareControlSafely();

    this.clearAllComparisonObjectLayers();
    this.updateImageLayersBasedOnPane();
    this.removeCompareWhenSinglePaneRemains();
  }

  private resetChangeDetectionHistoryCompareForRebuild(): void {
    this.clearChangeDetectionHistoryCompareLayers();
    this.lastSliderValue = 0;
    this.needsCompareResetToCenter = true;
  }

  clearChangeDetectionTabLayers(sensorType?: string): void {
    const tabScenes = this.scenesNew.filter(
      (sceneNew: any) =>
        sceneNew?.scene?.isChangeDetectionCurrentWeekTab &&
        (!sensorType || sceneNew?.scene?.currentWeekSensorType === sensorType)
    );

    this.clearChangeDetectionCurrentWeekFeedPanels();

    const retainedScenes = this.scenesNew.filter(
      (sceneNew: any) => !tabScenes.includes(sceneNew)
    );
    const retainedImageLayers = new Set<any>();
    retainedScenes.forEach((sceneNew: any) => {
      if (sceneNew?.leftImageLayer) {
        retainedImageLayers.add(sceneNew.leftImageLayer);
      }
      if (sceneNew?.rightImageLayer) {
        retainedImageLayers.add(sceneNew.rightImageLayer);
      }
    });

    tabScenes.forEach((sceneNew: any) => {
      if (sceneNew?.footprint) {
        this.map.removeLayer(sceneNew.footprint);
      }
      if (sceneNew?.tiffootprint) {
        this.map.removeLayer(sceneNew.tiffootprint);
      }
      if (
        sceneNew?.leftImageLayer &&
        !retainedImageLayers.has(sceneNew.leftImageLayer)
      ) {
        this.map.removeLayer(sceneNew.leftImageLayer);
      }
      if (
        sceneNew?.rightImageLayer &&
        !retainedImageLayers.has(sceneNew.rightImageLayer)
      ) {
        this.map.removeLayer(sceneNew.rightImageLayer);
      }
      if (sceneNew?.legendScale) {
        this.map.removeLayer(sceneNew.legendScale);
      }
      if (sceneNew?.currentWeekImageLayer) {
        this.map.removeLayer(sceneNew.currentWeekImageLayer);
      }
    });

    this.scenesNew = retainedScenes;
    this.leftImageNew = retainedScenes.find(
      (sceneNew: any) =>
        sceneNew?.leftImageLayer && this.map.hasLayer(sceneNew.leftImageLayer)
    )?.leftImageLayer ?? null;
    this.rightImageNew = retainedScenes.find(
      (sceneNew: any) =>
        sceneNew?.rightImageLayer && this.map.hasLayer(sceneNew.rightImageLayer)
    )?.rightImageLayer ?? null;
    this.refreshTiffMaxZoomAfterLayerChange();

    if (this.changeDetectionHistorySelections.length > 1) {
      this.syncChangeDetectionHistoryCompareState();
      this.syncChangeDetectionHistoryCompareMode();
    }
  }

  // Latest Change imagery gets its own pane so the compare SplitMap clip never hides it.
  private ensureChangeDetectionCurrentWeekPane(): string {
    const paneName = 'changeDetectionCurrentWeekPane';
    if (!this.map.getPane(paneName)) {
      this.map.createPane(paneName);
      (this.map as any).getPane(paneName).style.zIndex = 455;
    }
    return paneName;
  }

  private clearChangeDetectionCurrentWeekFeedPanels(): void {
    const panelKeys = Array.from(this.feedPanels.keys()).filter((key) => {
      const cachedFeed = this.geoByFeed.get(key);
      const config = feedsConfig[key];

      return (
        !key.includes('::history::') &&
        (cachedFeed?.type === 'Mining changes monitoring' ||
          config?.type === 'Mining changes monitoring')
      );
    });

    panelKeys.forEach((key) => {
      const feedLayer = this.feedLayers[key];
      if (feedLayer && this.map.hasLayer(feedLayer)) {
        this.removeVesselLabelLayer(feedLayer);
        this.map.removeLayer(feedLayer);
      }
      delete this.feedLayers[key];

      const filteredLayer = this.currentFilteredLayers?.[key];
      if (filteredLayer && this.map.hasLayer(filteredLayer)) {
        this.removeVesselLabelLayer(filteredLayer);
        this.map.removeLayer(filteredLayer);
      }
      if (this.currentFilteredLayers) {
        delete this.currentFilteredLayers[key];
      }

      this.removeFeedPanel(key);
      if (this.changeDetectionHistorySelections.length === 0) {
        this.activeFeedKeys.delete(key);
        this.geoByFeed.delete(key);
      }
    });
  }

private rebuildChangeDetectionHistoryCompare(
  collection: any,
  sensor: any
): void {
  this.changeDetectionHistorySelections =
    this.changeDetectionHistorySelections
      .slice(-2)
      .map((selection: any, index: number) => ({
        ...selection,
        pane: index === 0 ? 'left' : 'right',
      }));


  // =========================================================
  // 2. CHECK WHAT IS STILL ACTIVE BEFORE CLEARING LAYERS
  // =========================================================

  const remainingInformationFeeds =
    this.getCheckedChangeDetectionCompareFeeds();


  const historyCount =
    this.changeDetectionHistorySelections.length;
  if (historyCount === 0) {

    this.clearChangeDetectionHistoryCompareLayers();

    this.resetChangeDetectionCompareDisplayState();

    this.mapPane = '';
    return;
  }
  if (historyCount === 1) {

    this.restoreSingleChangeDetectionSelection(
      collection,
      sensor
    );

    return;
  }

  this.changeDetectionHistorySelections.forEach((selection: any) => {
    const historyFeed = this.getChangeDetectionHistoryFeed(selection.data, sensor);
    const historyFeedKey = this.getChangeDetectionHistoryFeedKey(selection.data, historyFeed);

    this.removeDataLayer({
      ...historyFeed,
      _changeDetectionHistoryFeedKey: historyFeedKey,
    });
    if (historyFeedKey) {
      this.removeFeedPanel(historyFeedKey);
      this.activeFeedKeys.delete(historyFeedKey);
    }
  });

  this.resetChangeDetectionHistoryCompareForRebuild();

  this.syncChangeDetectionHistoryCompareMode();

  this.syncChangeDetectionHistoryCompareState();


  this.changeDetectionHistorySelections.forEach(
    (selection: any) => {

      this.loadChangeDetectionHistorySelection(
        collection,
        sensor,
        selection
      );

    }
  );
}

  handleChangeHistoryToggle(
    event: any,
    collection: any,
    sensor: any,
    history: any,
    taskStrategy?: any
  ): void {
    if (!this.isChangeDetectionTask(taskStrategy ?? this.collection?.taskStrategy)) {
      this.displayChangeData(
        event,
        sensor?.scenes?.[0],
        sensor,
        'display',
        history,
        undefined,
        this.getHistoryComparePane(sensor)
      );
      return;
    }
    this.clearChangeDetectionHistoryCompareLayers();
    if (this.compare) {
      this.map.removeControl(this.compare);
      this.compare = null;
    }
    const sceneId = this.getChangeDetectionHistorySceneId(history);
    if (!sceneId) {
      history.checked = false;
      return;
    }

    const key = this.getChangeDetectionHistoryKey(history);

    const previousSelectionCount = this.changeDetectionHistorySelections.length;
    const existingSelection = this.changeDetectionHistorySelections.find(
      (selection: any) => selection.key === key
    );
    const informationFeedPane: 'left' | 'right' | undefined = undefined;
    const isMixedComparison =
      event?.checked &&
      !existingSelection &&
      previousSelectionCount === 0 &&
      !!informationFeedPane;
    this.removeCompareControlSafely();
        this.clearComparisonObjectLayer('left');
        this.clearComparisonObjectLayer('right');
    if (event?.checked) {
      if (!existingSelection) {
        if (this.changeDetectionHistorySelections.length >= 2) {
          const removedSelection = this.changeDetectionHistorySelections.shift();
          if (removedSelection?.data) {
            removedSelection.data.checked = false;

            const removedHistoryFeed = this.getChangeDetectionHistoryFeed(
              removedSelection.data,
              sensor
            );
            const removedHistoryFeedKey = this.getChangeDetectionHistoryFeedKey(
              removedSelection.data,
              removedHistoryFeed
            );
            const scopedRemovedHistoryFeed = {
              ...removedHistoryFeed,
              _changeDetectionHistoryFeedKey: removedHistoryFeedKey,
            };

            this.removeDataLayer(scopedRemovedHistoryFeed);

            if (removedHistoryFeedKey) {
              this.removeFeedPanel(removedHistoryFeedKey);
              this.leftFeedPanels.delete(removedHistoryFeedKey);
              this.rightFeedPanels.delete(removedHistoryFeedKey);
              this.clearFilteredLayerAndRestore(false, removedHistoryFeedKey);
              this.activeFeedKeys.delete(removedHistoryFeedKey);
            }
          }

          if (removedSelection?.sceneId) {
            const removedHistoryScenes = this.scenesNew.filter(
              (sceneNew: any) => {
                const matchesSceneId =
                  sceneNew?.scene?.id === removedSelection.sceneId ||
                  sceneNew?.id === removedSelection.sceneId;
                const matchesPane = removedSelection?.pane
                  ? sceneNew?.pane === removedSelection.pane
                  : true;
                return matchesSceneId && matchesPane;
              }
            );

            removedHistoryScenes.forEach((sceneNew: any) => {
              this.removeLayerByScene(sceneNew, { paneSpecific: true });
              if (sceneNew?.legendScale && this.map.hasLayer(sceneNew.legendScale)) {
                this.map.removeLayer(sceneNew.legendScale);
              }
            });

            this.scenesNew = this.scenesNew.filter(
              (sceneNew: any) => {
                const matchesSceneId =
                  sceneNew?.scene?.id === removedSelection.sceneId ||
                  sceneNew?.id === removedSelection.sceneId;
                const matchesPane = removedSelection?.pane
                  ? sceneNew?.pane === removedSelection.pane
                  : true;
                return !(matchesSceneId && matchesPane);
              }
            );

            this.updateImageLayersBasedOnPane();
          }
        }

        this.changeDetectionHistorySelections.push({
          key,
          sceneId,
          data: history,
          pane: informationFeedPane === 'left' ? 'right' : 'left',
        });
      }

      history.checked = true;
      this.syncChangeHistoryOverlayOpacity();

      if (
        previousSelectionCount === 0 &&
        this.changeDetectionHistorySelections.length === 1
      ) {
        this.isCompare = false;
        this.isCompareRecurrency = false;
        this.isCompareClicked = false;
        this.needsCompareResetToCenter = false;
        this.resetChangeDetectionCompareDisplayState();
        this.loadChangeDetectionHistoryFeed(
          collection,
          sensor,
          history,
          undefined,
          false
        );
        return;
      }
    } else {
      history.checked = false;

      const historyFeed = this.getChangeDetectionHistoryFeed(history, sensor);
      const historyFeedKey = this.getChangeDetectionHistoryFeedKey(
        history,
        historyFeed
      );
      const scopedHistoryFeed = {
        ...historyFeed,
        _changeDetectionHistoryFeedKey: historyFeedKey,
      };

      this.removeDataLayer(scopedHistoryFeed);

      if (historyFeedKey) {
        this.removeFeedPanel(historyFeedKey);
        this.leftFeedPanels.delete(historyFeedKey);
        this.rightFeedPanels.delete(historyFeedKey);
        this.clearFilteredLayerAndRestore(false, historyFeedKey);
        this.activeFeedKeys.delete(historyFeedKey);
      }

      if (existingSelection?.sceneId) {
        const removedHistoryScenes = this.scenesNew.filter((sceneNew: any) => {
          const matchesSceneId =
            sceneNew?.scene?.id === existingSelection.sceneId ||
            sceneNew?.id === existingSelection.sceneId;
          const matchesPane = existingSelection?.pane
            ? sceneNew?.pane === existingSelection.pane
            : true;
          return matchesSceneId && matchesPane;
        });

        removedHistoryScenes.forEach((sceneNew: any) => {
          this.removeLayerByScene(sceneNew, { paneSpecific: true });
          if (sceneNew?.legendScale && this.map.hasLayer(sceneNew.legendScale)) {
            this.map.removeLayer(sceneNew.legendScale);
          }
        });

        this.scenesNew = this.scenesNew.filter((sceneNew: any) => {
          const matchesSceneId =
            sceneNew?.scene?.id === existingSelection.sceneId ||
            sceneNew?.id === existingSelection.sceneId;
          const matchesPane = existingSelection?.pane
            ? sceneNew?.pane === existingSelection.pane
            : true;
          return !(matchesSceneId && matchesPane);
        });

        this.updateImageLayersBasedOnPane();
      }

      if (existingSelection?.pane === 'left') {
        this.clearComparisonObjectLayer('left');
      }

      if (existingSelection?.pane === 'right') {
        this.clearComparisonObjectLayer('right');
      }

      this.changeDetectionHistorySelections = this.changeDetectionHistorySelections.filter(
        (selection: any) => selection.key !== key
      );
      this.syncChangeHistoryOverlayOpacity();
      this.syncChangeDetectionHistoryCompareState();
    }

    if (isMixedComparison) {
      this.isCompare = true;
      this.isCompareRecurrency = true;
      this.isCompareClicked = true;
      this.needsCompareResetToCenter = true;
      this.syncChangeDetectionHistoryCompareState();
      this.loadChangeDetectionHistorySelection(
        collection,
        sensor,
        this.changeDetectionHistorySelections[0]
      );
      return;
    }

    const shouldAppendIncrementally =
      event?.checked &&
      !existingSelection &&
      previousSelectionCount === 1 &&
      this.changeDetectionHistorySelections.length === 2;

    if (shouldAppendIncrementally) {
      this.rebuildChangeDetectionHistoryCompare(collection, sensor);
      return;
    }

    this.rebuildChangeDetectionHistoryCompare(collection, sensor);
  }

  getChangeHistory(sensor: any, taskStrategy?: any): any[] {
    // For Change Detection tasks, use historicalData array (not tab-aware)
    if (this.isChangeDetectionTask(taskStrategy ?? this.collection?.taskStrategy)) {
      const history = Array.isArray(sensor?.historicalData) ? sensor.historicalData : [];
      return history.slice().reverse();
    }

    // For other tasks, use changeHistory
    const history = Array.isArray(sensor?.changeHistory) ? sensor.changeHistory : [];
    return history.slice().reverse();
  }

  hasChangeHistory(sensor: any, taskStrategy?: any): boolean {
    if (this.isChangeDetectionTask(taskStrategy ?? this.collection?.taskStrategy)) {
      return Array.isArray(sensor?.historicalData) && sensor.historicalData.length > 0;
    }
    return false;
  }

  private initializeChangeDetectionSensors(collection: any): void {
    if (!this.isChangeDetectionTask(collection?.taskStrategy)) {
      return;
    }

    this.selectedChangeDetectionTab = [];
  }

  initializeDefaultValue() {
    if (this.collection?.recurrencyArray?.length) {
      this.selectedValue = this.collection.recurrencyArray[0];
    }
  }

  isNumberOfCollectionsFrequency(value: any): boolean {
    return `${value ?? ''}`.trim().toLowerCase() === 'number of collections';
  }

  private isIceyeSensor(sensor: any): boolean {
    return sensor?.operatorKey === OPERATORS.ICEYE;
  }

  private getUtcDateKey(value: any): string | null {
    const parsed = new Date(value);
    if (isNaN(parsed.getTime())) {
      return null;
    }

    return parsed.toISOString().slice(0, 10);
  }

  private normalizeIceyeSubdailyRecurrency(task: any): any {
    if (
      !task ||
      (task?.repeatFrequency !== 'Daily' && task?.repeatFrequency !== 'Sub-daily') ||
      !Array.isArray(task?.sensors)
    ) {
      return task;
    }

    const iceyeSensors = task.sensors.filter((sensor: any) => this.isIceyeSensor(sensor));
    if (!iceyeSensors.length) {
      return task;
    }

    const nonIceyeSensors = task.sensors.filter((sensor: any) => !this.isIceyeSensor(sensor));
    const byCompositeKey = new Map<string, any[]>();

    iceyeSensors.forEach((sensor: any) => {
      const sensorKey = [
        sensor?.sensor ?? '',
        sensor?.operatorKey ?? '',
        sensor?.sensorType ?? sensor?.sensortype ?? ''
      ].join('|');

      if (!byCompositeKey.has(sensorKey)) {
        byCompositeKey.set(sensorKey, []);
      }
      byCompositeKey.get(sensorKey)?.push(sensor);
    });

    const normalizedIceyeSensors = Array.from(byCompositeKey.values()).map((occurrences: any[]) => {
      const sortedOccurrences = [...occurrences].sort((left: any, right: any) => {
        const leftTime = new Date(left?.day_start_date ?? left?.date ?? 0).getTime();
        const rightTime = new Date(right?.day_start_date ?? right?.date ?? 0).getTime();
        return leftTime - rightTime;
      });

      const baseSensor = { ...sortedOccurrences[0] };
      const slotCounterByDate = new Map<string, number>();
      const subdailyGroups: { [dateKey: string]: { [slot: number]: any[] } } = {};
      const normalizedScenes: any[] = [];
      const normalizedSceneIds = new Set<string>();

      sortedOccurrences.forEach((occurrence: any) => {
        const occurrenceDate = occurrence?.day_start_date ?? occurrence?.date ?? occurrence?.day_end_date;
        const dateKey = this.getUtcDateKey(occurrenceDate) ?? '__unknown__';

        const explicitSlot = Number(occurrence?.subDailySlot);
        const hasExplicitSlot = Number.isFinite(explicitSlot) && explicitSlot > 0;

        // Fallback to subTaskName when subDailySlot is not available.
        // Example: Collection_repeat_1 -> 1
        const subTaskMatch = String(occurrence?.subTaskName ?? '').match(/(?:repeat|subdaily)[_\s-]*(\d+)/i);
        const subTaskSlot = subTaskMatch ? Number(subTaskMatch[1]) : NaN;
        const hasSubTaskSlot = Number.isFinite(subTaskSlot) && subTaskSlot > 0;
        const configuredSubDailyCount = Number(task?.subDailyCount) || 0;
        const isConfiguredSlot = (candidate: number) =>
          configuredSubDailyCount === 0 || candidate <= configuredSubDailyCount;

        if (!slotCounterByDate.has(dateKey)) {
          slotCounterByDate.set(dateKey, 0);
        }

        const derivedSlot = (slotCounterByDate.get(dateKey) ?? 0) + 1;

        const slot = hasExplicitSlot && isConfiguredSlot(explicitSlot)
          ? explicitSlot
          : hasSubTaskSlot && configuredSubDailyCount === 0
            ? subTaskSlot
            : derivedSlot;

        // Respect configured sub-daily count for the recurrency UI.
        if (configuredSubDailyCount > 0 && slot > configuredSubDailyCount) {
          return;
        }

        slotCounterByDate.set(
        dateKey,
        Math.max(slotCounterByDate.get(dateKey) ?? 0, slot)
      );

        const occurrenceScenes = Array.isArray(occurrence?.scenes)
          ? occurrence.scenes
          : [];

        const normalizedOccurrence = {
          ...occurrence,
          subDailySlot: slot,
          scenes: occurrenceScenes.map((scene: any) => ({
            ...scene,
            // Sub-daily selection logic reads sequence fields in many paths,
            // so align them with the resolved slot for ICEYE recurrency.
            sequence: slot,
            sequenceNumber: slot,
            predicted_date:
              scene?.day_start_date ??
              occurrence?.day_start_date ??
              scene?.predicted_date ??
              occurrence?.date,
            predictedDate:
              scene?.day_start_date ??
              occurrence?.day_start_date ??
              scene?.predictedDate ??
              scene?.predicted_date ??
              occurrence?.date,
            subTaskName:
              scene?.subTaskName ??
              occurrence?.subTaskName,
            subDailySlot: slot,
            day_start_date:
              scene?.day_start_date ??
              occurrence?.day_start_date,
            day_end_date:
              scene?.day_end_date ??
              occurrence?.day_end_date,
          })),
        };

        // Keep existing top-level scenes for existing collection logic
        normalizedOccurrence.scenes.forEach((scene: any) => {
          // The same ICEYE asset can be returned in more than one sensor
          // occurrence. Keep it once so a sub-daily slot renders one scene.
          const sceneId = scene?.id;
          // An ICEYE asset ID may legitimately occur in more than one
          // sub-daily sensor occurrence.  Deduplicate only within a slot so
          // compare mode retains one selectable scene for every slot.
          const sceneDate = scene?.day_start_date; // use the actual date property from your scene

          const sceneKey = sceneId != null ? `date:${sceneDate}|slot:${slot}|id:${sceneId}` : null;
          if (!sceneKey || !normalizedSceneIds.has(sceneKey)) {
            normalizedScenes.push(scene);
            if (sceneKey) {
              normalizedSceneIds.add(sceneKey);
            }
          }
        });

        // New date + subdaily grouping
        if (!subdailyGroups[dateKey]) {
          subdailyGroups[dateKey] = {};
        }

        if (!subdailyGroups[dateKey][slot]) {
          subdailyGroups[dateKey][slot] = [];
        }

        subdailyGroups[dateKey][slot].push(normalizedOccurrence);
      });

      normalizedScenes.sort((left: any, right: any) => {
        const leftTime = new Date(left?.predicted_date ?? left?.predictedDate ?? 0).getTime();
        const rightTime = new Date(right?.predicted_date ?? right?.predictedDate ?? 0).getTime();
        if (leftTime !== rightTime) {
          return leftTime - rightTime;
        }

        const leftSeq = Number(left?.sequence ?? left?.sequenceNumber ?? 0);
        const rightSeq = Number(right?.sequence ?? right?.sequenceNumber ?? 0);
        return leftSeq - rightSeq;
      });

      const firstDate = sortedOccurrences[0]?.day_start_date ?? sortedOccurrences[0]?.date ?? task?.openWindow;
      const lastDate = sortedOccurrences[sortedOccurrences.length - 1]?.day_end_date ?? sortedOccurrences[sortedOccurrences.length - 1]?.day_start_date ?? sortedOccurrences[sortedOccurrences.length - 1]?.date ?? task?.closeWindow;

      return {
        ...baseSensor,
        scenes: normalizedScenes,
        day_start_date: firstDate,
        day_end_date: lastDate,
        _iceyeSubdailyGroups: subdailyGroups,
        _iceyeOccurrences: sortedOccurrences,
      };
    });

    const normalizedSubDailyCount = normalizedIceyeSensors.reduce(
      (maxSlot: number, sensor: any) =>
        sensor.scenes.reduce(
          (currentMax: number, scene: any) => Math.max(currentMax, Number(scene?.subDailySlot) || 0),
          maxSlot
        ),
      0
    );

    task.subDailyCount = Math.max(Number(task?.subDailyCount) || 0, normalizedSubDailyCount);

    task.sensors = [...normalizedIceyeSensors, ...nonIceyeSensors];
    return task;
  }

  togglePanel() {
    this.showMe = !this.showMe;
  }

  ngAfterViewInit() {
    this.initializeMap();
    this.initGeoSearchControl();
    this.setupEventListeners();
    // ResizeObserver fires the instant the flex container reaches its true
    // painted dimensions — handles initial load AND re-navigation where a
    // cached API response races ahead of rAF-based invalidateSize calls.
    this.mapContainerResizeObserver = new ResizeObserver((entries) => {
      if (this.map) {
        const e = entries[0]?.contentRect;
        const cachedSize = (this.map as any)._size;
        // Leaflet caches _size as a truthy Point object. When the map is created
        // inside a 0-width container (e.g. during a router transition), _size is
        // locked as Point{x:0} and invalidateSize() becomes a no-op because
        // `_size || _getMapSize()` short-circuits on the truthy object.
        // Force-null the cache so Leaflet re-reads clientWidth from the DOM.
        if (cachedSize && cachedSize.x === 0 && (e?.width ?? 0) > 0) {
          (this.map as any)._size = null;
        }
        this.map.invalidateSize();
      }
    });
    this.mapContainerResizeObserver.observe(this.mapContainer.nativeElement);
  }

  chngAlphaNew(value: any) {
    const sliderValue = value / 100;
    const tilePane: any = document.querySelector('.leaflet-tile-pane');
    tilePane.style.opacity = sliderValue;
  }

  private applySceneOverlayOpacity(layer: any): void {
    if (typeof layer?.setOpacity === 'function') {
      layer.setOpacity(this.sceneOverlayOpacity / 100);
    }
  }

  private syncChangeHistoryOverlayOpacity(): void {
    this.sceneOverlayOpacity =
      this.changeDetectionHistorySelections.length > 0
        ? this.CHANGE_HISTORY_DEFAULT_OPACITY
        : 100;

    this.scenesNew.forEach((sceneNew: any) => {
      this.applySceneOverlayOpacity(sceneNew?.leftImageLayer);
      this.applySceneOverlayOpacity(sceneNew?.rightImageLayer);
      this.applySceneOverlayOpacity(sceneNew?.currentWeekImageLayer);
    });
  }

  private applyThermalObservationOpacity(): void {
    this.sceneOverlayOpacity = this.THERMAL_OBSERVATION_DEFAULT_OPACITY;
    this.thermalObservationOpacityApplied = true;
    this.scenesNew?.forEach((sceneNew: any) => {
      this.applySceneOverlayOpacity(sceneNew?.leftImageLayer);
      this.applySceneOverlayOpacity(sceneNew?.rightImageLayer);
      this.applySceneOverlayOpacity(sceneNew?.currentWeekImageLayer);
    });
  }

  private restoreThermalObservationOpacity(): void {
    if (!this.thermalObservationOpacityApplied) {
      return;
    }
    this.thermalObservationOpacityApplied = false;
    this.syncChangeHistoryOverlayOpacity();
  }

  chngSceneOpacity(value: any, sensor) {
    const parsedValue = Number(value);
    this.sceneOverlayOpacity = Number.isFinite(parsedValue) ? parsedValue : 100;
    const sliderValue = value / 100;
    // WeatherEx markers are circle markers stored separately — apply opacity directly.
    if (sensor?.operatorKey === OPERATORS.WEATHEREX) {
      for (const { marker } of this.weatherEx.markers) {
        marker.setStyle({ opacity: sliderValue, fillOpacity: 0.85 * sliderValue });
      }
      // Also apply to WMS tile layers (GeoServer path).
      this.weatherExWmsLayers.forEach(layer => layer.setOpacity(sliderValue));
      return;
    }
    this.scenesNew.map((scene) => {
      if (sensor.start) {
        if (scene.scene.start == sensor.start) {
          if (scene.leftImageLayer) {
            scene.leftImageLayer.setOpacity(sliderValue);
          }
          if (scene.rightImageLayer) {
            scene.rightImageLayer.setOpacity(sliderValue);
          }
          if (scene.currentWeekImageLayer) {
            scene.currentWeekImageLayer.setOpacity(sliderValue);
          }
        }
      } else if (sensor.id) {
        if (scene.sensorId == sensor.id) {
          if (scene.leftImageLayer) {
            scene.leftImageLayer.setOpacity(sliderValue);
          }
          if (scene.rightImageLayer) {
            scene.rightImageLayer.setOpacity(sliderValue);
          }
          if (scene.currentWeekImageLayer) {
            scene.currentWeekImageLayer.setOpacity(sliderValue);
          }
        }
      }
    });
  }

  chngSceneSite(value: any, sensor) {
    const sliderValue = value / 100;
    this.scenesNew.map((scene) => {
      if (sensor.sequenceNumber) {
        if (scene.scene.siteId == sensor.sequenceNumber) {
          if (scene.leftImageLayer) {
            scene.leftImageLayer.setOpacity(sliderValue);
          }
          if (scene.rightImageLayer) {
            scene.rightImageLayer.setOpacity(sliderValue);
          }
        }
      }
    });
  }

  createPixelValuesToColorFn(georaster: any, scene: any) {
    if (georaster.numberOfRasters === 1) {
      return (values) => {
        if (georaster.noDataValue === values[0]) {
          return 'rgba(0, 0, 0, 0)';
        }
        return chroma
          .scale(['black', 'white'])
          .domain([scene?.min, scene?.max])(values[0])
          .hex();
      };
    } else {
      return undefined;
    }
  }

  private setupEventListeners(): void {
    this.map.on('mousemove', this.handleMouseMove);
    this.map.on('contextmenu', this.handleMouseRightclick);
    document.addEventListener(
      'fullscreenchange',
      this.onFullscreenChange.bind(this)
    );
    this.map.doubleClickZoom.disable();
  }

  private initializeMeasurementTool(): void {
    if (!this.map.getPane(this.measurementPaneName)) {
      const pane = this.map.createPane(this.measurementPaneName);
      // Keep measurement above scene/image layers but below tooltips/popups.
      pane.style.zIndex = '4800';
    }

    this.map.addLayer(this.measurementLayers);
    this.measureDrawControl = new (L as any).Control.Draw({
      draw: {
        polyline: {
          shapeOptions: {
            pane: this.measurementPaneName,
          },
        },
        polygon: false,
        rectangle: false,
        circle: false,
        marker: false,
        circlemarker: false,
      },
      edit: false,
    });
    this.map.addControl(this.measureDrawControl);
    this.customizeMeasurementToolbar();
    this.map.on((L as any).Draw.Event.DRAWSTART, this.onMeasurementDrawStart);
    this.map.on('draw:drawvertex', this.onMeasurementDrawVertex);
    this.map.on('draw:drawstop', this.onMeasurementDrawStop);
    this.map.on((L as any).Draw.Event.CREATED, this.onMeasurementCreated);
    this.map.on('popupopen', this.handleMeasurementPopupOpen);
  }

  private customizeMeasurementToolbar(): void {
    setTimeout(() => {
      const toolbar = this.map
        ?.getContainer()
        ?.querySelector('.leaflet-draw-toolbar');
      const measureButton = toolbar?.querySelector(
        '.leaflet-draw-draw-polyline'
      ) as HTMLElement | null;

      if (!measureButton) {
        return;
      }

      toolbar?.classList.add('collection-measure-toolbar');
      this.renderer.setAttribute(measureButton, 'title', 'Measure distance');
      measureButton.classList.add('custom-button-leaflet');
    }, 0);
  }

  get measurementDrawingActive(): boolean {
    return this.isMeasurementDrawing;
  }

  get measurementModeActive(): boolean {
    const drawToolbar = this.measureDrawControl?._toolbars?.draw;
    const activeHandler = drawToolbar?._activeMode?.handler;
    const polylineHandler = drawToolbar?._modes?.polyline?.handler;
    return this.isMeasurementDrawing || (!!activeHandler && activeHandler === polylineHandler);
  }

  toggleMeasurementTool(): void {
    const drawToolbar = this.measureDrawControl?._toolbars?.draw;
    const activeHandler = drawToolbar?._activeMode?.handler;
    const polylineHandler = drawToolbar?._modes?.polyline?.handler;

    if (!drawToolbar || !polylineHandler) {
      return;
    }

    // Clicking the same button again exits measurement mode.
    if (activeHandler && activeHandler === polylineHandler) {
      if (typeof polylineHandler.disable === 'function') {
        polylineHandler.disable();
      }
      this.clearMeasurementInteraction();
      return;
    }

    if (typeof polylineHandler.enable === 'function') {
      polylineHandler.enable();
    }
  }

  private cancelMeasurementMode(): void {
    const drawToolbar = this.measureDrawControl?._toolbars?.draw;
    const activeHandler = drawToolbar?._activeMode?.handler;

    if (activeHandler && typeof activeHandler.disable === 'function') {
      activeHandler.disable();
    }

    this.clearMeasurementInteraction();
  }

  private onMeasurementDrawStart = (event: any) => {
    if (event.layerType !== 'polyline') {
      return;
    }

    this.isMeasurementDrawing = true;
    this.promoteOverlayPaneForMeasurement();
    this.removeMeasurementTooltip();
    this.map.on('contextmenu', this.finishMeasurementOnShortcut);
    this.map.on('dblclick', this.finishMeasurementOnShortcut);
  };

  private promoteOverlayPaneForMeasurement(): void {
    const overlayPane = (this.map as any)?.getPane?.('overlayPane') as
      | HTMLElement
      | undefined;
    if (!overlayPane) {
      return;
    }

    if (this.measurementOverlayPreviousZIndex === undefined) {
      this.measurementOverlayPreviousZIndex = overlayPane.style.zIndex || '';
    }
    overlayPane.style.zIndex = '4800';
  }

  private restoreOverlayPaneAfterMeasurement(): void {
    const overlayPane = (this.map as any)?.getPane?.('overlayPane') as
      | HTMLElement
      | undefined;
    if (!overlayPane || this.measurementOverlayPreviousZIndex === undefined) {
      return;
    }

    overlayPane.style.zIndex = this.measurementOverlayPreviousZIndex;
    this.measurementOverlayPreviousZIndex = undefined;
  }

  private onMeasurementDrawVertex = (event: any) => {
    if (!this.isMeasurementDrawing) {
      return;
    }

    const layers = Object.values(event?.layers?._layers || {});
    const lastVertex: any = layers[layers.length - 1];
    const latlng = lastVertex?.getLatLng?.();

    if (!latlng) {
      return;
    }

    this.showMeasurementTooltip(latlng);
    this.map.off('mousemove', this.updateMeasurementTooltipPosition);
    this.map.off('touchmove', this.updateMeasurementTooltipPosition);
    this.map.on('mousemove', this.updateMeasurementTooltipPosition);
    this.map.on('touchmove', this.updateMeasurementTooltipPosition);
  };

  private onMeasurementDrawStop = () => {
    this.clearMeasurementInteraction();
  };

  private updateMeasurementTooltipPosition = (event: any) => {
    if (!this.isMeasurementDrawing || !event?.latlng) {
      return;
    }

    this.showMeasurementTooltip(event.latlng);
  };

  private showMeasurementTooltip(latlng: L.LatLng): void {
    if (!this.map) {
      return;
    }

    const mapContainer = this.map.getContainer();
    if (!this.measurementTooltipElement) {
      const tooltipElement = this.renderer.createElement('div');
      tooltipElement.className = 'custom-draw-tooltip-overlay';
      this.renderer.appendChild(mapContainer, tooltipElement);
      this.measurementTooltipElement = tooltipElement;
    }

    const tooltipElement = this.measurementTooltipElement;
    if (!tooltipElement) {
      return;
    }

    const point = this.map.latLngToContainerPoint(latlng);
    tooltipElement.textContent = 'Double click or right click to end measurement.';
    tooltipElement.style.display = 'block';
    tooltipElement.style.left = `${point.x + 14}px`;
    tooltipElement.style.top = `${point.y + 12}px`;
  }

  private removeMeasurementTooltip(): void {
    if (!this.measurementTooltipElement) {
      return;
    }

    this.measurementTooltipElement.style.display = 'none';
  }

  private clearMeasurementInteraction(): void {
    this.isMeasurementDrawing = false;
    this.restoreOverlayPaneAfterMeasurement();
    this.map?.off('mousemove', this.updateMeasurementTooltipPosition);
    this.map?.off('touchmove', this.updateMeasurementTooltipPosition);
    this.map?.off('contextmenu', this.finishMeasurementOnShortcut);
    this.map?.off('dblclick', this.finishMeasurementOnShortcut);
    this.removeMeasurementTooltip();
  }

  private finishMeasurementOnShortcut = (event: any) => {
    if (!this.isMeasurementDrawing) {
      return;
    }

    event?.originalEvent?.preventDefault?.();
    event?.originalEvent?.stopPropagation?.();

    const activeHandler = this.measureDrawControl?._toolbars?.draw?._activeMode?.handler;
    const markers = activeHandler?._markers || [];

    if (!activeHandler || markers.length < 2) {
      return;
    }

    if (typeof activeHandler.completeShape === 'function') {
      activeHandler.completeShape();
    }
  };

  private onMeasurementCreated = (event: any) => {
    if (event.layerType !== 'polyline') {
      return;
    }

    this.clearMeasurementInteraction();
    const layer = event.layer as L.Polyline;
    (layer as any).options = {
      ...(layer as any).options,
      pane: this.measurementPaneName,
    };
    this.measurementLayers.addLayer(layer);
    const totalDistance = this.calculateMeasurementPolylineDistance(layer);
    this.openMeasurementPopup(event, totalDistance / 1000);
  };

  private calculateMeasurementPolylineDistance(polyline: L.Polyline): number {
    const points = polyline.getLatLngs() as L.LatLng[];
    let totalDistance = 0;

    for (let index = 0; index < points.length - 1; index++) {
      totalDistance += points[index].distanceTo(points[index + 1]);
    }

    return totalDistance;
  }

  private openMeasurementPopup(event: any, totalDistance: number): void {
    const popupContent = `<div class="distance-popup">Total Distance : ${Number(
      totalDistance
    ).toFixed(2)} km <button class="closeButton" data-layer-type="${
      event.layerType
    }">Close</button></div>`;
    const latLngs = event.layer.getLatLngs() as L.LatLng[];
    const popupAnchor = latLngs[latLngs.length - 1];

    event.layer
      .bindPopup(popupContent, {
        autoClose: false,
        closeOnClick: false,
        direction: 'auto',
        closeButton: false,
      })
      .addTo(this.map);
    event.layer.off('click');
    event.layer.openPopup(popupAnchor);
  }

  private handleMeasurementPopupOpen = (event: any) => {
    const closeButton = event.popup?._container?.querySelector('.closeButton');
    if (!closeButton) {
      return;
    }

    closeButton.onclick = (clickEvent: MouseEvent) => {
      clickEvent.preventDefault();
      clickEvent.stopPropagation();

      const layerType = closeButton.getAttribute('data-layer-type');
      if (layerType === 'polyline') {
        this.removeMeasurementLayer(event.popup._source);
      }
    };
  };

  private removeMeasurementLayer(layer: any): void {
    if (!layer) {
      return;
    }

    layer.closePopup?.();
    layer.unbindPopup?.();

    const layerId = layer?._leaflet_id;
    const measurementLayer = layerId
      ? this.measurementLayers.getLayer(layerId)
      : null;

    if (measurementLayer) {
      this.measurementLayers.removeLayer(measurementLayer);
    }

    if (this.map?.hasLayer(layer)) {
      this.map.removeLayer(layer);
    }
  }

  private async initializeMap() {
    this.map = L.map(this.mapContainer.nativeElement, {
      zoom: this.zoomLevel,
      maxZoom: 18,
      minZoom: 7,
      layers: [
        environment.enableSentinelBaseMap === 'true' && baseLayers['Sentinel']
          ? baseLayers['Sentinel']
          : baseLayers['Openstreetmap'],
      ],
      attributionControl: false,
      worldCopyJump: true,
      maxBounds: [
      [-90, -180],
      [90, 180]
      ],
      maxBoundsViscosity: 1.0,
    });
    const annotationPane = this.map.getPane('annotationMarkersPane')
      ?? this.map.createPane('annotationMarkersPane');
    annotationPane.style.setProperty('z-index', '100005', 'important');
    this.map.getPane('tooltipPane')!.style.zIndex = '100006';
    this.map.getPane('popupPane')!.style.zIndex = '100007';

    var myAttrControl = L.control.attribution().addTo(this.map);
    myAttrControl.setPrefix('<a href="https://leafletjs.com/">Leaflet</a>');

    L.control
      .layers(baseLayers, overlays, {
        collapsed: false,
        position: 'topright',
      })
      .addTo(this.map);

    this.initializeMeasurementTool();

    const castUser = this.authService.castCurrentUser
      .pipe(take(1))
      .subscribe(
        async (res: any) => {
          this.loadUserDetails(res?.id);
        }
      );

    L.Icon.Default.mergeOptions({
      iconUrl: '../../../assets/map-icons/marker-icon.png',
      iconSize: [25, 41],
      iconAnchor: [12, 41],
      popupAnchor: [1, -34],
      shadowUrl: '../../../assets/map-icons/marker-shadow.png',
      shadowSize: [41, 41],
      shadowAnchor: [12, 41],
    });

    setTimeout(() => {
      const layersControlElement = document.querySelector(
        '.leaflet-control-layers'
      );
      if (layersControlElement) {
        const container = document.getElementsByClassName(
          'leaflet-control-layers-expanded'
        )[0];
        if (container) {
          this.renderer.removeClass(
            container,
            'leaflet-control-layers-expanded'
          );
        }
      }
    }, 0);

    this.map.on('baselayerchange', (event: any) => {
      let layerBtn: any = document.querySelector(
        '.leaflet-control-layers-toggle'
      );
      if (this.layerBtn) {
        this.renderer.removeClass(this.layerBtn, 'highlight-border');
      }
      const container = document.getElementsByClassName(
        'leaflet-control-layers-expanded'
      )[0] as HTMLElement;
      if (container) {
        this.renderer.removeClass(container, 'leaflet-control-layers-expanded');
        document
          .querySelector('.leaflet-control-layers-toggle')
          ?.setAttribute('style', 'top:0px !important'); // Set the style for the layer toggle button
      }
      if (this.homeButton) {
        this.renderer.setStyle(this.homeButton.nativeElement, 'z-index', '500');
      }
      if (event.name === 'Openstreetmap') {
        this.mapFontColor = 'black';
        myAttrControl.setPrefix('<a href="https://leafletjs.com/">Leaflet</a>');
        if (environment.enableSentinelBaseMap === 'true') {
          myAttrControl.removeAttribution(
            '<a href="https://scihub.copernicus.eu/" target="_blank">Copernicus Sentinel data 2020</a>'
          );
        }
        myAttrControl.addAttribution(
          '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a> contributers'
        );
        this.map.setMinZoom(1);
        this.map.setMaxZoom(18);
        if (this.map.getZoom() < 1) {
        this.map.setZoom(1);
        }
        if (this.map.getZoom() > 18) {
        this.map.setZoom(18);
        }    
        if (environment.enableSentinelBaseMap === 'true' && this.map.hasLayer(baseLayers['Sentinel'])) {
          this.map.removeLayer(baseLayers['Sentinel']);
        }
      } else if (environment.enableSentinelBaseMap === 'true') {
        this.mapFontColor = 'white';
        myAttrControl.setPrefix('<a href="https://leafletjs.com/">Leaflet</a>');
        myAttrControl.removeAttribution(
          '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a> contributers'
        );
        myAttrControl.addAttribution(
          '<a href="https://scihub.copernicus.eu/" target="_blank">Copernicus Sentinel data 2020</a>'
        );
        this.map.setMinZoom(7);
        this.map.setMaxZoom(18);
        if (this.map.getZoom() < 7) {
        this.map.setZoom(7);
        }
        if (this.map.getZoom() > 18) {
        this.map.setZoom(18);
       }
      }
    });

    document
      .querySelector('.leaflet-control-layers-toggle')
      ?.addEventListener('click', (e) => {
        let layerBtn: any = document.querySelector(
          '.leaflet-control-layers-toggle'
        );
        layerBtn.classList.add('highlight-border');
        if (document.querySelector('.leaflet-control-layers-expanded')) {
          document
            .querySelector('.leaflet-control-layers-toggle')
            ?.setAttribute('style', 'top:-48px !important');
          if (this.darkTheme) {
            document
              .querySelector('.leaflet-control-layers-expanded')
              ?.setAttribute('style', 'background:black !important');
          } else {
            document
              .querySelector('.leaflet-control-layers-expanded')
              ?.setAttribute('style', 'background:none !important');
          }
          const searchBtnParentEl = document.querySelector(
            '.leaflet-geosearch-button'
          ) as HTMLElement;
          const searchInput = document.querySelector(
            '.leaflet-geosearch-button form input'
          ) as HTMLInputElement;
          if (!searchInput.value && !searchInput.classList.contains('active')) {
            searchBtnParentEl.classList.remove('active');
          }
        }
      });

    this.map.on('click', function () {
      let homeBtn: any = document.querySelector('#homeButton');
      homeBtn.classList.remove('highlight-border');
      let layerBtn: any = document.querySelector(
        '.leaflet-control-layers-toggle'
      );
      layerBtn.classList.remove('highlight-border');
      var controlContainer = document.getElementsByClassName(
        'leaflet-control-layers-expanded'
      )[0];
      if (
        controlContainer &&
        controlContainer.classList.contains('leaflet-control-layers-expanded')
      ) {
        controlContainer.classList.remove('leaflet-control-layers-expanded');
        document
          .querySelector('.leaflet-control-layers-toggle')
          ?.setAttribute('style', 'top:0px !important');
      }
      const searchBtnParentEl = document.querySelector(
        '.leaflet-geosearch-button'
      ) as HTMLElement;
      searchBtnParentEl.classList.remove('active');
    });
    this.map.createPane('left');
    this.map.createPane('right');
    // Sits above 'left'/'right', which get bumped to 451 whenever a cueing
    // sensor tiff/bbox is shown, so the observation's own shape never ends up
    // underneath the imagery it is meant to be checked against.
    this.map.createPane('voyageObservationAreaPane');
    (this.map as any).getPane('voyageObservationAreaPane').style.zIndex = 460;
    this.map.on('baselayerchange', (e: any) => {
      this.map.off('layerremove');
      this.map.off('layeradd');
    });
    this.map.on('layeradd', (e: any) => {});
    this.map.on('layerremove', (e: any) => {
      this.map.off('layerremove');
    });
    const mapContainer: any = document.getElementById('map');
    const zoomDiv = document.getElementById('zoomDiv');
    mapContainer.appendChild(zoomDiv);
    this.map.removeControl(this.map.zoomControl);
    const zoomControl = new L.Control.Zoom({ position: 'bottomright' });
    zoomControl.addTo(this.map);
    this.map.whenReady(() => {
      this.calculateZoomLevel();
    });
    this.map.on('zoomend', this.HandleZoomEnd);
    this.changDetectionRef.detectChanges();
    this.map.getContainer().addEventListener('pointerup', () => {
    this.map.dragging.enable();
    });
    this.map.on('mousemove', (e: any) => {
    const lat = e.latlng.lat;
    const lng = ((e.latlng.lng + 180) % 360 + 360) % 360 - 180;
    });

  }

  HandleZoomEnd = () => {
    this.calculateZoomLevel();
  };

  calculateZoomLevel = () => {
    if (this.map) {
      this.zoomLevel = this.map.getZoom();
      const bounds = this.map.getBounds();
      const distance = bounds.getSouthWest().distanceTo(bounds.getNorthEast());
      this.mapDistance = distance / 1000;
    }
  };

  handleMouseMove = (e: any) => {
  if (this.isCoordinateSearchActive && this.searchedCoordinate) {
    this.latLngDMS = this.decimalToDMS(
      this.searchedCoordinate.lat,
      this.searchedCoordinate.lng
    );
    return;
  }
  const lat = e.latlng.lat;
  const lng = this.normalizeLng(e.latlng.lng); 
    this.latLngDMS = this.decimalToDMS(lat, lng);
  };

  private normalizeLng(lng: number): number {
  return ((lng + 180) % 360 + 360) % 360 - 180;
  }

  handleMouseRightclick = (e: any) => {
    this.isAnnotationSaved = false;
    let scene: any;
    let isInsideAnyFeature = false;
    var isInside = false;
    if (this.annotateClicked && !this.isCompare) {
      let latlng = e.latlng;
      this.annotatedLat = latlng.lat;
      this.annotatedLng = latlng.lng;
      var point = turf.point([latlng.lng, latlng.lat]);
      const isInsideAnyPolygon = this.scenesNew.some((scenesNew) => {
        var polyCoords;
        var polygonFeature;
        if (
          scenesNew?.scene?.operatorKey == this.OPERATOR.LBAND &&
          scenesNew?.scene?.metadata
        ) {
          const features = scenesNew.scene.metadata.features;
          for (const feature of features) {
            const polygonFeature = turf.multiPolygon(
              feature.geometry.coordinates
            );
            if (turf.booleanPointInPolygon(point, polygonFeature)) {
              isInsideAnyFeature = true;
              break;
            }
          }
        } else if (
          scenesNew?.tiffootprint?.toGeoJSON().geometry.coordinates[0].length >
          0
        ) {
          polyCoords = scenesNew?.tiffootprint.toGeoJSON().geometry.coordinates;
          polyCoords[0].push(
            scenesNew?.tiffootprint.toGeoJSON().geometry.coordinates[0][0]
          );
          polygonFeature = turf.polygon(polyCoords);
          isInside = turf.booleanPointInPolygon(point, polygonFeature);
        } else if (
          scenesNew?.footprint?.toGeoJSON().geometry.coordinates[0].length > 0
        ) {
          polyCoords = scenesNew?.footprint.toGeoJSON().geometry.coordinates;
          polyCoords[0].push(
            scenesNew?.footprint.toGeoJSON().geometry.coordinates[0][0]
          );
          polygonFeature = turf.polygon(polyCoords);
          isInside = turf.booleanPointInPolygon(point, polygonFeature);
        } else if (this.scenesNew[0].bboxs?.length > 0) {
          polyCoords =
            scenesNew?.bboxs[0].toGeoJSON()?.features[0].geometry.coordinates;
          polyCoords[0].push(
            scenesNew?.bboxs[0].toGeoJSON()?.features[0].geometry
              .coordinates[0][0]
          );
          polygonFeature = turf.polygon(polyCoords);
          isInside = turf.booleanPointInPolygon(point, polygonFeature);
        } else {
          var polyCoords =
            this.scenesNew[0]?.footprint.toGeoJSON().geometry.coordinates[0];
          polyCoords.push(
            scenesNew?.footprint.toGeoJSON().geometry.coordinates[0][0]
          );
          polygonFeature = turf.polygon([polyCoords]);
          isInside = turf.booleanPointInPolygon(point, polygonFeature);
        }
        if (isInside || isInsideAnyFeature) {
          scene = scenesNew;
          return true;
        }
        return false;
      });

      if (isInsideAnyPolygon) {
        var customIcon = L.icon({
          iconUrl: 'assets/images/notes.png',
          iconSize: [27, 27],
          iconAnchor: [13.5, 13.5],
          popupAnchor: [0, -13],
        });
        let sceneId = scene.id;
        let sensorId = scene.sensorId;
        const uniqueId = `annotation-text-${Date.now()}`;
        const savedContent = this.annotationContent[uniqueId] || '';
        var popupContent = `
          <div style="position: relative; width: 200px;">
            <textarea id="${uniqueId}" value="${uniqueId}" style="width: 100%; height: 90px;  resize: none; margin-top: 6px; margin-bottom: 3px;" onclick="this.setSelectionRange(0, 0);"
                onfocus="this.setSelectionRange(0, 0);">
            </textarea>
            <span style="position: absolute; bottom: 0px; cursor: pointer; color: rgb(182, 182, 186);">
              <i class="material-icons" style="font-size:18px; color: #000000b8" onclick="window.saveAnnotationContent('${uniqueId}', '${sceneId}', '${sensorId}')">save</i>
            </span>
            <div>Lng: ${latlng.lng.toFixed(4)}, Lat: ${latlng.lat.toFixed(
          4
        )}</div>
          </div>
        `;

        if (!this.isAnnotationSaved && this.annotaionMarker) {
          this.map.removeLayer(this.annotaionMarker);
          this.annotaionMarker = null;
        }
        this.annotaionMarker = L.marker(latlng, {
          icon: customIcon,
          pane: 'annotationMarkersPane',
          zIndexOffset: 1000,
        }).addTo(this.map);
        this.annotaionMarker.bindPopup(popupContent).openPopup();
        this.annotaionMarker.on('popupclose', () => {
          if (!this.isAnnotationSaved && this.annotaionMarker) {
            this.map.removeLayer(this.annotaionMarker);
            this.annotaionMarker = null;
          }
        });
      }
      (window as any).saveAnnotationContent =
        this.saveAnnotationContent.bind(this);
    } else if (this.newTaskButtonClicked) {
      var customIcon = L.icon({
        iconUrl: '../../../assets/map-icons/marker-icon.png',
        iconSize: [25, 41],
        iconAnchor: [12, 41],
        popupAnchor: [1, -34],
        shadowUrl: '../../../assets/map-icons/marker-shadow.png',
        shadowSize: [41, 41],
        shadowAnchor: [12, 41],
      });
      let latlng = e.latlng;
      this.collectionTaskMarker = L.marker(latlng, { icon: customIcon }).addTo(
        this.map
      );
      let message = '';
      const dialogRef = this.dialog.open(CreateTaskConfirmDialog, {
        backdropClass: 'blurr',
        disableClose: true,
        data: {
          message: message,
          longitude: ((latlng.lng + 180) % 360 + 360) % 360 - 180,
          latitude: latlng.lat,
          task: this.collection,
          user: this.currentUser,
        },
      });
      dialogRef.afterClosed().subscribe((result) => {
        this.map.removeLayer(this.collectionTaskMarker);
        this.collectionTaskMarker = null;
      });
    }
  };

  saveAnnotationContent(textAreaId: any, sceneId: any, sensorId: any) {
    this.annotationMarkers.push({
      marker: this.annotaionMarker,
      scene: sceneId,
    });
    const textAreaElement: any = document.querySelector(`#${textAreaId}`);
    this.annotationContent = textAreaElement.value;
    if (this.annotationContent) {
      this.isAnnotationSaved = true;
      const annotation = {
        customerid: '',
        taskid: this.collection.taskId,
        sensorid: sensorId,
        sceneid: sceneId,
        property: this.annotationContent,
        lat: this.annotatedLat,
        lng: this.annotatedLng,
      };
      this.apiService.addAnnotation(annotation).subscribe((res: any) => {
        if (res?.msg === 'Success') {
          this.map.closePopup();
          this.getAnnotations();
        }
      });
      this.map.closePopup();
    } else {
      this.isAnnotationSaved = false;
    }
  }

  decimalToDMS(lat: number, lng: number): string {
    const convert = (decimal: number) => {
      const absolute = Math.abs(decimal);
      const degrees = Math.floor(absolute);
      const minutesNotTruncated = (absolute - degrees) * 60;
      const minutes = Math.floor(minutesNotTruncated);
      const seconds = ((minutesNotTruncated - minutes) * 60).toFixed(1);
      return `${degrees}° ${minutes}' ${seconds}"`;
    };
    const latitude = convert(lat) + (lat >= 0 ? ' N' : ' S');
    const longitude = convert(lng) + (lng >= 0 ? ' E' : ' W');
    return `Lng:${longitude}, Lat:${latitude}`;
  }

  removeHighlight() {
    let homeBtn: any = document.querySelector('#homeButton');
    if (homeBtn) {
      homeBtn.classList.remove('highlight-border');
    }
    let layerBtn: any = document.querySelector(
      '.leaflet-control-layers-toggle'
    );
    if (layerBtn) {
      layerBtn.classList.remove('highlight-border');
    }
  }

  viewHome(event: any) {
    this.removeHighlight();
    let layerList: any = document.querySelector(
      '.leaflet-control-layers-expanded'
    );
    if (layerList) {
      layerList.classList.remove('leaflet-control-layers-expanded');
    }
    document
      .querySelector('.leaflet-control-layers-toggle')
      ?.setAttribute('style', 'top:0px !important');
    let homeBtn: any = document.querySelector('#homeButton');
    homeBtn.classList.add('highlight-border');
    // VoyageRadar: home should always fit to the task AOI (the sensor's scene
    // footprint), regardless of whether data was loaded via live refresh,
    // refresh-history, or a per-vessel historical track. These paths do not
    // reliably populate scenesNew, and the sensor's `checked` flag may be false
    // at this point, so match the VoyageRadar sensor directly and return.
    // …but ONLY when Voyage Radar is the whole collection. In a mixed task the
    // generic framing below belongs to the other sensors, and hijacking it here
    // would leave optical/USL/LBAND collections framed on the AIS AOI.
    // The footprint→bounds walk lives on the VR controller (`aoiBounds`), which
    // the load-time framing and the nominatim guard read too — one task has one
    // answer to "where is it", however it is asked.
    const voyageOnly =
      this.collection?.sensors?.length &&
      this.collection.sensors.every(
        (s: any) => s?.operatorKey === OPERATORS.VOYAGERADAR
      );
    if (voyageOnly) {
      const vrBounds = this.voyage.aoiBounds();
      if (vrBounds) {
        this.map.fitBounds(vrBounds);
        event.stopPropagation();
        return;
      }
    }
    if (this.scenesNew.length > 0) {
      if (this.scenesNew[0]?.scene.operatorKey == 'USL') {
        if (this.scenesNew[0]?.scene?.uslFootprint) {
          const geojsonLayer = L.geoJSON(this.scenesNew[0].scene?.uslFootprint);
          this.map.fitBounds(geojsonLayer.getBounds());
        } else {
          const geojsonLayer = L.geoJSON(
            this.scenesNew[0].scene?.usl_footprint
          );
          this.map.fitBounds(geojsonLayer.getBounds());
        }
      } else if (this.scenesNew[0]?.scene.operatorKey == this.OPERATOR.LBAND) {
        this.map.fitBounds(this.scenesNew[0].signalLayers[0].getBounds());
      } else {
        let footprintcordinates = JSON.parse(
          JSON.stringify(
            this.scenesNew[0].scene.footprint.coordinates[0].map((sub) => {
              return [sub[1], sub[0]];
            })
          )
        );
        footprintcordinates.push(footprintcordinates[0]);
        const polygon: any = L.polygon(footprintcordinates).getBounds();
        if (
          this.scenesNew.filter((scnNew) => scnNew.scene?.imageType == 'tif')
            .length > 0
        ) {
          this.map.setMinZoom(1);
          this.map.fitBounds(
            this.scenesNew
              .filter((scnNew) => scnNew.scene?.imageType == 'tif')[0]
              .tiffootprint.getBounds(),
            {
              maxZoom: DEFAULT_ZOOMLEVEL,
            }
          );
          const tiffScene = this.scenesNew.filter(
            (scnNew) => scnNew.scene?.imageType == 'tif'
          )[0];
          this.map.setMaxZoom(
            Number(
              this.calculateZoomFromResolution(
                this.getTiffResolutionSources(tiffScene?.scene, tiffScene?.sensorId)
              )
            )
          );
        } else {
          this.map.fitBounds(polygon);
        }
      }
    } else {
      if (this.clydeAoiFootprintLayer || this.aoiFootprintLayer) {
        let layer =
          this.clydeAoiFootprintLayer || this.aoiFootprintLayer;
        this.map.fitBounds(layer.getBounds());
      } else {
        // Voyage Radar draws no aoiFootprintLayer at all — its target, ring or
        // POI disc alike, lives in the map controller and answers to the sensor
        // checkbox — so zoom-to-target frames the task via aoiBounds(), which
        // also answers before the first pull. Null on non-VR tasks, so the
        // chain below is untouched for everyone else.
        const vrBounds = this.voyage.aoiBounds();
        const wxBounds = this.weatherEx.getTargetBounds();
        if (vrBounds) {
          this.map.fitBounds(vrBounds, { padding: [50, 50] });
        } else if (wxBounds) {
          this.map.fitBounds(wxBounds, { padding: [50, 50] });
        } else {
          const castUser = this.authService.castCurrentUser.subscribe(
            async (res: any) => {
              this.loadUserDetails(res?.id, true);
            }
          );
        }
      }
    }
    event.stopPropagation();
  }

  async getFile(url: string) {
    const httpOptions = { responseType: 'blob' as 'json' };
    const res = await this.httpClient
      .get(url, httpOptions)
      .toPromise()
      .catch((err: HttpErrorResponse) => {
        const error = err.error;
        return error;
      });
    return res;
  }

  async downloadAndZip(url: string): Promise<JSZip> {
    const response = await fetch(url);
    const data = await response.blob();
    const fileName: any = url.split('/').pop();
    const zip = new JSZip();
    zip.file(fileName, data);
    return zip;
  }

  async createZip(zipArray: JSZip[], zipName: string): Promise<void> {
    const zip = new JSZip();
    zipArray.forEach((z) => {
      const files = z.files;
      for (const fileName in files) {
        if (Object.prototype.hasOwnProperty.call(files, fileName)) {
          zip.file(fileName, files[fileName].async('blob'));
        }
      }
    });
    const content = await zip.generateAsync({ type: 'blob' });
    saveAs(content, `${zipName}.zip`);
  }

  createNewTask() {
    this.newTaskButtonClicked = !this.newTaskButtonClicked;
  }

  getAnnotations() {
    let requests: any[] = [];
    for (let scene of this.scenesNew) {
      const request = this.apiService.getAnnotations(
        this.collection.taskId,
        scene.sensorId,
        scene.id
      );
      requests.push(request);
    }

    forkJoin(requests).subscribe((results) => {
      this.removeAnnotationMarkers();
      this.displayAnnotationNew(results);
    });
  }

  annotateImageNew() {
    this.annotateClicked = !this.annotateClicked;
    if (this.annotateClicked) {
      this.getAnnotations();
    } else {
      this.removeAnnotationMarkers();
    }
  }

  displayAnnotationNew(annotations: any[]) {
    annotations.map((annotation) => {
      annotation.data?.features.forEach((feature) => {
        var customIcon = L.icon({
          iconUrl: 'assets/images/notes.png',
          iconSize: [27, 27],
          iconAnchor: [13.5, 13.5],
          popupAnchor: [0, -13],
        });
        let scene: any = this.scenesNew.filter(
          (sceneNew) => sceneNew.id == annotation.data.sceneid
        )[0];
        let sceneId = annotation.data.sceneid;
        let sensorId = annotation.data.sensorid;
        let text = feature.property;
        let featureId = feature._id;
        const uniqueId = `annotation-text-${Date.now()}`;
        var popupContent;

        if (this.isCompare) {
          popupContent = `
          <div style="position: relative; width: 200px;">
              <textarea id="${uniqueId}" style="width: 100%; height: 90px;  resize: none; margin-top: 6px; margin-bottom: 3px;" disabled>${text}</textarea>
              <div>Lng: ${feature.coordinates.longitude.toFixed(
                4
              )}, Lat: ${feature.coordinates.latitude.toFixed(4)}</div>
          </div>
        `;
        } else {
          popupContent = `
          <div style="position: relative; width: 200px;">
              <textarea id="${uniqueId}" style="width: 100%; height: 90px;  resize: none; margin-top: 6px; margin-bottom: 3px;" disabled>${text}</textarea>
              <span id="saveIcon" style="position: absolute; bottom: 0px; cursor: pointer; color: rgb(182, 182, 186); right: 10px;">
                <i class="material-icons" id="edit-save-button" style="font-size:18px;color: #000000b8" onclick="window.editAnnotationContent('${uniqueId}', '${sceneId}', '${sensorId}', '${featureId}')">edit</i>
              </span>
              <span style="position: absolute; bottom: 0px; cursor: pointer; color: rgb(182, 182, 186);" id="deleteIcon">
                <i class="material-icons" id="edit-save-button" style="font-size:18px;color: #000000b8" onclick="window.deleteAnnotationContent('${uniqueId}', '${sceneId}', '${sensorId}', '${featureId}')">delete</i>
              </span>
              
              <div>Lng: ${feature.coordinates.longitude.toFixed(
                4
              )}, Lat: ${feature.coordinates.latitude.toFixed(4)}5</div>
          </div>
        `;
        }

        (window as any).editAnnotationContent =
          this.editAnnotationContent.bind(this);
        (window as any).deleteAnnotationContent =
          this.deleteAnnotationContent.bind(this);

        const popupOffset: any = [0, 20];
        let annotaionMarker = L.marker(
          [feature.coordinates.latitude, feature.coordinates.longitude],
          {
            icon: customIcon,
            pane: 'annotationMarkersPane',
            zIndexOffset: 1000,
          }
        )
          .bindPopup(popupContent, { offset: popupOffset })
          .addTo(this.map);

        this.annotationMarkers.push({
          marker: annotaionMarker,
          scene: sceneId,
        });
      });
    });
  }

  editAnnotationContent(textAreaId, sceneId, sensorId, featureId) {
    const textarea = document.getElementById(textAreaId) as HTMLTextAreaElement;
    const buttonIcon = document.getElementById(
      'edit-save-button'
    ) as HTMLElement;
    this.isTextareaDisabled = true;
    this.isTextareaDisabled = !this.isTextareaDisabled;
    if (buttonIcon.textContent != 'save') {
      textarea.disabled = false;
      buttonIcon.textContent = 'save';
      const textAreaElement: any = document.querySelector(`#${textAreaId}`);
      this.annotationContent = textAreaElement.value;
      document
        .getElementById('deleteIcon')
        ?.setAttribute('style', 'display: none !important');
      const saveIcon = document.getElementById('saveIcon');
      if (saveIcon) {
        saveIcon.style.right = 'auto';
      }
      textarea.addEventListener('focus', () => {
        const len = textarea.value.length - 12;
        textarea.setSelectionRange(len, len);
      });

      textarea.addEventListener('click', () => {
        const len = textarea.value.length - 12;
        textarea.setSelectionRange(len, len);
      });
    } else {
      const textAreaElement: any = document.querySelector(`#${textAreaId}`);
      this.annotationContent = textAreaElement.value;
      let updateObj = {
        customerid: '',
        taskid: this.collection.taskId,
        sensorid: sensorId,
        sceneid: sceneId,
        featureid: featureId,
        property: this.annotationContent,
      };
      this.apiService.editAnnotations(updateObj).subscribe((res: any) => {
        if (res?.msg === 'Success') {
          this.map.closePopup();
          this.getAnnotations();
        }
      });
      this.isTextareaDisabled = true;
    }
  }

  deleteAnnotationContent(textAreaId, sceneId, sensorId, featureId) {
    let deleteObj = {
      customerid: '',
      taskid: this.collection.taskId,
      sensorid: sensorId,
      sceneid: sceneId,
      featureid: featureId,
    };
    this.apiService.deleteAnnotations(deleteObj).subscribe((res: any) => {
      if (res?.msg === 'Success') {
        this.map.closePopup();
        this.getAnnotations();
      }
    });
  }

  getVesselsGeojson(geoJSONdata, customIcon, isHistorical, sensor, type) {
    return L.geoJSON(geoJSONdata, {
      pointToLayer: (feature, latlng) => {
        if (type === 'SPIRE' || type === 'VOYAGERADAR') {
          const icon = this.makeNavIconFromFeature(feature);
          return L.marker(latlng, {
            icon,
            zIndexOffset: 100000,
            riseOnHover: true,
            opacity: 1,
          });
        }
        return L.marker(latlng, { icon: customIcon });
      },
      onEachFeature: (ftr, lyr) => {
        const iconOpts = (lyr as any)?.options?.icon?.options;
        const iconW = iconOpts?.iconSize?.[0] ?? 24;
        const offsetX = Math.round(iconW / 2 + 6);
        if (type === 'VOYAGERADAR') {
          // Track mode: the popup IS the launcher (info + trace actions), and
          // the click selects the vessel. No modal, no historical-fetch dialog.
          lyr.bindPopup(
            () => buildVesselPopup(
              ftr.properties,
              this.voyage.popupOptsFor(String(ftr.properties?.['MMSI'] ?? ftr.properties?.mmsi ?? '')),
            ),
            {
              className: 'ais-vessel-popup',
              closeButton: false,
              offset: L.point(0, -6),
              autoPanPadding: L.point(40, 90),
            },
          );
          lyr.on('click', () => this.voyage.activateVessel(ftr.properties, lyr));
          return;
        }
        {
          this.attachTooltip(
            lyr,
            `<span style="text-transform: capitalize;">
              ${this.formatProperties(ftr.properties)}
          </span>`
          );
        }
        {
          sensor?.noOfHistoricalData != '' &&
            lyr.on('click', () => {
              this.clickedMarker = lyr;
              if (this.clickedMarker) this.clickedMarker.closeTooltip();
              this.handleLayerClick(
                ftr,
                isHistorical,
                sensor,
                this.clickedMarker
              );
            });
        }

        if (type === 'CLYDE') {
          this.clydeHistoricalLayer.push({
            marker: lyr,
            type: type,
          });
        } else {
          this.spireHistoricalLayer.push({
            marker: lyr,
            type: type,
          });
        }
      },
    }).addTo(this.map);
  }

  private makeNavIconFromFeature(ftr: any, history?: any): L.Icon {
    const baseSize = 50;
    const histSize = 24;
    const size = history === 'historySpire' ? histSize : baseSize;
    const shipType = ftr?.properties?.['Ship Type'] ?? 'OTHER';
    const course = Number(ftr?.properties?.['Course']) || 0;
    const color =
      history === 'historySpire'
        ? '#99BF00'
        : ftr?.properties?.['Color'] ?? this.utilsService.getShipColor(shipType);

    const canvas = this.createNavigationIconSpire(color, course, history);
    return L.icon({
      iconUrl: canvas.toDataURL(),
      iconSize: [size, size],
      iconAnchor: [25, 25], // center
      popupAnchor: [0, -25],
    });
  }

  /**
   * Draws a freshly pulled set of AIS vessels — ClydeSpace, Spire OR Voyage
   * Radar, chosen by `type`. It also builds the AOI outline and populates
   * `vesselJsonData` / `displayedVesselData` / `vesselSensorId`, all three of
   * which every operator here writes.
   *
   * Was `displayClydeAISNew`. Anything changed here lands on three operators —
   * branch on `type` (or `sensor.operatorKey`) for anything that must not.
   */
  displayVesselSnapshot(scene: any, data: any, sensor: any, type: any, res?: any) {
    let sensorId = sensor.id;
    let ischangerefreshes = data?.ischangerefreshes === true;
    if (type == 'SPIRE' && ischangerefreshes == false) {
      this.collection.sensors.map((sensor) => {
        if (sensor.operatorKey === OPERATORS.SPIRE) {
          if (sensor.updatedRefreshes) sensor.updatedRefreshes -= 1;
          else sensor.updatedRefreshes = sensor.noOfRefreshes - 1;
        }
      });
    }
    let footprintcordinates: any[] = [];
    let isHistorical = sensor?.isHistorical;
    // A Voyage Radar POI pull never reaches this renderer (its list draws as
    // the target popup — see the POI branch in fetchAISDataFromServer), so the
    // footprint here is always a ring.
    footprintcordinates = scene?.footprint?.coordinates[0].map((sub) => {
      return [sub[1], sub[0]];
    });

    if (type == 'CLYDE' && !this.clydeAoiFootprintLayer) {
      this.clydeAoiFootprintLayer = L.polygon(footprintcordinates, {
        color: 'yellow',
        fillColor: 'none',
        pane: 'left',
      }).addTo(this.map);
    } else if (type == 'SPIRE' && !this.aoiFootprintLayer) {
      this.aoiFootprintLayer = L.polygon(footprintcordinates, {
        color: 'yellow',
        fillColor: 'none',
        pane: 'left',
      }).addTo(this.map);
    }
    // VOYAGERADAR draws no ring here. Its target belongs to the sensor
    // checkbox, not to this pull — `voyage.showTarget()` has already drawn the
    // same ring from the same footprint, and it outlives the vessels. Building
    // a second one here would put an identical polygon over it whose life ended
    // with `removeVesselLayer()`, which is what made the target come and go.
    if (type == 'VOYAGERADAR') this.voyage.showTarget();
    let geoJSONdata: any = this.convertToGeoJSONNew(data, type);
    if (this.isObservation(sensor)) {
      this.observationChecked = true;
      this.selectedHistory[res.newRefreshHistory.refreshId] = geoJSONdata;
    }

    if (res) {
      const sensorIndex = this.collection.sensors.findIndex(
        (sensor) => sensor.id === sensorId
      );
      if (sensorIndex !== -1) {
        if (!sensor.refreshHistory) {
          sensor.refreshHistory = []; // Initialize if not present
        }
        sensor.refreshHistory.push(res?.newRefreshHistory);
      }
    }

    this.vesselJsonData = JSON.parse(JSON.stringify(geoJSONdata));
    this.displayedVesselData = geoJSONdata;
    this.vesselSensorId = sensor?.id;
    var customIcon = L.icon({
      iconUrl:
        type == 'SPIRE'
          ? 'assets/images/yellow-cross.png'
          : 'assets/images/orange-cross.png',
      iconSize: [23, 23],
      iconAnchor: [16, 23],
      popupAnchor: [0, -32],
    });

    if (type == 'CLYDE') {
      this.clydeVesselLayer = this.getVesselsGeojson(
        geoJSONdata,
        customIcon,
        isHistorical,
        sensor,
        type
      );
    } else {
      this.aisVesselLayer = this.getVesselsGeojson(
        geoJSONdata,
        null,
        isHistorical,
        sensor,
        type
      );
    }

    if (this.clydeAoiFootprintLayer) {
      this.map.fitBounds(this.clydeAoiFootprintLayer.getBounds());
    } else if (this.aoiFootprintLayer) {
      this.map.fitBounds(this.aoiFootprintLayer.getBounds());
    } else if (type == 'VOYAGERADAR') {
      // No `aoiFootprintLayer` on a VR-only task any more — the same ring is the
      // controller's target layer, so the pull frames exactly what it used to.
      // (In a MIXED task the branch above still wins, unchanged: that layer
      // belongs to the Spire sensor sitting next to this one.)
      const vrBounds = this.voyage.targetBounds() ?? this.voyage.aoiBounds();
      if (vrBounds) this.map.fitBounds(vrBounds);
    }
    let index = this.scenesNew.findIndex(
      (scenesNew) => scenesNew.id == scene.id
    );
    if (index == -1) {
      this.scenesNew.push({
        // VOYAGERADAR gets a DETACHED polygon — built from the same ring, never
        // added to the map. This field is read as geometry (`toGeoJSON` for the
        // annotate hit-test, `getBounds` for framing), and one of those readers
        // has an unguarded fallback, so null is not an option. It also must not
        // be the drawn target: the scene sweeps (`removeLayerByScene`) remove
        // whatever is here, and the target answers to the checkbox alone. A
        // removeLayer on a layer that was never added is a no-op, so those
        // sweeps stay correct and the target stays up.
        footprint:
          type == 'CLYDE'
            ? this.clydeAoiFootprintLayer
            : type == 'VOYAGERADAR'
            ? L.polygon(footprintcordinates)
            : this.aoiFootprintLayer,
        id: scene.id,
        scene: scene,
        sensorId: sensor?.id,
        pane: this.mapPane,
      });
    }

    if (type === 'VOYAGERADAR') {
      // Live VoyageRadar data is on the map — hand the layer to the controller,
      // which lights up the on-map toolbar and seeds the type-filter categories.
      let features = Array.isArray(data?.features)
        ? data.features
        : Array.isArray(data)
        ? data
        : [];
      // A pull made while OBSERVATIONS owns the map answers the observation with
      // fresher data — so it stays in observations mode and lands filtered,
      // rather than silently handing the map back to the archive. Pruned on the
      // built layer (the shared `getVesselsGeojson` created it before this
      // branch is reached) and the unfiltered set kept for the section's counts.
      if (this.voyageMapSource === 'observations') {
        this.voyageObservationSource = features;
        features = this.pruneVoyageLayerToObservations(this.aisVesselLayer, sensor, features);
      }
      this.voyage.adoptLiveLayer(this.aisVesselLayer, features);
      // Live pull just landed — stamp the toolbar's "Updated …" clock with now.
      this.playback.markUpdated();

      // A fresh pull IS the newest refresh-history snapshot, so it goes through
      // the same single-select state as a history pick: whatever snapshot was
      // drawn before comes off (the sweep also removes the PREVIOUS pull's
      // layer — tagged below — which this path never used to clean up), the new
      // layer is tagged so clear/step can find it, and the ON MAP bar flashes.
      // Order matters: the new layer is still untagged during the sweep, so the
      // sweep cannot touch it.
      const pulledRefreshId = res?.newRefreshHistory?.refreshId ?? null;
      // A pull replaces what is drawn rather than emptying the map, so the
      // vessel-type selection survives it — `adoptLiveLayer` above has already
      // re-applied it to the layer that just landed.
      this.clearVoyageSnapshot(false);
      if (pulledRefreshId && this.aisVesselLayer) {
        (this.aisVesselLayer as any).refreshId = pulledRefreshId;
        this.voyageActiveRefreshId = pulledRefreshId;
        this._flashVoyageSnapshot(pulledRefreshId);
      }
    }
  }

  groupVesselsByDateRange(dateRangeArray: string[]) {
    this.vesselData = {};
    this.sliderShow = true;
    for (let i = 0; i < dateRangeArray.length - 1; i++) {
      const startDate = new Date(dateRangeArray[i]);
      const endDate = new Date(dateRangeArray[i + 1]);
      this.vesselData[dateRangeArray[i]] = this.historicalVesselData.filter(
        (data) => {
          const dataDate = new Date(data.timestamp);
          return dataDate >= startDate && dataDate < endDate;
        }
      );
    }
    const lastDate = new Date(dateRangeArray[dateRangeArray.length - 1]);
    this.vesselData[dateRangeArray[dateRangeArray.length - 1]] =
      this.historicalVesselData.filter((data) => {
        const dataDate = new Date(data.timestamp);
        return dataDate >= lastDate;
      });

    this.dateRangeArray = dateRangeArray.reverse();
  }

  handleLayerClick(
    entity: any,
    isHistorical: any,
    sensor: any,
    clickedMarker: any
  ) {
    // Voyage Radar no longer uses the duration modal / per-day marker slider —
    // vessel clicks go through track mode (voyage.activateVessel + the popup's
    // action footer). Hard stop here so no residual caller can reopen the modal.
    if (sensor?.operatorKey === OPERATORS.VOYAGERADAR) return;
    let historicalFetchCount: any;
    let type;
    if (sensor?.operatorKey === OPERATORS.SPIRE) {
      historicalFetchCount =
        sensor?.updatedFetches == 0
          ? 0
          : sensor?.updatedFetches || sensor?.noOfHistoricalData;
      type = 'ais';
    } else {
      historicalFetchCount = sensor?.noOfHistoricalData;
      type = 'clyde';
    }
    if (historicalFetchCount > 0) {
      const dialogRef = this.matdialog.open(FilterPopupComponent, {
        width: '35%',
        backdropClass: 'blurr',
        disableClose: true,
        data: {
          type: type,
          historicalDays: historicalFetchCount,
          isVessel: this.isVesselInfoService(sensor.InfoServices),
        },
      });

      dialogRef.afterClosed().subscribe((result) => {
        if (this.clickedMarker) this.clickedMarker.closeTooltip();
        let timestamp = entity.properties['Timestamp UTC'];
        let mmsi = entity.properties['MMSI'];
        let courseValue = entity.properties['Course'];
        let compassDirection =
          this.utilsService.getCompassDirection(courseValue);
        const shipType = entity.properties['Ship Type'] || 'OTHER';
        const iconColor = this.utilsService.getShipColor(shipType);
        this.shipColor = iconColor;
        let vesselName = entity?.properties.Name;
        let taskId = this.collection?.taskId;
        this.predictedVesselData = {
          color: iconColor,
          lng: entity.properties.Lng,
          lat: entity.properties.Lat,
          timestamp: timestamp,
        };
        this.prediction = result?.type === STRINGCONSTANTS.PREDICTION;

        if (result) {
          // Only show the map spinner once the user has actually chosen a
          // period — setting it before this guard left it stuck on Cancel.
          this.mapLoad = true;
          if (sensor?.operatorKey === OPERATORS.CLYDE) {
            this.spinnerService.show();
            let endDate: any = new Date(timestamp);
            let startDate: any;
            if (result?.type === 'minutes') {
              const millisecondsBack = result?.duration * 60 * 1000;
              const newDateObj = new Date(endDate - millisecondsBack);
              startDate = newDateObj.toISOString();
            } else {
              const previousDate = endDate;
              previousDate.setDate(endDate.getDate() - (result?.duration - 1));
              startDate = previousDate.toDateString();
            }
            this.clydeHistoricalLayer.forEach((innerLayer: any) => {
              if (innerLayer.marker !== clickedMarker) {
                innerLayer.marker.setOpacity(0);
              }
            });
            let vesselObject = {
              mmsi: mmsi,
              endTime: timestamp,
              inputMinutes: result?.duration,
              eeTaskId: taskId,
              startTime: startDate,
              polygon: this.vesselPolygon,
              startTimeType: result?.type,
              duration: result?.duration,
            };
            const sliderStart = new Date(timestamp);
            const sliderEnd = new Date(startDate);
            const differenceInMilliseconds =
              sliderStart.getTime() - sliderEnd.getTime();
            const differenceInDays =
              differenceInMilliseconds / (1000 * 60 * 60 * 24);
            if (this.clickedMarker) this.clickedMarker.closeTooltip();
            this.apiService
              .getClydeHistoricalData(vesselObject)
              .subscribe((response: any) => {
                this.spinnerService.hide();
                this.mapLoad = false;
                if (response?.data?.length > 0) {
                  if (this.clickedAIS) {
                    this.resetSelectedVessels(false);
                  }
                  this.clickedAIS = sensor;
                  this.sliderView = false;
                  this.currentHistoryIndex = 0;
                  this.previousIndex = -1;
                  if (!this.timeseries) {
                    this.resetTimeSeries();
                  } else {
                    this.sliderDateRangeArray = [];
                  }
                  this.isClydeHistorical = true;
                  this.historicalVesselData = response?.data;
                  let dateRangeArray = this.generateSliderDateRange(
                    timestamp,
                    startDate
                  );
                  if (differenceInDays <= 10)
                    this.groupVesselsByDate(dateRangeArray, compassDirection);
                  else this.groupVesselsByDateRange(dateRangeArray);
                  this.sliderView = true;
                  this.clydeHistoricalLayer.forEach((innerLayer: any) => {
                    if (innerLayer.marker !== clickedMarker) {
                      this.map.removeLayer(innerLayer.marker);
                    }
                  });
                } else {
                  const message = `There are no vessels in the duration requested. Please change the historical period to try again.`;
                  this.popupService.openPopup(
                    CollectionPopupComponent,
                    message,
                    '',
                    '40%'
                  );
                  this.clydeHistoricalLayer.forEach((innerLayer: any) => {
                    if (innerLayer.marker !== clickedMarker) {
                      innerLayer.marker.setOpacity(1);
                    }
                  });
                  this.resetSelectedVessels(true);
                }
              });
          } else if (result.type === 'history') {
            this.spinnerService.show();
            this.spireHistoricalLayer.forEach((innerLayer: any) => {
              if (innerLayer.marker !== clickedMarker) {
                innerLayer.marker.setOpacity(0);
              }
            });
            let endDate: any = new Date(timestamp);
            let startDate: any;
            const millisecondsBack = result?.duration * 60 * 1000;
            const newDateObj = new Date(endDate - millisecondsBack);
            startDate = newDateObj.toISOString();
            let vesselObject = {
              mmsi: mmsi,
              endTime: timestamp,
              inputMinutes: result?.duration,
              eeTaskId: this.collection.taskId,
              compassDirection: compassDirection,
              fetchType: result.type,
            };

            const sliderStart = new Date(timestamp);
            const sliderEnd = new Date(startDate);
            const differenceInMilliseconds =
              sliderStart.getTime() - sliderEnd.getTime();
            const differenceInDays =
              differenceInMilliseconds / (1000 * 60 * 60 * 24);
            this.apiService
              .getHistoricalData(vesselObject)
              .subscribe((response: any) => {
                this.spinnerService.hide();
                this.mapLoad = false;
                if (response?.data?.length > 0) {
                  if (this.clickedAIS) {
                    this.resetSelectedVessels(false, true, true);
                  }
                  this.clickedAIS = sensor;
                  this.sliderView = false;
                  this.currentHistoryIndex = 0;
                  this.previousIndex = -1;
                  if (!this.timeseries) {
                    this.resetTimeSeries();
                  } else {
                    this.sliderDateRangeArray = [];
                  }
                  this.isClydeHistorical = true;
                  this.collection.sensors.map((sensor) => {
                    if (sensor.operatorKey === OPERATORS.SPIRE) {
                      if (sensor.updatedFetches) sensor.updatedFetches -= 1;
                      else
                        sensor.updatedFetches = sensor.noOfHistoricalData - 1;
                    }
                  });
                  this.sliderView = true;
                  this.historicalVesselData = response?.data;
                  let dateRangeArray = this.generateSliderDateRange(
                    timestamp,
                    startDate
                  );
                  this.groupVesselsByDate(dateRangeArray, compassDirection);
                  this.sliderView = true;
                  this.spireHistoricalLayer.forEach((innerLayer: any) => {
                    if (innerLayer.marker !== clickedMarker) {
                      this.map.removeLayer(innerLayer.marker);
                    }
                  });
                } else {
                  const message = `There are no vessels in the duration requested. Please change the historical period to try again.`;
                  this.popupService.openPopup(
                    CollectionPopupComponent,
                    message,
                    '',
                    '40%'
                  );
                  this.spireHistoricalLayer.forEach((innerLayer: any) => {
                    if (innerLayer.marker !== clickedMarker) {
                      innerLayer.marker.setOpacity(1);
                    }
                  });
                  this.resetSelectedVessels(true, false);
                }
              });
          } else if (result.type === STRINGCONSTANTS.PREDICTION) {
            let vesselId = entity.properties.ID;
            const selectedVesselJson = this.spireData?.vessels?.nodes.find(
              (item) => item.id === vesselId
            );
            this.progressing = true;
            if (this.clickedMarker) this.clickedMarker.closeTooltip();
            this.spireHistoricalLayer.forEach((innerLayer: any) => {
              if (innerLayer.marker !== clickedMarker) {
                innerLayer.marker.setOpacity(0);
              }
            });

            let predictedObject = {
              fetchType: result.type,
              feedId: sensor.InfoServices[0]._id,
              sensorId: sensor.InfoServices[0].sensorId,
              timestamp: timestamp,
              mmsi: mmsi,
              eeTaskId: taskId,
              endTime: timestamp,
              vesselName: vesselName,
              selectedVesselJson: selectedVesselJson,
            };
            const abort$ = this.opManager.startOperation();
            this.predictionSubscription = this.apiService
              .getPredictionData(predictedObject)
              .pipe(takeUntil(abort$))
              .subscribe((response: any) => {
                this.prediction = true;
                if (this.clickedMarker) this.clickedMarker.closeTooltip();
                if (response.msg === 'success') {
                  if (response?.data?.vessel_predict?.length > 0) {
                    //Remove last known vessel location from vessel_predict array
                    response.data.vessel_predict =
                      response?.data?.vessel_predict?.slice(1);
                    this.clickedAIS = sensor;
                    this.sliderView = false;
                    this.currentHistoryIndex = 0;
                    this.previousIndex = -1;
                    if (!this.timeseries) {
                      this.resetTimeSeries();
                    } else {
                      this.sliderDateRangeArray = [];
                    }
                    this.collection.sensors.map((sensor) => {
                      if (sensor.operatorKey === OPERATORS.SPIRE) {
                        if (sensor.updatedFetches) sensor.updatedFetches -= 1;
                        else
                          sensor.updatedFetches = sensor.noOfHistoricalData - 1;
                      }
                    });
                    this.historicalVesselData = response?.data?.vessel_predict;
                    if(Object.keys(response?.data?.feed_results || {})?.length > 0){
                    const formattedPrediction = {
                    locations: this.historicalVesselData.length + 2,
                    location_time: response?.data?.feed_results.location_after_one_hour.location_time,
                    location: {
                    LAT: response?.data?.feed_results?.location_after_one_hour?.location?.LAT,
                    LON: response?.data?.feed_results?.location_after_one_hour?.location?.LON
                     }
                    };
                    this.historicalVesselData.push(formattedPrediction);
                     }
                    const startTime =
                      this.historicalVesselData[0].location_time;
                    const endTime =
                      this.historicalVesselData[
                        this.historicalVesselData.length - 1
                      ].location_time;
                    let dateRangeArray = this.generateSliderDateRangePredict(
                      endTime,
                      startTime
                    );
                    this.groupVesselsByDatePredict(dateRangeArray);
                    this.sliderView = true;
                    this.progressing = false;
                    this.sliderView = false;
                    const feedId = String(sensor.InfoServices[0]?._id);
                    const config = feedsConfig[feedId];
                    const color = 'Yellowgreen';
                    const vm = this.helperService.buildFeedSections(config, response?.data?.feed_results, color);
                    const title = this.feedTitleOf(config, sensor.InfoServices[0]?.feedName || sensor.InfoServices[0]?.name);
                    this.addFeedPanel(sensor.InfoServices[0]?._id, title, color, vm.sections);
                    this.spinnerService.hide();
                    this.opManager.completeOperation();
                  } else {
                    const message = `There are no vessel location(s) predicted because of a lack of sufficient historical data.`;
                    this.popupService.openPopup(
                      CollectionPopupComponent,
                      message,
                      '',
                      '40%'
                    );
                    this.spinnerService.hide();
                    this.progressing = false;
                    this.resetSelectedVessels(false, false);
                    this.clearAllPredictionData();
                    this.opManager.completeOperation();
                    this.spireHistoricalLayer.forEach((innerLayer: any) => {
                      innerLayer.marker.setOpacity(1);
                    });
                  }
                } else {
                  if (response?.msg) {
                    const message = response?.msg;
                    this.popupService.openPopup(
                      CollectionPopupComponent,
                      message,
                      '',
                      '40%'
                    );
                    this.spinnerService.hide();
                    this.progressing = false;
                    this.resetSelectedVessels(true, false);
                    this.clearAllPredictionData();
                    this.spireHistoricalLayer.forEach((innerLayer: any) => {
                      if (innerLayer.marker !== clickedMarker) {
                        innerLayer.marker.setOpacity(1);
                      }
                    });
                  } else {
                    const message = `An error occurred during processing and ingestion of the request. Please try after sometime.`;
                    this.popupService.openPopup(
                      CollectionPopupComponent,
                      message,
                      '',
                      '40%'
                    );
                    this.spinnerService.hide();
                    this.progressing = false;
                    this.resetSelectedVessels(true, false);
                    this.clearAllPredictionData();
                    this.spireHistoricalLayer.forEach((innerLayer: any) => {
                      if (innerLayer.marker !== clickedMarker) {
                        innerLayer.marker.setOpacity(1);
                      }
                    });
                  }
                  this.opManager.completeOperation();
                }
              });
          }
        }
      });
    } else if (sensor.operatorKey === OPERATORS.SPIRE) {
      const message = `Your historical fetches for this task has been exhausted. Please retask.`;
      this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
    }
    this.progressing = false;
  }

  async downloadPastPredicitionList(
    predictedId: any,
    date: any,
    type: any,
    sensor: any,
    scene: any
  ) {
    const sensorId = sensor.id;
    const taskId = this.collection?.taskId;

    const predictData = {
      sensorId,
      predictionId: predictedId,
      taskid: taskId,
      action: type,
    };

    this.freeze = true;
    this.spinnerService.show();

    try {
      const res: any = await firstValueFrom(
        this.apiService.getPastPredictedData(predictData).pipe(takeUntil(this.destroy$))
      );

      if (res?.msg === 'failed') {
        this.popupService.openPopup(
          CollectionPopupComponent,
          'An error occurred during processing and ingestion of the request. Please try after sometime.',
          '',
          '40%'
        );
        this.mapLoad = false;
        return;
      }

      const fileName = res.result.imageUrl.split('/').pop().split('?')[0];
      const downloadTarget = await this.resolveDownloadTarget(fileName);
      if (!downloadTarget) {
        this.resetDownload();
        return;
      }

      const parsed = await firstValueFrom(
        this.httpClient.get(res?.result?.imageUrl).pipe(takeUntil(this.destroy$))
      );

      const sensorObj = {
        progress: 100,
        taskId,
        sensorId,
        sceneId: sensor.scenes[0].id,
        download: true,
        action: 'aisDownload',
      };
      this.downloadService.setProgress(sensorObj);

      const blob = new Blob([JSON.stringify(parsed)], {
        type: 'application/json',
      });
      const saveResult = await this.downloadService.saveBlob(
        blob,
        fileName,
        downloadTarget
      );

      if (saveResult.status === 'cancelled') {
        this.resetDownload();
        return;
      }

      if (saveResult.status !== 'saved') {
        this.popupService.openPopup(
          CollectionPopupComponent,
          saveResult.message,
          '',
          '40%'
        );
        this.resetDownload();
        return;
      }
    } catch (error) {
      this.popupService.openPopup(
        CollectionPopupComponent,
        'An error occurred during processing and ingestion of the request. Please try after sometime.',
        '',
        '40%'
      );
    } finally {
      this.spinnerService.hide();
      this.freeze = false;
      this.disable = false;
    }
  }

  displayPastPredicitionList(predictedId, date, type, sensor, scene) {
    this.resetAllFeedPanels();
    this.clearAllPredictionData();
    this.clearFilteredLayerAndRestore(true);
    this.sliderShow = false;
    if (this.clickedMarker) this.map.removeLayer(this.clickedMarker);
    this.predictedVesselData = null;
    this.progressing = false;
    this.prediction = false;
    this.spinnerService.show();
    this.mapLoad = true;
    this.previousIndex = -1;
    this.predictionLastPoint = null;
    if (this.selectedPredictionId === predictedId) {
      this.selectedPredictionId = null;
      this.spinnerService.hide();
      this.mapLoad = false;
      this.freeze = false;
      this.map.setView([15.0, 68.0], 5);
      return;
    }

    this.selectedPredictionId = predictedId;
    let sensorId = sensor.id;
    let taskId = this.collection?.taskId;
    const predictData = {
      sensorId: sensorId,
      predictionId: predictedId,
      taskid: taskId,
      action: type,
    };
    this.apiService
      .getPastPredictedData(predictData)
      .pipe(
        takeUntil(this.destroy$),
        switchMap((res: any) => {
          if (res?.msg === 'failed') {
            const message =
              'An error occurred during processing and ingestion of the request. Please try after sometime.';
            this.popupService.openPopup(
              CollectionPopupComponent,
              message,
              '',
              '40%'
            );
            this.spinnerService.hide();
            this.mapLoad = false;
            this.freeze = false;
            return EMPTY;
          }
          const imageUrl = res?.result?.imageUrl;
          if (!imageUrl) return EMPTY;
          return this.httpClient.get<any>(imageUrl);
        })
      )
      .subscribe((data) => {
        this.map.setView([0, 80], 4);
        this.mapLoad = false;
        this.freeze = false;
        this.sliderView = true;

        const parsedData = JSON.parse(data);
        this.pastpreditedVesselData = parsedData.vessel_predict[0];

        const result = parsedData?.vessel_predict;

        //Fiest element is last known location, so we skip it
        if (type === 'display' && result?.length > 1) {
          const startTime = result[0].location_time;
          const endTime = result[result.length - 1].location_time;

          let dateRangeArray = this.generateSliderDateRangePredict(
            endTime,
            startTime
          );
          this.groupVesselsByDatePredict(dateRangeArray, result);
          this.pastPrediction = true;
        }
      });
  }

  getGroupedVessels(sensor, taskId) {
    let getVessels =
      this.taskid === taskId &&
      sensor.pastPrediction &&
      Object.keys(sensor.pastPrediction).length > 0 &&
      this.isVesselInfoService(sensor.InfoServices);
    if (getVessels) {
      this.groupedVessels = sensor.pastPrediction;
      return true;
    } else {
      this.groupedVessels = {};
      return false;
    }
  }
  isFeedBased(InfoService, iconType?:any) {
    if (InfoService?.ais_observation || InfoService?.rf_observation) {
      return false;
    }

    if (InfoService?.thermal_observation === true && InfoService?.data_type === 'area' && iconType === 'download') {
      return true;
    }

    if (InfoService?.thermal_observation === true) {
      return false;
    }

    return true;
  }
  isVesselInfoService(infoService: any[]): boolean {
    if (infoService?.length > 0 && infoService[0]?._id) {
      const config = feedsConfig[infoService[0]._id];
      if (config && config.type === VESSEL_PREDICTION) {
        return true;
      }
    }
    return false;
  }

  /**
   * Get active feeds from sensor - uses InfoServices if available, otherwise returns AssociatedFeeds
   * @param sensor The sensor object containing InfoServices and AssociatedFeeds
   * @returns Array of feeds to display
   */
  getActiveFeedsForSensor(sensor: any): any[] {
    if (Array.isArray(sensor?.InfoServices) && sensor.InfoServices.length > 0) {
      return sensor.InfoServices;
    }
    if (Array.isArray(sensor?.AssociatedFeeds) && sensor.AssociatedFeeds.length > 0) {
      return sensor.AssociatedFeeds;
    }
    return [];
  }

  /**
   * Get combined feeds from sensor - combines both InfoServices and AssociatedFeeds
   * @param sensor The sensor object containing InfoServices and AssociatedFeeds
   * @returns Combined array of all available feeds
   */
  getCombinedFeedsForSensor(sensor: any): any[] {
    const feeds: any[] = [];
    if (Array.isArray(sensor?.InfoServices) && sensor.InfoServices.length > 0) {
      feeds.push(...sensor.InfoServices);
    }
    if (Array.isArray(sensor?.AssociatedFeeds) && sensor.AssociatedFeeds.length > 0) {
      feeds.push(...sensor.AssociatedFeeds);
    }
    return feeds;
  }

  hasPredictionDriftFeed(sensor: any): boolean {
    return !!this.getLoadedPredictionDriftFeed(sensor);
  }

  private getLoadedPredictionDriftFeed(sensor: any): { info: any; layer: L.Layer } | null {
    if (sensor && this.refundedPredictionDriftSensors.has(sensor)) return null;

    const infoServices = Array.isArray(sensor?.InfoServices) ? sensor.InfoServices : [];
    for (const info of infoServices) {
      if (info?.prediction_info_ordered !== false || !info?.checked) continue;

      const feedKey = this.getFeedKey(info, feedsConfig[info?._id]);
      const layer = this.currentFilteredLayers?.[feedKey] || this.feedLayers?.[feedKey];
      if (layer) return { info, layer };
    }
    return null;
  }

  isPredictionDriftPanelOpenFor(sensor: any): boolean {
    return this.predictionDriftChecked && this.predictionDrift.activeSensor === sensor;
  }

  getPredictionDriftSourceLayer(sensor: any): L.Layer | null {
    if (this.predictionDrift.activeSensor !== sensor) return null;
    const info = this.predictionDrift.activeSourceFeed;
    if (!info?.checked) return null;
    const feedKey = this.getFeedKey(info, feedsConfig[info?._id]);
    return this.currentFilteredLayers?.[feedKey] || this.feedLayers?.[feedKey] || null;
  }

  getPredictionDriftSelectableLayers(): L.Layer[] {
    const visible = new Set<L.Layer>();
    for (const layer of [
      ...Object.values(this.currentFilteredLayers || {}),
      ...Object.values(this.feedLayers || {}),
    ]) {
      if (layer && this.map?.hasLayer(layer)) visible.add(layer);
    }
    return Array.from(visible);
  }

  getPredictionDriftFeedName(sensor: any): string {
    const services = [
      ...(sensor?.InfoServices ?? []),
      ...(sensor?.informationServices ?? []),
      ...(sensor?.AssociatedFeeds ?? []),
    ];

    for (const service of services) {
      const detail = service?.predictionInfoDetails?.[0];
      const feedName = detail?.feedName ?? detail?.feed_name;

      if (feedName) {
        return String(feedName);
      }
    }

    return 'Prediction Drift';
  }

  addPredictionDriftFeed(sensor: any): void {
    const source = this.getLoadedPredictionDriftFeed(sensor);
    if (!source) return;

    if (this.predictionDrift.activeSensor !== sensor || this.predictionDrift.activeSourceFeed !== source.info) {
      this.predictionDrift.deactivate();
      this.predictionDrift.activeSensor = sensor;
      this.predictionDrift.activeSourceFeed = source.info;
      this.predictionDrift.registerPredictionDetectionLayer(source.layer);
    }
    this.predictionDriftChecked = true;
    this.predictionDrift.toggle(true);
    this.predictionDrift.onModeChange('select');
  }

  private resetPredictionDriftPanel(): void {
    this.predictionDriftChecked = false;
    this.predictionDrift.deactivate();
  }

  private isNormalAssociatedFeedMode(): boolean {
    return !this.isCompare && !this.isCompareRecurrency;
  }

  shouldShowAssociatedFeedToggle(feed: any): boolean {
    return this.informationFeedHasAssociatedFeedData(feed);
  }

  isAssociatedFeedToggleEnabled(feed: any): boolean {
    return this.isNormalAssociatedFeedMode() &&
      this.shouldShowAssociatedFeedToggle(feed) &&
      this.isInformationFeedChecked(feed);
  }

  private getFeedIdentity(feed: any): string {
    return String(
      feed?._id ??
      feed?.isInfo?._id ??
      feed?.id ??
      feed?.isInfo?.id ??
      feed?.feedId ??
      feed?.isInfo?.feedId ??
      feed?.name ??
      feed?.isInfo?.name ??
      ''
    );
  }

  private getNestedAssociatedFeeds(feed: any): any[] {
    const nestedFeeds =
      feed?.associatedFeeds ??
      feed?.AssociatedFeeds ??
      feed?.associated_feeds ??
      feed?.isInfo?.associatedFeeds ??
      feed?.isInfo?.AssociatedFeeds ??
      feed?.isInfo?.associated_feeds;

    return Array.isArray(nestedFeeds) ? nestedFeeds : [];
  }

  private informationFeedHasAssociatedFeedData(feed: any): boolean {
    return this.getNestedAssociatedFeeds(feed).length > 0;
  }

  private isInformationFeedChecked(feed: any): boolean {
    return !!(feed?.checked ?? feed?.isInfo?.checked);
  }

  private getSensorIdentity(sensor: any): string {
    return String(sensor?.id ?? sensor?.sensorId ?? sensor?._id ?? '');
  }

  private getAssociatedFeedTargetSensorId(feed: any): string {
    return String(
      feed?.sensorId ??
      feed?.sensor_id ??
      feed?.targetSensorId ??
      feed?.target_sensor_id ??
      feed?.associatedSensorId ??
      feed?.associated_sensor_id ??
      ''
    );
  }

  private getCheckedAssociatedFeedTargetSensorIds(): Set<string> {
    const sensorIds = new Set<string>();
    this.collection?.sensors?.forEach((sensor: any) => {
      sensor?.AssociatedFeeds?.forEach((associatedFeed: any) => {
        if (!associatedFeed?.checked) {
          return;
        }

        const sensorId = this.getAssociatedFeedTargetSensorId(associatedFeed);
        if (sensorId) {
          sensorIds.add(sensorId);
        }
      });
    });
    return sensorIds;
  }

  isSensorDisabledByAssociatedFeed(sensor: any): boolean {
    const sensorId = this.getSensorIdentity(sensor);
    return !!sensorId && this.getCheckedAssociatedFeedTargetSensorIds().has(sensorId);
  }

  private syncSensorsDisabledByAssociatedFeed(): void {
    const disabledSensorIds = this.getCheckedAssociatedFeedTargetSensorIds();
    if (disabledSensorIds.size === 0) {
      return;
    }

    this.collection?.sensors?.forEach((sensor: any) => {
      const sensorId = this.getSensorIdentity(sensor);
      if (!disabledSensorIds.has(sensorId)) {
        return;
      }

      sensor.checked = false;
      sensor.scenes?.forEach((scene: any) => {
        scene.checked = false;
      });
      sensor.InfoServices?.forEach((feed: any) => {
        feed.checked = false;
      });
      sensor.AssociatedFeeds?.forEach((feed: any) => {
        feed.checked = false;
      });
    });
  }

  private cleanupAssociatedFeedLayer(feed: any): void {
    const config = feedsConfig?.[this.getFeedIdentity(feed)];
    const key = this.getFeedKey(feed, config);
    this.removeDataLayer(feed);
    this.removeFeedPanel(key);
    this.clearFilteredLayerAndRestore(false, key);
    this.activeFeedKeys.delete(key);
  }

  private uncheckAssociatedFeedsForParent(sensor: any, parentFeed: any): void {
    const parentFeedId = this.getFeedIdentity(parentFeed);
    sensor?.AssociatedFeeds?.forEach((associatedFeed: any) => {
      if (associatedFeed?._associatedParentFeedId !== parentFeedId) {
        return;
      }

      if (associatedFeed.checked) {
        this.cleanupAssociatedFeedLayer(associatedFeed);
      }
      associatedFeed.checked = false;
    });
    this.expandedAssociatedFeedIds.delete(parentFeedId);
  }

  private uncheckAssociatedFeedsForSensor(sensor: any): void {
    sensor?.AssociatedFeeds?.forEach((associatedFeed: any) => {
      if (associatedFeed.checked) {
        this.cleanupAssociatedFeedLayer(associatedFeed);
      }
      associatedFeed.checked = false;
    });
    sensor?.InfoServices?.forEach((feed: any) => {
      this.expandedAssociatedFeedIds.delete(this.getFeedIdentity(feed));
    });
  }

  private ensureAssociatedFeedsRegistered(
    sensor: any,
    parentFeed: any,
    associatedFeeds: any[]
  ): any[] {
    if (!sensor || !Array.isArray(associatedFeeds) || associatedFeeds.length === 0) {
      return [];
    }

    if (!Array.isArray(sensor.AssociatedFeeds)) {
      sensor.AssociatedFeeds = [];
    }

    const parentFeedId = this.getFeedIdentity(parentFeed);
    const sensorId = sensor?.id ?? sensor?.sensorId ?? parentFeed?.sensorId;
    return associatedFeeds.map((associatedFeed: any) => {
      const associatedFeedId = this.getFeedIdentity(associatedFeed);
      const existingFeed = sensor.AssociatedFeeds.find(
        (feed: any) => this.getFeedIdentity(feed) === associatedFeedId
      );

      if (existingFeed) {
        existingFeed._associatedParentFeedId =
          existingFeed._associatedParentFeedId ?? parentFeedId;
        return existingFeed;
      }

      const registeredFeed = {
        ...associatedFeed,
        sensorId: associatedFeed?.sensorId ?? sensorId,
        checked: associatedFeed?.checked ?? false,
        isDisable:
          associatedFeed?.isDisable ??
          (!this.areAllScenesChecked(sensor) ||
            !this.hasAssociatedFeedResults(associatedFeed)),
        _associatedParentFeedId: parentFeedId,
      };

      sensor.AssociatedFeeds.push(registeredFeed);
      return registeredFeed;
    });
  }

  getAssociatedFeedsForInfoFeed(sensor: any, feed: any): any[] {
    if (!this.isNormalAssociatedFeedMode()) {
      return [];
    }

    const nestedFeeds = this.getNestedAssociatedFeeds(feed);
    if (nestedFeeds.length === 0) {
      return [];
    }

    return this.ensureAssociatedFeedsRegistered(sensor, feed, nestedFeeds);
  }

  hasAssociatedFeedsForInfoFeed(sensor: any, feed: any): boolean {
    return this.shouldShowAssociatedFeedToggle(feed);
  }

  isAssociatedFeedsExpanded(feed: any): boolean {
    return this.expandedAssociatedFeedIds.has(this.getFeedIdentity(feed));
  }

  toggleAssociatedFeeds(feed: any): void {
    if (!this.isAssociatedFeedToggleEnabled(feed)) {
      return;
    }

    const feedId = this.getFeedIdentity(feed);
    if (!feedId) {
      return;
    }

    if (this.expandedAssociatedFeedIds.has(feedId)) {
      this.expandedAssociatedFeedIds.delete(feedId);
      return;
    }

    this.expandedAssociatedFeedIds.add(feedId);
  }

  getAssociatedFeedToggleTooltip(feed: any, count: number): string {
    if (!this.isNormalAssociatedFeedMode()) {
      return 'Associated feeds are unavailable in comparison mode. Select a single sensor to view associated feeds.';
    }

    if (!this.isInformationFeedChecked(feed)) {
      return 'Select information feed to view associated feeds';
    }

    if (this.isAssociatedFeedsExpanded(feed)) {
      return 'Hide associated feeds';
    }

    return count > 1 ? `View associated feeds (${count})` : 'View associated feeds';
  }

  getAssociatedFeedIndex(sensor: any, associatedFeed: any): number {
    const feeds = Array.isArray(sensor?.AssociatedFeeds)
      ? sensor.AssociatedFeeds
      : [];
    const directIndex = feeds.indexOf(associatedFeed);
    if (directIndex !== -1) {
      return directIndex;
    }

    const associatedFeedId = this.getFeedIdentity(associatedFeed);
    return feeds.findIndex(
      (feed: any) => this.getFeedIdentity(feed) === associatedFeedId
    );
  }

  trackByFeedId = (index: number, feed: any): string => {
    return this.getFeedIdentity(feed) || String(index);
  };

  private isAssociatedFeed(sensor: any, feed: any): boolean {
    const feedId = this.getFeedIdentity(feed);
    return (
      Array.isArray(sensor?.AssociatedFeeds) &&
      sensor.AssociatedFeeds.some(
        (associatedFeed: any) =>
          associatedFeed === feed ||
          (!!feedId && this.getFeedIdentity(associatedFeed) === feedId)
      )
    );
  }

  private findSensorForAssociatedFeed(feed: any): any {
    return this.collection?.sensors?.find((sensor: any) =>
      this.isAssociatedFeed(sensor, feed)
    );
  }

  private findSensorForObservation(info: any): any {
    return this.collection?.sensors?.find((sensor: any) =>
      Array.isArray(sensor?.Observation) && sensor.Observation.includes(info)
    );
  }

  private getFeedDisplayColor(sensor: any, feed: any, config: any): any {
    const ownerSensor = sensor || this.findSensorForAssociatedFeed(feed);

    if (ownerSensor && this.isAssociatedFeed(ownerSensor, feed)) {
      return ASSOCIATED_FEED_LIGHT_MAGENTA;
    }

    return config?.color;
  }

  isMiningChangesMonitoringFeed(feed: any): boolean {
    const feedId = feed?._id ?? feed?.isInfo?._id;
    const feedConfig = feedId ? feedsConfig?.[String(feedId)] : null;

    return feedConfig?.type === 'Mining changes monitoring';
  }

  isRelatedFeedOrdered(feed: any): boolean {
    return feed?.related_feed_ordered === true || feed?.isInfo?.related_feed_ordered === true;
  }

  private areAllScenesChecked(sensor: any): boolean {
    const validScenes = Array.isArray(sensor?.scenes)
      ? sensor.scenes.filter(
          (scene: any) => scene?.id && scene?.status !== 'failed'
        )
      : [];

    return (
      validScenes.length > 0 &&
      validScenes.every((scene: any) => scene?.checked === true)
    );
  }

  private getCheckedValidScenes(sensor: any): any[] {
    return Array.isArray(sensor?.scenes)
      ? sensor.scenes.filter(
          (scene: any) =>
            scene?.id && scene?.status !== 'failed' && scene?.checked === true
        )
      : [];
  }

  private getActiveSceneForSensor(sensor: any): any {
    const sensorScene = this.getCheckedValidScenes(sensor)[0];

    if (sensorScene) {
      return sensorScene;
    }

    const sensors =
      this.collection?.sensors ??
      this.collections?.[this.collectionIndex]?.sensors ??
      [];

    for (const currentSensor of sensors) {
      const fallbackScene = this.getCheckedValidScenes(currentSensor)[0];

      if (fallbackScene) {
        return fallbackScene;
      }
    }

    return null;
  }

  private syncCurrentSceneSelection(sensor: any): void {
    const activeScene = this.getActiveSceneForSensor(sensor);

    this.selectedSceneNew = activeScene;
    this.sceneSelected = activeScene?.id ?? null;
  }

  private refreshAssociatedFeedsState(sensor: any): void {
    if (
      !Array.isArray(sensor?.AssociatedFeeds) ||
      sensor.AssociatedFeeds.length === 0
    ) {
      return;
    }

    if (this.isStandardMultiSensorCompareActive(sensor)) {
      this.clearAssociatedFeedsForCompare(sensor);
      return;
    }

    const canEnableAssociatedFeeds = this.areAllScenesChecked(sensor);

    sensor.AssociatedFeeds.forEach((associatedFeed: any) => {
      associatedFeed.isDisable =
        !canEnableAssociatedFeeds || !this.hasAssociatedFeedResults(associatedFeed);
    });
  }

  private hasAssociatedFeedResults(associatedFeed: any): boolean {
    return Object.keys(associatedFeed?.feed_results || {}).length > 0;
  }

  private isAssociatedFeedStatusSuccess(associatedFeed: any): boolean {
    return this.hasAssociatedFeedResults(associatedFeed);
  }

  getAssociatedFeedDisabledTooltip(associatedFeed: any): string {
    return this.hasAssociatedFeedResults(associatedFeed)
      ? ''
      : 'The feed could not be generated';
  }

  private syncAssociatedFeedsForSensorToggle(
    sensor: any,
    eventChecked: boolean
  ): void {
    if (
      !Array.isArray(sensor?.AssociatedFeeds) ||
      sensor.AssociatedFeeds.length === 0
    ) {
      return;
    }

    if (this.isStandardMultiSensorCompareActive(sensor)) {
      this.clearAssociatedFeedsForCompare(sensor);
      return;
    }

    sensor.AssociatedFeeds.forEach((associatedFeed: any) => {
      associatedFeed.isDisable =
        !eventChecked || !this.hasAssociatedFeedResults(associatedFeed);

      if (associatedFeed.isDisable) {
        associatedFeed.checked = false;
      }
    });
  }

  private clearAssociatedFeedsForCompare(sensor: any): void {
    if (
      !Array.isArray(sensor?.AssociatedFeeds) ||
      sensor.AssociatedFeeds.length === 0
    ) {
      return;
    }

    sensor.AssociatedFeeds.forEach((associatedFeed: any) => {
      const feedId = associatedFeed?._id;
      const config = feedId ? feedsConfig?.[feedId] : null;
      const feedKey = this.getFeedKey(associatedFeed, config);

      associatedFeed.checked = false;
      associatedFeed.isDisable = true;
      this.removeDataLayer(associatedFeed);
      this.removeFeedPanel(feedKey);
      this.removeLeftFeedPanel(feedKey);
      this.removeRightFeedPanel(feedKey);
      this.clearFilteredLayerAndRestore(false, feedKey);
      this.activeFeedKeys.delete(feedKey);
      this.clearFeedFilterState(feedKey);
    });

    if (this.displayedIS?.isInfo && this.isAssociatedFeed(sensor, this.displayedIS.isInfo)) {
      this.displayedIS = null;
    }
  }

  generateSliderDateRangePredict(end: string, start: string) {
    this.dateRangeArray = [];
    const startDate = new Date(start);
    const endDate = new Date(end);
    const diffMs = endDate.getTime() - startDate.getTime();
    const diffMins = diffMs / (1000 * 60);
    const diffHours = diffMs / (1000 * 60 * 60);
    const diffDays = diffMs / (1000 * 60 * 60 * 24);

    const dateArray: string[] = [];
    const sameDay =
      startDate.toISOString().split('T')[0] ===
      endDate.toISOString().split('T')[0];

  if (sameDay) {
  const step = 2 * 60 * 1000;
  let count = 0;
  let time = startDate.getTime();
    while (time <= endDate.getTime() && count < 5) {
    const dt = new Date(time);
        const hh = String(dt.getUTCHours()).padStart(2, '0');
    const mm = String(dt.getUTCMinutes()).padStart(2, '0');

    dateArray.push(`${hh}:${mm}`);
    time += step;
    count++;
   }

  const endDt = new Date(endDate.getTime());
  const endHh = String(endDt.getUTCHours()).padStart(2, '0');
  const endMm = String(endDt.getUTCMinutes()).padStart(2, '0');

  dateArray.push(`${endHh}:${endMm}`);
  }
    return dateArray;
  }

  groupVesselsByDatePredict(dateRangeArray, data: any = false) {
    this.vesselData = {};
    this.dateRangeArray = dateRangeArray;
    this.sliderShow = true;

    const isTimeOnly = this.dateRangeArray.every(
      (d) => d.length === 5 && d.includes(':')
    );
    const isDateOnly = this.dateRangeArray.every(
      (d) => d.length === 10 && d.includes('-')
    );
    let predictData: any = '';
    if (data) {
      predictData = data;
    } else {
      predictData = this.historicalVesselData;
    }
    for (const range of this.dateRangeArray) {
      this.vesselData[range] = predictData.filter((data) => {
        const timestamp = new Date(data.location_time);
        const isoDate = timestamp.toISOString().split('T')[0];
        const isoHour = timestamp.toISOString().split('T')[1].substring(0, 5); // "HH:MM"

        if (isTimeOnly) {
          return isoHour === range;
        } else if (isDateOnly) {
          return isoDate === range;
        } else {
          return timestamp.toISOString().startsWith(range);
        }
      });
    }
  }

  convertToGeoJSONNew(vesselsData: any, type: string) {
    let AISdata: any[];
    if (type === 'overlay' || type === 'CLYDE') {
      AISdata = vesselsData;
    } else if (type === 'VOYAGERADAR') {
      AISdata = toVoyageVesselList(vesselsData);
    } else {
      AISdata = vesselsData?.vessels ? vesselsData?.vessels.nodes : vesselsData;
    }
    const dataMappers = {
      CLYDE: (vessel) => ({
        type: 'Feature',
        id: vessel.id,
        geometry: {
          type: 'Point',
          coordinates: [
            vessel.location?.longitude || vessel.longitude,
            vessel.location?.latitude || vessel.latitude,
          ],
        },
        properties: {
          ID: vessel.id,
          'Timestamp UTC': vessel.timestamp,
          Lng: (vessel.location?.longitude || vessel.longitude).toString(),
          Lat: (vessel.location?.latitude || vessel.latitude).toString(),
          MMSI: vessel.mmsi,
        },
      }),
      SPIRE: (vessel) => ({
        type: 'Feature',
        id: vessel.id,
        geometry: {
          type: 'Point',
          coordinates: [
            vessel.lastPositionUpdate?.longitude || vessel.longitude,
            vessel.lastPositionUpdate?.latitude || vessel.latitude,
          ],
        },
        properties: {
          ID: vessel.id,
          MMSI: vessel.staticData?.mmsi || vessel.mmsi,
          Name: vessel.staticData?.name || vessel.name || 'N/A',
          'Timestamp UTC':
            vessel.lastPositionUpdate?.timestamp || vessel.timestamp,
          Lng: (
            vessel.lastPositionUpdate?.longitude ||
            vessel.longitude ||
            vessel.location?.LON
          ).toString(),
          Lat: (
            vessel.lastPositionUpdate?.latitude ||
            vessel.latitude ||
            vessel.location?.LAT
          ).toString(),
          Course: vessel.lastPositionUpdate?.course || vessel.course,
          Flag: vessel.staticData?.flag || vessel.flag,
          'Ship Type': vessel.staticData?.shipType || vessel.shipType || 'N/A',
          IMO: vessel.staticData?.imo || vessel?.staticData?.imo,
          'ETA UTC': vessel.currentVoyage?.eta || vessel.eta || 'N/A',
          'Port Name':
            vessel.currentVoyage?.matchedPort?.port?.name ||
            vessel.port?.name ||
            'N/A',
          Destination: vessel?.currentVoyage?.destination
            ? vessel?.currentVoyage?.destination
            : 'N/A',
          Speed: vessel.lastPositionUpdate?.speed
            ? vessel.lastPositionUpdate.speed
            : 'N/A',
          'Vessel Length': vessel.staticData?.dimensions?.length || 'N/A',
          'Vessel Width': vessel.staticData?.dimensions?.width || 'N/A',
        },
      }),
      VOYAGERADAR: toVoyageVesselFeature,
    };
    const mapperKey =
      type === 'CLYDE'
        ? 'CLYDE'
        : type === 'VOYAGERADAR'
        ? 'VOYAGERADAR'
        : 'SPIRE';
    const mapper = dataMappers[mapperKey];
    const features = AISdata?.map(mapper) || [];
    return {
      type: 'FeatureCollection',
      features: features,
    };
  }

  filterScenesBySiteId = (array, id) => {
    return array.map((obj) => ({
      ...obj,
      scenes: obj.scenes.filter((scene) => scene.siteId === id),
    }));
  };

  filterScenesBySubdaily = (array, id) => {
    const targetSlot = Number(id);
    return array.map((obj) => ({
      ...obj,
      scenes: obj.scenes.filter(
        (scene) =>
          Number(scene?.subDailySlot ?? scene?.sequence ?? scene?.sequenceNumber) === targetSlot
      ),
    }));
  };

  private getRecurrencySceneId(item: any): any {
    return item?.scenesList?.[0]?.id ?? item?.scenes?.[0]?.id ?? item?.sceneId;
  }

  private getRecurrencyCompareKey(item: any): string {
    const sceneId = this.getRecurrencySceneId(item);

    if (this.isNumberOfCollectionsFrequency(item?.repeatFrequency) && sceneId != null) {
      return `scene:${sceneId}`;
    }

    return `start:${item?.start ?? ''}`;
  }

  private isSameRecurrencySelection(left: any, right: any): boolean {
    return this.getRecurrencyCompareKey(left) === this.getRecurrencyCompareKey(right);
  }

  private isSceneInRecurrency(sceneEntry: any, recurrency: any): boolean {
    const sceneId = this.getRecurrencySceneId(recurrency);

    if (this.isNumberOfCollectionsFrequency(recurrency?.repeatFrequency) && sceneId != null) {
      return (sceneEntry?.id ?? sceneEntry?.scene?.id) === sceneId;
    }

    return sceneEntry?.scene?.start == recurrency?.start;
  }

  setCollectionRecurrencyArray(
    collectionType: 'opportunityList' | 'recurrencyArray',
    recurrencyIndex: any
  ) {
    const currentList = this.collection[collectionType];
    currentList[recurrencyIndex].checked = true;
    currentList[recurrencyIndex].index = recurrencyIndex;
    currentList[recurrencyIndex].scenes.forEach((scene) => {
      if (scene.status !== 'failed') scene.checked = true;
    });
    if (collectionType == 'recurrencyArray') {
      if (
        this.selectedCheckboxesNew[this.selectedCheckboxesNew.length - 1]
          ?.pane == 'left'
      ) {
        this.mapPane = 'right';
      } else {
        this.mapPane = 'left';
      }
    } else {
      if (this.mapPane == 'left') {
        this.mapPane = 'right';
      } else {
        this.mapPane = 'left';
      }
    }
    const primarySensor = this.collection.sensors[0];
    const collectionItem = this.collection[collectionType][recurrencyIndex];
    collectionItem.name = primarySensor.name;
    collectionItem.resolution_tooltip = primarySensor?.resolution_tooltip;
    collectionItem.downloaded = primarySensor?.downloaded;
    collectionItem.status = primarySensor?.status;
    collectionItem.restoreStatus = primarySensor?.restoreStatus;
    collectionItem.restoreOption = primarySensor?.restoreOption;
    collectionItem.checked = true;
    collectionItem.pane = this.mapPane;
    collectionItem.isAdditionalCSIProducts =
      primarySensor?.isAdditionalCSIProducts;
    collectionItem.obfuscateName = primarySensor?.obfuscateName;
    collectionItem.tnqSensorType = primarySensor?.tnqSensorType;
    collectionItem.questionName = primarySensor?.questionName;
    collectionItem.assetsDelivered = primarySensor?.assetsDelivered;
  }

  setLeftRightLabels(recurrencyIndex) {
    this.normalizeRecurrentComparePanes();
    this.sensorsNew = this.selectedCheckboxesNew;
    this.leftData = this.selectedCheckboxesNew.filter(
      (selectedCheckboxes) => selectedCheckboxes.pane == 'left'
    );
    this.rightData = this.selectedCheckboxesNew.filter(
      (selectedCheckboxes) => selectedCheckboxes.pane == 'right'
    );
    this.setPreviousSelectiontext();
    this.selectionChange.next(this.collection.recurrencyArray[recurrencyIndex]);
  }

  private syncSensorPane(sensor: any, pane: 'left' | 'right'): void {
    if (!sensor) {
      return;
    }

    sensor.pane = pane;

    if (Array.isArray(sensor.scenes)) {
      sensor.scenes.forEach((scene: any) => {
        if (scene?.status !== 'failed') {
          scene.pane = pane;
        }
      });
    }
  }

  private normalizeRecurrentComparePanes(): void {
    if (!Array.isArray(this.selectedCheckboxesNew)) {
      return;
    }

    this.selectedCheckboxesNew.forEach((selectedSensor: any, index: number) => {
      if (!selectedSensor || index > 1) {
        return;
      }

      const pane: 'left' | 'right' = index === 0 ? 'left' : 'right';
      this.syncSensorPane(selectedSensor, pane);
    });
  }

  setLeftandRightBands(dataList) {
    this.leftBand = dataList.filter((item) => item.pane == 'left').length > 0;
    this.rightBand = dataList.filter((item) => item.pane == 'right').length > 0;
  }

  updateImageLayersBasedOnPane() {
    if (
      this.scenesNew.filter((scenenew) => scenenew.pane == 'left')[0]
        ?.leftImageLayer
    ) {
      this.leftImageNew = this.scenesNew.filter(
        (scenenew) => scenenew.pane == 'left'
      )[0]?.leftImageLayer;
    }
    if (
      this.scenesNew.filter((scenenew) => scenenew.pane == 'right')[0]
        ?.rightImageLayer
    ) {
      this.rightImageNew = this.scenesNew.filter(
        (scenenew) => scenenew.pane == 'right'
      )[0].rightImageLayer;
    }
    if (
      this.scenesNew.filter((scenenew) => scenenew.pane == 'left').length == 0
    ) {
      this.leftImageNew = null;
    }
    if (
      this.scenesNew.filter((scenenew) => scenenew.pane == 'right').length == 0
    ) {
      this.rightImageNew = null;
    }
  }

  limitSensorSelectionToTwo() {
    let selectedSensor: any;
    if (this.compare) {
      this.map.removeControl(this.compare);
      this.compare = null;
      let dateSelected: any;
      this.filterDateData = [];
      this.selectedCheckboxesNew.forEach((item) => {
        let start_date = this.datePipe.transform(
          item.start,
          'dd/MM/yyyy',
          'UTC'
        );
        let end_date = this.datePipe.transform(item.end, 'dd/MM/yyyy', 'UTC');
        dateSelected = start_date + ' - ' + end_date;
        this.filterDateData.push(dateSelected);
      });
    }
    if (this.selectedCheckboxesNew.length > 2) {
      selectedSensor = JSON.parse(
        JSON.stringify(this.selectedCheckboxesNew[0])
      );
      const indexToRemove = 0;
      this.selectedCheckboxesNew.splice(indexToRemove, 1);
      this.normalizeRecurrentComparePanes();
      this.sensorsNew = this.selectedCheckboxesNew;
      this.selectionChange.next(this.selectedCheckboxesNew[0]);
      this.subSelectionSelectionChange.next(1);
      if (
        this.collection.recurrencyArray.filter((item) => item.checked).length >
        0
      ) {
        this.collection.recurrencyArray.forEach((sensor, index) => {
          const indexTouncheck = this.selectedCheckboxesNew.findIndex(
            (item) => this.isSameRecurrencySelection(item, sensor)
          );
          if (indexTouncheck === -1) {
            sensor.checked = false;
            sensor.scenes.forEach((scene) => {
              scene.checked = false;
            });
          }
        });
      }
      if (this.compare) {
        this.map.removeControl(this.compare);
        this.compare = null;
        let dateSelected: any;
        this.filterDateData = [];
        this.selectedCheckboxesNew.forEach((item) => {
          let start_date = this.datePipe.transform(
            item.start,
            'dd/MM/yyyy',
            'UTC'
          );
          let end_date = this.datePipe.transform(item.end, 'dd/MM/yyyy', 'UTC');
          dateSelected = start_date + ' - ' + end_date;
          this.filterDateData.push(dateSelected);
        });
      }
      this.scenesNew.map((scene: any, index: any) => {
        if (this.isSceneInRecurrency(scene, selectedSensor)) {
          let ghgIndex = this.ghgLayers.findIndex(
            (ghg) => ghg.scene.id == scene.scene.id
          );
          if (ghgIndex != -1) {
            this.removeGHGLayerByScene(this.ghgLayers[ghgIndex]);
            this.ghgLayers.splice(ghgIndex, 1);
          }
          this.removeLayerByScene(scene, { paneSpecific: true });
          this.clearRFBandsByScene(scene, false);
          this.clearRFSignalsByScene(scene);
        }
      });
      this.scenesNew = this.scenesNew.filter((scene: any) => {
        return scene.scene?.start != selectedSensor.start;
      });
    }
  }

  checkForScenes(scenesList: any[]) {
    const collectionRecurrencyArray = this.collection.recurrencyArray
    this.isAllRecurrencyDisabled =
    collectionRecurrencyArray?.every(r => r.disabled) ?? false;

    if (scenesList.length == 0) {
      this.isNoScenes = true;
    } else {
      this.isNoScenes = false;
    }
  }

  toggleRecurrentSensor(indexToRemove: any, event: any, sensorSelected: any) {
    if (indexToRemove < 0) return;

    this.selectedCheckboxesNew.splice(indexToRemove, 1);
    this.normalizeRecurrentComparePanes();
    this.sensorsNew = this.selectedCheckboxesNew;
    this.selectionChange.next(this.selectedCheckboxesNew[0]);
    this.subSelectionSelectionChange.next(1);
    if (
      this.collection.recurrencyArray.filter((item) => item.checked).length > 0
    ) {
      this.collection.recurrencyArray.forEach((sensor, index) => {
        const indexTouncheck = this.selectedCheckboxesNew.findIndex(
          (item) => this.isSameRecurrencySelection(item, sensor)
        );
        if (indexTouncheck === -1) {
          sensor.checked = false;
          sensor.scenes.forEach((scene) => {
            scene.checked = false;
          });
        }
      });
      if (this.selectedCheckboxesNew?.length === 0) {
        this.defaultSubdailyCount = 1;
        this.toggleDailyRecurrency(event);
      }

      if (this.selectedCheckboxesNew?.length > 0) {
        if (this.compare) {
          this.map.removeControl(this.compare);
          this.compare = null;
        }

        this.scenesNew.map((scene: any, index: any) => {
          if (this.isSceneInRecurrency(scene, sensorSelected)) {
            let ghgIndex = this.ghgLayers.findIndex(
              (ghg) => ghg.scene.id == scene.scene.id
            );
            if (ghgIndex != -1) {
              this.removeGHGLayerByScene(this.ghgLayers[ghgIndex]);
              this.ghgLayers.splice(ghgIndex, 1);
            }
            this.removeLayerByScene(scene, { paneSpecific: true });
            this.clearRFSignalsByScene(scene);
            this.removeAnnoatationByScene(scene);
          }
        });
        this.mapPane = sensorSelected?.pane;
        if (this.mapPane == 'left') {
          this.leftImageNew = null;
          this.mapPane = 'right';
        } else {
          this.mapPane = 'left';
          this.rightImageNew = null;
        }
        if (this.leftImageNew == null && this.rightImageNew == null) {
          this.mapPane = '';
        }
        this.scenesNew = this.scenesNew.filter((scene: any) => {
          return !this.isSceneInRecurrency(scene, sensorSelected);
        });
        if (
          this.selectedCheckboxesNew[0]?.scenes[0]?.operatorKey ==
            this.OPERATOR.GHG &&
          this.selectedSites.length > 0
        ) {
          this.selectedCheckboxesNew[0].pane = 'left';
          this.selectedSites = [];
          this.removeLayers();
          this.removeGHGLayer();
          this.scenesNew = [];
          this.defaultSubdailyCount =
            this.selectedCheckboxesNew[0].scenes[0].siteId;
          this.selectOptionNew(this.selectedCheckboxesNew[0], 'compare');
        } else if (
          this.selectedCheckboxesNew[0]?.scenes[0]?.operatorKey ==
            this.OPERATOR.GHG &&
          this.selectedSites.length == 0
        ) {
          this.defaultSubdailyCount = 0;
          this.selectOptionNew(this.selectedCheckboxesNew[0], 'compare');
        }
      }
    }
  }

  toggleRecurrentDatesNew(
    collectionIndex: any,
    recurrencyIndex: any,
    event: any,
    type: any,
    task: any
  ) {
    this.recurrrencyIndexValue = recurrencyIndex;
    this.fail = 0;
    this.tifPopupShown = 0;
    this.lastSliderValue = 0;
    if (this.collection.opportunityList.length > 0) {
      this.toggleRecurrentDatesOpportunity(
        collectionIndex,
        recurrencyIndex,
        event,
        type,
        task
      );
      this.setLeftRightLabels(recurrencyIndex);
    } else if (
      this.collection?.recurrencyArray[recurrencyIndex]?.scenes[0]
        ?.operatorKey == this.OPERATOR.USL
    ) {
      this.toggleRecurrentDatesRFbandNew(
        collectionIndex,
        recurrencyIndex,
        event,
        type,
        task
      );
    } else if (
      this.collection?.recurrencyArray[recurrencyIndex]?.scenes[0]
        ?.operatorKey == this.OPERATOR.LBAND
    ) {
      this.toggleRecurrentDatesRFSignalNew(
        collectionIndex,
        recurrencyIndex,
        event,
        type,
        task
      );
    } else {
      this.RF = false;
      if (event.checked) {
        this.annotateClicked = false;
        this.newTaskButtonClicked = false;
        this.removeAnnotationMarkers();
        this.showSubDailyList = false;
        let selectedSensor: any;
        this.setCollectionRecurrencyArray('recurrencyArray', recurrencyIndex);
        this.cloneselectedCheckboxesNew = JSON.parse(
          JSON.stringify(this.cloneselectedCheckboxesNew)
        );
        this.selectedCheckboxesNew.push(
          this.collection.recurrencyArray[recurrencyIndex]
        );
        this.limitSensorSelectionToTwo();
        this.normalizeRecurrentComparePanes();
        if (this.collections[collectionIndex]?.recurrencyArray?.length > 1) {
          this.selectOptionNew(
            this.collections[collectionIndex]?.recurrencyArray[recurrencyIndex],
            'compare'
          );
        } else {
          this.selectOptionNew(
            this.collections[collectionIndex]?.recurrencyArray?.[0],
            'compare'
          );
        }
        if (this.selectedSites.length == 1) {
          this.selectedCheckboxesNew.map((selectedDate, index) => {
            let scenes: any[] = [];
            this.filteredCollection.recurrencyArray.map((recurrency) => {
              if (selectedDate.start == recurrency.start) {
                recurrency.scenes.map((scn) => {
                  scenes.push(scn);
                });
              }
            });
            this.selectedCheckboxesNew[index].scenes = scenes;
          });
          if (this.selectedSites[0]) {
            this.selectedCheckboxesNew = this.filterScenesBySiteId(
              this.selectedCheckboxesNew,
              this.selectedSites[0].value
            );
          }
        }
        this.setLeftRightLabels(recurrencyIndex);
        let sensor = this.collection.sensors[0];
        sensor.checked = true;
        if (
          (this.selectedSites.length == 0 &&
            this.selectedSubDailyItemsNew.length == 0) ||
          this.selectedCheckboxesNew.length == 2
        ) {
          for (const [sceneIndex, scene] of this.selectedCheckboxesNew[
            this.selectedCheckboxesNew.length - 1
          ]?.scenes.entries()) {
            if (scene?.id && scene?.status !== 'failed') {
              scene.checked = true;
              if (scene.footprint) {
                const sensorId = sensor?.id;
                const sceneId = scene?.id;
                const action = 'sensor';
                const taskId = this.collection?.taskId;
                if (this.imageType == 'tiff') {
                  scene.imageType = 'tif';
                }
                const sensorObj = {
                  sensorId: sensorId,
                  sceneId: sceneId,
                  action: action,
                  fileType: scene.imageType,
                };
                scene.start =
                  this.collection.recurrencyArray[recurrencyIndex]?.start;
                this.tifPopupShown = 0;
                this.fetchImageFromServer(this.collection, sensorObj, scene);
              }
            }
          }
          this.scenIdList.push(this.collection.recurrencyArray[recurrencyIndex]?.scenes[0]?.id);
        }
      } else {
        this.leftData = [];
        this.rightData = [];
        const indexToRemove =
          type === 'dropdown'
            ? this.selectedCheckboxesNew.findIndex(
                (item) =>
                  this.isSameRecurrencySelection(
                    item,
                    this.collection.recurrencyArray[recurrencyIndex]
                  )
              )
            : recurrencyIndex;
        let sensorSelected = this.collection.recurrencyArray[recurrencyIndex];
        this.toggleRecurrentSensor(indexToRemove, event, sensorSelected);
      }
    }
    if(!this.timeseries){
      this.observationChecked = true;
      if (event.checked) {
        this.observationEnabled = true;
      } else {
        this.observationEnabled = false;
      }
    }
  }

  toggleRecurrentSensorNew(collectionIndex: any, sensorIndex: any, event: any, sensor?: any) {
    if (this.collection.opportunityList.length > 0) {
      this.toggleRecurrentSensorOpportunityNew(
        collectionIndex,
        sensorIndex,
        event
      );
    } else if (this.collection.sensors[0].operatorKey == this.OPERATOR.USL) {
      this.toggleRecurrentRFNew(collectionIndex, sensorIndex, event);
    } else if (this.collection.sensors[0].operatorKey == this.OPERATOR.LBAND) {
      this.toggleRecurrentRFSignalNew(collectionIndex, sensorIndex, event);
    } else {
      if (event.checked == false) {
        this.rightData = [];
        this.leftData = [];
        const indexToRemove = sensorIndex;
        let sensorSelected = JSON.parse(
          JSON.stringify(this.selectedCheckboxesNew[indexToRemove])
        );
        this.toggleRecurrentSensor(indexToRemove, event, sensorSelected);
            this.needsCompareResetToCenter = true;

        const isLeftPane = sensor?.pane === 'left';
        const isRightPane = sensor?.pane === 'right';

        const comparisonLayer = isLeftPane
        ? this.leftComparisonObjectLayer
        : this.rightComparisonObjectLayer;

        if (comparisonLayer && this.map.hasLayer(comparisonLayer)) {
          // Remove comparison layer
          this.map.removeLayer(comparisonLayer);

          // Reset pane-specific state
          if (isLeftPane) {
            this.leftComparisonObjectLayer = null;
            this.leftFeedPanels.clear();
            this.clearCompareFeedCache('left');
            this.leftImageNew = null;
            this.updateObjectVisibility(0);
          } else if (isRightPane) {
            this.rightComparisonObjectLayer = null;
            this.rightFeedPanels.clear();
            this.clearCompareFeedCache('right');
            this.rightImageNew = null;
            this.updateObjectVisibility(this.map.getSize().x);
          }
          // Clean up scene-specific layers & annotations
          const sceneId = sensor.scenes[0]?.id;

          this.scenesNew.forEach(sceneNew => {
            if (sceneNew.id !== sceneId) return;

            this.removeLayerByScene(sceneNew);

            if (isLeftPane && sceneNew?.leftImageLayer) {
              this.leftImageNew = null;
            }

            if (isRightPane && sceneNew?.rightImageLayer) {
              this.rightImageNew = null;
            }

            this.removeAnnoatationByScene(sceneNew);
          });
        }
      }
    }
  }

  toggleDatesBySite(
    collectionIndex: any,
    recurrencyIndex: any,
    event: any,
    type: any,
    task: any
  ) {
    this.fail = 0;
    this.RF = false;
    this.lastSliderValue = 0;
    if (event.checked) {
      this.annotateClicked = false;
      this.newTaskButtonClicked = false;
      this.removeAnnotationMarkers();
      let selectedSensor: any;
      this.setCollectionRecurrencyArray('recurrencyArray', recurrencyIndex);
      this.cloneselectedCheckboxesNew = JSON.parse(
        JSON.stringify(this.cloneselectedCheckboxesNew)
      );
      if (
        this.selectedSites.length == 1 &&
        this.selectedCheckboxesNew.length == 0
      ) {
        this.defaultSubdailyCount = this.selectedSites[0].value;
        this.resetMapNew();
      }
      this.selectedCheckboxesNew.push(
        this.collection.recurrencyArray[recurrencyIndex]
      );
      this.limitSensorSelectionToTwo();
      if (this.collections[0]?.recurrencyArray?.length > 1) {
        this.selectOptionNew(
          this.collections[0]?.recurrencyArray[recurrencyIndex],
          'compare'
        );
      } else {
        this.selectOptionNew(
          this.collections[0]?.recurrencyArray?.[0],
          'compare'
        );
      }
      if (this.selectedSites.length == 1) {
        this.selectedCheckboxesNew.map((selectedDate, index) => {
          let scenes: any[] = [];
          this.filteredCollection.recurrencyArray.map((recurrency) => {
            if (selectedDate.start == recurrency.start) {
              recurrency.scenes.map((scn) => {
                scn.predictedDate = scn?.predicted_date;
                scenes.push(scn);
              });
            }
          });
          this.selectedCheckboxesNew[index].scenes = scenes;
        });
        if (this.selectedSites[0]) {
          this.selectedCheckboxesNew = this.filterScenesBySiteId(
            this.selectedCheckboxesNew,
            this.selectedSites[0].value
          );
        }
        this.subDailyFinalArray = this.selectedCheckboxesNew;
      }
      this.setLeftRightLabels(recurrencyIndex);
      let sensor = this.collection.sensors[0];
      sensor.checked = true;
      if (
        (this.selectedSites.length == 0 &&
          this.selectedSubDailyItemsNew.length == 0) ||
        this.selectedCheckboxesNew.length == 2
      ) {
        for (const [sceneIndex, scene] of this.selectedCheckboxesNew[
          this.selectedCheckboxesNew.length - 1
        ]?.scenes.entries()) {
          if (scene?.id && scene?.status !== 'failed') {
            scene.checked = true;
            scene.imageType = 'png';
            this.imageType = this.checkType();
            if (this.imageType == 'tiff') {
              scene.imageType = 'tif';
            }
            scene.tif = false;
            if (scene.footprint) {
              const sensorId = sensor?.id;
              const sceneId = scene?.id;
              const action = 'sensor';
              const taskId = this.collection?.taskId;
              const sensorObj = {
                sensorId: sensorId,
                sceneId: sceneId,
                action: action,
                fileType: scene.imageType,
              };
              scene.start =
                this.collection.recurrencyArray[recurrencyIndex]?.start;
              this.tifPopupShown = 0;
              this.fetchImageFromServer(this.collection, sensorObj, scene);
            }
          }
        }
      }
    } else {
      this.leftData = [];
      this.rightData = [];
      const indexToRemove =
        type === 'dropdown'
          ? this.selectedCheckboxesNew.findIndex(
              (item) =>
                item.start ===
                this.collection.recurrencyArray[recurrencyIndex].start
            )
          : recurrencyIndex;
      this.selectedCheckboxesNew.splice(indexToRemove, 1);
      this.normalizeRecurrentComparePanes();
      this.sensorsNew = this.selectedCheckboxesNew;
      this.subDailyFinalArray = this.selectedCheckboxesNew;
      if (this.selectedSites.length > 0) {
        if (this.compare) {
          this.map.removeControl(this.compare);
          this.compare = null;
        }
        this.scenesNew.map((scene: any, index: any) => {
          if (
            scene.scene?.start ==
            this.collection.recurrencyArray[recurrencyIndex].start
          ) {
            this.mapPane = scene?.pane;
            let ghgIndex = this.ghgLayers.findIndex(
              (ghg) => ghg.scene.id == scene.scene.id
            );
            if (ghgIndex != -1) {
              this.removeGHGLayerByScene(this.ghgLayers[ghgIndex]);
              this.ghgLayers.splice(ghgIndex, 1);
            }
            this.removeLayerByScene(scene, { paneSpecific: true });
          }
          this.removeAnnoatationByScene(scene);
        });
        if (this.mapPane == 'left') {
          this.leftImageNew = null;
          this.mapPane = 'right';
        } else {
          this.mapPane = 'left';
          this.rightImageNew = null;
        }
        if (this.leftImageNew == null && this.rightImageNew == null) {
          this.mapPane = '';
        }
        this.scenesNew = this.scenesNew.filter((scene: any) => {
          return (
            scene.scene?.start !=
            this.collection.recurrencyArray[recurrencyIndex].start
          );
        });
        if (this.selectedCheckboxesNew.length > 0) {
          this.selectedValue = this.collection.recurrencyArray.filter(
            (recurrency) => {
              return recurrency.start == this.selectedCheckboxesNew[0].start;
            }
          )[0];
          let sceneBySite = this.collection.recurrencyArray.filter(
            (recurrency) => {
              return recurrency.start == this.selectedCheckboxesNew[0].start;
            }
          )[0];
          this.subDailyCountarray.forEach((item) => {
            item.disabled = !sceneBySite.scenes.some(
              (obj) => obj.siteId === item.siteId
            );
          });
        } else {
          this.selectedValue = this.collection.recurrencyArray[0];
        }
        if (this.selectedCheckboxesNew.length == 0) {
          this.defaultSubdailyCount = this.selectedSites[0]?.siteId;
          this.resetMapNew();
          this.filteredCollection = this.fullCollection;
          this.subDailyFinalArray = [];
          this.selectSites(this.defaultSubdailyCount, event);
        }
      }
    }
  }

  toggleRecurrentOpportunity(
    event: any,
    indexToRemove: any,
    sensorSelected: any
  ) {
    this.selectedCheckboxesNew.splice(indexToRemove, 1);
    this.sensorsNew = this.selectedCheckboxesNew;
    this.selectionChange.next(this.selectedCheckboxesNew[0]);
    this.subSelectionSelectionChange.next(1);
    if (
      this.collection.opportunityList.filter((item) => item.checked).length > 0
    ) {
      this.collection.opportunityList.forEach((sensor, index) => {
        const indexTouncheck = this.selectedCheckboxesNew.findIndex(
          (item) => item.date === sensor.date
        );
        if (indexTouncheck === -1) {
          sensor.checked = false;
          sensor.scenes.forEach((scene) => {
            scene.checked = false;
          });
        }
      });
    }
    if (this.selectedCheckboxesNew?.length === 0) {
      this.toggleDailyRecurrency(event);
    }
    if (this.selectedCheckboxesNew.length > 0) {
      if (this.compare) {
        this.map.removeControl(this.compare);
        this.compare = null;
      }
      this.scenesNew.map((scene: any, index: any) => {
        if (scene.scene?.start == sensorSelected.date) {
          this.mapPane = scene?.pane;
          this.removeLayerByScene(scene, { paneSpecific: true });
        }
      });
      if (this.mapPane == 'left') {
        this.leftImageNew = null;
        this.mapPane = 'right';
      } else {
        this.mapPane = 'left';
        this.rightImageNew = null;
      }
      if (this.leftImageNew == null && this.rightImageNew == null) {
        this.mapPane = '';
      }
      this.scenesNew = this.scenesNew.filter((scene: any) => {
        return scene.scene?.start != sensorSelected.date;
      });
    }
  }

  toggleRecurrentDatesOpportunity(
    collectionIndex: any,
    opportunityIndex: any,
    event: any,
    type: any,
    task: any
  ) {
    if (event?.checked) {
      this.setCollectionRecurrencyArray('opportunityList', opportunityIndex);
      this.cloneselectedCheckboxesNew = JSON.parse(
        JSON.stringify(this.cloneselectedCheckboxesNew)
      );
      this.selectedCheckboxesNew.push(
        this.collection.opportunityList[opportunityIndex]
      );
      this.sensorsNew = this.selectedCheckboxesNew;
      this.setPreviousSelectiontext();
      this.selectionChange.next(
        this.collection.opportunityList[opportunityIndex]
      );
      let sensor = this.collection.opportunityList[opportunityIndex];
      sensor.checked = true;
      this.tifPopupShown = 0;
      for (const [sceneIndex, scene] of this.selectedCheckboxesNew[
        this.selectedCheckboxesNew.length - 1
      ]?.scenes.entries()) {
        if (scene?.id && scene?.status !== 'failed') {
          scene.checked = true;
          if (this.imageType === 'tiff') {
            scene.imageType = 'tif';
          }
          if (scene.footprint) {
            const sensorId = sensor?.id;
            const sceneId = scene?.id;
            const action = 'sensor';
            const taskId = this.collection?.taskId;
            const sensorObj = {
              sensorId: sensorId,
              sceneId: sceneId,
              action: action,
              fileType: scene.imageType,
            };
            scene.start = sensor?.date;
            this.tifPopupShown = 0;
            this.fetchImageFromServer(this.collection, sensorObj, scene);
          }
        }
      }
    } else {
      const indexToRemove =
        type === 'dropdown'
          ? this.selectedCheckboxesNew.findIndex(
              (item) =>
                item.date ===
                this.collection.opportunityList[opportunityIndex].date
            )
          : opportunityIndex;
      let selectedSensor = this.collection.opportunityList[opportunityIndex];
      this.toggleRecurrentOpportunity(event, indexToRemove, selectedSensor);
    }
  }

  toggleRecurrentSensorOpportunityNew(
    collectionIndex: any,
    sensorIndex: any,
    event: any
  ) {
    if (event.checked == false) {
      const indexToRemove = sensorIndex;
      let sensorSelected = JSON.parse(
        JSON.stringify(this.selectedCheckboxesNew[indexToRemove])
      );
      this.toggleRecurrentOpportunity(event, indexToRemove, sensorSelected);
    }
  }

  setPreviousSelectiontext() {
    if (this.selectedCheckboxes[0] && this.selectedCheckboxes[0]?.start) {
      const start = this.formatDate(
        new Date(this.selectedCheckboxes[0]?.start)
      );
      const end = this.formatDate(new Date(this.selectedCheckboxes[0]?.end));
      const combinedDate = `${start} - ${end}`;
      if (this.dateRange) {
        this.previousSelectionText = new Date(
          this.selectedCheckboxes[0]?.start
        );
        this.previousEndText = new Date(this.selectedCheckboxes[0]?.end);
      } else
        this.previousSelectionText = new Date(
          this.selectedCheckboxes[0]?.start
        );
    }
  }

  formatDate(date) {
    const day = String(date.getDate() - 1).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = String(date.getFullYear()).slice(-4);
    return `${day}/${month}/${year}`;
  }

  selectMetric(metric, event) {
    this.removeGHGLayer();
    if (!this.isCompare || this.timeseries) {
      this.resetMapNew();
      this.resetScenesBySite(this.defaultSubdailyCount, event);
    }
    this.metric = metric;
    if (this.timeseries) {
      this.scenesNew.forEach((selectedScene) => {
        this.showMetric(this.metric, selectedScene);
      });
    } else {
      this.showMetric(this.metric, this.scenesNew[this.scenesNew.length - 1]);
    }
    let footprintcordinates = JSON.parse(
      JSON.stringify(
        this.scenesNew[0].scene.footprint.coordinates[0].map((sub) => {
          return [sub[1], sub[0]];
        })
      )
    );
    footprintcordinates.push(footprintcordinates[0]);
    const polygon = turf.polygon([footprintcordinates]);
    const centroid = turf.centroid(polygon);
    const centerCoordinates = centroid.geometry.coordinates;
    this.map.setView(centerCoordinates, this.zoomLevel);
  }

  showMetric(metric: any, scene) {
    let trendLine: any;
    this.metric = metric;
    let legendScale: any;
    let emissionMarker: any;
    let footprintcordinates = scene?.scene?.footprint?.coordinates[0].map(
      (sub) => {
        return [sub[1], sub[0]];
      }
    );

    const hasValue = this.ghgLayers.some(
      (item) => item.legendScale !== null && item.legendScale !== undefined
    );
    if (this.scenesNew.length > 0) {
      if (
        (!this.timeseries &&
          scene?.scene?.legendScale &&
          this.metric == 'ppb') ||
        (this.timeseries &&
          scene?.scene?.legendScale &&
          this.metric == 'ppb' &&
          !hasValue)
      ) {
        var legendCanvas = this.drawLegendOnCanvas(
          scene?.scene?.legendScale,
          scene?.scene?.legend_max,
          '(PPB)'
        );
        legendScale = this.addDynamicLegendToMap(legendCanvas, scene?.scene);
      } else if (this.metric == 'kg') {
        let textMarkerCordinates: any[] = JSON.parse(
          JSON.stringify(footprintcordinates)
        );
        textMarkerCordinates.push(footprintcordinates[0][0]);
        var polygon = turf.polygon([textMarkerCordinates]);
        var centroid = turf.centroid(polygon);
        var centroidCoordinates = centroid.geometry.coordinates;

        if (scene?.scene?.metadata?.emission != false) {
          this.trendLinecordinates.push([
            centroidCoordinates[0],
            centroidCoordinates[1],
          ]);
        }
        emissionMarker = L.marker(
          [centroidCoordinates[0], centroidCoordinates[1]],
          {
            pane: this.mapPane,
            icon: L.divIcon({
              html:
                '<div style="background: grey; width: 100px">' +
                `${
                  scene?.scene?.metadata?.emission == false
                    ? 'No Emission'
                    : scene?.scene?.ch4srData?.sourceRate
                }` +
                '</div>',
            }),
          }
        ).addTo(this.map);
        this.attachTooltip(
          emissionMarker,
          `<span style="text-transform: capitalize;">
            ${this.formatProperties(scene?.scene?.ch4srData)}
        </span>`
        );

        if (this.timeseries) {
          trendLine = L.polyline([this.trendLinecordinates], {
            color: 'yellow',
          }).addTo(this.map);
        }
      }
      this.ghgLayers.push({
        markerLayer: emissionMarker,
        legendScale: legendScale,
        scene: scene,
         renderedPredictedDate:
          scene?.renderedPredictedDate ??
          scene?.scene?.predicted_date?.split('T')[0],
        trendLine: trendLine,
      });
    }
  }

  shouldDisableIndicesHourGlass(collectionIndex, sensorIndex, scene, indices) {
    let isDisable: boolean = true;
    const sensor = this.collections?.[collectionIndex]?.sensors?.[sensorIndex];
    if (!sensor?.scenes) {
      return true;
    }

    const selectedScenes = sensor.scenes.filter((i) => i.checked === true);
    if (selectedScenes.length === 1) {
      if (indices?.products.length === 0) {
        isDisable = false;
      } else {
        const hasMatchingScene = selectedScenes.some((scene) =>
          indices.products.some((product) => {
            return product.sceneId == scene.id && product.status == 'success';
          })
        );
        if (hasMatchingScene) {
          isDisable = true;
        } else {
          isDisable = false;
        }
      }
    }
    return isDisable;
  }

  drawLegendOnCanvas(grades: any[], maximum: any, title?: any) {
    grades = grades.reverse();
    let legendScale: any[] = [];
    if (this.indicesLayer) {
      legendScale = [1.0, 0.8, 0.6, 0.4, 0.2, 0, -1];
    } else {
      legendScale = this.generateLegendScaleAdjusted(
        maximum,
        grades.length - 1
      ).reverse();
    }

    var canvas = document.createElement('canvas');
    var ctx: any = canvas.getContext('2d');
    canvas.width = 800;
    canvas.height = grades.length * 20 + 40;
    ctx.scale(2, 1);
    ctx.font = '8px Arial';

    this.indicesLayer
      ? (ctx.textBaseline = 'top')
      : (ctx.textBaseline = 'middle');
    ctx.fillStyle = '#fff';
    this.indicesLayer
      ? ctx.fillText(`(${title})`, 1, 23)
      : ctx.fillText(title, 3, 10);

    if (this.indicesLayer) {
      for (var i = 0; i < grades.length; i++) {
        let divident = grades.length / 7;
        if (i !== 0) {
          ctx.fillStyle = grades[i].color;
          ctx.fillRect(0, i * 20 + 20, 20, 20);
        }
        if (
          i === 0 ||
          i === grades.length - 1 ||
          i % Math.round(divident) === 0
        ) {
          ctx.fillStyle = '#fff';
          ctx.fillText(legendScale[i], 30, i * 20 + 34);
        }
      }
    } else {
      for (var i = 0; i < grades.length; i++) {
        let divident = grades.length / 7;
        ctx.fillStyle = grades[i].color;
        ctx.fillRect(0, i * 20 + 20, 20, 20);
        if (i == 0 || i == grades.length - 1 || i % Math.round(divident) == 0) {
          ctx.fillStyle = '#fff';
          ctx.fillText(Math.round(legendScale[i]), 24, i * 20 + 30);
        }
      }
    }
    return canvas;
  }

  addDynamicLegendToMap(legendCanvas: any, scene: any) {
    var legendDataURL = legendCanvas.toDataURL();
    const legendWidth = scene?.png_footprint[0][2] - scene?.png_footprint[0][0];
    const areaEasternmost = scene?.png_footprint[0][2];
    const shift = 0.01;
    const newLegendSouthWestLongitude = areaEasternmost + shift;
    const newLegendNorthEastLongitude =
      newLegendSouthWestLongitude + legendWidth;
    const newLegendBounds: any = [
      [scene?.png_footprint[0][1], newLegendSouthWestLongitude],
      [scene?.png_footprint[0][3], newLegendNorthEastLongitude],
    ];
    return L.imageOverlay(legendDataURL, newLegendBounds, {
      pane: this.mapPane,
    }).addTo(this.map);
  }

  generateLegendScaleAdjusted(legendMax: any, steps: any) {
    const startValue = 0;
    const endValue = Math.ceil(legendMax / 10) * 10;
    const interval = (endValue - startValue) / steps;
    let scale: any[] = [];
    for (let i = 0; i <= steps; i++) {
      const value = startValue + i * interval;
      scale.push(value);
    }
    return scale;
  }

  spinnerLoaderTifZoom(image: any) {
    let tileload = false;
    this.spinnerService.show();
    image.on('tileload', () => {
      this.spinnerService.hide();
    });

    this.map.on('zoomstart', () => {
      this.spinnerService.show();
    });
    this.map.on('zoomend', () => {
      this.spinnerService.hide();
    });
  }

  private getTiffResolutionSources(scene?: any, sensorId?: any): any[] {
    const matchedSensor =
      this.sensorsNew.find((sensor) => sensor?.id === sensorId) ||
      this.collection?.sensors?.find((sensor: any) => sensor?.id === sensorId);

    return [
      scene,
      matchedSensor,
      this.selectedSceneNew,
      ...this.sensorsNew,
    ].filter(Boolean);
  }

  calculateZoomFromResolution(source?: any) {
    return this.mapResolutionZoomService.calculateZoomFromResolution(
      source ?? this.sensorsNew[0]
    );
  }

  private applyTiffMaxZoom(scene?: any, sensorId?: any): void {
    if (!this.map || (scene?.imageType !== 'tif' && this.imageType !== 'tif')) {
      return;
    }

    this.map.setMaxZoom(
      Number(this.calculateZoomFromResolution(this.getTiffResolutionSources(scene, sensorId)))
    );
  }

  private resetDefaultMaxZoom(): void {
    if (this.map) {
      this.map.setMaxZoom(18);
    }
  }

  private refreshTiffMaxZoomAfterLayerChange(): void {
    const remainingTiffScene = this.scenesNew.find(
      (sceneNew: any) => sceneNew?.scene?.imageType === 'tif'
    );

    if (remainingTiffScene) {
      this.applyTiffMaxZoom(remainingTiffScene.scene, remainingTiffScene.sensorId);
    } else {
      this.resetDefaultMaxZoom();
    }
  }

  fetchImageFromServer(
    collection: any,
    sensorObj: any,
    scene: any,
    isVdapChange?: boolean,
    info?: any
  ) {
    this.mapLoad = true;
    this.spinnerService.show();
    const failurePane: 'left' | 'right' = scene?.pane === 'right' || (!scene?.pane && this.mapPane === 'right')
      ? 'right' : 'left';

    if(scene.imageType === 'png' && scene.skipPreview){
      this.spinnerService.hide();
      return
    }

    const api$ = isVdapChange
      ? this.apiService.getvadpFromGeoCollection(sensorObj)
      : this.apiService.getCollectionImage(collection.taskId, sensorObj);

    api$
      .pipe(
        switchMap((res: any) => {
          return of(res);
        }),
        finalize(() => {
          this.mapLoad = false;
          this.spinnerService.hide();
        })
      )
      .subscribe({
        next: (res: any) => {
          if (info?.thermal_observation === true && !res?.result?.imageUrl) {
            this.showObservationError('The thermal observation is not available for this scene.');
          }
          else if (res?.msg === 'Failed') {
            this.questionWmsHandoff.publishFailure(
              scene,
              sensorObj?.sensorId,
              failurePane,
              new Error('WMS imagery request failed')
            );
            this.pointerEvent = 'auto';
            this.fail++;

            if (this.fail === 1) {
              const message =
                'An error occurred during processing and ingestion of the request. Please try after sometime.';
              this.popupService.openPopup(
                CollectionPopupComponent,
                message,
                '',
                '40%'
              );
            }
          } else if (res?.msg === 'user storage') {
            this.questionWmsHandoff.publishFailure(
              scene,
              sensorObj?.sensorId,
              failurePane,
              new Error('WMS imagery is stored externally')
            );
            this.freeze = false;
            this.fail++;

            if (this.fail === 1) {
              const message =
                'We cannot display or download the image as the delivery was made to your storage. You can access the image via your storage.';
              this.popupService.openPopup(
                CollectionPopupComponent,
                message,
                '',
                '40%'
              );
            }
          } else if (res?.result) {
            this.responseResult = res.result;
            void this.displayFootprintImageNew(
              scene,
              res.result,
              sensorObj.sensorId,
              'image',
              collection.taskId,
              info
            ).catch((error) => {
              this.questionWmsHandoff.publishFailure(
                scene,
                sensorObj?.sensorId,
                failurePane,
                error
              );
            })
            .finally(() => {
                this.spinnerService.hide();
                this.mapLoad = false;
              });
          } else {
            this.spinnerService.hide();
            this.mapLoad = false;
            this.questionWmsHandoff.publishFailure(
              scene,
              sensorObj?.sensorId,
              failurePane,
              new Error('WMS imagery metadata is unavailable')
            );
          }
        },
        error: () => {
          this.spinnerService.hide();
          this.mapLoad = false;
          this.questionWmsHandoff.publishFailure(
            scene,
            sensorObj?.sensorId,
            failurePane,
            new Error('WMS imagery request failed')
          );
          this.pointerEvent = 'auto';
        },
      });
  }

  FetchCordinatesOfImage(scene: any, pane: any) {
    let footprintcordinates: any[] = [];
    if (scene?.footprint?.type != 'Point') {
      footprintcordinates = scene?.footprint?.coordinates[0].map((sub) => {
        return [sub[1], sub[0]];
      });
    } else {
      for (let i = 0; i < scene?.tif_footprint?.length; i += 2) {
        footprintcordinates.push([
          scene?.tif_footprint[i + 1],
          scene?.tif_footprint[i],
        ]);
      }
    }
    let tifcordinates: any[] = [];
    for (let i = 0; i < scene?.tif_footprint?.length; i += 2) {
      tifcordinates.push([
        scene?.tif_footprint[i + 1],
        scene?.tif_footprint[i],
      ]);
    }
    let footprintlayer = L.polygon(footprintcordinates, {
      color: 'green',
      fillColor: 'none',
      pane: pane,
    }).addTo(this.map);
    let tiffootprintlayer: any;
    if (tifcordinates.length > 0) {
      tiffootprintlayer = L.polygon(tifcordinates, {
        color: 'yellow',
        fillColor: 'none',
        pane: pane,
      }).addTo(this.map);
    }

    return {
      tiffootprintlayer: tiffootprintlayer,
      footprintlayer: footprintlayer,
      footprintcordinates: footprintcordinates,
      tifcordinates: tifcordinates,
    };
  }

  DisplayPopupsBasedOnResponse(res: any) {
    if (res?.msg === 'Failed') {
      this.spinnerService.hide();
      this.freeze = false;
      this.fail = this.fail + 1;
      if (this.fail === 1) {
        const message =
          'An error occurred during processing and ingestion of the request. Please try after sometime.';
        this.popupService.openPopup(
          CollectionPopupComponent,
          message,
          '',
          '40%'
        );
      }
    } else if (res?.msg === 'user storage') {
      this.spinnerService.hide();
      this.freeze = false;
      this.fail = this.fail + 1;
      if (this.fail === 1) {
        const message =
          'We cannot display or download the image as the delivery was made to your storage. You can access the image via your storage.';
        this.popupService.openPopup(
          CollectionPopupComponent,
          message,
          '',
          '40%'
        );
      }
    }
  }

  /** Uncheck a WeatherEx sensor and remove it from sensorsNew.
   *  Uses setTimeout so the assignment runs after the mat-checkbox [(ngModel)]
   *  ControlValueAccessor write settles, matching the async timing of the AIS pattern. */
  // ── WeatherEx delegating wrappers (called from the template) ────────────
  fetchWeatherExData(collection: any, sensorIndex: number) { this.weatherEx.fetchData(collection, sensorIndex); }
  renderWeatherExTimeseries(geoJson: any, refreshId?: any, onDone?: () => void) { this.weatherEx.renderTimeseries(geoJson, refreshId, onDone); }
  toggleWeatherExVariable(variable: string) { this.weatherEx.toggleVariable(variable); }
  onWeatherExTimeChange(index: number) { this.weatherEx.onTimeChange(index); }
  onWeatherExSelectDate(dateStr: string) { this.weatherEx.onSelectDate(dateStr); }
  onWeatherExSliderChange(position: number | null) { this.weatherEx.onSliderChange(position); }
  closeWeatherExDrawer() { this.weatherEx.closeDrawer(); }
  closeWeatherExTooltip() { this.weatherEx.closeTooltip(); }
  onWeatherExTooltipLeave() { this.weatherEx.onTooltipLeave(); }
  clearWeatherExLayer() { this.weatherEx.clearLayer(); }
  showWeatherExTarget(collection: any) { this.weatherEx.showTarget(collection); }
  downloadWeatherExHistory(refreshData: any, sensor?: any) { this.weatherEx.downloadHistory(refreshData, sensor); }
  private resetWeatherExForecastSelection(activeSensor?: any, activeRefreshId?: any) { this.weatherEx.resetForecastSelection(activeSensor, activeRefreshId); }
  fetchAISDataFromServer(collection, sensorIndex, scene) {
    const targetSensor = collection.sensors[sensorIndex];
    const isVoyage = targetSensor?.operatorKey === OPERATORS.VOYAGERADAR;
    // Voyage Radar answers this through the shared predicate rather than the
    // raw flag: `timeExpired` is stamped when the collection is fetched and
    // never moves again, and this is the guard the Refresh button, the paid
    // drawers and the refund gate all have to agree with. Spire and Clyde keep
    // the flag — their windows carry different meanings and are not in scope.
    let timeExpired = isVoyage ? hasVoyageToiFinished(targetSensor) : targetSensor.timeExpired;
    let refreshCount =
      collection.sensors[sensorIndex]?.updatedRefreshes == 0
        ? 0
        : collection.sensors[sensorIndex]?.updatedRefreshes ||
          collection.sensors[sensorIndex]?.noOfRefreshes;
    if (!scene.aisAvailable) {
      const message =
        'AIS data is not available until the start of the time of interest (TOI)';
      this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
      this.spinnerService.hide();
      return;
    } else if (timeExpired) {
      // Voyage Radar's wallet outlives its TOI and can be refunded, so its
      // refusal has to say so; the other two operators buy refreshes outright
      // and keep the sentence they always had.
      const message = isVoyage
        ? VOYAGE_TOI_ENDED_MESSAGE
        : 'The time of interest (TOI), along with the seven days of access to the historical data, has ended. Please re-task if the area of interest (AOI) continues to be the same.';
      this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
      this.spinnerService.hide();
      return;
    } else if (
      collection.sensors[sensorIndex].scenes[0].operatorKey ==
      this.OPERATOR.CLYDE
    ) {
      const coordinates = scene?.footprint?.coordinates[0];
      let taskId = this.collection?.taskId;
      let newCoordinates = coordinates.map((coord) => {
        return [coord[1], coord[0]];
      });
      newCoordinates = [newCoordinates];
      newCoordinates = JSON.stringify(newCoordinates);
      const encodedCoordinates = encodeURIComponent(newCoordinates);
      const startTime = encodeURIComponent(scene.openWindow);
      const endTime = encodeURIComponent(scene.closeWindow);
      const clydePayload = {
        polygon: encodedCoordinates,
        startTime: startTime,
        endTime: endTime,
        type: 'display',
      };
      const input = JSON.parse(decodeURIComponent(clydePayload.polygon));
      this.vesselPolygon = input[0]
        .map((pair) => pair.reverse().join(' '))
        .join(', ');
      clydePayload.polygon = this.vesselPolygon;
      this.apiService.getClydeAISData(clydePayload, taskId).subscribe(
        (res: any) => {
          this.clydeData = res.data;
          this.mapLoad = false;
          this.spinnerService.hide();
          if (res?.msg === 'failed') {
            const message =
              'An error occurred during processing and ingestion of the request. Please try after sometime.';
            this.popupService.openPopup(
              CollectionPopupComponent,
              message,
              '',
              '40%'
            );
          } else if (res?.data?.length === 0) {
            const message =
              'There is no AIS data in the area tasked. If there were to be vessels during the time of interest (TOI), those observations would become available when refreshed.';
            this.popupService.openPopup(
              CollectionPopupComponent,
              message,
              '',
              '40%'
            );
            collection.sensors[sensorIndex].checked = false;
            collection.sensors[sensorIndex].scenes.forEach((scene: any) => {
              scene.checked = false;
            });
          } else {
            this.displayVesselSnapshot(
              scene,
              res.data,
              this.collection.sensors[sensorIndex],
              'CLYDE',
              res
            );
          }
        },
        (error) => {
          this.mapLoad = false;
          this.spinnerService.hide();
        }
      );
    } else if (
      collection.sensors[sensorIndex].scenes[0].operatorKey ==
        this.OPERATOR.SPIRE &&
      refreshCount > 0
    ) {
      this.mapLoad = true;
      this.spinnerService.show();
      const coordinates = scene?.footprint?.coordinates[0];
      let taskId = this.collection?.taskId;

      let newCoordinates = coordinates.map((coord) => {
        return [coord[0], coord[1]];
      });
      newCoordinates = [newCoordinates];
      newCoordinates = JSON.stringify(newCoordinates);
      const encodedCoordinates = encodeURIComponent(newCoordinates);
      const startTime = encodeURIComponent(scene.openWindow);
      const endTime = encodeURIComponent(scene.closeWindow);
      const spirePayload = {
        polygon: encodedCoordinates,
        startTime: startTime,
        endTime: endTime,
        type: 'display',
      };
      this.apiService.getAISData(spirePayload, taskId).subscribe(
        (res: any) => {
          this.spireData = res.data;
          this.mapLoad = false;
          this.spinnerService.hide();
          if (res?.msg === 'failed') {
            const message =
              'An error occurred during processing and ingestion of the request. Please try after sometime.';
            this.popupService.openPopup(
              CollectionPopupComponent,
              message,
              '',
              '40%'
            );
          } else {
            this.displayVesselSnapshot(
              scene,
              res.data,
              this.collection.sensors[sensorIndex],
              'SPIRE',
              res
            );
          }
        },
        (error) => {
          this.mapLoad = false;
          this.spinnerService.hide();
        }
      );
    } else if (
      collection.sensors[sensorIndex].scenes[0].operatorKey === OPERATORS.VOYAGERADAR &&
      // Own gate, NOT the shared `refreshCount` local above (that one is
      // Spire's counter pair). canAfford treats an unknown wallet as spendable
      // — the server re-checks and 402s, which the error handler reports.
      canAfford(
        voyageCreditsRemaining(collection.sensors[sensorIndex]),
        // Priced from the sensor's own catalogue and target shape, so an area
        // task is gated on the bbox price and a point task on the nearby one.
        refreshCredits(collection.sensors[sensorIndex])
      )
    ) {
      this.mapLoad = true;
      this.spinnerService.show();
      let taskId = this.collection?.taskId;
      // A POI task has no ring to send — `coordinates` is [lng, lat], so the
      // mapping below would call .map() on a number. The server reads the
      // tasked point from the scene footprint it already holds and queries
      // /v1/vessels/nearby instead of /v1/vessels/bbox; the client sends no
      // geometry at all on this path.
      const isPoiTarget = scene?.footprint?.type === 'Point';
      let ring: any;
      if (!isPoiTarget) {
        const coordinates = scene?.footprint?.coordinates[0];
        ring = [coordinates.map((coord) => [coord[0], coord[1]])];
      }
      const vrPayload = {
        ...(isPoiTarget ? {} : { polygon: JSON.stringify(ring) }),
        type: 'display',
        sensorId: collection.sensors[sensorIndex]?.id,
      };
      // Tells a toolbar-initiated refresh that a request is really in flight, so
      // it waits for the response instead of settling on a guard path.
      this.voyage.markRefreshStarted();
      this.apiService.getVoyageRadarData(vrPayload, taskId).subscribe(
        (res: any) => {
          this.mapLoad = false;
          this.spinnerService.hide();
          if (!res?.data?.length) {
            const message =
              'There is no AIS data in the area tasked. If there were to be vessels during the time of interest (TOI), those observations would become available when refreshed.';
            this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
            collection.sensors[sensorIndex].checked = false;
            collection.sensors[sensorIndex].scenes.forEach((scene: any) => { scene.checked = false; });
          } else {
            // One wallet write path for both actions — authoritative on the
            // server's apiCreditsRemaining, `current − cost` fallback, scoped
            // to the charged sensor.
            this.voyage.applyCreditSpend(
              res,
              collection.sensors[sensorIndex]?.id,
              refreshCredits(collection.sensors[sensorIndex])
            );
            if (scene?.footprint?.type === 'Point') {
              // A POI pull answers with a positionless nearby LIST — the
              // target marker's popup is the whole result, so nothing goes
              // through the vessel-snapshot renderer. Mirror the two side
              // effects that renderer owns for AOI pulls: the refresh-history
              // push and the single-selection sweep + active id.
              const vrSensor = this.collection.sensors[sensorIndex];
              if (res?.newRefreshHistory) {
                if (!vrSensor.refreshHistory) vrSensor.refreshHistory = [];
                vrSensor.refreshHistory.push(res.newRefreshHistory);
              }
              this.clearVoyageSnapshot(false);
              this.voyageActiveRefreshId = res?.newRefreshHistory?.refreshId ?? null;
              this.voyage.showPoiNearby(scene, res.data);
            } else {
              this.displayVesselSnapshot(
                scene, res.data,
                this.collection.sensors[sensorIndex],
                'VOYAGERADAR', res
              );
            }
          }
          this.voyage.settleRefresh();
        },
        (err: any) => {
          this.mapLoad = false;
          this.spinnerService.hide();
          this.voyage.settleRefresh();
          // This handler used to take no argument at all, so a server 402
          // failed in complete silence. Re-sync the wallet from the error
          // payload first — the local balance is wrong by definition.
          const vrSensor = this.collection.sensors[sensorIndex];
          syncWalletFromError(err, vrSensor);
          // The action key is resolved from the tasked shape, exactly as
          // `refreshCredits` beside it already does — NOT the literal 'refresh'.
          // This route charges whichever key `refreshActionKey` selects, so a
          // point task's failure is booked against `nearby`; naming 'refresh'
          // here told that user the platform had "failed to refresh vessel
          // data" for a call the server priced as a nearby search, and broke
          // SPEND_ACTION_COPY's own rule that the key the server priced and the
          // key the message names are the same string. Both entries cost 2
          // today, so only the wording was ever wrong — but the wording is what
          // this function exists to get right, and the day ee-admin prices them
          // apart the sentence and the figure would have diverged too.
          this.popupService.openPopup(
            CollectionPopupComponent,
            voyageSpendErrorMessage(
              err,
              refreshActionKey(isPoiSensor(vrSensor)),
              refreshCredits(vrSensor),
            ),
            '',
            '40%'
          );
        }
      );
    } else if (
      collection.sensors[sensorIndex].scenes[0].operatorKey === OPERATORS.VOYAGERADAR
    ) {
      // Wallet cannot cover a refresh — canAfford above said no.
      this.mapLoad = false;
      this.spinnerService.hide();
      const left = voyageCreditsRemaining(collection.sensors[sensorIndex]);
      const cost = refreshCredits(collection.sensors[sensorIndex]);
      const message =
        left != null && left > 0
          ? `A vessel refresh costs ${cost} credits and you have ${left} left. Re-task to buy more.`
          : 'Your credits are spent or refunded, please Re-task to buy more.';
      this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
    } else if (scene?.operatorKey !== this.OPERATOR.CLYDE) {
      this.mapLoad = false;
      this.spinnerService.hide();
      const message =
        'Your refresh count has been exhausted. Please re-task to continue receiving latest AIS information.';
      this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
      this.spinnerService.hide();
    }
  }

  async LoadTiffImage(imageUrl: any, scene: any, pane: any) {
    const georaster = await parseGeoRaster(imageUrl);
    let geoRasterLayer = new GeoRasterLayer({
      georaster: georaster,
      resolution: 256,
      opacity: 1,
      pane: pane,
      pixelValuesToColorFn: this.createPixelValuesToColorFn(georaster, scene),
    }).addTo(this.map);
    (geoRasterLayer as any).resolutionSource = scene;
    return geoRasterLayer;
  }

  displayTiffImage(imageLayer: any, source?: any) {
    imageLayer.addTo(this.map);
    this.map.setMinZoom(DEFAULT_ZOOMLEVEL);
    this.map.fitBounds(imageLayer.getBounds(), {
      maxZoom: DEFAULT_ZOOMLEVEL,
    });
    this.map.setMaxZoom(
      Number(this.calculateZoomFromResolution(source ?? imageLayer?.resolutionSource))
    );
    this.spinnerLoaderTifZoom(imageLayer);
  }

  convertToLeafletBounds(coords) {
    const [west, south, east, north] = coords;
    return [
      [south, west],
      [north, east],
    ];
  }

  private async renderThermalGeoJsonOverlay(
    imageUrl: string,
    pane: string
  ): Promise<boolean> {
    if (!imageUrl || !/\.geojson(?:\?|$)/i.test(String(imageUrl))) {
      return false;
    }
    
    this.spinnerService.show();
    this.mapLoad = true;

    try {
      const response = await fetch(imageUrl, {
        credentials: 'same-origin',
        cache: 'no-store',
      });

      if (!response.ok) {
        return false;
      }

      const geojson = await response.json();

      this.removeThermalObservationLayer();

      const tooltipDiv = this.thermalTooltipDiv ?? this.createTooltipDiv();
      this.thermalTooltipDiv = tooltipDiv;
      tooltipDiv.style.display = 'none';

      const renderer = L.canvas({ pane, padding: 0.5 });

      const layer = (L as any).geoJSON(undefined, {
        pane,
        renderer,
        style: {
          color: '#ff4500',
          weight: 1,
          fillColor: '#ff4500',
          fillOpacity: 1,
        },
        onEachFeature: (feature: any, lyr: any) => {
          lyr.on('mouseover', (e: any) => {
            const temperature = feature?.properties?.average_temperature;
            const coordinates = feature?.geometry?.coordinates;
            const centroidCoordinates = coordinates?.[0]?.[0];

            const loc = Array.isArray(centroidCoordinates)
              ? centroidCoordinates.join(', ')
              : '';

            const locParts = String(loc).split(',').map((p) => p.trim());
            tooltipDiv.innerHTML = `
              <div style="line-height:1.6;">
                <div><strong>Mean Temperature:</strong> ${temperature}K</div>
                <div><strong>Lng:</strong> ${loc !== '' ? locParts[0] : ''}</div>
                <div><strong>Lat:</strong> ${loc !== '' ? locParts[1] : ''}</div>
              </div>`;
            tooltipDiv.style.display = 'block';
            this.updateTooltipPosition(e, tooltipDiv);
          });

          lyr.on('mousemove', (e: any) => {
            this.updateTooltipPosition(e, tooltipDiv);
          });

          lyr.on('mouseout', () => {
            tooltipDiv.style.display = 'none';
          });
        },
      }).addTo(this.map);

      this.thermalObservationLayer = layer as L.Layer;

      const features: any[] = Array.isArray(geojson?.features) ? geojson.features : [];
      await this.addGeoJsonFeaturesInChunks(layer, features);

      const bounds = layer.getBounds?.();
      if (bounds?.isValid?.()) {
        this.map.fitBounds(bounds, { padding: [20, 20] });
      }

      return true;
    } catch {
      return false;
    } finally {
      this.spinnerService.hide();
      this.mapLoad = false;
    }
  }


  private addGeoJsonFeaturesInChunks(
    layer: L.GeoJSON,
    features: any[],
    chunkSize = 2000
  ): Promise<void> {
    if (features.length === 0) {
      return Promise.resolve();
    }

    return new Promise((resolve) => {
      let index = 0;

      const addNextChunk = () => {
        const slice = features.slice(index, index + chunkSize);
        slice.forEach((feature) => layer.addData(feature));
        index += chunkSize;

        if (index < features.length) {
          requestAnimationFrame(addNextChunk);
        } else {
          resolve();
        }
      };

      addNextChunk();
    });
  }

  private removeThermalObservationLayer(): void {
    this.viewportGeojson.endSession('thermal-observation');
    if (this.thermalObservationLayer) {
      if (this.map.hasLayer(this.thermalObservationLayer)) {
        this.map.removeLayer(this.thermalObservationLayer);
      }
      this.thermalObservationLayer = null;
    }
    if (this.thermalTooltipDiv) {
      this.thermalTooltipDiv.style.display = 'none';
    }
  }

  async displayFootprintImageNew(
    scene: any,
    urlData: any,
    sensorId: any,
    shapeFile: any,
    taskId?: any,
    info?: any
  ) {
    this.displayedScene = scene;
    this.displayedUrl = urlData;
    this.displayedSensorId = sensorId;
    if (
      !this.timeseries &&
      !this.collection.feedBased &&
      !scene?.isChangeDetectionCurrentWeekTab
    ) {
      this.removeDynamicLayer();
    }
    this.needsCompareResetToCenter = true;

    this.pointerEvent = 'none';
    let legendScale: any;
    if (this.mapPane == '') {
      this.mapPane = 'left';
    }
    const isCurrentWeekTabScene = !!scene?.isChangeDetectionCurrentWeekTab;
    // Latest Change imagery stays out of the compare panes so SplitMap never clips it away.
    const activePane = isCurrentWeekTabScene
      ? this.ensureChangeDetectionCurrentWeekPane()
      : this.mapPane;
    const isThermalAreaObservation =
      info?.thermal_observation === true &&
      String(info?.data_type ?? '').trim().toLowerCase() === 'area';
    const previousLeftImage = this.leftImageNew;
    const previousRightImage = this.rightImageNew;
    let createdImageLayer: L.Layer | null = null;
    scene.pane = activePane;
    if (
      scene?.isChangeDetectionHistoryCompare &&
      !this.isActiveChangeDetectionHistorySelection(
        scene.changeDetectionCompareKey,
        this.mapPane as 'left' | 'right'
      )
    ) {
      return;
    }
    const {
      tiffootprintlayer,
      tifcordinates,
      footprintcordinates,
      footprintlayer,
    } = await this.FetchCordinatesOfImage(scene, activePane);
    if (scene?.legendScale && scene?.operatorKey != this.OPERATOR.GHG) {
      let title = '';
      if (scene?.operatorKey == 'Ororatech') {
        title = '(W/sr/m²)';
      }
      var legendCanvas = this.drawLegendOnCanvas(
        scene?.legendScale,
        scene?.legend_max,
        title
      );
      legendScale = this.addDynamicLegendToMap(legendCanvas, scene);
    }
    this.isLoadFeedComapre = true;
    if(
      !scene?.isChangeDetectionCurrentWeekTab &&
      this.mapPane === 'left' &&
      this.leftComparisonObjectLayer &&
      this.map.hasLayer(this.leftComparisonObjectLayer)
    ){
      this.map.removeLayer(this.leftComparisonObjectLayer);
      this.leftComparisonObjectLayer = null;
      this.leftFeedPanels.clear();
      this.clearCompareFeedCache('left');
    }
    
    if(
      !scene?.isChangeDetectionCurrentWeekTab &&
      this.mapPane === 'right' &&
      this.rightComparisonObjectLayer &&
      this.map.hasLayer(this.rightComparisonObjectLayer)
    ){
      this.map.removeLayer(this.rightComparisonObjectLayer);
      this.rightComparisonObjectLayer = null;
      this.rightFeedPanels.clear();
      this.clearCompareFeedCache('right');
    }
    const isChangeDetectionTiff = scene.imageType == 'tif' &&
      !!this.collection?.taskStrategy &&
      this.isChangeDetectionTask(this.collection?.taskStrategy);
    const baseLayerName = urlData?.layer?.layerName || urlData?.layer?.layer;
    const missingChangeDetectionBaseLayer = isChangeDetectionTiff &&
      (typeof baseLayerName !== 'string' || !baseLayerName.trim());
    if (isCurrentWeekTabScene || this.sensorsNew.length == 1 || this.timeseries) {
      const layerLength = Object.keys(urlData?.layer || {}).length;
      if (scene.imageType == 'tif' &&
        (missingChangeDetectionBaseLayer || (urlData?.imageUrl && layerLength === 0))) {
        this.questionWmsHandoff.publishFailure(
          scene,
          sensorId,
          activePane === 'right' ? 'right' : 'left',
          new Error('WMS layer metadata is empty')
        );
        this.tifPopupShown = this.tifPopupShown + 1;
        if (this.tifPopupShown == 1) {
          this.resetMapNew();
          this.filterInfoVisible = false;
          const message = isChangeDetectionTiff
            ? 'There is no project-specific base map, or the base map is not loading. Please access the project data by selecting the sensor(s) next.'
            : 'not-available';
          this.mapLoad = false;
          this.spinnerService.hide();
          this.popupService
            .openPopup(CollectionPopupComponent, message, '', '40%')
            .afterClosed()
            .subscribe((result) => {
              this.resetMapNew();
              scene.checked = false;
            });
        }

        return;
      }
      if (urlData?.imageUrl) {
        const imageLoadPromises: Promise<any>[] = [];
        if ((scene.imageType == 'tif'|| this.imageType === 'tif') && layerLength > 0) {
          this.spinnerService.show();
            let bandvalue;
            if(this.shouldLoadBandInfoForScene(scene)){
            bandvalue = await firstValueFrom(
            this.getBandMinMax(taskId, scene.id, this.selectedBands));
            }
          
          this.leftImageNew = this.helperService.createWmsLayer(
            this.map,
            urlData,
            shapeFile,
            1000,
            false,           
            undefined,       
            activePane,
            bandvalue?.bands_info    

          );
        } else {
          if (isThermalAreaObservation) {
            const geoJsonRendered = await this.renderThermalGeoJsonOverlay(
              urlData.imageUrl,
              activePane
            );
            if (geoJsonRendered) {
              this.applyThermalObservationOpacity();
              this.spinnerService.hide();
              return;
            }
          }

          let leafletBounds: any;
          if (scene?.png_footprint) {
            leafletBounds = this.convertToLeafletBounds(
              scene?.png_footprint[0]
            );
          } else {
            leafletBounds = footprintcordinates;
          }

          this.leftImageNew = L.imageOverlay(urlData.imageUrl, leafletBounds, {
            pane: activePane,
            opacity: 1,
            crossOrigin: true,
          }).addTo(this.map);
          //this.handleCompareRecurrencyFeed(scene, 'left');
          this.map.fitBounds(this.leftImageNew.getBounds());
          this.spinnerService.hide();
        }
      } else if (urlData?.layer?.product) {
        const layerLength = Object.keys(urlData.layer.product).length;
        const filteredProducts = urlData.layer.product.find(
          (p: any) => p.name === this.selectvdap
        );
        if (scene.imageType == 'tif' && layerLength > 0) {
            let bandvalue;
            if(this.shouldLoadBandInfoForScene(scene)){
            bandvalue = await firstValueFrom(
            this.getBandMinMax(taskId, scene.id, this.selectedBands));
            }
          this.leftImageNew = this.helperService.createWmsLayer(
            this.map,
            filteredProducts,
            shapeFile,
            1000,
            true,
            urlData.layer.url,
            activePane,   
            bandvalue?.bands_info   
          );
        }
      } else if (urlData?.layer && scene.imageType == 'tif') {
        const layerLength = Object.keys(urlData.layer || {}).length;
        if (layerLength > 0) {
          let bandvalue;
          if(this.shouldLoadBandInfoForScene(scene)){
          bandvalue = await firstValueFrom(
          this.getBandMinMax(taskId, scene.id, this.selectedBands));
          }
          this.leftImageNew = this.helperService.createWmsLayer(
            this.map,
            urlData,
            shapeFile,
            1000,
            false,
            undefined,
            activePane,
            bandvalue?.bands_info
          );
        }
      }
      if (
        !scene?.isChangeDetectionCurrentWeekTab &&
        this.displayedIS?.isInfo?.modelType == this.infoserviceModelType
      ) {
        this.spinnerService.show();

        const payload: any = {
          action: this.combinedScenes ? 'sensorFeed' : 'ISDisplay',
          type: 'json',
          sensorId,
          ...(!this.combinedScenes && { sceneId: this.selectedSceneNew.id }),
        };

        this.apiService
          .getCollectionImage(this.collection.taskId, payload)
          .subscribe(
            (res: any) => {
              let feedDatas = res?.result?.feedData;
              this.fetchAndCombineGeoJson(feedDatas, this.displayedIS.isInfo);
            },
            (err) => {
              this.spinnerService.hide();
              this.mapLoad = false;
              this.cleanupAfterOperation();
            }
          );
      } else {
      }
      const currentWeekImageLayer = isCurrentWeekTabScene
        ? this.leftImageNew
        : null;
      if (this.leftImageNew && this.leftImageNew !== previousLeftImage) {
        createdImageLayer = this.leftImageNew;
      }
      if (isCurrentWeekTabScene) {
        this.leftImageNew = previousLeftImage;
      }
      this.applySceneOverlayOpacity(currentWeekImageLayer ?? this.leftImageNew);
      this.scenesNew.push({
        footprint: footprintlayer,
        tiffootprint: tiffootprintlayer,
        id: scene.id,
        scene: scene,
        sensorId: sensorId,
        leftImageLayer: activePane == 'left' ? this.leftImageNew : null,
        rightImageLayer: activePane == 'right' ? this.rightImageNew : null,
        currentWeekImageLayer: currentWeekImageLayer,
        legendScale: legendScale,
        pane: activePane,
      });
      if (this.superResolutionLayer) {
        this.removeSuperResolutions();
      }
      if (scene?.operatorKey == this.OPERATOR.GHG) {
        this.showMetric(this.metric, this.scenesNew[this.scenesNew.length - 1]);
      }
      (currentWeekImageLayer ?? this.leftImageNew)?.on('load', () => {
        this.pointerEvent = 'auto';
      });
    } else if (this.sensorsNew.length == 2) {
      this.isCompare = true;
      const imageLoadPromises: Promise<any>[] = [];
      const layerLength = Object.keys(urlData?.layer || {}).length;
      if (scene.imageType == 'tif' &&
        (missingChangeDetectionBaseLayer || (this.mapPane == 'right' && layerLength === 0))) {
        this.tifPopupShown = this.tifPopupShown + 1;
        if (this.tifPopupShown == 1) {
          this.resetMapNew();
          this.filterInfoVisible = false;
          const message = isChangeDetectionTiff
            ? 'There is no project-specific base map, or the base map is not loading. Please access the project data by selecting the sensor(s) next.'
            : 'not-available';
          this.mapLoad = false;
          this.spinnerService.hide();
          this.popupService
            .openPopup(CollectionPopupComponent, message, '', '40%')
            .afterClosed()
            .subscribe((result) => {
              this.resetMapNew();
              scene.checked = false;
            });
        }

        return;
      }
      if (this.mapPane == 'right') {
        if (scene.imageType == 'tif') {
          const bounds = urlData.layer.bounds;
          const baseUrl = urlData.layer.url;
          const layerName = urlData.layer.layerName;

          this.map.fitBounds(bounds);
            let bandvalue;
            if(this.shouldLoadBandInfoForScene(scene)){
            bandvalue = await firstValueFrom(
            this.getBandMinMax(taskId, scene.id, this.selectedBands));
            }
          this.rightImageNew = this.helperService.createWmsLayer(
            this.map,
            urlData,
            shapeFile,
            1000,
            false,          
            undefined,      
            this.mapPane,
            bandvalue?.bands_info        

          );

          this.rightImageNew.addTo(this.map);
        } else {
          let leafletBounds;
          if (scene?.png_footprint) {
            leafletBounds = this.convertToLeafletBounds(
              scene?.png_footprint[0]
            );
          } else {
            leafletBounds = footprintcordinates;
          }
          this.rightImageNew = L.imageOverlay(
            urlData.imageUrl,
            leafletBounds,
            { pane: this.mapPane, crossOrigin: true }
          ).addTo(this.map);
          this.map.fitBounds(leafletBounds);
          //this.handleCompareRecurrencyFeed(scene, 'right');
          this.spinnerService.hide();
        }
      } else {
        if (scene.imageType == 'tif') {
          const bounds = urlData.layer.bounds;
          const baseUrl = urlData.layer.url;
          const layerName = urlData.layer.layerName;

          this.map.fitBounds(bounds);
            let bandvalue;
            if(this.shouldLoadBandInfoForScene(scene)){
            bandvalue = await firstValueFrom(
            this.getBandMinMax(taskId, scene.id, this.selectedBands));
            }
          this.leftImageNew = this.helperService.createWmsLayer(
            this.map,
            urlData,
            shapeFile,
            1000,
            false,           
            undefined,      
            this.mapPane,
            bandvalue?.bands_info     
          )
          this.leftImageNew.addTo(this.map);
        } else {
          let leafletBounds;
          if (scene?.png_footprint) {
            leafletBounds = this.convertToLeafletBounds(
              scene?.png_footprint[0]
            );
          } else {
            leafletBounds = footprintcordinates;
          }
          //this.handleCompareRecurrencyFeed(scene, 'left');
          this.leftImageNew = L.imageOverlay(
            urlData.imageUrl,
            leafletBounds,
            { pane: this.mapPane, crossOrigin: true }
          ).addTo(this.map);
          this.spinnerService.hide();
          this.map.fitBounds(leafletBounds);
        }
      }
      const paneImageLayer = activePane === 'right' ? this.rightImageNew : this.leftImageNew;
      const previousPaneImageLayer = activePane === 'right' ? previousRightImage : previousLeftImage;
      if (paneImageLayer && paneImageLayer !== previousPaneImageLayer) {
        createdImageLayer = paneImageLayer;
      }
      this.map.on('layerremove', () => {
        this.map.off('layerremove');
      });
      await Promise.all(imageLoadPromises);
      this.applySceneOverlayOpacity(
        this.mapPane == 'right' ? this.rightImageNew : this.leftImageNew
      );
      this.scenesNew.push({
        footprint: footprintlayer,
        tiffootprint: tiffootprintlayer,
        id: scene.id,
        scene: scene,
        sensorId: sensorId,
        leftImageLayer: this.mapPane == 'left' ? this.leftImageNew : null,
        rightImageLayer: this.mapPane == 'right' ? this.rightImageNew : null,
        legendScale: legendScale,
        pane: this.mapPane,
      });

      if (scene?.operatorKey == this.OPERATOR.GHG) {
        this.showMetric(this.metric, this.scenesNew[this.scenesNew.length - 1]);
      }
      let totalScenes =
        this.sensorsNew[0]?.scenes?.filter((scene) => scene.checked == true)
          .length +
        this.sensorsNew[1]?.scenes?.filter((scene) => scene.checked == true)
          .length;

      if (!this.compare && this.leftImageNew && this.rightImageNew) {
        this.ensureCompareSplit();
        if (
          this.collection?.recurrencyArray.length > 0 ||
          this.collection?.opportunityList.length > 0
        ) {
          this.toggleCompareLabels();
        }
      }
    }
    this.applyTiffMaxZoom(scene, sensorId);
    if (this.annotateClicked) {
      this.getAnnotations();
    }
    if(this.shouldApplyCompareVisibility() && this.leftComparisonObjectLayer && this.rightImageNew && this.needsCompareResetToCenter) {
      const mapWidth = (this.map.getSize().x);
    this.updateObjectVisibility(this.lastSliderValue === 0 ? mapWidth/2 : this.lastSliderValue);
    this.needsCompareResetToCenter = false;
    }
    const publishedPane: 'left' | 'right' = scene?.pane === 'right' ? 'right' : 'left';
    if (createdImageLayer) {
      this.questionWmsHandoff.publishLayer(scene, sensorId, createdImageLayer, publishedPane);
    } else {
      this.questionWmsHandoff.publishFailure(
        scene,
        sensorId,
        publishedPane,
        new Error('WMS layer was not created for the selected scene')
      );
    }
    this.spinnerService.hide();
  }

  handleCompareRecurrencyFeed(
    scene: any,
    pane: 'left' | 'right',
    infoServiceIndex: number = 0,
    feedType: 'info' | 'associated' = 'info'
  ) {
  if (!this.isCompareRecurrency) {
    return;
  }

  const recurrencyItem = this.collection?.recurrencyArray?.find(item =>
    item?.scenes?.some(s => s?.id === scene?.id)
  );
  if (!recurrencyItem) {
    return;
  }

  const feedCollectionKey =
    feedType === 'associated' ? 'AssociatedFeeds' : 'InfoServices';
  const recurrencyInfoServices = Array.isArray(recurrencyItem[feedCollectionKey])
    ? recurrencyItem[feedCollectionKey]
    : [];

  recurrencyItem[feedCollectionKey] = recurrencyInfoServices.map(
    (service, index) => ({
      ...service,
      checked: index === infoServiceIndex
    })
  );

  const infoService = recurrencyItem?.[feedCollectionKey]?.[infoServiceIndex ?? 0];

  if (!infoService) {
    return;
  }

  if (infoService?.modelType === this.infoserviceModelType) {
    this.loadCompareFeatureExtractionFeed(
      scene,
      infoService,
      recurrencyItem,
      pane,
      feedType
    );
    return;
  }

  const insight = infoService?.insightDatas?.find(
    (sc: any) => sc.sceneId === scene.id
  );

     this.displayISNew(insight, infoService, null, true, pane);
 
}

handleCompareSensorFeed(
  scene: any,
  sensor: any,
  pane: 'left' | 'right',
  infoServiceIndex: number = 0,
  feedType: 'info' | 'associated' = 'info'
) {
  if (!sensor || !scene) {
    return;
  }

  const feedCollectionKey =
    feedType === 'associated' ? 'AssociatedFeeds' : 'InfoServices';
  const sensorInfoServices = Array.isArray(sensor?.[feedCollectionKey])
    ? sensor[feedCollectionKey]
    : [];

  sensor[feedCollectionKey] = sensorInfoServices.map((service, index) => ({
    ...service,
    checked: index === infoServiceIndex,
  }));

  const infoService = sensor?.[feedCollectionKey]?.[infoServiceIndex ?? 0];

  if (!infoService) {
    return;
  }

  if (infoService?.modelType === this.infoserviceModelType) {
    this.loadCompareFeatureExtractionFeed(
      scene,
      infoService,
      sensor,
      pane,
      feedType
    );
    return;
  }

  const insight = infoService?.insightDatas?.find(
    (sc: any) => sc.sceneId === scene?.id
  );

  if (!insight) {
    return;
  }

  this.displayISNew(insight, infoService, sensor, true, pane);
}

private loadCompareFeatureExtractionFeed(
  scene: any,
  infoService: any,
  sensor: any,
  pane: 'left' | 'right',
  feedType: 'info' | 'associated' = 'info'
): void {
  if (!scene || !infoService) {
    return;
  }

  const isAssociatedFeed = feedType === 'associated';
  const fallbackSensor = this.collection?.sensors?.[0];
  const sensorId = isAssociatedFeed
    ? infoService?.sensorId
    : sensor?.sensorId ?? sensor?.id ?? fallbackSensor?.id;
  const operatorKey =
    sensor?.operatorKey ?? scene?.operatorKey ?? fallbackSensor?.operatorKey;

  if (!sensorId) {
    return;
  }

  let payload: any;

  if (operatorKey === OPERATORS.AXELSPACE) {
    payload = {
      action: this.combinedScenes || isAssociatedFeed ? 'sensorFeed' : 'ISDisplay',
      feedId: infoService?._id,
      type: 'json',
      ...(isAssociatedFeed ? {} : { sceneId: sensorId }),
      sensorId,
    };
  } else {
    payload = {
      action: this.combinedScenes || isAssociatedFeed ? 'sensorFeed' : 'ISDisplay',
      feedId: infoService?._id,
      type: 'json',
      ...(this.combinedScenes || isAssociatedFeed || !scene?.id
        ? {}
        : { sceneId: scene.id }),
      sensorId,
    };
  }

  this.spinnerService.show();
  this.mapLoad = true;

  this.apiService.getCollectionImage(this.collection.taskId, payload).subscribe(
    (res: any) => {
      this.fetchAndCombineGeoJson(
        res?.result?.feedData,
        infoService,
        sensor,
        { isCompare: true, pane }
      );
    },
    () => {
      this.spinnerService.hide();
      this.mapLoad = false;
      this.cleanupAfterOperation();
    }
  );
}


loadInfoFeedOnCompare(
  $event,
  sensor,
  sensorIndex,
  infoServiceIndex,
  InfoService,
  feedType: 'info' | 'associated' = 'info'
) {
  const feedId = InfoService?._id;
  const config = feedId ? feedsConfig[feedId] : null;
  const feedKey = InfoService ? this.getFeedKey(InfoService, config) : null;
   if(this.compare) {
   this.compare.on('dividermove', (e: any) => {
    //this.map.dragging.disable();
    const dividerX = e.x;
    this.updateObjectVisibility(dividerX);
    this.map.dragging.enable();
   });
  }
  const feedCollectionKey =
    feedType === 'associated' ? 'AssociatedFeeds' : 'InfoServices';
  const isStandardCompare = this.isStandardMultiSensorCompareActive(sensor);

  if (isStandardCompare && feedType === 'associated') {
    this.clearAssociatedFeedsForCompare(sensor);
    return;
  }

  if (isStandardCompare) {
    const comparePane = this.getComparePaneForSensor(sensor);
    const compareScene = this.getCompareSceneForSensor(sensor, comparePane);
    const sensorInfoServices = Array.isArray(sensor?.[feedCollectionKey])
      ? sensor[feedCollectionKey]
      : [];

    sensor[feedCollectionKey] = sensorInfoServices.map((service: any, index: number) => ({
      ...service,
      checked: index === infoServiceIndex ? $event.checked : false,
    }));

    if ($event.checked) {
      if (comparePane && compareScene) {
        this.handleCompareSensorFeed(
          compareScene,
          sensor,
          comparePane,
          infoServiceIndex,
          feedType
        );
      }
    } else {
      this.needsCompareResetToCenter = true;

      if (feedKey && comparePane === 'left') {
        this.removeLeftFeedPanel(feedKey);
      }

      if (feedKey && comparePane === 'right') {
        this.removeRightFeedPanel(feedKey);
      }

      if (
        comparePane === 'left' &&
        this.leftComparisonObjectLayer &&
        this.map.hasLayer(this.leftComparisonObjectLayer)
      ) {
        this.map.removeLayer(this.leftComparisonObjectLayer);
        this.leftComparisonObjectLayer = null;
        this.leftFeedPanels.clear();
        this.clearCompareFeedCache('left');
      }

      if (
        comparePane === 'right' &&
        this.rightComparisonObjectLayer &&
        this.map.hasLayer(this.rightComparisonObjectLayer)
      ) {
        this.map.removeLayer(this.rightComparisonObjectLayer);
        this.rightComparisonObjectLayer = null;
        this.rightFeedPanels.clear();
        this.clearCompareFeedCache('right');
      }
    }

    if (InfoService) {
      const currentEvent = $event.checked ? { ...$event, checked: true } : $event;
      this.updateFeedInfo(sensor, currentEvent, feedKey);
    }

    return;
  }

  const recurrencyInfoServices = Array.isArray(
    this.collection?.recurrencyArray?.[sensorIndex]?.[feedCollectionKey]
  )
    ? this.collection.recurrencyArray[sensorIndex][feedCollectionKey]
    : [];

  if (this.collection?.recurrencyArray?.[sensorIndex]) {
    this.collection.recurrencyArray[sensorIndex][feedCollectionKey] =
      recurrencyInfoServices.map((service, i) => ({
        ...service,
        checked: i === infoServiceIndex ? $event.checked : false
      }));
  }
  if($event.checked) {
    const comparePane = sensor?.pane === 'left' || sensor?.pane === 'right'
      ? sensor.pane
      : this.getComparePaneForSensor(sensor);
    const compareScene = this.getCompareSceneForSensor(sensor, comparePane);

       if(comparePane === 'left' && compareScene){
      this.handleCompareRecurrencyFeed(compareScene, 'left', infoServiceIndex, feedType);
    }
    
    if(comparePane === 'right' && compareScene){
      this.handleCompareRecurrencyFeed(compareScene, 'right', infoServiceIndex, feedType);
    }
     let feedId = '';
     let config: any = '';
     if (InfoService) {
      const fakeEvent = { ...$event, checked: true };
       this.updateFeedInfo(
        this.isStandardMultiSensorCompareActive(sensor)
          ? sensor
          : this.selectedCheckboxesNew[sensorIndex],
        fakeEvent,
        feedKey
       ) 
    }
  } else {
    this.needsCompareResetToCenter = true;

    if (feedKey && sensor.pane === 'left') {
      this.removeLeftFeedPanel(feedKey);
    }

    if (feedKey && sensor.pane === 'right') {
      this.removeRightFeedPanel(feedKey);
    }

        if(sensor.pane === 'left' && this.leftComparisonObjectLayer && this.map.hasLayer(this.leftComparisonObjectLayer)){
      this.map.removeLayer(this.leftComparisonObjectLayer);
      //this.map.removeLayer(this.leftImageNew);
      this.leftComparisonObjectLayer = null;
     this.leftFeedPanels.clear();
      this.clearCompareFeedCache('left');
    }
    
    if(sensor.pane === 'right' && this.rightComparisonObjectLayer && this.map.hasLayer(this.rightComparisonObjectLayer)){
      this.map.removeLayer(this.rightComparisonObjectLayer);
      this.rightComparisonObjectLayer = null;
     this.rightFeedPanels.clear();
      this.clearCompareFeedCache('right');
    }
    if (this.selectedCheckboxesNew[sensorIndex]?.[feedCollectionKey]?.[infoServiceIndex]) {
      this.selectedCheckboxesNew[sensorIndex][feedCollectionKey][infoServiceIndex].checked = false;
    }
  this.removeCompareWhenSinglePaneRemains();
    if (this.changeDetectionHistorySelections.length > 0) {
      this.rebuildChangeDetectionHistoryCompare(
        this.collection,
        this.collection?.sensors?.[0] ?? sensor
      );
    } else {
      this.restoreSingleChangeDetectionSelection(
        this.collection,
        this.collection?.sensors?.[0] ?? sensor
      );
    }
  }
}

private getComparePaneForSensor(sensor: any): 'left' | 'right' | null {
  if (sensor?.pane === 'left' || sensor?.pane === 'right') {
    return sensor.pane;
  }

  const compareScene = sensor?.scenes?.find(
    (scene: any) =>
      scene?.checked && (scene?.pane === 'left' || scene?.pane === 'right')
  );

  if (compareScene?.pane === 'left' || compareScene?.pane === 'right') {
    return compareScene.pane;
  }

  return null;
}

private getCompareSceneForSensor(
  sensor: any,
  pane?: 'left' | 'right' | null
): any {
  const validScenes = Array.isArray(sensor?.scenes)
    ? sensor.scenes.filter(
        (scene: any) => scene?.id && scene?.status !== 'failed'
      )
    : [];

  return (
    validScenes.find(
      (scene: any) => scene?.checked === true && (!pane || scene?.pane === pane)
    ) ??
    validScenes.find((scene: any) => scene?.checked === true) ??
    validScenes.find((scene: any) => !pane || scene?.pane === pane) ??
    validScenes[0] ??
    null
  );
}

private syncStandardCompareSideData(): void {
  const compareSensors = Array.isArray(this.sensorsNew) && this.sensorsNew.length > 0
    ? this.sensorsNew
    : this.selectedCheckboxesNew;

  if (!Array.isArray(compareSensors)) {
    this.leftData = [];
    this.rightData = [];
    return;
  }

  this.leftData = compareSensors.filter(
    (sensor: any) => this.getComparePaneForSensor(sensor) === 'left'
  );
  this.rightData = compareSensors.filter(
    (sensor: any) => this.getComparePaneForSensor(sensor) === 'right'
  );
}

get compareLegendSelectionCount(): number {
  if (Array.isArray(this.selectedCheckboxesNew) && this.selectedCheckboxesNew.length > 0) {
    return this.selectedCheckboxesNew.length;
  }

  if (Array.isArray(this.sensorsNew) && this.sensorsNew.length > 0) {
    return this.sensorsNew.length;
  }

  return 0;
}

// Supplier attribution required by some operators' licenses for the displayed image.
private getImageSupplier(entry: any): string | null {
  if (!entry) {
    return null;
  }
  const sensor =
    (this.sensorsNew ?? []).find((s: any) => s?.id === entry.sensorId) ??
    (this.collection?.sensors ?? []).find((s: any) => s?.id === entry.sensorId);
  const operatorKey = sensor?.operatorKey ?? entry.scene?.operatorKey;
  return IMAGE_ATTRIBUTION_SUPPLIERS[operatorKey] ?? null;
}

get leftImageSupplier(): string | null {
  return this.getImageSupplier(this.scenesNew?.find((entry: any) => entry?.pane !== 'right'));
}

get rightImageSupplier(): string | null {
  return this.getImageSupplier(this.scenesNew?.find((entry: any) => entry?.pane === 'right'));
}

// Single view: whichever scene is still displayed, regardless of the pane it was loaded into.
get singleImageSupplier(): string | null {
  for (const entry of this.scenesNew ?? []) {
    const supplier = this.getImageSupplier(entry);
    if (supplier) {
      return supplier;
    }
  }
  return null;
}

get isImageAttributionCompare(): boolean {
  return (
    !!this.compare &&
    !!this.scenesNew?.some((entry: any) => entry?.pane === 'right') &&
    !!this.scenesNew?.some((entry: any) => entry?.pane !== 'right')
  );
}

// True when the feed legends are rendered inside the left/right pane date labels.
get showsPaneLabelFeedLegends(): boolean {
  return (
    this.compareLegendSelectionCount > 1 ||
    this.changeDetectionHistorySelections.length > 1
  );
}

isStandardMultiSensorCompareActive(sensor?: any): boolean {
  // if (!this.isCompare || this.timeseries || this.isLoadFeedComapre) {
  //   return false;
  // }

  if (!Array.isArray(this.sensorsNew) || this.sensorsNew.length !== 2) {
    return false;
  }

  const comparePanes = this.sensorsNew
    .map((currentSensor: any) => this.getComparePaneForSensor(currentSensor))
    .filter((pane): pane is 'left' | 'right' => pane === 'left' || pane === 'right');

  const hasBothPanes =
    comparePanes.includes('left') && comparePanes.includes('right');

  if (!hasBothPanes) {
    return false;
  }

  if (!sensor) {
    return true;
  }

  return this.getComparePaneForSensor(sensor) !== null;
}

private shouldApplyCompareVisibility(): boolean {
  return this.isCompareRecurrency || this.isStandardMultiSensorCompareActive();
}

// Rebuilds the SplitMap against whatever images are currently displayed so it
// never keeps clipping stale/removed layers from an earlier scene selection.
private ensureCompareSplit(): void {
  if (!this.map || !this.leftImageNew || !this.rightImageNew) {
    return;
  }

  if (this.compare) {
    this.map.removeControl(this.compare);
    this.compare = null;
  }

  this.compare = new SplitMap(this.leftImageNew, this.rightImageNew).addTo(this.map);
  this.compare.on('dividermove', (e: any) => {
    const dividerX = e.x;
    this.updateObjectVisibility(dividerX);
    this.map.dragging.enable();
  });
}

updateObjectVisibility(dividerX: number) {
  this.lastSliderValue = dividerX;

  if (!this.map) {
    return;
  }

  const mapWidth = this.map.getSize().x;
  const boundedDividerX = Math.max(0, Math.min(dividerX, mapWidth));
  this.updateCompareLegendVisibility(boundedDividerX, mapWidth);

  this.pendingCompareDividerX = boundedDividerX;

  if (this.compareRenderFrameId !== null) {
    return;
  }

  this.compareRenderFrameId = window.requestAnimationFrame(() => {
    this.compareRenderFrameId = null;

    if (this.pendingCompareDividerX === null) {
      return;
    }

    const currentDividerX = this.pendingCompareDividerX;
    this.pendingCompareDividerX = null;
    this.renderCompareVisibility(currentDividerX);
  });
  if (this.leftComparisonObjectLayer) {
    this.leftComparisonObjectLayer.eachLayer((layer: any) => {
      const bounds = layer.getBounds?.();
      if (!bounds) {
        return;
      }

      const northWest = this.map.latLngToContainerPoint(bounds.getNorthWest());
      const southEast = this.map.latLngToContainerPoint(bounds.getSouthEast());
      const minX = Math.min(northWest.x, southEast.x);
      const leftOpacity = minX < dividerX ? 1 : 0;

      layer.setStyle?.({
        opacity: leftOpacity,
        fillOpacity: leftOpacity,
      });
    });
  }

   if (this.rightComparisonObjectLayer) {
    this.rightComparisonObjectLayer.eachLayer((layer: any) => {
      const bounds = layer.getBounds?.();
      if (!bounds) {
        return;
      }

      const northWest = this.map.latLngToContainerPoint(bounds.getNorthWest());
      const southEast = this.map.latLngToContainerPoint(bounds.getSouthEast());
      const maxX = Math.max(northWest.x, southEast.x);
      const rightOpacity = maxX > dividerX ? 1 : 0;

      layer.setStyle?.({
        opacity: rightOpacity,
        fillOpacity: rightOpacity,
      });
    });
  }
}

private updateCompareLegendVisibility(dividerX: number, mapWidth: number): void {
  // The labels sit near the outer quarters of the map. Hide a side when the
  // divider reaches its label, and restore it as soon as there is room again.
  this.hideLeftCompareLegend = dividerX < mapWidth * 0.26;
  this.hideRightCompareLegend = dividerX > mapWidth * 0.74;
  // Leaflet's divider event can fire outside Angular change detection. Apply
  // the same state to the mounted legends immediately during a drag.
  const root = this.el?.nativeElement as HTMLElement | undefined;
  root?.querySelectorAll<HTMLElement>('[data-compare-legend="left"]').forEach((legend) => {
    legend.style.visibility = this.hideLeftCompareLegend ? 'hidden' : 'visible';
  });
  root?.querySelectorAll<HTMLElement>('[data-compare-legend="right"]').forEach((legend) => {
    legend.style.visibility = this.hideRightCompareLegend ? 'hidden' : 'visible';
  });
}

private renderCompareVisibility(dividerX: number): void {
  this.renderCompareSide('left', dividerX);
  this.renderCompareSide('right', dividerX);
  this.applyComparePaneClip(dividerX);
}

// Pixel-level safety net: mirrors SplitMap._updateClip's CSS clip so a side's feed
// pane never paints past the divider even if the turf geometry clip above is off.
// Clips the canonical 'left-objects'/'right-objects' panes directly (not via
// compareFeedCache) since more than one feed-loading pipeline renders into them.
private applyComparePaneClip(dividerX: number): void {
  if (!this.map) {
    return;
  }

  const nw = this.map.containerPointToLayerPoint([0, 0]);
  const se = this.map.containerPointToLayerPoint(this.map.getSize());
  const clipX = nw.x + dividerX;

  const leftPane = this.map.getPane('left-objects');
  if (leftPane) {
    leftPane.style.clip = `rect(${nw.y}px,${clipX}px,${se.y}px,${nw.x}px)`;
  }

  const rightPane = this.map.getPane('right-objects');
  if (rightPane) {
    rightPane.style.clip = `rect(${nw.y}px,${se.x}px,${se.y}px,${clipX}px)`;
  }
}

private resetComparePaneClip(side?: ComparePaneSide): void {
  const sides: ComparePaneSide[] = side ? [side] : ['left', 'right'];

  sides.forEach((s) => {
    const pane = this.map?.getPane(`${s}-objects`);
    if (pane) {
      pane.style.clip = '';
    }
  });
}


private renderCompareSide(side: ComparePaneSide, dividerX: number): void {
  const cache = this.compareFeedCache[side];
  const registeredLayer = side === 'left' ? this.leftComparisonObjectLayer : this.rightComparisonObjectLayer;
  if (this.isRegisteredViewportLayer(registeredLayer)) {
    this.applyComparePaneClip(dividerX);
    return;
  }

  if (!this.map || !cache) {
    return;
  }

  const nextLayer = this.buildFeedGeoJsonLayer(
    this.buildClippedCompareCollection(cache, dividerX),
    cache.config,
    cache.color,
    cache.feedName,
    cache.paneName
  );

  const currentLayer =
    side === 'left'
      ? this.leftComparisonObjectLayer
      : this.rightComparisonObjectLayer;

  if (currentLayer && this.map.hasLayer(currentLayer)) {
    this.map.removeLayer(currentLayer);
  }

  nextLayer.addTo(this.map);

  if (side === 'left') {
    this.leftComparisonObjectLayer = nextLayer;
  } else {
    this.rightComparisonObjectLayer = nextLayer;
  }
}

private buildClippedCompareCollection(
  cache: CompareFeedCache,
  dividerX: number
): FeatureCollection<Geometry, FeatureProps> {
  const clipBounds = this.getCompareClipBounds(cache.side, dividerX);

  if (!clipBounds) {
    return cache.fc;
  }

  const features = (cache.fc.features ?? [])
    .map((feature) => this.clipCompareFeature(feature, clipBounds, cache.side, dividerX))
    .filter((feature): feature is Feature<Geometry, FeatureProps> => !!feature);

  return {
    type: 'FeatureCollection',
    features,
  };
}

private getCompareClipBounds(
  side: ComparePaneSide,
  dividerX: number
): [number, number, number, number] | null {
  if (!this.map) {
    return null;
  }

  const mapSize = this.map.getSize();
  const startX = side === 'left' ? 0 : dividerX;
  const endX = side === 'left' ? dividerX : mapSize.x;

  const topLeft = this.map.containerPointToLatLng([startX, 0]);
  const bottomRight = this.map.containerPointToLatLng([endX, mapSize.y]);

  return [
    Math.min(topLeft.lng, bottomRight.lng),
    Math.min(bottomRight.lat, topLeft.lat),
    Math.max(topLeft.lng, bottomRight.lng),
    Math.max(bottomRight.lat, topLeft.lat),
  ];
}

private clipCompareFeature(
  feature: Feature<Geometry, FeatureProps>,
  clipBounds: [number, number, number, number],
  side: ComparePaneSide,
  dividerX: number
): Feature<Geometry, FeatureProps> | null {
  const geometryType = feature?.geometry?.type;

  if (!geometryType) {
    return null;
  }

  if (
    geometryType === 'Polygon' ||
    geometryType === 'MultiPolygon' ||
    geometryType === 'LineString' ||
    geometryType === 'MultiLineString'
  ) {
    return this.clipVectorCompareFeature(feature, clipBounds);
  }

  return this.isFeatureVisibleOnCompareSide(feature, side, dividerX)
    ? feature
    : null;
}

private clipVectorCompareFeature(
  feature: Feature<Geometry, FeatureProps>,
  clipBounds: [number, number, number, number]
): Feature<Geometry, FeatureProps> | null {
  try {
    const [featureMinLng, featureMinLat, featureMaxLng, featureMaxLat] = turf.bbox(feature);
    const [clipMinLng, clipMinLat, clipMaxLng, clipMaxLat] = clipBounds;

    if (
      featureMaxLng <= clipMinLng ||
      featureMinLng >= clipMaxLng ||
      featureMaxLat <= clipMinLat ||
      featureMinLat >= clipMaxLat
    ) {
      return null;
    }

    // Always clip to the divider rect (never short-circuit on bbox containment) so a
    // polygon merely touching the divider only renders the sliver on this pane's side.
    const clipped = turf.bboxClip(feature, clipBounds) as Feature<Geometry, FeatureProps>;

    return this.hasRenderableGeometry(clipped?.geometry) ? clipped : null;
  } catch {
    return null;
  }
}

private isFeatureVisibleOnCompareSide(
  feature: Feature<Geometry, FeatureProps>,
  side: ComparePaneSide,
  dividerX: number
): boolean {
  if (!this.map) {
    return false;
  }

  try {
    const centroid = turf.centroid(feature);
    const [lng, lat] = centroid.geometry.coordinates;
    const point = this.map.latLngToContainerPoint([lat, lng]);

    return side === 'left' ? point.x < dividerX : point.x >= dividerX;
  } catch {
    return true;
  }
}

private hasRenderableGeometry(geometry: Geometry | null | undefined): boolean {
  if (!geometry) {
    return false;
  }

  const coordinates = (geometry as any).coordinates;

  if (!Array.isArray(coordinates)) {
    return false;
  }

  return this.hasNestedCoordinates(coordinates);
}

private hasNestedCoordinates(value: any): boolean {
  if (!Array.isArray(value) || value.length === 0) {
    return false;
  }

  if (typeof value[0] === 'number') {
    return value.length >= 2;
  }

  return value.some((entry) => this.hasNestedCoordinates(entry));
}

private orderMiningChangeFeatures<T extends FeatureCollection>(collection: T, feedType?: string): T {
  if (feedType !== 'Mining changes monitoring') return collection;

  // Leaflet paints later features on top. Keep the source data order untouched.
  const isBaseline = (feature: Feature) =>
    String(feature.properties?.['class'] ?? '').trim().toLowerCase() === 'baseline';
  return {
    ...collection,
    features: [...(collection.features ?? [])].sort(
      (a, b) => Number(isBaseline(a)) - Number(isBaseline(b))
    ),
  };
}

private buildFeedGeoJsonLayer(
  featureCollection: FeatureCollection<Geometry, FeatureProps>,
  config: any,
  color: any,
  feedName: string,
  objectPane: string
): any {
  const pointRenderer = L.canvas({ padding: 0.5, pane: objectPane });

  const layer = (L as any).geoJSON(this.orderMiningChangeFeatures(featureCollection, config?.type), {
    pane: objectPane,
    style: (feature: any) => {
      const isSoilMoisture = config?.type === 'Soil Moisture - SAR';
      const isVesselClassification = config?.type === 'Vessel-classification';
      const isVehicleClassification = config?.type === 'Vehicle-classification';
      const isPrediction = isPredictionFeedType(config?.type);

      const cls = feature?.properties?.class ?? feature?.properties?.depth_class;

      if (isSoilMoisture && cls != null) {
        const entry = SOIL_MOISTURE_SAR_CLASS_MAP[cls];
        if (entry) {
          return {
            color: entry.color,
            fillColor: entry.color,
            fillOpacity: 0.8,
            weight: 0.4,
          };
        }
      } else if (isVesselClassification && cls != null) {
        const entry = VESSEL_CLASS_COLOR_MAP[cls];
        if (entry) {
          return {
            color: entry.color,
            fillColor: entry.color,
            fillOpacity: 1.0,
          };
        }
       } else if (config?.type === 'Flood Inundation') {
          let rawCls = feature?.properties?.depth_class ?? feature?.properties?.depth_clas ?? cls;
          const normalizedCls = rawCls
            ? String(rawCls).replace(/[\u2010-\u2015\u2212\-\?]/g, '–').trim()
            : rawCls;
          const entry = FLOOD_INUNDATION_DEPTH_CLASS_MAP[normalizedCls] || FLOOD_INUNDATION_DEPTH_CLASS_MAP[rawCls];
          if (entry) {
            return {
              color: entry.color,
              fillColor: entry.color,
              fillOpacity: 1,
              weight: 0.4,
            };
          }
        } else if (isVehicleClassification && cls != null) {
          const entry = (VEHICLE_CLASS_COLOR_MAP as any)[cls];
          if (entry) {
            return { color: entry.color, fillColor: entry.color, fillOpacity: 0.8, weight: 3 };
          }
       } else if (isPrediction) {
          if (
            (feature?.geometry?.type === 'Polygon' || feature?.geometry?.type === 'MultiPolygon') &&
            !this.isPredictionForecastFeature(feature)
          ) {
            const detectionColor = this.getPredictionDetectionColor(config, feature, color);
            return { color: detectionColor, fillColor: detectionColor, fillOpacity: 1, weight: 2 };
          }
          const forecastColor = this.getPredictionColor(config, feature, color);
          return { color: forecastColor, fillColor: forecastColor, fillOpacity: 0.75, weight: 0 };
         } else if (config?.colorMode == 'CLASS_BASED') {
          const feedColor = config?.color ?? color;
          const normalizedCls = typeof cls === 'string' ? cls.trim() : cls;
          const normalizedClassKey = typeof normalizedCls === 'string'
            ? Object.keys(feedColor ?? {}).find((key) => key.toLowerCase() === normalizedCls.toLowerCase())
            : normalizedCls;
          const classColor =
            feedColor?.[normalizedClassKey]?.color ??
            feedColor?.[String(normalizedCls)]?.color ??
            (config?.type === 'Mining changes monitoring' ? feedColor?.Change?.color : undefined);
          return {
            color: classColor,
            fillColor: classColor,
            fillOpacity: 1.0,
          };
      }

      const feedColor = color;
      return {
        color: feedColor,
        fillColor: feedColor,
        fillOpacity: 1.0,
      };
    },
    pointToLayer: (ftr: any, latlng: any) => {
      if (isPredictionFeedType(config?.type)) {
          const forecastColor = this.getPredictionColor(config, ftr, color);
          return L.circleMarker(latlng, {
            radius: 2,
            color: forecastColor,
            weight: 0,
            fillColor: forecastColor,
            fillOpacity: 0.75,
            renderer: pointRenderer,
          });
      }
      if (config?.type === 'Tuna-detection') {
        return L.circleMarker(latlng, {
          radius: 6,
          fillColor: '#2ecc71',
          color: '#27ae60',
          weight: 2,
          opacity: 0.9,
          fillOpacity: 0.8,
          pane: objectPane,
        });
      }

      if (
        this.nonVesselFeed.findIndex((item) => item.name == feedName) != -1 &&
        (ftr.geometry.type === 'Point' || ftr.geometry.type === 'MultiPoint') &&
        feedName === 'Tree crown detection and count'
      ) {
        return new L.Marker(latlng, {
          icon: new L.DivIcon({
            className: 'leaflet-div-icon',
            html: `
                <div style="
                  width: 10px; 
                  height: 10px; 
                  border-radius: 50%; 
                  background-color: green; 
                  border: 2px solid darkgreen;
                  box-shadow: 0 0 3px rgba(0,0,0,0.3);
                "></div>`,
            iconSize: [10, 10],
            iconAnchor: [5, 5],
          }),
        });
      }

      if (config?.type === 'Container detection') {
        const dotCanvas = L.canvas({ padding: 0.5, pane: objectPane });
        return L.circleMarker(latlng, {
          radius: 2,
          color,
          weight: 1,
          fillColor: color,
          fillOpacity: 0.9,
          renderer: dotCanvas,
        });
      }

      return new L.Marker(latlng);
    },
    onEachFeature: (ftr: any, lyr: any) => {
    if (isPredictionFeedType(config?.type)) {
          attachForecastPointHoverPopup({
            layer: lyr,
            feature: ftr,
            map: this.map,
            nudgeInsideView: this.nudgeInsideView.bind(this),
            pickDirection: this.pickDirection.bind(this),
            showEeTooltip: this.showFeatureTooltip.bind(this),
            onForecastHover: (hour) => (this.hoveredPredictionForecastHour = hour),
          });
        } else {
          attachVesselHoverPopup({
            layer: lyr,
            feature: ftr,
            feedName,
            map: this.map,
            nonVesselFeed: this.nonVesselFeed,
            helperService: this.helperService,
            nudgeInsideView: this.nudgeInsideView.bind(this),
            pickDirection: this.pickDirection.bind(this),
            showEeTooltip: this.showFeatureTooltip.bind(this),
          });
        }
    },
  });

  if (isPredictionFeedType(config?.type) && !['left-objects', 'right-objects'].includes(objectPane)) {
    this.allowFeedHoverThroughForecastCanvas(layer, pointRenderer);
  }
  return layer;
}

/** A canvas covers the map even where no forecast dot is drawn. Forward hover
 * to Leaflet's canvas hit test while letting other feed layers receive DOM hover. */
private allowFeedHoverThroughForecastCanvas(layer: L.GeoJSON, renderer: L.Canvas): void {
  const canvas = renderer as any;
  let mapElement: HTMLElement | null = null;
  const canvasEvent = (event: MouseEvent) => ({
    type: event.type,
    target: canvas._container,
    clientX: event.clientX,
    clientY: event.clientY,
    button: event.button,
  });
  const onMove = (event: MouseEvent) => {
    const target = event.target as Element;
    const interactiveTarget = target.closest?.('.leaflet-interactive');
    const isOtherFeedFeature = interactiveTarget &&
      !canvas._container.parentElement?.contains(interactiveTarget);
    if (isOtherFeedFeature ||
        (target !== mapElement && !target.closest?.('.leaflet-map-pane'))) {
      canvas._handleMouseOut(canvasEvent(event));
      return;
    }
    canvas._onMouseMove(canvasEvent(event));
  };
  const onLeave = (event: MouseEvent) => canvas._handleMouseOut(canvasEvent(event));
  const detach = () => {
    if (!mapElement) return;
    mapElement.removeEventListener('mousemove', onMove, true);
    mapElement.removeEventListener('mouseleave', onLeave);
    canvas._handleMouseOut({ type: 'mouseout', target: canvas._container });
    mapElement = null;
  };
  const attach = () => {
    if (!this.map?.hasLayer(layer) || !canvas._container || mapElement) return;
    canvas._container.style.pointerEvents = 'none';
    mapElement = this.map.getContainer();
    mapElement.addEventListener('mousemove', onMove, true);
    mapElement.addEventListener('mouseleave', onLeave);
  };
  layer.on('add', attach);
  layer.on('remove', detach);
  renderer.on('add', attach);
}

private clearCompareFeedCache(side?: ComparePaneSide): void {
  this.resetComparePaneClip(side);

  if (!side) {
    this.compareFeedCache = {};
  } else {
    delete this.compareFeedCache[side];
  }

  if (!this.compareFeedCache.left && !this.compareFeedCache.right) {
    this.pendingCompareDividerX = null;
    if (this.compareRenderFrameId !== null) {
      window.cancelAnimationFrame(this.compareRenderFrameId);
      this.compareRenderFrameId = null;
    }
  }
}

private clearDisplayedCompareFeedLayers(): void {
  if (this.leftComparisonObjectLayer && this.map?.hasLayer(this.leftComparisonObjectLayer)) {
    this.map.removeLayer(this.leftComparisonObjectLayer);
  }
  if (this.rightComparisonObjectLayer && this.map?.hasLayer(this.rightComparisonObjectLayer)) {
    this.map.removeLayer(this.rightComparisonObjectLayer);
  }

  this.leftComparisonObjectLayer = null;
  this.rightComparisonObjectLayer = null;
  this.leftFeedPanels.clear();
  this.rightFeedPanels.clear();
  this.clearCompareFeedCache();
  this.needsCompareResetToCenter = true;
}

private restoreRemainingFeedLayerAfterCompareReset(
  sensor: any,
  compareCache?: CompareFeedCache | null
): void {
  if (!sensor || this.shouldApplyCompareVisibility()) {
    return;
  }

  const activeFeed = this.getCombinedFeedsForSensor(sensor).find(
    (feed: any) => feed?.checked === true
  );
  if (!activeFeed) {
    return;
  }

  const activeScene = this.getActiveSceneForSensor(sensor);
  const cachedInsight =
    activeFeed?.insightDatas?.find(
      (insight: any) => insight?.sceneId === activeScene?.id
    ) ?? activeFeed?.insightDatas?.[0];
  const insightFootprint = compareCache?.fc ?? cachedInsight?.insightFootprint;

  if (!insightFootprint) {
    return;
  }

  const feedConfig = activeFeed?._id ? feedsConfig?.[activeFeed._id] : null;
  const feedKey = this.getFeedKey(activeFeed, feedConfig);

  this.removeDataLayer(activeFeed);
  this.removeFeedPanel(feedKey);
  this.activeFeedKeys.delete(feedKey);
  this.clearFeedFilterState(feedKey);

  const sceneInfo = cachedInsight
    ? { ...cachedInsight, insightFootprint, isInfo: activeFeed, sensor }
    : { insightFootprint, isInfo: activeFeed, sensor };

  this.displayISNew(sceneInfo, activeFeed, sensor, false);
  this.displayedIS = {
    insightFootprint: JSON.parse(JSON.stringify(insightFootprint)),
    isInfo: activeFeed,
  };
}

  async displayFootprintImageTimeseriesNew(
    scene: any,
    urlData: any,
    sensorId: any
  ) {
    this.mapPane = 'left';
    const {
      tiffootprintlayer,
      tifcordinates,
      footprintcordinates,
      footprintlayer,
    } = this.FetchCordinatesOfImage(scene, 'left');
    if (urlData?.imageUrl) {
      let leafletBounds: any;
          if (scene?.png_footprint) {
            leafletBounds = this.convertToLeafletBounds(
              scene?.png_footprint[0]
            );
          } else {
            leafletBounds = footprintcordinates;
          }

          this.leftImageNew = L.imageOverlay(urlData.imageUrl, leafletBounds, {
            pane: this.mapPane,
            opacity: 1,
            crossOrigin: true,
          }).addTo(this.map);
          this.map.fitBounds(this.leftImageNew.getBounds());
          this.spinnerService.hide();
    }
    this.scenesNew.push({
      footprint: footprintlayer,
      tiffootprint: tiffootprintlayer,
      id: scene.id,
      scene: scene,
      renderedPredictedDate: scene?.predicted_date?.split('T')[0],
      sensorId: sensorId,
      leftImageLayer: this.leftImageNew,
      rightImageLayer: this.rightImageNew,
      pane: this.mapPane,
    });
    if (scene?.operatorKey == this.OPERATOR.GHG) {
      this.showMetric(this.metric, this.scenesNew[this.scenesNew.length - 1]);
    }
  }

  async displayFootprintImageByRecurrentDataNew(
    scene: any,
    urlData: any,
    sensorId: any,
    dataList: any
  ) {
    if (this.mapPane == '') {
      this.mapPane = 'left';
    }
    const {
      tiffootprintlayer,
      tifcordinates,
      footprintcordinates,
      footprintlayer,
    } = await this.FetchCordinatesOfImage(scene, this.mapPane);
    let dateSelected: any;
    if (dataList.length == 1) {
      const imageLoadPromises: Promise<any>[] = [];
      if (urlData?.imageUrl) {
        if (scene.imageType == 'tif') {
          const bounds = urlData.layer.bounds;
          const baseUrl = urlData.layer.url;
          const layerName = urlData.layer.layerName;

          this.map.fitBounds(bounds);
            let bandvalue;
            if(this.shouldLoadBandInfoForScene(scene)){
            bandvalue = await firstValueFrom(
            this.getBandMinMax(this.collection?.taskId, scene.id, this.selectedBands));
            }
          this.leftImageNew = this.helperService.createWmsLayer(
            this.map,
            urlData,
            this.imageType,
            1000,
            false,          
            undefined,      
            this.mapPane,
            bandvalue?.bands_info     

          );

          this.leftImageNew.addTo(this.map);
        } else {
          this.leftImageNew = L.imageOverlay(
            urlData.imageUrl,
            footprintcordinates,
            { pane: this.mapPane, crossOrigin: true }
          ).addTo(this.map);
        }
        this.map.fitBounds(footprintcordinates);
      }
      await Promise.all(imageLoadPromises);
      this.scenesNew.push({
        footprint: footprintlayer,
        tiffootprint: tiffootprintlayer,
        id: scene.id,
        scene: scene,
        sensorId: sensorId,
        leftImageLayer: this.leftImageNew,
        rightImageLayer: this.rightImageNew,
        pane: this.mapPane,
      });
      if (scene?.operatorKey == this.OPERATOR.GHG) {
        this.showMetric(this.metric, this.scenesNew[this.scenesNew.length - 1]);
      }
      this.selectedCheckboxesNew.forEach((date) => {
        let start_date = this.datePipe.transform(
          date.start,
          'dd/MM/yyyy',
          'UTC'
        );
        let end_date = this.datePipe.transform(date.end, 'dd/MM/yyyy', 'UTC');
        dateSelected = start_date + ' - ' + end_date;
      });
      this.filterSiteData = [];
      this.selectedSites.forEach((item) => {
        this.filterDateData.push(dateSelected);
        this.filterSiteData.push(item?.siteName);
      });
    } else if (dataList.length == 2) {
      const imageLoadPromises: Promise<any>[] = [];
      if (this.mapPane == 'right') {
        if (scene.imageType == 'tif') {
          const bounds = urlData.layer.bounds;
          const baseUrl = urlData.layer.url;
          const layerName = urlData.layer.layerName;

          this.map.fitBounds(bounds);
            let bandvalue;
            if(this.shouldLoadBandInfoForScene(scene)){
            bandvalue = await firstValueFrom(
            this.getBandMinMax(this.collection?.taskId, scene.id, this.selectedBands));
            }
          this.rightImageNew = this.helperService.createWmsLayer(
            this.map,
            urlData,
            this.imageType,
            1000,
            false,           
            undefined,      
            this.mapPane,
            bandvalue?.bands_info     

          );

          this.rightImageNew.addTo(this.map);
        } else {
          this.rightImageNew = L.imageOverlay(
            urlData.imageUrl,
            footprintcordinates,
            { pane: this.mapPane, crossOrigin: true }
          ).addTo(this.map);
          this.map.fitBounds(footprintcordinates);
          this.spinnerService.hide();
        }
      } else {
        if (scene.imageType == 'tif') {
          const bounds = urlData.layer.bounds;
          const baseUrl = urlData.layer.url;
          const layerName = urlData.layer.layerName;

          this.map.fitBounds(bounds);

            let bandvalue;
            if(this.shouldLoadBandInfoForScene(scene)){
            bandvalue = await firstValueFrom(
            this.getBandMinMax(this.collection?.taskId, scene.id, this.selectedBands));
            }
          this.leftImageNew = this.helperService.createWmsLayer(
            this.map,
            urlData,
            this.imageType,
            1000,
            false,          
            undefined,      
            this.mapPane,
            bandvalue?.bands_info     

          );

          this.leftImageNew.addTo(this.map);
        } else {
          this.leftImageNew = L.imageOverlay(
            urlData.imageUrl,
            footprintcordinates,
            { pane: this.mapPane, crossOrigin: true }
          ).addTo(this.map);
          this.spinnerService.hide();
          this.map.fitBounds(footprintcordinates);
        }
      }
      this.map.on('layerremove', () => {
        this.map.off('layerremove');
      });
      await Promise.all(imageLoadPromises);
      this.scenesNew.push({
        footprint: footprintlayer,
        tiffootprint: tiffootprintlayer,
        id: scene.id,
        scene: scene,
        sensorId: sensorId,
        rightImageLayer: this.rightImageNew,
        leftImageLayer: this.leftImageNew,
        pane: this.mapPane,
      });
      if (scene?.operatorKey == this.OPERATOR.GHG) {
        this.showMetric(this.metric, this.scenesNew[this.scenesNew.length - 1]);
      }
      if (!this.compare && this.leftImageNew && this.rightImageNew) {
        this.ensureCompareSplit();
        this.toggleCompareLabels();
      }
    }
  }

  toggleCompareLabels() {
    if (!this.map) return;
    const mapWidth = this.map.getSize().x;
    this.updateCompareLegendVisibility(
      this.lastSliderValue === 0 ? mapWidth / 2 : this.lastSliderValue,
      mapWidth
    );
  }

  recurrentSlider = false;
  createSliderData(data: any[]): { start: string; end: string }[] {
    return data.map((item) => ({
      start: item.start.split('T')[0],
      end: item.end.split('T')[0],
    }));
  }

  groupRecurrencyCollections(recurrencyArray) {
    this.recurrentSlider = true;
    let sliderDates: any;
    sliderDates = this.createSliderData(recurrencyArray);
    const groupedScenes = {};
    this.groupedScenes = {};
    this.sliderDateRangeArray = [];
    this.sliderDateRangeArray = sliderDates;
    for (const range of this.sliderDateRangeArray) {
      const key = `${range.start} to ${range.end}`;
      groupedScenes[key] = [];
    }
    for (const sensor of recurrencyArray) {
      for (const scene of sensor.scenes) {
        const sceneDate = scene.predicted_date.split('T')[0];
        for (const range of this.sliderDateRangeArray) {
          if (sceneDate >= range.start && sceneDate <= range.end) {
            const key = `${range.start} to ${range.end}`;
            groupedScenes[key].push(scene);
            break;
          }
        }
      }
    }
    return groupedScenes;
  }

  getDateArray(start: string, end: string): string[] {
    const dateArray: string[] = [];
    let currentDate = new Date(start);
    const endDate = new Date(end);
    while (currentDate <= endDate) {
      dateArray.push(currentDate.toISOString().split('T')[0]);
      currentDate.setDate(currentDate.getDate() + 1);
    }
    return dateArray;
  }

  AISdata = false;
  selectedClydeScene: any;
  groupCollections() {
    const groupedScenes = {};
    this.groupedScenes = {};
    this.sliderDateRangeArray = [];
    this.AISdata = false;
    this.recurrentSlider = false;
    let startDate = this.collection?.openWindow;
    let endDate = this.collection?.closeWindow;
    if (this.filterStart && this.filterEnd) {
      startDate = this.filterStart;
      endDate = this.filterEnd;
    }
    let dateRangeArray = this.getDateArray(startDate, endDate);
    this.sliderDateRangeArray = dateRangeArray;
    for (const date of this.sliderDateRangeArray) {
      groupedScenes[date] = [];
    }
    for (const sensor of this.collection.sensors) {
      if (sensor.checked) {
        if (
          sensor.scenes[0]?.operatorKey === OPERATORS.AISSTREAM
        ) {
          // AISstream: start live SSE stream — vessel rendering is fully owned by the service
          this.aisstreamLayer.attach(this.map, this.collection.taskId, this.collection);
        } else if (sensor.scenes[0].operatorKey === OPERATORS.VOYAGERADAR) {
          // Viewing is free: a redraw renders the LAST SAVED refresh via the
          // snapshot recall (S3, no operator call). The paid live pull happens
          // only on the Refresh button (fetchAISDataFromServer) — this path
          // used to call the billed endpoint and blind-decrement every Voyage
          // Radar sensor on the task on every re-render.
          this.redrawVoyageFromLastRefresh(sensor);
        } else if (
          sensor.scenes[0].operatorKey === OPERATORS.SPIRE ||
          sensor.scenes[0].operatorKey === OPERATORS.CLYDE
        ) {
          this.getAISData(sensor.scenes[0], 'display', sensor);
        } else {
          for (const scene of sensor.scenes) {
            const sceneDate = scene.predictedDate.split('T')[0];
            if (groupedScenes.hasOwnProperty(sceneDate)) {
              groupedScenes[sceneDate].push(scene);
              this.AISdata = true;
            }
          }
        }
      }
    }
    return groupedScenes;
  }

  generateSliderDateRange(end, start) {
    const dateArray: string[] = [];

    this.dateRangeArray = [];

    const toDateOnly = (d) => {
      const dt = new Date(d);
      return new Date(dt.getFullYear(), dt.getMonth(), dt.getDate());
    };

    const formatLocalDate = (d: Date) => d.toLocaleDateString('en-CA');

    const startDate = toDateOnly(start);
    const endDate = toDateOnly(end);

    const diffDays = Math.floor(
      (endDate.getTime() - startDate.getTime()) / (1000 * 60 * 60 * 24)
    );

    if (diffDays <= 10) {
      for (
        let d = new Date(startDate);
        d <= endDate;
        d.setDate(d.getDate() + 1)
      ) {
        dateArray.push(formatLocalDate(new Date(d)));
      }
    } else {
      const step = diffDays / 9;
      for (let i = 0; i < 10; i++) {
        const d = new Date(
          startDate.getTime() + i * step * 24 * 60 * 60 * 1000
        );
        dateArray.push(formatLocalDate(d));
      }
    }

    return dateArray;
  }

  groupVesselsByDate(dateRangeArray, compassDirection) {
    let vesselDirection =
      this.utilsService.getVesselDirection(compassDirection);
    this.vesselData = {};
    if (vesselDirection === 'LR') this.dateRangeArray = dateRangeArray;
    else this.dateRangeArray = dateRangeArray.reverse();

    this.sliderShow = true;
    for (const date of this.dateRangeArray) {
      this.vesselData[date] = this.historicalVesselData.filter((data) => {
        const dataDate = new Date(data.timestamp || data.location_time)
          .toISOString()
          .split('T')[0];
        return dataDate === date;
      });
    }
  }

  private getOrCreateVesselMarker(
    feature: any,
    latlng: any,
    sensor: any,
    customIcon: any,
    history: string
  ) {
    const vesselId = feature.properties?.ID;
    if (!vesselId) return L.marker(latlng);

    if (this.vesselMarkerCache.has(vesselId)) {
      const marker = this.vesselMarkerCache.get(vesselId)!;
      marker.setLatLng(latlng);

      if (sensor?.operatorKey === OPERATORS.SPIRE || sensor?.operatorKey === OPERATORS.VOYAGERADAR) {
        marker.setOpacity(history === 'historySpire' ? 0.65 : 1);
        marker.setZIndexOffset(history === 'historySpire' ? 0 : 100000);
      }

      return marker;
    }

    let marker: L.Marker;

    if (sensor?.operatorKey === OPERATORS.SPIRE || sensor?.operatorKey === OPERATORS.VOYAGERADAR) {
      const iconCanvas = createNavigationGlobalIcon(
        this.shipColor,
        'dotted'
      );

      const customIcon = L.icon({
        iconUrl: iconCanvas.toDataURL(),
        iconSize: [28, 24],
        iconAnchor: [14, 12],
      });
      const icon = customIcon;
      marker = L.marker(latlng, {
        icon,
        rotationAngle: feature.properties?.Course + 90,
        zIndexOffset: history === 'historySpire' ? 0 : 100000,
        riseOnHover: !(history === 'historySpire'),
        opacity: history === 'historySpire' ? 0.65 : 1,
      });
    } else {
      marker = L.marker(latlng, { icon: customIcon });
    }

    this.vesselMarkerCache.set(vesselId, marker);

    return marker;
  }

  displayVesselData(
    date,
    vesselData: any,
    iconUrl: any,
    sensor: any,
    isTimeseries,
    history?: string
  ) {
    let customIcon;
    if (iconUrl) {
      customIcon = L.icon({
        iconUrl: iconUrl,
        iconSize: [23, 23],
        iconAnchor: [16, 23],
        popupAnchor: [0, -32],
      });
    }
    const geoJsonLayer = (L as any)
      .geoJSON(vesselData, {
        pointToLayer: (feature, latlng) => {
          return this.getOrCreateVesselMarker(
            feature,
            latlng,
            sensor,
            customIcon,
            history ?? ''
          );
        },
        onEachFeature: (ftr, lyr) => {
          let isHistorical = sensor?.isHistorical;

          if (isTimeseries || history === 'historySpire') {
            this.attachTooltip(lyr, this.formatProperties(ftr.properties));

            if (isTimeseries) {
              lyr.on('click', () => {
                this.clickedMarker = lyr;
                if (this.clickedMarker) this.clickedMarker.closeTooltip();
                this.handleLayerClick(
                  ftr,
                  isHistorical,
                  sensor,
                  this.clickedMarker
                );
              });

              if (sensor?.operatorKey === OPERATORS.CLYDE) {
                this.clydeHistoricalLayer.push({ date, marker: lyr });
              }
              if (sensor?.operatorKey === OPERATORS.SPIRE) {
                this.spireHistoricalLayer.push({ date, marker: lyr });
              }
            } else {
              this.HistoricalLayer.push({ date, marker: lyr });
            }
          } else {
            this.HistoricalLayer.push({ date, marker: lyr });
          }
        },
      })
      .addTo(this.map);
    if (geoJsonLayer.getBounds().isValid()) {
      this.map.flyToBounds(geoJsonLayer.getBounds(), {
        padding: [50, 50],
        duration: 1,
        maxZoom: 18,
      });
    }
  }

  removeVesselData(date: any) {
    this.clydeHistoricalLayer = this.clydeHistoricalLayer.filter(
      (clydeData) => {
        if (!this.isClydeHistorical && this.timeseries) {
          if (clydeData.date >= date) {
            this.map.removeLayer(clydeData.marker);
            return false;
          }
        } else {
          if (clydeData.date <= date) {
            this.map.removeLayer(clydeData.marker);
            return false;
          }
        }
        return true;
      }
    );

    this.spireHistoricalLayer = this.spireHistoricalLayer.filter(
      (spireData) => {
        if (!this.isClydeHistorical && this.timeseries) {
          if (spireData.date >= date) {
            this.map.removeLayer(spireData.marker);
            return false;
          }
        } else {
          if (spireData.date <= date) {
            this.map.removeLayer(spireData.marker);
            return false;
          }
        }
        return true;
      }
    );

    this.spirePredictionLayer = this.spirePredictionLayer.filter((layer) => {
      if (layer.date > date) {
        if (layer.marker) {
          this.map.removeLayer(layer.marker);
        }

        if (layer.path) {
          this.map.removeLayer(layer.path);
        }

        return false;
      }

      return true;
    });
  }

  removeHistoricalData(date: any) {
    this.HistoricalLayer = this.HistoricalLayer.filter((clydeData) => {
      if (clydeData.marker !== this.clickedMarker) {
        if (clydeData.date == date) {
          this.map.removeLayer(clydeData.marker);
          return false;
        }
      }
      return true;
    });
    this.spireHistoricalLayer = this.spireHistoricalLayer.filter(
      (spireData) => {
        if (spireData.marker !== this.clickedMarker) {
          if (spireData.date == date) {
            this.map.removeLayer(spireData.marker);
            return false;
          }
        }
        return true;
      }
    );

    this.spirePredictionLayer = this.spirePredictionLayer.filter((layer) => {
      if (layer.date >= date) {
        // Remove markers
        if (layer.marker) {
          this.map.removeLayer(layer.marker);
        }

        if (layer.path) {
          this.map.removeLayer(layer.path);
        }

        return false;
      }

      return true;
    });

    if (this.predictionLayers[date]) {
      this.predictionLayers[date].clearLayers();
      this.map.removeLayer(this.predictionLayers[date]);
      delete this.predictionLayers[date];
    }

    if (this.predictionPathLayers[date]) {
      this.map.removeLayer(this.predictionPathLayers[date]);
      delete this.predictionPathLayers[date];
    }
  }

  clearAllPredictionData() {
    this.currentSliderValue = 0;
    this.currentHistoryIndex = 0;
    this.previousIndex = -1;

    Object.keys(this.predictionLayers).forEach((key) => {
      this.map.removeLayer(this.predictionLayers[key]);
    });
    this.predictionLayers = {};
    Object.keys(this.predictionPathLayers).forEach((key) => {
      this.map.removeLayer(this.predictionPathLayers[key]);
    });
    Object.values(this.pastPredictedPathLayers).forEach((layer) => {
      if (this.map.hasLayer(layer)) this.map.removeLayer(layer);
    });
    this.pastPredictedPathLayers = {};
    this.predictionPathLayers = {};
    this.predictionLastPoint = null;
  }

  getSelectedDateVessels(event: any): void {
    const index = event.value;
    let type = '';
    // Voyage Radar never reaches this slider — its tracks play through the
    // track toolbar (VoyageTrackController), not the per-day marker sets.
    if (this.clickedAIS.operatorKey == this.OPERATOR.CLYDE) {
      type = 'CLYDE';
    } else {
      type = 'SPIRE';
    }

    if (index !== null && index !== undefined) {
      let currentIndex = index - 1;
      if (currentIndex > this.previousIndex) {
        for (let i = this.previousIndex + 1; i <= currentIndex; i++) {
          let convertedVessels: any = '';
          const date = this.dateRangeArray[i];
          this.removeFutureLayers(currentIndex);
          const vessels = this.vesselData[date];
          if (this.prediction) {
            convertedVessels = this.vesselData[date];
            this.displayPredictionData(date, convertedVessels);
          } else if (this.pastPrediction) {
            const date = this.dateRangeArray[currentIndex];
            const vesselData = this.vesselData[date];
            this.displayPastPrediction(date, vesselData);
            this.drawPredictionPath(date, vesselData, 'dash');
          } else {
            let convertedVessels = this.convertToGeoJSONNew(
              this.vesselData[date],
              type
            );

            let iconUrl =
              type === 'SPIRE' ? null : 'assets/images/green-cross.png';
            let historySpire: any = iconUrl === null ? 'historySpire' : null;
            let sensor =
              type === 'SPIRE'
                ? this.collection.sensors.filter(
                    (sensor) => sensor.operatorKey == this.OPERATOR.SPIRE
                  )[0]
                : this.collection.sensors.filter(
                    (sensor) => sensor.operatorKey == this.OPERATOR.CLYDE
                  )[0];
            this.displayVesselData(
              date,
              convertedVessels,
              iconUrl,
              sensor,
              false,
              historySpire
            );
          }
        }
      } else {
        for (let i = this.previousIndex; i > currentIndex; i--) {
          const date = this.dateRangeArray[i];
          this.removeHistoricalData(date);
          if (currentIndex < this.previousIndex) {
            this.lastPredictionLatLng = null; // RESET
          }
          const rebuilt = this.getLastPointForIndex(currentIndex);
          if (rebuilt) {
            this.predictionLastPoint = rebuilt;
          } else {
            // no previous date: if you have a base predicted vessel position, use it:
            if (this.predictedVesselData) {
              this.predictionLastPoint = {
                lat: Number(this.predictedVesselData.lat),
                lng: Number(this.predictedVesselData.lng),
              };
            } else {
              this.predictionLastPoint = null;
            }
          }
        }
      }
      this.previousIndex = currentIndex;
    }
  }

  removeFutureLayers(currentIndex: number) {
    this.spirePredictionLayer = this.spirePredictionLayer.filter((layer) => {
      if (layer.index > currentIndex) {
        if (layer.marker) this.map.removeLayer(layer.marker);
        if (layer.path) this.map.removeLayer(layer.path);
        return false;
      }
      return true;
    });
  }

  displayPastPrediction(date: string, vesselData: any[]) {
    // Remove old layer for this date
    if (this.predictionLayers[date]) {
      this.map.removeLayer(this.predictionLayers[date]);
    }

    const layerGroup = L.featureGroup();
    const previousDate = this.getPreviousVesselDate(date);
    if (previousDate === 'baseDate') {
      this.predictionLastPoint = {
        lat: Number(this.pastpreditedVesselData.location.LAT),
        lng: Number(this.pastpreditedVesselData.location.LON),
      };
    }

    vesselData.forEach((item) => {
      const currLat = Number(item?.location?.LAT ?? item.latitude);
      const currLng = Number(item?.location?.LON ?? item.longitude);
      let bearing;
      if (!this.predictionLastPoint) {
        this.predictionLastPoint = { lat: currLat, lng: currLng };
        return;
      }
      if (!item?.course) {
        const prevLat = Number(this.predictionLastPoint.lat);
        const prevLng = Number(this.predictionLastPoint.lng);

        bearing = bearingDeg(prevLat, prevLng, currLat, currLng);
      }
      const rotationDeg = item?.course ? item?.course + 90 : bearing + 90;

      this.predictionLastPoint = { lat: currLat, lng: currLng }; // FIXED

      // Create icon
      const iconCanvas = createNavigationGlobalIcon(
        'Yellowgreen',
        item?.course ? 'filled' : 'dotted',
        false,
        item?.course ? true : false
      );

      const icon = L.icon({
        iconUrl: iconCanvas.toDataURL(),
        iconSize: [28, 24],
        iconAnchor: [14, 12],
      });

      // Marker
      const marker = L.marker([currLat, currLng], {
        icon,
        rotationAngle: rotationDeg,
        rotationOrigin: 'center',
      }).addTo(layerGroup);
      const tooltipContent = `
      <strong>Location:</strong> ${item.locations - 1}<br>
      <strong>Timestamp(UTC):</strong> ${item.location_time}<br>
      <strong>Lng:</strong> ${currLng}<br>
      <strong>Lat:</strong> ${currLat}<br>
    `;

      this.attachTooltip(marker, tooltipContent);
    });

    // Add layer group to map
    layerGroup.addTo(this.map);

    // Store reference
    this.predictionLayers[date] = layerGroup;

    const bounds = layerGroup.getBounds();
    if (bounds && bounds.isValid()) {
      this.map.flyToBounds(bounds, {
        padding: [50, 50],
        duration: 1.5,
      });
    }
  }

  getLastPointForDate(index: number) {
    // If there is no previous date, we cannot build a correct dash
    if (index <= 0) return null;

    const prevDate = this.dateRangeArray[index - 1];
    const prevData = this.vesselData[prevDate];

    if (!prevData || prevData.length === 0) return null;

    return L.latLng(prevData[0].location.LAT, prevData[0].location.LON);
  }

  getRandomColor(): string {
    const letters = '0123456789ABCDEF';
    let color = '#';
    for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  }

  displayPredictionData(date: string, vesselData: any[]) {
    const color = this.predictedVesselData?.color ?? 'Yellowgreen';
    if (this.predictionLayers[date]) {
      this.map.removeLayer(this.predictionLayers[date]);
      delete this.predictionLayers[date];
    }
    const layerGroup = L.featureGroup();
    this.predictionLayers[date] = layerGroup;
    const previousDate = this.getPreviousVesselDate(date);
    if (previousDate === 'baseDate') {
      this.predictionLastPoint = {
        lat: Number(this.predictedVesselData.lat),
        lng: Number(this.predictedVesselData.lng),
      };
    }
    vesselData.forEach((item) => {
      const currLat = Number(item.location.LAT);
      const currLng = Number(item.location.LON);
      if (!this.predictionLastPoint) {
        this.predictionLastPoint = { lat: currLat, lng: currLng };
        return;
      }
      const prevLat = Number(this.predictionLastPoint.lat);
      const prevLng = Number(this.predictionLastPoint.lng);

      const bearing = bearingDeg(prevLat, prevLng, currLat, currLng);
      const rotationDeg = bearing + 90;

      this.predictionLastPoint = { lat: currLat, lng: currLng }; // FIXED

      // Create icon
      const iconCanvas = createNavigationGlobalIcon(
        vesselData[0]?.locations === 7 ?'Yellowgreen' : color,
        'dotted'
      );

      const icon = L.icon({
        iconUrl: iconCanvas.toDataURL(),
        iconSize: [28, 24],
        iconAnchor: [14, 12],
      });

      // Marker
      const marker = L.marker([currLat, currLng], {
        icon,
        rotationAngle: rotationDeg,
        rotationOrigin: 'center',
      }).addTo(layerGroup);
      const tooltipContent = `
      <strong>Location:</strong> ${item.locations - 1}<br>
      <strong>Timestamp(UTC):</strong> ${item.location_time}<br>
      <strong>Lng:</strong> ${currLng}<br>
      <strong>Lat:</strong> ${currLat}<br>
    `;
      this.attachTooltip(marker, tooltipContent);
    });

    layerGroup.addTo(this.map);
    this.drawPredictionPath(date, vesselData, 'dash', vesselData[0]?.locations === 7 ?'Yellowgreen' : color);

    const bounds = layerGroup.getBounds();
    if (bounds && bounds.isValid()) {
      this.map.flyToBounds(bounds, {
        padding: [50, 50],
        duration: 1.5,
      });
    }
  }

  getPreviousVesselDate(date: string): string | null {
    const dates = Object.keys(this.vesselData);
    const index = dates.indexOf(date);

    if (index === -1) {
      return null;
    }

    if (index === 0) {
      this.lastPredictionLatLng = null;
      return 'baseDate';
    }

    return dates[index - 1];
  }

  getLastPointForIndex(index: number): { lat: number; lng: number } | null {
    if (index <= 0) return null;
    const prevDate = this.dateRangeArray[index - 1];
    if (!prevDate) return null;
    const prevData = this.vesselData[prevDate];
    if (!prevData || prevData.length === 0) return null;

    const last = prevData[prevData.length - 1];
    return {
      lat: Number(last.location.LAT),
      lng: Number(last.location.LON),
    };
  }

  drawPredictionPath(
    date: string,
    vesselData: any[],
    mode: 'dash' | 'arrow' | 'solid' = 'solid',
    color = 'Yellowgreen'
  ) {
    const latlngs = vesselData
      .filter((v) => v.location?.LAT && v.location?.LON)
      .map((v) => L.latLng(v.location.LAT, v.location.LON));
    const previousDate = this.getPreviousVesselDate(date);
    if (previousDate && previousDate !== 'baseDate') {
      const prev = this.vesselData[previousDate][0];
      latlngs.unshift(L.latLng(prev.location.LAT, prev.location.LON));
    } else if (previousDate === 'baseDate' && this.predictedVesselData) {
      latlngs.unshift(
        L.latLng(this.predictedVesselData.lat, this.predictedVesselData.lng)
      );
    }
    if (latlngs.length > 0) {
      this.lastPredictionLatLng = latlngs[latlngs.length - 1];
    }

    if (latlngs && latlngs.length < 2) return;

    if (this.predictionPathLayers[date]) {
      this.map.removeLayer(this.predictionPathLayers[date]);
    }

    const polyline = L.polyline(latlngs, {
      color,
      weight: 4,
      opacity: 1,
      dashArray: mode === 'dash' ? '10, 10' : undefined,
    }).addTo(this.map);

    if (mode === 'arrow') {
      polyline.arrowheads({
        size: '12px',
        frequency: '30px',
        fill: true,
        color,
      });
    }

    this.predictionPathLayers[date] = polyline;
  }

  showVesselsForSelectedDate(event: any): void {
    if (this.clydeAoiFootprintLayer) {
      this.map.removeLayer(this.clydeAoiFootprintLayer);
      this.clydeAoiFootprintLayer = null;
    }
    if (this.aoiFootprintLayer) {
      this.map.removeLayer(this.aoiFootprintLayer);
      this.aoiFootprintLayer = null;
    }

    if (event.value !== 0) {
      let footprintcordinates =
        this.selectedClydeScene?.footprint?.coordinates[0].map((sub) => {
          return [sub[1], sub[0]];
        });
      const randomColor = this.getRandomColor();
      this.clydeAoiFootprintLayer = L.polygon(footprintcordinates, {
        color: randomColor,
        fillColor: 'none',
      }).addTo(this.map);
      this.map.fitBounds(this.clydeAoiFootprintLayer.getBounds());
    }
    const index = event.value;
    if (index !== null && index !== undefined) {
      let currentIndex = index - 1;
      if (currentIndex > this.previousIndex) {
        for (let i = this.previousIndex + 1; i <= currentIndex; i++) {
          const date = this.sliderDateRangeArray[i];
          if (this.overlayClydeVessel) {
            let convertedVessels = this.convertToGeoJSONNew(
              this.overlayClydeVessel[date],
              'CLYDE'
            );
            this.displayVesselData(
              date,
              convertedVessels,
              'assets/images/orange-cross.png',
              this.collection.sensors.filter(
                (sensor) =>
                  sensor.checked && sensor.operatorKey == this.OPERATOR.CLYDE
              )[0],
              true
            );
          }
          if (this.overlaySpireVessel) {
            let convertedVessels = this.convertToGeoJSONNew(
              this.overlaySpireVessel[date],
              'SPIRE'
            );
            this.displayVesselData(
              date,
              convertedVessels,
              'assets/images/yellow-cross.png',
              this.collection.sensors.filter(
                (sensor) =>
                  sensor.checked && sensor.operatorKey == this.OPERATOR.SPIRE
              )[0],
              true
            );
          }
        }
      } else {
        for (let i = this.previousIndex; i > currentIndex; i--) {
          const date = this.sliderDateRangeArray[i];
          this.removeVesselData(date);
        }
      }

      this.previousIndex = currentIndex;
    }
  }

  /**
   * Redraw a checked Voyage Radar sensor from its newest saved refresh — free
   * recall by refreshId, no operator call, no wallet touch. A sensor with no
   * refreshes yet simply renders nothing until the user buys one with the
   * Refresh button.
   */
  private redrawVoyageFromLastRefresh(sensor: any): void {
    const history = Array.isArray(sensor?.refreshHistory) ? sensor.refreshHistory : [];
    const last = history[history.length - 1];
    if (!last?.refreshId) return;
    const scene = (sensor?.scenes ?? []).find((s: any) => s?.checked) ?? sensor?.scenes?.[0];
    this.displayRecalledSnapshot(scene, 'display', sensor, last);
  }

  getAISData(scene: any, type: any, sensor: any) {
    let refreshCount;
    let timeExpired;
    let sensorId;
    let taskId;
    if (sensor.operatorKey === OPERATORS.SPIRE) {
      sensorId = sensor.id;
      timeExpired = sensor.timeExpired;
      refreshCount =
        sensor.updatedRefreshes == 0
          ? 0
          : sensor.updatedRefreshes || sensor.noOfRefreshes;
      this.selectedClydeScene = scene;
    } else if (sensor.operatorKey === OPERATORS.CLYDE) {
      this.selectedClydeScene = scene;
      sensorId = sensor.id;
      timeExpired = sensor.timeExpired;
    }
    if (!scene.aisAvailable) {
      this.spinnerService.hide();
      const message =
        'AIS data is not available until the start of the time of interest (TOI)';
      this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
      this.spinnerService.hide();
      for (const item of this.collection.sensors) {
        if (item.id === sensor.id) {
          item.checked = false;
        }
      }
      return;
    } else if (timeExpired && sensor.operatorKey === OPERATORS.SPIRE) {
      const message =
        'The time of interest (TOI), along with the seven days of access to the historical data, has ended. Please re-task if the area of interest (AOI) continues to be the same.';
      this.spinnerService.hide();
      this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
      for (const item of this.collection.sensors) {
        if (item.id === sensor.id) {
          item.checked = false;
        }
      }
    } else if (refreshCount > 0 && sensor.operatorKey === OPERATORS.SPIRE) {
      const coordinates = scene?.footprint?.coordinates[0];
      taskId = this.collection?.taskId;
      let newCoordinates = coordinates.map((coord) => {
        return [coord[0], coord[1]];
      });
      newCoordinates = [newCoordinates];
      newCoordinates = JSON.stringify(newCoordinates);
      const encodedCoordinates = encodeURIComponent(newCoordinates);
      const startTime = encodeURIComponent(scene.openWindow);
      const endTime = encodeURIComponent(scene.closeWindow);
      const aisReq = {
        polygon: encodedCoordinates,
        startTime: startTime,
        endTime: endTime,
        type: type,
      };
      this.spinnerService.show();
      this.mapLoad = true;
      this.apiService.getAISData(aisReq, taskId).subscribe((res: any) => {
        if (res?.msg === 'failed') {
          this.spinnerService.hide();
          this.mapLoad = false;
          const message =
            'An error occurred during processing and ingestion of the request. Please try after sometime.';
          this.popupService.openPopup(
            CollectionPopupComponent,
            message,
            '',
            '40%'
          );
          for (const item of this.collection.sensors) {
            if (item.id === sensor.id) {
              item.checked = false;
            }
          }
        } else if (res?.msg === 'success') {
          if (res?.data?.vessels?.nodes?.length === 0) {
            this.spinnerService.hide();
            this.mapLoad = false;
            const message =
              'There is no AIS data in the area tasked. If there were to be vessels during the time of interest (TOI), those observations would become available when refreshed.';
            this.popupService.openPopup(
              CollectionPopupComponent,
              message,
              '',
              '40%'
            );
            for (const item of this.collection.sensors) {
              if (item.id === sensor.id) {
                item.checked = false;
              }
            }
          } else {
            this.groupVessels(res?.data, sensor);
            this.collection.sensors.map((sensor) => {
              if (sensor.operatorKey === OPERATORS.SPIRE) {
                if (sensor.updatedRefreshes) sensor.updatedRefreshes -= 1;
                else sensor.updatedRefreshes = sensor.noOfRefreshes - 1;
                if (!sensor.refreshHistory) {
                  sensor.refreshHistory = []; // Initialize if not present
                }
                sensor.refreshHistory.push(res.newRefreshHistory);
              }
            });
            this.AISdata = true;
          }
        }
      });
    } else if (sensor.operatorKey === OPERATORS.CLYDE) {
      const coordinates = scene?.footprint?.coordinates[0];
      taskId = this.collection?.taskId;
      let newCoordinates = coordinates.map((coord) => {
        return [coord[1], coord[0]];
      });
      newCoordinates = [newCoordinates];
      newCoordinates = JSON.stringify(newCoordinates);
      const encodedCoordinates = encodeURIComponent(newCoordinates);
      const startTime = encodeURIComponent(scene.openWindow);
      const endTime = encodeURIComponent(scene.closeWindow);
      const aisReq = {
        polygon: encodedCoordinates,
        startTime: startTime,
        endTime: endTime,
        type: type,
      };
      this.spinnerService.show();
      this.mapLoad = true;
      if (timeExpired) {
        const message =
          'The time of interest (TOI) has ended. Please re-task if the area of interest (AOI) continues to be the same.';
        this.spinnerService.hide();
        this.popupService.openPopup(
          CollectionPopupComponent,
          message,
          '',
          '40%'
        );
        this.spinnerService.hide();
        this.mapLoad = false;
        this.freeze = false;
        for (const item of this.collection.sensors) {
          if (item.id === sensor.id) {
            item.checked = false;
          }
        }
        return;
      }
      const input = JSON.parse(decodeURIComponent(aisReq.polygon));
      this.vesselPolygon = input[0]
        .map((pair) => pair.reverse().join(' '))
        .join(', ');
      aisReq.polygon = this.vesselPolygon;
      this.apiService.getClydeAISData(aisReq, taskId).subscribe((res: any) => {
        if (res?.msg === 'failed') {
          const message =
            'An error occurred during processing and ingestion of the request. Please try after sometime.';
          this.popupService.openPopup(
            CollectionPopupComponent,
            message,
            '',
            '40%'
          );
          this.spinnerService.hide();
          this.mapLoad = false;
          this.freeze = false;
          for (const item of this.collection.sensors) {
            if (item.id === sensor.id) {
              item.checked = false;
            }
          }
        } else if (res?.msg === 'Success') {
          if (res?.data?.length === 0) {
            this.spinnerService.hide();
            this.mapLoad = false;
            const message =
              'There is no AIS data in the area tasked. If there were to be vessels during the time of interest (TOI), those observations would become available when refreshed.';
            this.popupService.openPopup(
              CollectionPopupComponent,
              message,
              '',
              '40%'
            );
            for (const item of this.collection.sensors) {
              if (item.id === sensor.id) {
                item.checked = false;
              }
            }
          } else {
            for (const item of this.collection.sensors) {
              if (item.id === sensor.id) {
                if (!sensor.refreshHistory) {
                  sensor.refreshHistory = []; // Initialize if not present
                }
                sensor.refreshHistory.push(res.newRefreshHistory);
              }
            }
            this.groupVessels(res?.data, sensor);
            this.AISdata = true;
          }
        }
      });
    } else if (timeExpired) {
      const message =
        'The time of interest (TOI), along with the seven days of access to the historical data, has ended. Please re-task if the area of interest (AOI) continues to be the same.';
      this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
      this.spinnerService.hide();
      for (const item of this.collection.sensors) {
        if (item.id === sensor.id) {
          item.checked = false;
        }
      }
      this.spinnerService.hide();
    } else {
      const message =
        'Your refresh count has been exhausted. Please re-task to continue receiving latest AIS information.';
      this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
      this.spinnerService.hide();
      for (const item of this.collection.sensors) {
        if (item.id === sensor.id) {
          item.checked = false;
        }
      }
    }
  }

  groupVessels(responseData: any, sensor: any) {
    let vessels: any;
    if (sensor.operatorKey === OPERATORS.SPIRE) {
      this.overlaySpireVessel = {};
      vessels = responseData?.vessels?.nodes;
      for (const date of this.sliderDateRangeArray) {
        this.overlaySpireVessel[date] = vessels.filter((data) => {
          const dataDate = new Date(data.lastPositionUpdate.timestamp)
            .toISOString()
            .split('T')[0];
          return dataDate === date;
        });
      }
    }
    if (sensor.operatorKey === OPERATORS.CLYDE) {
      this.overlayClydeVessel = {};
      vessels = responseData;
      for (const date of this.sliderDateRangeArray) {
        this.overlayClydeVessel[date] = vessels.filter((data) => {
          const dataDate = new Date(data.timestamp).toISOString().split('T')[0];
          return dataDate === date;
        });
      }
    }
    if (sensor.operatorKey === OPERATORS.VOYAGERADAR) {
      this.overlayVoyageVessel = {};
      vessels = responseData;
      for (const date of this.sliderDateRangeArray) {
        this.overlayVoyageVessel[date] = vessels.filter((data) => {
          const reportTime = data?.properties?.time_utc ?? data?.timestamp;
          const dataDate = new Date(reportTime).toISOString().split('T')[0];
          return dataDate === date;
        });
      }
    }
    this.spinnerService.hide();
    this.mapLoad = false;
  }

  resetSelectedVessels(
    isButtonClicked: any,
    isRemoveHistrorical = true,
    ischangerefreshes = false
  ) {
    this.sliderView = false;
    this.sliderShow = false;
    this.previousIndex = -1;
    if (this.clickedMarker && isButtonClicked) {
      this.map.removeLayer(this.clickedMarker);
      this.clickedMarker = null;
      this.isClydeHistorical = false;
    }
    this.clydeVesselLayer = null;
    this.HistoricalLayer.forEach((clydeData) => {
      this.map.removeLayer(clydeData.marker);
    });
    this.HistoricalLayer = [];
    let sensor = this.clickedAIS;
    let type = '';
    if (
      sensor?.operatorKey == this.OPERATOR.CLYDE ||
      (sensor?.operatorKey == this.OPERATOR.CLYDE && this.timeseries)
    ) {
      type = 'CLYDE';
      if (isRemoveHistrorical) {
        this.clydeHistoricalLayer.map((layer) => {
          if (this.clickedMarker != layer.marker) {
            this.map.removeLayer(layer.marker);
          }
          this.clydeHistoricalLayer = [];
        });
      }
    }
    if (
      sensor?.operatorKey == this.OPERATOR.SPIRE ||
      (sensor?.operatorKey == this.OPERATOR.SPIRE && this.timeseries)
    ) {
      type = 'SPIRE';
      if (isRemoveHistrorical) {
        this.spireHistoricalLayer.map((layer) => {
          if (this.clickedMarker != layer.marker) {
            this.map.removeLayer(layer.marker);
          }
          this.spireHistoricalLayer = [];
        });
      }
    }
    if (sensor?.operatorKey === OPERATORS.VOYAGERADAR) {
      // Voyage Radar owns its own teardown (track mode + on-map toolbar) and
      // never uses the Spire re-render below — `spireData` is only ever set on
      // the Spire path, so falling through here would throw.
      this.overlayVoyageVessel = null;
      this.track.close();
      this.voyage.deactivateVessel();
      this.sliderShow = false;
      this.sliderView = false;
      this.isClydeHistorical = false;
      if (this.clickedMarker) this.clickedMarker.closeTooltip();
      this.clearAllPredictionData();
      this.clearAllFeedPanels();
      return;
    }
    if (!this.timeseries) {
      sensor?.scenes?.forEach((scene) => {
        if (scene.checked == true) {
          if (type == 'CLYDE') {
            this.displayVesselSnapshot(scene, this.clydeData, sensor, type);
          } else if (this.spireData) {
            this.spireData.ischangerefreshes = ischangerefreshes;
            this.displayVesselSnapshot(scene, this.spireData, sensor, type);
          }
          this.sliderShow = false;
          this.filterObject = undefined;
          this.sceneFilterData = false;
        }
      });
    }
    if (this.timeseries) {
      this.sliderView = true;
      let dateRangeArray = this.getDateArray(
        this.collection?.openWindow,
        this.collection?.closeWindow
      );
      this.sliderDateRangeArray = dateRangeArray;
      this.clydeHistoricalLayer.map((layer) => {
        if (this.clickedMarker != layer.marker) {
          this.map.removeLayer(layer.marker);
        }
      });
      this.spireHistoricalLayer.map((layer) => {
        if (this.clickedMarker != layer.marker) {
          this.map.removeLayer(layer.marker);
        }
      });
      for (let i = this.previousIndex + 1; i <= this.currentSliderValue; i++) {
        const date = this.sliderDateRangeArray[i];
        if (this.overlayClydeVessel) {
          let convertedVessels = this.convertToGeoJSONNew(
            this.overlayClydeVessel[date],
            'CLYDE'
          );
          this.displayVesselData(
            date,
            convertedVessels,
            'assets/images/orange-cross.png',
            this.collection.sensors.filter(
              (sensor) =>
                sensor.checked && sensor.operatorKey == this.OPERATOR.CLYDE
            )[0],
            true
          );
        }
        if (this.overlaySpireVessel) {
          let convertedVessels = this.convertToGeoJSONNew(
            this.overlaySpireVessel[date],
            'SPIRE'
          );
          this.displayVesselData(
            date,
            convertedVessels,
            'assets/images/yellow-cross.png',
            this.collection.sensors.filter(
              (sensor) =>
                sensor.checked && sensor.operatorKey == this.OPERATOR.SPIRE
            )[0],
            true
          );
        }
        if (this.overlayVoyageVessel) {
          const convertedVessels = this.convertToGeoJSONNew(
            this.overlayVoyageVessel[date],
            'VOYAGERADAR'
          );
          this.displayVesselData(
            date,
            convertedVessels,
            'assets/images/yellow-cross.png',
            this.collection.sensors.filter(
              (sensor) => sensor.checked && sensor.operatorKey === OPERATORS.VOYAGERADAR
            )[0],
            true
          );
        }
      }
    }
    this.isClydeHistorical = false;
    if (this.clickedMarker) this.clickedMarker.closeTooltip();
    this.clearAllPredictionData();
    this.clearAllFeedPanels();
  }

  clearAllFeedPanels() {
    this.legendController?.clearPane('normal');
    if (!this.feedPanels || this.feedPanels.size === 0) return;
    this.feedPanels = new Map();
    this.rebuildCombined();
 } 

  private clearComparisonFeedPanels(): void {
    this.legendController?.clearPane('left');
    this.legendController?.clearPane('right');
    this.leftFeedPanels = new Map();
    this.rightFeedPanels = new Map();
  }

  updateFeedsStatus(
    sensorIndex,
    feedDetails,
    feedDetailsindex,
    itemType: 'superResolutions' | 'indicesDetails'
  ) {
    if (
      this.collection.sensors[sensorIndex].id == feedDetails.sensorId &&
      feedDetails?.products?.length > 0
    ) {
      this.collection.sensors[sensorIndex][itemType][
        feedDetailsindex
      ].isDisable = false;
    } else {
      this.collection.sensors[sensorIndex][itemType][
        feedDetailsindex
      ].isDisable = true;
      this.collection.sensors[sensorIndex][itemType][feedDetailsindex].loadTif =
        false;
    }
  }

  resetFeedsStatus(collection: any) {
    collection.sensors.map((sensor) => {
      const allFeeds = this.getCombinedFeedsForSensor(sensor);
      allFeeds.map((infoService) => {
        infoService.checked = false;
        infoService.isDisable = true;
      });
    });

    collection.sensors.map((sensor) => {
      sensor?.indicesDetails?.map((indicesDetails) => {
        indicesDetails.checked = false;
        indicesDetails.isDisable = true;
        indicesDetails.loadTif = false;
      });
    });

    collection.sensors.map((sensor) => {
      sensor?.superResolutions?.map((superResolutions) => {
        superResolutions.checked = false;
        superResolutions.isDisable = true;
      });
    });
  }
  showNoPreview(event, scenes?: any) {
    if (scenes?.isNonImagery) {
      if (scenes.operatorKey === 'USL' && !scenes.s_band && !scenes.x_band)
        this.handleOptionError(
          event,
          `We cannot display or download the image as the delivery was made to your storage. You can access the image via your storage.`
        );
      else
        this.handleOptionError(
          event,
          `The observation delivered can only be downloaded now and cannot be visualised on the map here.`
        );
    } else if (!scenes?.isNonImagery) {
      this.handleOptionError(
        event,
        `The imagery delivered can only be downloaded now and cannot be visualised on the map here.`
      );
    }
  }

  private handleToggleFlow(collection, collectionIndex, sensorIndex, event, sensor?) {
  if (!this.showDailyRecurrencyCheckboxes) {
    this.handleSensorToggleWithAbort(collection, collectionIndex, sensorIndex, event);
  } else if (!this.showSubDailyList) {
    this.toggleRecurrentSensorNew(collectionIndex, sensorIndex, event, sensor);
  } else {
    this.toggleSubDailyRecurrentSensorNew(sensorIndex, sensor, event);
  }
 }

  private handlePostPopupFlow(collection, collectionIndex, sensorIndex, event, sensor?) {
   if (this.selectedBands.length === 0 && this.imageType === 'tif' && this.collection.sensors[sensorIndex].operatorKey === this.OPERATOR.OSK) {
    this.openBandSelectorOnSensorChange(collection, collectionIndex, sensorIndex, event, sensor);
   } else {
    this.handleToggleFlow(collection, collectionIndex, sensorIndex, event, sensor);
   }
 }

  handleSensorChange(collection, collectionIndex, sensorIndex, event, sensor?) {
  if (this.measurementModeActive) {
    this.cancelMeasurementMode();
  }

  const currentSensor = collection?.sensors?.[sensorIndex] ?? sensor;
  if (!event.checked) {
    this.clearChangeDetectionForSensorUncheck(currentSensor);
    this.uncheckAssociatedFeedsForSensor(collection?.sensors?.[sensorIndex]);
  }

  if(!event.checked && this.collection?.recurrencyArray[sensor?.index]){
    const infoServices = Array.isArray(
      this.collection?.recurrencyArray?.[sensor?.index]?.InfoServices
    )
      ? this.collection.recurrencyArray[sensor.index].InfoServices
      : [];

    infoServices.forEach((service) => {
      service.checked = false;
    });
   } 
  const hasSkipPreviewNotPending =
    currentSensor?.scenes?.some(
      (scene) =>
        (scene.skipPreview === true || !scene.footprint) &&
        !this.isScenePending(scene)
    ) ?? false;

  const isOSKTif =
    event.checked &&
    currentSensor?.operatorKey === this.OPERATOR.OSK
  if (hasSkipPreviewNotPending && isOSKTif) {

    const message = `Not all scenes on this project can be visualised.
    Clicking on scene's checkboxes will identify those that cannot be visualised.
    All scenes can still be downloaded individually or at the project level.`;

    const dialogRef = this.popupService.openPopup(
      CollectionPopupComponent,
      message,
      '',
      '40%'
    );

    dialogRef.afterClosed().subscribe(() => {
      this.handlePostPopupFlow(collection, collectionIndex, sensorIndex, event, sensor);
    });

    return; 
  }
  if (isOSKTif && this.imageType === 'tif' && this.selectedBands.length === 0) {
    this.openBandSelectorOnSensorChange(collection, collectionIndex, sensorIndex, event, sensor);
    return;
  }
  this.handleToggleFlow(collection, collectionIndex, sensorIndex, event, sensor);
}

  handleSceneChange(collection, collectionIndex, sensorIndex, scenesIndex, event, scene?, sensor?) {
    if (!event.checked) {
      this.resetObservationSelection();
      this.uncheckAssociatedFeedsForSensor(collection?.sensors?.[sensorIndex]);
    }
  if(!event.checked && this.collection?.recurrencyArray[sensor?.index]){
    const infoServices = Array.isArray(
      this.collection?.recurrencyArray?.[sensor?.index]?.InfoServices
    )
      ? this.collection.recurrencyArray[sensor.index].InfoServices
      : [];

    infoServices.forEach((service) => {
      service.checked = false;
    });

   } 
    if(event.checked && this.collection.sensors[sensorIndex].operatorKey === this.OPERATOR.OSK && this.imageType === 'tif' && this.selectedBands.length === 0) {
      collection.sensors[sensorIndex].scenes[scenesIndex].checked = event.checked; 
      this.openBandSelectorOnScenChange(collection, collectionIndex, sensorIndex, scenesIndex, event, scene);
    } else {
    if(!this.showDailyRecurrencyCheckboxes) {
    this.toggleSceneNew(collection, collectionIndex, sensorIndex, scenesIndex, event);
    } else if(this.showDailyRecurrencyCheckboxes && !this.showSubDailyList) {
        this.toggleRecurrentSceneNew(collection, collectionIndex, sensorIndex, scenesIndex, scene, event)
      } else if(this.showDailyRecurrencyCheckboxes && this.showSubDailyList) {
        this.toggleRecurrentSubdailySceneNew(collection, collectionIndex, sensorIndex, scenesIndex, event);
      }
   }
  }

  handleSensorToggleWithAbort(collection, collectionIndex, sensorIndex, event) {    
    if (
      this.opManager?.isOperationRunning &&
      !event.checked &&
      collection.sensors.length > 1
    ) {
      return this.showAbortRetainPopup().then((shouldAbort) => {
        if (shouldAbort) {
          this.opManager.abortOperation();
          collection.sensors[sensorIndex].checked = false;
          this.clearChangeDetectionForSensorUncheck(collection.sensors[sensorIndex]);
          this.resetAllFeedPanels();
          this.clearAllPredictionData();
          this.clearFilteredLayerAndRestore(true);
          this.resetMapNew();
          this.progressing = false;
          this.spinnerService.hide();
          return this.toggleSensorNew(
            collection,
            collectionIndex,
            sensorIndex,
            event
          );
        } else {
          collection.sensors[sensorIndex].checked = true;
        }
      });
    }
    return this.toggleSensorNew(
      collection,
      collectionIndex,
      sensorIndex,
      event
    );
  }

  openBandSelectorOnSensorChange(collection, collectionIndex, sensorIndex, event, sensor? ) {
  const dialogRef = this.dialog.open(BandSelectorComponent, {
    width: '500px',
    maxHeight: '80vh',
    disableClose: true,
    data: {
      selectedBands: this.selectedBands,
      operatorKey: this.getBandSelectorOperatorKey(
        sensor ?? collection?.sensors?.[sensorIndex]
      ),
      sensorType: this.getBandSelectorSensorType(
        sensor ?? collection?.sensors?.[sensorIndex]
      ),
    }
  });

  dialogRef.afterClosed().subscribe(result => {
    if (result === 'cancel' && result) {
      collection.sensors[sensorIndex].checked = false;
      collection.sensors[sensorIndex].scenes?.map((scene) => {scene.checked = false; });
      
    } else if(result === 'clear_bands') {
      this.selectedBands = [];
      collection.sensors[sensorIndex].checked = false;
      collection.sensors[sensorIndex].scenes?.map((scene) => {scene.checked = false; });
      this.resetMapNew();
     } else {
      this.selectedBands = result??[];
      if(!this.showDailyRecurrencyCheckboxes){
      this.handleSensorToggleWithAbort(collection, collectionIndex, sensorIndex, event);
      } else if(this.showDailyRecurrencyCheckboxes &&!this.showSubDailyList) {
        this.toggleRecurrentSensorNew(collectionIndex,sensorIndex, event, sensor)
      } else if(this.showDailyRecurrencyCheckboxes && this.showSubDailyList) {
        this.toggleSubDailyRecurrentSensorNew(sensorIndex, sensor, event )
        }
       }
     });
   }

  openBandSelectorOnScenChange(collection, collectionIndex, sensorIndex, scenesIndex, event, scene? ) {
    const dialogRef = this.dialog.open(BandSelectorComponent, {
    width: '500px',
    maxHeight: '80vh',
    disableClose: true,
    data: {
      selectedBands: this.selectedBands,
      operatorKey: this.getBandSelectorOperatorKey(
        collection?.sensors?.[sensorIndex]
      ),
      sensorType: this.getBandSelectorSensorType(
        collection?.sensors?.[sensorIndex]
      ),
    }
  });

  dialogRef.afterClosed().subscribe(result => {
    if (result === 'cancel' && result) {
      collection.sensors[sensorIndex].scenes[scenesIndex].checked = false;
    } else if(result === 'clear_bands') {
      this.selectedBands = [];
      collection.sensors[sensorIndex].scenes[scenesIndex].checked = false;
      this.resetMapNew();
    } else {
      this.selectedBands = result??[];
      if(!this.showDailyRecurrencyCheckboxes){
      this.toggleSceneNew(collection, collectionIndex, sensorIndex, scenesIndex, event);
      } else if(this.showDailyRecurrencyCheckboxes && !this.showSubDailyList) {
        this.toggleRecurrentSceneNew(collection, collectionIndex, sensorIndex, scenesIndex, scene, event)
      } else if(this.showDailyRecurrencyCheckboxes && this.showSubDailyList) {
        this.toggleRecurrentSubdailySceneNew(collection, collectionIndex, sensorIndex, scenesIndex, event);
       }
      }
    });
  }

  private isScenePending(scene: any): boolean {
  return (
    (
      (
        (scene.operatorKey === OPERATORS.SPIRE ||
         scene.operatorKey === OPERATORS.CLYDE) &&
        !scene.aisAvailable &&
        scene.id
      ) ||
      (
        scene.operatorKey !== OPERATORS.SPIRE &&
        scene.operatorKey !== OPERATORS.CLYDE &&
        !scene.id
      )
    ) &&
    scene.status !== 'failed'
  );
}

  toggleSensorNew(collection, collectionIndex, sensorIndex, event) {
    if (!event.checked) {
      this.resetObservationSelection();
    }
    this.resetAllFeedPanels();
    this.clearAllPredictionData();
    this.clearFilteredLayerAndRestore(true);
    this.unSubscribeAPI();
    this.opManager.completeOperation();
    // AISstream: sensor-level control — no scene interaction needed
    if (!event.checked && collection.sensors[sensorIndex]?.operatorKey === OPERATORS.AISSTREAM) {
      this.aisstreamLayer.detach();
      this.resetMapNew();
      return;
    }
    const sensorFeeds = this.getCombinedFeedsForSensor(
      collection.sensors[sensorIndex]
    );
    this.questionWmsHandoff.clear(collection.sensors[sensorIndex]?.id);
    const questionFeedsToRedisplay = this.isFeedTasking
      ? [...this.getActiveFeedsForSensor(collection.sensors[sensorIndex])]
      : [];
    const suppressFeedRedisplayOnSensorCheck =
      !this.isFeedTasking && !!event.checked && sensorFeeds.some((feed) => feed?.checked === true);
    if (
      collection.sensors?.length == 1 &&
      collection.sensors.filter((sensor) => sensor.checked).length == 1
    ) {
      this.resetMapNew();
      this.clickedAIS = '';
      this.spireData = null;
      this.removeVesselLayer();
    }
    if (event.checked) {
      this.clearDisplayedCompareFeedLayers();
      sensorFeeds.forEach((feed) => {
        feed.checked = false;
      });
      this.displayedIS = null;

      if (
        this.collections[collectionIndex]?.sensors[sensorIndex]
          ?.valueAddedOption?.length > 0
      ) {
        this.collections[collectionIndex].sensors[
          sensorIndex
        ].valueAddedOption.map((valueAddedOption) => {
          valueAddedOption.checked = false;
        });
      }

      // Check if there are scenes with skipPreview/no footprint that are NOT pending
      const hasSkipPreviewNotPending =
        collection.sensors[sensorIndex]?.scenes?.some(
          (scene) =>
            (scene.skipPreview === true || !scene.footprint) &&
            !this.isScenePending(scene)
        ) ?? false;
      if (hasSkipPreviewNotPending &&  this.collection.sensors[sensorIndex].operatorKey !== this.OPERATOR.OSK && this.collection.sensors[sensorIndex].operatorKey !== OPERATORS.AISSTREAM) {
        let message = `Not all scenes on this project can be visualised. Clicking on scene's
                        checkboxes will identify those that cannot be visualised. All scenes can
                        still be downloaded individually or at the project level.`;
        this.popupService.openPopup(
          CollectionPopupComponent,
          message,
          '',
          '40%'
        );
      }
    }
    if (this.getCollectionSub) {
      this.getCollectionSub.unsubscribe();
      this.spinnerService.hide();
    }

    if (collection.sensors[sensorIndex].scenes?.length > 0) {
      collection.sensors[sensorIndex].scenes.forEach((scene) => {
        if (
          ((scene.operatorKey === OPERATORS.SPIRE ||
            scene.operatorKey === OPERATORS.CLYDE) &&
            !scene.aisAvailable) ||
          !scene.id ||
          scene?.status === 'failed' ||
          collection.sensors[sensorIndex]?.status === 'archived' ||
          this.timeseries ||
          (collection.sensors[sensorIndex]?.operatorKey ===
            OPERATORS.SATELLOGIC &&
            scene?.sceneName?.includes('L1D'))
        )
          scene.checked = false;
      });
    }

    collection.sensors[sensorIndex].scenes.map((scene) => {
      scene.imageType = this.imageType;
      scene.tif = this.imageType == 'tif' ? true : false;
    });
    if (collection.sensors[sensorIndex].scenes.length === 1) {
      this.sceneSelected = collection.sensors[sensorIndex]?.scenes[0]?.id;
    }
    if (
      collection.sensors[sensorIndex]?.scenes?.length > 1 &&
      collection.sensors[sensorIndex]?.InfoServices?.length === 1
    )
      this.combinedScenes = event.checked;
    this.indiceType = 'display';
    this.fail = 0;
    this.tifPopupShown = 0;
    let count = 0;
    this.newTaskButtonClicked = false;
    if (this.displayedIS) {
      this.displayedIS = null;
    }
    this.isClydeHistorical = false;
    this.HistoricalLayer.forEach((HisLayer) => {
      this.map.removeLayer(HisLayer.marker);
    });
    this.HistoricalLayer = [];
    this.removeDynamicLayer();
    if (this.timeseries) {
      this.currentHistoryIndex = 0;
      this.previousIndex = -1;
      this.currentSliderValue = 0;
      if (event.checked) {
        this.resetMapNew();
        this.isClydeHistorical = false;
        this.sliderShow = false;
        collection.sensors[sensorIndex].checked = event?.checked;
        this.sensorSelected = collection.sensors[sensorIndex].id;
        if (collection?.recurrencyArray?.length > 1 && !this.spire) {
          this.groupedScenes = this.groupRecurrencyCollections(
            collection?.recurrencyArray
          );
        } else {
          this.groupedScenes = this.groupCollections();
        }
      } else {
        if (collection?.recurrencyArray?.length > 1 && !this.spire) {
          this.groupedScenes = this.groupRecurrencyCollections(
            collection?.recurrencyArray
          );
        } else {
          this.groupedScenes = this.groupCollections();
        }
        if (
          collection.sensors[sensorIndex]?.operatorKey == this.OPERATOR.SPIRE
        ) {
          this.overlaySpireVessel = null;
        }
        if (
          collection.sensors[sensorIndex]?.operatorKey == this.OPERATOR.CLYDE
        ) {
          this.overlayClydeVessel = null;
        }
        this.resetMapNew();
        this.isSitechanged = false;
      }
    } else {
      this.observationChecked = true;
      if (event.checked) {
        this.observationEnabled = true;
      } else {
        this.observationEnabled = false;
      }
      if (event.checked) {
        if (collection.sensors[sensorIndex]?.operatorKey !== OPERATORS.WEATHEREX) {
          this.resetWeatherExForecastSelection();
        }
        this.collection.sensors[sensorIndex]?.indicesDetails?.map(
          (indicesDetails) => {
            indicesDetails.checked = false;
            indicesDetails.loadTif = false;
          }
        );
        // Uncheck all feeds when sensor is re-selected so only scene data shows
        this.collection.sensors.forEach((sensor) => {
          this.getCombinedFeedsForSensor(sensor).forEach((feed) => {
            feed.checked = false;
          });
        });
        this.resetAllFeedPanels();
        this.removeISLayers();
        this.removeIndices();
        this.removeSuperResolutions();
        this.annotateClicked = false;
        this.newTaskButtonClicked = false;
        this.removeAnnotationMarkers();
        this.pointerEvent = 'none';
        if (
          this.sensorsNew.findIndex(
            (sensor) => sensor.id == collection.sensors[sensorIndex].id
          ) == -1
        ) {
          const pane: 'left' | 'right' =
            this.mapPane == 'left' ? 'right' : 'left';

          this.syncSensorPane(collection.sensors[sensorIndex], pane);
          this.sensorsNew.push(collection.sensors[sensorIndex]);
          this.mapPane = pane;
        } else {
          if (this.mapPane == '') {
            this.mapPane = 'left';
          }
        }
        if (collection.sensors[sensorIndex].scenes.length == 0) {
          if (collection.sensors[sensorIndex]?.operatorKey === OPERATORS.WEATHEREX) {
            this.fetchWeatherExData(collection, sensorIndex);
          } else if (collection.sensors[sensorIndex]?.operatorKey === OPERATORS.AISSTREAM) {
            this.aisstreamLayer.attach(this.map, collection.taskId, collection);
            this.mapLoad = false;
            this.spinnerService.hide();
          } else {
            this.spinnerService.hide();
          }
        }

        collection.sensors[sensorIndex].scenes.forEach((scene: any) => {
          if (
            this.scenesNew.findIndex((sceneNew) => sceneNew.id == scene.id) ==
            -1
          ) {
            if (
              scene?.id &&
              scene?.status !== 'failed' &&
              !scene?.sceneName?.includes('L1D')
            ) {
              this.sceneId = scene?.id;
              scene.checked = true;
              const sensorObj = {
                sensorId: collection.sensors[sensorIndex].id,
                sceneId: scene?.id,
                action: 'sensor',
                fileType: scene.imageType,
              };
              if (
                collection.sensors[sensorIndex].scenes[0].operatorKey ===
                  OPERATORS.AISSTREAM
              ) {
                // AISstream: start live SSE stream
                this.aisstreamLayer.attach(this.map, collection.taskId, collection);
                this.mapLoad = false;
                this.spinnerService.hide();
              } else if (
                collection.sensors[sensorIndex].scenes[0].operatorKey ==
                  this.OPERATOR.CLYDE ||
                collection.sensors[sensorIndex].scenes[0].operatorKey ==
                  this.OPERATOR.SPIRE ||
                collection.sensors[sensorIndex].scenes[0].operatorKey ==
                  this.OPERATOR.VOYAGERADAR
              ) {
                if (
                  collection.sensors[sensorIndex].scenes[0]?.operatorKey ===
                    this.OPERATOR.CLYDE &&
                  collection.sensors[sensorIndex].status === 'canceled'
                ) {
                  const message =
                    'The user has cancelled the task, and the data is unavailable';
                  this.popupService.openPopup(
                    WarningPopupComponent,
                    message,
                    '',
                    '40%'
                  );
                }
                this.fetchAISDataFromServer(collection, sensorIndex, scene);
              } else if (
                collection.sensors[sensorIndex].scenes[0].operatorKey ==
                this.OPERATOR.USL
              ) {
                this.mapLoad = false;
                this.spinnerService.hide();
                scene.pane = 'left';
                if (!scene?.s_band && !scene?.x_band && scene?.usl_footprint) {
                  scene.x_band = scene?.usl_footprint;
                }
                this.displayRFBandNew(
                  scene,
                  collection.sensors[sensorIndex].id,
                  this.selectedBand
                );
              } else if (
                collection.sensors[sensorIndex].scenes[0].operatorKey ==
                this.OPERATOR.LBAND
              ) {
                this.mapLoad = false;
                this.spinnerService.hide();
                scene.pane = 'left';
                this.displayRFSignalsNew(
                  scene,
                  collection.sensors[sensorIndex].id,
                  this.signalSelected
                );
              } else if (!scene?.sceneName?.includes('L1D')) {
                this.tifPopupShown = 0;
                this.fetchImageFromServer(collection, sensorObj, scene);
              }
            }
          }
        });
        if (this.clydeData && this.clickedAIS?.operatorKey == OPERATORS.CLYDE) {
          let selectedAISSensor = collection.sensors.filter((snsr) => {
            return snsr.operatorKey == OPERATORS.CLYDE;
          })[0];
          this.displayVesselSnapshot(
            selectedAISSensor.scenes[0],
            this.clydeData,
            selectedAISSensor,
            'CLYDE'
          );
        }
        if (this.spireData && this.clickedAIS?.operatorKey == OPERATORS.SPIRE) {
          let selectedAISSensor = collection.sensors.filter((snsr) => {
            return snsr.operatorKey == OPERATORS.SPIRE;
          })[0];
          this.displayVesselSnapshot(
            selectedAISSensor.scenes[0],
            this.spireData,
            selectedAISSensor,
            'SPIRE'
          );
        }

        if (this.collection.sensors[sensorIndex].indicesDetails?.length > 0) {
          const scenesArray = this.collection.sensors[sensorIndex].scenes;
          const checkedScenes = scenesArray.filter(
            (scene) => scene.checked === true
          );
          count = checkedScenes.length;
          const checkedSensors = this.collection.sensors.filter(
            (scene) => scene.checked === true
          );
          const selectedScenes: any = [],
            sceneList: any = [];
          for (const sensors of checkedSensors) {
            for (const item of sensors.scenes) {
              if (item.checked) {
                selectedScenes.push(item);
              }
            }
          }
          if (
            this.collection.sensors[0].operatorKey == this.OPERATOR.AXELSPACE ||
            this.collection.sensors[0].operatorKey == this.OPERATOR.AZISTA
          ) {
            for (const sensors of this.collection.sensors) {
              for (const item of sensors.scenes) {
                if (item.checked) {
                  sceneList.push(item);
                }
              }
            }
          }

          if (
            (count != 2 &&
              this.collection.sensors[0].operatorKey !==
                this.OPERATOR.AXELSPACE) ||
            this.collection.sensors[0].operatorKey !== this.OPERATOR.AZISTA
          ) {
            for (const sensors of this.collection.sensors) {
              for (const item of sensors.scenes) {
                if (item.checked) {
                  sceneList.push(item);
                }
              }
            }
          }
          if (sceneList?.length > 0) {
            this.sceneSelected = sceneList[0]?.id;
            this.selectedSceneNew = sceneList[0];
          }
        }
        if (
          this.collection.sensors[sensorIndex].indicesDetails?.length > 0 &&
          this.sensorsNew.length == 1
        ) {
          if (
            this.collection.sensors[0].operatorKey == this.OPERATOR.AXELSPACE ||
            this.collection.sensors[0].operatorKey == this.OPERATOR.AZISTA
          ) {
            let selectedScenes = this.collection.sensors[
              sensorIndex
            ].scenes.filter((scene) => scene.checked == true);
            if (selectedScenes.length > 0) {
              this.collection.sensors[sensorIndex].indicesDetails?.map(
                (indicesDetails, indicesDetailsindex) => {
                  this.updateFeedsStatus(
                    sensorIndex,
                    indicesDetails,
                    indicesDetailsindex,
                    'indicesDetails'
                  );
                }
              );
            }
          } else {
            let selectedScenes = this.collection.sensors[
              sensorIndex
            ].scenes.filter((scene) => scene.checked == true);
            if (selectedScenes.length == 1) {
              this.collection.sensors[sensorIndex].indicesDetails?.map(
                (indicesDetails, indicesDetailindex) => {
                  this.updateFeedsStatus(
                    sensorIndex,
                    indicesDetails,
                    indicesDetailindex,
                    'indicesDetails'
                  );
                }
              );
            } else {
              this.collection.sensors.map((sensor) => {
                sensor.InfoServices.map((infoService) => {
                  infoService.isDisable = true;
                  infoService.checked = false;
                });
                sensor.AssociatedFeeds?.map((associatedFeed) => {
                  associatedFeed.isDisable = true;
                  associatedFeed.checked = false;
                });
              });
              this.removeISLayers();
            }
          }
        } else {
          this.collection.sensors.map((sensor) => {
            sensor.indicesDetails?.map((indicesDetail) => {
              indicesDetail.isDisable = true;
              indicesDetail.checked = false;
              indicesDetail.loadTif = false;
            });
          });
        }
        if (
          this.collection.sensors[sensorIndex]?.superResolutions?.length > 0
        ) {
          const scenesArray = this.collection.sensors[sensorIndex].scenes;
          const checkedScenes = scenesArray.filter(
            (scene) => scene.checked === true
          );
          count = checkedScenes.length;
          const checkedSensors = this.collection.sensors.filter(
            (scene) => scene.checked === true
          );
          const selectedScenes: any = [],
            sceneList: any = [];
          for (const sensors of checkedSensors) {
            for (const item of sensors.scenes) {
              if (item.checked) {
                selectedScenes.push(item);
              }
            }
          }
          if (
            this.collection.sensors[0].operatorKey == this.OPERATOR.AXELSPACE ||
            this.collection.sensors[0].operatorKey == this.OPERATOR.AZISTA
          ) {
            for (const sensors of this.collection.sensors) {
              for (const item of sensors.scenes) {
                if (item.checked) {
                  sceneList.push(item);
                }
              }
            }
          }
          if (
            count != 2 &&
            (this.collection.sensors[0].operatorKey !==
              this.OPERATOR.AXELSPACE ||
              this.collection.sensors[0].operatorKey !== this.OPERATOR.AZISTA)
          ) {
            for (const sensors of this.collection.sensors) {
              for (const item of sensors.scenes) {
                if (item.checked) {
                  sceneList.push(item);
                }
              }
            }
          }
        }
        if (
          this.collection.sensors[sensorIndex]?.superResolutions?.length > 0 &&
          this.sensorsNew.length == 1
        ) {
          if (
            this.collection.sensors[0].operatorKey == this.OPERATOR.AXELSPACE ||
            this.collection.sensors[0].operatorKey == this.OPERATOR.AZISTA
          ) {
            let selectedScenes = this.collection.sensors[
              sensorIndex
            ].scenes.filter((scene) => scene.checked == true);
            if (
              this.collection.sensors[0].scenes.length == selectedScenes.length
            ) {
              this.collection.sensors[sensorIndex].superResolutions?.map(
                (superResolution, superResolutionsindex) => {
                  this.updateFeedsStatus(
                    sensorIndex,
                    superResolution,
                    superResolutionsindex,
                    'superResolutions'
                  );
                }
              );
            }
          } else {
            let selectedScenes = this.collection.sensors[
              sensorIndex
            ].scenes.filter((scene) => scene.checked == true);
            if (selectedScenes.length == 1) {
              this.collection.sensors[sensorIndex].superResolutions?.map(
                (superResolutions, superResolutionsindex) => {
                  this.updateFeedsStatus(
                    sensorIndex,
                    superResolutions,
                    superResolutionsindex,
                    'superResolutions'
                  );
                }
              );
            } else {
              this.collection.sensors.map((sensor) => {
                sensor.superResolutions.map((superResolutions) => {
                  superResolutions.isDisable = true;
                  superResolutions.checked = false;
                });
              });
            }
          }
        } else {
          this.collection.sensors.map((sensor) => {
            sensor.superResolutions?.map((superResolutions) => {
              superResolutions.isDisable = true;
              superResolutions.checked = false;
            });
          });
        }

        const activeFeedsForSensor = this.getActiveFeedsForSensor(this.collection.sensors[sensorIndex]);
        if (activeFeedsForSensor.length > 0) {
          const scenesArray = this.collection.sensors[sensorIndex].scenes;
          const checkedScenes = scenesArray.filter(
            (scene) => scene.checked === true
          );
          const checkedInfo = activeFeedsForSensor.filter((info) => info.checked === true);
          count = checkedScenes.length;
          const checkedSensors = this.collection.sensors.filter(
            (scene) => scene.checked === true
          );
          const selectedScenes: any = [],
            sceneList: any = [];
          for (const sensors of checkedSensors) {
            for (const item of sensors.scenes) {
              if (item.checked) {
                selectedScenes.push(item);
              }
            }
          }
          if (
            this.collection.sensors[0].operatorKey == this.OPERATOR.AXELSPACE ||
            this.collection.sensors[0].operatorKey == this.OPERATOR.AZISTA
          ) {
            for (const sensors of this.collection.sensors) {
              for (const item of sensors.scenes) {
                if (item.checked) {
                  sceneList.push(item);
                }
              }
            }
          }
          if (
            count != 2 &&
            (this.collection.sensors[0].operatorKey !==
              this.OPERATOR.AXELSPACE ||
              this.collection.sensors[0].operatorKey !== this.OPERATOR.AZISTA)
          ) {
            for (const sensors of this.collection.sensors) {
              for (const item of sensors.scenes) {
                if (item.checked) {
                  sceneList.push(item);
                }
              }
            }
          }
        }
        const activeFeedsForCheck = this.getCombinedFeedsForSensor(
          this.collection.sensors[sensorIndex]
        );
        if (
          activeFeedsForCheck.length > 0 &&
          this.sensorsNew.length == 1
        ) {
          if (
            this.collection.sensors[0].operatorKey == this.OPERATOR.AXELSPACE ||
            this.collection.sensors[0].operatorKey == this.OPERATOR.AZISTA
          ) {
            let selectedScenes = this.collection.sensors[
              sensorIndex
            ].scenes.filter((scene) => scene.checked == true);
            if (
                this.areAllScenesChecked(this.collection.sensors[sensorIndex])
            ) {
              activeFeedsForCheck.map(
                (infoService, infoserviceindex) => {
                  if (
                    this.collection.sensors[sensorIndex].id ==
                      infoService.sensorId &&
                    infoService?.insightDatas?.length > 0
                  ) {
                    infoService.isDisable = false;
                  } else {
                    infoService.isDisable = true;
                  }
                }
              );
            }
          } else {
            let selectedScenes = this.collection.sensors[
              sensorIndex
            ].scenes.filter((scene) => scene.checked == true);

            if (selectedScenes.length == 1) {
              activeFeedsForCheck.map(
                (infoService, infoserviceindex) => {
                  const canEnableAssociated =
                    !this.isAssociatedFeed(
                      this.collection.sensors[sensorIndex],
                      infoService
                    ) ||
                    this.areAllScenesChecked(
                      this.collection.sensors[sensorIndex]
                    );
                  if (
                    this.collection.sensors[sensorIndex].id ==
                      infoService.sensorId &&
                    infoService?.insightDatas?.length > 0 &&
                    canEnableAssociated
                  ) {
                    infoService.isDisable = false;
                  } else {
                    infoService.isDisable = true;
                  }
                }
              );
            } else if (
              this.combinedScenes &&
              selectedScenes.length ===
                this.collection.sensors[sensorIndex].scenes.length
            ) {
              this.collection.sensors.map((sensor) => {
                const feedsToUpdate = this.getCombinedFeedsForSensor(sensor);
                feedsToUpdate.map((feed) => {
                  const canEnableAssociated =
                    !this.isAssociatedFeed(sensor, feed) ||
                    this.areAllScenesChecked(sensor);
                  if (
                    sensor.id == feed.sensorId &&
                    feed?.insightDatas?.length > 0 &&
                    canEnableAssociated
                  ) {
                    sensor.AssociatedFeeds?.map((associatedFeed) => {
                        associatedFeed.isDisable = !this.hasAssociatedFeedResults(associatedFeed);
                    });
                    feed.isDisable = false;
                  } else {
                    sensor.AssociatedFeeds?.map((associatedFeed) => {
                        associatedFeed.isDisable = true;
                    });
                    feed.isDisable = true;
                  }
                });
              });
            } else {
              this.collection.sensors.map((sensor) => {
                const feedsToUpdate = this.getCombinedFeedsForSensor(sensor);
                feedsToUpdate.map((infoService) => {
                  infoService.isDisable = true;
                  infoService.checked = false;
                });
              });
              this.removeISLayers();
            }
          }
        } else {
          this.collection.sensors.map((sensor) => {
            const feedsToReset = this.getCombinedFeedsForSensor(sensor);
            feedsToReset.map((infoService) => {
              infoService.isDisable = true;
              infoService.checked = false;
            });
          });
          this.removeISLayers();
        }
      } else {
        this.clearCurrentWeekTabForSensor(collection.sensors[sensorIndex]);
        this.feedUi = { showFilterIcon: false };
        this.removeVectorOverlay();
        this.selectedSignals = this.selectedSignals.filter(
          (signal) => signal.sensorId !== collection.sensors[sensorIndex].id
        );
        this.vesselJsonData = undefined;
        this.resetTimeSeries();
        const removedComparePane = this.getComparePaneForSensor(
          collection.sensors[sensorIndex]
        );
        const remainingCompareSensor =
          this.sensorsNew.find(
            (currentSensor: any) =>
              currentSensor.id != collection.sensors[sensorIndex].id
          ) ?? null;
        const remainingComparePane = remainingCompareSensor
          ? this.getComparePaneForSensor(remainingCompareSensor)
          : null;
        const remainingCompareCache = remainingComparePane
          ? this.compareFeedCache[remainingComparePane] ?? null
          : null;
        if (this.compare) {
          this.map.removeControl(this.compare);
          this.compare = null;
        }

        this.sensorsNew = this.sensorsNew.filter((sensor: any) => {
          return collection.sensors[sensorIndex].id != sensor.id;
        });
        let selectedSensor = collection.sensors.filter((sensor) => {
          return collection.sensors[sensorIndex].id != sensor.id;
        });

        this.isCompare = false;
        if (this.sensorsNew.length == 1) {
          selectedSensor.map((sensor) => {
            if (
              sensor.scenes.filter((scene) => scene.checked == true).length == 1
            ) {
              sensor.InfoServices.map((infoService, infoserviceindex) => {
                if (
                  sensor.id == infoService.sensorId &&
                  infoService?.insightDatas?.length > 0
                ) {
                  infoService.isDisable = false;
                } else {
                  infoService.isDisable = true;
                }
              });
              this.refreshAssociatedFeedsState(sensor);
            } else {
              sensor.InfoServices.map((infoService, infoserviceindex) => {
                infoService.isDisable = true;
              });
              this.refreshAssociatedFeedsState(sensor);
            }
          });
        }
        if (this.sensorsNew.length == 0) {
          this.resetFeedsStatus(this.collection);
          this.removeAnnotationMarkers();
        }
        collection.sensors[sensorIndex].scenes.map((scene: any) => {
          scene.checked = false;
        });
        this.scenesNew.map((scene: any, index: any) => {
          if (scene.sensorId == collection.sensors[sensorIndex].id) {
            this.mapPane = scene?.pane;
            if (
              collection.sensors[sensorIndex].scenes[0].operatorKey ==
              this.OPERATOR.USL
            ) {
              this.clearRFBandsByScene(scene, true);
              this.removeGHGLayer();
            } else {
              if (scene?.legendScale) {
                this.map.removeLayer(scene?.legendScale);
              }
              this.removeLayerByScene(scene, { paneSpecific: true });
              this.clearRFSignalsByScene(scene);
            }
            this.removeAnnoatationByScene(scene);
          }
        });

        this.ghgLayers.map((ghgLayer) => {
          if (ghgLayer.scene.sensorId == collection.sensors[sensorIndex].id) {
            this.removeGHGLayerByScene(ghgLayer);
          }
        });
        const sensorFeedsToClear = this.getCombinedFeedsForSensor(
          this.collection.sensors[sensorIndex]
        );
        sensorFeedsToClear.forEach((feed) => {
          feed.checked = false;
          feed.isDisable = true;
        });
        this.clearDisplayedCompareFeedLayers();
        this.displayedIS = null;
        this.collection.sensors[sensorIndex]?.indicesDetails?.map(
          (indicesDetails) => {
            indicesDetails.checked = false;
          }
        );
        this.removeISLayers();
        this.removeIndices();
        if (this.mapPane == 'left') {
          this.leftImageNew = null;
          this.mapPane = 'right';
          this.leftBand = false;
        } else {
          this.mapPane = 'left';
          this.rightImageNew = null;
          this.rightBand = false;
        }
        if (this.leftImageNew == null && this.rightImageNew == null) {
          this.mapPane = '';
        }

        this.scenesNew = this.scenesNew.filter((scene: any) => {
          return scene.sensorId != collection.sensors[sensorIndex].id;
        });
        this.refreshTiffMaxZoomAfterLayerChange();
        this.ghgLayers = this.ghgLayers.filter((ghgLayer: any) => {
          return ghgLayer.scene.sensorId != collection.sensors[sensorIndex].id;
        });

        if (
          collection?.sensors[sensorIndex]?.scenes[0]?.operatorKey ==
          this.OPERATOR.CLYDE
        ) {
          this.removeClydeVesselLayer();
          this.clydeData = null;
          if (this.clickedMarker) {
            this.map.removeLayer(this.clickedMarker);
            this.clickedMarker = null;
          }
          if (this.spireData && this.sensorsNew.length > 0) {
            if (
              this.scenesNew[0].scene?.operatorKey == OPERATORS.SPIRE &&
              this.scenesNew[0].scene.checked
            ) {
              this.displayVesselSnapshot(
                this.scenesNew[0].scene,
                this.spireData,
                selectedSensor[0],
                'SPIRE'
              );
            }
          }
        } else if (
          collection.sensors[sensorIndex].scenes[0].operatorKey ==
          this.OPERATOR.SPIRE
        ) {
          this.spireData = null;
          this.removeVesselLayer();
          if (this.clickedMarker) {
            this.map.removeLayer(this.clickedMarker);
            this.clickedMarker = null;
          }
          if (this.clydeData && this.sensorsNew.length > 0) {
            if (
              this.scenesNew[0].scene?.operatorKey == OPERATORS.CLYDE &&
              this.scenesNew[0].scene.checked
            ) {
              this.displayVesselSnapshot(
                this.scenesNew[0].scene,
                this.clydeData,
                selectedSensor[0],
                'CLYDE'
              );
            }
          }
        }
        this.syncStandardCompareSideData();
        if (this.sensorsNew.length === 1) {
          this.restoreRemainingFeedLayerAfterCompareReset(
            this.sensorsNew[0],
            remainingCompareCache
          );
        }
      }
      if (
        collection.sensors[sensorIndex].scenes.filter(
          (scene) => scene.checked == true
        ) > 1
      ) {
        this.isDisableIS = true;
      } else if (
        collection.sensors[sensorIndex].scenes.filter(
          (scene) => scene.checked == true
        ) == 1
      ) {
        let selectedScene = collection.sensors[sensorIndex].scenes[0];
      }
    }
    if (!event.checked) {
      const allFeeds = this.getCombinedFeedsForSensor(collection.sensors[sensorIndex]);
      allFeeds.forEach((feed) => {
        feed.checked = false;
        feed.isDisable = true;
      });
    }
    this.syncAssociatedFeedsForSensorToggle(
      collection.sensors[sensorIndex],
      event.checked
    );
    if (this.isStandardMultiSensorCompareActive()) {
      this.sensorsNew.forEach((compareSensor: any) => {
        this.clearAssociatedFeedsForCompare(compareSensor);
      });
    }
    if (this.isFeedTasking && !suppressFeedRedisplayOnSensorCheck) {
      const activeFeeds = event.checked
        ? questionFeedsToRedisplay
        : this.getActiveFeedsForSensor(collection.sensors[sensorIndex]);
      activeFeeds.forEach(
        (InfoService, infoServiceIndex) => {
          this.selectISNew(
            collectionIndex,
            sensorIndex,
            infoServiceIndex,
            event,
            InfoService,
            collection?.taskId
          );
        }
      );
    }
  }

  showAbortRetainPopup(): Promise<boolean> {
    return new Promise((resolve) => {
      const dialogRef = this.dialog.open(WarningPopup, {
        width: '40%',
        data: {
          type: 'abortApi',
          title: 'Operation Running',
          message:
            'Changing project name, task name or navigating away from the page will abort the current operation. Please confirm whether to abort or continue the ongoing operation.',
        },
      });

      dialogRef.afterClosed().subscribe((result) => {
        resolve(result === 'confirm'); // return true if confirmed
      });
    });
  }

  toggleSceneNew(collection, collectionIndex, sensorIndex, sceneIndex, event) {
    this.resetAllFeedPanels();
    this.clearAllPredictionData();
    this.clearFilteredLayerAndRestore(true);
    this.feedInfo = false;
    this.indiceType = 'display';
    this.failScene = 0;
    this.sliderShow = false;
    let scene = collection.sensors[sensorIndex].scenes[sceneIndex];
    this.selectedSceneNew = scene;
    this.removeDynamicLayer();
    this.opManager.completeOperation();
    collection.sensors[sensorIndex].scenes[sceneIndex].checked = event.checked;
    const remainingCompareSensor =
      this.sensorsNew.find(
        (currentSensor: any) =>
          currentSensor.id != collection.sensors[sensorIndex].id
      ) ?? null;
    const remainingComparePane = remainingCompareSensor
      ? this.getComparePaneForSensor(remainingCompareSensor)
      : null;
    const remainingCompareCache = remainingComparePane
      ? this.compareFeedCache[remainingComparePane] ?? null
      : null;
    if (!event.checked) {
      const sceneFeeds = this.getCombinedFeedsForSensor(
        collection.sensors[sensorIndex]
      );
      sceneFeeds.forEach((feed) => {
        feed.checked = false;
        feed.isDisable = true;
      });
      this.clearDisplayedCompareFeedLayers();
      this.displayedIS = null;
    }
    this.removeVectorOverlay();
    {
      this.feedUi = { showFilterIcon: false };
    }
    this.unSubscribeAPI();
    if (this.getCollectionSub) {
      this.getCollectionSub.unsubscribe();
      this.spinnerService.hide();
    }
    if (
      (collection.sensors[sensorIndex].scenes[sceneIndex]?.skipPreview &&
        this.imageType !== 'tif') ||
      ((!collection.sensors[sensorIndex].scenes[sceneIndex]?.footprint ||
        !collection.sensors[sensorIndex].scenes[sceneIndex]?.id) &&
        !collection.sensors[sensorIndex].scenes[sceneIndex]?.uslFootprint &&
        !collection.sensors[sensorIndex].scenes[sceneIndex]?.signalOfInterest)
    ) {
      if (event.checked) {
        this.showNoPreview(
          event,
          collection.sensors[sensorIndex].scenes[sceneIndex]
        );
      }
      collection.sensors[sensorIndex].scenes[sceneIndex].checked =
        event.checked;
      return;
    }
    if (scene) {
      this.sceneSelected = scene?.id;
    }
    collection.sensors[sensorIndex].scenes.forEach((scene: any) => {
      scene.imageType = this.imageType;
      scene.tif = this.imageType == 'tif' ? true : false;
    });

    collection.sensors[sensorIndex].indicesDetails?.map((indicesDetails) => {
      indicesDetails.checked = false;
      indicesDetails.loadTif = false;
    });

    this.isClydeHistorical = false;
    this.HistoricalLayer.forEach((HisLayer) => {
      this.map.removeLayer(HisLayer.marker);
    });
    this.HistoricalLayer = [];
    this.observationChecked = true;
    if (event.checked) {
      this.observationEnabled = true;
    } else {
      this.observationEnabled = false;
    }

    if (event.checked) {
      this.newTaskButtonClicked = false;
      this.selectedSceneIndex = sceneIndex;
      this.mapLoad = true;
      this.spinnerService.show();
      this.selectedSceneNew = scene;
      this.isScenSelected = true;

      this.removeIndices();
      if (
        this.collections[collectionIndex]?.sensors[sensorIndex]
          ?.valueAddedOption?.length > 0
      ) {
        this.collections[collectionIndex].sensors[
          sensorIndex
        ].valueAddedOption.map((valueAddedOption) => {
          valueAddedOption.checked = false;
        });
      }

      collection.sensors[sensorIndex].indicesDetails?.map((indicesDetails) => {
        indicesDetails.checked = false;
        indicesDetails.loadTif = false;
      });

      const hasCheckedFeeds =
        this.collections[collectionIndex].sensors[sensorIndex].InfoServices.filter(
          (InfoService) => InfoService.checked == true
        ).length > 0 ||
        this.collections[collectionIndex].sensors[
          sensorIndex
        ].AssociatedFeeds?.filter((feed) => feed.checked == true)?.length > 0;

      if (
        hasCheckedFeeds &&
        this.collections[collectionIndex].sensors[sensorIndex]?.operatorKey !==
          OPERATORS.AXELSPACE
      ) {
        const activeFeeds = this.getActiveFeedsForSensor(this.collections[collectionIndex].sensors[sensorIndex]);
        const selectedFeed = activeFeeds.filter(
          (infoService) => infoService.checked === true
        )[0];
        
        let selectedSceneIS = selectedFeed?.insightDatas?.filter(
          (scene) => scene.sceneId === this.selectedSceneNew.id
        ) || [];

        this.displayedIS = {
          insightFootprint: selectedSceneIS[0]?.insightFootprint ? JSON.parse(
            JSON.stringify(selectedSceneIS[0].insightFootprint)
          ) : {},
          isInfo: selectedFeed,
        };
      }
      if (
        this.sensorsNew.findIndex(
          (sensor) => sensor.id == collection.sensors[sensorIndex].id
        ) == -1
      ) {
        // collection.sensors[sensorIndex].checked = true;
        this.sensorsNew.push(collection.sensors[sensorIndex]);
        if (this.mapPane == 'left') {
          this.mapPane = 'right';
        } else {
          this.mapPane = 'left';
        }
      } else {
        if (
          (this.leftImageNew == null && this.rightImageNew == null) ||
          this.mapPane == ''
        ) {
          this.mapPane = 'left';
        }
      }

      if (scene?.id && scene?.status !== 'failed') {
        scene.checked = true;
        scene.pane = this.mapPane;
        const sensorObj = {
          sensorId: collection.sensors[sensorIndex].id,
          sceneId: scene?.id,
          action: 'scene',
          fileType: scene.imageType,
        };
        if (collection.sensors[sensorIndex].checked != true) {
          collection.sensors[sensorIndex].checked = false;
        }
        let selectedScenes: any[] = this.collection.sensors[
          sensorIndex
        ].scenes.filter((scene) => scene.checked == true);
        if (this.clydeData && this.clickedAIS?.operatorKey == OPERATORS.CLYDE) {
          let selectedAISSensor = collection.sensors.filter((snsr) => {
            return snsr.operatorKey == OPERATORS.CLYDE;
          })[0];
          this.displayVesselSnapshot(
            selectedAISSensor.scenes[0],
            this.clydeData,
            selectedAISSensor,
            'CLYDE'
          );
        }
        if (this.spireData && this.clickedAIS?.operatorKey == OPERATORS.SPIRE) {
          let selectedAISSensor = collection.sensors.filter((snsr) => {
            return snsr.operatorKey == OPERATORS.SPIRE;
          })[0];
          this.displayVesselSnapshot(
            selectedAISSensor.scenes[0],
            this.spireData,
            selectedAISSensor,
            'SPIRE'
          );
        }

        if (
          this.collections[collectionIndex].sensors[sensorIndex]
            ?.operatorKey === OPERATORS.AXELSPACE ||
          this.collections[collectionIndex].sensors[sensorIndex]
            ?.operatorKey === OPERATORS.AZISTA
        ) {
          if (
            this.collection.sensors[sensorIndex]?.indicesDetails?.length > 0
          ) {
            if (selectedScenes.length > 0) {
              this.collection.sensors[sensorIndex].indicesDetails?.map(
                (indicesDetails, indicesDetailsindex) => {
                  if (
                    this.collection.sensors[sensorIndex].id ==
                      indicesDetails.sensorId &&
                    indicesDetails?.products?.length > 0
                  ) {
                    this.collection.sensors[sensorIndex].indicesDetails[
                      indicesDetailsindex
                    ].isDisable = false;
                  } else {
                    this.collection.sensors[sensorIndex].indicesDetails[
                      indicesDetailsindex
                    ].isDisable = true;
                  }
                }
              );
            }
          }
          if (
            this.collection.sensors[0].scenes.length != selectedScenes.length
          ) {
            collection.sensors[sensorIndex].InfoServices.map((infoService) => {
              infoService.isDisable = true;
            });
            collection.sensors[sensorIndex].AssociatedFeeds?.map(
              (associatedFeed) => {
                associatedFeed.isDisable = true;
              }
            );
          } else {
            collection.sensors[sensorIndex].InfoServices.map((infoService) => {
              infoService.isDisable = false;
            });
            collection.sensors[sensorIndex].AssociatedFeeds?.map(
              (associatedFeed) => {
                associatedFeed.isDisable =
                  !this.areAllScenesChecked(collection.sensors[sensorIndex]) ||
                  !this.hasAssociatedFeedResults(associatedFeed);
              }
            );
          }
        } else if (
          collection.sensors[sensorIndex].scenes.filter(
            (scene) =>
              scene?.id && scene?.status !== 'failed' && scene.checked == true
          ).length == 1 &&
          this.sensorsNew.length == 1
        ) {
          this.removeIndices();
          this.removeSuperResolutions();
          collection.sensors[sensorIndex].InfoServices.map((infoService) => {
            infoService.isDisable = false;
          });
          collection.sensors[sensorIndex].AssociatedFeeds?.map(
            (associatedFeed) => {
              associatedFeed.isDisable =
                !this.areAllScenesChecked(collection.sensors[sensorIndex]) ||
                !this.hasAssociatedFeedResults(associatedFeed);
            }
          );
          collection.sensors[sensorIndex].indicesDetails?.map(
            (indicesDetails) => {
              indicesDetails.isDisable = false;
            }
          );
          collection.sensors[sensorIndex].superResolutions?.map(
            (superResolutions) => {
              superResolutions.isDisable = false;
            }
          );
        } else if (this.sensorsNew.length == 2) {
          this.removeIndices();
          this.resetFeedsStatus(collection);
        } else {
          this.removeIndices();
          this.resetFeedsStatus(collection);
        }
        if (
          collection.sensors[sensorIndex].scenes[0].operatorKey ==
          this.OPERATOR.CLYDE
        ) {
          const coordinates = scene?.footprint?.coordinates[0];
          let taskId = this.collection?.taskId;
          let newCoordinates = coordinates.map((coord) => {
            return [coord[1], coord[0]];
          });
          newCoordinates = [newCoordinates];
          newCoordinates = JSON.stringify(newCoordinates);
          const encodedCoordinates = encodeURIComponent(newCoordinates);
          const startTime = encodeURIComponent(scene.openWindow);
          const endTime = encodeURIComponent(scene.closeWindow);
          const clydePayload = {
            polygon: encodedCoordinates,
            startTime: startTime,
            endTime: endTime,
            type: 'display',
          };
          const input = JSON.parse(decodeURIComponent(clydePayload.polygon));
          this.vesselPolygon = input[0]
            .map((pair) => pair.reverse().join(' '))
            .join(', ');
          clydePayload.polygon = this.vesselPolygon;
          this.apiService.getClydeAISData(clydePayload, taskId).subscribe(
            (res: any) => {
              this.clydeData = res.data;
              this.mapLoad = false;
              this.spinnerService.hide();
              if (res?.data?.length === 0) {
                const message =
                  'There is no AIS data in the area tasked. If there were to be vessels during the time of interest (TOI), those observations would become available when refreshed.';
                this.popupService.openPopup(
                  CollectionPopupComponent,
                  message,
                  '',
                  '40%'
                );
                collection.sensors[sensorIndex].checked = false;
                collection.sensors[sensorIndex].scenes.forEach((scene: any) => {
                  scene.checked = false;
                });
              } else {
                this.displayVesselSnapshot(
                  scene,
                  res.data,
                  this.collection.sensors[sensorIndex],
                  'CLYDE',
                  res
                );
              }
            },
            (error) => {
              this.mapLoad = false;
              this.spinnerService.hide();
            }
          );
        }
        if (
          collection.sensors[sensorIndex].scenes[0].operatorKey ==
            this.OPERATOR.CLYDE ||
          collection.sensors[sensorIndex].scenes[0].operatorKey ==
            this.OPERATOR.SPIRE ||
          collection.sensors[sensorIndex].scenes[0].operatorKey ==
            this.OPERATOR.VOYAGERADAR
        ) {
          this.fetchAISDataFromServer(collection, sensorIndex, scene);
        } else if (
          collection.sensors[sensorIndex].scenes[0].operatorKey ==
          this.OPERATOR.USL
        ) {
          if (!scene?.s_band && !scene?.x_band && scene?.usl_footprint) {
            scene.x_band = scene?.usl_footprint;
          }
          this.displayRFBandNew(
            scene,
            collection.sensors[sensorIndex].id,
            this.selectedBand
          );
        } else if (
          collection.sensors[sensorIndex].scenes[0].operatorKey ==
          this.OPERATOR.LBAND
        ) {
          this.displayRFSignalsNew(
            scene,
            collection.sensors[sensorIndex].id,
            this.signalSelected
          );
        } else {
          this.tifPopupShown = 0;
          this.fetchImageFromServer(collection, sensorObj, scene);
        }
      }
    } else {
      this.isScenSelected = false;
      scene.checked = false;
      this.vesselJsonData = undefined;
      let selectedSensor = collection.sensors.filter((sensor) => {
        return collection.sensors[sensorIndex].id != sensor.id;
      });
      if (
        collection.sensors[sensorIndex].scenes.filter(
          (scene) => scene?.id && scene?.status !== 'failed'
        ).length !=
        collection.sensors[sensorIndex].scenes.filter(
          (scene) =>
            scene?.id && scene?.status !== 'failed' && scene.checked == true
        ).length
      ) {
        this.removeIndices();
        this.removeISLayers();
        this.removeSuperResolutions();
        if (this.displayedIS) {
          this.displayedIS = null;
        }
      }
      let selectedScenes: any[] = this.collection.sensors[
        sensorIndex
      ].scenes.filter((scene) => scene.checked == true);
      if (
        this.collections[collectionIndex].sensors[sensorIndex]?.operatorKey ===
          OPERATORS.AXELSPACE ||
        this.collections[collectionIndex].sensors[sensorIndex]?.operatorKey ===
          OPERATORS.AZISTA
      ) {
        if (this.collection.sensors[sensorIndex]?.indicesDetails?.length > 0) {
          if (selectedScenes.length == 0) {
            this.resetFeedsStatus(this.collection);
          }
        }
        if (this.collection.sensors[0].scenes.length != selectedScenes.length) {
          collection.sensors[sensorIndex].InfoServices.map((infoService) => {
            infoService.isDisable = true;
          });
          this.removeISLayers();
          if (this.displayedIS) {
            this.displayedIS = null;
          }
        } else {
          collection.sensors[sensorIndex].InfoServices.map((infoService) => {
            infoService.isDisable = false;
          });
        }
      } else {
        if (
          collection.sensors[sensorIndex].scenes.filter((scene) => {
            return (
              scene?.id && scene?.status !== 'failed' && scene.checked == true
            );
          }).length == 1
        ) {
          this.syncCurrentSceneSelection(collection.sensors[sensorIndex]);
          collection.sensors[sensorIndex].InfoServices.map((infoService) => {
            infoService.isDisable = false;
          });
          this.refreshAssociatedFeedsState(collection.sensors[sensorIndex]);
          collection.sensors[sensorIndex].indicesDetails?.map(
            (indicesDetails) => {
              indicesDetails.isDisable = false;
            }
          );
          collection.sensors[sensorIndex].superResolutions?.map(
            (superResolutions) => {
              superResolutions.isDisable = false;
            }
          );
        } else {
          this.resetFeedsStatus(collection);
        }
      }

      this.collection.sensors[sensorIndex]?.InfoServices.map((infoService) => {
        infoService.checked = false;
      });

      this.collection.sensors[sensorIndex]?.indicesDetails?.map(
        (indicesDetails) => {
          indicesDetails.checked = false;
        }
      );
      this.collection.sensors[sensorIndex]?.superResolutions?.map(
        (superResolutions) => {
          superResolutions.checked = false;
        }
      );
      let sensorNewIndex = this.sensorsNew.findIndex(
        (sensor) => sensor.id == collection.sensors[sensorIndex].id
      );
      if (
        collection.sensors[sensorIndex].scenes.filter(
          (scene) =>
            scene?.id && scene?.status !== 'failed' && scene.checked == false
        ).length ==
        this.sensorsNew[sensorNewIndex]?.scenes.filter(
          (scene) => scene?.id && scene?.status !== 'failed'
        ).length
      ) {
        this.sensorsNew.splice(sensorNewIndex, 1);
        if (this.sensorsNew.length == 1) {
          this.isCompare = false;
          let index = this.collection.sensors.findIndex(
            (sensor) => sensor.id == this.sensorsNew[0].id
          );
          if (
            collection.sensors[index].scenes.filter(
              (scene) =>
                scene?.id && scene?.status !== 'failed' && scene.checked == true
            ).length == 1
          ) {
            collection.sensors[index].InfoServices.map((infoService) => {
              infoService.isDisable = false;
            });
            this.refreshAssociatedFeedsState(collection.sensors[index]);
            collection.sensors[index].indicesDetails?.map((indicesDetails) => {
              indicesDetails.isDisable = false;
            });

            collection.sensors[index].superResolutions?.map(
              (superResolutions) => {
                superResolutions.isDisable = false;
              }
            );
            this.syncCurrentSceneSelection(collection.sensors[index]);
          }
        }
        let sceneNewIndex = this.scenesNew.findIndex(
          (sceneNew) => sceneNew.id == scene.id
        );
        this.mapPane = this.scenesNew[sceneNewIndex]?.pane;
        if (this.sensorsNew.length == 0) {
          this.mapPane = '';
          this.leftBand = false;
          this.annotateClicked = false;
          this.newTaskButtonClicked = false;
        } else if (this.mapPane == 'left') {
          this.leftImageNew = null;
          this.mapPane = 'right';
        } else {
          this.mapPane = 'left';
          this.rightImageNew = null;
        }
        if (this.compare) {
          this.map.removeControl(this.compare);
          this.compare = null;
        }
      }
      let sceneNewIndex = this.scenesNew.findIndex(
        (sceneNew) => sceneNew.id == scene.id
      );
      if (
        collection.sensors[sensorIndex].scenes[0].operatorKey ==
        this.OPERATOR.USL
      ) {
        this.clearRFBandsByScene(this.scenesNew[sceneNewIndex], true);
        this.removeAnnoatationByScene(this.scenesNew[sceneNewIndex]);
      } else {
        this.scenesNew.forEach((sceneItem) => {
          if (sceneItem?.scene?.id === scene?.id && !this.isVadapSelected) {
            this.removeAnnoatationByScene(sceneItem);
            let ghgIndex = this.ghgLayers.findIndex(
              (ghg) => ghg.scene.id == sceneItem.id
            );
            if (ghgIndex != -1) {
              this.removeGHGLayerByScene(this.ghgLayers[ghgIndex]);
              this.ghgLayers.splice(ghgIndex, 1);
            }
            if (sceneItem?.footprint) {
              this.map.removeLayer(sceneItem?.footprint);
            }
            if (sceneItem?.legendScale) {
              this.map.removeLayer(sceneItem?.legendScale);
            }
            if (sceneItem?.tiffootprint) {
              this.map.removeLayer(sceneItem?.tiffootprint);
            }
            if (this.scenesNew[sceneNewIndex]?.tiffootprint) {
              this.scenesNew.forEach((sceneItem) => {
                if (sceneItem?.scene?.id === scene?.id) {
                  this.map.removeLayer(sceneItem.tiffootprint);
                }
              });
            }
            this.clearRFSignalsByScene(sceneItem);
            if (this.selectedSignals.length > 0) {
              let removeIndex = this.selectedSignals.findIndex(
                (Signal) => Signal.sceneId == sceneItem?.id
              );
              this.selectedSignals.splice(removeIndex, 1);
            }
            if (sceneItem?.leftImageLayer && sceneItem?.pane == 'left') {
              this.map.removeLayer(sceneItem?.leftImageLayer);
            }
            if (sceneItem?.rightImageLayer && sceneItem?.pane == 'right') {
              this.map.removeLayer(sceneItem?.rightImageLayer);
            }
            if (this.leftImageNew == null && this.rightImageNew == null) {
              this.mapPane = '';
            }
          }
        });
      }
      this.removeISLayers();
      this.removeIndices();
      this.removeSuperResolutions();
      if (sceneNewIndex != -1) {
        this.scenesNew.splice(sceneNewIndex, 1);
      }
      this.refreshTiffMaxZoomAfterLayerChange();

      if (
        collection.sensors[sensorIndex].scenes.filter(
          (scene) =>
            scene?.id && scene?.status !== 'failed' && scene.checked == true
        ).length == 1
      ) {
        this.isDisableIS = false;
      } else {
        this.isDisableIS = true;
      }
      if (
        collection.sensors[sensorIndex].scenes[0].operatorKey ==
        this.OPERATOR.CLYDE
      ) {
        this.removeClydeVesselLayer();
        this.clydeData = null;
        if (this.clickedMarker) {
          this.map.removeLayer(this.clickedMarker);
          this.clickedMarker = null;
        }
        if (this.spireData && this.sensorsNew.length > 0) {
          if (
            this.scenesNew[0].scene?.operatorKey == OPERATORS.SPIRE &&
            this.scenesNew[0].scene.checked
          ) {
            let selectedAISSensor = collection.sensors.filter((snsr) => {
              return snsr.operatorKey == OPERATORS.SPIRE;
            })[0];
            if (this.clickedMarker) {
              this.map.removeLayer(this.clickedMarker);
              this.clickedMarker = null;
            }
            this.displayVesselSnapshot(
              selectedAISSensor.scenes[0],
              this.spireData,
              selectedAISSensor,
              'SPIRE'
            );
          }
        }
      } else if (
        collection.sensors[sensorIndex].scenes[0].operatorKey ==
        this.OPERATOR.SPIRE
      ) {
        this.spireData = null;
        this.removeVesselLayer();
        if (this.clickedMarker) {
          this.map.removeLayer(this.clickedMarker);
          this.clickedMarker = null;
        }
        if (this.clydeData && this.sensorsNew.length > 0) {
          if (
            this.scenesNew[0].scene?.operatorKey == OPERATORS.CLYDE &&
            this.scenesNew[0].scene.checked
          ) {
            let selectedAISSensor = collection.sensors.filter((snsr) => {
              return snsr.operatorKey == OPERATORS.CLYDE;
            })[0];
            this.displayVesselSnapshot(
              selectedAISSensor.scenes[0],
              this.clydeData,
              selectedAISSensor,
              'CLYDE'
            );
          }
        }
      }
      if (this.sensorsNew.length === 1) {
        this.restoreRemainingFeedLayerAfterCompareReset(
          this.sensorsNew[0],
          remainingCompareCache
        );
      }
      if (this.isStandardMultiSensorCompareActive()) {
        this.sensorsNew.forEach((compareSensor: any) => {
          this.clearAssociatedFeedsForCompare(compareSensor);
        });
      }
    }
    if (
      collection.sensors[sensorIndex]?.scenes?.length > 1 &&
      collection.sensors[sensorIndex]?.InfoServices?.length === 1
    )
      this.updateFeedEnabledState(collectionIndex, sensorIndex);
  }

  toggleRecurrentSceneNew(
    collection,
    collectionIndex,
    sensorIndex,
    sceneIndex,
    scene,
    event
  ) {
    this.failScene = 0;
    this.selectedCheckboxesNew[sensorIndex].scenes[sceneIndex].checked =
      event.checked;
    if (
      this.collection.sensors[0].operatorKey == this.OPERATOR.USL ||
      this.collection.sensors[0].operatorKey == this.OPERATOR.LBAND
    ) {
      if (event.checked) {
        this.removeAnnotationMarkers();
        this.annotateClicked = false;
        this.newTaskButtonClicked = false;
        if (
          this.selectedCheckboxesNew[sensorIndex].scenes.filter(
            (scene) => scene?.id && scene?.status !== 'failed'
          ).length ==
          this.selectedCheckboxesNew[sensorIndex].scenes.filter(
            (scene) =>
              scene?.id && scene?.status !== 'failed' && scene.checked == true
          ).length
        ) {
          this.selectedCheckboxesNew[sensorIndex].checked = true;
        }
        if (
          scene?.id &&
          scene?.status !== 'failed' &&
          this.collection.sensors[0].operatorKey == this.OPERATOR.USL
        ) {
          scene.checked = true;
          scene.start = this.selectedCheckboxesNew[sensorIndex]?.start;
          if (!scene?.s_band && !scene?.x_band && scene?.usl_footprint) {
            scene.x_band = scene?.usl_footprint;
          }
          this.displayRFBandNew(
            scene,
            this.collection.sensors[0].id,
            this.selectedBand
          );
        } else {
          scene.checked = true;
          scene.start = this.selectedCheckboxesNew[sensorIndex]?.start;
          this.displayRFSignalsNew(
            scene,
            this.collection.sensors[0].id,
            this.signalSelected
          );
        }
      } else {
        this.selectedCheckboxesNew[sensorIndex].scenes[sceneIndex].checked =
          false;
        if (
          this.selectedCheckboxesNew[sensorIndex].scenes.filter(
            (scene) => scene?.id && scene?.status !== 'failed'
          ).length ==
          this.selectedCheckboxesNew[sensorIndex].scenes.filter(
            (scene) =>
              scene?.id && scene?.status !== 'failed' && scene.checked == false
          ).length
        ) {
          this.toggleRecurrentSensorNew(collectionIndex, sensorIndex, event);
        } else {
          let sceneNewIndex = this.scenesNew.findIndex(
            (sceneNew) => sceneNew.id == scene.id
          );
          if (
            this.selectedCheckboxesNew[sensorIndex].scenes[0].operatorKey ==
            this.OPERATOR.USL
          ) {
            this.clearRFBandsByScene(this.scenesNew[sceneNewIndex], false);
            this.removeAnnoatationByScene(this.scenesNew[sceneNewIndex]);
            this.scenesNew = this.scenesNew.filter(
              (sceneNew) => sceneNew.id != scene.id
            );
            this.refreshTiffMaxZoomAfterLayerChange();
          } else if (
            this.selectedCheckboxesNew[sensorIndex].scenes[0].operatorKey ==
            this.OPERATOR.LBAND
          ) {
            this.scenesNew.map((scene: any, index: any) => {
              this.clearRFSignalsByScene(scene);
            });
            this.scenesNew = this.scenesNew.filter(
              (sceneNew) => sceneNew.id != scene.id
            );
            this.refreshTiffMaxZoomAfterLayerChange();
          }
        }
      }
    } else {
      if (this.collection.recurrencyArray.length > 0) {
        if (event.checked) {
          this.removeAnnotationMarkers();
          this.annotateClicked = false;
          this.newTaskButtonClicked = false;
          this.spinnerService.show();
          if (scene.pane == undefined) {
            scene.pane = 'left';
          }
          this.mapPane = scene.pane;
          this.removeCompareControlSafely();
          if (scene?.id && scene?.status !== 'failed') {
            scene.checked = true;
            const sensorObj = {
              sensorId: collection.sensors[collection.sensors.length - 1].id,
              sceneId: scene?.id,
              action: 'scene',
              fileType: scene.imageType,
            };
            this.tifPopupShown = 0;
            this.fetchImageFromServer(collection, sensorObj, scene);
          }
        } else {
          scene.tif = false;
          scene.imageType = 'png';
          this.imageType = this.checkType();
          this.removeCompareControlSafely();
          this.scenesNew.forEach((sceneNew) => {
            if (sceneNew.id == scene.id) {
              this.removeLayerByScene(sceneNew);
              if (sceneNew?.leftImageLayer) {
                this.leftImageNew = null;
              }
              if (sceneNew?.rightImageLayer) {
                this.rightImageNew = null;
              }
              this.removeAnnoatationByScene(sceneNew);
            }
          });

          this.ghgLayers.forEach((ghgLayer) => {
            if (ghgLayer.scene.id == scene.id) {
              this.removeGHGLayerByScene(ghgLayer);
            }
          });

          this.scenesNew = this.scenesNew.filter((sceneNew) => {
            return sceneNew.id != scene.id;
          });
          this.refreshTiffMaxZoomAfterLayerChange();
          this.ghgLayers = this.ghgLayers.filter((ghgLayer) => {
            return ghgLayer.scene.id != scene.id;
          });
          this.updateImageLayersBasedOnPane();
          if (
            this.selectedCheckboxesNew[sensorIndex].scenes.filter(
              (scene) => scene?.id && scene?.status !== 'failed'
            ).length ==
            this.selectedCheckboxesNew[sensorIndex].scenes.filter(
              (scene) =>
                scene?.id &&
                scene?.status !== 'failed' &&
                scene.checked == false
            ).length
          ) {
            this.toggleRecurrentSensorNew(collectionIndex, sensorIndex, event, this.selectedCheckboxesNew[sensorIndex]);
          }
          if (this.leftImageNew && this.rightImageNew) {
            this.ensureCompareSplit();
          }
        }
        this.toggleCompareLabels();
      } else if (
        this.collection.sensors[0].operatorKey == this.OPERATOR.AXELSPACE ||
        this.collection.sensors[0].operatorKey == this.OPERATOR.AZISTA
      ) {
        if (event.checked) {
          this.removeAnnotationMarkers();
          this.annotateClicked = false;
          this.newTaskButtonClicked = false;
          this.spinnerService.show();
          this.mapPane = scene.pane;
          this.removeCompareControlSafely();
          if (scene?.id && scene?.status !== 'failed') {
            scene.checked = true;
            const sensorObj = {
              sensorId: collection.sensors[collection.sensors.length - 1].id,
              sceneId: scene?.id,
              action: 'scene',
              fileType: scene.imageType,
            };
            this.tifPopupShown = 0;
            this.fetchImageFromServer(collection, sensorObj, scene);
          }
        } else {
          if (this.compare) {
            this.map.removeControl(this.compare);
            this.compare = null;
          }
          this.scenesNew.forEach((sceneNew) => {
            if (sceneNew.id == scene.id) {
              this.removeLayerByScene(sceneNew);
              if (sceneNew?.leftImageLayer) {
                this.leftImageNew = null;
              }
              if (sceneNew?.rightImageLayer) {
                this.rightImageNew = null;
              }
              this.removeAnnoatationByScene(sceneNew);
            }
          });
          this.scenesNew = this.scenesNew.filter((sceneNew) => {
            return sceneNew.id != scene.id;
          });
          this.refreshTiffMaxZoomAfterLayerChange();
          this.updateImageLayersBasedOnPane();
          if (
            this.selectedCheckboxesNew[sensorIndex].scenes.filter(
              (scene) => scene?.id && scene?.status !== 'failed'
            ).length ==
            this.selectedCheckboxesNew[sensorIndex].scenes.filter(
              (scene) =>
                scene?.id &&
                scene?.status !== 'failed' &&
                scene.checked == false
            ).length
          ) {
            this.toggleRecurrentSensorNew(collectionIndex, sensorIndex, event);
          }
          if (this.leftImageNew && this.rightImageNew) {
            this.ensureCompareSplit();
          }
        }
      }
    }
    if (
      collection.sensors[sensorIndex].scenes?.length > 1 &&
      collection.sensors[sensorIndex].InfoServices.length === 1
    )
      this.updateFeedEnabledState(collectionIndex, sensorIndex);
  }

  updateFeedEnabledState(
    collectionIndex: number,
    sensorIndex: number,
    isLoadCombineScenes?: any
  ): void {
    const sensor = this.collections[collectionIndex].sensors[sensorIndex];
    const scenes = sensor.scenes;
    if (isLoadCombineScenes?.checked) {
      scenes.forEach((scene) => {
        scene.checked = true;
      });
      sensor.checked = true;
      this.combinedScenes = true;
      const allFeeds = this.getCombinedFeedsForSensor(sensor);
      allFeeds.forEach((feed) => {
        const canEnableAssociated =
          !this.isAssociatedFeed(sensor, feed) ||
          this.areAllScenesChecked(sensor);
        feed.isDisable = !canEnableAssociated;
      });
      this.toggleSensorNew(
        this.collections[collectionIndex],
        collectionIndex,
        sensorIndex,
        { checked: true }
      );
    } else if (isLoadCombineScenes?.checked === false) {
      const allFeeds = this.getCombinedFeedsForSensor(sensor);
      allFeeds.forEach((feed) => {
        feed.isDisable = true;
      });
      scenes.forEach((scene) => {
        scene.checked = false;
      });
      sensor.InfoServices.forEach((feed) => {
        feed.isDisable = true;
      });
      this.combinedScenes = false;
      this.resetMapNew();
    }

    if (!isLoadCombineScenes) {
      const selectedCount = scenes.filter((s) => s.checked).length;
      const totalScenes = scenes.length;
      const isTileBasedOperator =
        sensor?.operatorKey === OPERATORS.AXELSPACE ||
        sensor?.operatorKey === OPERATORS.AZISTA;
      const selectableTileScenes = isTileBasedOperator
        ? scenes.filter((s) => s?.id && s?.status !== 'failed')
        : [];
      const selectedSelectableTiles = isTileBasedOperator
        ? selectableTileScenes.filter((s) => s.checked).length
        : 0;

      const enableFeeds = isTileBasedOperator
        ? selectableTileScenes.length > 0 &&
          selectedSelectableTiles === selectableTileScenes.length
        : selectedCount === 1 || selectedCount === totalScenes;
      const isStandardCompare = this.isStandardMultiSensorCompareActive(sensor);

      sensor.InfoServices.forEach((feed) => {
        feed.isDisable = isStandardCompare ? false : !enableFeeds;
      });
      this.combinedScenes = selectedCount === totalScenes && totalScenes > 1;
      if (selectedCount === totalScenes && totalScenes > 1)
        sensor.checked = true;
    }
    this.collections[collectionIndex]?.sensors[
      sensorIndex
    ]?.InfoServices.forEach((feed) => {
      feed.checked = false;
    });
    scenes.forEach((scene) => {
      if (scene.checked == true) this.sceneSelected = scene.id;
    });
    this.resetAllFeedPanels();
    this.clearFilteredLayerAndRestore(true);
    this.removeISLayers();
    this.removeSuperResolutions();
    this.removeDynamicLayer();
    this.removeVectorOverlay();
    this.clearAllPredictionData();
  }

  toggleRecurrentSubdailySceneNew(
    collection,
    collectionIndex,
    sensorIndex,
    sceneIndex,
    event
  ) {
    this.failScene = 0;
    let scene = this.subDailyFinalArray[sensorIndex].scenes[sceneIndex];
    this.subDailyFinalArray[sensorIndex].scenes[sceneIndex].checked =
      event.checked;
    if (
      this.collection.sensors[0].operatorKey == this.OPERATOR.USL ||
      this.collection.sensors[0].operatorKey == this.OPERATOR.LBAND
    ) {
      if (event.checked) {
        this.annotateClicked = false;
        this.newTaskButtonClicked = false;
        this.removeAnnotationMarkers();
        if (
          this.subDailyFinalArray[sensorIndex].scenes.filter(
            (scene) => scene?.id && scene?.status !== 'failed'
          ).length ==
          this.subDailyFinalArray[sensorIndex].scenes.filter(
            (scene) =>
              scene?.id && scene?.status !== 'failed' && scene.checked == true
          ).length
        ) {
          this.subDailyFinalArray[sensorIndex].checked = true;
        }
        if (scene?.id && scene?.status !== 'failed') {
          scene.checked = true;
          scene.sequenceNumber =
            this.selectedCheckboxesNew[sensorIndex]?.sequenceNumber;
          if (this.collection.sensors[0].operatorKey == this.OPERATOR.USL) {
            if (!scene?.s_band && !scene?.x_band && scene?.usl_footprint) {
              scene.x_band = scene?.usl_footprint;
            }
            this.displayRFBandNew(
              scene,
              this.selectedCheckboxesNew[sensorIndex].id,
              this.selectedBand
            );
          } else {
            this.displayRFSignalsNew(
              scene,
              this.selectedCheckboxesNew[sensorIndex].id,
              this.signalSelected
            );
          }
        }
      } else {
        this.subDailyFinalArray[sensorIndex].scenes[sceneIndex].checked = false;
        const allScenesUnchecked = this.subDailyFinalArray.every((obj) =>
          obj.scenes.every((scene) => scene.checked === false)
        );

        if (allScenesUnchecked) {
          this.showDailyRecurrencyCheckboxes = false;
          this.toggleDailyRecurrency(event);
        }
        if (
          this.subDailyFinalArray[sensorIndex].scenes.filter(
            (scene) => scene?.id && scene?.status !== 'failed'
          ).length ==
          this.subDailyFinalArray[sensorIndex].scenes.filter(
            (scene) =>
              scene?.id && scene?.status !== 'failed' && scene.checked == false
          ).length
        ) {
          this.toggleSubDailyRecurrentSensorNew(
            sensorIndex,
            this.subDailyFinalArray[sensorIndex],
            event
          );
        } else {
          let sceneNewIndex = this.scenesNew.findIndex(
            (sceneNew) => sceneNew.id == scene.id
          );
          if (
            this.subDailyFinalArray[sensorIndex].scenes[0].operatorKey ==
              this.OPERATOR.USL ||
            this.subDailyFinalArray[sensorIndex].scenes[0].operatorKey ==
              this.OPERATOR.LBAND
          ) {
            this.clearRFBandsByScene(this.scenesNew[sceneNewIndex], false);
            this.clearRFSignalsByScene(this.scenesNew[sceneNewIndex]);
          }
        }
      }
    } else {
      if (event.checked) {
        this.annotateClicked = false;
        this.newTaskButtonClicked = false;
        this.removeAnnotationMarkers();
        this.spinnerService.show();
        this.mapPane = scene.pane;
        if (this.compare) {
          this.map.removeControl(this.compare);
          this.compare = null;
        }
        if (scene?.id && scene?.status !== 'failed') {
          scene.checked = true;
          const sensorObj = {
            sensorId: collection.sensors[collection.sensors.length - 1].id,
            sceneId: scene?.id,
            action: 'scene',
            fileType: scene.imageType,
          };
          this.apiService
            .getCollectionImage(collection.taskId, sensorObj)
            .subscribe((res: any) => {
              if (res?.msg === 'Failed') {
                this.mapLoad = false;
                this.spinnerService.hide();
                this.failScene = this.failScene + 1;
                if (this.failScene == 1) {
                  const message =
                    'An error occurred during processing and ingestion of the request. Please try after sometime.';
                  this.popupService.openPopup(
                    CollectionPopupComponent,
                    message,
                    '',
                    '40%'
                  );
                }
              } else if (res?.result) {
                if (this.selectedSites.length > 0) {
                  let site = this.selectedSites.filter((selectedSite) => {
                    return selectedSite.value == scene.siteId;
                  })[0];
                  this.mapPane = site.mapPane;
                  this.displayFootprintImageByRecurrentDataNew(
                    scene,
                    res.result,
                    collection.sensors[collection.sensors.length - 1].id,
                    this.selectedSites
                  );
                } else {
                  this.displayFootprintImageByRecurrentDataNew(
                    scene,
                    res.result,
                    collection.sensors[collection.sensors.length - 1].id,
                    this.selectedSubDailyItemsNew
                  );
                }
              } else {
                this.mapLoad = false;
                this.spinnerService.hide();
              }
            });
        }
      } else {
        if (this.compare) {
          this.map.removeControl(this.compare);
          this.compare = null;
        }
        this.scenesNew.forEach((sceneNew) => {
          if (sceneNew.id == scene.id) {
            this.removeLayerByScene(sceneNew, { paneSpecific: true });
            this.removeAnnoatationByScene(sceneNew);
          }
        });

        this.ghgLayers.forEach((ghgLayer) => {
          if (ghgLayer.scene.id == scene.id) {
            this.removeGHGLayerByScene(ghgLayer);
          }
        });

        this.scenesNew = this.scenesNew.filter((sceneNew) => {
          return sceneNew.id != scene.id;
        });
        this.refreshTiffMaxZoomAfterLayerChange();
        this.ghgLayers = this.ghgLayers.filter((ghgLayer) => {
          return ghgLayer.scene.id != scene.id;
        });
        scene.tif = false;
        scene.imageType = 'png';
        this.imageType = this.checkType();
        this.updateImageLayersBasedOnPane();
        if (
          this.subDailyFinalArray[sensorIndex].scenes.filter(
            (scene) => scene?.id && scene?.status !== 'failed'
          ).length ==
          this.subDailyFinalArray[sensorIndex].scenes.filter(
            (scene) =>
              scene?.id && scene?.status !== 'failed' && scene.checked == false
          ).length
        ) {
          this.toggleSubDailyRecurrentSensorNew(
            sensorIndex,
            this.subDailyFinalArray[sensorIndex],
            event
          );
        }
        if (this.leftImageNew && this.rightImageNew) {
          this.ensureCompareSplit();
        }
      }
    }
    if (
      collection.sensors[sensorIndex].scenes?.length > 1 &&
      collection.sensors[sensorIndex].InfoServices.length === 1
    )
      this.updateFeedEnabledState(collectionIndex, sensorIndex);
  }

  toggleUSLSensorNew(collection, collectionIndex, sensorIndex, event) {
    this.mapPane = 'left';
    if (event.checked) {
      if (
        this.sensorsNew.findIndex(
          (sensorNew) => sensorNew.id == collection.sensors[sensorIndex].id
        ) == -1
      ) {
        this.sensorsNew.push(collection.sensors[sensorIndex]);
      }
      collection.sensors[sensorIndex].scenes.map((scene: any) => {
        if (scene?.id && scene?.status !== 'failed') {
          scene.checked = true;
          if (!scene?.s_band && !scene?.x_band && scene?.usl_footprint) {
            scene.x_band = scene?.usl_footprint;
          }
          this.displayRFBandNew(
            scene,
            collection.sensors[sensorIndex].id,
            this.selectedBand
          );
        }
      });
    } else {
      this.sensorsNew = this.sensorsNew.filter((sensor: any) => {
        return collection.sensors[sensorIndex].id != sensor.id;
      });
      collection.sensors[sensorIndex].scenes.map((scene: any) => {
        scene.checked = false;
      });
      this.scenesNew.map((scene: any, index: any) => {
        if (scene.sensorId == collection.sensors[sensorIndex].id) {
          this.clearRFBandsByScene(scene, false);
        }
      });
      this.scenesNew = this.scenesNew.filter((scene: any) => {
        return scene.sensorId != collection.sensors[sensorIndex].id;
      });
    }
  }

  toggleRecurrentRFNew(collectionIndex: any, sensorIndex: any, event: any) {
    this.subDailyFinalArray = [];
    if (event.checked == false) {
      const indexToRemove = sensorIndex;
      let sensorSelected = JSON.parse(
        JSON.stringify(this.selectedCheckboxesNew[indexToRemove])
      );
      if (sensorSelected?.pane == 'left') {
        this.mapPane = 'right';
      } else if (sensorSelected?.pane == 'right') {
        this.mapPane = 'left';
      }
      this.selectedCheckboxesNew.splice(indexToRemove, 1);
      this.normalizeRecurrentComparePanes();
      this.sensorsNew = this.selectedCheckboxesNew;
      this.selectionChange.next(this.selectedCheckboxesNew[0]);
      this.subSelectionSelectionChange.next(1);
      this.collection.recurrencyArray.forEach((sensor, index) => {
        const indexTouncheck = this.selectedCheckboxesNew.findIndex(
          (item) => this.isSameRecurrencySelection(item, sensor)
        );
        if (indexTouncheck === -1) {
          sensor.checked = false;
          sensor.scenes.forEach((scene) => {
            scene.checked = false;
          });
        }
      });
      if (this.selectedCheckboxesNew.length === 0) {
        this.defaultSubdailyCount = 1;
        this.toggleDailyRecurrency(event);
      }
      if (this.selectedCheckboxesNew.length > 0) {
        this.scenesNew.map((scene: any, index: any) => {
          if (this.isSceneInRecurrency(scene, sensorSelected)) {
            this.clearRFBandsByScene(scene, false);
          }
        });
        this.scenesNew = this.scenesNew.filter((scene: any) => {
          return !this.isSceneInRecurrency(scene, sensorSelected);
        });
        this.refreshTiffMaxZoomAfterLayerChange();
        if (this.selectedSubDailyItemsNew.length == 0) {
          this.defaultSubdailyCount = 0;
          this.selectOptionNew(this.selectedCheckboxesNew[0], 'compare');
        }
      }
      this.setLeftandRightBands(this.selectedCheckboxesNew);
    }
  }

  toggleRecurrentRFSignalNew(
    collectionIndex: any,
    sensorIndex: any,
    event: any
  ) {
    this.subDailyFinalArray = [];
    if (event.checked == false) {
      const indexToRemove = sensorIndex;
      let sensorSelected = JSON.parse(
        JSON.stringify(this.selectedCheckboxesNew[indexToRemove])
      );
      if (sensorSelected?.pane == 'left') {
        this.mapPane = 'right';
      } else if (sensorSelected?.pane == 'right') {
        this.mapPane = 'left';
      }
      this.selectedCheckboxesNew.splice(indexToRemove, 1);
      this.normalizeRecurrentComparePanes();
      this.sensorsNew = this.selectedCheckboxesNew;
      this.selectionChange.next(this.selectedCheckboxesNew[0]);
      this.subSelectionSelectionChange.next(1);
      this.collection.recurrencyArray.forEach((sensor, index) => {
        const indexTouncheck = this.selectedCheckboxesNew.findIndex(
          (item) => this.isSameRecurrencySelection(item, sensor)
        );
        if (indexTouncheck === -1) {
          sensor.checked = false;
          sensor.scenes.forEach((scene) => {
            scene.checked = false;
          });
        }
      });
      if (this.selectedCheckboxesNew.length === 0) {
        this.defaultSubdailyCount = 1;
        this.toggleDailyRecurrency(event);
      }
      if (this.selectedCheckboxesNew.length > 0) {
        this.scenesNew.map((scene: any, index: any) => {
          if (this.isSceneInRecurrency(scene, sensorSelected)) {
            this.clearRFSignalsByScene(scene);
          }
        });
        this.scenesNew = this.scenesNew.filter((scene: any) => {
          return !this.isSceneInRecurrency(scene, sensorSelected);
        });
        if (this.selectedSubDailyItemsNew.length > 0) {
          this.selectedSubDailyItemsNew = [];
          this.clearRFSignalsNew();
          this.scenesNew = [];
          this.defaultSubdailyCount =
            this.selectedCheckboxesNew[0].scenes[0].sequence;
          this.selectOptionNew(this.selectedCheckboxesNew[0], 'compare');
        } else if (this.selectedSubDailyItemsNew.length == 0) {
          this.defaultSubdailyCount = 0;
          this.selectOptionNew(this.selectedCheckboxesNew[0], 'compare');
        }
      }
    }
  }

  toggleRecurrentDatesRFbandNew(
    collectionIndex: any,
    recurrencyIndex: any,
    event: any,
    type: any,
    task: any
  ) {
    this.subDailyFinalArray = [];
    if (!this.isCompare) {
      this.clearRFBandsNew();
      this.scenesNew = [];
      this.selectedSubDailyItemsNew = [];
      this.selectedSubDailyItems = [];
    }
    if (event?.checked) {
      let selectedSensor: any;
      this.RF = true;
      this.showSubDailyList = false;
      this.setCollectionRecurrencyArray('recurrencyArray', recurrencyIndex);
      this.collection.recurrencyArray[recurrencyIndex].sensorId =
        this.collection.sensors[0].id;
      this.selectedCheckboxesNew.push(
        this.collection.recurrencyArray[recurrencyIndex]
      );
      if(this.selectedCheckboxesNew.length > 1)
        this.isShowSubDailyLegend = false;
      this.limitSensorSelectionToTwo();
      this.normalizeRecurrentComparePanes();
      if (this.selectedSubDailyItemsNew.length == 1) {
        this.defaultSubdailyCount = this.selectedSubDailyItemsNew[0].value;
        this.selectedCheckboxesNew.map((selectedDate, index) => {
          let scenes: any[] = [];
          this.filteredCollection.recurrencyArray.map((recurrency) => {
            if (selectedDate.start == recurrency.start) {
              recurrency.scenes.map((scn) => {
                scn.checked = true;
                scenes.push(scn);
              });
            }
          });
          this.selectedCheckboxesNew[index].scenes = scenes;
        });
        this.selectedCheckboxesNew = this.filterScenesBySubdaily(
          this.selectedCheckboxesNew,
          this.selectedSubDailyItemsNew[0].value
        );
      }
      this.setPreviousSelectiontext();
      this.selectionChange.next(
        this.collection.recurrencyArray[recurrencyIndex]
      );
      this.sensorsNew = this.selectedCheckboxesNew;
      this.selectOptionNew(
        this.collection?.recurrencyArray[recurrencyIndex],
        'compare'
      );
      let sensor = this.collection.recurrencyArray[recurrencyIndex];
      sensor.checked = true;
      if (
        this.selectedSubDailyItemsNew.length == 0 ||
        this.selectedCheckboxesNew.length == 2
      ) {
        sensor.pane =
          this.selectedCheckboxesNew[this.selectedCheckboxesNew.length - 2]
            ?.pane == 'left'
            ? 'right'
            : 'left';
        for (const [sceneIndex, scene] of this.selectedCheckboxesNew[
          this.selectedCheckboxesNew.length - 1
        ]?.scenes.entries()) {
          if (scene?.id && scene?.status !== 'failed') {
            scene.checked = true;
            scene.pane = sensor.pane;
            scene.checked = true;
            scene.start = sensor?.start;
            if (!scene?.s_band && !scene?.x_band && scene?.usl_footprint) {
              scene.x_band = scene?.usl_footprint;
            }
            this.displayRFBandNew(
              scene,
              this.collection.sensors[0].id,
              this.selectedBand
            );
          }
        }
      }
    } else {
      this.selectedCheckboxesNew[this.selectedCheckboxesNew.length - 1]?.pane ==
      'left'
        ? (this.leftBand = false)
        : (this.rightBand = false);
      const indexToRemove =
        type === 'dropdown'
          ? this.selectedCheckboxesNew.findIndex(
              (item) =>
                this.isSameRecurrencySelection(
                  item,
                  this.collection.recurrencyArray[recurrencyIndex]
                )
            )
          : recurrencyIndex;
      let sensorSelected: any;
      if (this.selectedCheckboxesNew[indexToRemove]) {
        sensorSelected = JSON.parse(
          JSON.stringify(this.selectedCheckboxesNew[indexToRemove])
        );
      }
      this.selectedCheckboxesNew.splice(indexToRemove, 1);
      this.normalizeRecurrentComparePanes();
      this.sensorsNew = this.selectedCheckboxesNew;
      this.selectionChange.next(this.selectedCheckboxesNew[0]);
      this.subSelectionSelectionChange.next(1);
      if (
        this.collection.recurrencyArray.filter((item) => item.checked).length >
        0
      ) {
        this.collection.recurrencyArray.forEach((sensor, index) => {
          const indexTouncheck = this.selectedCheckboxesNew.findIndex(
            (item) => this.isSameRecurrencySelection(item, sensor)
          );
          if (indexTouncheck === -1) {
            sensor.checked = false;
            sensor.scenes.forEach((scene) => {
              scene.checked = false;
            });
          }
        });
      }
      if (this.selectedCheckboxesNew.length === 0) {
        this.defaultSubdailyCount = 1;
        this.toggleDailyRecurrency(event);
      }
      if (this.selectedCheckboxesNew.length > 0) {
        this.scenesNew.map((scene: any, index: any) => {
          if (this.isSceneInRecurrency(scene, sensorSelected)) {
            this.clearRFBandsByScene(scene, false);
          }
        });
        this.scenesNew = this.scenesNew.filter((scene: any) => {
          return !this.isSceneInRecurrency(
            scene,
            this.collection.recurrencyArray[recurrencyIndex]
          );
        });
        if (this.selectedSubDailyItemsNew.length > 0) {
          this.selectedSubDailyItemsNew = [];
          this.clearRFBandsNew();
          this.scenesNew = [];
          this.defaultSubdailyCount =
            this.selectedCheckboxesNew[0].scenes[0].sequence;
          this.selectOptionNew(this.selectedCheckboxesNew[0], 'compare');
        } else if (this.selectedSubDailyItemsNew.length == 0) {
          this.defaultSubdailyCount = 0;
          this.selectOptionNew(this.selectedCheckboxesNew[0], 'compare');
        }
      }
    }
    this.setLeftandRightBands(this.selectedCheckboxesNew);
  }

  toggleRecurrentDatesRFSignalNew(
    collectionIndex: any,
    recurrencyIndex: any,
    event: any,
    type: any,
    task: any
  ) {
    this.subDailyFinalArray = [];
    if (!this.isCompare) {
      this.clearRFSignalsNew();
      this.scenesNew = [];
      this.selectedSubDailyItemsNew = [];
      this.selectedSubDailyItems = [];
    }
    if (event?.checked) {
      let selectedSensor: any;
      this.RF = true;
      this.showSubDailyList = false;
      this.setCollectionRecurrencyArray('recurrencyArray', recurrencyIndex);
      this.collection.recurrencyArray[recurrencyIndex].sensorId =
        this.collection.sensors[0].id;
      this.selectedCheckboxesNew.push(
        this.collection.recurrencyArray[recurrencyIndex]
      );
      this.limitSensorSelectionToTwo();
      this.normalizeRecurrentComparePanes();
      if (this.selectedSubDailyItemsNew.length == 1) {
        this.defaultSubdailyCount = this.selectedSubDailyItemsNew[0].value;
        this.selectedCheckboxesNew.map((selectedDate, index) => {
          let scenes: any[] = [];
          this.filteredCollection.recurrencyArray.map((recurrency) => {
            if (selectedDate.start == recurrency.start) {
              recurrency.scenes.map((scn) => {
                scn.checked = true;
                scenes.push(scn);
              });
            }
          });
          this.selectedCheckboxesNew[index].scenes = scenes;
        });
        this.selectedCheckboxesNew = this.filterScenesBySubdaily(
          this.selectedCheckboxesNew,
          this.selectedSubDailyItemsNew[0].value
        );
      }
      this.setPreviousSelectiontext();
      this.selectionChange.next(
        this.collection.recurrencyArray[recurrencyIndex]
      );
      this.sensorsNew = this.selectedCheckboxesNew;
      this.selectOptionNew(
        this.collection?.recurrencyArray[recurrencyIndex],
        'compare'
      );
      let sensor = this.collection.recurrencyArray[recurrencyIndex];
      sensor.checked = true;
      if (
        this.selectedSubDailyItemsNew.length == 0 ||
        this.selectedCheckboxesNew.length == 2
      ) {
        sensor.pane =
          this.selectedCheckboxesNew[this.selectedCheckboxesNew.length - 2]
            ?.pane == 'left'
            ? 'right'
            : 'left';
        for (const [sceneIndex, scene] of this.selectedCheckboxesNew[
          this.selectedCheckboxesNew.length - 1
        ]?.scenes.entries()) {
          if (scene?.id && scene?.status !== 'failed') {
            scene.checked = true;
            scene.pane = sensor.pane;
            scene.checked = true;
            scene.start = sensor?.start;
            this.displayRFSignalsNew(
              scene,
              this.collection.sensors[0].id,
              this.signalSelected
            );
          }
        }
      }
    } else {
      this.selectedCheckboxesNew[this.selectedCheckboxesNew.length - 1]?.pane ==
      'left'
        ? (this.leftBand = false)
        : (this.rightBand = false);
      const indexToRemove =
        type === 'dropdown'
          ? this.selectedCheckboxesNew.findIndex(
              (item) =>
                this.isSameRecurrencySelection(
                  item,
                  this.collection.recurrencyArray[recurrencyIndex]
                )
            )
          : recurrencyIndex;
      let sensorSelected: any;
      if (this.selectedCheckboxesNew[indexToRemove]) {
        sensorSelected = JSON.parse(
          JSON.stringify(this.selectedCheckboxesNew[indexToRemove])
        );
      }
      this.selectedCheckboxesNew.splice(indexToRemove, 1);
      this.normalizeRecurrentComparePanes();
      this.sensorsNew = this.selectedCheckboxesNew;
      this.selectionChange.next(this.selectedCheckboxesNew[0]);
      this.subSelectionSelectionChange.next(1);
      if (
        this.collection.recurrencyArray.filter((item) => item.checked).length >
        0
      ) {
        this.collection.recurrencyArray.forEach((sensor, index) => {
          const indexTouncheck = this.selectedCheckboxesNew.findIndex(
            (item) => this.isSameRecurrencySelection(item, sensor)
          );
          if (indexTouncheck === -1) {
            sensor.checked = false;
            sensor.scenes.forEach((scene) => {
              scene.checked = false;
            });
          }
        });
      }
      if (this.selectedCheckboxesNew.length === 0) {
        this.defaultSubdailyCount = 1;
        this.toggleDailyRecurrency(event);
      }
      if (this.selectedCheckboxesNew.length > 0) {
        this.scenesNew.map((scene: any, index: any) => {
          if (this.isSceneInRecurrency(scene, sensorSelected)) {
            this.clearRFSignalsByScene(scene);
          }
        });
        this.scenesNew = this.scenesNew.filter((scene: any) => {
          return !this.isSceneInRecurrency(
            scene,
            this.collection.recurrencyArray[recurrencyIndex]
          );
        });
        if (this.selectedSubDailyItemsNew.length > 0) {
          this.selectedSubDailyItemsNew = [];
          this.clearRFSignalsNew();
          this.scenesNew = [];
          this.defaultSubdailyCount =
            this.selectedCheckboxesNew[0].scenes[0].sequence;
          this.selectOptionNew(this.selectedCheckboxesNew[0], 'compare');
        } else if (this.selectedSubDailyItemsNew.length == 0) {
          this.defaultSubdailyCount = 0;
          this.selectOptionNew(this.selectedCheckboxesNew[0], 'compare');
        }
      }
    }
    this.setLeftandRightBands(this.selectedCheckboxesNew);
  }

  displayRFBandNew(scene, sensorId, band) {
    this.mapLoad = false;
    this.spinnerService.hide();
    let customXbandIcon: any;
    let customSBandIcon: any;
    this.enableBand = false;
    if (band == 'all') {
      this.enableBand = true;
      this.leftBand = true;
    }
    if (scene?.pane == 'left') {
      customXbandIcon = L.icon({
        iconUrl: '../../../assets/images/cross.png',
        iconSize: [20, 20],
      });
      customSBandIcon = L.icon({
        iconUrl: '../../../assets/images/cross-S.png',
        iconSize: [20, 20],
      });
    } else {
      customXbandIcon = L.icon({
        iconUrl: '../../../assets/images/green-cross.png',
        iconSize: [20, 20],
      });
      customSBandIcon = L.icon({
        iconUrl: '../../../assets/images/green-cross-S.png',
        iconSize: [20, 20],
      });
    }
    let sBand: any;
    let xBand: any;
    let uslMarkers: any[] = [];
    let xbandLayers: any[] = [];
    let sbandLayers: any[] = [];
    let bboxs: any[] = [];
    if (this.mapPane == '') {
      this.mapPane = 'left';
    }
    (this.map as any).getPane(this.mapPane).style.zIndex = 451;
    if (scene?.metadata?.features?.length > 0) {
      let bbox = L.geoJSON(scene.metadata.features[0], { pane: 'left' });
      bbox.addTo(this.map).setStyle({
        fillColor: 'none',
        color: scene?.pane == 'left' ? 'red' : 'green',
      });
      bboxs.push(bbox);
      this.map.fitBounds(bbox.getBounds());
    }
    if (
      scene.x_band?.features?.length > 0 &&
      (band == 'xband' || band == 'all')
    ) {
      scene.x_band.features.forEach((feature: any, i: any) => {
        let lat = feature.geometry.coordinates[1];
        let lng = feature.geometry.coordinates[0];
        let properties = this.mapProperties(feature.properties);
        xBand = L.marker([lat, lng], {
          pane: 'left',
          icon: customXbandIcon,
        });
        this.attachTooltip(xBand, this.formatProperties(properties));
        xBand.addTo(this.map);
        xbandLayers.push(xBand);
      });
    }
    if (
      scene.s_band?.features?.length > 0 &&
      (band == 'sband' || band == 'all')
    ) {
      scene.s_band.features.forEach((feature: any, i: any) => {
        let lat = feature.geometry.coordinates[1];
        let lng = feature.geometry.coordinates[0];
        let properties = this.mapProperties(feature.properties);
        sBand = L.marker([lat, lng], {
          pane: 'left',
          icon: customSBandIcon,
        });
        this.attachTooltip(sBand, this.formatProperties(properties));
        sBand.addTo(this.map);
        sbandLayers.push(sBand);
      });
    } else {
      if (!scene?.s_band && !scene?.x_band) {
        if (scene?.uslFootprint?.features.length > 0) {
          scene.uslFootprint.features.forEach((feature: any, i: any) => {
            let lat = feature.geometry.coordinates[1];
            let lng = feature.geometry.coordinates[0];
            let properties = this.mapProperties(feature.properties);
            let uslmarker = L.marker([lat, lng], {
              pane: 'left',
              icon: L.icon({
                iconUrl: '../../../assets/images/cross.png',
                iconSize: [20, 20],
              }),
            });
            this.attachTooltip(uslmarker, this.formatProperties(properties));
            uslmarker.addTo(this.map);
            uslMarkers.push(uslmarker);
          });
          this.map.fitBounds(L.geoJSON(scene?.uslFootprint).getBounds());
        }
      }
    }

    this.scenesNew.push({
      id: scene.id,
      sensorId: sensorId,
      scene: scene,
      bboxs: bboxs,
      sbands: sbandLayers,
      xbands: xbandLayers,
      uslMarkers: uslMarkers,
      pane: this.mapPane,
    });
  }

  displaySubdailyRFBandNew(scene, subDailyCount, band) {
    let customIcon = L.icon({
      iconUrl: 'assets/images/cross-icon.svg',
      iconSize: [18, 90],
    });
    let sBand: any;
    let xBand: any;
    let xbandLayers: any[] = [];
    let sbandLayers: any[] = [];
    let bboxs: any[] = [];
    let bbox = L.geoJSON(scene.metadata.features[0], { pane: 'left' });
    bbox.addTo(this.map).setStyle({ fillColor: 'none', color: 'green' });
    bboxs.push(bbox);
    if (band == 'xband' || band == 'all') {
      scene.x_band.features.forEach((feature: any, i: any) => {
        let lat = feature.geometry.coordinates[1];
        let lng = feature.geometry.coordinates[0];
        let properties = feature.properties;
        xBand = L.marker([lat, lng], {
          pane: 'left',
          icon: customIcon,
        });
        this.attachTooltip(
          xBand,
          `<span style="text-transform: capitalize;">
            ${this.formatProperties(properties)}
            </span>`
        );
        xBand.addTo(this.map);
        xbandLayers.push(xBand);
      });
    }
    if (band == 'sband' || band == 'all') {
      scene.s_band.features.forEach((feature: any, i: any) => {
        let lat = feature.geometry.coordinates[1];
        let lng = feature.geometry.coordinates[0];
        let properties = feature.properties;
        sBand = (L as any).circleMarker([lat, lng], { pane: 'left' });
        this.attachTooltip(
          sBand,
          `<span style="text-transform: capitalize;">
            ${this.formatProperties(properties)}
        </span>`
        );
        sBand.addTo(this.map);
        sBand.setStyle({ color: 'red', fillColor: 'none' });
        sbandLayers.push(sBand);
      });
    }
    this.map.fitBounds(bbox.getBounds());
    this.scenesNew.push({
      id: scene.id,
      subDailyCount: subDailyCount,
      scene: scene,
      bboxs: bboxs,
      sbands: sbandLayers,
      xbands: xbandLayers,
    });
  }

  createColoredIcon(color) {
    return L.divIcon({
      className: 'custom-marker',
      html: `<div style="background-color: ${color}; width: 8px; height: 8px; border-radius: 50%;"></div>`,
      iconSize: [10, 10],
      iconAnchor: [5, 5],
    });
  }

  calculateCombineBound() {
    if (this.scenesNew.length > 0) {
      let maxNorth = -Infinity;
      let maxEast = -Infinity;
      let minSouth = Infinity;
      let minWest = Infinity;
      this.scenesNew.forEach((scene) => {
        const bounds = scene.leftImageLayer.getBounds();
        const northEast = bounds.getNorthEast();
        const southWest = bounds.getSouthWest();
        if (northEast.lat > maxNorth) maxNorth = northEast.lat;
        if (northEast.lng > maxEast) maxEast = northEast.lng;
        if (southWest.lat < minSouth) minSouth = southWest.lat;
        if (southWest.lng < minWest) minWest = southWest.lng;
      });
      const customBounds: any = L.latLngBounds(
        L.latLng(minSouth, maxEast),
        L.latLng(maxNorth, maxEast)
      );
      return customBounds;
    }
  }

  selectedSignals: any[] = [];
  displayRFSignalsNew(scene, sensorId, selectedsignal) {
    if (scene?.start) {
      scene.openWindow = scene.start;
    }
    let sensor = this.selectedCheckboxesNew.find(
      (selectedCheckbox) =>
        new Date(selectedCheckbox.start).getTime() ==
        new Date(scene.openWindow).getTime()
    );
    let signalLayers: any[] = [];
    this.mapLoad = false;
    this.spinnerService.hide();
    this.enableBand = false;
    if (this.mapPane == '') {
      this.mapPane = 'left';
    }
    (this.map as any).getPane(this.mapPane).style.zIndex = 451;
    for (const signal of scene.signalOfInterest) {
      const signalWithSceneId = {
        ...signal,
        sceneId: scene.id,
        sensorId: sensorId,
      };
      if (selectedsignal === 'All') {
        signalLayers.push(signalWithSceneId);
      } else if (signal.product === selectedsignal) {
        signalLayers.push(signalWithSceneId);
      }
      let vhfsignals = signalLayers.filter(
        (signalLayer) => signalLayer.product == 'VHF'
      );
      if (vhfsignals.length > 0) {
        this.audioAvailable = true;
      }
      if (signalWithSceneId?.product === 'VHF') {
        this.selectedSignals.push(signalWithSceneId);
      }
    }

    const multiPolygonSignals = signalLayers.map((signal) => {
      return signal.features
        .filter(
          (feature) =>
            feature.geometry?.type === 'MultiPolygon' ||
            feature.geometry?.type === 'Polygon'
        )
        .map((feature) => {
          if (feature.properties) feature.properties.product = signal.product;
          return feature;
        });
    });
    let rfSignalLayers: any[] = [];
    let centerMarkers: any[] = [];
    let tooltip;
    multiPolygonSignals.forEach((multiPolygonSignal) => {
      const signalGeoJson = L.geoJSON(multiPolygonSignal, {
        onEachFeature: (feature, layer: any) => {
          const rawTimeStamp = Number(feature?.properties?.utc);
          let date = '';
          if (Number.isFinite(rawTimeStamp)) {
            const normalizedTimeStamp =
              rawTimeStamp < 1e12 ? rawTimeStamp * 1000 : rawTimeStamp;
            date = new Date(normalizedTimeStamp).toISOString();
          }
          if (feature.properties) {
            if (
              feature.properties.title == 'Estimated Emitter and Error Ellipse'
            ) {
              if (feature.properties.band == 'VHF') {
                layer.setStyle({ color: 'yellow' });
              }
              if (feature.properties.band == 'UHF') {
                layer.setStyle({ color: 'darkgrey' });
              }
              if (feature.properties.band == 'GPS L1') {
                layer.setStyle({ color: 'green' });
              }
              if (feature.properties.band == 'GPS L2') {
                layer.setStyle({ color: 'hotpink' });
              }
              if (feature.properties.band == 'GPS L5') {
                layer.setStyle({ color: 'yellowgrey' });
              }
              if (feature.properties.band == 'L-band(ADS-B)') {
                layer.setStyle({ color: 'magenta' });
              }
              if (feature.properties.band == 'L-band(GNSS)') {
                layer.setStyle({ color: 'blue' });
              }
              if (feature.properties.band == 'L-band(SATCOM)') {
                layer.setStyle({ color: 'darkgreen' });
              }
              const centerMarker = L.marker(layer.getBounds().getCenter(), {
                icon: this.createColoredIcon(
                  sensor?.pane == 'left' ? 'red' : 'green'
                ),
              }).addTo(this.map);
              const tooltipContent = `
                   <strong>Signal: </strong> ${feature.properties.product}<br>
                    <strong>Lng: </strong> ${feature.properties.lon}<br>
                    <strong>Lat: </strong> ${feature?.properties.lat}<br>
                    <strong>Timestamp UTC: </strong> ${date}<br>
                    <strong>Error radius: </strong> ${feature?.properties?.error_radius}
                `;

              this.attachTooltip(centerMarker, tooltipContent);
              centerMarkers.push(centerMarker);
              const CurrenttooltipContent = `
                    <strong>Signal: </strong> ${feature.properties.product}<br>
                    <strong>Lng: </strong> ${feature.properties.lon.toFixed(
                      2
                    )}<br>
                    <strong>Lat: </strong> ${feature.properties.lat.toFixed(
                      2
                    )}<br>
                    <strong>Title: </strong> ${feature.properties.title}
                `;
              this.attachTooltip(layer, CurrenttooltipContent);
            } else {
              layer.setStyle({ color: 'blue' });
            }
          } else {
            layer.setStyle({ color: 'blue' });
          }
        },
      }).addTo(this.map);
      rfSignalLayers.push(signalGeoJson);
    });
    this.scenesNew.push({
      id: scene.id,
      scene: scene,
      signalLayers: rfSignalLayers,
      pane: this.mapPane,
      sensorId: sensorId,
      centerMarkers: centerMarkers,
    });
    if (rfSignalLayers.length > 0) {
      this.map.fitBounds(rfSignalLayers[0].getBounds());
    }
  }

  openAudioSignals() {
    const hasAudioFiles = this.selectedSignals.some(
      (item) => item.audioFiles && item.audioFiles.length > 0
    );
    if (hasAudioFiles) {
      let selectedSignals = this.selectedSignals.filter((signal) =>
        this.collection.sensors.some(
          (col) => col.id == signal.sensorId && col.operatorKey === 'Spire-RF'
        )
      );
      let sensorIds = selectedSignals.map((signal) => signal.sensorId);
      const sensorId = sensorIds;
      const action = 'audioDownload';
      const taskId = this.collection.taskId;
      const sensorObj = {
        sensorId: sensorId,
        sceneId: undefined,
        action: action,
        fileType: 'audio',
        taskId: taskId,
      };
      const dialogRef = this.matdialog.open(FilterPopupComponent, {
        width: '30%',
        backdropClass: 'blurr',
        disableClose: true,
        data: {
          type: 'audio',
          signals: selectedSignals,
          sensorData: sensorObj,
        },
      });
    } else {
      const message =
        'There is no audio recording within the AOI for this task.';
      this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
    }
  }

  clearRFBandsByScene(scene: any, isUslMarker: any) {
    if (scene?.xbands) {
      scene?.xbands.map((xband: any) => {
        this.map.removeLayer(xband);
      });
    }
    if (scene?.sbands) {
      scene?.sbands.map((sband: any) => {
        this.map.removeLayer(sband);
      });
    }
    if (scene?.bboxs) {
      scene?.bboxs.map((bbox: any) => {
        this.map.removeLayer(bbox);
      });
    }
    if (isUslMarker) {
      if (scene?.uslMarkers) {
        scene?.uslMarkers.map((marker: any) => {
          this.map.removeLayer(marker);
        });
      }
    }
  }

  clearRFBandsNew() {
    this.scenesNew.map((scene: any, index: any) => {
      this.clearRFBandsByScene(scene, true);
    });
  }

  clearRFSignalsByScene(scene: any) {
    if (scene?.signalLayers) {
      scene?.signalLayers.map((signalLayer: any) => {
        this.map.removeLayer(signalLayer);
      });
    }
    if (scene?.centerMarkers) {
      scene?.centerMarkers.map((centerMarker: any) => {
        this.map.removeLayer(centerMarker);
      });
    }
  }

  clearRFSignalsNew() {
    this.selectedSignals = [];
    this.scenesNew.map((scene: any, index: any) => {
      this.clearRFSignalsByScene(scene);
    });
  }

  getTooltipMessage(sensor) {
    this.tooltipDisabled = false;
    if (sensor.operatorKey === OPERATORS.CAPELLA) {
      this.downloadTooltip =
        'Click here for additional GEO, SLC and SICD files available for download';
    } else if (
      sensor.operatorKey === OPERATORS.UMBRA &&
      sensor?.isAdditionalProducts
    ) {
      this.downloadTooltip =
        'Click here for additional CPHD, SIDD, and SICD files available for download';
    } else if (
      sensor.operatorKey === OPERATORS.UMBRA &&
      sensor?.isAdditionalCSIProducts
    ) {
      this.downloadTooltip =
        'Click here for additional CSI-TIFF and CSI-SIDD files available for download';
    } else if (sensor.operatorKey === OPERATORS.SATELLOGIC) {
      this.downloadTooltip =
        'Click to request for the Orthorectified (L1D) product';
    }
  }

  onMouseOut() {
    this.tooltipDisabled = true;
    this.downloadTooltip = '';
  }

  async downloadScn(url: any) {
    const fileName = this.getFileNameFromS3SignedUrl(url);
    const downloadTarget = await this.resolveDownloadTarget(fileName);
    if (!downloadTarget) {
      return;
    }

    const response = await fetch(url);
    if (!response.ok) {
      this.showDownloadError();
      return;
    }

    const blob = await response.blob();
    const saveResult = await this.downloadService.saveBlob(
      blob,
      fileName,
      downloadTarget
    );
    if (saveResult.status === 'cancelled') {
      this.resetDownload();
      return;
    }

    if (saveResult.status !== 'saved') {
      this.popupService.openPopup(
        CollectionPopupComponent,
        saveResult.message,
        '',
        '40%'
      );
      this.resetDownload();
    }
  }

  zipDownload(urls: any, taskId: any, sensorId: any, sceneId: any) {
    var zip = new JSZip();
    var count = 0;
    var zipFilename = 'zipFilename.zip';
    urls.forEach((url: any) => {
      const filename = url.split('/')[url.split('/').length - 1].split('?')[0];
      JSZipUtils.getBinaryContent(url, (err: any, data: any) => {
        if (err) {
          this.progress = 0;
          this.mapLoad = false;
          this.spinnerService.hide();
          this.freeze = false;
          this.downloadClick = false;
          const message =
            'An error occurred during processing and ingestion of the request. Please try after sometime.';
          throw err;
        }
        zip.file(filename, data, { binary: true });
        count++;
        const totalCount = urls.length;
        const percentComplete = Math.round((count / totalCount) * 100);
        this.progress = percentComplete;
        const sensorObj = {
          progress: this.progress,
          taskId: taskId,
          sensorId: sensorId,
          sceneId: sceneId,
          download: this.downloadClick,
        };
        this.downloadService.setProgress(sensorObj);
        if (count == urls.length) {
          this.progress = 0;
          this.mapLoad = false;
          this.spinnerService.hide();
          this.freeze = false;
          this.disable = false;
          zip.generateAsync({ type: 'blob' }).then(function (content) {
            const objectUrl: string = URL.createObjectURL(content);
            const link: any = document.createElement('a');
            link.download = `${taskId}.zip`;
            link.href = objectUrl;
            link.click();
          });
        }
      });
    });
  }

  /**
   *
   * @param i
   * @param j
   * @param k
   */
  fullDownload(i: any, j: any, k: any) {
    var urls: any = [];
    this.collections[i]?.taskCollection?.map((item: any, index: any) => {
      if (this.collections[i]?.sensorName.includes('Capella')) {
        [
          { path: 'HH', ext: '.tiff' },
          { path: 'metadata', ext: '.json' },
          { path: 'thumbnail', ext: '.png' },
          { path: 'preview', ext: '.tiff' },
        ]?.map((downlaodItem) => {
          urls.push(
            environment.eeDownloadUrl +
              `collections/orders/${this.collections[i].taskId}/${downlaodItem?.path}/${item}${downlaodItem?.ext}`
          );
        });
      } else {
        if (this.collections[i]?.sensorName.includes('Satellogic')) {
          urls.push(
            environment.eeDownloadUrl +
              `collections/orders/${this.collections[i].taskId}/delivery_zip/${item}.zip`
          );
        }
      }
    });
    if (this.collections[i]?.sensorName.includes('21AT')) {
      urls.push(
        environment.eeDownloadUrl +
          `collections/${this.collections[i].sensors[j].downloadUrl}`
      );
    }
  }

  checkDownloaded(scene: any): boolean {
    const isDownloaded =
      this.downloadedScene.includes(scene.id) || scene.downloaded;
    return isDownloaded;
  }

  checkSensorDownloaded(sensor: any): boolean {
    const isDownloaded =
      this.downloadedSensor.includes(sensor.id) || sensor.downloaded;
    return isDownloaded;
  }

  getAdditionalData(taskId: any, sensor: any) {
    let message: any;
    let sensorObj = {
      sensorId: sensor.id,
      taskId: taskId,
    };
    this.apiService.addCollectionData(sensorObj).subscribe((res: any) => {
      if (res) {
        if (res.msg === 'success' && res?.refundRequested) {
          message =
            'As you requested a refund of the L1B product, L1D is unavailable.';
          this.popupService.openPopup(
            CollectionPopupComponent,
            message,
            '',
            '40%'
          );
        } else if (res.msg === 'success') {
          const type = 'download';
          message =
            'Thank you for submitting additional files for download. You will be notified via email when the files are ready.';
          this.popupService.openPopup(
            WarningPopupComponent,
            message,
            type,
            '40%'
          );
        } else if (res.msg === 'already requested') {
          message =
            'The download request for additional files has either already been made and is being processed.';
          this.popupService.openPopup(
            CollectionPopupComponent,
            message,
            '',
            '40%'
          );
        } else if (res?.msg === 'user storage') {
          const message =
            'We cannot download the image as the delivery was made to your storage. You can access the image via your storage.';
          this.popupService.openPopup(
            CollectionPopupComponent,
            message,
            '',
            '40%'
          );
        } else {
          message =
            'An error occurred during processing and ingestion of the request. Please try after sometime.';
          this.popupService.openPopup(
            CollectionPopupComponent,
            message,
            '',
            '40%'
          );
        }
      } else {
        message =
          'An error occurred during processing and ingestion of the request. Please try after sometime.';
        this.popupService.openPopup(
          CollectionPopupComponent,
          message,
          '',
          '40%'
        );
      }
    });
  }

  async download(i: any, j: any, k: any, scene: any, mode: any = false) {
    let sceneId: any = [],
      scenesId: any = [];
    let sensorId: any, infoId: any, sensorObj: any;
    let action: any;
    let urls: any = [];
    let sensorDownloadId: any;
    let isColorisation = false;
    let isColorisationItem:any = '';
    const selectedSensor = this.collections[i].sensors[j];
    // Colorisation items come from sensor.sarColorisation and have no actionProvider
    isColorisationItem = (selectedSensor?.sarColorisation || []).find((item: any) => item?.id === scene?.id);
    let sceneType = mode == 'rawdataDownload' ? 'raw_iq' : '';
    const taskId = this.collections[i]?.taskId;
    this.ecursSensorObject = null;
    let downloadTarget: DownloadTarget | null = null;
    const isChangeDetectionHistoryDownload =
      !!scene?._changeDetectionHistoryDownload;

    let refCount;
    const selcetedSensor = this.collection.sensors[j];
    if (
      selcetedSensor?.operatorKey === this.OPERATOR.CLYDE &&
      selcetedSensor.status === 'canceled'
    ) {
      const message =
        'The user has cancelled the task, and the data is unavailable';
      this.popupService.openPopup(WarningPopupComponent, message, '', '40%');
      return;
    }

    if (this.collection.sensors[j].operatorKey === OPERATORS.SPIRE) {
      refCount =
        this.collection.sensors[j].updatedRefreshes == 0
          ? 0
          : this.collection.sensors[j].updatedRefreshes ||
            this.collection.sensors[j].noOfRefreshes;
    }
    if (
      (refCount > 0 && scene.operatorKey === OPERATORS.SPIRE) ||
      scene.operatorKey !== OPERATORS.SPIRE
    ) {
      const endDate = new Date(this.collections[i].closeWindow);
      const currentDate = new Date();

      if (this.freeze) {
        const message =
          'A download is in progress. Please wait until the current download finishes to continue downloading others.';
        this.popupService.openPopup(
          CollectionPopupComponent,
          message,
          '',
          '40%'
        );
        return;
      } else if (
        ((scene?.downloaded ||
          this.checkDownloaded(scene) ||
          this.checkSensorDownloaded(scene)) &&
          !mode &&
          !isChangeDetectionHistoryDownload) ||
        scene?.rawIQDownloaded
      ) {
        let message = 'download';
        if (mode && scene?.rawIQDownloaded) {
          message = 'rawIQmessage';
        }
        this.popupService.openPopup(
          CollectionPopupComponent,
          message,
          '',
          '40%'
        );
        return;
      } else if (
        scene.operatorKey === OPERATORS.CLYDE &&
        endDate.getTime() < currentDate.getTime()
      ) {
        const message =
          'The time of interest (TOI) has been passed. Download is possible only during the TOI.';
        this.popupService.openPopup(
          CollectionPopupComponent,
          message,
          '',
          '40%'
        );
        return;
      }else if(isColorisationItem?.isDownloaded){
        const message = 'download_vadp';
        this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
        return;
      }

      this.spinnerService.show();
      this.freeze = true;
      this.fail = 0;
      this.progress = 0;
      this.downloadClick = true;
      const sensor = this.collections[i].sensors[j];

      if (
        (scene?.insightDatas || isChangeDetectionHistoryDownload) &&
        !mode
      ) {
        this.mapLoad = false;
        sensorId = scene?.sensorId ?? sensor?.id;
        action = this.combinedScenes ? 'sensorFeed' : 'ISDownload';
        infoId = scene?._id ?? scene?.feedId ?? scene?.isInfo?._id;
        sceneId = scene?._downloadSceneId ?? this.selectedSceneNew?.id;
        if (
          !isChangeDetectionHistoryDownload &&
          this.collections[i]?.sensors[j]?.operatorKey === OPERATORS.AXELSPACE
        )
          sceneId = scene?.sensorId;
        sensorObj = {
          sensorId: sensorId,
          sceneId: sceneId,
          action: action,
          feedId: infoId,
        };
      } else if (scene?.refreshId && !mode) {
        sensorId = scene?.sensorId;
        action = 'download';
        sceneId = sensor.scenes[0].id;
        sensorObj = {
          sensorId: sensorId,
          sceneId: sceneId,
          action: action,
          refreshId: scene?.refreshId,
        };
      } else if (k === undefined && !mode) {
        if (scene?.thermal_observation === true) {
          sceneId = sensor.scenes[0].id;
          action = 'observation' ;
        }
        else{
          sensor.scenes.forEach(async (scn: any, index: any) => {
            sceneId.push(scn.id);
            scenesId.push(scn.id);
          });
          action = 'sensorDownload';
        }
        
        sensorId = sensor?.id;
        sensorDownloadId = sensor?.id;
        sensorObj = { sensorId: sensorId, sceneId: sceneId, action: action };
      } else if (mode) {
        sensorId = this.collections[i].sensors[j].id;
        sensorDownloadId = this.collections[i].sensors[j].id;
        scenesId = scene?.id;
        action = mode;
        sensorObj = {
          sensorId: this.collections[i].sensors[j].id,
          sceneId: scene?.id,
          action: mode,
          type: 'zip',
        };
      } else {
        sceneId = scene?.id;
        scenesId.push(scene?.id);
        // Colorisation items come from sensor.sarColorisation and have no actionProvider
        isColorisation = (sensor?.sarColorisation || []).some((item: any) => item?.id === scene?.id);
        action = isColorisation ? 'colorisationDownload' : 'sceneDownload';
        sensorId = sensor?.id;
        sensorObj = {
          sensorId: sensorId,
          sceneId: sceneId,
          action: action,
          type: this.imageType,
        };
      }

      const downloadObj = {
        progress: this.progress,
        taskId: this.collections[i].taskId,
        sensorId: sensorDownloadId,
        sceneId: scenesId,
        download: this.downloadClick,
        type: sceneType,
        action: action,
      };
      // Browsers with the file picker (Chrome/Edge) should show progress only
      // after a save location is selected and transfer starts.
      // Keep the initial emit only for non-picker browsers.
      const shouldEmitInitialProgress =
        !this.downloadService.isFolderPickerSupported() &&
        (!(sensor?.sensorType == 'InSAR') || k == undefined);
      if (shouldEmitInitialProgress) {
        this.downloadService.setProgress(downloadObj);
      }
    }
    const proceedDownload = async () => {
      this.apiService
        .getCollectionImage(taskId, sensorObj)
        .subscribe(async (res: any) => {
          if (res?.msg === 'Failed' || res?.msg === 'user storage') {
            this.DisplayPopupsBasedOnResponse(res);
            this.downloadService.unsubscribeProgress();
          } else {
            const result = res.result;

            const files = Array.isArray(result) ? result : [result.imageUrl];

            for (const [index, item] of files.entries()) {
              let url = item;
              const fileName = this.getFileNameFromS3SignedUrl(url);
              const perFileDownloadTarget = await this.resolveDownloadTarget(
                fileName
              );
              if (!perFileDownloadTarget) {
                this.resetDownload();
                return;
              }

              const xhr = new XMLHttpRequest();
              xhr.open('GET', url);
              xhr.responseType = 'blob';

              xhr.onprogress = (event) => {
                if (event.lengthComputable) {
                  const percentComplete = (event.loaded / event.total) * 100;
                  this.progress = percentComplete.toFixed(2);
                  const sensorObj = {
                    progress: this.progress,
                    taskId: this.collections[i].taskId,
                    sensorId: sensorDownloadId,
                    sceneId: scenesId,
                    download: this.downloadClick,
                    type: sceneType,
                    action: action,
                    // Sent as product in updateCollectionDownload once the download completes
                    product: isColorisation ? 'sarColorisation' : undefined,
                  };
                  if(isColorisation) sensorObj.product = 'sarColorisation';
                  this.downloadService.setProgress(sensorObj);
                }
              };

              xhr.onload = () => {
                if (xhr.status === 200) {
                  const blob = xhr.response;
                  this.downloadService
                    .saveBlob(blob, fileName, perFileDownloadTarget)
                    .then(async (saveResult) => {
                      if (
                        isChangeDetectionHistoryDownload &&
                        saveResult.status === 'permissionDenied'
                      ) {
                        saveResult = await this.downloadService.saveBlob(
                          blob,
                          fileName,
                          { mode: 'browser' }
                        );
                      }

                      if (saveResult.status === 'cancelled') {
                        this.resetDownload();
                        return;
                      }

                      if (saveResult.status !== 'saved') {
                        this.popupService.openPopup(
                          CollectionPopupComponent,
                          saveResult.message,
                          '',
                          '40%'
                        );
                        this.resetDownload();
                        return;
                      }

                      this.progress = 0;
                      this.spinnerService.hide();
                      this.freeze = false;
                      this.disable = false;
                      if (mode == 'rawdataDownload') scene.rawIQDownloaded = true;
                    });
                } else {
                  this.showDownloadError();
                }
              };

              xhr.onerror = () => {
                this.showDownloadError();
                // Handle errors
              };
              xhr.send();
            }
          }
        });
    };
    if (scene?.refreshId && !mode) {
      const sensor = this.collections[i].sensors[j];

      await this.displayChangeData(
        '$event',
        sensor.scenes[0],
        sensor,
        action,
        scene,
        downloadTarget
      );
    } else if (
      ((scene.operatorKey === OPERATORS.SPIRE && scene.aisDownloadable) ||
        (scene.operatorKey === OPERATORS.CLYDE && scene.aisAvailable)) &&
      !mode
    ) {
      const sensors = this.collections[i].sensors[j];
      this.AISDownload(sensors);
    } else {
      if (
        (scene?.operatorKey == OPERATORS.ECURS ||
          scene?.operatorKey == OPERATORS.ECURS_L) &&
        this.collections[i].sensors[j].sensorType === 'InSAR' &&
        k != undefined &&
        !mode
      ) {
        let sceneIds = [scene.id];
        let index = this.collections[i].sensors[j]?.scenes.findIndex(
          (scn) => scn.id == scene.id
        );
        if (index > 0) {
          const scenes = this.collections?.[i]?.sensors?.[j]?.scenes ?? [];
          const downloadedSet = new Set(this.downloadedScene ?? []);
          const prior = scenes.slice(0, Math.max(0, index));

          const missingPrevScenes: any[] = prior.filter(
            (s) => s && !(s.downloaded || downloadedSet.has(s.id))
          );
          if (missingPrevScenes.length > 0) {
            const message = 'downloadWarning';
            this.downloadClick = false;
            this.freeze = false;
            const dialog = this.popupService.openPopup(
              CollectionPopupComponent,
              message,
              '',
              '40%'
            );
            dialog.afterClosed().subscribe((res) => {
              if (res == 'cancel') {
                this.freeze = false;
                this.fail = 0;
                this.progress = 0;
                this.downloadClick = false;
                return;
              } else if (res == 'yes') {
                const dialog = this.popupService.openPopup(
                  CollectionPopupComponent,
                  'downloadProgress',
                  '',
                  '40%'
                );
                dialog.afterClosed().subscribe((res) => {
                  this.downloadClick = true;
                  this.freeze = false;
                  missingPrevScenes.forEach((scn) => {
                    sceneIds.push(scn.id);
                  });
                  sensorObj = {
                    sensorId: sensorId,
                    sceneIds: sceneIds,
                    action: action,
                    type: this.imageType,
                  };
                  this.ecursSensorObject = sensorObj;
                  proceedDownload();
                });
              } else if (res == 'no') {
                this.downloadClick = true;
                this.freeze = false;
                sensorObj = {
                  sensorId: sensorId,
                  sceneIds: sceneIds,
                  action: action,
                  type: this.imageType,
                };
                this.ecursSensorObject = sensorObj;
                proceedDownload();
              }
            });
          } else {
            this.ecursSensorObject = sensorObj;
            proceedDownload();
          }
        } else {
          sensorObj = {
            sensorId: sensorId,
            sceneIds: sceneIds,
            action: action,
            type: this.imageType,
          };
          proceedDownload();
        }
      } else {
        proceedDownload();
      }
    }
    return;
  }

  private async resolveDownloadTarget(
    suggestedFileName: string
  ): Promise<DownloadTarget | null> {
    if (!this.downloadService.isFolderPickerSupported()) {
      return { mode: 'browser' };
    }

    const selection = await this.downloadService.pickSaveFileForDownload(
      suggestedFileName
    );
    if (selection.status === 'selected') {
      return { mode: 'saveFile', fileHandle: selection.handle };
    }

    if (
      selection.status === 'unsupported' ||
      selection.status === 'permissionDenied'
    ) {
      return { mode: 'browser' };
    }

    if (selection.status !== 'cancelled') {
      this.popupService.openPopup(
        CollectionPopupComponent,
        selection.message,
        '',
        '40%'
      );
    }

    return null;
  }

  getFileNameFromS3SignedUrl(signedUrl) {
    try {
      const parsedUrl = new URL(signedUrl);
      const rawContentDisposition =
        parsedUrl.searchParams.get('response-content-disposition') ||
        parsedUrl.searchParams.get('content-disposition');

      if (rawContentDisposition) {
        const decodedContentDisposition = decodeURIComponent(
          rawContentDisposition
        );
        const utfFileNameMatch = decodedContentDisposition.match(
          /filename\*=UTF-8''([^;]+)/i
        );
        if (utfFileNameMatch?.[1]) {
          return utfFileNameMatch[1].replace(/"/g, '').trim();
        }

        const fileNameMatch = decodedContentDisposition.match(
          /filename="?([^";]+)"?/i
        );
        if (fileNameMatch?.[1]) {
          return fileNameMatch[1].trim();
        }
      }

      const decodedPathName = decodeURIComponent(parsedUrl.pathname || '');
      const pathFileName = decodedPathName.split('/').pop();
      if (pathFileName) {
        return pathFileName;
      }
    } catch {
      // Fall through to legacy parsing.
    }

    const filename = signedUrl
      .split('/')
      [signedUrl.split('/').length - 1].split('?')[0];
    try {
      return `${decodeURIComponent(filename)}`;
    } catch {
      return `${filename}`;
    }
  }

  handleclickMenuItemWithAbort(menuItem: ProjectInfo, index: number) {
    this.observationEnabled =false;
    if (this.opManager?.isOperationRunning) {
      return this.showAbortRetainPopup().then((shouldAbort) => {
        if (shouldAbort) {
          this.opManager.abortOperation();
          this.resetAllFeedPanels();
          this.clearAllPredictionData();
          this.clearFilteredLayerAndRestore(true);
          this.resetMapNew();
          this.progressing = false;
          this.spinnerService.hide();
          return this.clickMenuItem(menuItem, index);
        }
      });
    }
    return this.clickMenuItem(menuItem, index);
  }

  clickMenuItem(menuItem, index) {
    this.sceneOverlayOpacity = 100;
    const isSameProject =
      this.previousSelectedProject !== null &&
      JSON.stringify(this.previousSelectedProject) === JSON.stringify(menuItem);

    if (isSameProject) {
      return;
    }

    this.clearActiveChangeDetectionCurrentWeekTab();
    this.clearChangeDetectionHistoryForNavigation();
    this.cancelTiffWfsLoads();
    this.resetWeatherExForecastSelection();

    this.checkedObservation = false;
    this.observationEnabled = false;
    this.removeObservationMarker();

    this.resetAllFeedPanels();
    this.clearAllPredictionData();
    this.fail = 0;
    this.imageType = this.checkType();
    this.mapPane = '';
    this.audioAvailable = false;
    this.selectedSignals = [];
    this.jump = false;
    this.mapLoad = false;
    this.sliderView = false;
    this.sliderDateRangeArray = [];
    this.recurrentSlider = false;
    this.isCompare = false;
    this.isCompareClicked = false;
    this.taskSelected = false;
    this.selectedSubDailyItems = [];
    this.selectedSubDailyItemsNew = [];
    this.subDailyFinalArray = [];
    this.selectedCheckboxes = [];
    this.subDailyArray = [];
    this.showDailyRecurrencyCheckboxes = false;
    this.spinnerService.hide();
    this.loadTiff = false;
    this.operatorArray = [];
    this.defaultSubdailyCount = 1;
    this.showDailyRecurrencyCheckboxes = false;
    this.subDailyCount = '';
    this.selectedSubdaily = '';
    this.selectedBand = 'all';
    this.scnLyr = [];
    this.scnLyr2 = [];
    this.taskCollection = '';
    this.selectedSites = [];
    this.collections = [];
    this.collection = null;
    this.subDailyCountarray = [];
    this.isSitechanged = false;
    this.resetMapNew();
    this.emissionMessage = '';
    this.scenes = [];
    this.sensors = [];
    this.sliderShow = false;
    this.removeVectorOverlay();
    this.imageType = 'png';
    this.feedUi = { showFilterIcon: false };
    this.filterInfoVisible = false;
    this.combinedScenes = false;
    this.previousSelectedProject = menuItem;
    this.getCollections(menuItem?.projectid, 0);
    this.projectName = menuItem?.project;
    this.collectionIndex = 0;

    this.removeISLayers();
    if (this.displayedIS) {
      this.displayedIS = null;
    }
    if (this.getCollectionSub) {
      this.getCollectionSub.unsubscribe();
      this.spinnerService.hide();
    }
    this.unSubscribeAPI();
  }

  unSubscribeAPI() {
    // If already fetching prediction → cancel it
    if (this.predictionSubscription) {
      this.predictionSubscription.unsubscribe();
      this.predictionSubscription = null;
      this.progressing = false;
    }
  }

  getCollections(item, idx) {
    if (!item) return;
    this.taskCollection = '';
    this.sliderView = false;
    this.timeseries = false;
    this.jump = false;
    this.currentSliderValue = 0;
    this.signalSelected = 'All';
    this.feedInfo = false;
    this.removeDynamicLayer();

    this.clydeHistoricalLayer.map((layer) => {
      this.map.removeLayer(layer.marker);
    });
    this.spireHistoricalLayer.map((layer) => {
      this.map.removeLayer(layer.marker);
    });
    this.clydeHistoricalLayer = [];
    this.spireHistoricalLayer = [];
    if (this.displayedIS) {
      this.displayedIS = null;
    }
    this.apiService.getCollections(item).subscribe((res: any) => {
      this.dataSource = res.result;
      if (res.result?.length > 0) {
        this.collectionsData = res.result;
        this.collections = [];
        this.fullCollection = [];
        let count: any;
        res.result.forEach((rawItem, index) => {
          const item = this.normalizeIceyeSubdailyRecurrency({ ...rawItem });
          const project = item.project;
          const taskname = item.taskname;
          const createdDate = item?.createdAt;
          const taskId = item.id;
          const questionId = item.questionId;
          const collectionFrequency = this.isChangeDetectionTask(item?.taskStrategy)
            ? 2
            : item?.frequency;
          let sensorName = item?.sensors?.[0]?.sensor;
          const target = JSON.parse(item.target);
          const sensors: any = [];
          const start: Date = new Date(item?.openWindow);
          const end: Date = new Date(item?.closeWindow);
          let datesArray: any[] = [];
          const isNumberOfCollectionTask = this.isNumberOfCollectionsFrequency(item?.repeatFrequency);
          if (
            item?.repeatFrequency === 'Daily' ||
            item?.repeatFrequency === 'Sub-daily'
          ) {
            count = 1;
            this.dateRange = false;
          } else if (isNumberOfCollectionTask) {
            this.dateRange = false;
          } else if (item?.repeatFrequency === 'Weekly') {
            count = 7;
            this.dateRange = true;
          } else if (item?.repeatFrequency === 'Fortnightly') {
            count = 14;
            this.dateRange = true;
          } else if (item?.repeatFrequency === 'Days') {
            this.dateRange = false;
          } else if (item?.repeatFrequency === 'Monthly') {
            count = 30;
            this.dateRange = true;
          }

          function generateDateRangeArray(startDate, endDate, daysInterval) {
            const dateRangeArray: any = [];
            let currentDate = new Date(startDate);
            const hasIceyeSensor = item?.sensors?.some(
              (sensor: any) => sensor?.operatorKey === OPERATORS.ICEYE
            );
            const isIceyeDailyOrSubdailyTask =
              hasIceyeSensor &&
              (item?.repeatFrequency === 'Sub-daily' || item?.repeatFrequency === 'Daily');
            const configuredSubDailyCount = Number(item?.subDailyCount) || 0;
            const effectiveEndDate = new Date(endDate);

            // ICEYE daily/sub-daily recurrency is calendar-day based.
            // Normalize loop bounds to UTC midnight so the close-day is included.
            if (isIceyeDailyOrSubdailyTask) {
              currentDate.setUTCHours(0, 0, 0, 0);
              effectiveEndDate.setUTCHours(0, 0, 0, 0);
            }

            while (currentDate <= effectiveEndDate) {
              let isDisabled = true;
              let scenesFilterarray: any = [],
                scenesList: any = [];
              const endDateCopy = new Date(currentDate);
              endDateCopy.setDate(endDateCopy.getDate() + daysInterval - 1);
              if (endDateCopy > endDate) {
                endDateCopy.setTime(endDate.getTime());
              }
              endDateCopy.setUTCHours(23, 59, 59, 0);
              const convertedStart = new Date(currentDate).toISOString();
              const convertedEnd = endDateCopy.toISOString();
              const startDateOnly = new Date(currentDate)
                .toISOString()
                .split('T')[0];

              for (const [
                sceneIndex,
                scenes,
              ] of item?.sensors?.[0].scenes.entries()) {
                scenes.operatorKey = item?.sensors[0]?.operatorKey;
                scenes.sceneName = scenes.name;
                const datePredicted = scenes.predicted_date;
                let PredictedDateOnly;
                if (scenes.predicted_date != undefined) {
                  PredictedDateOnly = new Date(scenes.predicted_date)
                    .toISOString()
                    .split('T')[0];
                }
                const isIceyeDailyOrSubdaily =
                  item?.sensors?.[0]?.operatorKey === OPERATORS.ICEYE &&
                  (item?.repeatFrequency === 'Sub-daily' || item?.repeatFrequency === 'Daily');
                const iceyePredictedSource = isIceyeDailyOrSubdaily
                  ? scenes.day_start_date ?? scenes.predicted_date ?? scenes.predictedDate
                  : null;
                const iceyePredictedDateOnly = iceyePredictedSource
                  ? new Date(iceyePredictedSource).toISOString().split('T')[0]
                  : null;

                if (
                  isIceyeDailyOrSubdaily &&
                  (configuredSubDailyCount === 0 ||
                    Number(scenes?.subDailySlot ?? scenes?.sequence ?? scenes?.sequenceNumber) <= configuredSubDailyCount) &&
                  iceyePredictedDateOnly == startDateOnly &&
                  scenes.status !== 'error'
                ) {
                  const sceneTimeKey = scenes?.id != null
                    ? `slot:${scenes.subDailySlot ?? scenes.sequence ?? scenes.sequenceNumber ?? ''}|id:${scenes.id}`
                    : [
                        scenes.predicted_date ?? scenes.predictedDate ?? scenes.day_start_date ?? scenes.date,
                        scenes.subDailySlot ?? scenes.sequence ?? scenes.sequenceNumber ?? ''
                      ].join('|');
                  const indexToRemove = scenesFilterarray.findIndex((existingScene) => {
                    const existingKey = existingScene?.id != null
                      ? `slot:${existingScene.subDailySlot ?? existingScene.sequence ?? existingScene.sequenceNumber ?? ''}|id:${existingScene.id}`
                      : [
                          existingScene.predicted_date ?? existingScene.predictedDate ?? existingScene.day_start_date ?? existingScene.date,
                          existingScene.subDailySlot ?? existingScene.sequence ?? existingScene.sequenceNumber ?? ''
                        ].join('|');
                    return existingKey === sceneTimeKey;
                  });
                  if (indexToRemove === -1) {
                    scenesFilterarray.push(scenes);
                    isDisabled = false;
                  }
                } else if (
                  !isIceyeDailyOrSubdaily &&
                  (((item?.repeatFrequency === 'Sub-daily' || item?.repeatFrequency === 'Daily') &&
                    PredictedDateOnly == startDateOnly && scenes.status !== 'error') ||
                    (datePredicted >= convertedStart && datePredicted <= convertedEnd && scenes.status !== 'error'))
                ) {
                  const indexToRemove = scenesFilterarray.findIndex(
                    (item) => item.predicted_date === scenes.predicted_date
                  );
                  if (indexToRemove === -1) {
                    scenesFilterarray.push(scenes);
                    isDisabled = false;
                  }
                }
              }
              scenesFilterarray.forEach((element, index) => {
                element.sceneIdx = index + 1;
                if (element?.id != null && element?.status != 'failed') {
                  scenesList.push({ id: element.id });
                }
              });
              const unfailedScenes = scenesFilterarray.filter(
                (scene) => scene.status != 'failed'
              );
              if (unfailedScenes.length === 0) isDisabled = true;
              const availableSubDailySlots =
                item?.repeatFrequency === 'Sub-daily' &&
                item?.sensors?.some((sensor: any) => sensor?.operatorKey === OPERATORS.ICEYE)
                ? Array.from(
                    new Set<number>(
                      (item?.sensors ?? []).flatMap((sensor: any) =>
                        Object.keys(sensor?._iceyeSubdailyGroups?.[startDateOnly] ?? {})
                          .map(Number)
                          .filter(
                            (slot) =>
                              Number.isFinite(slot) &&
                              slot > 0 &&
                              (configuredSubDailyCount === 0 || slot <= configuredSubDailyCount)
                          )
                      ) as number[]
                    )
                  ).sort((left, right) => left - right)
                : [];
              dateRangeArray.push({
                start: convertedStart,
                end: convertedEnd,
                repeatFrequency: item?.repeatFrequency,
                checked: false,
                disabled: isDisabled,
                scenes: scenesFilterarray,
                scenesList: scenesList,
                subdailySlots: availableSubDailySlots,
                InfoServices: item?.sensors?.[0].informationServices || [],
                AssociatedFeeds:
                  item?.sensors?.[0].associated_feeds ??
                  item?.sensors?.[0].associatedFeeds ??
                  []
              });
              currentDate.setUTCDate(currentDate.getUTCDate() + daysInterval);
            }
            return dateRangeArray;
          }

          function buildNumberOfCollectionRecurrencyArray() {
            const dateRangeArray: any[] = [];
            const sceneIds = new Set<any>();
            const sourceSensor = item?.sensors?.[0];
            const sourceScenes = sourceSensor?.scenes ?? [];

            sourceScenes.forEach((scene: any) => {
              if (
                scene?.id == null ||
                scene?.status === 'failed' ||
                scene?.status === 'error' ||
                sceneIds.has(scene.id)
              ) {
                return;
              }

              sceneIds.add(scene.id);
              scene.operatorKey = sourceSensor?.operatorKey;
              scene.sceneName = scene.name;
              scene.sceneIdx = dateRangeArray.length + 1;
              const predictedDate = scene?.predicted_date ?? item?.openWindow;

              dateRangeArray.push({
                start: predictedDate,
                end: predictedDate,
                predictedDate: predictedDate,
                repeatFrequency: item?.repeatFrequency,
                checked: false,
                disabled: false,
                scenes: [scene],
                scenesList: [{ id: scene.id }],
                InfoServices: sourceSensor?.informationServices || [],
                AssociatedFeeds:
                  sourceSensor?.associated_feeds ?? sourceSensor?.associatedFeeds ?? [],
              });
            });

            return dateRangeArray;
          }

          function hasTimeReached(openWindow) {
            const targetTime = new Date(openWindow);
            const currentTime = new Date();
            return currentTime >= targetTime;
          }

          function hasCloseWindowPassed(closeWindow) {
            const closeTime = new Date(closeWindow);
            const currentTime = new Date();

            return currentTime > closeTime;
          }

          if (collectionFrequency === 1 && item?.repeatFrequency !== 'Days') {
            datesArray = isNumberOfCollectionTask
              ? buildNumberOfCollectionRecurrencyArray()
              : generateDateRangeArray(start, end, count);
          }
          item.sensors.forEach((sensor, i) => {
            const scenes: any = [];
            const scenesList: any = [];
            const startDate = new Date(item?.openWindow);
            const endDate = new Date(item?.closeWindow);
            let gropVessel: any;
            let valueAddedOption: any;
            let superResolutions: any;
            let indicesDetails: any;
            if (sensor?.operatorKey === this.OPERATOR.GHG) {
              const daysInterval = 30;
              datesArray = [];
              item.repeatFrequency = 'GHG-Monthly';
              this.dateRange = true;
              const dateRange = generateDateRangeArray(
                startDate,
                endDate,
                daysInterval
              );
              datesArray = dateRange;
              function generateDateRangeArray(
                startDate,
                endDate,
                daysInterval
              ) {
                const dateRangeArray: any = [];
                let currentDate = new Date(startDate);
                while (currentDate <= endDate) {
                  let isDisabled = true;
                  let scenesFilterarray: any = [],
                    scenesList: any = [];
                  const endDateCopy = new Date(currentDate);
                  endDateCopy.setDate(endDateCopy.getDate() + daysInterval - 1);
                  if (endDateCopy > endDate) {
                    endDateCopy.setTime(endDate.getTime());
                  }
                  endDateCopy.setUTCHours(23, 59, 59, 0);
                  const convertedStart = new Date(currentDate).toISOString();
                  const convertedEnd = endDateCopy.toISOString();
                  for (const [
                    sceneIndex,
                    scenes,
                  ] of item?.sensors?.[0].scenes.entries()) {
                    scenes.operatorKey = item?.sensors[0]?.operatorKey;
                    const datePredicted = scenes.predicted_date;
                    if (
                      datePredicted >= convertedStart &&
                      datePredicted <= convertedEnd &&
                      scenes.status !== 'error'
                    ) {
                      const indexToRemove = scenesFilterarray.findIndex(
                        (item) => item.predicted_date === scenes.predicted_date
                      );
                      if (indexToRemove === -1) {
                        scenesFilterarray.push(scenes);
                        isDisabled = false;
                      }
                    }
                  }
                  scenesFilterarray.forEach((element, index) => {
                    element.sceneIdx = index + 1;
                    if (element?.id != null && element?.status != 'failed') {
                      scenesList.push({ id: element.id });
                    }
                  });
                  const unfailedScenes = scenesFilterarray.filter(
                    (scene) => scene.status != 'failed'
                  );
                  if (unfailedScenes.length === 0) isDisabled = true;
                  dateRangeArray.push({
                    start: convertedStart,
                    end: convertedEnd,
                    repeatFrequency: 'GHG-Monthly',
                    checked: false,
                    disabled: isDisabled,
                    scenes: scenesFilterarray,
                    scenesList: scenesList,
                  });
                  currentDate.setDate(currentDate.getDate() + daysInterval);
                }
                return dateRangeArray;
              }
            }

            if (sensor?.valueAddedOption) {
              valueAddedOption = this.getValueAddedOption(
                sensor?.valueAddedOption
              );
            }
            if (sensor?.super_resolution) {
              superResolutions = sensor?.super_resolution;
            }
            if (sensor?.indices) {
              indicesDetails = sensor?.indices;
            }
            if (sensor?.pastPredictions) {
              gropVessel = sensor?.pastPredictions.reduce((acc, item) => {
                if (!acc[item.mmsi]) acc[item.mmsi] = [];
                acc[item.mmsi].push(item);
                return acc;
              }, {} as { [key: string]: any[] });
              this.groupedVessels = gropVessel;
            }
            const isNonImagery = this.nonImageryKey.includes(
              sensor?.operatorKey ?? false
            );
            if (
              (sensor?.scenes?.length > 0 || sensor?.operatorKey === OPERATORS.WEATHEREX) &&
              sensor?.status != 'rejected' &&
              sensor?.status != 'approved' &&
              sensor?.status != 'review' &&
              sensor?.status != 'pending' &&
              sensor?.status != 'failed' &&
              ((sensor?.status != 'canceled' &&
                sensor?.operatorKey != OPERATORS.CLYDE) ||
                sensor?.operatorKey === OPERATORS.CLYDE)
            ) {
              sensor?.scenes?.forEach((scene, index) => {
                const predictedDate = new Date(
                  scene?.predicted_date
                ).getUTCDate();
                scene.checked = false;
                let thumbnailUrl;
                let aisAvailable = hasTimeReached(item?.openWindow);
                let aisDownloadable = hasCloseWindowPassed(item?.closeWindow);
                sensor.scenes[index] = scene;
                thumbnailUrl =
                  environment.eeTaskServer + '/' + scene.thumbnailUrl || '';
                if (scene.status != 'error') {
                  scenes.push({
                    id: scene.id,
                    name: `Scene ${index + 1}`,
                    sceneIdx: index + 1,
                    footprint: scene.footprint,
                    aisAvailable,
                    aisDownloadable,
                    openWindow: item?.openWindow,
                    closeWindow: item?.closeWindow,
                    metadata: scene.metadata,
                    metadata_tooltip: scene?.metadata_tooltip,
                    thumbnailUrl: thumbnailUrl,
                    previewUrl: scene.previewUrl,
                    downloadUrl: scene.downloadUrl,
                    checked: false,
                    color: 'primary',
                    imageType: this.imageType,
                    scene_id: scene?.scene_id,
                    predictedDate: scene?.predicted_date ?? scene?.predictedDate ?? sensor?.day_start_date,
                    status: scene?.status,
                    RRdeliveryDate: scene?.RRdeliveryDate,
                    sequenceNumber: scene?.sequenceNumber ?? scene?.sequence ?? sensor?.subDailySlot,
                    sequence: scene?.sequence ?? scene?.sequenceNumber ?? sensor?.subDailySlot,
                    subDailySlot: scene?.subDailySlot ?? sensor?.subDailySlot,
                    subTaskName: scene?.subTaskName ?? sensor?.subTaskName,
                    day_start_date: scene?.day_start_date ?? sensor?.day_start_date,
                    day_end_date: scene?.day_end_date ?? sensor?.day_end_date,
                    uslFootprint: scene?.usl_footprint,
                    s_band: scene?.s_band,
                    x_band: scene?.x_band,
                    operatorKey: sensor?.operatorKey,
                    downloaded: scene?.downloaded,
                    refundRequest: scene?.refundRequest,
                    returnRefundAccept: scene?.returnRefundAccept,
                    returnRefundReject: scene?.returnRefundReject,
                    siteId: scene?.siteId,
                    target: scene?.target,
                    isName: scene?.isName,
                    png_footprint: scene?.png_footprint,
                    tif_footprint: scene?.tif_footprint,
                    legendScale: scene?.legendScale,
                    legend_min: scene?.legend_min,
                    legend_max: scene?.legend_max,
                    legend_long: scene?.legend_long,
                    legend_lat: scene?.legend_lat,
                    ch4srData: scene?.ch4srData,
                    signals: this.getSignals(scene?.signalOfInterest),
                    signalOfInterest: scene?.signalOfInterest,
                    skipPreview: scene?.skipPreview,
                    isNonImagery: isNonImagery,
                    min: scene?.min,
                    max: scene?.max,
                    tif: false,
                    sceneName: scene.name,
                    rawIQDownloaded: scene?.raw_iq_downloaded,
                    rawIQIncluded: scene?.raw_iq_included,
                    tnqSensorType: sensor?.tnqSensorType,
                    pastPrediction: gropVessel,
                  });
                }

                for (const [idx, scene] of scenes.entries()) {
                  scene.name = `Scene ${idx + 1}`;
                  scene.sceneIdx = idx + 1;
                }

                if (scene?.id != null && scene?.status != 'failed') {
                  sensor.scenes[index] = scene;
                  scenesList.push({
                    id: scene.id,
                  });
                }
              });
              if (scenes.length > 0 || sensor?.operatorKey === OPERATORS.WEATHEREX) {
                sensors.push({
                  name: sensor.sensor,
                  scenes,
                  checked: false,
                  id: sensor?.sensor_uuid,
                  downloadUrl: sensor?.downloadUrl,
                  questionName: sensor?.questionName,
                  questionId: sensor?.questionId,
                  scenesList,
                  latency: sensor?.latency,
                  downloaded: sensor?.downloaded,
                  resolution_tooltip: sensor.resolution_tooltip,
                  siteData: sensor?.siteData,
                  InfoServices: sensor.informationServices || [],
                  AssociatedFeeds:
                    sensor.associated_feeds ?? sensor.associatedFeeds ?? [],
                  Observation: sensor.observation || [],
                  intervals: sensor?.intervals,
                  status: sensor?.status,
                  restoreStatus: sensor?.restoreStatus,
                  restoreOption: sensor?.restoreOption,
                  operatorKey: sensor?.operatorKey,
                  noOfRefreshes: sensor?.noOfRefreshes,
                  updatedRefreshes: sensor?.updatedRefreshes,
                  timeExpired: sensor?.timeExpired,
                  aisDownloadable: hasCloseWindowPassed(item?.closeWindow),
                  // The TOI's own start, on the SENSOR. The scenes carry it
                  // too, but `isVesselFinderToiNotStarted` is asked about a
                  // sensor — often one whose scenes this operator never looks
                  // at — so the answer must not depend on a scene being there.
                  // Carried as the date, not as a load-time boolean like
                  // `aisDownloadable` above: a flag stamped here would still
                  // read "not started" on a session left open across the
                  // opening, where the date is re-read on every check.
                  openWindow: item?.openWindow,
                  isHistorical: sensor?.isHistorical,
                  noOfHistoricalData: sensor?.noOfHistoricalData,
                  updatedFetches: sensor?.updatedFetches,
                  // Voyage Radar credit wallet (undefined for every other operator).
                  apiCredits: sensor?.apiCredits,
                  apiCreditsRemaining: sensor?.apiCreditsRemaining,
                  apiCreditActions: sensor?.apiCreditActions,
                  // Balance at approval. The wallet is zeroed when a refund is
                  // approved, so this is the only record of what was refunded.
                  refundedApiCredits: sensor?.refundedApiCredits,
                  valueAddedOption: valueAddedOption,
                  superResolutions: superResolutions,
                  indicesDetails: indicesDetails,
                  sarColorisation: sensor?.sarColorisation,
                  isAdditionalCSIProducts: sensor?.isAdditionalCSIProducts,
                  obfuscateName: sensor?.obfuscateName,
                  unUsedRefreshes:
                    sensor.updatedRefreshes == 0
                      ? 0
                      : sensor.updatedRefreshes || sensor.noOfRefreshes,
                  unUsedFetches:
                    sensor.updatedFetches == 0
                      ? 0
                      : sensor.updatedFetches || sensor.noOfHistoricalData,
                  assetsDelivered: sensor?.assetsDelivered,
                  refreshHistory: sensor?.refreshHistory,
                  ...this.normalizeSensorTaskData(sensor),
                  // Voyage Radar: purchased vessel tracks, replayable for free.
                  trackHistory: sensor?.trackHistory,
                  // Voyage Radar: the saved vessels. Persisted server-side by
                  // /saveVoyageRadarVessel, so it has to be carried across here
                  // like its two sibling histories — this view-model is built
                  // field by field, and a field left out is a feature that
                  // works until the page is reloaded.
                  vesselHistory: sensor?.vesselHistory,
                  sensorType: sensor?.sensorType,
                  tnqSensorType: sensor?.tnqSensorType,
                  pastPrediction: gropVessel,
                  feed_results: sensor?.feed_results,
                  week: sensor?.week,
                  week_day: sensor?.week_day,
                  subTaskName: sensor?.subTaskName,
                  day_start_date: sensor?.day_start_date,
                  day_end_date: sensor?.day_end_date,
                  refreshRate: sensor?.refreshRate,
                  collectionMode: sensor?.collectionMode,
                });
              }
            } else if (item?.repeatFrequency === 'Days' && sensor?.week) {
              // Days task: push sensor even with no scenes so all weeks/days appear in dropdowns
              sensors.push({
                name: sensor.sensor,
                scenes: [],
                scenesList: [],
                checked: false,
                id: sensor?.sensor_uuid,
                downloadUrl: sensor?.downloadUrl,
                questionName: sensor?.questionName,
                questionId: sensor?.questionId,
                latency: sensor?.latency,
                downloaded: sensor?.downloaded,
                resolution_tooltip: sensor.resolution_tooltip,
                siteData: sensor?.siteData,
                InfoServices: sensor.informationServices || [],
                AssociatedFeeds:
                  sensor.associated_feeds ?? sensor.associatedFeeds ?? [],
                Observation: sensor.observation || [],
                intervals: sensor?.intervals,
                status: sensor?.status,
                restoreStatus: sensor?.restoreStatus,
                restoreOption: sensor?.restoreOption,
                operatorKey: sensor?.operatorKey,
                noOfRefreshes: sensor?.noOfRefreshes,
                updatedRefreshes: sensor?.updatedRefreshes,
                timeExpired: sensor?.timeExpired,
                aisDownloadable: hasCloseWindowPassed(item?.closeWindow),
                // Same reasoning as the branch above.
                openWindow: item?.openWindow,
                isHistorical: sensor?.isHistorical,
                noOfHistoricalData: sensor?.noOfHistoricalData,
                updatedFetches: sensor?.updatedFetches,
                // Voyage Radar credit wallet (undefined for every other operator).
                apiCredits: sensor?.apiCredits,
                apiCreditsRemaining: sensor?.apiCreditsRemaining,
                apiCreditActions: sensor?.apiCreditActions,
                refundedApiCredits: sensor?.refundedApiCredits,
                valueAddedOption: valueAddedOption,
                superResolutions: superResolutions,
                indicesDetails: indicesDetails,
                sarColorisation: sensor?.sarColorisation,
                isAdditionalCSIProducts: sensor?.isAdditionalCSIProducts,
                obfuscateName: sensor?.obfuscateName,
                unUsedRefreshes:
                  sensor.updatedRefreshes == 0
                    ? 0
                    : sensor.updatedRefreshes || sensor.noOfRefreshes,
                unUsedFetches:
                  sensor.updatedFetches == 0
                    ? 0
                    : sensor.updatedFetches || sensor.noOfHistoricalData,
                assetsDelivered: sensor?.assetsDelivered,
                refreshHistory: sensor?.refreshHistory,
                ...this.normalizeSensorTaskData(sensor),
                // Voyage Radar: purchased vessel tracks, replayable for free.
                trackHistory: sensor?.trackHistory,
                // Voyage Radar: the saved vessels — same reasoning as the branch above.
                vesselHistory: sensor?.vesselHistory,
                sensorType: sensor?.sensorType,
                tnqSensorType: sensor?.tnqSensorType,
                pastPrediction: gropVessel,
                feed_results: sensor?.feed_results,
                week: sensor?.week,
                week_day: sensor?.week_day,
                subTaskName: sensor?.subTaskName,
                day_start_date: sensor?.day_start_date,
                day_end_date: sensor?.day_end_date,
                refreshRate: sensor?.refreshRate,
                collectionMode: sensor?.collectionMode,
              });
            }
          });
          let taskCollection = item?.taskcollection;
          let captures = item?.captures;
          let sensorsName = item?.sensorsName;
          let info = item?.info;
          // Build week+day grouped structure for Days-frequency tasks
          if (item?.repeatFrequency === 'Days' && sensors.length > 0) {
            const weekMap: { [key: string]: any } = {};
            const openDate = new Date(item.openWindow);
            const closeDate = new Date(item.closeWindow);
            // Weeks run Sunday–Saturday; compute days from openDate to the first Saturday
            const daysToFirstSat = (6 - openDate.getUTCDay() + 7) % 7;
            sensors.forEach((s: any) => {
              const wk = s.week ?? 'Unknown';
              const wd = s.week_day ?? 'Unknown';
              if (!weekMap[wk]) {
                const weekNum = parseInt(wk.replace(/^W/i, ''), 10) || 1;
                const wkStart = new Date(openDate);
                const wkEnd = new Date(openDate);
                if (weekNum === 1) {
                  // W1: openDate → first Saturday of task window
                  wkEnd.setUTCDate(openDate.getUTCDate() + daysToFirstSat);
                } else {
                  // Wn (n≥2): starts next Sunday after previous week's Saturday
                  wkStart.setUTCDate(openDate.getUTCDate() + daysToFirstSat + (weekNum - 2) * 7 + 1);
                  wkEnd.setUTCDate(openDate.getUTCDate() + daysToFirstSat + (weekNum - 1) * 7);
                }
                if (wkEnd > closeDate) wkEnd.setTime(closeDate.getTime());
                weekMap[wk] = {
                  key: wk,
                  label: `Week ${weekNum}`,
                  days: {},
                  weekStart: wkStart.toISOString(),
                  weekEnd: wkEnd.toISOString()
                };
              }
              if (!weekMap[wk].days[wd]) {
                weekMap[wk].days[wd] = { key: wd, day_start_date: s.day_start_date, sensors: [] };
              }
              weekMap[wk].days[wd].sensors.push(s);
            });
            item._groupedDaysSensors = Object.values(weekMap).map((wk: any) => ({
              ...wk,
              days: Object.values(wk.days)
            }));
          }

          

          if (sensors.length > 0) {
            this.collections.push({
              project,
              taskname,
              target,
              sensors,
              taskId,
              taskStrategy: item?.taskStrategy,
              sensorName,
              taskCollection,
              captures,
              sensorsName,
              info,
              frequency: collectionFrequency,
              repeatFrequency: item?.repeatFrequency,
              noOfRepeats: item?.noOfRepeats,
              recurrencyArray: datesArray,
              subDailyCount: item?.subDailyCount,
              feasibilityTask: item?.feasibilityTask,
              opportunityList: item?.opportunityList,
              projectId: item?.projectid,
              returnRefund: item?.returnRefund,
              createdDate,
              openWindow: item?.openWindow,
              closeWindow: item?.closeWindow,
              _groupedDaysSensors: item?._groupedDaysSensors ?? null,
              feedBased: item?.feed_based,
              questionId,
            });
          }
        });
        if (this.collections.length > 0) {
          const sensorWithData = this.collections[0].sensors.find(
            (sensor) =>
              (Array.isArray(sensor.InfoServices) && sensor.InfoServices.length > 0) ||
              (Array.isArray(sensor.AssociatedFeeds) && sensor.AssociatedFeeds.length > 0)
          );

          const sensorWithindicesDetails = this.collections[0].sensors.find(
            (sensor) => sensor.indicesDetails
          );

          const sensorWithSR = this.collections[0].sensors.find(
            (sensor) => sensor.superResolutions
          );
          if (sensorWithData) {
            const infoServicesLength = sensorWithData.InfoServices.length;
            this.selectedIS = Array(infoServicesLength).fill(false);
          }
          this.collection = this.collections[idx];
          this.taskName = this.collections[idx].taskname;
          this.taskid = this.collections[idx].taskId;
          this.sensorList = this.collections[idx].sensors;
          this._attachVesselFinder();
          this.isFeedTasking = this.taskMode === 'feed' || (this.collections[idx].feedBased ?? false);
          this.fullCollection = JSON.parse(JSON.stringify(this.collections[idx]));
          this.recurrencyArray = this.collections[idx].recurrencyArray;
          if (sensorWithData) {
            this.collection.sensors.map((sensor) => {
              sensor.InfoServices.map((infoService) => {
                infoService.isDisable = true;
              });
              sensor.AssociatedFeeds?.map((associatedFeed) => {
                associatedFeed.isDisable = true;
              });
            });
          }
          if (sensorWithindicesDetails) {
            this.collection.sensors.map((sensor) => {
              sensor.indicesDetails?.map((indicesDetails) => {
                indicesDetails.isDisable = true;
                indicesDetails.loadTif = false;
              });
            });
          }
          if (sensorWithSR) {
            this.collection.sensors.map((sensor) => {
              sensor.superResolutions?.map((superResolution) => {
                superResolution.isDisable = true;
              });
            });
          }
          if (
            (this.collection?.frequency === 1 &&
              this.collection?.recurrencyArray?.length > 0) ||
            this.collection?.recurrencyArray?.[0]?.repeatFrequency ===
              'GHG-Monthly' ||
            (this.collection?.feasibilityTask &&
              this.collection?.opportunityList?.length > 0)
          ) {
            this.recurrentTask = true;
          } else this.recurrentTask = false;
          this.taskCreatedDate = this.collections[idx].createdDate;
          for (const [
            sensorIndex,
            opprDates,
          ] of this.collection.opportunityList.entries()) {
            const givenDateObj = new Date(opprDates.date);
            givenDateObj.setHours(0, 0, 0, 0);
            opprDates.checked = false;
            opprDates.name = this.collections[idx].sensors[0].name;
            opprDates.id = this.collections[idx].sensors[0]?.id;
            opprDates.scenes = this.collections[idx].sensors[0].scenes.filter(
              (scene) => {
                const dateObj = new Date(scene.predictedDate);
                dateObj.setHours(0, 0, 0, 0);
                return givenDateObj.getTime() === dateObj.getTime();
              }
            );
          }
          if (
            (this.collections[idx]?.frequency === 1 &&
              this.collections[idx]?.recurrencyArray?.length > 0) ||
            this.collections[idx]?.repeatFrequency === 'GHG-Monthly'
          ) {
            this.initializeDefaultValue();
            this.selectOptionNew(
              this.collections[idx]?.recurrencyArray?.[0],
              'normal'
            );
          } else if (
            this.collections[idx]?.repeatFrequency === 'Days' &&
            this.collections[idx]?._groupedDaysSensors?.length > 0
          ) {
            this.initializeDaysCollection(idx);
          } else if (
            this.collections[idx]?.feasibilityTask &&
            this.collections[idx]?.opportunityList?.length > 0
          ) {
            this.selectOpportunity(
              this.collections[idx]?.opportunityList?.[0],
              'normal'
            );
          }
        }
      } else {
        this.collectionsData = [];
      }
      this.spire = false;
      this.usl = false;
      this.lband = false;
      for (const [sensorIndex, sensor] of (this.collections?.[idx]?.sensors ?? []).entries()) {
        if (
          sensor?.operatorKey === OPERATORS.SPIRE ||
          sensor?.operatorKey === OPERATORS.CLYDE ||
          sensor?.operatorKey === OPERATORS.VOYAGERADAR
        ) {
          this.spire = true;
        } else if (sensor?.operatorKey === OPERATORS.USL) {
          this.usl = true;
        } else if (sensor?.operatorKey === OPERATORS.LBAND) {
          this.lband = true;
        }
      }
      this.sensorLength = this.collections?.[idx]?.sensors?.length ?? 0;
      // Show target polygon immediately for WeatherEx tasks on initial load
      const wxCollection = this.collections?.[idx];
      if (wxCollection?.sensors?.some(s => s.operatorKey === OPERATORS.WEATHEREX)) {
        this.showWeatherExTarget(wxCollection);
      }
      // Same idea for Voyage Radar: frame the tasked AOI rather than leaving the
      // map on the country-level view loadUserDetails sets, which is nowhere near
      // this task's data.
      if (wxCollection?.sensors?.some(s => s.operatorKey === OPERATORS.VOYAGERADAR)) {
        this.voyage.showAoi(wxCollection);
        // A task that loads with its sensor already ticked is a sensor that is
        // on, so it gets the target the checkbox would have drawn. Framing above
        // is unconditional; DRAWING follows the box, so a task opened with it
        // clear is still framed on the AOI but shows nothing on the map.
        // The collection is passed explicitly — `this.collection` is not this
        // one yet at load time, which is why `showAoi` takes it too.
        if (wxCollection.sensors.some(
          (s: any) => s?.operatorKey === OPERATORS.VOYAGERADAR && s?.checked,
        )) {
          this.voyage.showTarget({ collection: wxCollection });
        }
      }
    });
  }

  getSignals(signalOfInterest) {
    let signals;
    if (signalOfInterest) {
      signals = [
        {
          features: [],
          product: 'All',
          type: 'FeatureCollection',
        },
        ...signalOfInterest,
      ];
    }

    return signals;
  }

  selectSignals(sensor: any, signal: any) {
    this.signalSelected = signal;
    this.audioAvailable = false;
    this.clearRFSignalsNew();
    this.scenesNew = this.scenesNew.filter(
      (scnNew) => !scnNew.hasOwnProperty('signalLayers')
    );
    if (this.isCompare) {
      this.collection.recurrencyArray.forEach((recurrency) => {
        recurrency.scenes.forEach((scene) => {
          if (scene.checked) {
            this.displayRFSignalsNew(scene, sensor.id, this.signalSelected);
          }
        });
      });
    } else {
      sensor.scenes.map((scene: any) => {
        if (scene.checked == true) {
          this.displayRFSignalsNew(scene, sensor.id, this.signalSelected);
        }
      });
    }
  }

  getValueAddedOption(dataArray: any) {
    let productsData: any;
    productsData = dataArray[0];

    const productsInfo = ((productsData || {}).products || []).map(
      (product) => ({
        ...product,
        product_id: productsData.product_id,
        sensorid: productsData.sensorId,
        releaseRequest: dataArray[0]?.releaseRequest,
      })
    );

    productsInfo.sort((a, b) => {
      const actionA = a.product || '';
      const actionB = b.product || '';
      return actionA.localeCompare(actionB);
    });

    return productsInfo;
  }

  restTask() {
    this.selectedCheckboxes = [];
    this.showDailyRecurrencyCheckboxes = false;
  }

  handleclickTaskItemWithAbort(menuItem: ProjectInfo, index: number) {
    this.observationEnabled = false;
    if (this.opManager?.isOperationRunning) {
      return this.showAbortRetainPopup().then((shouldAbort) => {
        if (shouldAbort) {
          this.opManager.abortOperation();
          return this.clickTask(menuItem, index);
        }
      });
    }
    return this.clickTask(menuItem, index);
  }

  clickTask(taskItem, index) {
    this.sceneOverlayOpacity = 100;
    this.clearActiveChangeDetectionCurrentWeekTab();
    this.clearChangeDetectionHistoryForNavigation();
    this.cancelTiffWfsLoads();
    this.resetWeatherExForecastSelection();

    this.checkedObservation = false;
    this.observationEnabled = false;
    this.removeObservationMarker();

    this.removeVectorOverlay();
    (this.imageType = 'png'), (this.loadTiff = false);
    this.feedUi = { showFilterIcon: false };
    this.taskSelected = true;
    this.taskCollection = JSON.parse(JSON.stringify(taskItem));
    this.collectionIndex = JSON.parse(JSON.stringify(index));
    this.defaultSubdailyCount = 1;
    this.isSitechanged = false;
    this.filterInfoVisible = false;
    this.toggleDailyRecurrency(index);
    this.resetAllFeedPanels();
    this.clearAllPredictionData();
    this.combinedScenes = false;
    this.sliderShow = false;
    if (this.getCollectionSub) {
      this.getCollectionSub.unsubscribe();
      this.spinnerService.hide();
    }
    this.unSubscribeAPI();
    // Show target polygon immediately for WeatherEx tasks
    if (taskItem?.sensors?.some(s => s.operatorKey === OPERATORS.WEATHEREX)) {
      this.showWeatherExTarget(taskItem);
    }
  }

  selectOpportunity(event, type: any) {
    this.opportunityId = event.oppid[0];
    this.filteredCollection = [];
    let scenesList: any = [];
    const collection = this.fullCollection;
    let opportunityDate = new Date(event.date);
    opportunityDate.setHours(0, 0, 0, 0);
    this.selectedStartDate = event.date;
    for (const [sensorIndex, sensors] of collection.sensors.entries()) {
      let sceneArray: any = [];
      for (const [sceneIndex, scenes] of sensors.scenes.entries()) {
        let predictedDate = new Date(scenes.predictedDate);
        predictedDate.setHours(0, 0, 0, 0);
        scenes.checked = false;
        if (predictedDate.getTime() === opportunityDate.getTime()) {
          sceneArray.push(scenes);
        }
      }
      sceneArray.forEach((element, index) => {
        element.sceneIdx = index + 1;
        if (element?.id != null && element?.status != 'failed') {
          scenesList.push({ id: element.id });
        }
      });
      this.collection.sensors[sensorIndex].scenesList = scenesList;
      this.collection.sensors[sensorIndex].scenes = sceneArray;
    }
    this.collection.sensors.forEach((element, index) => {
      element.checked = false;
    });
    this.resetFeedsStatus(this.collection);
    this.resetMapNew();
    this.removeVectorOverlay();
  }

  selectSiteOptionNew(event, type: any) {
    this.selectOptionNew(event, type);
  }

  initializeDaysCollection(idx: number): void {
    this.daysWeekOptions = this.collections[idx]._groupedDaysSensors ?? [];
    // Build recurrencyArray from every day's scenes so compare pipeline works
    this._daysRecurrencyIndexMap = {};
    const daysRecurrencyArray: any[] = [];
    this.daysWeekOptions.forEach((wk: any) => {
      wk.days.forEach((day: any) => {
        const dayKey = `${wk.key}_${day.key}`;
        const scenes: any[] = [];
        const scenesList: any[] = [];
        day.sensors.forEach((s: any) => {
          (s.scenes ?? []).forEach((scene: any, si: number) => {
            if (scene.status !== 'error' && scene.status !== 'failed') {
              scenes.push({ ...scene, sceneIdx: scenes.length + 1 });
              if (scene.id) scenesList.push({ id: scene.id });
            }
          });
        });
        this._daysRecurrencyIndexMap[dayKey] = daysRecurrencyArray.length;
        daysRecurrencyArray.push({
          start: day.day_start_date,
          end: day.sensors[0]?.day_end_date ?? day.day_start_date,
          repeatFrequency: 'Days',
          checked: false,
          disabled: scenes.length === 0,
          scenes,
          scenesList,
          _dayKey: dayKey,
          _weekKey: wk.key,
          _weekDayKey: day.key,
        });
      });
    });
    this.collection.recurrencyArray = daysRecurrencyArray;
    if (this.daysWeekOptions.length > 0) {
      this.selectedDaysWeek = this.daysWeekOptions[0].key;
      this.daysDayOptions = this.daysWeekOptions[0].days ?? [];
      if (this.daysDayOptions.length > 0) {
        this.onDaysDayChange(this.daysDayOptions[0].key);
      }
    }
  }

  onDaysWeekChange(weekKey: string): void {
    // Reset compare state when switching weeks
    if (this.showDailyRecurrencyCheckboxes) {
      this.showDailyRecurrencyCheckboxes = false;
      this.isCompare = false;
      this.isCompareRecurrency = false;
      this.isCompareClicked = false;
      this.collection.recurrencyArray.forEach((r: any) => { r.checked = false; });
    }
    this.selectedDaysWeek = weekKey;
    const weekGroup = this.daysWeekOptions.find(w => w.key === weekKey);
    this.daysDayOptions = weekGroup?.days ?? [];
    this.selectedDaysDay = '';
    if (this.daysDayOptions.length > 0) {
      this.onDaysDayChange(this.daysDayOptions[0].key);
    }
  }

  onDaysDayChange(dayKey: string): void {
    if (this.showDailyRecurrencyCheckboxes) return; // compare mode — handled by toggleRecurrentDatesNew
    this.selectedDaysDay = dayKey;
    const weekGroup = this.daysWeekOptions.find(w => w.key === this.selectedDaysWeek);
    const dayGroup = weekGroup?.days?.find((d: any) => d.key === dayKey);
    if (dayGroup) {
      this.collection.sensors = dayGroup.sensors.map((s: any) => ({ ...s, checked: false }));
      this.resetMapNew();
    }
  }

  selectOptionNew(event, type: any) {
    this.subSelectionSelectionChange.next(1);
    this.filteredCollection = [];
    let scenesList: any = [];
    const collection = this.fullCollection;
    this.sceneBands = '';
    this.selectedStartDate = '';
    this.selectedEndDate = '';
    const parseLocalBoundaryDate = (value: any, endOfDay = false) => {
      if (value instanceof Date) {
        return new Date(
          value.getFullYear(),
          value.getMonth(),
          value.getDate(),
          endOfDay ? 23 : 0,
          endOfDay ? 59 : 0,
          endOfDay ? 59 : 0,
          endOfDay ? 999 : 0
        );
      }

      const datePart = String(value ?? '').split('T')[0];
      const [year, month, day] = datePart.split('-').map(Number);

      if (!year || !month || !day) {
        const fallbackDate = new Date(value);
        return new Date(
          fallbackDate.getFullYear(),
          fallbackDate.getMonth(),
          fallbackDate.getDate(),
          endOfDay ? 23 : 0,
          endOfDay ? 59 : 0,
          endOfDay ? 59 : 0,
          endOfDay ? 999 : 0
        );
      }

      return new Date(
        year,
        month - 1,
        day,
        endOfDay ? 23 : 0,
        endOfDay ? 59 : 0,
        endOfDay ? 59 : 0,
        endOfDay ? 999 : 0
      );
    };
    const startDate = parseLocalBoundaryDate(event.start);
    const endDate = parseLocalBoundaryDate(event.end, true);
    const toLocalDateKey = (date: Date) => {
      const year = date.getFullYear();
      const month = `${date.getMonth() + 1}`.padStart(2, '0');
      const day = `${date.getDate()}`.padStart(2, '0');
      return `${year}-${month}-${day}`;
    };
    this.selectionChange.next(event);
    this.selectedValue = event;
    this.selectedStartDate = event.start;
    this.selectedEndDate = event.end;
    this.filterInfoVisible = false;

    // ── Days-frequency: match sensors by day_start_date, not predictedDate ──
    if (event?.repeatFrequency === 'Days') {
      const dayStart = event.start;
      const allScenesList: any[] = [];
      const matchingSensors: any[] = [];
      const otherSensors: any[] = [];
      for (const sensor of collection.sensors) {
        sensor.scenes.forEach((s: any) => { s.checked = false; });
        if (sensor.day_start_date === dayStart) {
          const filteredScenes = sensor.scenes.filter(
            (s: any) => s.status !== 'failed' && s.status !== 'error'
          );
          filteredScenes.forEach((s: any, i: number) => { s.sceneIdx = i + 1; });
          allScenesList.push(...filteredScenes.filter((s: any) => s.id).map((s: any) => ({ id: s.id })));
          matchingSensors.push({ ...sensor, scenes: filteredScenes, scenesList: allScenesList.slice(), checked: false });
        } else {
          otherSensors.push({ ...sensor, scenes: [], scenesList: [], checked: false });
        }
      }
      // matching day's sensors first → collection.sensors[0] has the correct sensor UUID for API calls
      this.collection.sensors = [...matchingSensors, ...otherSensors];
      this.previousSelection = event;
      this.collection.sensors.forEach((s: any) => { s.checked = false; });
      this.filteredCollection = JSON.parse(JSON.stringify(this.collection));
      this.checkForScenes(allScenesList);
      if (type !== 'compare') {
        this.resetMapNew();
        this.removeVectorOverlay();
      }
      this.resetFeedsStatus(this.collection);
      return;
    }

    if (this.isNumberOfCollectionsFrequency(event?.repeatFrequency)) {
      const selectedSceneId =
        event?.scenesList?.[0]?.id ?? event?.scenes?.[0]?.id ?? event?.sceneId;
      const selectedDate = event?.predictedDate
        ? toLocalDateKey(new Date(event.predictedDate))
        : toLocalDateKey(startDate);
      const allScenesList: any[] = [];

      for (const [sensorIndex, sensor] of collection.sensors.entries()) {
        const sceneArray = sensor.scenes.filter((scene: any) => {
          if (!scene?.predictedDate) return false;
          const sceneDate = toLocalDateKey(new Date(scene.predictedDate));
          return (
            (selectedSceneId ? scene?.id === selectedSceneId : sceneDate === selectedDate) &&
            scene?.id != null &&
            scene?.status !== 'failed' &&
            scene?.status !== 'error'
          );
        });

        sceneArray.forEach((scene: any, index: number) => {
          scene.checked = false;
          scene.sceneIdx = index + 1;
          allScenesList.push({ id: scene.id });
        });

        this.collection.sensors[sensorIndex].scenesList = sceneArray.map((scene: any) => ({ id: scene.id }));
        this.collection.sensors[sensorIndex].scenes = sceneArray;
        this.collection.sensors[sensorIndex].checked = false;
      }

      this.checkForScenes(allScenesList);
      this.previousSelection = event;
      this.filteredCollection = JSON.parse(JSON.stringify(this.collection));
      if (type !== 'compare') {
        this.resetMapNew();
        this.removeVectorOverlay();
      }
      this.resetFeedsStatus(this.collection);
      return;
    }

    for (const [sensorIndex, sensors] of collection.sensors.entries()) {
      let sceneArray: any = [];
      for (const [sceneIndex, scenes] of sensors.scenes.entries()) {
        let datePredicted = new Date(scenes.predictedDate);
        const predictedDate = scenes.predictedDate;
        scenes.checked = false;
        if (
          event?.repeatFrequency === 'Daily' &&
          datePredicted >= startDate &&
          datePredicted <= endDate
        ) {
          sceneArray.push(scenes);
        } else if (
          event?.repeatFrequency === 'Sub-daily' &&
          predictedDate !== undefined
        ) {
          const PredictedDateOnly = toLocalDateKey(new Date(scenes.predictedDate));
          const startDateOnly = toLocalDateKey(startDate);
          const endDateOnly = toLocalDateKey(endDate);
          if (
            PredictedDateOnly == startDateOnly &&
            PredictedDateOnly == endDateOnly
          ) {
            sceneArray.push(scenes);
          } 
        } else if (datePredicted >= startDate && datePredicted <= endDate) {
          sceneArray.push(scenes);
        }
      }
      sceneArray.forEach((element, index) => {
        element.sceneIdx = index + 1;
        if (element?.id != null && element?.status != 'failed') {
          scenesList.push({ id: element.id });
        }
      });
      
      this.collection.sensors[sensorIndex].scenesList = scenesList;
      this.collection.sensors[sensorIndex].scenes = sceneArray;
      this.checkForScenes(scenesList);
    }
    if (
      (type !== 'compare' &&
        ((this.previousSelection !== null &&
          JSON.stringify(this.previousSelection) !== JSON.stringify(event)) ||
          this.previousSelection === null)) ||
      type === 'compare'
    ) {
      this.previousSelection = event;
      if (event?.repeatFrequency !== 'GHG-Monthly') {
        this.collection.sensors.forEach((element, index) => {
          element.checked = false;
        });
      }
      this.filteredCollection = JSON.parse(JSON.stringify(this.collection));
      if (event?.repeatFrequency === 'Sub-daily') {
        this.selectSubdailyNew(this.defaultSubdailyCount, event);
      } else if (event?.repeatFrequency === 'GHG-Monthly') {
        if (type != 'compare') {
          this.resetMapNew();
          this.removeVectorOverlay();
        }
        this.selectSites(this.defaultSubdailyCount, event);
        this.checkForScenes(this.collection.sensors[0].scenes);
      } else if (type != 'compare') {
        this.resetMapNew();
        this.removeVectorOverlay();
      }
    } else {
      this.filteredCollection = JSON.parse(JSON.stringify(this.collection));
      if (event?.repeatFrequency === 'Sub-daily') {
        this.selectSubdailyNew(this.defaultSubdailyCount, event);
      } else if (event?.repeatFrequency === 'GHG-Monthly') {
        this.selectSites(this.defaultSubdailyCount, event);
      }
    }
    this.resetFeedsStatus(this.collection);
  }

  selectSubdailyNew(count: number, event: any) {
    if (this.selectedCheckboxes?.length > 1) return;
    this.subDailyCountarray = [];
    this.defaultSubdailyCount = count;
    
    let scenesList: any = [];
    
    // Keep ALL scenes - don't filter them
    for (const [sensorIndex, sensors] of this.filteredCollection.sensors.entries()) {
      let sceneArray: any = [];
      for (const [sceneIndex, scenes] of sensors.scenes.entries()) {
        scenes.checked = false;

        // Filter: only include scenes matching the selected subdaily count
        const sceneSlot = Number(scenes?.subDailySlot ?? scenes?.sequence ?? scenes?.sequenceNumber);
        if (sceneSlot === count) {
          sceneArray.push(scenes);
        }
      }
      
      sceneArray.forEach((element, index) => {
        element.sceneIdx = index + 1;
        if (element?.id != null && element?.status != 'failed') {
          scenesList.push({ id: element.id });
        }
      });
      
      this.collection.sensors[sensorIndex].checked = false;
      this.collection.sensors[sensorIndex].scenesList = scenesList;
      this.collection.sensors[sensorIndex].scenes = sceneArray;
    }
    
    this.checkForScenes(scenesList);
    
    for (let i = 0; i < this.collection?.subDailyCount; i++) {
      const countObject = {
        checked: false,
        value: i + 1,
        disabled: this.disabledCheck(i + 1),
      };
      this.subDailyCountarray.push(countObject);
      this.suppressSubDailyCheckbox = true;
    }
    
    const sequenceExists = this.collection?.recurrencyArray
      ?.some(r => r?.scenes?.some(s => s?.sequence !== undefined && s.sequence != null));

    if (sequenceExists && count !== 0) {
      this.collection?.recurrencyArray?.forEach((recurrency: any, i: any) => {
        // Use fallback chain for ICEYE compatibility
        let res = recurrency?.scenes?.filter(
          (scene: any) => Number(scene?.subDailySlot ?? scene?.sequence ?? scene?.sequenceNumber) === count
        );
        if (res.length == 0) {
          recurrency.disabled = true;
        } else {
          recurrency.disabled = false;
        }
      });
    }

    if (!this.showDailyRecurrencyCheckboxes && !this.RF) {
      this.resetMapNew();
      this.removeVectorOverlay();
    }
    
    for (const [subdailyIndex, subdaily] of this.subDailyCountarray.entries()) {
      subdaily.checked = this.defaultSubdailyCount == subdailyIndex + 1;
    }
    
    let selectedSubdaily = this.subDailyCountarray.find(
      (subDaily) => subDaily.value == this.defaultSubdailyCount
    );
    
    if (
      this.isCompare &&
      this.selectedCheckboxesNew.length == 1 &&
      this.defaultSubdailyCount != 0
    ) {
      event.checked = true;
      this.selectSubdailyRecurrentNew(event, selectedSubdaily, false);
    }
  }

  clickSites(item: number, event: any) {
    if (!this.isCompare || this.timeseries) {
      this.resetMapNew();
      this.removeVectorOverlay();
    }
    this.isSitechanged = true;
    this.defaultSubdailyCount = item;
    this.resetScenesBySite(item, event);
    this.selectionChange.next(this.collection.recurrencyArray[0]);
    this.selectedValue = this.collection.recurrencyArray[0];
  }

  resetScenesBySite(item, event) {
    this.imageType = this.checkType();
    let scenesList: any = [];
    for (const [sensorIndex, sensors] of [
      this.collection.recurrencyArray[0],
    ].entries()) {
      let sceneArray: any = [];
      for (const [sceneIndex, scenes] of sensors.scenes.entries()) {
        scenes.checked = false;
        scenes.imageType = this.imageType;
        scenes.tif = false;
        scenes.predictedDate = scenes?.predicted_date;
        if (scenes?.siteId == item) {
          sceneArray.push(scenes);
        }
      }
      sceneArray.forEach((element, index) => {
        element.sceneIdx = index + 1;
        if (element?.id != null && element?.status != 'failed') {
          scenesList.push({ id: element.id });
        }
      });
      this.checkForScenes(sceneArray);
      if (this.timeseries) {
        this.currentSliderValue = 0;
        this.previousIndex = -1;
      }
      this.collection.sensors[sensorIndex].scenesList = scenesList;
      this.collection.sensors[sensorIndex].scenes = sceneArray;
      if (sensors.siteData) {
        this.collection.siteData = sensors.siteData;
      }
    }
    this.resetFeedsStatus(this.collection);
    for (const [
      siteIndex,
      site,
    ] of this.fullCollection?.sensors[0].siteData.entries()) {
      site.checked = false;
      site.value = siteIndex + 1;
      site.siteId = site.value;
      site.disabled = this.disabledSiteCheck(site.siteId);
    }
  }

  selectSites(item: number, event: any) {
    this.subDailyCountarray = [];
    this.defaultSubdailyCount = item;
    let scenesList: any = [];
    this.collection.siteData = [];
    if (!this.isCompare || this.timeseries) {
      this.resetMapNew();
      this.removeVectorOverlay();
    }
    for (const [
      sensorIndex,
      sensors,
    ] of this.filteredCollection.sensors.entries()) {
      let sceneArray: any = [];
      for (const [sceneIndex, scenes] of sensors.scenes.entries()) {
        scenes.checked = false;
        if (scenes?.siteId == item) {
          sceneArray.push(scenes);
        }
      }
      sceneArray.forEach((element, index) => {
        element.sceneIdx = index + 1;
        if (element?.id != null && element?.status != 'failed') {
          scenesList.push({ id: element.id });
        }
      });
      this.checkForScenes(sceneArray);
      if (this.timeseries) {
        this.currentSliderValue = 0;
        this.previousIndex = -1;
      }
      this.collection.sensors[sensorIndex].scenesList = scenesList;
      this.collection.sensors[sensorIndex].scenes = sceneArray;

      if (sensors.siteData) {
        this.collection.siteData = sensors.siteData;
      }
    }

    this.resetFeedsStatus(this.collection);

    for (const [siteIndex, site] of this.collection?.siteData.entries()) {
      site.checked = false;
      site.value = siteIndex + 1;
      site.siteId = site.value;
      site.disabled = this.disabledSiteCheck(item);
    }
    for (const [siteIndex, site] of this.collection?.siteData.entries()) {
      site.checked = this.defaultSubdailyCount == siteIndex + 1;
    }

    this.subDailyCountarray = this.collection?.siteData;
    this.fullsubDailyCountarray = JSON.parse(
      JSON.stringify(this.subDailyCountarray)
    );
    let selectedSite = this.fullsubDailyCountarray.find(
      (subDaily) => subDaily.siteId == this.defaultSubdailyCount
    );
    if (
      this.isCompare &&
      this.selectedCheckboxesNew.length <= 1 &&
      this.defaultSubdailyCount != 0
    ) {
      event.checked = true;
      this.selectSiteRecurrentNew(event, selectedSite);
    }
  }

  disabledCheck(count: number) {
    let sceneArray: any = [];
    for (const [
      sensorIndex,
      sensors,
    ] of this.filteredCollection.sensors.entries()) {
      for (const [sceneIndex, scenes] of sensors.scenes.entries()) {
        scenes.checked = false;
        if (
          Number(scenes?.subDailySlot ?? scenes?.sequence ?? scenes?.sequenceNumber) === Number(count)
        ) {
          sceneArray.push(scenes);
        }
      }
    }
    if (sceneArray.length === 0) return true;
    else return false;
  }

  disabledSiteCheck(count: number) {
    let sceneArray: any = [];
    for (const [
      sensorIndex,
      sensors,
    ] of this.filteredCollection.sensors.entries()) {
      for (const [sceneIndex, scenes] of sensors.scenes.entries()) {
        if (scenes?.siteId == count) {
          sceneArray.push(scenes);
        }
      }
    }
    if (sceneArray.length === 0) return true;
    else return false;
  }

  selectSubdailyRecurrentNew(event, data, isSubdailyCheck = true) {
      if (this.selectedCheckboxesNew.length === 1 && isSubdailyCheck) 
      this.suppressSubDailyCheckbox = false;
    if (this.suppressSubDailyCheckbox) {
      data.checked = false;
      this.suppressSubDailyCheckbox = false;
      return;
    }
    this.isShowSubDailyLegend = data.checked;
    if (this.showSubDailyList == false) {
      this.removeGHGLayer();
      this.removeLayers();
      this.clearRFBandsNew();
      this.scenesNew = [];
    }
    this.showSubDailyList = true;
    if (event.checked) {
      this.selectedSubDailyItems.push(data.value)
      this.subSelectionSelectionChange.next(data.value);
      this.selectedSites.push(data.siteName);
    }
    else {
      let countIndex = this.selectedSubDailyItems.findIndex(item => parseInt(item) === parseInt(data.value));
      this.selectedSubDailyItems.splice(countIndex, 1)
      this.subSelectionSelectionChange.next(this.selectedSubDailyItems[this.selectedSubDailyItems.length - 1]);
      let siteNameIndex = this.selectedSubDailyItems.findIndex(item => (item) === (data.siteName));
      this.selectedSites.splice(siteNameIndex, 1)
    }
    if (this.selectedSubDailyItems.length > 2) {
      // If more than 2 items are selected, remove the first selected item
      this.selectedSubDailyItems.shift();
    }
    if (!data.siteName) {
      this.subDailyCount = 'Sub-daily Count : ' + this.selectedSubDailyItems[0];
      this.selectedSubdaily = 'Sub-daily Count : ' + this.selectedSubDailyItems[1];
      } else {
      this.subDailyCount = 'Site Name : ' + this.selectedSites[0];
      this.selectedSubdaily = 'Site Name : ' + this.selectedSites[1];
    }
    if (event.checked) {
      this.annotateClicked = false;
      this.newTaskButtonClicked = false;
      this.removeAnnotationMarkers();
      this.collection?.recurrencyArray?.forEach((recurrency: any, i: any) => {
        let res = recurrency?.scenes?.filter(
          (scene: any) => scene?.sequence == data.value
        );
        if (res.length == 0) {
          recurrency.disabled = true;
        } else {
          recurrency.disabled = false;
        }
      });

      if (this.selectedSubDailyItemsNew.length == 0) {
        this.mapPane = 'left';
      } else if (
        this.selectedSubDailyItemsNew[this.selectedSubDailyItemsNew.length - 1]
          ?.mapPane == 'left'
      ) {
        this.mapPane = 'right';
      } else {
        this.mapPane = 'left';
      }
      data.mapPane = this.mapPane;
      this.selectedSubDailyItemsNew.push(data);
      this.subSelectionSelectionChange.next(data.value);
      if (this.selectedSubDailyItemsNew.length > 2) {
        let countIndex = 0;
        let selectedSubDaily = JSON.parse(
          JSON.stringify(this.selectedSubDailyItemsNew[countIndex])
        );
        this.subDailyFinalArray = this.subDailyFinalArray.filter((subDaily) => {
          return subDaily.scenes[0].sequenceNumber != selectedSubDaily.value;
        });
        if (this.compare) {
          this.map.removeControl(this.compare);
          this.compare = null;
        }
        const indices: any[] = [];
        this.scenesNew.forEach((scenenew, index) => {
          if (
            Number(scenenew.scene.sequenceNumber) === selectedSubDaily.value
          ) {
            indices.push(index);
          }
        });

        indices.forEach((scenenewIndex) => {
          let ghgIndex = this.ghgLayers.findIndex(
            (ghg) => ghg.scene.id == this.scenesNew[scenenewIndex].id
          );
          if (ghgIndex != -1) {
            this.removeGHGLayerByScene(this.ghgLayers[ghgIndex]);
            this.ghgLayers.splice(ghgIndex, 1);
          }
          this.removeLayerByScene(this.scenesNew[scenenewIndex], {
            paneSpecific: true,
          });
        });

        this.selectedSubDailyItemsNew.splice(countIndex, 1);
        this.scenesNew = this.scenesNew.filter((scenenew) =>
          this.selectedSubDailyItemsNew.some(
            (selectedSubDaily) =>
              Number(scenenew.scene.sequenceNumber) === selectedSubDaily.value
          )
        );
        this.subDailyCountarray.forEach((subDailyCount) => {
          if (selectedSubDaily.value == subDailyCount.value) {
            subDailyCount.checked = false;
            this.changDetectionRef.detectChanges();
          }
        });
      }
      let scenesList: any = [];
      const filterSubDailyArray = this.filteredCollection.sensors;
      let filterArray: any = [];
      let sensor: any;
        this.mapPane;
      for (const [
        countIndex,
        count,
      ] of this.selectedSubDailyItemsNew.entries()) {
        let sceneArray: any;
        for (const [sensorIndex, sensor] of filterSubDailyArray.entries()) {
          sceneArray = this.filteredCollection.sensors[
            sensorIndex
          ].scenes.filter(
            (scene) => parseInt(scene?.sequenceNumber) === parseInt(count.value)
          );
          sceneArray.forEach((element, index) => {
            element.sensorId = sensor.id;
            element.start = sensor.start;
            element.sceneIdx = index + 1;
            element.pane = count.mapPane;
            element.start = this.selectedCheckboxesNew[0].start;
            if (element?.id != null && element?.status != 'failed') {
              scenesList.push({ id: element.id });
            }
          });
          filterArray.push({
            scenes: sceneArray,
            scenesList: scenesList,
            checked: event.checked,
            downloaded: sensor.downloaded,
            id: sensor.id,
            name: sensor.name,
            sequenceNumber: count.value,
            resolution_tooltip: sensor?.resolution_tooltip,
            downloadUrl: sensor?.downloadUrl,
            latency: sensor?.latency,
            status: sensor?.status,
            restoreStatus: sensor?.restoreStatus,
            restoreOption: sensor?.restoreOption,
            pane: count.mapPane,
            isAdditionalCSIProducts: sensor?.isAdditionalCSIProducts,
            obfuscateName: sensor?.obfuscateName,
            assetsDelivered: sensor?.assetsDelivered,
            siteData: sensor?.siteData,
          });
        }
      }
      this.subDailyFinalArray = filterArray;
      this.subDailyFinalArray[this.subDailyFinalArray.length - 1].pane =
        this.subDailyFinalArray[this.subDailyFinalArray.length - 2]?.scenes[0]?.pane == 'left'
          ? 'right'
          : 'left';
      this.subDailyFinalArray[this.subDailyFinalArray.length - 1].scenes.map(
        (scene) => {
          if (scene?.id && scene?.status !== 'failed') {
            scene.checked = true;
            scene.pane =
              this.subDailyFinalArray[this.subDailyFinalArray.length - 1]?.pane;
            if (scene?.operatorKey === this.OPERATOR.USL) {
              if (!scene?.s_band && !scene?.x_band && scene?.uslFootprint) {
                scene.x_band = scene?.uslFootprint;
              }
              this.displayRFBandNew(
                scene,
                this.collection.sensors[0].id,
                this.selectedBand
              );
            } else if (scene?.operatorKey === this.OPERATOR.LBAND) {
              this.displayRFSignalsNew(
                scene,
                this.collection.sensors[0].id,
                this.signalSelected
              );
            } else {
              if (scene?.id && scene?.status !== 'failed') {
                scene.checked = true;
                if (scene.footprint) {
                  const sensorId = scene?.sensorId;
                  const sceneId = scene?.id;
                  const action = 'sensor';
                  const taskId = this.collection?.taskId;
                  const sensorObj = {
                    sensorId: sensorId,
                    sceneId: sceneId,
                    action: action,
                    type: scene.imageType,
                  };
                  this.apiService
                    .getCollectionImage(taskId, sensorObj)
                    .subscribe((res: any) => {
                      this.DisplayPopupsBasedOnResponse(res);
                      scene.thumbnailUrl = res.result?.COGUrl
                        ? res.result?.COGUrl
                        : res.result?.imageUrl;
                      scene.start = scene?.start;
                      this.displayFootprintImageByRecurrentDataNew(
                        scene,
                        res.result,
                        sensorId,
                        this.selectedSubDailyItemsNew
                      );
                      this.spinnerService.hide();
                    });
                }
              }
            }
          }
        }
      );
      this.setLeftandRightBands(this.subDailyFinalArray);
    } else {
      this.selectedSubdaily = '';
      let removeIndex = this.subDailyFinalArray.findIndex(
        (item) => parseInt(item.sequenceNumber) === parseInt(data.value)
      );
      let selectedSubdailycount = JSON.parse(
        JSON.stringify(this.subDailyFinalArray[removeIndex])
      );
      if (this.compare) {
        this.map.removeControl(this.compare);
        this.compare = null;
      }
      this.subDailyFinalArray.splice(removeIndex, 1);
      this.selectedSubDailyItemsNew.splice(removeIndex, 1);
      if (
        this.selectedSubDailyItemsNew[this.selectedSubDailyItemsNew.length - 1]
          ?.mapPane == 'right'
      ) {
        this.mapPane = 'left';
      } else {
        this.mapPane = 'right';
      }
      this.collection?.recurrencyArray?.forEach((recurrency: any, i: any) => {
        let res = recurrency?.scenes?.filter(
          (scene: any) =>
            scene?.sequence == this.selectedSubDailyItemsNew[0]?.value
        );
        if (res.length == 0) {
          recurrency.disabled = true;
        } else {
          recurrency.disabled = false;
        }
        if (
          this.selectedSubDailyItemsNew.length == 0 &&
          recurrency?.scenes?.length > 0
        ) {
          recurrency.disabled = false;
        }
      });

      const indices: any[] = [];
      this.scenesNew.forEach((scenenew, index) => {
        if (
          Number(scenenew.scene.sequenceNumber) ==
          selectedSubdailycount.sequenceNumber
        ) {
          indices.push(index);
        }
      });
      this.scenesNew.map((scene: any, index: any) => {
        if (
          Number(scene.scene.sequenceNumber) ==
          selectedSubdailycount.sequenceNumber
        ) {
          this.clearRFBandsByScene(scene, false);
          this.removeLayerByScene(scene);
          if (scene?.leftImageLayer) {
            this.leftImageNew = null;
          }
          if (scene?.rightImageLayer) {
            this.rightImageNew = null;
          }
          this.removeAnnoatationByScene(scene);
        }
      });

      if (this.mapPane == 'right') {
        this.rightImageNew = null;
        this.mapPane = 'right';
      } else {
        this.mapPane = 'left';
        this.leftImageNew = null;
      }
      if (this.leftImageNew == null && this.rightImageNew == null) {
        this.mapPane = '';
      }

      this.scenesNew = this.scenesNew.filter((scene) => {
        return (
          scene.scene.sequenceNumber != selectedSubdailycount.sequenceNumber
        );
      });
      if (this.selectedSubDailyItemsNew.length == 0) {
        this.mapPane = 'left';
        this.rightBand = false;
        let recurrency = this.filteredCollection.recurrencyArray.filter(
          (recurrency) => {
            return recurrency.start == this.selectedCheckboxesNew[0].start;
          }
        );
        this.selectedCheckboxesNew[0].scenes = recurrency[0].scenes;
        this.showSubDailyList = false;
        let sensor = recurrency;
        sensor.checked = true;
        this.selectedCheckboxesNew[0].pane = this.mapPane;
        for (const [sceneIndex, scene] of this.selectedCheckboxesNew[
          this.selectedCheckboxesNew.length - 1
        ]?.scenes.entries()) {
          if (scene?.id && scene?.status !== 'failed') {
            scene.checked = true;
            scene.pane = this.mapPane;
            scene.start = recurrency[0].start;
            if (scene?.operatorKey == this.OPERATOR.USL) {
              if (!scene?.s_band && !scene?.x_band && scene?.usl_footprint) {
                scene.x_band = scene?.usl_footprint;
              }
              this.displayRFBandNew(
                scene,
                this.collection.sensors[0].id,
                this.selectedBand
              );
            } else {
              scene.checked = true;
              if (scene.footprint) {
                const sensorId = sensor?.id;
                const sceneId = scene?.id;
                const action = 'sensor';
                const taskId = this.collection?.taskId;
                const sensorObj = {
                  sensorId: sensorId,
                  sceneId: sceneId,
                  action: action,
                  fileType: scene.imageType,
                };
                scene.start = sensor[0].start;
                this.tifPopupShown = 0;
                this.fetchImageFromServer(this.collection, sensorObj, scene);
              }
            }
          }
        }
      } else {
        this.selectedCheckboxesNew[0].pane =
          this.selectedSubDailyItemsNew[0].mapPane;
        this.sensorsNew = this.selectedCheckboxesNew;
        this.subSelectionSelectionChange.next(
          this.selectedSubDailyItemsNew[0].value
        );
        this.setLeftandRightBands(this.subDailyFinalArray);
      }
    }
  }

  displayPromise: any;
  selectSiteRecurrentNew(event: any, data1: any) {
    let data = JSON.parse(JSON.stringify(data1));
    if (this.showSubDailyList == false) {
      this.removeGHGLayer();
      this.removeLayers();
      this.scenesNew = [];
    }
    this.showSubDailyList = true;
    if (event.checked) {
      this.annotateClicked = false;
      this.newTaskButtonClicked = false;
      this.removeAnnotationMarkers();
      this.collection?.recurrencyArray?.forEach((recurrency: any, i: any) => {
        let res = recurrency?.scenes?.filter(
          (scene: any) => scene?.siteId == data.value
        );
        if (res.length == 0) {
          recurrency.disabled = true;
        } else {
          recurrency.disabled = false;
        }
      });
      this.mapLoad = true;
      this.spinnerService.show();
      if (this.selectedSites.length == 0) {
        this.mapPane = 'left';
      } else if (
        this.selectedSites.length == 1 &&
        this.selectedCheckboxesNew.length == 1
      ) {
      } else if (
        this.selectedSites[this.selectedSites.length - 1]?.mapPane == 'left'
      ) {
        this.mapPane = 'right';
      } else {
        this.mapPane = 'left';
      }
      data.mapPane = this.mapPane;
      this.selectedSites.push({ ...data });
      this.subSelectionSelectionChange.next(data.value);
      this.spinnerService.hide();
      if (
        this.selectedSites.length > 1 &&
        this.selectedCheckboxesNew.length > 0
      ) {
        this.collection.recurrencyArray.forEach((rec) => {
          rec.checked = false;
        });
        this.selectedCheckboxesNew = [];
        this.subDailyFinalArray = [];
        this.resetMapNew();
        let checkedsite = this.subDailyCountarray.find(
          (subDailyCount) => subDailyCount.checked == true
        );
        checkedsite.mapPane = 'left';
        data.mapPane = 'right';
        this.selectedSites.push({ ...checkedsite });
        this.subDailyCountarray.forEach((site) => {
          if (site.value == data.value) {
            site.checked = true;
          }
        });
        this.selectedSites.forEach((site) => {
          if (site.value == data.value) {
            site.checked = true;
          }
        });
        this.filteredCollection = this.fullCollection;
        let scenesList: any = [];
        const filterSubDailyArray = this.filteredCollection.sensors;
        let filterArray: any = [];
        // this.selectSites(selectedSite.value, event)
        for (const [countIndex, count] of this.selectedSites.entries()) {
          let sceneArray: any;
          for (const [sensorIndex, sensor] of filterSubDailyArray.entries()) {
            sceneArray = sensor.scenes.filter(
              (scene) => parseInt(scene?.siteId) === parseInt(count.value)
            );
            sceneArray.forEach((element, index) => {
              element.sceneIdx = index + 1;
              element.start = this.selectedValue.start;
              if (element?.id != null && element?.status != 'failed') {
                element.checked = true;
                scenesList.push({ id: element.id });
              }
            });

            filterArray.push({
              scenes: sceneArray,
              scenesList: scenesList,
              checked: event.checked,
              downloaded: sensor.downloaded,
              id: sensor.id,
              name: sensor.name,
              sequenceNumber: count.value,
              resolution_tooltip: sensor?.resolution_tooltip,
              downloadUrl: sensor?.downloadUrl,
              latency: sensor?.latency,
              status: sensor?.status,
              restoreStatus: sensor?.restoreStatus,
              restoreOption: sensor?.restoreOption,
              isAdditionalCSIProducts: sensor?.isAdditionalCSIProducts,
              obfuscateName: sensor?.obfuscateName,
              assetsDelivered: sensor?.assetsDelivered,
              tnqSensorType: sensor?.tnqSensorType,
              siteData: sensor?.siteData,
            });
          }
        }
        this.subDailyFinalArray = filterArray;
        const displayPromises = this.subDailyFinalArray[
          this.subDailyFinalArray.length - 1
        ].scenes
          .map((scene) => {
            if (scene?.id && scene?.status !== 'failed') {
              scene.checked = true;
              scene.imageType = 'png';
              this.imageType = this.checkType();
              scene.tif = false;
              if (scene.footprint) {
                const sensorId =
                  this.subDailyFinalArray[this.subDailyFinalArray.length - 1]
                    ?.id;
                const sceneId = scene?.id;
                const action = 'sensor';
                const taskId = this.collection?.taskId;
                const sensorObj = {
                  sensorId: sensorId,
                  sceneId: sceneId,
                  action: action,
                  type: scene.imageType,
                };

                return new Promise((resolve) => {
                  this.apiService
                    .getCollectionImage(taskId, sensorObj)
                    .subscribe((res: any) => {
                      this.mapLoad = false;
                      this.spinnerService.hide();
                      scene.thumbnailUrl = res.result?.COGUrl
                        ? res.result?.COGUrl
                        : res.result?.imageUrl;
                      if (
                        this.scenesNew.findIndex(
                          (sceneNew) => sceneNew.id == scene.id
                        ) == -1
                      ) {
                        this.mapPane = 'left';
                        this.displayFootprintImageByRecurrentDataNew(
                          scene,
                          res.result,
                          sensorId,
                          this.selectedSites
                        );
                        resolve(true);
                      } else {
                        resolve(false);
                      }
                    });
                });
              }
            }
            return null;
          })
          .filter((promise) => promise !== null);
        Promise.all(displayPromises).then(() => {
          this.selectedSites.push({ ...data });
          this.subDailyCountarray.forEach((site) => {
            if (site.value == data.value) {
              site.checked = true;
            }
          });
          this.selectedSites.forEach((site) => {
            if (site.value == data.value) {
              site.checked = true;
            }
          });
          this.filteredCollection = this.fullCollection;
          scenesList = [];
          filterArray = [];
          for (const [countIndex, count] of this.selectedSites.entries()) {
            let sceneArray: any;
            for (const [sensorIndex, sensor] of filterSubDailyArray.entries()) {
              sceneArray = sensor.scenes.filter(
                (scene) => parseInt(scene?.siteId) === parseInt(count.value)
              );
              sceneArray.forEach((element, index) => {
                element.sceneIdx = index + 1;
                element.start = this.selectedValue.start;
                if (element?.id != null && element?.status != 'failed') {
                  element.checked = true;
                  scenesList.push({ id: element.id });
                }
              });
              filterArray.push({
                scenes: sceneArray,
                scenesList: scenesList,
                checked: event.checked,
                downloaded: sensor.downloaded,
                id: sensor.id,
                name: sensor.name,
                sequenceNumber: count.value,
                resolution_tooltip: sensor?.resolution_tooltip,
                downloadUrl: sensor?.downloadUrl,
                latency: sensor?.latency,
                status: sensor?.status,
                restoreStatus: sensor?.restoreStatus,
                restoreOption: sensor?.restoreOption,
                isAdditionalCSIProducts: sensor?.isAdditionalCSIProducts,
                obfuscateName: sensor?.obfuscateName,
                assetsDelivered: sensor?.assetsDelivered,
                siteData: sensor?.siteData,
              });
            }
          }
          this.subDailyFinalArray = filterArray;
          this.subDailyFinalArray[
            this.subDailyFinalArray.length - 1
          ].scenes.map((scene) => {
            if (scene?.id && scene?.status !== 'failed') {
              scene.checked = true;
              if (scene.footprint) {
                this.imageType = this.checkType();
                scene.imageType = 'png';
                scene.tif = false;
                const sensorId =
                  this.subDailyFinalArray[this.subDailyFinalArray.length - 1]
                    ?.id;
                const sceneId = scene?.id;
                const action = 'sensor';
                const taskId = this.collection?.taskId;
                const sensorObj = {
                  sensorId: sensorId,
                  sceneId: sceneId,
                  action: action,
                  type: this.imageType,
                };
                this.apiService
                  .getCollectionImage(taskId, sensorObj)
                  .subscribe((res: any) => {
                    this.mapLoad = false;
                    this.spinnerService.hide();
                    this.DisplayPopupsBasedOnResponse(res);
                    scene.thumbnailUrl = res.result?.COGUrl
                      ? res.result?.COGUrl
                      : res.result?.imageUrl;
                    if (
                      this.scenesNew.findIndex(
                        (sceneNew) => sceneNew.id == scene.id
                      ) == -1
                    ) {
                      this.mapPane = 'right';
                      this.spinnerService.hide();
                      this.displayFootprintImageByRecurrentDataNew(
                        scene,
                        res.result,
                        sensorId,
                        this.selectedSites
                      );
                    }
                  });
              }
            }
          });
          this.leftData = this.selectedSites.filter(
            (site) => site.mapPane == 'left'
          );
          this.rightData = this.selectedSites.filter(
            (site) => site.mapPane == 'right'
          );
        });
      } else {
        if (this.selectedSites.length > 2) {
          let countIndex = 0;
          let site = JSON.parse(JSON.stringify(this.selectedSites[countIndex]));
          this.subDailyFinalArray = this.subDailyFinalArray.filter(
            (subDaily) => {
              return subDaily.scenes[0].siteId != site.value;
            }
          );
          if (this.compare) {
            this.map.removeControl(this.compare);
            this.compare = null;
          }
          this.scenesNew.map((scene: any, index: any) => {
            if (scene.scene.siteId == site.value) {
              this.removeLayerByScene(scene, { paneSpecific: true });
              let ghgIndex = this.ghgLayers.findIndex(
                (ghg) => ghg.scene.id == scene.id
              );
              if (ghgIndex != -1) {
                this.removeGHGLayerByScene(this.ghgLayers[ghgIndex]);
                this.ghgLayers.splice(ghgIndex, 1);
              }
            }
          });
          this.scenesNew = this.scenesNew.filter((scene) => {
            return scene.scene.siteId != site.value;
          });
          this.selectedSites.splice(countIndex, 1);
          this.subDailyCountarray.forEach((subDailyCount) => {
            if (site.value == subDailyCount.value) {
              subDailyCount.checked = false;
              this.changDetectionRef.detectChanges();
            }
          });
        }
        let scenesList: any = [];
        const filterSubDailyArray = this.fullCollection.sensors;
        let filterArray: any = [];
        let recurrency = this.filteredCollection.recurrencyArray.filter(
          (recurrency1) => {
            return recurrency1.start == this.selectedCheckboxesNew[0]?.start;
          }
        );
        this.subDailyCountarray.forEach((site) => {
          if (site.value == data.value) {
            site.checked = true;
            this.changDetectionRef.detectChanges();
          }
        });
        this.defaultSubdailyCount =
          this.selectedSites[this.selectedSites.length - 1].value;
        for (const [countIndex, count] of this.selectedSites.entries()) {
          let sceneArray: any;
          for (const [sensorIndex, sensor] of filterSubDailyArray.entries()) {
            if (this.selectedCheckboxesNew.length > 0) {
              sceneArray = recurrency[0].scenes.filter(
                (scene) => parseInt(scene?.siteId) === parseInt(count.value)
              );
            } else {
              sceneArray = sensor.scenes.filter(
                (scene) => parseInt(scene?.siteId) === parseInt(count.value)
              );
            }
            sceneArray.forEach((element, index) => {
              element.sceneIdx = index + 1;
              element.start = this.selectedValue.start;
              if (element?.id != null && element?.status != 'failed') {
                scenesList.push({ id: element.id });
              }
            });
            filterArray.push({
              scenes: sceneArray,
              scenesList: scenesList,
              checked: event.checked,
              downloaded: sensor.downloaded,
              id: sensor.id,
              name: sensor.name,
              sequenceNumber: count.value,
              resolution_tooltip: sensor?.resolution_tooltip,
              downloadUrl: sensor?.downloadUrl,
              latency: sensor?.latency,
              status: sensor?.status,
              restoreStatus: sensor?.restoreStatus,
              restoreOption: sensor?.restoreOption,
              isAdditionalCSIProducts: sensor?.isAdditionalCSIProducts,
              obfuscateName: sensor?.obfuscateName,
              assetsDelivered: sensor?.assetsDelivered,
              siteData: sensor?.siteData,
            });
          }
        }
        this.subDailyFinalArray = filterArray;
        this.collection?.recurrencyArray?.forEach((recurrency: any, i: any) => {
          let res = recurrency?.scenes?.filter(
            (scene: any) => scene?.siteId == this.selectedSites[0]?.value
          );

          if (res.length == 0) {
            recurrency.disabled = true;
          } else {
            recurrency.disabled = false;
          }

          if (
            this.selectedSites.length == 0 &&
            recurrency?.scenes?.length > 0
          ) {
            recurrency.disabled = false;
          }
        });
        this.subDailyFinalArray[this.subDailyFinalArray.length - 1].scenes.map(
          (scene) => {
            if (scene?.id && scene?.status !== 'failed') {
              scene.checked = true;
              if (scene.footprint) {
                this.imageType = this.checkType();
                scene.imageType = 'png';
                scene.tif = false;
                const sensorId =
                  this.subDailyFinalArray[this.subDailyFinalArray.length - 1]
                    ?.id;
                const sceneId = scene?.id;
                const action = 'sensor';
                const taskId = this.collection?.taskId;
                const sensorObj = {
                  sensorId: sensorId,
                  sceneId: sceneId,
                  action: action,
                  type: this.imageType,
                };
                this.apiService
                  .getCollectionImage(taskId, sensorObj)
                  .subscribe((res: any) => {
                    this.mapLoad = false;
                    this.spinnerService.hide();
                    this.DisplayPopupsBasedOnResponse(res);
                    scene.thumbnailUrl = res.result?.COGUrl
                      ? res.result?.COGUrl
                      : res.result?.imageUrl;
                    if (
                      this.scenesNew.findIndex(
                        (sceneNew) => sceneNew.id == scene.id
                      ) == -1
                    ) {
                      this.spinnerService.hide();
                      this.displayFootprintImageByRecurrentDataNew(
                        scene,
                        res.result,
                        sensorId,
                        this.selectedSites
                      );
                    }
                  });
              }
            }
          }
        );
        this.leftData = this.selectedSites.filter(
          (site) => site.mapPane == 'left'
        );
        this.rightData = this.selectedSites.filter(
          (site) => site.mapPane == 'right'
        );
      }
    } else {
      data.checked = false;
      let countIndex = this.selectedSites.findIndex(
        (item) => parseInt(item.value) === parseInt(data.value)
      );
      let site = this.selectedSites[countIndex];
      this.subDailyFinalArray = this.subDailyFinalArray.filter((subDaily) => {
        return subDaily.scenes[0].siteId != site.value;
      });

      if (this.compare) {
        this.map.removeControl(this.compare);
        this.compare = null;
        if (this.selectedSites.length > 0) this.filterSiteData = [];
      }
      this.scenesNew.forEach((scenenew) => {
        if (scenenew.scene.siteId == site.value) {
          let ghgIndex = this.ghgLayers.findIndex(
            (ghg) => ghg.scene.id == scenenew.id
          );
          if (ghgIndex != -1) {
            this.removeGHGLayerByScene(this.ghgLayers[ghgIndex]);
            this.ghgLayers.splice(ghgIndex, 1);
          }
          this.removeLayerByScene(scenenew, { paneSpecific: true });
        }
      });
      this.scenesNew = this.scenesNew.filter((scene: any) => {
        return scene.scene?.siteId != site.value;
      });
      this.selectedSites.splice(countIndex, 1);
      if (this.selectedSites.length == 0) {
        this.toggleDailyRecurrency(event);
      } else {
        if (this.selectedSites.length > 0) {
          this.defaultSubdailyCount = this.selectedSites[0].value;
          if (this.selectedCheckboxesNew.length > 0) {
            this.selectedCheckboxesNew[0].pane =
              this.selectedSites[this.selectedSites.length - 1].mapPane;
          }
          this.selectedSite = this.subDailyCountarray.filter(
            (subDailyCount) => {
              return subDailyCount.value == this.selectedSites[0].value;
            }
          )[0].value;
        }
        this.collection?.recurrencyArray?.forEach((recurrency: any, i: any) => {
          let res = recurrency?.scenes?.filter(
            (scene: any) => scene?.siteId == this.selectedSites[0]?.value
          );
          if (res.length == 0) {
            recurrency.disabled = true;
          } else {
            recurrency.disabled = false;
          }
          if (
            this.selectedSites.length == 0 &&
            recurrency?.scenes?.length > 0
          ) {
            recurrency.disabled = false;
          }
        });
      }
    }
  }

  compareOpportunityNew(
    collectionIndex: any,
    opportunityIndex: any,
    event: any,
    type: any,
    task: any
  ) {
    this.toggleRecurrentDatesNew(
      collectionIndex,
      opportunityIndex,
      event,
      type,
      task
    );
  }

  toggleSubDailyRecurrentSensorNew(sensorIndex: any, sensor: any, event: any) {
    if (event.checked == false) {
       this.selectedSubdaily = '';
       this.isShowSubDailyLegend = false;
      if (this.selectedSubDailyItemsNew.length > 0) {
        let selectedSensor = JSON.parse(
          JSON.stringify(this.subDailyFinalArray[sensorIndex])
        );
        this.subDailyCountarray.map((subdaily) => {
          if (subdaily.value == selectedSensor.scenes[0]?.sequenceNumber) {
            subdaily.checked = false;
          }
        });
        let countIndex = this.selectedSubDailyItemsNew.findIndex(
          (item) =>
            parseInt(item.value) ===
            parseInt(selectedSensor.scenes[0].sequenceNumber)
        );
        let selectedsubdaily = this.selectedSubDailyItemsNew[countIndex];
        this.subDailyFinalArray = this.subDailyFinalArray.filter((subDaily) => {
          return subDaily.scenes[0].sequenceNumber != selectedsubdaily.value;
        });
        let scenenewIndex: any = this.scenesNew.findIndex(
          (scenenew) => scenenew.scene.sequenceNumber == selectedsubdaily.value
        );
        if (this.subDailyFinalArray.length == 0) {
          this.showDailyRecurrencyCheckboxes = false;
          this.toggleDailyRecurrency(event);
        }
        this.changDetectionRef.detectChanges();
        if (this.compare) {
          this.map.removeControl(this.compare);
          this.compare = null;
        }
        this.scenesNew.map((scene: any, index: any) => {
          if (scene.scene.sequenceNumber == selectedsubdaily.value) {
            this.clearRFBandsByScene(scene, false);
            this.removeLayerByScene(scene, { paneSpecific: true });
            this.clearRFSignalsByScene(scene);
            this.removeAnnoatationByScene(scene);
          }
        });

        this.selectedSubDailyItemsNew.splice(sensorIndex, 1);
        this.scenesNew = this.scenesNew.filter((scene) => {
          return scene.scene.sequenceNumber != selectedsubdaily.value;
        });

        this.collection?.recurrencyArray?.forEach((recurrency: any, i: any) => {
          let res = recurrency?.scenes?.filter(
            (scene: any) =>
              scene?.sequence == this.selectedSubDailyItemsNew[0]?.value
          );
          if (res.length == 0) {
            recurrency.disabled = true;
          } else {
            recurrency.disabled = false;
          }
          if (
            this.selectedSubDailyItemsNew.length == 0 &&
            recurrency?.scenes?.length > 0
          ) {
            recurrency.disabled = false;
          }
        });

        if (this.selectedSubDailyItemsNew.length == 0) {
          this.mapPane = '';
          let recurrency = this.filteredCollection.recurrencyArray.filter(
            (recurrency) => {
              return recurrency.start == this.selectedCheckboxesNew[0].start;
            }
          );
          this.selectedCheckboxesNew[0].pane = 'left';
          this.selectedCheckboxesNew[0].scenes = recurrency[0].scenes;
          this.showSubDailyList = false;
          let sensor = recurrency;
          sensor.checked = true;
          this.rightBand = false;
          for (const [sceneIndex, scene] of this.selectedCheckboxesNew[
            this.selectedCheckboxesNew.length - 1
          ]?.scenes.entries()) {
            if (
              scene?.id &&
              scene?.status !== 'failed' &&
              (scene?.operatorKey == this.OPERATOR.USL ||
                scene?.operatorKey == this.OPERATOR.LBAND)
            ) {
              scene.checked = true;
              scene.start = sensor[0].start;
              scene.pane = 'left';
              if (scene?.operatorKey == this.OPERATOR.USL) {
                if (!scene?.s_band && !scene?.x_band && scene?.usl_footprint) {
                  scene.x_band = scene?.usl_footprint;
                }
                this.displayRFBandNew(
                  scene,
                  this.collection.sensors[0].id,
                  this.selectedBand
                );
              } else {
                this.displayRFSignalsNew(
                  scene,
                  this.collection.sensors[0].id,
                  this.signalSelected
                );
              }
            } else {
              if (scene?.id && scene?.status !== 'failed') {
                scene.checked = true;
                if (scene.footprint) {
                  const sensorId = this.collection.sensors[0]?.id;
                  const sceneId = scene?.id;
                  const action = 'sensor';
                  const taskId = this.collection?.taskId;
                  const sensorObj = {
                    sensorId: sensorId,
                    sceneId: sceneId,
                    action: action,
                    fileType: scene.imageType,
                  };
                  scene.start = sensor[0].start;
                  this.tifPopupShown = 0;
                  this.fetchImageFromServer(this.collection, sensorObj, scene);
                }
              }
            }
          }
        } else {
          this.selectedCheckboxesNew[0].pane =
            this.selectedSubDailyItemsNew[0].mapPane;
          this.sensorsNew = this.selectedCheckboxesNew;
          this.subSelectionSelectionChange.next(
            this.selectedSubDailyItemsNew[0].value
          );
          this.leftBand =
            this.subDailyFinalArray.filter(
              (subDailyFinal) => subDailyFinal.pane == 'left'
            ).length > 0;
          this.rightBand =
            this.subDailyFinalArray.filter(
              (subDailyFinal) => subDailyFinal.pane == 'right'
            ).length > 0;
        }
      } else {
        let selectedSensor = JSON.parse(
          JSON.stringify(this.subDailyFinalArray[sensorIndex])
        );
        if (this.selectedSites.length == 2) {
          this.subDailyCountarray.map((subdaily) => {
            if (subdaily.value == selectedSensor.scenes[0].siteId) {
              subdaily.checked = false;
            }
          });
          let countIndex = this.selectedSites.findIndex(
            (item) =>
              parseInt(item.value) === parseInt(selectedSensor.scenes[0].siteId)
          );
          let site = this.selectedSites[countIndex];
          this.subDailyFinalArray = this.subDailyFinalArray.filter(
            (subDaily) => {
              return subDaily.scenes[0].siteId != site.value;
            }
          );
          if (this.compare) {
            this.map.removeControl(this.compare);
            this.compare = null;
          }
          this.scenesNew.forEach((scenenew) => {
            if (scenenew.scene.siteId == site.value) {
              this.removeAnnoatationByScene(scenenew);
              let ghgIndex = this.ghgLayers.findIndex(
                (ghg) => ghg.scene.id == scenenew.id
              );
              if (ghgIndex != -1) {
                this.removeGHGLayerByScene(this.ghgLayers[ghgIndex]);
                this.ghgLayers.splice(ghgIndex, 1);
              }
              this.removeLayerByScene(scenenew, { paneSpecific: true });
            }
          });
          this.scenesNew = this.scenesNew.filter((scene: any) => {
            return scene.scene?.siteId != site.value;
          });
          this.selectedSites.splice(countIndex, 1);
          if (this.selectedSites.length > 0) {
            if (this.selectedCheckboxesNew.length > 0) {
              this.selectedCheckboxesNew[0].pane =
                this.selectedSites[this.selectedSites.length - 1].mapPane;
            }
            this.selectedSite = this.subDailyCountarray.filter(
              (subDailyCount) => {
                return subDailyCount.value == this.selectedSites[0]?.value;
              }
            )[0].value;
            this.collection?.recurrencyArray?.forEach(
              (recurrency: any, i: any) => {
                let res = recurrency?.scenes?.filter(
                  (scene: any) => scene?.siteId == this.selectedSites[0]?.value
                );
                if (res.length == 0) {
                  recurrency.disabled = true;
                } else {
                  recurrency.disabled = false;
                }
              }
            );
          }
        } else {
          if (this.selectedCheckboxesNew.length == 0) {
            this.toggleDailyRecurrency(event);
          } else {
            this.subDailyFinalArray = this.subDailyFinalArray.filter(
              (subDaily) => {
                return subDaily.start != selectedSensor.start;
              }
            );
            this.collection?.recurrencyArray?.forEach(
              (recurrency: any, i: any) => {
                if (recurrency.start == selectedSensor.start) {
                  recurrency.checked = false;
                }
              }
            );

            if (this.subDailyFinalArray.length > 0) {
              this.selectedValue = this.collection.recurrencyArray.filter(
                (recurrency) => {
                  return recurrency.start == this.subDailyFinalArray[0].start;
                }
              )[0];
            } else {
              this.collection?.recurrencyArray?.forEach(
                (recurrency: any, i: any) => {
                  if (recurrency.start == this.selectedCheckboxesNew[0].start) {
                    this.selectedValue = recurrency;
                  }
                }
              );
            }

            this.selectedCheckboxesNew = this.subDailyFinalArray;
            if (this.compare) {
              this.map.removeControl(this.compare);
              this.compare = null;
            }
            let scenenewIndex: any = this.scenesNew.findIndex(
              (scenenew) => scenenew.scene.start == selectedSensor.start
            );
            if (scenenewIndex != -1) {
              this.removeAnnoatationByScene(this.scenesNew[scenenewIndex]);
              let ghgIndex = this.ghgLayers.findIndex(
                (ghg) => ghg.scene.id == this.scenesNew[scenenewIndex].id
              );
              if (ghgIndex != -1) {
                this.removeGHGLayerByScene(this.ghgLayers[ghgIndex]);
              }
              this.removeLayerByScene(this.scenesNew[scenenewIndex], {
                paneSpecific: true,
              });
              this.removeAnnoatationByScene(this.scenesNew[scenenewIndex]);
              this.ghgLayers.splice(ghgIndex, 1);
              this.scenesNew.splice(scenenewIndex, 1);
            }
            if (this.selectedCheckboxesNew.length == 0) {
              this.collection.recurrencyArray.forEach((recurrency) => {
                recurrency.checked = false;
              });
              this.defaultSubdailyCount = this.selectedSites[0]?.siteId;
              this.resetMapNew();
              this.filteredCollection = this.fullCollection;
              this.subDailyFinalArray = [];
              this.selectSites(this.defaultSubdailyCount, event);
            }
          }
        }
      }
      this.changDetectionRef.detectChanges();
    }
  }

  downloadProgress(progress: any) {
    if (
      progress?.sensorId != undefined &&
      !progress?.product &&
      !progress?.type
    ) {
      const sensor = this.fullCollection?.sensors?.find(
        (sensor) => sensor.id === progress?.sensorId
      );
      if (sensor?.scenes) {
        progress.sceneId = sensor.scenes
          .filter((scene) => scene.id !== '')
          .map((scene) => scene.id);
      }
    }
    let sensorObj = {
      taskId: progress.taskId,
      sensorId: progress?.sensorId,
      sceneId: progress?.sceneId,
      product: progress?.product,
      type: progress?.type,
    };
    if (progress?.type) {
      sensorObj.sceneId = [progress?.sceneId];
    }

    if (
      progress?.downloadClick &&
      progress.progress > 0 &&
      progress.progress < 100
    ) {
      this.freeze = true;
      this.spinnerService.show();
    } else if (
      progress?.downloadClick &&
      progress.progress >= 100 &&
      progress?.action != 'aisDownload' &&
      progress?.action != 'observation'
    ) {
      localStorage.setItem('scene-downloaded', progress?.sceneId);
      if (progress?.sensorId != undefined && !progress?.product) {
        localStorage.setItem('sensor-downloaded', progress?.sensorId);
      }
      if (!progress?.product) {
        if (this.ecursSensorObject) {
          this.downloadedScene = this.downloadedScene.concat(
            this.ecursSensorObject?.sceneIds
          );
        } else {
          this.downloadedScene = this.downloadedScene.concat(progress?.sceneId);
        }
        // this.downloadedSensor.push(localStorage.getItem('sensor-downloaded'));
      }

      this.freeze = false;
      this.downloadClick = false;
      this.spinnerService.hide();

      if (progress?.action === 'aisDownload') return;

      if (this.ecursSensorObject) {
        sensorObj = {
          taskId: progress.taskId,
          sensorId: progress?.sensorId,
          sceneId: this.ecursSensorObject?.sceneIds,
          product: progress?.product,
          type: '',
        };
      }
      this.apiService
        .updateCollectionDownload(sensorObj)
        .subscribe(async (res: any) => {
          if(res.msg === 'Success' && res.downloaded === true){
            this.setDownloadedStatusForSensors(sensorObj, progress.taskId);
          }
          if (res.msg === 'Success' && progress?.product) {
            switch (progress?.product) {
              case 'CWSI':
              case 'MBSI':
              case 'NDVI':
              case 'NCCI':
              case 'OSI':
              case 'NDTI':
              case 'NDRE':
              case 'NDMI':
              case 'TVDI':
                this.setDownloadedIndices();
                break;
              case 'sarColorisation':
                // Not a VADP row; mark the colorisation item downloaded for checkDownloaded()
                this.downloadedScene = this.downloadedScene.concat(progress?.sceneId);
                break;
              default:
                this.setDownloadedVADP();
                break;
            }
          }
        });
    }
  }

  setDownloadedVADP() {
    this.collections[this.currentDownloadingVADP.collectionIndex].sensors[
      this.currentDownloadingVADP.sensorIndex
    ].valueAddedOption.forEach((row) => {
      if (row.product == this.currentDownloadingVADP.product) {
        row.isDownloaded = true;
      }
    });
    this.currentDownloadingVADP = {};
  }
  fullsubDailyCountarray: any[] = [];
  toggleDailyRecurrency(event: any) {
    this.feasibilityArray = [];
    for (const opportunity of this.collection.opportunityList) {
      opportunity.checked = false;
    }
    this.signalSelected = 'All';
    this.selectedBand = 'all';
    this.isSitechanged = false;
    this.selectedSensors = [];
    this.recurrencyArray = [];
    this.selectedCheckboxes = [];
    this.selectedCheckboxesNew = [];
    this.subDailyFinalArray = [];
    this.subDailyArray = [];
    this.selectedSubDailyItems = [];
    this.selectedSubDailyItemsNew = [];
    this.selectedSites = [];
    this.isVisible = false;
    this.showSubDailyList = false;
    this.annotateClicked = false;
    this.newTaskButtonClicked = false;
    this.resetMapNew();
    this.sensors = [];
    this.scenes = [];
    this.scnLyr = [];
    this.scnLyr2 = [];
    this.feedInfo = false;
    this.oilSpil = false;
    this.imageType = this.checkType();
    this.leftFeedPanels.clear();
    this.rightFeedPanels.clear();
    this.needsCompareResetToCenter = true;

    this.removeDynamicLayer();

    this.collection.sensors.forEach((sensor, index) => {
      sensor.checked = false;
      sensor.scenes.forEach((scene) => {
        scene.checked = false;
      });
    });
    this.resetFeedsStatus(this.collection);
    this.collection?.recurrencyArray.forEach((recurrency) => {
      recurrency.checked = false;
    });
    this.leftBand = false;
    this.rightBand = false;
    this.leftData = [];
    this.rightData = [];
    this.resetAllFeedPanels();
    if (event.checked) {
      this.mapPane = '';
      this.isCompare = true;
      this.isCompareRecurrency = true;
      this.isCompareClicked = true;
      this.showDailyRecurrencyCheckboxes = true;
      if (
        this.selectedStartDate &&
        this.collection.sensors[0].operatorKey != OPERATORS.GHG
      ) {
      } else {
        this.fullsubDailyCountarray = JSON.parse(
          JSON.stringify(this.subDailyCountarray)
        );
        this.collection.recurrencyArray.map((recurrency, index) => {
          if (this.selectedValue && this.selectedValue.start == recurrency.start) {
            recurrency.checked = false;
            this.subDailyCountarray.forEach((subDailyCount) => {
              if (subDailyCount.siteId == this.defaultSubdailyCount) {
                subDailyCount.checked = false;
                this.selectedSite = subDailyCount.value;
              } else {
                subDailyCount.checked = false;
              }
            });
          }
        });
      }
    } else {
      this.showDailyRecurrencyCheckboxes = false;
      this.mapPane = '';
      this.isCompare = false;
      this.isCompareRecurrency = false;
      this.isCompareClicked = false;
      this.RF = false;
      this.defaultSubdailyCount = 1;
      this.metric = 'kg';
      if (this.taskSelected) {
        this.collections = [];
        this.getCollections(
          this.previousSelectedProject?.projectid
            ? this.previousSelectedProject?.projectid
            : this.projectSelected,
          this.collectionIndex
        );
        this.selectionChange.next(this.collection.recurrencyArray[0]);
      } else {
        this.collections = [];
        this.getCollections(
          this.previousSelectedProject?.projectid
            ? this.previousSelectedProject?.projectid
            : this.projectSelected,
          0
        );
        this.selectionChange.next(this.collection.recurrencyArray[0]);
      }
      this.filterSiteData = [];
      this.filterDateData = [];
    }
  }

  countSelectedOptions(): number {
    return this.collection.recurrencyArray.filter((item) => item.checked)
      .length;
  }

  exceedsSelectionLimit(): boolean {
    return this.countSelectedOptions() >= this.maxSelections;
  }

  async fetchAndCombineGeoJson(
    urls: string[],
    info: any,
    sensor?: any,
    options?: {
      isCompare?: boolean;
      pane?: 'left' | 'right';
      cacheHistory?: any;
    }
  ): Promise<void> {
    const requestScope = this.getPngGeoJsonRequestScope(info, options);
    const request = this.beginPngGeoJsonLoad(requestScope);
    if (!urls?.length) {
      this.finishPngGeoJsonLoad(request);
      return;
    }
    this.spinnerService.show();
    this.mapLoad = true;
    // FOR TESTING: Uncomment below to use local test asset instead of backend URLs
    // const geoJsonRequests = [this.httpClient.get('assets/lulc.geojson')];
    try {
      const geoJsonDataArray: any[] = await Promise.all(
        urls.map((url) => this.loadPngGeoJsonUrl(url, request))
      );
      if (
        options?.isCompare &&
        options?.cacheHistory &&
        !this.isActiveChangeDetectionHistorySelection(
          options.cacheHistory,
          options.pane
        )
      ) {
        return;
      }
      const combinedGeoJson = this.combineGeoJsonFeatures(geoJsonDataArray);
      if (options?.cacheHistory) {
        combinedGeoJson.feed_results = this.getChangeDetectionHistoryFeedResults(
          options.cacheHistory,
          combinedGeoJson,
          combinedGeoJson?.features?.length ?? 0
        );
        this.cacheChangeDetectionHistoryInsight(
          options.cacheHistory,
          combinedGeoJson
        );
      }
      const displayInfo = options?.cacheHistory
        ? this.getChangeDetectionHistoryScopedFeed(
            info,
            options.cacheHistory,
            combinedGeoJson
          )
        : info;
      if (options?.cacheHistory) {
        this.addChangeDetectionHistoryCompareFeedPanel(
          displayInfo,
          sensor,
          feedsConfig[displayInfo?._id],
          combinedGeoJson?.feed_results,
          options.pane,
          !!options.isCompare
        );
      }
      this.displayISNew(
        {
          insightFootprint: combinedGeoJson,
          isInfo: displayInfo,
          sensor: sensor,
          _changeDetectionHistoryFeedResults:
            displayInfo?._changeDetectionHistoryFeedResults,
        },
        displayInfo,
        sensor,
        !!options?.isCompare,
        options?.pane
      );
      this.displayedIS = {
        insightFootprint: JSON.parse(JSON.stringify(combinedGeoJson)),
        isInfo: displayInfo,
      };
    } catch (error: any) {
      if (error?.name !== 'EmptyError') {
        this.hideMapLoaderWhenPngGeoJsonIdle();
      }
    } finally {
      this.finishPngGeoJsonLoad(request);
      this.opManager.completeOperation();
    }
  }

  private getPngGeoJsonRequestScope(
    info: any,
    options?: {
      isCompare?: boolean;
      pane?: 'left' | 'right';
      cacheHistory?: any;
    }
  ): string {
    const feedKey = String(info?._id ?? info?.isInfo?._id ?? info?.name ?? '');
    const historyKey = String(
      options?.cacheHistory?.refreshId ??
        options?.cacheHistory?.id ??
        options?.cacheHistory?._id ??
        ''
    );
    const paneKey = options?.isCompare ? options?.pane ?? 'compare' : 'map';
    return [paneKey, feedKey, historyKey].join('|');
  }

  private beginPngGeoJsonLoad(scope: string): {
    id: number;
    scope: string;
    cancel$: Subject<void>;
  } {
    const existingCancel = this.pngGeoJsonCancelByScope.get(scope);
    if (existingCancel) {
      existingCancel.next();
      existingCancel.complete();
    }

    const cancel$ = new Subject<void>();
    this.pngGeoJsonCancelByScope.set(scope, cancel$);
    const requestId = ++this.pngGeoJsonLoadSeq;
    this.activePngGeoJsonLoadIds.add(requestId);
    this.spinnerService.show();
    this.mapLoad = true;
    return { id: requestId, scope, cancel$ };
  }

  private finishPngGeoJsonLoad(request: {
    id: number;
    scope: string;
    cancel$: Subject<void>;
  }): void {
    this.activePngGeoJsonLoadIds.delete(request.id);
    if (!request.cancel$.closed) {
      request.cancel$.complete();
    }
    if (this.pngGeoJsonCancelByScope.get(request.scope) === request.cancel$) {
      this.pngGeoJsonCancelByScope.delete(request.scope);
    }
    if (this.activePngGeoJsonLoadIds.size === 0) {
      this.spinnerService.hide();
      this.mapLoad = false;
    }
  }

  private loadPngGeoJsonUrl(
    url: string,
    request: {
      id: number;
      cancel$: Subject<void>;
    }
  ): Promise<any> {
    const requestKey = this.getPngGeoJsonUrlKey(url);
    let inFlight = this.pngGeoJsonRequestByUrl.get(requestKey);

    if (!inFlight) {
      const cancel$ = new Subject<void>();
      const promise = firstValueFrom(
        this.httpClient
          .get(url)
          .pipe(takeUntil(cancel$), takeUntil(this.destroy$))
      ).finally(() => {
        this.pngGeoJsonRequestByUrl.delete(requestKey);
      });

      inFlight = {
        cancel$,
        consumers: new Set<number>(),
        promise,
      };
      this.pngGeoJsonRequestByUrl.set(requestKey, inFlight);
    }

    inFlight.consumers.add(request.id);

    return Promise.race([
      inFlight.promise,
      this.cancelPromise(request.cancel$),
    ]).finally(() => {
      inFlight!.consumers.delete(request.id);
      if (inFlight!.consumers.size === 0 && this.pngGeoJsonRequestByUrl.get(requestKey) === inFlight) {
        inFlight!.cancel$.next();
        inFlight!.cancel$.complete();
      }
    });
  }

  private getPngGeoJsonUrlKey(url: string): string {
    try {
      const parsedUrl = new URL(url);
      return `${parsedUrl.origin}${parsedUrl.pathname}`;
    } catch {
      return url.split('?')[0];
    }
  }

  private cancelPromise(cancel$: Subject<void>): Promise<never> {
    return new Promise((_, reject) => {
      const subscription = cancel$.subscribe(() => {
        subscription.unsubscribe();
        reject({ name: 'EmptyError' });
      });
    });
  }

  private hideMapLoaderWhenPngGeoJsonIdle(): void {
    if (this.activePngGeoJsonLoadIds.size > 0) {
      return;
    }

    this.spinnerService.hide();
    this.mapLoad = false;
  }

  private cancelPngGeoJsonLoadsFor(feedOrInfo: any): void {
    const feedKey = String(
      feedOrInfo?._id ?? feedOrInfo?.isInfo?._id ?? feedOrInfo?.name ?? ''
    );
    if (!feedKey) {
      return;
    }

    Array.from(this.pngGeoJsonCancelByScope.entries())
      .filter(([scope]) => {
        const [, scopeFeedKey] = scope.split('|');
        return scopeFeedKey === feedKey;
      })
      .forEach(([, cancel$]) => {
        cancel$.next();
        cancel$.complete();
      });
  }

  private cancelAllPngGeoJsonLoads(): void {
    this.pngGeoJsonCancelByScope.forEach((cancel$) => {
      cancel$.next();
      cancel$.complete();
    });
  }

  fetchAndCombineIndesisGeoJson(urls: any[], indices?): void {
    this.spinnerService.show();

    if (!urls?.length) {
      this.spinnerService.hide();
      return;
    }

    const geoJsonRequests = urls.map((item: any) =>
      this.httpClient.get(item.imageUrl)
    );

    forkJoin(geoJsonRequests).subscribe({
      next: (responses: any[]) => {
        try {
          let combinedGeoJson;
          if (responses.length > 1) {
            combinedGeoJson = this.combineGeoJsonFeatures(responses);
          } else {
            combinedGeoJson = responses[0];
          }

          this.displayIndesisLayer(combinedGeoJson, indices);

          this.displayedIS = {
            insightFootprint: JSON.parse(JSON.stringify(combinedGeoJson)),
            indices: indices,
          };
        } finally {
          this.spinnerService.hide();
        }
      },

      error: (error) => {
        this.spinnerService.hide();
        this.mapLoad = false;
      },
    });
  }

  private displayIndesisLayer(insightFootprint, indices): void {
    if (!insightFootprint) return;

    if (this.indicesLayer) {
      this.map.removeLayer(this.indicesLayer);
    }

    // Create or reuse a pane for indices layers
    if (!this.map.getPane('indicesPane')) {
      const indicesPane = this.map.createPane('indicesPane');
      indicesPane.style.zIndex = '650'; // higher than default overlayPane (400)
      indicesPane.style.pointerEvents = 'auto'; // optional, allows interaction
    }

    const feedResults = insightFootprint?.feed_results || {};
    const hasFeedResults = Object.keys(feedResults).length > 0;

    this.indicesLayer = L.geoJSON(insightFootprint, {
      pane: 'indicesPane',
      style: (feature) => {
        const value = feature?.properties?.value ?? 0;
        return {
          fillColor: getIndicesColor(value, indices.product),
          color: '#000',
          weight: 1,
          fillOpacity: 0.95,
        };
      },
      onEachFeature: (feature, layer) => {
        const classValue = feature?.properties?.value;
        if (classValue == null || !hasFeedResults) {
          return;
        }

        const areaPercent = feedResults[String(classValue)];
        if (areaPercent == null) {
          return;
        }

        const categoryMap = {
          CWSI: cwsiCategories,
          MBSI: mbsiCategories,
          NCCI: ncciCategories,
          OSI: osiCategories,
          NDTI: ndtiCategories,
          NDMI: ndmiCategories,
          NDRE: ndreCategories,
          NDVI: ndviCategories,
          TVDI: tvdiCategories,
        };
        const classLabel = (categoryMap[indices?.product] || []).find(
          (item: any) => item.value === Number(classValue)
        )?.label ?? `Class ${classValue}`;
        layer.bindTooltip(`${classLabel}: ${areaPercent}%`, {
          sticky: true,
          direction: 'top',
          className: 'indices-tooltip',
        });
     layer.on('mousedown', (e: L.LeafletMouseEvent) => {
     L.DomEvent.preventDefault(e.originalEvent);
      });
      },
    }).addTo(this.map);

    this.indicesLayer.bringToFront();
    this.addColorLegend(indices.product, indices?.products?.[0]?.message);

    this.map.fitBounds(this.indicesLayer.getBounds());
  }

  private addColorLegend(name, message?): void {
    // Remove existing legend if any
    if (this.colorLegendControl) {
      this.map.removeControl(this.colorLegendControl);
    }
    const categoryConfig: any = {
      CWSI: { title: 'CWSI', list: cwsiCategories },
      MBSI: { title: 'MBSI', list: mbsiCategories },
      NCCI: { title: 'NCCI', list: ncciCategories },
      OSI: { title: 'OSI', list: osiCategories },
      NDTI: { title: 'NDTI', list: ndtiCategories },
      NDMI: { title: 'NDMI', list: ndmiCategories },
      NDRE: { title: 'NDRE', list: ndreCategories },
      NDVI: { title: 'NDVI', list: ndviCategories },
      TVDI: { title: 'TVDI', list: tvdiCategories },
      SOIL_MOISTURE_SAR: {
        title: 'Soil Moisture',
        list: Object.entries(SOIL_MOISTURE_SAR_CLASS_MAP).map(
          ([key, value]) => ({
            label: value.label,
            color: value.color,
          })
        ),
      },
      FLOOD_INUNDATION_SAR: {
        title: 'Flood Depth',
        list: Object.values(FLOOD_INUNDATION_DEPTH_CLASS_MAP).map((entry) => ({
          label: entry.label,
          color: entry.color,
        })),
      },
      COLORISATION: { title: 'Colorisation', list: COLORISATION_LEGEND },
    };
    if (!categoryConfig[name]) return;
    this.colorLegendControl = L.control.zoom({ position: 'bottomleft' });
    this.colorLegendControl.onAdd = () => {
      const div = L.DomUtil.create('div', 'info legend');
      div.style.marginBottom = '50px';

      const infoIconHtml = message
        ? `
      <span class="legend-info" aria-label="Index info">
      ℹ
      <span class="legend-tooltip">
        ${message}
      </span>
    </span>
     `
        : '';
      let html = `
      <div style="display:flex; align-items:center; justify-content:space-between; padding-bottom:5px">
      <h6 style="color:white; margin:0;">
         ${categoryConfig[name].title}
      </h6>
      ${infoIconHtml}
     </div>`;

      categoryConfig[name].list.forEach((product) => {
        // Colorisation labels are long: show 20 chars on one line with a View more/less toggle
        const label =
          name === 'COLORISATION' && product.label.length > 20
            ? `<span class="legend-label">
          <span class="legend-short">${product.label.slice(0, 20)}...</span>
          <span class="legend-full">${product.label}</span>
          <a class="legend-toggle">View more</a>
        </span>`
            : product.label;
        html += `
    <div style="display:flex; margin-bottom:3px;">
      <span style="
        background:${product.color};
        width:18px;
        height:18px;
        display:inline-block;
        margin-right:6px;
        border:1px solid #333;
        margin-top: 2px;
        flex-shrink: 0;
      "></span>
      <span style="color:white; font-size:12px;">${label}</span>
    </div>
      `;
      });

      div.innerHTML = html;
      if (name === 'COLORISATION') {
        // Keep toggle clicks from reaching the map (click/dblclick zoom, drag)
        L.DomEvent.disableClickPropagation(div);
        div.addEventListener('click', (e) => {
          const toggle = (e.target as HTMLElement).closest('.legend-toggle');
          if (!toggle) return;
          const expanded = toggle.parentElement?.classList.toggle('expanded');
          toggle.textContent = expanded ? 'View less' : 'View more';
          // Cap the width only while a description is expanded: 320px, or 70% of a smaller map.
          // A % here resolves against Leaflet's shrink-to-fit corner (the legend itself), so use px
          div.style.maxWidth = div.querySelector('.legend-label.expanded')
            ? `${Math.min(320, this.map.getSize().x * 0.7)}px`
            : '';
        });
      }
      div.style.padding = '6px 8px';
      div.style.background = 'rgba(0,0,0,0.7)';
      div.style.boxShadow = '0 0 15px rgba(0,0,0,0.2)';
      div.style.borderRadius = '5px';

      return div;
    };

    this.colorLegendControl.addTo(this.map);
}

  combineGeoJsonFeatures(geoJsonDataArray: any[]): any {
    const allFeatures = geoJsonDataArray.flatMap((geoJson) => geoJson.features);
    return {
      type: 'FeatureCollection',
      features: allFeatures,
      metadata: geoJsonDataArray[0]?.metadata,
      feed_results: geoJsonDataArray[0]?.feed_results,
    };
  }

  private stopHover() {
    if (!this.map) return;
    if (this._hoverMove) this.map.off('mousemove', this._hoverMove);
    if (this._hoverOut) this.map.off('mouseout', this._hoverOut);
    this._hoverMove = undefined;
    this._hoverOut = undefined;
    if (this.currentTooltip && this.map.hasLayer(this.currentTooltip)) {
      this.map.removeLayer(this.currentTooltip);
    }
    this.currentTooltip = null;
    this.currentTooltipOwner = null;
    (this.map.getContainer() as HTMLElement).style.cursor = '';
  }

  // optional: a pane for vectors above raster tiles
  private ensureVectorPane(z = 3000) {
    const pane =
      this.map.getPane('vector-overlays') ||
      this.map.createPane('vector-overlays');
    pane.style.zIndex = String(z);
    pane.style.pointerEvents = 'auto';
  }

  /** Ensure we have a dedicated tooltip pane (once). */
  private ensureTooltipPane() {
    if (!this.map) return;
    let pane = this.map.getPane('eeTooltipPane');
    if (!pane) {
      pane = this.map.createPane('eeTooltipPane');
      pane.style.pointerEvents = 'none';
    }
    pane.style.zIndex = this.hoverTooltipPaneZIndex;
  }

  /** Fallback offsets if this.OFFSETS isn't defined yet */
  private readonly DEFAULT_OFFSETS: Record<
    'top' | 'bottom' | 'left' | 'right',
    L.PointExpression
  > = {
    top: [0, -10],
    bottom: [0, 10],
    left: [-10, 0],
    right: [10, 0],
  };

  private bindEeTooltip(
    layer: L.Layer,
    dir: 'top' | 'bottom' | 'left' | 'right',
    text: string = ''
  ): L.Tooltip | undefined {
    if (!this.map || !layer) return;
    this.ensureTooltipPane();

    // use your OFFSETS if present; otherwise defaults
    const offsets = (this as any).OFFSETS ?? this.DEFAULT_OFFSETS;
    // Clear anything old on this layer
    (layer as any).off?.('mouseover');
    (layer as any).off?.('mouseout');
    (layer as any).unbindTooltip?.();
    layer.bindTooltip(text, {
      pane: 'eeTooltipPane',
      permanent: false,
      direction: dir,
      offset: offsets[dir],
      className: 'custom-black-tooltip',
      opacity: 0.9,
      sticky: false,
    });

    return (layer as any).getTooltip?.();
  }

  private showFeatureTooltip(
    layer: L.Layer,
    dir: 'top' | 'bottom' | 'left' | 'right',
    contentHtml: string,
    anchorLatLng?: L.LatLngExpression
  ): void {
    if (!this.map || !layer) return;

    this.ensureTooltipPane();
    this.removeTooltip();

    const offsets = (this as any).OFFSETS ?? this.DEFAULT_OFFSETS;
    const anchor =
      anchorLatLng ??
      ((layer as any).getLatLng?.() as L.LatLngExpression | undefined);

    if (!anchor) return;

    this.currentTooltip = L.tooltip({
      pane: 'eeTooltipPane',
      direction: dir,
      offset: offsets[dir],
      className: 'custom-black-tooltip',
      opacity: 0.9,
      interactive: false,
      permanent: false,
      sticky: false,
    })
      .setLatLng(anchor)
      .setContent(contentHtml)
      .addTo(this.map);

    this.currentTooltipOwner = layer;
    layer.once('mouseout', () => this.removeTooltip(layer));
  }

  private getPredictionDetectionColor(config: any, feature: any, fallbackColor: string): string {
    const detectionClass = feature?.properties?.class;
    if (detectionClass == null || String(detectionClass).trim() === '') {
      return fallbackColor;
    }

    return config?.detectionColorMap?.[String(detectionClass).trim()]?.color ?? fallbackColor;
  }

  // Flood prediction sends forecast trajectories as polygons; hour 0 (or no hour) is the detection.
  private isPredictionForecastFeature(feature: any): boolean {
    const forecastHour = Number(
      feature?.properties?.forecast_h ?? feature?.properties?.forecast_hour
    );
    return Number.isFinite(forecastHour) && forecastHour > 0;
  }

  private getPredictionColor(config: any, feature: any, fallbackColor: string): string {
    const forecastHour =
      feature?.properties?.forecast_h ?? feature?.properties?.forecast_hour;
    const detectionClass = feature?.properties?.class;
    const hasDetectionClass = detectionClass != null && String(detectionClass).trim() !== '';
    const classColor = hasDetectionClass
      ? config?.classForecastColorMap?.[String(detectionClass).trim()]?.[forecastHour]?.color
      : undefined;

    return classColor ?? config?.forecastColorMap?.[forecastHour]?.color ?? fallbackColor;
  }

  private isPredictionFeed(feed: any): boolean {
    const config = feedsConfig[feed?._id ?? feed?.isInfo?._id];
    if (isPredictionFeedType(config?.type)) return true;

    const name = String(
      feed?.feedName ?? feed?.name ?? feed?.isInfo?.feedName ?? feed?.isInfo?.name ?? ''
    )
      .trim()
      .toLowerCase()
      .replace(/[\s_]+/g, '-');

    return Object.keys(PREDICTION_FEED_TYPES).some((type) =>
      name.includes(type.toLowerCase().replace(/[\s_]+/g, '-'))
    );
  }

  private getPredictionForecastDetails(...sources: any[]): PredictionForecastDetail[] {
    for (const source of sources) {
      const details = [
        source?.forecast_details,
        source?.fc?.forecast_details ??
        source?.isInfo?.forecast_details,
        source?.insightFootprint?.forecast_details,
        source?.insightDatas?.[0]?.insightFootprint?.forecast_details,
        source?.isInfo?.insightDatas?.[0]?.insightFootprint?.forecast_details,
      ].find((candidate) => Array.isArray(candidate) && candidate.length);

      if (!Array.isArray(details) || !details.length) continue;

      const seen = new Set<string>();
      const normalizedDetails = details
        .filter(
          (detail: any) =>
            (detail?.forecast_hour != null || detail?.forecast_h != null) &&
            !!(detail?.forecast_time_utc || detail?.fcst_t_utc || detail?.fcst_t_ut)
        )
        .map((detail: any) => {
          const forecastTime = String(
            detail.forecast_time_utc ?? detail.fcst_t_utc ?? detail.fcst_t_ut
          );
          return {
            forecast_h: detail.forecast_hour ?? detail.forecast_h,
            fcst_t_utc: /(?:Z|[+-]\d{2}:?\d{2})$/i.test(forecastTime)
              ? forecastTime
              : `${forecastTime}Z`,
          };
        })
        .filter((detail: PredictionForecastDetail) => {
          const key = `${detail.forecast_h}_${detail.fcst_t_utc}`;
          if (seen.has(key)) return false;
          seen.add(key);
          return true;
        });
      if (normalizedDetails.length) return normalizedDetails;
    }

    const featureDetails = sources.reduce((details: any[], source: any) => {
      const features = source?.features ?? source?.fc?.features;
      if (!Array.isArray(features)) return details;
      return details.concat(features.map((feature: any) => ({
        forecast_h: feature?.properties?.forecast_h ?? feature?.properties?.forecast_hour,
        fcst_t_utc:
          feature?.properties?.fcst_t_utc ??
          feature?.properties?.fcst_t_ut ??
          feature?.properties?.forecast_time_utc,
      })));
    }, []);
    if (featureDetails.length) {
      return this.getPredictionForecastDetails({ forecast_details: featureDetails })
        .sort((left, right) => Number(left.forecast_h) - Number(right.forecast_h));
    }

    return [];
  }

  private registerPredictionTimeseries(
    feedKey: string,
    feed: any,
    collection: FeatureCollection<Geometry, FeatureProps>,
    layer: L.GeoJSON,
    showInitialForecast = false
  ): void {
    const forecastDetails = this.getPredictionForecastDetails(collection, feed);

    if (
      this.predictionTimeseriesContext &&
      this.predictionTimeseriesContext.feedKey !== feedKey
    ) {
      this.unregisterPredictionTimeseries(false);
    }

    this.predictionTimeseriesContext = {
      feedKey,
      feed,
      layer,
      fullCollection: {
        ...collection,
        features: [...(collection?.features ?? [])],
      },
      forecastDetails,
    };
    this.predictionForecastDetails = forecastDetails;

    if (showInitialForecast) {
      this.showPredictionForecastForSelectedTime(1);
    }
  }

  private activatePredictionTimeseries(): void {
    const context = this.predictionTimeseriesContext;
    if (!context?.forecastDetails?.length) return;

    this.annotateClicked = false;
    this.newTaskButtonClicked = false;
    this.timeseries = true;
    this.sliderView = true;
    this.sliderShow = false;
    this.predictionTimeseriesActive = true;
    this.predictionForecastDetails = context.forecastDetails;
    this.currentSliderValue = 1;
    this.previousIndex = 0;
    this.showPredictionForecastForSelectedTime(1);
  }

  showPredictionForecastForSelectedTime(sliderValue: number): void {
    const context = this.predictionTimeseriesContext;
    if (!context?.layer || !context.forecastDetails.length) return;

    const selectedCount = Math.max(
      0,
      Math.min(Math.floor(Number(sliderValue) || 0), context.forecastDetails.length)
    );
    this.currentSliderValue = selectedCount;
    this.previousIndex = selectedCount - 1;
    // Keep the user's selection, but wait for the gated WMS/WFS viewport result before drawing.
    if (this.predictionTimeseriesViewportPending) return;
    const visibleHours = new Set<string>([
      '0',
      ...context.forecastDetails
        .slice(0, selectedCount)
        .map((detail) => String(detail.forecast_h)),
    ]);
    const visibleCollection: FeatureCollection<Geometry, FeatureProps> = {
      ...context.fullCollection,
      features: predictionFeaturesAtHours(context.fullCollection.features, visibleHours),
    };

    this.removeTooltip();
    context.layer.clearLayers();
    context.layer.addData(visibleCollection as any);
    this.liftPredictionLayer(context.layer);
  }

  private clearPredictionTimeseries(restoreFullCollection: boolean): void {
    const context = this.predictionTimeseriesContext;
    const wasPredictionTimeseriesActive = this.predictionTimeseriesActive;
    if (restoreFullCollection && context?.layer && !this.predictionTimeseriesViewportPending) {
      this.removeTooltip();
      context.layer.clearLayers();
      context.layer.addData(context.fullCollection as any);
      this.liftPredictionLayer(context.layer);
    }

    this.predictionTimeseriesActive = false;
    if (wasPredictionTimeseriesActive) {
      this.timeseries = false;
      this.sliderView = false;
      this.currentSliderValue = 0;
      this.previousIndex = -1;
    }
  }

  private unregisterPredictionTimeseries(restoreFullCollection: boolean): void {
    this.clearPredictionTimeseries(restoreFullCollection);
    this.predictionTimeseriesContext = null;
    this.predictionForecastDetails = [];
    this.predictionTimeseriesViewportPending = false;
  }

  async loadFeedOnTiff(
    collectionIndex: number,
    sensorIndex: number,
    infoServiceIndex: number,
    event: any,
    info: any,
    config: any,
    compareOptions?: { isCompare: boolean; pane: 'left' | 'right' }
  ) {
    if (!this.map) return;
    this.currentFilteredLayers = this.currentFilteredLayers || {};
    const feedKey = this.getFeedKey(info, config);
    const storageKey =
      compareOptions?.isCompare && compareOptions?.pane
        ? `${feedKey}::compare::${compareOptions.pane}`
        : feedKey;
    const currentSensor = this.collections[collectionIndex].sensors[sensorIndex];
    const isAssociatedFeed = this.isAssociatedFeed(currentSensor, info);
    const isPredictionDriftFeed =
      !isAssociatedFeed &&
      info?.prediction_info_ordered === false;

    if (this.currentFilteredLayers[storageKey]) {
      info.checked = true;
      this.feedLoaded = true;
      this.updateFeedInfo(currentSensor, { checked: true }, feedKey);
      if (this.isPredictionConfig(config)) {
        this.liftPredictionLayer(this.currentFilteredLayers[feedKey]);
      }
      if (isPredictionDriftFeed && this.predictionDrift.activeSourceFeed === info) {
        this.predictionDrift.registerPredictionDetectionLayer(
          this.currentFilteredLayers[feedKey] as L.Layer
        );
      }
      this.spinnerService.hide();
      return;
    }

    const imageryOptions = compareOptions ? { ...compareOptions } : undefined;
    const questionTasking = this.isFeedTasking;
    const questionPane: 'left' | 'right' = compareOptions?.pane
      ?? (this.mapPane === 'right' ? 'right' : 'left');
    let wmsLayer = this.getActiveFeedWmsLayer(imageryOptions);
    const checkedScenes = currentSensor.scenes?.filter((scene) => scene.checked === true) ?? [];
    const selectedScene = !this.combinedScenes && !isAssociatedFeed && checkedScenes.length === 1
      ? checkedScenes[0]
      : undefined;
    const selectedSceneId = selectedScene?.id;
    this.mapLoad = true;
    this.spinnerService.show();
    const cancel$ = this.beginTiffWfsLoad(storageKey);
    if (questionTasking) {
      try {
        wmsLayer = await this.questionWmsHandoff.waitForLayer(
          currentSensor.id,
          selectedSceneId,
          questionPane,
          cancel$
        );
      } catch (err) {
        if ((err as any)?.name !== 'EmptyError' && !cancel$.isStopped) {
          this.notifyViewportGeojsonLoadError(err);
        }
        this.finishTiffWfsLoad(storageKey, cancel$);
        this.spinnerService.hide();
        this.mapLoad = false;
        return;
      }
    }
    const cancelOnImageryRemoval = () => {
      cancel$.next();
      cancel$.complete();
    };
    wmsLayer?.on('remove', cancelOnImageryRemoval);
    const isCurrentLoad = () => {
      if (cancel$.isStopped || info?.checked === false) return false;
      if (questionTasking) {
        const currentQuestionLayer = this.questionWmsHandoff.currentLayer(
          currentSensor.id,
          selectedSceneId,
          questionPane
        );
        if (currentQuestionLayer !== wmsLayer) return false;
      } else if (this.getActiveFeedWmsLayer(imageryOptions) !== wmsLayer) {
        return false;
      }
      if (wmsLayer && !this.map?.hasLayer(wmsLayer)) return false;
      if (!selectedScene) return true;
      const sensor = this.collections?.[collectionIndex]?.sensors?.[sensorIndex];
      const scenes = sensor?.scenes?.filter((scene) => scene.checked === true) ?? [];
      return sensor === currentSensor && scenes.length === 1 &&
        scenes[0] === selectedScene && scenes[0].id === selectedSceneId;
    };
    let result: any = null;
    try {
      if (this.combinedScenes || isAssociatedFeed) {
        const payload = {
          customerid: this.currentUser?.id,
          feedId: info?._id,
          taskId: this.currentTaskId,
          sensorId: isAssociatedFeed
            ? info?.sensorId ?? currentSensor.id
            : currentSensor.id,
        };

        const res: any = await firstValueFrom(
          this.apiService
            .getFeedFromGeoCollection(payload)
            .pipe(takeUntil(this.destroy$))
        );

        if (res?.msg === 'Failed') {
          this.pointerEvent = 'auto';
          this.mapLoad = false;
          this.spinnerService.hide();
          this.fail = this.fail + 1;
          if (this.fail == 1) {
            const message =
              'An error occurred during processing and ingestion of the request. Please try after sometime.';
            this.popupService.openPopup(
              CollectionPopupComponent,
              message,
              '',
              '40%'
            );
          }
          return;
        }

        result = res.result;
      } else if (selectedScene) {
        const sensorObj = {
          sensorId: currentSensor.id,
          sceneId: selectedScene.id,
          action: 'scene',
          fileType: selectedScene.imageType,
        };
        result = await this.getCollectionImageResult(
          this.collections[collectionIndex],
          sensorObj,
          cancel$
        );
      } else {
        result = this.responseResult;
      }
      if (!isCurrentLoad()) return;
      if (!result?.layer) {
        this.feedLoaded = false;
        this.uncheckFeedAfterEmptyResult(info);
        this.spinnerService.hide();
        return;
      }

      const shapeList = result.layer.shapes;
      if (!shapeList?.length) {
        this.feedLoaded = false;
        this.uncheckFeedAfterEmptyResult(info);
        this.spinnerService.hide();
        return;
      }

      const isPrediction = this.isPredictionConfig(config);
      const matchedShapes = matchingFeedShapes(shapeList, info, isPrediction);
      const matchedShape = matchedShapes[0];
      if (!matchedShape || matchedShapes.some((shape) => !shapeLayerName(shape))) {
        this.feedLoaded = false;
        this.uncheckFeedAfterEmptyResult(info);
        this.spinnerService.hide();
        return;
      }
      const classFilter = this.helperService.classCqlStrict(
        config?.class,
        'class'
      );
      const sources = matchedShapes.map((shape) => ({
        layerName: shapeLayerName(shape),
        baseCql: this.helperService.combineFilters(shape.cql, classFilter) || null,
      }));
      const { layerName, baseCql } = sources[0];
      const multiShapeSources = isPrediction && sources.length > 1
        ? sources
        : undefined;
      const sceneResults = (info?.insightDatas ?? info?.isInfo?.insightDatas ?? []).find(
        (entry: any) => entry.sceneId === (selectedScene?.id ?? info?.sceneId)
      )?.insightFootprint?.feed_results;
      const originalResults = isPredictionFeedType(config?.type)
        ? info?.feed_results ?? info?.isInfo?.feed_results ?? currentSensor?.feed_results ?? sceneResults
        : this.combinedScenes ? currentSensor.feed_results
          : sceneResults ?? info?.feed_results ?? info?.isInfo?.feed_results;
      if (isPrediction && isEmptyPredictionFeedResult(originalResults)) {
        this.feedLoaded = false;
        this.uncheckFeedAfterEmptyResult(info);
        this.showNoInformationExtractedPopup();
        this.spinnerService.hide();
        this.mapLoad = false;
        return;
      }
      let geojson: any;
      try {
            geojson = await this.loadViewportGeojson(
            layerName,
            baseCql,
            wmsLayer,
            cancel$,
            'afterWmsLoad',
            this.helperService.getFeedResultCount(originalResults, config?.type),
            multiShapeSources
          );
      } catch (err) {
        if (!cancel$.isStopped && (err as any)?.name !== 'EmptyError') this.notifyViewportGeojsonLoadError(err);
          this.feedLoaded = false;
        this.uncheckFeedAfterEmptyResult(info);
        this.spinnerService.hide();
        return;
      }
      if (!isCurrentLoad()) return;
      const isEmptyFeed = await this.isEntireTiffFeedEmpty(geojson, layerName, baseCql, cancel$);
      if (!isCurrentLoad()) return;
      if (isEmptyFeed) {
        this.feedLoaded = false;
        this.uncheckFeedAfterEmptyResult(info);
        this.showNoInformationExtractedPopup();
        this.spinnerService.hide();
        this.mapLoad = false;
        return;
      }

      const isUpperCase =
        config?.type === 'Vessel' || config?.type === 'Transshipment' || config?.type === 'Transhipment';

      this.vessel = [
        'Ship',
        'Vessel',
        'Transshipment',
        'Transhipment',
      ].includes(config?.type);
      const isExists = info?.isInfo?.insightDatas?.length > 0;
      let count: any;

      if (isPredictionFeedType(config?.type)) {
        // The feed result lists every forecast hour; the scene footprint may hold only the last hour.
        count = info?.feed_results ?? info?.isInfo?.feed_results ??
          currentSensor?.feed_results ?? sceneResults;
      } else if (!isUpperCase && isExists && !this.combinedScenes) {
        count = info?.isInfo?.insightDatas?.[0]?.insightFootprint?.feed_results;
      } else if (this.combinedScenes) {
        count =
          this.collections[collectionIndex].sensors[sensorIndex].feed_results;
      } else {
        if (info?.feed_results != null) {
          count = info?.feed_results;
        } else {
          const selectedscen = this.collections[collectionIndex].sensors[
            sensorIndex
          ].scenes.filter((scene) => scene.checked == true);
          const feedResult = info?.insightDatas?.find(
            (scene) => scene.sceneId === selectedscen[0]?.id
          );
          count = feedResult?.insightFootprint?.feed_results;
        }
      }

      let floodInundationFeedResults: any;
      if (config?.type === 'Flood Inundation') {
        const selectedScene = this.collections[collectionIndex].sensors[
          sensorIndex
        ]?.scenes?.find((scene) => scene.checked == true);
        const selectedSceneFeedResults = info?.insightDatas?.find(
          (scene) => scene.sceneId === selectedScene?.id
        )?.insightFootprint?.feed_results;
        const firstSceneFeedResults =
          info?.insightDatas?.[0]?.insightFootprint?.feed_results;
        const fallbackObjectFeedResults =
          typeof info?.feed_results === 'object'
            ? info?.feed_results
            : undefined;

        floodInundationFeedResults =
          selectedSceneFeedResults ??
          firstSceneFeedResults ??
          fallbackObjectFeedResults;
      }

      geojson.feed_results = floodInundationFeedResults ?? count ?? {};

      if (isPrediction && !geojson.forecast_details?.length) {
        geojson.forecast_details = this.getPredictionForecastDetails(geojson, info);
      }
      const color = this.getFeedDisplayColor(currentSensor, info, config);
      const feedResultsForSections =
        isPredictionFeedType(config?.type)
          ? this.predictionFeedController.buildFeedResultsForSections(
              geojson.feed_results
            )
          : geojson.feed_results;
      const vm = this.helperService.buildFeedSections(
        config,
        feedResultsForSections,
        color
      );

      this.feedSections = vm.sections;
      const title = this.feedTitleOf(config, info?.feedName || info?.name);

      if (compareOptions?.isCompare && compareOptions.pane === 'left') {
        this.addLeftFeedPanel(feedKey, title, color, this.feedSections);
      } else if (compareOptions?.isCompare && compareOptions.pane === 'right') {
        this.addRightFeedPanel(feedKey, title, color, this.feedSections);
      } else {
        const predictionLegendGroups = this.isPredictionConfig(config)
        ? buildPredictionLegendGroupsFromResults(
            geojson.feed_results,
            config,
            String(color ?? '#FF00FF'),
            feedKey
          )
        : undefined;
      this.addFeedPanel(
        feedKey,
        title,
        color,
        this.feedSections,
        predictionLegendGroups
      );
      }
      this.feedUi = vm.ui;
      const fcRendered =
        geojson?.type === 'FeatureCollection'
          ? geojson
          : { type: 'FeatureCollection', features: geojson?.features };

      // Attach feed_results to the FeatureCollection itself for access during filtering
      const fcWithResults = {
        ...fcRendered,
        feed_results: geojson.feed_results,
        forecast_details: info?.forecast_details ?? info?.isInfo?.forecast_details ??
          geojson.forecast_details,
      };

      this.geoByFeed.set(feedKey, {
        fc: fcWithResults,
        type: config?.type,
        color,
        title,
        feed_results: geojson.feed_results,
      });

      this.activeFeedKeys.add(feedKey);
      const paneId = compareOptions?.isCompare
        ? `${compareOptions.pane}-objects`
        : `tiff-pane-${feedKey}`;
      const isAssociatedFeedLayer = this.isAssociatedFeed(currentSensor, info);
      let pane = this.map.getPane(paneId);

      if (!pane) {
        pane = this.map.createPane(paneId);
        pane.style.zIndex = String(matchedShape.zIndex ?? 3000);
        pane.style.pointerEvents = 'auto';
      }
      if (compareOptions?.isCompare) {
        pane.style.zIndex = '650';
      } else if (config?.colorMode === 'CLASS_BASED') {
        pane.style.zIndex = '1500';
      }

      if (this.isPredictionConfig(config)) {
        pane.style.zIndex = this.predictionPaneZIndex;
      }

      if (isAssociatedFeedLayer) {
        pane.style.zIndex = '100000';
      }

      if (info?.isInfo?.modelType === this.infoserviceModelType) {
        pane.style.zIndex = '99999';
      }

      if (this.isPredictionConfig(config)) {
        pane.style.zIndex = this.predictionPaneZIndex;
      }

      const feedName = config?.name || 'Unknown Feed';
      let feedColor = color || '#007bff';

      const isVesselType = [
        'ship',
        'vessel',
        'transshipment',
        'transhipment',
        'vessel-classification'
      ].includes((config?.type || '').toLowerCase());
      const dotCanvas = L.canvas({ padding: 0.5, pane: paneId });
      const overlay = L.geoJSON(this.orderMiningChangeFeatures(fcRendered, config?.type), {
        pane: paneId,
        style: (feature: any) => {
          const isVesselClassification = config?.type === 'Vessel-classification';
          const isVehicleClassification = config?.type === 'Vehicle-classification';
          const isPrediction = isPredictionFeedType(config?.type);
          const cls = feature?.properties?.class?? feature?.properties?.depth_class;

        if (isVesselClassification && cls != null) {
          const entry = VESSEL_CLASS_COLOR_MAP[cls];
          if (entry) {
            return {
              color: entry.color,
              fillColor: entry.color,
              fillOpacity: 1.0,
            };
          }
        } else if (isVehicleClassification && cls != null) {
          const entry = (VEHICLE_CLASS_COLOR_MAP as any)[cls];
          if (entry) {
            return { color: entry.color, fillColor: entry.color, fillOpacity: 0.8, weight: 3 };
          }
          } else if (isPrediction) {
          if (
            (feature?.geometry?.type === 'Polygon' || feature?.geometry?.type === 'MultiPolygon') &&
            !this.isPredictionForecastFeature(feature)
          ) {
            const detectionColor = this.getPredictionDetectionColor(config, feature, feedColor);
            return { color: detectionColor, fillColor: detectionColor, fillOpacity: 1, weight: 2 };
          }
          const forecastColor = this.getPredictionColor(config, feature, feedColor);
          return { color: forecastColor, fillColor: forecastColor, fillOpacity: 0.75, weight: 0 };
        }
        else if (config?.type === 'Flood Inundation') {
          let rawCls = feature?.properties?.depth_class ?? feature?.properties?.depth_clas ?? cls;
          // Normalize dashes/hyphens/question marks in depth class string to match FLOOD_INUNDATION_DEPTH_CLASS_MAP keys
          const normalizedCls = rawCls
            ? String(rawCls).replace(/[\u2010-\u2015\u2212\-\?]/g, '–').trim()
            : rawCls;
          const entry = FLOOD_INUNDATION_DEPTH_CLASS_MAP[normalizedCls] || FLOOD_INUNDATION_DEPTH_CLASS_MAP[rawCls];
          if (entry) {
            return {
              color: entry.color,
              fillColor: entry.color,
              fillOpacity: 1,
              weight: 0.4,
            };
          }
        }
        else if (config?.colorMode == 'CLASS_BASED') {
          const feedColor = config?.color ?? color;
          const normalizedCls = typeof cls === 'string' ? cls.trim() : cls;
          const normalizedClassKey = typeof normalizedCls === 'string'
            ? Object.keys(feedColor ?? {}).find((key) => key.toLowerCase() === normalizedCls.toLowerCase())
            : normalizedCls;
          const classColor =
            feedColor?.[normalizedClassKey]?.color ??
            feedColor?.[String(normalizedCls)]?.color ??
            (config?.type === 'Mining changes monitoring' ? feedColor?.Change?.color : undefined);
          return {
            color: classColor,
            fillColor: classColor,
            fillOpacity: 1.0,
          };
        }

          return {
            color: feedColor,
            fillColor: feedColor,
            fillOpacity: 1,
          };
        },

        pointToLayer: (feature, latlng) => {
          if (isPredictionFeedType(config?.type)) {
            const forecastColor = this.getPredictionColor(config, feature, feedColor);
            return L.circleMarker(latlng, {
              radius: 2,
              color: forecastColor,
              weight: 0,
              fillColor: forecastColor,
              fillOpacity: 0.75,
              renderer: dotCanvas,
            });
          }
          if (config?.type === 'Tuna-detection') {
            return L.circleMarker(latlng, {
              radius: 6,
              fillColor: '#2ecc71',
              color: '#27ae60',
              weight: 2,
              opacity: 0.9,
              fillOpacity: 0.8,
              renderer: dotCanvas,
            });
          }
          if (config?.type === 'Tree counting') {
            return L.circleMarker(latlng, {
              radius: 4,
              color: feedColor,
              weight: 1,
              fillColor: feedColor,
              fillOpacity: 0.9,
              renderer: dotCanvas,
            });
          }
          if (config?.type === 'Container detection') {
            return L.circleMarker(latlng, {
              radius: 2,
              color: feedColor,
              weight: 1,
              fillColor: feedColor,
              fillOpacity: 0.9,
              renderer: dotCanvas,
            });
          }
          return L.circleMarker(latlng, { radius: 4, color: feedColor });
        },

        onEachFeature: (feature, layer) => {
            if (isPredictionFeedType(config?.type)) {
              attachForecastPointHoverPopup({
                layer,
                feature,
                map: this.map,
                nudgeInsideView: this.nudgeInsideView.bind(this),
                pickDirection: this.pickDirection.bind(this),
                showEeTooltip: this.showFeatureTooltip.bind(this),
                onForecastHover: (hour) => (this.hoveredPredictionForecastHour = hour),
              });
            } else {
              attachVesselHoverPopup({
                layer,
                feature,
                feedName,
                map: this.map,
                nonVesselFeed: this.nonVesselFeed,
                helperService: this.helperService,
                nudgeInsideView: this.nudgeInsideView.bind(this),
                pickDirection: this.pickDirection.bind(this),
                showEeTooltip: this.showFeatureTooltip.bind(this),
              });
            }
        },
      });

      if (this.isPredictionConfig(config) && !compareOptions?.isCompare) {
        this.allowFeedHoverThroughForecastCanvas(overlay, dotCanvas);
      }

      if (compareOptions?.isCompare && compareOptions?.pane) {
        (overlay as any)._changeDetectionComparePane = compareOptions.pane;
      }

      if (!compareOptions?.isCompare) {
        this.leftComparisonObjectLayer = overlay;
      }
      if (compareOptions?.isCompare) {
        if (compareOptions.pane === 'left') {
          this.leftComparisonObjectLayer = overlay;
        } else {
          this.rightComparisonObjectLayer = overlay;
        }
        overlay.addTo(this.map);
        this.ensureChangeDetectionHistorySplitMap();
      } else if (config?.colorMode === 'CLASS_BASED') {
        overlay.addTo(this.map);
        overlay.bringToBack();
      } else {
        overlay.addTo(this.map);
        if (isAssociatedFeedLayer) {
          overlay.bringToFront();
        }
      }
      this.currentShapeLayerName =
        matchedShape.layerName ?? matchedShape.layername;
      this.currentFilteredLayers[storageKey] = overlay;
      if (this.isPredictionConfig(config)) {
        this.liftPredictionLayer(overlay);
      }
      if (isPredictionFeedType(config?.type)) {
        this.registerPredictionTimeseries(feedKey, info, fcRendered, overlay);
      }
      info.checked = true;
      this.feedLoaded = true;
      this.updateFeedInfo(currentSensor, { checked: true }, feedKey);

      if (isPredictionDriftFeed && this.predictionDrift.activeSourceFeed === info) {
        this.predictionDrift.registerPredictionDetectionLayer(overlay as L.Layer);
      }

        this.registerViewportGeojsonSession(
          storageKey,
          feedKey,
          layerName,
          baseCql,
          undefined,
          wmsLayer,
          multiShapeSources
        );

      this.feedInfo = true;


      if(this.shouldApplyCompareVisibility() && (this.rightComparisonObjectLayer || this.rightImageNew) && (this.leftComparisonObjectLayer  || this.leftImageNew)) {
      const mapWidth = (this.map.getSize().x);
      this.updateObjectVisibility(this.lastSliderValue === 0 ? mapWidth/2 : this.lastSliderValue);
      this.needsCompareResetToCenter = false;
      }
    
    } catch (err) {
      if (cancel$.isStopped || (err as any)?.name === 'EmptyError') return;
      this.pointerEvent = 'auto';
      this.mapLoad = false;
      this.spinnerService.hide();
      this.fail = this.fail + 1;
      if (this.fail == 1) {
        const message =
          'An error occurred during processing and ingestion of the request. Please try after sometime.';
        this.popupService.openPopup(
          CollectionPopupComponent,
          message,
          '',
          '40%'
        );
      }
      return;
    } finally {
      wmsLayer?.off('remove', cancelOnImageryRemoval);
      this.finishTiffWfsLoad(storageKey, cancel$);
      this.spinnerService.hide();
      this.mapLoad = false;
    }
  }

  fetchImageFromServerWithResult(
    collection: any,
    sensorObj: any,
    scene: any
  ): Promise<any> {
    this.mapLoad = true;
    this.spinnerService.show();

    return new Promise((resolve, reject) => {
      this.apiService
        .getCollectionImage(collection.taskId, sensorObj)
        .subscribe(
          (res: any) => {
            this.spinnerService.hide();
            this.mapLoad = false;

            if (res?.result) {
              this.responseResult = res.result;

              void this.displayFootprintImageNew(
                scene,
                res.result,
                sensorObj.sensorId,
                'image',
                collection.taskId
              ).catch((error) => {
                this.questionWmsHandoff.publishFailure(
                  scene,
                  sensorObj?.sensorId,
                  scene?.pane === 'right' ? 'right' : 'left',
                  error
                );
              });

              resolve(res.result);
            } else {
              reject(res);
            }
          },
          (error) => {
            this.mapLoad = false;
            this.spinnerService.hide();
            reject(error);
          }
        );
    });
  }

  private async getCollectionImageResult(
    collection: any,
    sensorObj: any,
    cancel$?: Observable<unknown>
  ): Promise<any> {
    const response: any = await firstValueFrom(
      this.apiService.getCollectionImage(collection.taskId, sensorObj).pipe(
        takeUntil(merge(this.destroy$, cancel$ ?? EMPTY))
      )
    );

    if (!response?.result) {
      throw response;
    }

    return response.result;
  }

  private pickDirection(
    pt: L.Point,
    margin = 120,
    inset: { left?: number; right?: number; top?: number; bottom?: number } = {
      right: 100,
      top: 60,
    }
  ): 'left' | 'right' | 'top' | 'bottom' {
    const size = this.map.getSize();
    const Lm = (inset.left ?? 0) + margin;
    const Rm = (inset.right ?? 0) + margin;
    const Tm = (inset.top ?? 0) + margin;
    const Bm = (inset.bottom ?? 0) + margin;

    const nearLeft = pt.x <= Lm;
    const nearRight = pt.x >= size.x - Rm;
    const nearTop = pt.y <= Tm;
    const nearBottom = pt.y >= size.y - Bm;
    // prioritize horizontal flip, then vertical
    if (nearRight) return 'left';
    if (nearLeft) return 'right';
    if (nearTop) return 'bottom';
    if (nearBottom) return 'top';
    return 'right';
  }

  private nudgeInsideView(ll: L.LatLngExpression, pad = 80): L.LatLng {
    const p = this.map.latLngToContainerPoint(ll);
    const s = this.map.getSize();
    p.x = Math.max(pad, Math.min(s.x - pad, p.x));
    p.y = Math.max(pad, Math.min(s.y - pad, p.y));
    return this.map.containerPointToLatLng(p);
  }

  applyFeedSection(config: any, feed_results: any) {
    const vm = this.helperService.buildFeedSections(config, feed_results);
    this.feedSections = vm.sections;
    this.feedUi = vm.ui;
    return vm;
  }

  /** Wrap expressions with parens when they contain OR (to preserve precedence). */
  wrapIfNeeded = (s: string) =>
    /\bOR\b/i.test(s) && !(s.trim().startsWith('(') && s.trim().endsWith(')'))
      ? `(${s.trim()})`
      : s.trim();

  private upsertFeedResultCount(targetObj: any, key: string, value: number) {
    if (!targetObj.insightFootprint) targetObj.insightFootprint = {};
    if (!targetObj.insightFootprint.feed_results)
      targetObj.insightFootprint.feed_results = {};
    targetObj.insightFootprint.feed_results[key] = value;
  }

  removeVectorOverlay() {
    try {
      (this.shapeVectorOverlay as any).off?.();
    } catch {}
    if (this.shapeVectorOverlay && this.map.hasLayer(this.shapeVectorOverlay))
      this.map.removeLayer(this.shapeVectorOverlay);
    this.shapeVectorOverlay = undefined;
    this.feedInfo = false;
    this.feedData = '';
  }

  showNoFeedMessage(feedName) {
    const message = `Please see the ${feedName} after enabling the data in GeoTiff format on the map by toggling to Load Tiff.`;
    this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
    this.spinnerService.hide();
  }

  guardTreeCounting(e: MouseEvent, info: any) {
    const feedId = info?._id;
    const config = feedId ? feedsConfig[feedId] : null;

    const disallowed =
      this.imageType === 'png' && (config?.type === 'Tree counting' || config?.type === 'Container detection');
    if (disallowed) {
      e.preventDefault();
      e.stopPropagation();
      this.showNoFeedMessage(info?.feedName);
    }
  }

  selectISNew(
    collectionIndex: number,
    sensorIndex: number,
    infoServiceIndex: number,
    event,
    info: any,
    taskId: string
  ) {
    this.spinnerService.show();
    if (this.displayedIS) {
      this.displayedIS = null;
    }
    this.currentTaskId = taskId;
    let feedId = '';
    let config: any = '';
    if (info) {
      feedId = info?._id;
      config = feedsConfig[feedId];
      // Fallback: detect Vehicle-classification by feed name when real DB ID is not yet in feedsConfig
      if (!config) {
        const _n = (info?.feedName || info?.name || '').toLowerCase().replace(/[\s_]+/g, '-');
        if (_n.includes('vehicle-classification')) {
          config = Object.values(feedsConfig).find((c: any) => c?.type === 'Vehicle-classification');
        }
      }
      info.checked = event.checked;
    }

    this.info = info;
    const id = info?._id;
    if (!id) return;
    this.feedInfo = false;
    const key = this.getFeedKey(info, config);

    if (
      event.checked &&
      this.imageType === 'png' &&
      (config?.type === 'Tree counting' || config?.type === 'Container detection')
    ) {
      this.showNoFeedMessage(info?.feedName);
      // Set checked to false for the feed object directly
      info.checked = false;
      const fakeEvent = { ...event, checked: false };
      this.updateFeedInfo(
        this.collections[collectionIndex].sensors[sensorIndex],
        fakeEvent,
        key
      );
      this.uncheckAssociatedFeedsForParent(
        this.collections[collectionIndex].sensors[sensorIndex],
        info
      );
      return;
    }

    info.checked = event.checked;
    this.info = info;
    this.feedInfo = false;

    this.updateFeedInfo(
      this.collections[collectionIndex].sensors[sensorIndex],
      event,
      key
    );
    this.syncSensorsDisabledByAssociatedFeed();

    if (event.checked) {
      this.clearFeedFilterState( key, this.collections[collectionIndex].sensors[sensorIndex], sensorIndex );
      const isChangeDetectionStrategyTask = this.isChangeDetectionTask(
        this.collection?.taskStrategy
      );
      const comparePane = isChangeDetectionStrategyTask
        ? undefined
        : this.getChangeDetectionInformationFeedComparePane();

      if (comparePane && this.changeDetectionHistorySelections.length > 1) {
        const selectionToReplace = this.changeDetectionHistorySelections.find(
          (selection: any) => selection.pane === comparePane
        );

        if (selectionToReplace) {
          selectionToReplace.data.checked = false;

          const ownerSensor =
            this.collections?.[collectionIndex]?.sensors?.[sensorIndex] ??
            this.collection?.sensors?.[0];
          const historyFeed = this.getChangeDetectionHistoryFeed(
            selectionToReplace.data,
            ownerSensor
          );
          const historyFeedKey = String(
            historyFeed?._id ?? historyFeed?.name ?? ''
          );

          this.removeDataLayer(historyFeed);

          if (historyFeedKey) {
            this.removeFeedPanel(historyFeedKey);
            this.leftFeedPanels.delete(historyFeedKey);
            this.rightFeedPanels.delete(historyFeedKey);
            this.clearFilteredLayerAndRestore(false, historyFeedKey);
            this.activeFeedKeys.delete(historyFeedKey);
          }

          this.removeCompareControlSafely();

          const replacedHistoryScenes = this.scenesNew.filter(
            (sceneNew: any) =>
              sceneNew?.scene?.isChangeDetectionHistoryCompare &&
              sceneNew?.scene?.id === selectionToReplace.sceneId &&
              sceneNew?.pane === comparePane
          );

          replacedHistoryScenes.forEach((sceneNew: any) => {
            this.removeLayerByScene(sceneNew, { paneSpecific: true });
            if (sceneNew?.legendScale && this.map.hasLayer(sceneNew.legendScale)) {
              this.map.removeLayer(sceneNew.legendScale);
            }
          });

          this.scenesNew = this.scenesNew.filter(
            (sceneNew: any) =>
              !(
                sceneNew?.scene?.isChangeDetectionHistoryCompare &&
                sceneNew?.scene?.id === selectionToReplace.sceneId &&
                sceneNew?.pane === comparePane
              )
          );
          this.updateImageLayersBasedOnPane();

          this.clearComparisonObjectLayer(comparePane);

          this.changeDetectionHistorySelections =
            this.changeDetectionHistorySelections.filter(
              (selection: any) => selection.key !== selectionToReplace.key
            );
          this.syncChangeDetectionHistoryCompareState();
          this.needsCompareResetToCenter = true;
        }
      }

      const compareOptions = comparePane
        ? { isCompare: true, pane: comparePane }
        : undefined;
      info._changeDetectionComparePane = comparePane;
      if (!comparePane) {
        delete info._changeDetectionComparePane;
      }

      if (this.imageType == 'png') {
        this.loadFeedOnPNG(
          collectionIndex,
          sensorIndex,
          infoServiceIndex,
          event,
          info,
          config,
          compareOptions
        );
      } else if (this.imageType === 'tif') {
        this.loadFeedOnTiff(
          collectionIndex,
          sensorIndex,
          infoServiceIndex,
          event,
          info,
          config,
          compareOptions
        );
      }
    } else {

  const comparePane = info._changeDetectionComparePane;

  const wasPartOfChangeDetectionComparison =
    comparePane === 'left' ||
    comparePane === 'right';

  const isChangeDetectionTask =
    this.isChangeDetectionTask(
      this.collection?.taskStrategy
    );
     if (
    isChangeDetectionTask &&
    wasPartOfChangeDetectionComparison
  ) {

  info.checked = false;

  if (wasPartOfChangeDetectionComparison) {
    delete info._changeDetectionComparePane;
  }
  this.stopHover();

  this.feedLoaded = false;

  this.feedUi = {
    showFilterIcon: false
  };

  this.removeDataLayer(info);

  this.removeFeedPanel(key);

  this.removeIndices();

  this.updateFeedInfo(
    this.collections[collectionIndex].sensors[sensorIndex],
    event,
    key
  );

  this.removeVectorOverlay();

  this.clearFilteredLayerAndRestore(
    false,
    key
  );

  this.activeFeedKeys.delete(key);

    const historyStillSelected =
      this.changeDetectionHistorySelections?.length === 1;

    const informationFeedStillSelected =
      this.getCheckedChangeDetectionCompareFeeds().length === 1;

    if (historyStillSelected) {

      this.restoreSingleChangeDetectionSelection(
        this.collections[collectionIndex],
        this.collections[collectionIndex].sensors[sensorIndex]
      );

      this.spinnerService.hide();
      return;
    }

    if (informationFeedStillSelected) {

      this.restoreSingleChangeDetectionSelection(
        this.collections[collectionIndex],
        this.collections[collectionIndex].sensors[sensorIndex]
      );

      this.spinnerService.hide();
      return;
    }
    // -------------------------------------------------------

    this.isCompare = false;
    this.isCompareRecurrency = false;
    this.isCompareClicked = false;
    this.needsCompareResetToCenter = false;
  }

  this.spinnerService.hide();
      info.checked = false;
      if (this.predictionTimeseriesContext?.feedKey === key) {
        this.unregisterPredictionTimeseries(false);
      }
      if (info?.prediction_info_ordered === false && this.predictionDrift.activeSourceFeed === info) {
        this.resetPredictionDriftPanel();
      }
      if (!this.isAssociatedFeed(this.collections[collectionIndex].sensors[sensorIndex], info)) {
        this.uncheckAssociatedFeedsForParent(
          this.collections[collectionIndex].sensors[sensorIndex],
          info
        );
      }
      this.stopHover();
      this.feedLoaded = false;
      this.feedUi = { showFilterIcon: false };
      this.removeDataLayer(info);
      this.removeFeedPanel(key);
      this.removeIndices();
      this.updateFeedInfo(
        this.collections[collectionIndex].sensors[sensorIndex],
        event,
        key
      );
      this.removeVectorOverlay();
      this.clearFilteredLayerAndRestore(false, key);
      this.activeFeedKeys.delete(key);
      this.clearFeedFilterState(key);
      this.spinnerService.hide();
    }
  }

  updateFeedInfo(sensor: any, event?: any, key?: any) {
    this.filterInfoVisible = this.getFeedInfoForFilter(
      sensor.InfoServices,
      event,
      key
    );
    // Consolidate all CLASS_BASED detection into single property (Vehicle, LULC, Soil Moisture, Vessel Class, Flood Inundation)
    this.classBasedFilterMessageShown = this.hasClassBasedFilterMessageShown(
      sensor.InfoServices
    );
  }

  removeDataLayer(feedOrInfo: any): void {
    this.cancelPngGeoJsonLoadsFor(feedOrInfo);

    const feedKey = String(
      feedOrInfo?._changeDetectionHistoryFeedKey ??
        feedOrInfo?.isInfo?._changeDetectionHistoryFeedKey ??
        feedOrInfo?._id ??
        feedOrInfo?.isInfo?._id ??
        feedOrInfo?.name
    );
    this.cancelTiffWfsLoads((key) => key === feedKey || key.startsWith(`${feedKey}::compare::`));
    this.viewportGeojson.endSessionsFor(feedKey);
    this.removeLegendSummaries(feedKey);
    Array.from(this.viewportGeojsonRender.keys())
      .filter((key) => key === feedKey || key.startsWith(`${feedKey}::compare::`))
      .forEach((key) => this.viewportGeojsonRender.delete(key));
    this.viewportGeojsonLoadErrorShown = false;
    Object.keys(this.feedLayers || {})
      .filter((key) => key === feedKey || key.startsWith(`${feedKey}::compare::`))
      .forEach((key) => {
        const layer = this.feedLayers[key];
        if (layer && this.map.hasLayer(layer)) {
          this.removeVesselLabelLayer(layer);
          this.map.removeLayer(layer);
        }
        delete this.feedLayers[key];
      });

    Object.keys(this.currentFilteredLayers || {})
      .filter((key) => key === feedKey || key.startsWith(`${feedKey}::compare::`))
      .forEach((key) => {
        const layer = this.currentFilteredLayers[key];
        if (layer && this.map.hasLayer(layer)) {
          this.removeVesselLabelLayer(layer);
          this.map.removeLayer(layer);
        }
        delete this.currentFilteredLayers[key];
      });
  }

  private cleanupAfterOperation() {
    this.spinnerService.hide();
    this.mapLoad = false;
    this.opManager.completeOperation();
  }

  loadFeedOnPNG(
    collectionIndex: number,
    sensorIndex: number,
    infoServiceIndex: number,
    event,
    info: any,
    config: any,
    compareOptions?: { isCompare: boolean; pane: 'left' | 'right' }
  ) {
    const sensor = this.collections[collectionIndex].sensors[sensorIndex];
    const infoServiceRow = sensor?.InfoServices?.[infoServiceIndex];
    const associatedFeedRow = sensor?.AssociatedFeeds?.[infoServiceIndex];
    const isAssociatedFeed = this.isAssociatedFeed(sensor, info);
    const activeScene = this.getActiveSceneForSensor(sensor);
    const selectedFeed =
      infoServiceRow === info
        ? infoServiceRow
        : associatedFeedRow === info
        ? associatedFeedRow
        : info;
    if (!selectedFeed) {
      return;
    }
    selectedFeed.checked = !!event.checked;

    const hasObservation = sensor.Observation.length > 0;
    const infy = hasObservation ? sensor.Observation[0] : selectedFeed;
    this.currentSelectedConfig = { config: config };
    const activeSceneId = activeScene?.id;

    const continueExecution = () => {
      if (event.checked) {
        selectedFeed.checked = true;

        if (infy?.modelType === this.infoserviceModelType) {
          this.spinnerService.show();
          this.mapLoad = true;

          let payload: any;
          if (sensor?.operatorKey === OPERATORS.AXELSPACE) {
            payload = {
              action:
                this.combinedScenes || isAssociatedFeed
                  ? 'sensorFeed'
                  : 'ISDisplay',
              feedId: info?._id,
              type: 'json',
              ...(isAssociatedFeed ? {} : { sceneId: sensor.id }),
              sensorId: isAssociatedFeed ? selectedFeed?.sensorId : sensor.id,
            };
          } else {
            payload = {
              action:
                this.combinedScenes || isAssociatedFeed
                  ? 'sensorFeed'
                  : 'ISDisplay',
              feedId: info?._id,
              type: 'json',
              ...(isAssociatedFeed || !activeSceneId
                ? {}
                : { sceneId: activeSceneId }),
              sensorId: isAssociatedFeed ? selectedFeed?.sensorId : sensor.id,
            };
          }
          this.spinnerService.show();
          this.getCollectionSub = this.apiService
            .getCollectionImage(this.collection.taskId, payload)
            .subscribe(
              async (res: any) => {
                await this.fetchAndCombineGeoJson(
                  res?.result?.feedData,
                  info,
                  sensor,
                  compareOptions
                );
              },
              (err) => {
                this.spinnerService.hide();
                this.mapLoad = false;
                this.cleanupAfterOperation();
              }
            );
        } else if (
          (this.combinedScenes || isAssociatedFeed) &&
          infy?.modelType !== this.infoserviceModelType
        ) {
          this.spinnerService.show();
          this.mapLoad = true;
          let payload = {
            customerid: this.currentUser?.id,
            feedId: info?._id,
            taskId: this.currentTaskId,
            sensorId: isAssociatedFeed ? associatedFeedRow.sensorId : this.collections[collectionIndex].sensors[sensorIndex].id,
          };

          this.apiService
            .getObjectDetectionData(payload)
            .pipe(takeUntil(this.destroy$))
            .subscribe({
              next: (res: any) => {
                const feedData = res?.result?.feedData;
                this.displayISNew({
                  insightFootprint: feedData,
                  isInfo: info,
                  sensor: sensor,
                }, info, sensor, !!compareOptions?.isCompare, compareOptions?.pane);

                this.displayedIS = {
                  insightFootprint: JSON.parse(JSON.stringify(feedData)),
                  isInfo: info,
                };
              },
              error: () => {
                this.spinnerService.hide();
                this.mapLoad = false;
              },
            });
        } else {
          // cached logic unchanged
          const cached = info?.insightDatas ?? [];
          if (cached.length > 0) {
            if (sensor?.operatorKey === OPERATORS.AXELSPACE) {
              this.displayISNew(cached[0], info, sensor, !!compareOptions?.isCompare, compareOptions?.pane);
              this.displayedIS = JSON.parse(JSON.stringify(cached[0]));
            } else {
              if(activeSceneId) {
              const s = info.insightDatas.find(
                (sc: any) => sc.sceneId === activeSceneId
              );
              if (s && info) s._id = info._id;
              this.displayISNew(s, info, sensor, !!compareOptions?.isCompare, compareOptions?.pane);
              this.displayedIS = JSON.parse(JSON.stringify(s));
            } else {
              this.scenIdList.forEach((sceneId) => {
              const s = info.insightDatas.find(
                (sc: any) => sc.sceneId === sceneId
              );
              if (s && info) s._id = info._id;
              this.displayISNew(s, info, sensor, !!compareOptions?.isCompare, compareOptions?.pane);
              this.displayedIS = JSON.parse(JSON.stringify(s));
            })
            }
          }
          } else {
            this.spinnerService.hide();
            this.mapLoad = false;
          }
          this.opManager.completeOperation();
        }
      }
    };

    if (!this.opManager.isOperationRunning) {
      continueExecution();
    }
  }

  unCheckISNew(
    collectionIndex: number,
    sensorIndex: number,
    infoServiceIndex: number
  ) {
    this.collections[collectionIndex].sensors[sensorIndex].InfoServices.forEach(
      (InfoService) => {
        if (
          InfoService._id ==
          this.collections[collectionIndex].sensors[sensorIndex].InfoServices[
            infoServiceIndex
          ]._id
        ) {
          InfoService.checked = true;
        } else {
          InfoService.checked = false;
        }
      }
    );
  }

  showFeedData(feedId: any, insightFootprint: any) {
    const config = feedsConfig[feedId];
    let filteredCollection: any = insightFootprint;
    if (config?.filterKey) {
      filteredCollection = this.getFilteredData(
        insightFootprint,
        config?.filterKey
      );
    }
    const count = filteredCollection?.features?.length ?? 0;
    const firstAreaHa =
      filteredCollection?.features?.[0]?.properties?.area_ha ?? null;
    return filteredCollection;
  }

  showNoMatchesMessage(type:string) {
    const vessel = type === 'vessel' ? 'vessels' : 'aircrafts';
    const message = `There are no ${vessel} meeting the search criteria.`;
    this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
  }

  private showNoInformationExtractedPopup(): void {
    const formattedDate = formatDate(
      this.taskCreatedDate,
      'dd/MM/yyyy',
      'en-US'
    );
    const message = `There is no information extracted from the tasked data for ${this.taskName} submitted on ${formattedDate} as the observation of interest is not present.`;
    this.popupService.openPopup(
      CollectionPopupComponent,
      message,
      'pleaseNote',
      '40%'
    );
  }

  private uncheckFeedAfterEmptyResult(feed: any): void {
    if (!feed) {
      return;
    }

    feed.checked = false;
    if (feed?.prediction_info_ordered === false && this.predictionDrift.activeSourceFeed === feed) {
      this.resetPredictionDriftPanel();
    }
    delete feed._changeDetectionComparePane;
  }

  private removeTooltip(owner?: L.Layer) {
    if (owner && this.currentTooltipOwner !== owner) return;
    if (this.currentTooltip) {
      this.map.removeLayer(this.currentTooltip);
      this.currentTooltip = null;
    }
    this.currentTooltipOwner = null;
  }

  private isPredictionConfig(config: any): boolean {
    return isPredictionFeedType(config?.type);
  }

  private liftPredictionLayer(layer: any): void {
    const paneName = layer?.options?.pane;
    const pane = paneName ? this.map?.getPane(paneName) : null;
    if (pane) {
      pane.style.zIndex = this.predictionPaneZIndex;
    }
    layer?.bringToFront?.();
  }

  displayISNew(sceneISInfo: any, feed: any = null, sensor: any = null, isCompare: boolean = false , pane?) {
    this.spinnerService.show();
    if (isCompare) {
      this.syncStandardCompareSideData();
    }
    this.mapLoad = true;
    if (!(this.map as any).getPane('markersPane')) {
      this.map.createPane('markersPane');
      (this.map as any).getPane('markersPane').style.zIndex = 2600;
    }
    if (!(this.map as any).getPane('geojsonpane')) {
      this.map.createPane('geojsonpane');
      (this.map as any).getPane('geojsonpane').style.zIndex = 2500;
    }

    if(pane === 'left' && this.leftComparisonObjectLayer && this.map.hasLayer(this.leftComparisonObjectLayer)){
      this.map.removeLayer(this.leftComparisonObjectLayer);
      this.leftComparisonObjectLayer = null;
      this.leftFeedPanels.clear();
      this.clearCompareFeedCache('left');
    }
    
    if(pane === 'right' && this.rightComparisonObjectLayer && this.map.hasLayer(this.rightComparisonObjectLayer)){
      this.map.removeLayer(this.rightComparisonObjectLayer);
      this.rightComparisonObjectLayer = null;
      this.rightFeedPanels.clear();
      this.clearCompareFeedCache('right');
    }

if (pane === 'left') {
  this.leftFeedPanels.clear();
}

if (pane === 'right') {
  this.rightFeedPanels.clear();
}

    this.feedLoaded = true;
    if (!sceneISInfo) {
      this.hideMapLoaderWhenPngGeoJsonIdle();
      return;
    }

    let feedName =
      feed?.feedName ||
      sceneISInfo?.isInfo?.feedName ||
      sceneISInfo?.feedName ||
      sceneISInfo?.isInfo?.name ||
      sceneISInfo?.name ||
      feed?.name;
    let feedId = sceneISInfo?.isInfo
      ? sceneISInfo?.isInfo?._id
      : sceneISInfo?._id || feed?._id;
    let config: any = feedsConfig[feedId];
    // Fallback: detect Vehicle-classification by feed name when real DB ID is not yet in feedsConfig
    if (!config) {
      const _n = (feedName || '').toLowerCase().replace(/[\s_]+/g, '-');
      if (_n.includes('vehicle-classification')) {
        config = Object.values(feedsConfig).find((c: any) => c?.type === 'Vehicle-classification');
      }
    }
    const feedKey = this.getFeedKey(sceneISInfo, config);
     if(isCompare)
     this.removeFeedPanel(feedKey);
    const storageKey = isCompare && pane ? `${feedKey}::compare::${pane}` : feedKey;
    const existingFeedLayer = this.feedLayers[storageKey] as any;
    if (existingFeedLayer && !isCompare) {
      if (this.map.hasLayer(existingFeedLayer)) {
        try {
          this.map.fitBounds(existingFeedLayer.getBounds());
        } catch (e) {}
        this.hideMapLoaderWhenPngGeoJsonIdle();
        if (this.isPredictionConfig(config)) {
        this.liftPredictionLayer(this.feedLayers[feedKey]);
      }
      return;
      }

      // Cached layer reference is stale (not on map) - force a fresh render.
      delete this.feedLayers[storageKey];
    }

    const isUpperCase =
      config?.type === 'Vessel' || config?.type === 'Transshipment' || config?.type === 'Transhipment';
    this.vessel =
      config?.type === 'Ship' ||
      config?.type === 'Vessel' ||
      config?.type === 'Transshipment' ||
      config?.type === 'Transhipment';
    this.feedInfo = true;
    this.feedData = '';
    this.oilSpil = false;

    const index = this.nonVesselFeed.findIndex(
      (item) => item.name === feedName
    );
    this.vessel = index === -1 && !isPredictionFeedType(config?.type);
    const rawFC = this.asFeatureCollection(sceneISInfo);
    if (this.isEmptyWfsDataset(rawFC)) {
      this.feedLoaded = false;
      this.uncheckFeedAfterEmptyResult(feed ?? sceneISInfo?.isInfo ?? sceneISInfo);
      this.showNoInformationExtractedPopup();
      this.hideMapLoaderWhenPngGeoJsonIdle();
      return;
    }
    const insightFootprint = sceneISInfo?.insightFootprint;
    let filteredCollection = this.getFilteredData(rawFC, 'wake');
    if (config?.filterKey) {
      filteredCollection = this.getFilteredData(rawFC, config?.filterKey);
    }
    const featureCount = filteredCollection?.features?.length ?? 0;

    const isExists = sceneISInfo?.isInfo?.insightDatas?.length > 0;
    let count = 0;
    const changeDetectionHistoryFeedResults =
      sceneISInfo?._changeDetectionHistoryFeedResults ??
      sceneISInfo?.isInfo?._changeDetectionHistoryFeedResults;
    const isChangeDetectionTask = this.isChangeDetectionTask(
      sceneISInfo?.taskStrategy ??
        feed?.taskStrategy ??
        sensor?.taskStrategy ??
        this.collection?.taskStrategy
    );
    let isChangeDetectionHistoryFeedResultEmpty = false;

    if (isChangeDetectionTask) {
      const hasChangeDetectionHistoryFeedResult =
        Object.prototype.hasOwnProperty.call(
          sceneISInfo ?? {},
          '_changeDetectionHistoryFeedResults'
        ) ||
        Object.prototype.hasOwnProperty.call(
          sceneISInfo?.isInfo ?? {},
          '_changeDetectionHistoryFeedResults'
        );
      isChangeDetectionHistoryFeedResultEmpty =
        hasChangeDetectionHistoryFeedResult &&
        (changeDetectionHistoryFeedResults == null ||
          changeDetectionHistoryFeedResults === '');
    }

    if (
      changeDetectionHistoryFeedResults != null &&
      changeDetectionHistoryFeedResults !== ''
    ) {
      count = changeDetectionHistoryFeedResults;
    } else if (isPredictionFeedType(config?.type)) {
      count = sceneISInfo?.isInfo?.feed_results ?? feed?.feed_results ??
        sceneISInfo?.sensor?.feed_results ?? insightFootprint?.feed_results;
    } else if (!isUpperCase && isExists && !this.combinedScenes) {
      count =
        sceneISInfo?.isInfo?.insightDatas[0]?.insightFootprint?.feed_results;
    } else if (this.combinedScenes) {
      count = sceneISInfo.sensor?.feed_results;
    } else {
      count = sceneISInfo?.insightFootprint?.feed_results;
    }

    if (isPredictionFeedType(config?.type) && isEmptyPredictionFeedResult(count)) {
      this.feedLoaded = false;
      this.uncheckFeedAfterEmptyResult(feed ?? sceneISInfo?.isInfo ?? sceneISInfo);
      this.showNoInformationExtractedPopup();
      this.hideMapLoaderWhenPngGeoJsonIdle();
      return;
    }

    if (isChangeDetectionHistoryFeedResultEmpty && featureCount > 0) {
      this.showNoInformationExtractedPopup();
    }

    const key = this.getFeedKey(sceneISInfo, config);
    const feed_results = count ?? 0;
    const feedResultsForSections =
      isPredictionFeedType(config?.type)
        ? this.predictionFeedController.buildFeedResultsForSections(
            feed_results
          )
        : feed_results;
    const displayColor = this.getFeedDisplayColor(sceneISInfo?.sensor,  sceneISInfo?.isInfo, config);
    const vm = this.helperService.buildFeedSections(
      config,
      feedResultsForSections,
      displayColor
    );
    this.feedSections = vm.sections;
    const titleFallbackInput =
      feed?.feedName ||
      sceneISInfo?.isInfo?.feedName ||
      sceneISInfo?.feedName ||
      sceneISInfo?.isInfo?.name ||
      sceneISInfo?.name ||
      feed?.name;
    const title = this.feedTitleOf(
      config,
      titleFallbackInput
    );
    const color = displayColor;
    const fcRendered: FeatureCollection<Geometry, FeatureProps> =
      filteredCollection?.type === 'FeatureCollection'
        ? filteredCollection
        : {
            type: 'FeatureCollection',
            features: filteredCollection?.features ?? [],
          };

    this.geoByFeed.set(key, {
      fc: {
        ...fcRendered,
        feed_results,
        forecast_details: feed?.forecast_details ?? sceneISInfo?.isInfo?.forecast_details ??
          insightFootprint?.forecast_details,
      } as any,
      type: config?.type,
      color,
      title,
      feed_results,
    });
    this.activeFeedKeys.add(key);
    // Latest Change tab feeds never contribute a legend while change history compare is active.
    const isCurrentWeekTabFeed =
      isChangeDetectionTask &&
      !key.includes('::history::') &&
      this.changeDetectionHistorySelections.length > 0;
    if (isCurrentWeekTabFeed) {
      this.removeFeedPanel(key);
    } else if (isCompare && pane === 'left') {
      this.addLeftFeedPanel(key, title, color, this.feedSections);
    } else if (isCompare && pane === 'right') {
      this.addRightFeedPanel(key, title, color, this.feedSections);
    } else {
      const predictionLegendGroups = this.isPredictionConfig(config)
        ? buildPredictionLegendGroupsFromResults(
            feed_results,
            config,
            String(color ?? '#FF00FF'),
            key
          )
        : undefined;
      this.addFeedPanel(key, title, color, this.feedSections, predictionLegendGroups);
    }
    this.feedUi = vm.ui;

    if (!(filteredCollection?.features?.length > 0) && !(rawFC as any)?._viewportGeojson) {
      this.feedLoaded = false;
      this.uncheckFeedAfterEmptyResult(feed ?? sceneISInfo?.isInfo ?? sceneISInfo);
      this.showNoInformationExtractedPopup();
      this.hideMapLoaderWhenPngGeoJsonIdle();
      return;
    }
const isAssociatedFeedLayer = this.isAssociatedFeed(
  sceneISInfo?.sensor,
  sceneISInfo?.isInfo ?? feed
);
let paneName = isCompare && (pane === 'left' || pane === 'right')
  ? `${pane}-objects`
  : isAssociatedFeedLayer
    ? `associated-feed-pane-${feedKey}`
    : this.isPredictionConfig(config) && !isCompare
    ? `prediction-pane-${feedKey}`
    : 'geojsonpane';

if (!this.map.getPane(paneName)) {
  this.map.createPane(paneName);
}

const paneEl = this.map.getPane(paneName);
if (paneEl) {
  paneEl.style.zIndex = isAssociatedFeedLayer ? '100000' : '2500';

  if (config?.colorMode === 'CLASS_BASED') {
    paneEl.style.zIndex = '1500';
  } else if (sceneISInfo?.isInfo?.modelType !== this.infoserviceModelType) {
    paneEl.style.zIndex = '9999';
  }

  if (isAssociatedFeedLayer) {
    paneEl.style.zIndex = '100000';
  }

  if (this.isPredictionConfig(config) && !isCompare) {
    paneEl.style.zIndex = this.predictionPaneZIndex;
  }
}

const objectPane =
  paneName;

    const layer = this.buildFeedGeoJsonLayer(
      fcRendered,
      config,
      color,
      feedName,
      objectPane
    );
    if (isCompare && pane) {
      (layer as any)._changeDetectionComparePane = pane;
    }
    this.feedLayers[storageKey] = layer;
    this.registerViewportGeojsonSessionFromSource(
      storageKey, key, rawFC, config?.filterKey ?? 'wake',
      this.getActiveFeedWmsLayer({ isCompare, pane })
    );
    if(!isCompare) {
    if (config?.colorMode === 'CLASS_BASED') {
      layer.addTo(this.map);
      layer.bringToBack();
    } else {
      const type = filteredCollection?.type;
      if (type === 'ObjectCollection') {
        // ObjectCollection -> always on top
        layer.addTo(this.map);
        layer.options.isObjectLayer = true;
        this.bringObjectLayersToFront();
      } else if (type === 'FeatureCollection') {
        // FeatureCollection -> always below
        layer.addTo(this.map);
      } else {
        layer.addTo(this.map);
      }

      if (isAssociatedFeedLayer) {
        layer.bringToFront();
      }
      if (this.isPredictionConfig(config)) {
        this.liftPredictionLayer(layer);
      }
    }
  } else {
    if (pane === 'left' || pane === 'right') {
      this.compareFeedCache[pane] = {
        side: pane,
        fc: fcRendered,
        config,
        color,
        paneName: objectPane,
        feedName,
      };
    }

    if(pane && pane == 'left') {
      this.leftComparisonObjectLayer  = layer;
      layer.addTo(this.map);
    } else if(pane && pane == 'right') {
      this.rightComparisonObjectLayer  = layer;
      layer.addTo(this.map);
    }

    this.ensureChangeDetectionHistorySplitMap();
  
    if(isCompare && (this.rightComparisonObjectLayer || this.rightImageNew) && (this.leftComparisonObjectLayer  || this.leftImageNew)) {
      const mapWidth = (this.map.getSize().x);
    this.updateObjectVisibility(this.lastSliderValue === 0 ? mapWidth/2 : this.lastSliderValue);
    this.needsCompareResetToCenter = false;
    }
  }

    const predictionInfo = sceneISInfo?.isInfo ?? feed ?? sceneISInfo;
    const isPredictionDriftFeed =
      !isCompare &&
      !isAssociatedFeedLayer &&
      predictionInfo?.prediction_info_ordered === false;

    if (isPredictionDriftFeed && this.predictionDrift.activeSourceFeed === predictionInfo) {
      this.predictionDrift.registerPredictionDetectionLayer(layer as L.Layer);
    }

    this.feedLayers[feedKey] = layer;
    if (!isCompare && this.isPredictionConfig(config)) {
      this.liftPredictionLayer(layer);
    }
    if (!isCompare && isPredictionFeedType(config?.type)) {
      this.registerPredictionTimeseries(
        feedKey,
        feed ?? sceneISInfo?.isInfo ?? sceneISInfo,
        fcRendered,
        layer
      );
    }

    this.spinnerService.hide();
  if(!isCompare && !(rawFC as any)?._viewportGeojson) {
    try {
      this.map.fitBounds(layer.getBounds());
    } catch (e) {}
  }
    this.hideMapLoaderWhenPngGeoJsonIdle();
  }

  private bringObjectLayersToFront(): void {
    Object.values(this.currentFilteredLayers).forEach((layer: any) => {
      if (layer?.isObjectLayer && layer.bringToFront) {
        layer.bringToFront();
      }
    });
  }

  // Normalize to a FeatureCollection
  private asFeatureCollection(x: any): FeatureCollection {
    if (x?.type === 'FeatureCollection') return x;
    if (x?.insightFootprint?.type === 'FeatureCollection')
      return x.insightFootprint;
    const features = x?.insightFootprint?.features ?? x?.features ?? [];
    return { type: 'FeatureCollection', features };
  }

  private rebuildCombined(): void {
    const out: FeedSection[] = [];
    const predictionGroups: PredictionLegendGroup[] = [];

    const combinedSection: FeedSection = {
      show: false,
      className: '',
      style: {},
      items: [],
    };

    for (const { sections, predictionLegendGroups } of this.feedPanels.values()) {
      if (predictionLegendGroups?.length) {
        predictionGroups.push(...predictionLegendGroups);
        continue;
      }

      for (const s of sections) {
        combinedSection.className = s.className;
        combinedSection.items.push(...s.items);
        combinedSection.show = combinedSection.items.length > 0;
      }
    }

    if (combinedSection.items.length > 0) {
      if (combinedSection.show) out.push(combinedSection);
    }

    this.combinedFeedSections = out;
    this.predictionLegendGroups = predictionGroups;
    this.feedInfo =
      this.combinedFeedSections.length > 0 || this.predictionLegendGroups.length > 0;
  }

  get feedLegendItemCount(): number {
    return this.combinedFeedSections.reduce((sum, s) => sum + s.items.length, 0);
  }

  get predictionExtraLegendItems(): FeedLine[] {
    return this.combinedFeedSections.flatMap((section) => section.items ?? []);
  }

  private addFeedPanel(
    key: string,
    title: string,
    color: string | SoilMoistureSarClassMap | undefined,
    sections: FeedSection[],
    predictionLegendGroups?: PredictionLegendGroup[]
  ): void {
    const panes = this.legendController?.panes(key) ?? [];
    if (panes.length && !panes.includes('normal')) {
      if (panes.includes('left') && this.leftFeedPanels.has(key)) this.addLeftFeedPanel(key, title, color, sections);
      if (panes.includes('right') && this.rightFeedPanels.has(key)) this.addRightFeedPanel(key, title, color, sections);
      return;
    }
    sections = this.legendSections(key, 'normal', sections);
    const next = new Map(this.feedPanels);
    next.set(key, { title, color, sections, predictionLegendGroups });
    this.feedPanels = next;
    this.rebuildCombined();
  }

  private addLeftFeedPanel(
  key: string,
  title: string,
  color: string | SoilMoistureSarClassMap | undefined,
  sections: FeedSection[]
): void {
  sections = this.legendSections(key, 'left', sections);
  const next = new Map(this.leftFeedPanels);
  next.set(key, { title, color, sections });
  this.leftFeedPanels = next;
}

private addRightFeedPanel(
  key: string,
  title: string,
  color: string | SoilMoistureSarClassMap | undefined,
  sections: FeedSection[]
): void {
  sections = this.legendSections(key, 'right', sections);
  const next = new Map(this.rightFeedPanels);
  next.set(key, { title, color, sections });
  this.rightFeedPanels = next;
}

private removeLeftFeedPanel(key: string): void {
  this.removeLegendSummaries(key, 'left');
  if (!this.leftFeedPanels.has(key)) return;
  const next = new Map(this.leftFeedPanels);
  next.delete(key);
  this.leftFeedPanels = next;
}

private removeRightFeedPanel(key: string): void {
  this.removeLegendSummaries(key, 'right');
  if (!this.rightFeedPanels.has(key)) return;
  const next = new Map(this.rightFeedPanels);
  next.delete(key);
  this.rightFeedPanels = next;
}


  // Remove a feed’s panel by key
  private removeFeedPanel(key: string): void {
    this.removeLegendSummaries(key, 'normal');
    if (!this.feedPanels.has(key)) return;
    const next = new Map(this.feedPanels);
    next.delete(key);
    this.feedPanels = next;
    this.rebuildCombined();
  }

  private getObservationFeedPanelKey(): string {
    return '__observation_vessel_length__';
  }

  private clearObservationFeedPanel(): void {
    this.removeFeedPanel(this.getObservationFeedPanelKey());
  }

  private getFeedKey(feed: any, config: any): string {
    return String(
      feed?._changeDetectionHistoryFeedKey ??
        feed?.isInfo?._changeDetectionHistoryFeedKey ??
        feed?._id ??
        feed?.isInfo?._id ??
        feed?.id ??
        config?.type ??
        Date.now()
    );
  }

  private feedTitleOf(config?: { type?: string }, fallback?: string): string {
    return fallback || config?.type || 'Information Service';
  }

  getFilteredData(jsonData: any, className: string) {
    const filteredFeatures = jsonData.features.filter(
      (feature) => feature?.properties?.class != className
    );
    return {
      type: jsonData.type,
      crs: jsonData.crs,
      features: filteredFeatures,
      metadata: jsonData?.metadata,
      feed_results: jsonData?.feed_results,
      forecast_details: jsonData?.forecast_details,
    };
  }


  private getSensorFilterScopeKey(sensor: any, sensorIndex?: number): string {
    const stableId =
      sensor?.filterScopeKey ??
      sensor?.id ??
      sensor?.sensorId ??
      sensor?._id ??
      sensor?.questionId ??
      sensor?.questionName ??
      sensor?.name ??
      sensorIndex ??
      'unknown';

    return String(stableId);
  }

  private getSensorFilterState(sensor: any, sensorIndex?: number): SensorScopedFilterState {
    const scopeKey = this.getSensorFilterScopeKey(sensor, sensorIndex);

    let state = this.sensorFilterStates.get(scopeKey);
    if (!state) {
      state = {
        selectedFilterType: null,
        filtersByType: new Map<string, { feedKeys: string[]; value: any; isGreater?: boolean }>(),
      };
      this.sensorFilterStates.set(scopeKey, state);
    }

    return state;
  }

  private activateSensorFilterScope(sensor: any, sensorIndex?: number): SensorScopedFilterState {
    const scopeKey = this.getSensorFilterScopeKey(sensor, sensorIndex);
    this.activeFilterScopeKey = scopeKey;
    return this.getSensorFilterState(sensor, sensorIndex);
  }

  private getMergedFiltersByType(): Map<
    string,
    { feedKeys: string[]; value: any; isGreater?: boolean }
  > {
    const merged = new Map<
      string,
      { feedKeys: string[]; value: any; isGreater?: boolean }
    >();

    for (const [type, fs] of this.filtersByType.entries()) {
      merged.set(type, {
        feedKeys: [...(fs.feedKeys || [])],
        value: fs.value,
        isGreater: fs.isGreater,
      });
    }

    for (const state of this.sensorFilterStates.values()) {
      for (const [type, fs] of state.filtersByType.entries()) {
        const prev = merged.get(type);
        if (!prev) {
          merged.set(type, {
            feedKeys: [...(fs.feedKeys || [])],
            value: fs.value,
            isGreater: fs.isGreater,
          });
          continue;
        }

        merged.set(type, {
          feedKeys: Array.from(
            new Set([...(prev.feedKeys || []), ...(fs.feedKeys || [])])
          ),
          value: fs.value ?? prev.value,
          isGreater: fs.isGreater ?? prev.isGreater,
        });
      }
    }

    return merged;
  }

  private getAvailableFilterTypesForSensor(sensor: any, onlyChecked = false): AvailableFeedFilterType[] {
    return this.feedFilterService.getAvailableFilterTypesForSensor(sensor, onlyChecked);
  }

  shouldShowFilterOption(sensor: any): boolean {
    return this.feedFilterService.shouldShowFilterOption(sensor);
  }

  isFilterOptionDisabled(sensor: any): boolean {
    return this.feedFilterService.isFilterOptionDisabled(sensor, this.mapLoad);
  }

  getFilterTooltipForSensor(sensor: any, sensorIndex?: number): string {
    return this.feedFilterService.getFilterTooltip(
      sensor,
      this.getSensorFilterState(sensor, sensorIndex),
      this.mapLoad
    );
  }

  private buildSingleFeedFilterScope(infoService: any): any {
    return this.feedFilterService.buildSingleFeedScope(infoService);
  }

  shouldShowFilterOptionForFeed(infoService: any): boolean {
    return this.shouldShowFilterOption(this.buildSingleFeedFilterScope(infoService));
  }

  isFilterOptionDisabledForFeed(infoService: any): boolean {
    return this.isFilterOptionDisabled(this.buildSingleFeedFilterScope(infoService));
  }

  getFilterTooltipForFeed(infoService: any, sensorIndex?: number): string {
    return this.getFilterTooltipForSensor(this.buildSingleFeedFilterScope(infoService), sensorIndex);
  }

  openFilterForFeed(sensor: any, sensorIndex: number, infoService: any, isCompare?: boolean): void {
    this.openFilterForSensor(this.buildSingleFeedFilterScope(infoService), sensorIndex, isCompare);
  }


  // ============ HELPER: Get all available filter types across SELECTED feeds (Type-Centric) ============
  private getAvailableFilterTypes(): AvailableFeedFilterType[] {
    return this.feedFilterService.getAvailableFilterTypesForFeedKeys(
      Array.from(this.activeFeedKeys)
    );
  }

  openFilter(isCompare?: boolean) {
    // ============ TYPE-CENTRIC: Get all available filter types ============
    const availableFilterTypes = this.getAvailableFilterTypes();
    
    // ============ CONDITIONAL UI LOGIC ============
    // If multiple filter types available: Show new dynamic UI (Filter Type selector + dynamic secondary controls)
    // If single filter type available: Use existing filter logic for that type
    // If no filter types: Show default vessel length filter
    
    if (availableFilterTypes.length > 1) {
      const activeType = this.selectedFilterType;
      const selectedFilter =
        availableFilterTypes.find((item) => item.type === activeType) ||
        availableFilterTypes[0];

      this.selectedFilterType = selectedFilter.type;
      this.openFilterForType(selectedFilter, isCompare);
      return;
    }
    
    if (availableFilterTypes.length === 1) {
      // ============ SINGLE FILTER TYPE: Use existing filter dialog for that type ============
      const filterType = availableFilterTypes[0];
      this.selectedFilterType = filterType.type;
      this.openFilterForType(filterType, isCompare);
      return;
    }

    // ============ DEFAULT: No filter types available - show Vessel Length Filter ============
    const dialogRef = this.matdialog.open(FilterPopupComponent, {
      width: '35%',
      backdropClass: 'blurr',
      disableClose: true,
      data: { type: 'vessel', isCompare: isCompare ?? false },
    });
    dialogRef
      .afterClosed()
      .pipe(take(1))
      .subscribe((result) => {
        if (!result) return;
        const threshold = Number(result.length);
        this.handleVesselLengthFilter({ ...result, length: threshold });
      });
  }

  openFilterForSensor(sensor: any, sensorIndex: number, isCompare?: boolean): void {
    if (this.isFilterOptionDisabled(sensor)) {
      return;
    }

    const availableFilterTypes = this.getAvailableFilterTypesForSensor(sensor, true);
    if (availableFilterTypes.length === 0) {
      return;
    }

    const state = this.activateSensorFilterScope(sensor, sensorIndex);

    const filterType =
      availableFilterTypes.find((item) => item.type === state.selectedFilterType) ||
      availableFilterTypes[0];
    state.selectedFilterType = filterType.type;
    this.openFilterTypeForSensor(sensor, sensorIndex, filterType, isCompare);
  }

  private openFilterTypeForSensor(
    sensor: any,
    sensorIndex: number,
    filterType: AvailableFeedFilterType,
    isCompare?: boolean
  ): void {
    const state = this.getSensorFilterState(sensor, sensorIndex);
    const {
      type,
      label,
      feedKeys,
      colorMap,
      isVesselLength,
      isPrediction,
      popupLabel,
      placeholderLabel,
    } = filterType;
    
    const isAircraftLength = type === 'aircraftLength';
    if (isVesselLength) {
      const dialogRef = this.matdialog.open(FilterPopupComponent, {
        width: '35%',
        backdropClass: 'blurr',
        disableClose: true,
        data: {
          type: 'vessel',
          filterLabel: isAircraftLength ? 'Filter by aircraft length' : 'Filter by vessel length',
          isCompare: isCompare ?? false,
          currentFilterState: state.filtersByType.get(type),
        },
      });

      dialogRef
        .afterClosed()
        .pipe(take(1))
        .subscribe((result) => {
          if (!result) return;

          if (result.clear) {
            this.clearFilterForSensor(sensor, sensorIndex, type);
            return;
          }

          const activeState = this.activateSensorFilterScope(sensor, sensorIndex);
          activeState.selectedFilterType = type;
          activeState.filtersByType.set(type, {
            feedKeys,
            value: Number(result.length),
            isGreater: result.isGreater,
          });

          if (isAircraftLength) {
            this.handleAircraftLengthFilterByType(type, feedKeys, { ...result, length: result.length });
          } else {
            this.handleVesselLengthFilterByType(type, feedKeys, { ...result, length: result.length });
          }
        });

      return;
    }

    if (isPrediction) {
      this.predictionFeedController.openScopedFilterDialog({
        sensor,
        sensorIndex,
        filterType,
        state,
        isCompare,
      });
      return;
    }

    const dialogRef = this.matdialog.open(FilterPopupComponent, {
      width: '35%',
      backdropClass: 'blurr',
      disableClose: true,
      data: {
        type: 'classFilter',
        colorMap,
        filterLabel: popupLabel || label,
        placeholderLabel: placeholderLabel || popupLabel || label,
        currentFilterState: state.filtersByType.get(type),
        isCompare: isCompare ?? false,
      },
    });

    dialogRef
      .afterClosed()
      .pipe(take(1))
      .subscribe((result) => {
        if (!result) return;

        if (result.clear) {
          this.clearFilterForSensor(sensor, sensorIndex, type);
          return;
        }

        if (!result.value) return;

        const activeState = this.activateSensorFilterScope(sensor, sensorIndex);
        activeState.selectedFilterType = type;
        activeState.filtersByType.set(type, {
          feedKeys,
          value: result.value,
        });

        this.handleClassBasedFilterByType(type, feedKeys, result.value);
      });
  }

  private clearFilterForSensor(sensor: any, sensorIndex: number, filterType: string): void {
    const state = this.getSensorFilterState(sensor, sensorIndex);
    const clearedFeedKeys = state.filtersByType.get(filterType)?.feedKeys ?? this.filtersByType.get(filterType)?.feedKeys;
    state.filtersByType.delete(filterType);
    this.filtersByType.delete(filterType);

    if (state.selectedFilterType === filterType) {
      state.selectedFilterType = null;
    }

    const mergedFilters = this.getMergedFiltersByType();

    const remainingAircraftFilter = Array.from(mergedFilters.entries()).find(
      ([type, f]) => type === 'aircraftLength' && !!f && (f.feedKeys?.length ?? 0) > 0
    );

    if (remainingAircraftFilter) {
      const [nextType, nextFilter] = remainingAircraftFilter;
      state.selectedFilterType = nextType;
      this.handleAircraftLengthFilterByType(nextType, nextFilter.feedKeys, {
        length: Number(nextFilter.value),
        isGreater: !!nextFilter.isGreater,
      });
      return;
    }

    const remainingPredictionFilter = Array.from(mergedFilters.entries()).find(
      ([type, f]) => isPredictionFilterType(type) && !!f && (f.feedKeys?.length ?? 0) > 0
    );

    if (remainingPredictionFilter) {
      const [nextType, nextFilter] = remainingPredictionFilter;
      state.selectedFilterType = nextType;
      this.predictionFeedController.applyFilter(nextFilter.feedKeys, nextFilter.value);
      return;
    }

    const remainingClassFilter = Array.from(mergedFilters.entries()).find(
      ([type, f]) =>
        type !== 'vesselLength' && type !== 'aircraftLength' &&
        !isPredictionFilterType(type) &&
        !!f &&
        (f.feedKeys?.length ?? 0) > 0
    );

    if (remainingClassFilter) {
      const [nextType, nextFilter] = remainingClassFilter;
      state.selectedFilterType = nextType;
      this.handleClassBasedFilterByType(
        nextType,
        nextFilter.feedKeys,
        String(nextFilter.value ?? '')
      );
      return;
    }

    const remainingVesselFilter = mergedFilters.get('vesselLength');
    if (remainingVesselFilter && (remainingVesselFilter.feedKeys?.length ?? 0) > 0) {
      state.selectedFilterType = 'vesselLength';
      this.handleVesselLengthFilterByType('vesselLength', remainingVesselFilter.feedKeys, {
        length: Number(remainingVesselFilter.value),
        isGreater: !!remainingVesselFilter.isGreater,
      });
      return;
    }

    this.clearFilterByType(filterType, clearedFeedKeys);
  }

private clearFeedFilterState(feedKey: string, sensor?: any, sensorIndex?: number): void {
  const key = String(feedKey || '');
  if (!key) return;

  const scopedState = sensor ? this.sensorFilterStates.get(this.getSensorFilterScopeKey(sensor, sensorIndex)) : null;
  const states = scopedState ? [scopedState] : Array.from(this.sensorFilterStates.values());

  for (const state of states) {
    for (const [type, filterState] of Array.from(state.filtersByType.entries())) {
      const nextFeedKeys = (filterState.feedKeys || []).filter((fk) => String(fk) !== key);
      if (nextFeedKeys.length === 0) {
        state.filtersByType.delete(type);
        if (state.selectedFilterType === type) {
          state.selectedFilterType = null;
        }
      } else if (nextFeedKeys.length !== filterState.feedKeys.length) {
        state.filtersByType.set(type, { ...filterState, feedKeys: nextFeedKeys });
      }
    }
  }

  if (sensor) return;

  for (const [type, filterState] of Array.from(this.filtersByType.entries())) {
    const nextFeedKeys = (filterState.feedKeys || []).filter((fk) => String(fk) !== key);
    if (nextFeedKeys.length === 0) {
      this.filtersByType.delete(type);
      if (this.selectedFilterType === type) {
        this.selectedFilterType = null;
      }
    } else if (nextFeedKeys.length !== filterState.feedKeys.length) {
      this.filtersByType.set(type, { ...filterState, feedKeys: nextFeedKeys });
    }
  }
}

  // ============ TYPE-CENTRIC: Open appropriate filter dialog for selected type ============
  private openFilterForType(filterType: any, isCompare?: boolean): void {
    const {
      type,
      label,
      feedKeys,
      colorMap,
      isVesselLength,
      isPrediction,
      popupLabel,
      placeholderLabel,
    } = filterType;
    
    if (isVesselLength) {
      const isAircraftLength = type === 'aircraftLength';

      const dialogRef = this.matdialog.open(FilterPopupComponent, {
        width: '35%',
        backdropClass: 'blurr',
        disableClose: true,
        data: { 
          type: 'vessel', 
          filterLabel: isAircraftLength ? 'Filter by aircraft length' : 'Filter by vessel length',
          isCompare: isCompare ?? false,
          currentFilterState: this.filtersByType.get(type) 
        },
      });
      
      dialogRef
        .afterClosed()
        .pipe(take(1))
        .subscribe((result) => {
          if (!result) return;
          if (result?.clear) {
            this.filtersByType.delete(type);
            this.clearFilterByType(type);
            return;
          }
          
          const threshold = Number(result.length);
          this.filtersByType.set(type, {
            feedKeys,
            value: threshold,
            isGreater: result.isGreater
          });
          
          if (isAircraftLength) {
            this.handleAircraftLengthFilterByType(type, feedKeys, { ...result, length: threshold });
          } else {
            this.handleVesselLengthFilterByType(type, feedKeys, { ...result, length: threshold });
          }
        });
      return;
    }

    if (isPrediction) {
      this.predictionFeedController.openGlobalFilterDialog({
        filterType,
        currentFilterState: this.filtersByType.get(type),
        isCompare,
      });
      return;
    }

    // CLASS_BASED filter (class filter)
    if (colorMap) {
      const dialogRef = this.matdialog.open(FilterPopupComponent, {
        width: '35%',
        backdropClass: 'blurr',
        disableClose: true,
        data: {
          type: 'classFilter',
          colorMap: colorMap,
          filterLabel: popupLabel || label,
          placeholderLabel: placeholderLabel || popupLabel || label,
          currentFilterState: this.filtersByType.get(type),
          isCompare: isCompare ?? false,
        },
      });

      dialogRef
        .afterClosed()
        .pipe(take(1))
        .subscribe((result) => {
          if (!result) return;
          
          if (result?.clear) {
            this.filtersByType.delete(type);
            this.clearFilterByType(type);
            return;
          }
          
          if (!result?.value) return;
          
          this.filtersByType.set(type, {
            feedKeys,
            value: result.value
          });
          
          this.handleClassBasedFilterByType(type, feedKeys, result.value);
        });
      return;
    }
  }

  handleVesselLengthFilter(result: any) {
    if (this.viewportGeojsonRender.size) {
      const feedKeys = [...this.activeFeedKeys].filter(key =>
        ['Ship', 'Vessel', 'Transshipment', 'Transhipment'].includes(this.geoByFeed.get(key)?.type ?? '')
      );
      this.filtersByType.set('vesselLength', { feedKeys, value: Number(result.length), isGreater: !!result.isGreater });
      this.handleVesselLengthFilterByType('vesselLength', feedKeys, result);
      return;
    }
    const lenLimit = Number(result.length);
    const keepGreater = !!result.isGreater;

    if(!result.isCompare) {
    this.clearFilteredLayerAndRestore(true);
    this.removeISLayers();
    this.feedPanels.clear();
    const vesselPane =
      this.map.getPane('vesselPane') || this.map.createPane('vesselPane');
    vesselPane.style.zIndex = '9999';
    vesselPane.style.pointerEvents = 'auto';

    const nonVesselPane =
      this.map.getPane('nonVesselPane') || this.map.createPane('nonVesselPane');
    nonVesselPane.style.zIndex = '7000';
    nonVesselPane.style.pointerEvents = 'auto';

    const activeEntries: Array<
      [
        string,
        { fc: FeatureCollection; type?: string; color?: string; title: string }
      ]
    > = [];
    for (const key of this.activeFeedKeys) {
      const entry = this.geoByFeed.get(key);
      if (entry) activeEntries.push([key, entry]);
    }

    if (activeEntries.length === 0) {
      this.popupService.openPopup(
        CollectionPopupComponent,
        'No checked feeds to filter.',
        '',
        '40%'
      );
      this.resetAllFeedPanels();
      return;
    }

    const norm = (s?: string) => (s || '').toLowerCase();
    const isVesselType = (t?: string) =>
      ['ship', 'vessel'].includes(norm(t));
    const colorForType = (t?: string, fallback?: string) => {
      const hit = Object.values(feedsConfig).find(
        (c: any) => norm(c?.type) === norm(t)
      );
      return fallback || (hit as any)?.color || '#ffd166';
    };

    const combinedFeatures: GeoJSON.Feature[] = [];
    let vesselMatches = 0;

    for (const [feedKey, entry] of activeEntries) {
      const { fc, type: entryType, color: entryColor, title } = entry;
      const cfg = feedsConfig[feedKey];
      if (!cfg || !fc) continue;

      const effectiveType = cfg?.type ?? entryType;
      const feats = Array.isArray(fc.features) ? fc.features : [];
      const color = colorForType(effectiveType, entryColor);

      // (A) Vessel / Transshipment filtering
      if (isVesselType(effectiveType)) {
        const filtered = feats.filter((f) =>
          this.feedFilterService.matchesVesselLength(f, lenLimit, keepGreater)
        );
        vesselMatches += filtered.length;

        const classCounts = this.feedFilterService.countByClass(filtered);
        const resultKey = this.feedFilterService.getResultKey(cfg?.type);
        const totalCount = Object.values(classCounts).reduce(
          (sum, n) => sum + n,
          0
        );
        const feedResults = { [resultKey]: totalCount };
        const vm = this.helperService.buildFeedSections(cfg, feedResults, color);
        this.addFeedPanel(feedKey, title, color, vm.sections);

        for (const f of filtered) {
          const props = { ...(f.properties || {}), _color: color };
          combinedFeatures.push({ ...f, properties: props } as any);
        }
        const paneEl = this.map.getPane('vesselPane');
        if (paneEl) paneEl.style.zIndex = '9999';
        const filteredFC = { type: 'ObjectCollection', features: filtered };
        const filteredLayer = (L as any).geoJSON(filteredFC, {
          pane: 'vesselPane',
          style: (feature: any) => ({
            color: feature?.properties?._color || color,
            fillColor: feature?.properties?._color || color,
            fillOpacity: 1.0,
          }),
          pointToLayer: (ftr, latlng) =>
            new L.CircleMarker(latlng, { radius: 4 }),
          onEachFeature: (ftr: any, lyr: any) => {
            attachVesselHoverPopup({
              layer: lyr,
              feature: ftr,
              feedName: cfg?.name || feedKey,
              map: this.map,
              nonVesselFeed: this.nonVesselFeed,
              helperService: this.helperService,
              nudgeInsideView: this.nudgeInsideView.bind(this),
              pickDirection: this.pickDirection.bind(this),
              showEeTooltip: this.showFeatureTooltip.bind(this),
            });
          },
        });
        filteredLayer.addTo(this.map);
        this.currentFilteredLayers[feedKey] = filteredLayer;

        continue;
      }

      // (B) Non-vessel feeds → no filtering
      const paneE2 = this.map.getPane('nonVesselPane');
      if (paneE2) paneE2.style.zIndex = '7000';
      const vm = this.helperService.buildFeedSections(
        cfg,
        (fc as any)?.feed_results,
        color
      );
      this.addFeedPanel(feedKey, title, color, vm.sections);
       
      for (const f of feats) {
        const props = { ...(f.properties || {}), _color: color };
        combinedFeatures.push({ ...f, properties: props } as any);
      }

      const passthroughFC = { type: 'FeatureCollection', features: feats };
      const passthroughLayer = (L as any).geoJSON(passthroughFC, {
        pane: 'nonVesselPane',
        style: (feature: any) => {
          const isVehicleClassification = cfg?.type === 'Vehicle-classification';

          const cls = feature?.properties?.class;
            if( cfg?.type === 'Vessel-classification' && cls != null) {
            const entry = VESSEL_CLASS_COLOR_MAP[cls];
            if (entry) {
              return {
                color: entry.color,
                fillColor: entry.color,
                fillOpacity: 1.0,
              };
          }
        } else if (isVehicleClassification && cls != null) {
          const entry = (VEHICLE_CLASS_COLOR_MAP as any)[cls];
          if (entry) {
            return { color: entry.color, fillColor: entry.color, fillOpacity: 0.8, weight: 3 };
          }
        }

          const fallbackColor = feature?.properties?._color || color;
          return {
            color: fallbackColor,
            fillColor: fallbackColor,
            fillOpacity: 1.0,
          };
        },
        pointToLayer: (ftr, latlng) =>
          new L.CircleMarker(latlng, { radius: 4 }),
        onEachFeature: (ftr: any, lyr: any) => {
          attachVesselHoverPopup({
            layer: lyr,
            feature: ftr,
            feedName: cfg?.name || feedKey,
            map: this.map,
            nonVesselFeed: this.nonVesselFeed,
            helperService: this.helperService,
            nudgeInsideView: this.nudgeInsideView.bind(this),
            pickDirection: this.pickDirection.bind(this),
            showEeTooltip: this.showFeatureTooltip.bind(this),
          });
        },
      });
      passthroughLayer.addTo(this.map);
      this.currentFilteredLayers[feedKey] = passthroughLayer;
    }

    if (vesselMatches === 0) {
      this.showNoMatchesMessage('vessel');
      return;
    }

    const allFilteredFC = {
      type: 'FeatureCollection',
      features: combinedFeatures,
    };
    const allFilteredLayer = (L as any).geoJSON(allFilteredFC);
    this.map.fitBounds(allFilteredLayer.getBounds());

    this.rebuildCombined();
    this.feedLoaded = true;
  } else {
   const leftCount = this.filterLayersByDiagonal(
    this.leftComparisonObjectLayer,
    lenLimit,
    keepGreater
  );

  const rightCount = this.filterLayersByDiagonal(
    this.rightComparisonObjectLayer,
    lenLimit,
    keepGreater
  );
     if(leftCount === 0 && rightCount === 0) {
    this.showNoMatchesMessage('vessel');
  }

  this.leftFeedPanels = this.updateFeedCount(this.leftFeedPanels, leftCount);
  this.rightFeedPanels = this.updateFeedCount(this.rightFeedPanels, rightCount);
   }
 }

private handleAircraftLengthFilterByType(filterType: string, feedKeys: string[], result: any): void {
  const lenLimit = Number(result.length);
  const keepGreater = !!result.isGreater;

  this.refreshLegendSummaries();
  const managedFeeds = this.refreshViewportFeedFilters();
  if (managedFeeds.size && [...this.activeFeedKeys].every(key => managedFeeds.has(key))) return;

  if(!result.isCompare) {
    this.clearFilteredLayerAndRestore(true, undefined, true);
    this.removeISLayers(true);
    this.feedPanels = new Map([...this.feedPanels].filter(([key]) => managedFeeds.has(key)));

    const nonVesselPane =
      this.map.getPane('nonVesselPane') || this.map.createPane('nonVesselPane');
    nonVesselPane.style.zIndex = '7000';
    nonVesselPane.style.pointerEvents = 'auto';

    const activeEntries: Array<
      [
        string,
        { fc: FeatureCollection; type?: string; color?: string; title: string }
      ]
    > = [];
    for (const key of this.activeFeedKeys) {
      if (managedFeeds.has(key)) continue;
      const entry = this.geoByFeed.get(key);
      if (entry) activeEntries.push([key, entry]);
    }

    if (activeEntries.length === 0) {
      this.popupService.openPopup(
        CollectionPopupComponent,
        'No checked feeds to filter.',
        '',
        '40%'
      );
      this.resetAllFeedPanels();
      return;
    }

    const norm = (s?: string) => (s || '').toLowerCase();
    const colorForType = (t?: string, fallback?: string) => {
      const hit = Object.values(feedsConfig).find(
        (c: any) => norm(c?.type) === norm(t)
      );
      return fallback || (hit as any)?.color || '#ffd166';
    };

    const getAircraftLength = (feature: any): number => {
      const rawLength =
        feature?.properties?.length_m ??
        feature?.properties?.length ??
        0;

      const value = Number(rawLength);
      return Number.isNaN(value) ? 0 : value;
    };

    const combinedFeatures: GeoJSON.Feature[] = [];
    let aircraftMatches = 0;

    for (const [feedKey, entry] of activeEntries) {
      const { fc, type: entryType, color: entryColor, title } = entry;
      const cfg = feedsConfig[feedKey];
      if (!cfg || !fc) continue;

      const effectiveType = cfg?.type ?? entryType;
      const feats = Array.isArray(fc.features) ? fc.features : [];
      const color = colorForType(effectiveType, entryColor);

      if (norm(effectiveType) === 'aircraft') {
        const filtered = feats.filter((f) => {
          const aircraftLength = getAircraftLength(f);
          return keepGreater ? aircraftLength > lenLimit : aircraftLength < lenLimit;
        });

        aircraftMatches += filtered.length;

        const baseFeedResults =
          (entry.fc as any)?.feed_results && typeof (entry.fc as any).feed_results === 'object'
            ? (entry.fc as any).feed_results
            : {};

        const feedResults: Record<string, any> = {
          ...baseFeedResults,
          aircraft_count: filtered.length,
        };

        const vm = this.helperService.buildFeedSections(cfg, feedResults, color);
        this.addFeedPanel(feedKey, title, color, vm.sections);

        for (const f of filtered) {
          const props = { ...(f.properties || {}), _color: color };
          combinedFeatures.push({ ...f, properties: props } as any);
        }
        const paneEl = this.map.getPane('nonVesselPane');
        if (paneEl) paneEl.style.zIndex = '7000';
        const filteredFC = { type: 'FeatureCollection', features: filtered };
        const filteredLayer = (L as any).geoJSON(filteredFC, {
          pane: 'nonVesselPane',
          style: (feature: any) => ({
            color: feature?.properties?._color || color,
            fillColor: feature?.properties?._color || color,
            fillOpacity: 1.0,
          }),
          pointToLayer: (ftr, latlng) =>
            new L.CircleMarker(latlng, { radius: 4 }),
          onEachFeature: (ftr: any, lyr: any) => {
            attachVesselHoverPopup({
              layer: lyr,
              feature: ftr,
              feedName: cfg?.name || feedKey,
              map: this.map,
              nonVesselFeed: this.nonVesselFeed,
              helperService: this.helperService,
              nudgeInsideView: this.nudgeInsideView.bind(this),
              pickDirection: this.pickDirection.bind(this),
              showEeTooltip: this.showFeatureTooltip.bind(this),
            });
          },
        });
        filteredLayer.addTo(this.map);
        this.currentFilteredLayers[feedKey] = filteredLayer;

        continue;
      }

      const vm = this.helperService.buildFeedSections(
        cfg,
        (fc as any)?.feed_results,
        color
      );
      this.addFeedPanel(feedKey, title, color, vm.sections);

      for (const f of feats) {
        const props = { ...(f.properties || {}), _color: color };
        combinedFeatures.push({ ...f, properties: props } as any);
      }

      const passthroughFC = { type: 'FeatureCollection', features: feats };
      const passthroughLayer = (L as any).geoJSON(passthroughFC, {
        pane: 'nonVesselPane',
        style: (feature: any) => {
          const cls = feature?.properties?.class;
          const classEntry = (cfg?.color as any)?.[cls];
          if (classEntry) {
            return {
              color: classEntry.color || classEntry,
              fillColor: classEntry.color || classEntry,
              fillOpacity: 0.8,
              weight: 3,
            };
          }

          return {
            color,
            fillColor: color,
            fillOpacity: 1.0,
          };
        },
        pointToLayer: (ftr, latlng) =>
          new L.CircleMarker(latlng, { radius: 4 }),
        onEachFeature: (ftr: any, lyr: any) => {
          attachVesselHoverPopup({
            layer: lyr,
            feature: ftr,
            feedName: cfg?.name || feedKey,
            map: this.map,
            nonVesselFeed: this.nonVesselFeed,
            helperService: this.helperService,
            nudgeInsideView: this.nudgeInsideView.bind(this),
            pickDirection: this.pickDirection.bind(this),
            showEeTooltip: this.showFeatureTooltip.bind(this),
          });
        },
      });

      passthroughLayer.addTo(this.map);
      this.currentFilteredLayers[feedKey] = passthroughLayer;
    }

    if (aircraftMatches === 0) {
      this.showNoMatchesMessage('aircraft');
      return;
    }

    const allFilteredFC = {
      type: 'FeatureCollection',
      features: combinedFeatures,
    };
    const allFilteredLayer = (L as any).geoJSON(allFilteredFC);
    this.map.fitBounds(allFilteredLayer.getBounds());

    this.rebuildCombined();
    this.feedLoaded = true;
  } else {
   const leftCount = this.filterLayersByDiagonal(
    this.leftComparisonObjectLayer,
    lenLimit,
    keepGreater
  );

  const rightCount = this.filterLayersByDiagonal(
    this.rightComparisonObjectLayer,
    lenLimit,
    keepGreater
  );
     if(leftCount === 0 && rightCount === 0) {
    this.showNoMatchesMessage('aircraft');
  }

  this.leftFeedPanels = this.updateFeedCount(this.leftFeedPanels, leftCount, 'Aircraft count');
  this.rightFeedPanels = this.updateFeedCount(this.rightFeedPanels, rightCount, 'Aircraft count');
   }
 }



private filterLayersByDiagonal(
  layerGroup: any,
  lenLimit: number,
  keepGreater: boolean
): number {

  if (!layerGroup) return 0;

  let visibleCount = 0;

  const process = (layer: any) => {

    if (!layer.getBounds) return;

    const bounds = layer.getBounds();

    const diagonal = this.map.distance(
      bounds.getNorthWest(),
      bounds.getSouthEast()
    );

    const shouldShow = keepGreater
      ? diagonal > lenLimit
      : diagonal < lenLimit;

    layer.setStyle({
      stroke: shouldShow
    });

    if (shouldShow) visibleCount++;
  };

  layerGroup.eachLayer((layer: any) => {
    if (layer.eachLayer) {
      layer.eachLayer(process);
    } else {
      process(layer);
    }
  });

  return visibleCount;
}


// ============ TYPE-CENTRIC HANDLERS: Filter by type across all applicable feeds ============

private handleClassBasedFilterByType(filterType: string, feedKeys: string[], selectedClassValue: string): void {
  if (!selectedClassValue) return;
  this.refreshLegendSummaries();
  const managedFeeds = this.refreshViewportFeedFilters();
  if (managedFeeds.size && [...this.activeFeedKeys].every(key => managedFeeds.has(key))) return;

  this.clearFilteredLayerAndRestore(true, undefined, true);
  this.removeISLayers(true);
  this.unregisterPredictionTimeseries(false);
  this.feedPanels = new Map([...this.feedPanels].filter(([key]) => managedFeeds.has(key)));

  const nonVesselPane =
    this.map.getPane('nonVesselPane') || this.map.createPane('nonVesselPane');
  nonVesselPane.style.zIndex = '7000';
  nonVesselPane.style.pointerEvents = 'auto';

  const combinedFeatures: GeoJSON.Feature[] = [];
  const activeEntries: Array<
    [
      string,
      { fc: FeatureCollection; type?: string; color?: string; title: string; feed_results?: any }
    ]
  > = [];

  for (const key of this.activeFeedKeys) {
    if (managedFeeds.has(key)) continue;
    const entry = this.geoByFeed.get(key);
    if (entry) activeEntries.push([key, entry]);
  }

  const filtersSource = this.getMergedFiltersByType();
  const activeClassFilterByFeed = new Map<string, { type: string; value: any }>();
  const activeVesselLengthByFeed = new Map<string, { value: number; isGreater: boolean }>();

  for (const [type, filterState] of filtersSource.entries()) {
    if (type === 'vesselLength') {
      const value = Number(filterState?.value);
      if (!Number.isNaN(value)) {
        for (const key of filterState.feedKeys || []) {
          activeVesselLengthByFeed.set(String(key), {
            value,
            isGreater: !!filterState.isGreater,
          });
        }
      }
      continue;
    }
    if (isPredictionFilterType(type) || !filterState || filterState.value == null) continue;
    for (const key of filterState.feedKeys || []) {
      activeClassFilterByFeed.set(String(key), { type, value: filterState.value });
    }
  }

  const norm = (s?: string) => (s || '').toLowerCase();
  const normalizeFloodDepthClass = (value: any): string =>
    value == null
      ? ''
      : String(value)
          .replace(/[\u2010-\u2015\u2212\-\?]/g, '–')
          .replace(/\s+/g, ' ')
          .trim();

  const resolveFeatureClassKey = (feature: any, feedType?: string): string => {
    if (feedType === 'Flood Inundation') {
      const raw =
        feature?.properties?.depth_class ??
        feature?.properties?.depth_clas ??
        feature?.properties?.class;
      return normalizeFloodDepthClass(raw);
    }
    return String(feature?.properties?.['class'] ?? '').trim();
  };

  const colorForType = (t?: string, fallback?: string) => {
    const hit = Object.values(feedsConfig).find(
      (c: any) => norm(c?.type) === norm(t)
    );
    return fallback || (hit as any)?.color || '#ffd166';
  };

  // Apply relevant class filter per active feed; keep other checked feeds visible.
  for (const [feedKey, entry] of activeEntries) {
    const cfg = feedsConfig[feedKey];
    if (!cfg || !entry.fc) continue;

    const effectiveType = cfg?.type;
    const feats = Array.isArray(entry.fc.features) ? entry.fc.features : [];
    const color = colorForType(effectiveType, entry.color);
    const activeFilterForFeed = activeClassFilterByFeed.get(feedKey);
    const activeLengthFilterForFeed = activeVesselLengthByFeed.get(feedKey);
    const selectedClassKey = activeFilterForFeed
      ? effectiveType === 'Flood Inundation'
        ? normalizeFloodDepthClass(activeFilterForFeed.value)
        : String(activeFilterForFeed.value).trim()
      : '';

    const filtered = activeFilterForFeed
      ? feats.filter((f) => {
          const cls = resolveFeatureClassKey(f, effectiveType);
          if (cls !== selectedClassKey) {
            return false;
          }
          if (activeLengthFilterForFeed) {
            return this.feedFilterService.matchesVesselLength(
              f,
              activeLengthFilterForFeed.value,
              activeLengthFilterForFeed.isGreater
            );
          }
          return true;
        })
      : feats.filter((f) => {
          if (activeLengthFilterForFeed) {
            return this.feedFilterService.matchesVesselLength(
              f,
              activeLengthFilterForFeed.value,
              activeLengthFilterForFeed.isGreater
            );
          }
          return true;
        });

    const filteredCount = filtered.length;
    const resultKey = this.feedFilterService.getResultKey(cfg?.type);
    const isVesselLike = ['ship', 'vessel', 'transshipment', 'transhipment'].includes(
      norm(effectiveType)
    );
    const isClassBasedFeed = cfg?.colorMode === 'CLASS_BASED';
    const baseFeedResults =
      (entry.fc as any)?.feed_results && typeof (entry.fc as any).feed_results === 'object'
        ? (entry.fc as any).feed_results
        : {};
    let feedResults: any = baseFeedResults;

    if (isVesselLike) {
      feedResults = {
        [resultKey]: filteredCount,
      };
    } else if (effectiveType === 'Flood Inundation') {
      feedResults = {
        Inundated_area:
          (entry.fc as any)?.feed_results?.Inundated_area ??
          (entry.fc as any)?.feed_results?.inundated_area,
      };
    }

    // Multi-feed behavior: keep legend rows for all checked feeds visible.
    const shouldShowPanelForFeed = this.activeFeedKeys.has(feedKey);
    if (!shouldShowPanelForFeed) {
      if (filtered.length === 0) {
        continue;
      }

      for (const f of filtered) {
        const props = { ...(f.properties || {}), _color: color };
        combinedFeatures.push({ ...f, properties: props } as any);
      }

      const filteredFC = { type: 'FeatureCollection', features: filtered };
      const colorMap = cfg?.color || {};
      const filteredLayer = (L as any).geoJSON(filteredFC, {
        pane: 'nonVesselPane',
        style: (feature: any) => {
          const cls = resolveFeatureClassKey(feature, effectiveType);
          const classEntry = (colorMap as any)[cls];
          if (classEntry) {
            return {
              color: classEntry.color || classEntry,
              fillColor: classEntry.color || classEntry,
              fillOpacity: 0.8,
              weight: 3,
            };
          }
          return {
            color: color,
            fillColor: color,
            fillOpacity: 1.0,
          };
        },
        pointToLayer: (ftr, latlng) =>
          new L.CircleMarker(latlng, { radius: 4 }),
        onEachFeature: (ftr: any, lyr: any) => {
          attachVesselHoverPopup({
            layer: lyr,
            feature: ftr,
            feedName: cfg?.name || feedKey,
            map: this.map,
            nonVesselFeed: this.nonVesselFeed,
            helperService: this.helperService,
            nudgeInsideView: this.nudgeInsideView.bind(this),
            pickDirection: this.pickDirection.bind(this),
            showEeTooltip: this.showFeatureTooltip.bind(this),
          });
        },
      });

      this.currentFilteredLayers[feedKey] = filteredLayer;
      filteredLayer.addTo(this.map);
      continue;
    }

    const classCounts = activeFilterForFeed || activeLengthFilterForFeed
      ? this.feedFilterService.getClassCountsForLegend(effectiveType, filtered)
      : undefined;
    const vm = activeFilterForFeed
      ? this.helperService.buildFeedSections(cfg, feedResults, color, {
          type: 'classBasedFilter',
          value: selectedClassKey,
        }, classCounts)
      : this.helperService.buildFeedSections(cfg, feedResults, color, undefined, classCounts);
    this.addFeedPanel(feedKey, entry.title, color, vm.sections);

    if (filtered.length === 0) {
      continue;
    }

    for (const f of filtered) {
      const props = { ...(f.properties || {}), _color: color };
      combinedFeatures.push({ ...f, properties: props } as any);
    }

    const filteredFC = { type: 'FeatureCollection', features: filtered };
    const colorMap = cfg?.color || {};
    const filteredLayer = (L as any).geoJSON(filteredFC, {
      pane: 'nonVesselPane',
      style: (feature: any) => {
        const cls = resolveFeatureClassKey(feature, effectiveType);
        const classEntry = (colorMap as any)[cls];
        if (classEntry) {
          return {
            color: classEntry.color || classEntry,
            fillColor: classEntry.color || classEntry,
            fillOpacity: 0.8,
            weight: 3,
          };
        }
        return {
          color: color,
          fillColor: color,
          fillOpacity: 1.0,
        };
      },
      pointToLayer: (ftr, latlng) =>
        new L.CircleMarker(latlng, { radius: 4 }),
      onEachFeature: (ftr: any, lyr: any) => {
        attachVesselHoverPopup({
          layer: lyr,
          feature: ftr,
          feedName: cfg?.name || feedKey,
          map: this.map,
          nonVesselFeed: this.nonVesselFeed,
          helperService: this.helperService,
          nudgeInsideView: this.nudgeInsideView.bind(this),
          pickDirection: this.pickDirection.bind(this),
          showEeTooltip: this.showFeatureTooltip.bind(this),
        });
      },
    });

    this.currentFilteredLayers[feedKey] = filteredLayer;
    filteredLayer.addTo(this.map);
  }


  this.rebuildCombined();
  this.feedLoaded = true;
}

private handleVesselLengthFilterByType(filterType: string, feedKeys: string[], result: any): void {
  this.refreshLegendSummaries();
  const managedFeeds = this.refreshViewportFeedFilters();
  if (managedFeeds.size && [...this.activeFeedKeys].every(key => managedFeeds.has(key))) return;
  const lenLimit = Number(result.length);
  const keepGreater = !!result.isGreater;

  this.clearFilteredLayerAndRestore(true, undefined, true);
  this.removeISLayers(true);
  this.unregisterPredictionTimeseries(false);
  this.feedPanels = new Map([...this.feedPanels].filter(([key]) => managedFeeds.has(key)));

  const vesselPane =
    this.map.getPane('vesselPane') || this.map.createPane('vesselPane');
  vesselPane.style.zIndex = '9999';
  vesselPane.style.pointerEvents = 'auto';

  const nonVesselPane =
    this.map.getPane('nonVesselPane') || this.map.createPane('nonVesselPane');
  nonVesselPane.style.zIndex = '7000';
  nonVesselPane.style.pointerEvents = 'auto';

  const combinedFeatures: GeoJSON.Feature[] = [];
  const activeEntries: Array<
    [
      string,
      { fc: FeatureCollection; type?: string; color?: string; title: string; feed_results?: any }
    ]
  > = [];

  for (const key of this.activeFeedKeys) {
    if (managedFeeds.has(key)) continue;
    const entry = this.geoByFeed.get(key);
    if (entry) activeEntries.push([key, entry]);
  }

  const filtersSource = this.getMergedFiltersByType();
  const activeClassFilterByFeed = new Map<string, { type: string; value: any }>();

  for (const [type, filterState] of filtersSource.entries()) {
    if (type === 'vesselLength' || isPredictionFilterType(type)) continue;
    if (!filterState || filterState.value == null) continue;
    for (const key of filterState.feedKeys || []) {
      activeClassFilterByFeed.set(String(key), { type, value: filterState.value });
    }
  }

  const norm = (s?: string) => (s || '').toLowerCase();
  const normalizeFloodDepthClass = (value: any): string =>
    value == null
      ? ''
      : String(value)
          .replace(/[\u2010-\u2015\u2212\-\?]/g, '–')
          .replace(/\s+/g, ' ')
          .trim();

  const resolveFeatureClassKey = (feature: any, feedType?: string): string => {
    if (feedType === 'Flood Inundation') {
      const raw =
        feature?.properties?.depth_class ??
        feature?.properties?.depth_clas ??
        feature?.properties?.class;
      return normalizeFloodDepthClass(raw);
    }
    return String(feature?.properties?.['class'] ?? '').trim();
  };

  const colorForType = (t?: string, fallback?: string) => {
    const hit = Object.values(feedsConfig).find(
      (c: any) => norm(c?.type) === norm(t)
    );
    return fallback || (hit as any)?.color || '#ffd166';
  };

  const vesselKeySet = new Set(feedKeys.map((key) => String(key)));

  // Apply vessel filter to vessel feeds, while keeping class filters on other active feeds.
  for (const [feedKey, entry] of activeEntries) {
    const cfg = feedsConfig[feedKey];
    if (!cfg || !entry.fc) continue;

    const effectiveType = cfg?.type;
    const feats = Array.isArray(entry.fc.features) ? entry.fc.features : [];
    const color = colorForType(effectiveType, entry.color);
    const activeClassFilterForFeed = activeClassFilterByFeed.get(feedKey);
    const selectedClassKey = activeClassFilterForFeed
      ? effectiveType === 'Flood Inundation'
        ? normalizeFloodDepthClass(activeClassFilterForFeed.value)
        : String(activeClassFilterForFeed.value).trim()
      : '';
    const isVesselFilterFeed = vesselKeySet.has(feedKey);

    const filtered = feats.filter((f) => {
      if (activeClassFilterForFeed) {
        const cls = resolveFeatureClassKey(f, effectiveType);
        if (cls !== selectedClassKey) {
          return false;
        }
      }

      if (isVesselFilterFeed) {
        return this.feedFilterService.matchesVesselLength(f, lenLimit, keepGreater);
      }

      return true;
    });

    const filteredCount = filtered.length;
    const resultKey = this.feedFilterService.getResultKey(cfg?.type);
    const baseFeedResults =
      (entry.fc as any)?.feed_results && typeof (entry.fc as any).feed_results === 'object'
        ? (entry.fc as any).feed_results
        : {};
    const isVesselLike = ['ship', 'vessel', 'transshipment', 'transhipment'].includes(
      norm(effectiveType)
    );
    let feedResults: any = baseFeedResults;

    if (isVesselLike) {
      feedResults = {
        [resultKey]: filteredCount,
      };
    } else if (effectiveType === 'Flood Inundation') {
      feedResults = {
        Inundated_area:
          (entry.fc as any)?.feed_results?.Inundated_area ??
          (entry.fc as any)?.feed_results?.inundated_area,
      };
    }

    // Multi-feed behavior: keep legend rows for all checked feeds visible.
    const shouldShowPanelForFeed = this.activeFeedKeys.has(feedKey);
    if (!shouldShowPanelForFeed) {
      if (filteredCount === 0) continue;

      for (const f of filtered) {
        const props = { ...(f.properties || {}), _color: color };
        combinedFeatures.push({ ...f, properties: props } as any);
      }

      const filteredFC = { type: 'FeatureCollection', features: filtered };
      const filteredLayer = (L as any).geoJSON(filteredFC, {
        pane: isVesselFilterFeed ? vesselPane : 'nonVesselPane',
        style: (feature: any) => {
          const colorMap = cfg?.color || {};
          const cls = resolveFeatureClassKey(feature, effectiveType);
          const classEntry = (colorMap as any)[cls];

          if (classEntry) {
            return {
              color: classEntry.color || classEntry,
              fillColor: classEntry.color || classEntry,
              fillOpacity: 0.8,
              weight: 3,
            };
          }

          return {
            color: color,
            fillColor: color,
            fillOpacity: 1.0,
          };
        },
        pointToLayer: (ftr, latlng) =>
          new L.CircleMarker(latlng, { radius: 4 }),
        onEachFeature: (ftr: any, lyr: any) => {
          attachVesselHoverPopup({
            layer: lyr,
            feature: ftr,
            feedName: cfg?.name || feedKey,
            map: this.map,
            nonVesselFeed: this.nonVesselFeed,
            helperService: this.helperService,
            nudgeInsideView: this.nudgeInsideView.bind(this),
            pickDirection: this.pickDirection.bind(this),
            showEeTooltip: this.showFeatureTooltip.bind(this),
          });
        },
      });

      this.currentFilteredLayers[feedKey] = filteredLayer;
      filteredLayer.addTo(this.map);
      continue;
    }

    const classCounts = activeClassFilterForFeed || isVesselFilterFeed
      ? this.feedFilterService.getClassCountsForLegend(effectiveType, filtered)
      : undefined;
    const vm = activeClassFilterForFeed
      ? this.helperService.buildFeedSections(cfg, feedResults, color, {
          type: 'classBasedFilter',
          value: selectedClassKey,
        }, classCounts)
      : this.helperService.buildFeedSections(cfg, feedResults, color, undefined, classCounts);
    this.addFeedPanel(feedKey, entry.title, color, vm.sections);

    if (filteredCount === 0) continue;

    for (const f of filtered) {
      const props = { ...(f.properties || {}), _color: color };
      combinedFeatures.push({ ...f, properties: props } as any);
    }

    const filteredFC = { type: 'FeatureCollection', features: filtered };
    const filteredLayer = (L as any).geoJSON(filteredFC, {
      pane: isVesselFilterFeed ? vesselPane : 'nonVesselPane',
      style: (feature: any) => {
        const colorMap = cfg?.color || {};
        const cls = resolveFeatureClassKey(feature, effectiveType);
        const classEntry = (colorMap as any)[cls];

        if (classEntry) {
          return {
            color: classEntry.color || classEntry,
            fillColor: classEntry.color || classEntry,
            fillOpacity: 0.8,
            weight: 3,
          };
        }

        return {
          color: color,
          fillColor: color,
          fillOpacity: 1.0,
        };
      },
      pointToLayer: (ftr, latlng) =>
        new L.CircleMarker(latlng, { radius: 4 }),
      onEachFeature: (ftr: any, lyr: any) => {
        attachVesselHoverPopup({
          layer: lyr,
          feature: ftr,
          feedName: cfg?.name || feedKey,
          map: this.map,
          nonVesselFeed: this.nonVesselFeed,
          helperService: this.helperService,
          nudgeInsideView: this.nudgeInsideView.bind(this),
          pickDirection: this.pickDirection.bind(this),
          showEeTooltip: this.showFeatureTooltip.bind(this),
        });
      },
    });

    this.currentFilteredLayers[feedKey] = filteredLayer;
    filteredLayer.addTo(this.map);
  }


  this.rebuildCombined();
  this.feedLoaded = true;
}

private removePredictionFeedLayer(feedKey: string): string | undefined {
  const layers = [this.currentFilteredLayers[feedKey], this.feedLayers[feedKey]].filter(Boolean);
  const pane = (layers[0] as L.Layer & { options?: { pane?: string } })?.options?.pane;
  for (const layer of new Set(layers)) {
    if (this.map.hasLayer(layer)) {
      this.removeVesselLabelLayer(layer);
      this.map.removeLayer(layer);
    }
  }
  delete this.currentFilteredLayers[feedKey];
  delete this.feedLayers[feedKey];
  return pane;
}

private clearFilterByType(filterType: string, feedKeys?: string[]): void {
  const predictionFeedKeys = isPredictionFilterType(filterType)
    ? (feedKeys?.length ? feedKeys : [...this.activeFeedKeys].filter(key =>
        getPredictionFeedMeta(this.geoByFeed.get(key)?.type)?.filterType === filterType))
    : [];
  this.selectedFilterType = null;
  this.filtersByType.delete(filterType);
  this.classBasedFilterMessageShown = false;
  this.unregisterPredictionTimeseries(false);
  this.refreshLegendSummaries();
  const managedFeeds = this.refreshViewportFeedFilters();
  if (isPredictionFilterType(filterType)) {
    for (const key of predictionFeedKeys) {
      if (!this.activeFeedKeys.has(key) || managedFeeds.has(key)) continue;
      const entry = this.geoByFeed.get(key);
      const cfg = feedsConfig[key];
      if (!entry?.fc || !this.isPredictionConfig(cfg)) continue;

      const paneName = this.removePredictionFeedLayer(key) ?? `prediction-pane-${key}`;
      const pane = this.map.getPane(paneName) || this.map.createPane(paneName);
      pane.style.zIndex = this.predictionPaneZIndex;
      pane.style.pointerEvents = 'auto';
      const color = entry.color ?? cfg.color;
      const feedResults = (entry.fc as any).feed_results ?? entry.feed_results;
      const sections = this.helperService.buildFeedSections(cfg,
        this.predictionFeedController.buildFeedResultsForSections(feedResults), color).sections;
      this.addFeedPanel(key, entry.title, color, sections,
        buildPredictionLegendGroupsFromResults(feedResults, cfg, String(color ?? '#FF00FF'), key));
      const layer = this.buildFeedGeoJsonLayer(entry.fc, cfg, color, cfg.name || entry.title || key, paneName);
      this.currentFilteredLayers[key] = layer;
      layer.addTo(this.map);
      this.liftPredictionLayer(layer);
      this.registerPredictionTimeseries(key, entry, entry.fc, layer);
    }
    this.rebuildCombined();
    this.feedLoaded = true;
    return;
  }
  if (managedFeeds.size && [...this.activeFeedKeys].every(key => managedFeeds.has(key))) return;
  this.clearFilteredLayerAndRestore(true, undefined, true);
  this.removeISLayers(true);
  this.feedPanels = new Map([...this.feedPanels].filter(([key]) => managedFeeds.has(key)));

  const nonVesselPane =
    this.map.getPane('nonVesselPane') || this.map.createPane('nonVesselPane');
  nonVesselPane.style.zIndex = '7000';
  nonVesselPane.style.pointerEvents = 'auto';

  const activeEntries: Array<
    [
      string,
      { fc: FeatureCollection; type?: string; color?: string; title: string; feed_results?: any }
    ]
  > = [];

  for (const key of this.activeFeedKeys) {
    if (managedFeeds.has(key)) continue;
    const entry = this.geoByFeed.get(key);
    if (entry) activeEntries.push([key, entry]);
  }

  if (activeEntries.length === 0) {
    this.resetAllFeedPanels();
    return;
  }

  const norm = (s?: string) => (s || '').toLowerCase();
  const colorForType = (t?: string, fallback?: string) => {
    const hit = Object.values(feedsConfig).find(
      (c: any) => norm(c?.type) === norm(t)
    );
    return fallback || (hit as any)?.color || '#ffd166';
  };

  const combinedFeatures: GeoJSON.Feature[] = [];

  for (const [feedKey, entry] of activeEntries) {
    const { fc, type: entryType, color: entryColor, title } = entry;
    const cfg = feedsConfig[feedKey];
    if (!cfg || !fc) continue;

    const effectiveType = cfg?.type ?? entryType;
    const feats = Array.isArray(fc.features) ? fc.features : [];
    const color = colorForType(effectiveType, entryColor);
    const originalFeedResults = (fc as any)?.feed_results ?? entry.feed_results;
    const feedResults = this.isPredictionConfig(cfg)
      ? this.predictionFeedController.buildFeedResultsForSections(originalFeedResults)
      : originalFeedResults;
    const vm = this.helperService.buildFeedSections(cfg, feedResults, color);
    const predictionLegendGroups = this.isPredictionConfig(cfg)
      ? buildPredictionLegendGroupsFromResults(
          originalFeedResults,
          cfg,
          String(color ?? '#FF00FF'),
          feedKey
        )
      : undefined;
    this.addFeedPanel(feedKey, title, color, vm.sections, predictionLegendGroups);

    for (const f of feats) {
      const props = { ...(f.properties || {}), _color: color };
      combinedFeatures.push({ ...f, properties: props } as any);
    }

    const paneName = this.isPredictionConfig(cfg)
      ? `prediction-pane-${feedKey}`
      : 'nonVesselPane';
    const pane = this.map.getPane(paneName) || this.map.createPane(paneName);
    pane.style.zIndex = this.isPredictionConfig(cfg)
      ? this.predictionPaneZIndex
      : '7000';
    pane.style.pointerEvents = 'auto';

    const passthroughFC = {
      ...fc,
      type: 'FeatureCollection',
      features: feats,
    } as FeatureCollection<Geometry, FeatureProps>;
    const colorMap = cfg?.color || {};
    const passthroughLayer = this.isPredictionConfig(cfg)
      ? this.buildFeedGeoJsonLayer(
          passthroughFC,
          cfg,
          color,
          cfg?.name || title || feedKey,
          paneName
        )
      : (L as any).geoJSON(passthroughFC, {
      pane: 'nonVesselPane',
      style: (feature: any) => {
        const cls = this.feedFilterService.resolveClassKey(feature, effectiveType);
        const classEntry = (colorMap as any)[cls];
        if (classEntry) {
          return {
            color: classEntry.color || classEntry,
            fillColor: classEntry.color || classEntry,
            fillOpacity: 0.8,
            weight: 3,
          };
        }
        const fallbackColor = typeof color === 'string' ? color : '#ffd166';
        return {
          color: fallbackColor,
          fillColor: fallbackColor,
          fillOpacity: 1.0,
        };
      },
      pointToLayer: (ftr, latlng) =>
        new L.CircleMarker(latlng, { radius: 4 }),
      onEachFeature: (ftr: any, lyr: any) => {
        attachVesselHoverPopup({
          layer: lyr,
          feature: ftr,
          feedName: cfg?.name || feedKey,
          map: this.map,
          nonVesselFeed: this.nonVesselFeed,
          helperService: this.helperService,
          nudgeInsideView: this.nudgeInsideView.bind(this),
          pickDirection: this.pickDirection.bind(this),
          showEeTooltip: this.showFeatureTooltip.bind(this),
        });
      },
    });

    passthroughLayer.addTo(this.map);
    this.currentFilteredLayers[feedKey] = passthroughLayer;
    
      if (this.isPredictionConfig(cfg)) {
      this.liftPredictionLayer(passthroughLayer);
      this.registerPredictionTimeseries(feedKey, entry, passthroughFC, passthroughLayer);
    }
  }

  const allFC = {
    type: 'FeatureCollection',
    features: combinedFeatures,
  };
  const allLayer = (L as any).geoJSON(allFC);
  if (combinedFeatures.length > 0) {
    this.map.fitBounds(allLayer.getBounds());
  }

  this.rebuildCombined();
  this.feedLoaded = true;
}

private updateFeedCount(
  feedPanels: Map<string, any>,
  count: number,
  label = 'Vessel count'
): Map<string, any> {

  if (!feedPanels || feedPanels.size === 0) return feedPanels;

  const next = new Map(feedPanels);

  const key = Array.from(next.keys())[0];
  const pane = feedPanels === this.leftFeedPanels ? 'left' : feedPanels === this.rightFeedPanels ? 'right' : 'normal';
  if (this.legendController?.panes(key).includes(pane)) {
    this.refreshLegendSummaries();
    return pane === 'left' ? this.leftFeedPanels : pane === 'right' ? this.rightFeedPanels : this.feedPanels;
  }
  const panel = next.get(key);
  if (!panel) return feedPanels;

  panel.sections[0].items[0].text = `${label} : ${count}`;

  next.set(key, panel);

  return next;
}


  private clearFilteredLayerAndRestore(
    isRestore: boolean,
    feedKey?: string,
    preserveViewportLayers = false
  ): void {
    // Remove a single filtered layer
    if (feedKey) {
      this.viewportGeojson.endSessionsFor(feedKey);
      if (this.currentFilteredLayers?.[feedKey]) {
        const layer = this.currentFilteredLayers[feedKey];
        if (layer && this.map.hasLayer(layer)) {
          this.removeVesselLabelLayer(layer);
          this.map.removeLayer(layer);
        }
        delete this.currentFilteredLayers[feedKey];
      }

      if (this.feedLayers?.[feedKey]) {
        const layer = this.feedLayers[feedKey];
        if (layer && this.map.hasLayer(layer)) {
          this.removeVesselLabelLayer(layer);
          this.map.removeLayer(layer);
        }
        delete this.feedLayers[feedKey];
      }
    }

    if (isRestore) {
      Object.values(this.currentFilteredLayers || {}).forEach((layer) => {
        if (preserveViewportLayers && this.isRegisteredViewportLayer(layer)) return;
        if (this.map.hasLayer(layer)) {
           this.removeVesselLabelLayer(layer);
          this.map.removeLayer(layer);
        }
      });
      this.currentFilteredLayers = preserveViewportLayers
        ? Object.fromEntries(Object.entries(this.currentFilteredLayers || {}).filter(([, layer]) => this.isRegisteredViewportLayer(layer)))
        : {};
    }

    if (this.shapeVectorOverlay && this.map.hasLayer(this.shapeVectorOverlay) &&
        !(preserveViewportLayers && this.isRegisteredViewportLayer(this.shapeVectorOverlay))) {
      this.map.removeLayer(this.shapeVectorOverlay);
      this.shapeVectorOverlay = undefined;
    }

    this.rebuildCombined();
  }

  private upsertFeedResultsForFiltered(feedsObj: any, feats: any[]) {
    const filteredCount = feats.length;
    const allTransshipment =
      filteredCount > 0 &&
      feats.every((f) => this.isTransshipmentClass(f?.properties?.class));
    feedsObj.insightFootprint.feed_results = {
      ...(feedsObj.insightFootprint.feed_results ?? {}),
      ...(allTransshipment
        ? { transhipment_count: filteredCount }
        : { vessel_count: filteredCount }),
    };
  }
  private isTransshipmentClass(cls: unknown) {
    const s = String(cls || '')
      .trim()
      .toLowerCase();
    return s.startsWith('transship') || s.startsWith('tranship');
  }

  private isRegisteredViewportLayer(layer: any): boolean {
    return !!layer && [...this.viewportGeojsonRender.values()].some(render => render.layer === layer);
  }

  removeISLayers(preserveViewportLayers = false) {
    if (this.ISGeojsonLayer && !(preserveViewportLayers && this.isRegisteredViewportLayer(this.ISGeojsonLayer))) {
      this.map.removeLayer(this.ISGeojsonLayer);
      this.ISGeojsonLayer = null;
    }
    if (this.ISMarkers && this.ISMarkers.length > 0) {
      this.ISMarkers.map((marker) => {
        this.map.removeLayer(marker);
        marker = null;
      });
      this.ISMarkers = [];
    }

    Object.values(this.feedLayers).forEach((layer) => {
      if (preserveViewportLayers && this.isRegisteredViewportLayer(layer)) return;
      if (this.map.hasLayer(layer)) {
        this.map.removeLayer(layer);
      }
    });

    this.feedData = '';
  }

  removeIndices() {
    this.cancelTiffWfsLoads((key) => key.startsWith('indices::'));
    this.clearIndicesViewportGeojsonSessions();
    this.indicesLayers.forEach((indice) => {
      this.map.removeLayer(indice);
    });
    if (this.indicesLayer) {
      this.map.removeLayer(this.indicesLayer);
      this.indicesLayer = null;
    }
    if (this.indicesLegendLayer) {
      this.map.removeLayer(this.indicesLegendLayer);
      this.indicesLegendLayer = null;
    }
    if (this.indicesFootprintLayer) {
      this.map.removeLayer(this.indicesFootprintLayer);
      this.indicesFootprintLayer = null;
    }
    if (this.colorLegendControl) {
      this.map.removeControl(this.colorLegendControl);
      this.colorLegendControl = null;
    }
    this.indicesLayers = [];
  }

  private clearIndicesViewportGeojsonSessions(): void {
    Array.from(this.indicesViewportLayers.keys()).forEach((storageKey) => {
      this.viewportGeojson.endSession(storageKey);
      this.viewportGeojsonRender.delete(storageKey);
    });
    this.indicesViewportLayers.clear();
  }

  removeSuperResolutions() {
    if (this.superResolutionLayer) {
      this.map.removeLayer(this.superResolutionLayer);
      this.superResolutionLayer = null;
    }
    if (this.superResolutionFootprintLayer) {
      this.map.removeLayer(this.superResolutionFootprintLayer);
      this.superResolutionFootprintLayer = null;
    }
  }

  removeAnnoatationByScene(scene: any) {
    this.annotationMarkers.forEach((annotationMarker) => {
      if (annotationMarker.scene == scene.id) {
        this.map.removeLayer(annotationMarker.marker);
      }
    });
    this.annotationMarkers = this.annotationMarkers.filter(
      (annotationMarker) => {
        return annotationMarker.scene != scene.id;
      }
    );
  }

  removeAnnotationMarkers() {
    if (this.annotaionMarker) {
      this.annotaionMarker.closePopup();
      this.annotaionMarker = null;
    }
    this.annotationMarkers.forEach((annotationMarker) => {
      this.map.removeLayer(annotationMarker.marker);
    });
    this.annotationMarkers = [];
  }

  @HostListener('document:mouseup')
  onMouseUp() {
    this.isDragging = false;
  }

  flattenObject(obj: any): { key: string; value: any }[] {
    const result: { key: string; value: any }[] = [];

    function recurse(curr: any, prop?: string) {
      if (Object(curr) !== curr) {
        result.push({ key: prop || '', value: curr });
      } else if (Array.isArray(curr)) {
        for (let i = 0; i < curr.length; i++) {
          recurse(curr[i], prop ? prop + '[' + i + ']' : '[' + i + ']');
        }
        if (curr.length === 0) {
          result.push({ key: prop || '', value: [] });
        }
      } else {
        let isEmpty = true;
        for (const p in curr) {
          isEmpty = false;
          recurse(curr[p], prop ? prop + '.' + p : p);
        }
        if (isEmpty && prop) {
          result.push({ key: prop, value: {} });
        }
      }
    }
    recurse(obj);
    return result;
  }

  getMetadata(metadata: any, info?:any) {
    if(info?.thermal_observation == true && info?.data_type == "area") {
      let unit = "K";
      metadata = metadata + unit;
    }
    const flattenedJSON = this.flattenObject(metadata);
    this.metaDataTooltip = metadata;
  }

  transformDate(dates: string) {
    return this.datePipe.transform(dates, 'yyyy-MM-dd', 'UTC');
  }

  selectBandNew(band: any) {
    if (!this.leftImageNew && !this.rightImageNew) {
      this.selectedBand = band;
      this.clearRFBandsNew();
      this.scenesNew = [];
      if (this.subDailyFinalArray.length > 0) {
        this.selectedSubDailyItemsNew.map((subDaily) => {
          this.subDailyFinalArray.map((finalArr, index) => {
            if (subDaily.value == finalArr.sequenceNumber) {
              finalArr.scenes.map((scene: any) => {
                scene.pane = this.subDailyFinalArray[index].pane;
                if (
                  scene?.id &&
                  scene?.status !== 'failed' &&
                  scene?.checked != false
                ) {
                  if (
                    !scene?.s_band &&
                    !scene?.x_band &&
                    scene?.usl_footprint
                  ) {
                    scene.x_band = scene?.usl_footprint;
                  }
                  this.displayRFBandNew(
                    scene,
                    scene.sensorId,
                    this.selectedBand
                  );
                }
              });
            }
          });
        });
      } else if (this.selectedCheckboxesNew.length > 0) {
        this.selectedCheckboxesNew.forEach((selecteddate: any, index: any) => {
          if (selecteddate.checked == true) {
            selecteddate.scenes.map((scene: any) => {
              scene.start = this.selectedCheckboxesNew[index].start;
              scene.pane = this.selectedCheckboxesNew[index].pane;
              if (
                scene?.id &&
                scene?.status !== 'failed' &&
                scene?.checked != false
              ) {
                if (!scene?.s_band && !scene?.x_band && scene?.usl_footprint) {
                  scene.x_band = scene?.usl_footprint;
                }
                this.displayRFBandNew(
                  scene,
                  this.collection.sensors[0].id,
                  this.selectedBand
                );
              }
            });
          }
        });
      } else {
        this.sensorsNew.forEach((sensor: any) => {
          if (sensor.checked == true && sensor?.operatorKey == OPERATORS.USL) {
            sensor.scenes.map((scene: any) => {
              if (
                scene?.id &&
                scene?.status !== 'failed' &&
                scene?.checked != false
              ) {
                if (!scene?.s_band && !scene?.x_band && scene?.usl_footprint) {
                  scene.x_band = scene?.usl_footprint;
                }
                this.displayRFBandNew(
                  scene,
                  this.collection.sensors[0].id,
                  this.selectedBand
                );
              }
            });
          }
        });
      }
    }
  }

  resetSelect() {
    if (this.bandSelect) {
      this.bandSelect.value = 'both';
      this.sceneBands = '';
      this.bandSelected = 'both';
    }
  }

  removeLayerByScene(scene: any, options?: any) {
    const paneSpecific = options?.paneSpecific ?? false;
    if (scene?.footprint) {
      this.map.removeLayer(scene?.footprint);
    }
    if (scene?.tiffootprint) {
      this.map.removeLayer(scene?.tiffootprint);
    }
    if (scene?.leftImageLayer) {
      if (!paneSpecific || (paneSpecific && scene.pane == 'left')) {
        this.map.removeLayer(scene.leftImageLayer);
      }
    }
    if (scene?.rightImageLayer) {
      if (!paneSpecific || (paneSpecific && scene.pane == 'right')) {
        this.map.removeLayer(scene.rightImageLayer);
      }
    }
    if (scene?.currentWeekImageLayer) {
      this.map.removeLayer(scene.currentWeekImageLayer);
    }
  }

  removeLayers() {
    this.scenesNew.map((scene: any) => {
      this.removeLayerByScene(scene);
      if (scene?.legendScale) {
        this.map.removeLayer(scene?.legendScale);
      }
      if (scene?.ghgLayers && scene?.ghgLayers?.length > 0) {
        scene?.ghgLayers.forEach((layer) => {
          if (layer) {
            this.map.removeLayer(layer);
          }
        });
      }
    });
    this.resetDefaultMaxZoom();
  }

  removeGHGLayerByScene(ghg: any) {
    if (ghg?.markerLayer) {
      this.map.removeLayer(ghg.markerLayer);
    }
    if (ghg?.legendScale) {
      this.map.removeLayer(ghg.legendScale);
    }
    if (ghg?.trendLine) {
      this.map.removeLayer(ghg?.trendLine);
    }
  }

  removeGHGLayer() {
    this.ghgLayers.map((ghg) => {
      this.removeGHGLayerByScene(ghg);
    });
    this.ghgLayers = [];
    this.trendLinecordinates = [];
  }

  resetClydeHistoricalData() {
    this.clydeHistoricalLayer.map((clydeData) => {
      this.map.removeLayer(clydeData.marker);
    });
    this.clydeHistoricalLayer = [];
  }

  resetSpireHistoricalData() {
    this.spireHistoricalLayer.map((clydeData) => {
      this.map.removeLayer(clydeData.marker);
    });
    this.spireHistoricalLayer = [];
  }

  resetMapNew(isClearSensors: boolean = true) {
    this.unregisterPredictionTimeseries(false);
    this.annotateClicked = false;
    this.newTaskButtonClicked = false;
    this.mapPane = '';
    this.hideLeftCompareLegend = false;
    this.hideRightCompareLegend = false;
    if (this.compare) {
      this.map.removeControl(this.compare);
      this.compare = null;
    }
    if (isClearSensors) this.sensorsNew = [];
    this.selectedCheckboxesNew = [];
    this.subDailyFinalArray = [];
    this.removeLayers();
    this.clearRFBandsNew();
    this.clearRFSignalsNew();
    this.removeISLayers();
    this.removeIndices();
    this.removeSuperResolutions();
    this.removeGHGLayer();
    this.removeClydeVesselLayer();
    this.removeVesselLayer();
    this.removeAnnotationMarkers();
    this.resetClydeHistoricalData();
    this.resetSpireHistoricalData();
    this.isClydeHistorical = false;
    this.HistoricalLayer.forEach((HisLayer) => {
      this.map.removeLayer(HisLayer.marker);
    });
    this.geoByFeed.clear();
    this.HistoricalLayer = [];
    this.scenesNew = [];
    this.leftImageNew = null;
    this.rightImageNew = null;
    this.resetDefaultMaxZoom();
    this.ghgLayers = [];
    this.selectedSites = [];
    if (this.clickedMarker) {
      this.map.removeLayer(this.clickedMarker);
      this.clickedMarker = null;
    }
    if (!this.isAnnotationSaved && this.annotaionMarker) {
      this.map.removeLayer(this.annotaionMarker);
      this.annotaionMarker = null;
    }
    if (this.collectionTaskMarker) {
      this.map.removeLayer(this.collectionTaskMarker);
      this.collectionTaskMarker = null;
    }
    const layersToRemove: L.Layer[] = [];
    this.map.eachLayer((layer: any) => {
      if (layer instanceof L.TileLayer) return;
      layersToRemove.push(layer);
    });
    layersToRemove.forEach((layer) => {
      this.removeVesselLabelLayer(layer);
      this.map.removeLayer(layer);
    });
    Object.values(this.currentFilteredLayers || {}).forEach((layer) => {
        if (this.map.hasLayer(layer)) {
          this.removeVesselLabelLayer(layer);
          this.map.removeLayer(layer);
        }
      });
      this.currentFilteredLayers = {};
    this.filterVesselData = false;
    this.filterData = [];
    // Tear down VoyageRadar on-map toolbar state (isolated in its own method so
    // this shared reset never affects Spire/Clyde).
    this._resetVoyageRadarToolbar();
    // Tear down VesselFinder on-map toolbar state and markers.
    this._resetVesselFinderToolbar();
    // Re-attach WeatherEx target polygon if one is set (resetMapNew removes all non-tile layers).
    this.weatherEx.ensureBoundsLayerOnMap();
    // Re-attach AISstream AOI polygon if one is set.
    this.aisstreamLayer.ensureAoiLayerOnMap();
    // Same for Voyage Radar's tasked target, while its checkbox is still ticked.
    this._ensureVoyageTargetOnMap();
  }

  removeClydeVesselLayer() {
    if (this.clydeVesselLayer) {
      this.map.removeLayer(this.clydeVesselLayer);
      this.clydeVesselLayer = null;
    }
    if (this.clydeAoiFootprintLayer) {
      this.map.removeLayer(this.clydeAoiFootprintLayer);
      this.clydeAoiFootprintLayer = null;
    }
    this.resetClydeHistoricalData();
  }

  removeVesselLayer() {
    // A Voyage Radar pull tags this layer with its refreshId and records it as
    // the active snapshot — dropping the layer (e.g. unchecking the sensor)
    // must drop that selection too, or the ON MAP bar narrates an empty map.
    const voyageTaggedId = (this.aisVesselLayer as any)?.refreshId ?? null;
    if (voyageTaggedId && this.voyageActiveRefreshId === voyageTaggedId) {
      this.voyageActiveRefreshId = null;
      // Which SECTION owned those vessels has the same lifetime as the selection
      // itself — with them gone neither owns the map, and the Observations
      // header's on-map toggle must not stay lit over nothing. Reset here rather
      // than only in `clearVoyageSnapshot` so the paths that drop the layer
      // directly leave the same state behind.
      this.voyageMapSource = null;
      this.voyageObservationSource = [];
    }
    if (this.aisVesselLayer) {
      this.map.removeLayer(this.aisVesselLayer);
      this.aisVesselLayer = null;
    }
    if (this.aoiFootprintLayer) {
      this.map.removeLayer(this.aoiFootprintLayer);
      this.aoiFootprintLayer = null;
    }
    this.resetSpireHistoricalData();
    // VoyageRadar live vessels are drawn in this same layer — dismiss its on-map
    // toolbar when they go. Guarded so Spire (fields already empty) and an
    // active VR playback (layer hidden via a different path) are untouched.
    if (this.playback.mode !== 'playback') {
      this.voyage.releaseLiveLayer(true);
    }
  }

  checkForRelease(sensor) {
    let vadp: boolean = false;
    let sr: boolean = false;
    if (sensor?.valueAddedOption?.length > 0) {
      vadp = sensor.valueAddedOption.every(
        (item) => item?.releaseRequest == true
      );
    } else if (sensor?.superResolutions?.length > 0) {
      if (sensor?.superResolutions[0]?.releaseRequest == true) {
        sr = true;
      }
    }
    return vadp || sr;
  }

  showRefundIcon(scene, collection, downloadedScene, sensor) {
  const cond1 =
    (this.shouldNotDisplayScene(scene, collection, downloadedScene, sensor) ||
      (this.checkForRelease(sensor) && scene.operatorKey !== this.OPERATOR.USL))
    && scene.checked;

  const cond2 =
    !scene.checked ||
    (scene.operatorKey !== this.OPERATOR.SPIRE &&
     scene.operatorKey !== this.OPERATOR.CLYDE);

  return cond1 || cond2;
 }

  releaseVADP(taskId: any, sensor: any) {
    let productName: any, productId: any, product: any;
    if (sensor?.superResolutions?.length > 0) {
      productName = 'superResolutions';
      product = 'Super Resolution';
    } else {
      productName = 'valueAddedOption';
      productId = sensor?.valueAddedOption[0]?.product_id;
      product = 'vadp';
    }

    let message: any;
    let sensorObj = {
      sensorId: sensor.id,
      taskId: taskId,
      vadpId: productId,
      productName: productName,
    };

    let action = 'all';
    if (sensor?.superResolutions?.length > 0) product = 'Super Resolution';

    let params = {
      taskId,
      sensorId: sensor.id,
      product,
      action,
    };

    this.apiService.returnRefundStatus(params).subscribe((resp: any) => {
      if (resp.status != 'found' || (resp.status === 'found' && resp?.refund)) {
        message =
          'You have requested a refund for the value-added data products. You cannot request the products anymore.';
        this.popupService.openPopup(
          CollectionPopupComponent,
          message,
          '',
          '40%'
        );
        return;
      } else {
        this.apiService.processVADP(sensorObj).subscribe((res: any) => {
          if (res) {
            if (res.msg === 'success') {
              const type = 'download';
              message =
                'Thank you for submitting value added products for releasing. You will be notified via email when the files are ready.';
              this.popupService.openPopup(
                WarningPopupComponent,
                message,
                type,
                '40%'
              );
              for (const sensor of this.collection.sensors || []) {
                if (sensor?.valueAddedOption?.length > 0) {
                  sensor.valueAddedOption.releaseRequest = true;
                  for (const option of sensor.valueAddedOption || []) {
                    option.releaseRequest = true;
                  }
                }

                if (sensor.superResolutions?.length > 0) {
                  sensor.superResolutions.releaseRequest = true;
                  for (const option of sensor.superResolutions || []) {
                    option.releaseRequest = true;
                  }
                }
              }
            } else if (res.msg === 'already requested') {
              message =
                'The release request for value added products has either already been made and is being processed.';
              this.popupService.openPopup(
                CollectionPopupComponent,
                message,
                '',
                '40%'
              );
            } else {
              message =
                'An error occurred during processing and ingestion of the request. Please try after sometime.';
              this.popupService.openPopup(
                CollectionPopupComponent,
                message,
                '',
                '40%'
              );
            }
          } else {
            message =
              'An error occurred during processing and ingestion of the request. Please try after sometime.';
            this.popupService.openPopup(
              CollectionPopupComponent,
              message,
              '',
              '40%'
            );
          }
        });
      }
    });
  }

  refundVADP(collectionIndex, sensorIndex, sensor) {
    const taskId = this.collections[collectionIndex]?.taskId;
    let sensorId: any = sensor?.id;
    let product = 'vadp';
    let action = 'all';
    if (sensor?.superResolutions?.length > 0) product = 'Super Resolution';

    let sensorObj = {
      taskId,
      sensorId,
      product,
      action,
    };

    this.apiService.returnRefundStatus(sensorObj).subscribe((res: any) => {
      if (this.isPartialDelivery(res)) {
        return;
      }
      if (res?.status === 'found') {
        if (res?.refund) {
          let message = 'return-refund-accepted';
          if (res?.returnRefundReject) {
            message = 'return-refund-rejected';
          }
          if (res?.returnRefundReject || res?.returnRefundAccept) {
            this.popupService.openPopup(
              CollectionPopupComponent,
              message,
              '',
              '40%'
            );
            return;
          }
        } else {
          const dialog = this.matdialog.open(ReturnRefundComponent, {
            minWidth: '50%',
            data: {
              type: 'return',
              taskId: taskId,
              sensorId: sensorId,
              product: product,
              action: action,
            },
            backdropClass: 'blurred',
            disableClose: true,
          });

          dialog.afterClosed().subscribe((result) => {
            if (result != 'close') {
              const message = 'return-refund-success';
              this.popupService.openPopup(
                CollectionPopupComponent,
                message,
                '',
                '40%'
              );
              for (const sensor of this.collection.sensors || []) {
                for (const option of sensor.valueAddedOption || []) {
                  option.refundRequest = true;
                }

                for (const option of sensor.superResolutions || []) {
                  option.refundRequest = true;
                }
              }
            }
          });
        }
      } else {
        const message = 'return-refund-vadp';
        this.popupService.openPopup(
          CollectionPopupComponent,
          message,
          '',
          '40%'
        );
        return;
      }
    });
  }

  checkForDelivered(sensor) {
    let vadpRefund: boolean = false;
    let srRefund: boolean = false;
    if (sensor?.valueAddedOption?.length > 0) {
      vadpRefund = sensor.valueAddedOption.every(
        (item) => item.product_status === 'DELIVERED'
      );
    } else if (sensor?.superResolutions?.length > 0) {
      if (sensor?.superResolutions[0]?.product_status === 'DELIVERED') {
        srRefund = true;
      }
    }
    return srRefund || vadpRefund;
  }

  OpenReturnRequest(i: any, j: any, info: any, scene: any, action: any) {
    const sensor = this.collections[i].sensors[j];
    const selectedFeed = action === 'feed' ? info : sensor?.InfoServices?.[0];

    if (
      (action === 'feed' || action === 'IS') &&
      this.isMiningChangesMonitoringFeed(selectedFeed)
    ) {
      return;
    }

    if (action === 'feed' && this.isRelatedFeedOrdered(selectedFeed)) {
      return;
    }

    const taskId = this.collections[i]?.taskId;
    let sceneId: any = scene?.id;
    let sensorId: any = sensor?.id;
    let product = 'scene';
    let products = 'scene';
    let feedId: any;

    if (sensor?.superResolutions?.length > 0) product = 'Super Resolution';
    else if (sensor?.operatorKey === OPERATORS.SPIRE) {
      product = 'AIS';
      products = 'AIS';
    } else if (sensor?.operatorKey === OPERATORS.WEATHEREX) {
      product = 'Weather';
      products = 'Weather';
    } else if (info?.insightDatas && action === 'feed') {
      product = 'IS';
      feedId = info?._id;
      products = 'IS';
      sceneId = this.selectedSceneNew?.id;
    } else if (sensor?.operatorKey === OPERATORS.AZISTA) {
      product = OPERATORS.AZISTA;
      products = OPERATORS.AZISTA;
    }

    if (action === 'indices') {
      product = scene.product;
      products = scene.product;
      const currentScene = sensor.scenes.find(
        (scene) => scene.checked === true
      );
      sceneId = currentScene.id;
    }

    if (action === 'sarColorisation') {
      product = scene.actionProvider;
      products = scene.actionProvider;
      sceneId = scene.id;
    }

    let sensorObj = {
      taskId,
      sensorId,
      sceneId,
      product: products,
      feedId,
    };

    let sensorInfo = {
      scene,
      feed: selectedFeed,
      taskId,
      sensorId,
      sceneId,
      product,
      sensor,
      feedId,
      action,
    };

    this.apiService.returnRefundStatus(sensorObj).subscribe((res: any) => {
      if (this.isPartialDelivery(res)) {
        return;
      }
      if (res?.status === 'found') {
        let message = 'return-refund-accepted';
        if (res?.returnRefundReject) {
          message = 'return-refund-rejected';
        }

        if (res?.returnRefundReject || res?.returnRefundAccept) {
          this.popupService.openPopup(
            CollectionPopupComponent,
            message,
            '',
            '40%'
          );
          return;
        } else if (res?.refundRequest && product != 'IS') {
          const message = 'return-refund';
          let type = { msg: product };
          if (action === 'indices') type = { msg: 'indices' };
          if(this.isFeedTasking) type = { msg: 'feed-based' };
          this.popupService.openPopup(
            CollectionPopupComponent,
            message,
            type,
            '40%'
          );
          return;
        } else {
          this.handleRefundRequest(sensorInfo);
        }
      } else if (res?.refundRequest && product === 'IS') {
        const message = 'return-refund';
        let type = { msg: product };
        if (action === 'indices') type = { msg: 'indices' };
        if (action === 'sarColorisation') type = { msg: 'sarColorisation' };
        if(this.isFeedTasking) type = { msg: 'feed-based' };
        this.popupService.openPopup(
          CollectionPopupComponent,
          message,
          type,
          '40%'
        );
        return;
      } else {
        this.handleRefundRequest(sensorInfo);
      }
    });
  }

  handleRefundRequest(sensorInfo: any) {
    let scene = sensorInfo.scene;
    let taskId = sensorInfo.taskId;
    let sensorId = sensorInfo.sensorId;
    let sceneId = sensorInfo.sceneId;
    let product = sensorInfo.product;
    let sensor = sensorInfo.sensor;

    if (
      scene?.refundRequest &&
      product != 'IS' &&
      sensor?.operatorKey !== OPERATORS.AZISTA
    ) {
      const message = 'return-refund';
      const type = { msg: product };
      this.popupService.openPopup(
        CollectionPopupComponent,
        message,
        type,
        '40%'
      );
      return;
    } else {
      const dialog = this.matdialog.open(ReturnRefundComponent, {
        minWidth: '50%',
        data: {
          type: 'return',
          taskId: taskId,
          sensorId: sensorId,
          sceneId: sceneId,
          product: this.isFeedTasking ? 'scene' : product,
          action: this.isFeedTasking ? 'scene' :sensorInfo?.action,
          feedId: sensorInfo?.feedId,
        },
        backdropClass: 'blurred',
        disableClose: true,
      });

      dialog.afterClosed().subscribe((result) => {
        if (result != 'close') {
          if (sensorInfo.action === 'feed' && sensorInfo.feed?.prediction_info_ordered === false) {
            this.refundedPredictionDriftSensors.add(sensor);
          }
          const message = 'return-refund-success';
          this.popupService.openPopup(
            CollectionPopupComponent,
            message,
            '',
            '40%'
          );
          this.refundRequestScenes.push(localStorage.getItem('refund-request'));
        }
      });
    }
  }

  refundStatus(scene: any) {
    if (
      scene?.refundRequest &&
      (scene?.returnRefundAccept || scene?.returnRefundReject)
    ) {
      let message = 'return-refund-accepted';
      if (scene?.returnRefundReject) {
        message = 'return-refund-rejected';
      }
      this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
      return;
    }
  }

  shouldDisplayScene(
    scene: any,
    collection: any,
    downloadedScene: any[],
    sensor: any
  ): boolean {
    const isSceneValid = scene.id && scene.status !== 'failed';
    const isDownloaded = downloadedScene.includes(scene.id) || scene.downloaded;
    const isReturnRefund = collection?.returnRefund;
    const isNotArchive = sensor?.status != 'archived';
    return isSceneValid && isDownloaded && isReturnRefund && isNotArchive;
  }

  shouldNotDisplayScene(
    scene: any,
    collection: any,
    downloadedScene: any[],
    sensor: any
  ): boolean {
    const hasValidIdAndStatus = scene.id && scene.status !== 'failed';
    const isNotDownloadedAndNotInDownloadedScenes =
      !scene.downloaded && !downloadedScene.includes(scene.id);
    const isArchived =
      sensor?.status === 'archived' && collection?.returnRefund;

    return (
      (hasValidIdAndStatus && isNotDownloadedAndNotInDownloadedScenes) ||
      isArchived || sensor?.status !== 'completed'
    );
  }

  openRestoreRequest(i, j, sensor) {
    const sensors = this.collections[i].sensors[j];
    const taskId = this.collections[i]?.taskId;
    let sensorId: any;
    sensorId = sensors?.id;
    let statusObj = { taskId: taskId, sensorId: sensorId };

    this.apiService.restoreStatus(statusObj).subscribe(async (res: any) => {
      if (res?.restoreStatus === 'Submit') {
        const message = 'restore';
        const type = { msg: 'restore-prerequested' };
        this.popupService.openPopup(
          CollectionPopupComponent,
          message,
          type,
          '40%'
        );
        return;
      } else if (res?.restoreStatus === 'Rejected') {
        const message = 'restore';
        const type = {
          msg: 'rejected',
          taskname: res?.taskname,
          reason: res?.reason,
        };
        this.popupService.openPopup(
          CollectionPopupComponent,
          message,
          type,
          '40%'
        );
      } else {
        const dialog = this.matdialog.open(ReturnRefundComponent, {
          minWidth: '50%',
          data: { type: 'restore' },
          backdropClass: 'blurred',
          disableClose: true,
        });
        dialog.afterClosed().subscribe((result) => {
          if (result != 'close') {
            const message = 'restore';
            const type = { msg: 'restore-success' };
            this.popupService.openPopup(
              CollectionPopupComponent,
              message,
              type,
              '40%'
            );
            const restoreRequestReason = result.restoreReason;
            const restoreOption = result.restoreOption;

            const sensorObj = {
              taskId: taskId,
              sensorId: sensorId,
              restoreOption: restoreOption,
              restoreRequestReason: restoreRequestReason,
            };
            this.apiService
              .restoreRequest(sensorObj)
              .subscribe(async (res: any) => {});
            localStorage.setItem('restore-request', sensorId);
            this.restoreRequestedSensors.push(
              localStorage.getItem('restore-request')
            );
          } else {
            return;
          }
        });
      }
    });
  }

  
    hasCheckedValidSceneForSensor(collectionIndex, sensorIndex): boolean {
    const sensor = this.collections[collectionIndex]?.sensors[sensorIndex];
    return this.getCheckedValidScenes(sensor).length > 0;
  }

  isFeedDeliveryPending(collectionIndex: number, sensorIndex: number, infoService: any): boolean {
    if (!this.observationEnabled) return false;

    const sensor = this.collections[collectionIndex]?.sensors[sensorIndex];
    const selectedScenes = this.getCheckedValidScenes(sensor);
    if (!selectedScenes.length) return false;

    const insightDatas = Array.isArray(infoService?.insightDatas)
      ? infoService.insightDatas
      : [];

    return selectedScenes.some((scene) =>
      !insightDatas.some(
        (insight) => insight?.sceneId === scene.id && !!insight?.insightFootprint
      )
    );
  }

    shouldDisableIS(collectionIndex, sensorIndex, scene: any, InfoService?: any, infoServiceIndex: number = 0) {
    const sensor = this.collections[collectionIndex]?.sensors[sensorIndex];

    if (InfoService && this.isStandardMultiSensorCompareActive(sensor)) {
      return false;
    }


    // Case 1: If single InfoService object is passed
    if (InfoService) {
      return this.evaluateDisable(
        collectionIndex,
        sensorIndex,
        scene,
        InfoService,
      );
    }

    // Case 2: If not passed → use sensor.InfoService array
    const infoServices = sensor?.InfoServices || [];

    if (!infoServices.length) {
      return true; // no InfoService → disable
    }

    // If ANY one is enabled → overall enabled
    const anyEnabled = infoServices.some(
    (service) =>
      this.evaluateDisable(collectionIndex, sensorIndex, scene, service,true),
    );
     return anyEnabled;
  }

  private evaluateDisable(
    collectionIndex,
    sensorIndex,
    scene,
    InfoService,
    isTaskBased = false
  ): boolean {
    const sensorScenes =
      this.collections[collectionIndex]?.sensors[sensorIndex]?.scenes || [];
    const checkedSceneCount = sensorScenes.filter((sensorScene) => sensorScene?.checked).length;
    const insightDatas = Array.isArray(InfoService?.insightDatas)
      ? InfoService.insightDatas
      : [];
    const requiredSceneIds = this.combinedScenes
      ? sensorScenes.map((sensorScene) => sensorScene?.id).filter(Boolean)
      : [(isTaskBased ? scene?.id : this.sceneSelected)].filter(Boolean);
    const selectedSceneIS = insightDatas.filter((sceneData) =>
      requiredSceneIds.includes(sceneData?.sceneId)
    );
    const isData = this.combinedScenes
      ? requiredSceneIds.length > 0 &&
        requiredSceneIds.every((sceneId) =>
          selectedSceneIS.some(
            (sceneData) =>
              sceneData?.sceneId === sceneId && !!sceneData?.insightFootprint
          )
        )
      : selectedSceneIS?.length > 0 && !!selectedSceneIS?.[0]?.insightFootprint;
    this.isData = isData;
    const isSameSensor =
      this.collections[collectionIndex]?.sensors[sensorIndex]?.id ===
      InfoService.sensorId;
    const checkedSensors = this.collections[collectionIndex]?.sensors.filter(
      (scene) => scene.checked === true
    );
    let checkedInfo: boolean = true;

    if (checkedSensors?.length > 0) {
      checkedInfo = checkedSensors[0].id === InfoService.sensorId;
    }

    let isDisable: boolean = true;
    if (
      this.collections[collectionIndex]?.sensors[sensorIndex]?.operatorKey !=
      OPERATORS.AXELSPACE
    ) {
      isDisable =
        !isSameSensor ||
        !scene?.id ||
        scene?.status === 'failed' ||
        !isData ||
        !checkedInfo;
    } else {
      const isChecked =
        this.collections[collectionIndex]?.sensors[sensorIndex]?.checked;
      const allSceneChecked = this.collections[collectionIndex]?.sensors[
        sensorIndex
      ]?.scenes.every((scene) => scene.checked);
      isDisable = !isChecked || (isChecked && !allSceneChecked);
    }
    if (!isTaskBased) {
      const isTileBasedOperator =
        this.collections[collectionIndex]?.sensors[sensorIndex]?.operatorKey ===
          OPERATORS.AXELSPACE ||
        this.collections[collectionIndex]?.sensors[sensorIndex]?.operatorKey ===
          OPERATORS.AZISTA;
      if (
        this.isObservation(
          this.collections[collectionIndex]?.sensors[sensorIndex]
        ) &&
        Object.keys(this.selectedHistory).length > 0
      ) {
        isDisable = false;
      } else if (this.observationEnabled && (isData || isTileBasedOperator)) {
        isDisable = false;
      } else if (this.observationEnabled && this.collections[collectionIndex]?.sensors[sensorIndex]?.Observation[0]?.rf_observation == true){
        isDisable = false;
      }else {
        isDisable = true;
      }

      if (!this.combinedScenes && checkedSceneCount === 1) {
        return false;
      }
    }

    return isDisable;
  }

  shouldDisableFeedCompareIS(
  sensor: any,
  scene: any,
  InfoService: any
) {
  const selectedSceneIS = InfoService?.insightDatas?.filter(
    (s) => s.sceneId === sensor.scenes[0]?.id
  );

  const isData =
    selectedSceneIS?.length > 0 &&
    !!selectedSceneIS?.[0]?.insightFootprint;

  this.isData = isData;

  const isSameSensor = sensor?.id === InfoService.sensorId;

  const checkedSensors = this.selectedCheckboxesNew?.filter(
    (s) => s.checked === true
  );

  let checkedInfo: boolean = true;

  if (checkedSensors?.length > 0) {
    checkedInfo = checkedSensors[0].id === InfoService.sensorId;
  }

  let isDisable: boolean = true;

  if (sensor?.operatorKey !== OPERATORS.AXELSPACE) {
    isDisable =
      this.sensorsIS ||
      !isSameSensor ||
      !scene?.id ||
      scene?.status === 'failed' ||
      !isData ||
      !checkedInfo;
  } else {
    const isChecked = sensor?.checked;

    const allSceneChecked = sensor?.scenes?.every(
      (s) => s.checked
    );

    isDisable = !isChecked || (isChecked && !allSceneChecked);
  }

  if (
    this.isObservation(sensor) &&
    Object.keys(this.selectedHistory).length > 0
  ) {
    isDisable = false;
  } else if (this.observationEnabled && isData) {
    isDisable = false;
  } else {
    isDisable = true;
  }

  return isDisable;
}

    shouldDisableRecurrentIS(
    collectionIndex,
    sensorIndex,
    scene1: any,
    InfoService: any,
    infoServiceIndex: number = 0
  ) {
    
    const scene = this.selectedCheckboxesNew[sensorIndex]?.scenes[0];
    this.selectedCheckboxesNew
    const selectedSceneIS = InfoService?.insightDatas?.filter(
      (sceneValue) => sceneValue.sceneId === scene.id
    );
    const isData = selectedSceneIS?.length > 0;
    this.isData = isData;
    const checkedSensors = this.selectedCheckboxesNew.filter(
      (scene) => scene.checked === true
    );

    let isDisable: boolean = true;
    if (
      this.selectedCheckboxesNew[sensorIndex]?.operatorKey !=
      OPERATORS.AXELSPACE
    ) {
      isDisable =
        !scene.id ||
        scene?.status === 'failed' ||
        !isData 
    } else {
      const isChecked =
        this.selectedCheckboxesNew[sensorIndex]?.checked;
      const allSceneChecked = this.selectedCheckboxesNew[
        sensorIndex
      ]?.scenes.every((scene) => scene.checked);
      isDisable = !isChecked || (isChecked && !allSceneChecked);
    }

    if (
      this.isObservation(
        this.selectedCheckboxesNew[sensorIndex]
      ) &&
      Object.keys(this.selectedHistory).length > 0
    ) {
      isDisable = false;
    } else if (this.observationEnabled) {
      isDisable = false;
    } else {
      isDisable = true;
    }
    return isDisable;
  }

  shouldScenChecked(collectionIndex, sensorIndex, scene, scenesIndex) {
    if (scenesIndex !== undefined) {
      return (
        this.collections[collectionIndex]?.sensors[sensorIndex]?.scenes[
          scenesIndex
        ]?.checked ?? false
      );
    }
  }

  private _downloadStatesCache: Map<string, boolean> = new Map();
  private _lastInfoServiceData: any;

  shouldDownload(
    collectionIndex,
    sensorIndex,
    scene: any,
    InfoService,
    infoServiceIndex?: number
  ) {
    if (infoServiceIndex !== undefined) {
      const sensor = this.collections[collectionIndex]?.sensors[sensorIndex];
      const infoFeedAtIndex = sensor?.InfoServices?.[infoServiceIndex];

      if (
        infoFeedAtIndex &&
        infoFeedAtIndex === InfoService
      ) {
        return infoFeedAtIndex?.checked ?? false;
      }

      const associatedFeedAtIndex = sensor?.AssociatedFeeds?.[infoServiceIndex];
      if (
        associatedFeedAtIndex &&
        associatedFeedAtIndex === InfoService
      ) {
        return associatedFeedAtIndex?.checked ?? false;
      }

      const isthermalObservationAtIndex = sensor?.Observation?.[infoServiceIndex];
      if (isthermalObservationAtIndex && isthermalObservationAtIndex === InfoService && InfoService?.thermal_observation === true) {
        return this.checkedObservation ?? false;
      }

      return InfoService?.checked ?? false;
    }
    if (!this.sceneSelected) {
      return false;
    }

    scene = this.collections[collectionIndex]?.sensors[
      sensorIndex
    ]?.scenes.find((scn) => scn.id === this.sceneSelected);

    if (scene && scene.checked === false) {
      return false;
    }

    // Clear cache if InfoService data changed
    if (this._lastInfoServiceData !== InfoService?.insightDatas) {
      this._downloadStatesCache.clear();
      this._lastInfoServiceData = InfoService?.insightDatas;
    }

    // Create unique key for this combination
    const cacheKey = `${collectionIndex}-${sensorIndex}-${scene?.id}`;

    // Return cached value if exists
    if (this._downloadStatesCache.has(cacheKey)) {
      return this._downloadStatesCache.get(cacheKey)!;
    }
    const selectedSceneIS = InfoService?.insightDatas?.filter(
      (scene) => scene.sceneId === this.sceneSelected
    );
    const isData = selectedSceneIS?.length > 0;
    const isSameSensor =
      this.collections[collectionIndex]?.sensors[sensorIndex]?.id ===
      InfoService.sensorId;
    const isLength =
      isData && selectedSceneIS[0]?.insightFootprint?.features?.length > 0;
    const selectedSensorIS = InfoService?.insightDatas?.length > 0;
    let isDownload: boolean = true;

    const isChecked =
      this.collections[collectionIndex]?.sensors[sensorIndex]?.checked;
    const scenes =
      this.collections[collectionIndex]?.sensors[sensorIndex]?.scenes || [];
    const checkedScenesLength = scenes.filter((scene) => scene.checked).length;
    const totalScenes = scenes.length;
    const isOneOrAllChecked =
      checkedScenesLength === 1 || checkedScenesLength === totalScenes;
    isDownload = checkedScenesLength != 0 && isOneOrAllChecked;
    if (
      this.collections[collectionIndex]?.sensors[sensorIndex].InfoServices
        .length > 1 &&
      checkedScenesLength > 1
    ) {
      return false;
    }
    if (isDownload) {
      if (
        this.collections[collectionIndex]?.sensors[sensorIndex]?.operatorKey !=
        OPERATORS.AXELSPACE
      ) {
        for (let scene of scenes) {
          const hasScene = scene && scene.id;
          const isSceneValid = scene && scene.status !== 'failed';
          isDownload =
            hasScene &&
            isSceneValid &&
            isSameSensor &&
            isData &&
            !this.isVisible &&
            isLength;
          break;
        }
      } else {
        const isChecked =
          this.collections[collectionIndex]?.sensors[sensorIndex]?.checked;
        const allSceneChecked = this.collections[collectionIndex]?.sensors[
          sensorIndex
        ]?.scenes.every((scene) => scene.checked);
        isDownload = isChecked && allSceneChecked && selectedSensorIS;
      }
    }
    // Cache the result
    this._downloadStatesCache.set(cacheKey, isDownload);

    return isDownload;
  }

  shouldDownloadFeedTask(
  collectionIndex,
  sensorIndex,
  scene: any
): boolean {

  const sensor =
    this.collections[collectionIndex]?.sensors[sensorIndex];

  const infoServices = sensor?.InfoServices || [];

  if (!infoServices.length) {
    return false;
  }

  // every() → returns true only if ALL return true
  return infoServices.every((service, index) =>
    !service.isDisable &&
    this.shouldDownload(
      collectionIndex,
      sensorIndex,
      scene,
      service,
      index
    )
  );
}

  shouldDownloadCompareFeed(
  sensor: any,
  scene: any,
  InfoService: any,
  infoServiceIndex?: number
) {
  // If checking InfoService checkbox state
  if (infoServiceIndex !== undefined) {
    return InfoService?.checked ?? false;
  }

  // Find selected scene from sensor.scenes
  const selectedScene = sensor?.scenes?.find(
    (scn: any) => scn.id === sensor.scenes[0]?.id
  );

  if (selectedScene && selectedScene.checked === false) {
    return false;
  }

  // Clear cache if InfoService data changed
  if (this._lastInfoServiceData !== InfoService?.insightDatas) {
    this._downloadStatesCache.clear();
    this._lastInfoServiceData = InfoService?.insightDatas;
  }

  // Create unique key
  const cacheKey = `${sensor?.id}-${selectedScene?.id}`;

  if (this._downloadStatesCache.has(cacheKey)) {
    return this._downloadStatesCache.get(cacheKey)!;
  }

  const selectedSceneIS = InfoService?.insightDatas?.filter(
    (s: any) => s.sceneId === this.sceneSelected
  );

  const isData = selectedSceneIS?.length > 0;

  const isSameSensor = sensor?.id === InfoService?.sensorId;

  const isLength =
    isData &&
    selectedSceneIS?.[0]?.insightFootprint?.features?.length > 0;

  const selectedSensorIS = InfoService?.insightDatas?.length > 0;

  const scenes = sensor?.scenes || [];

  const checkedScenesLength = scenes.filter(
    (s: any) => s.checked
  ).length;

  const totalScenes = scenes.length;

  const isOneOrAllChecked =
    checkedScenesLength === 1 ||
    checkedScenesLength === totalScenes;

  let isDownload =
    checkedScenesLength !== 0 && isOneOrAllChecked;

  // Multiple InfoServices + multiple scenes checked
  if (sensor?.InfoServices?.length > 1 && checkedScenesLength > 1) {
    this._downloadStatesCache.set(cacheKey, false);
    return false;
  }

  if (isDownload) {
    if (sensor?.operatorKey !== OPERATORS.AXELSPACE) {
      const firstScene = scenes[0];

      const hasScene = !!firstScene?.id;
      const isSceneValid = firstScene?.status !== 'failed';

      isDownload =
        hasScene &&
        isSceneValid &&
        isSameSensor &&
        isData &&
        !this.isVisible &&
        isLength;
    } else {
      const isChecked = sensor?.checked;

      const allSceneChecked = scenes.every(
        (s: any) => s.checked
      );

      isDownload =
        isChecked && allSceneChecked && selectedSensorIS;
    }
  }

  // Cache the result
  this._downloadStatesCache.set(cacheKey, isDownload);

  return isDownload;
}

  shouldNotDownload(collectionIndex, sensorIndex, scene: any, InfoService) {

    const sensor = this.collections[collectionIndex]?.sensors[sensorIndex];

    const isThermalObservationEntry = Array.isArray(sensor?.Observation) && sensor.Observation.includes(InfoService) && InfoService?.thermal_observation === true;
    if (isThermalObservationEntry) {
      return !this.checkedObservation;
    }
    
    const selectedSceneIS = InfoService?.insightDatas?.filter(
      (scene) => scene.sceneId === this.sceneSelected
    );
    const isData = selectedSceneIS?.length > 0;
    const isSameSensor =
      this.collections[collectionIndex]?.sensors[sensorIndex]?.id ===
      InfoService.sensorId;
    const isLength =
      isData &&
      (selectedSceneIS[0]?.insightFootprint?.features?.length === 0 ||
        !selectedSceneIS[0]?.insightFootprint);
    const selectedSensorIS = InfoService?.insightDatas?.length > 0;

    let isDownload: boolean = false;
    if (
      this.collections[collectionIndex]?.sensors[sensorIndex]?.operatorKey !=
      OPERATORS.AXELSPACE
    ) {
      isDownload =
        !scene?.id ||
        scene?.status === 'failed' ||
        (this.sensorsIS && isSameSensor) ||
        !isData ||
        this.isVisible ||
        isLength;
    } else {
      const isChecked =
        this.collections[collectionIndex]?.sensors[sensorIndex]?.checked;
      const allSceneChecked = this.collections[collectionIndex]?.sensors[
        sensorIndex
      ]?.scenes.every((scene) => scene.checked);
      isDownload = !isChecked || !allSceneChecked || !selectedSensorIS;
    }
    return isDownload;
  }

  getFeedInfo(info: any) {
    const checkedInfo = info.filter((data) => data.checked === true);
    return checkedInfo.length > 0;
  }

  // ============ GENERIC: Detect ANY CLASS_BASED feed (Soil Moisture, Vessel Classification, Flood Inundation) ============
  hasClassBasedFilterMessageShown(info) {
    // Type-Centric: Check if any filter type is active
    if (this.filtersByType.size > 0) {
      return true;
    }
    
    // Original logic: check if feed supports filtering
    return info.some((item) => {
      const cfg = feedsConfig[item._id];
      // Show filter only if there are more than 2 classes to filter
      const colorMap = cfg?.color;
      const classCount = colorMap ? Object.keys(colorMap).length : 0;
      return (
        item?.checked === true &&
        cfg &&
        classCount > 2 &&
        cfg?.colorMode === 'CLASS_BASED' &&
        // Exclude vessel/vehicle/LULC (they have their own methods)
        !['ship', 'vessel', 'vehicle-classification', 'land use/land cover detection']
          .includes(cfg.type?.toLowerCase())
      );
    });
  }

  getFeedInfoForFilter(info: any, event?: any, key?: any) {
    if (!Array.isArray(info)) return false;
    const eventChecked = !!event?.checked;
    const hasCheckedSupportedFeed = () =>
      info.some((item) => {
        const cfg = feedsConfig[item._id];
        // Check for Vessel feeds (length filtering)
        const isVesselFeed = cfg && ['ship', 'vessel'].includes(cfg.type?.toLowerCase());
        if (isVesselFeed && item?.checked === true) return true;
        
        // Check for CLASS_BASED feeds (class filtering) - show filter only if > 2 classes
        const colorMap = cfg?.color;
        const classCount = colorMap ? Object.keys(colorMap).length : 0;
        return (
          item?.checked === true &&
          cfg &&
          classCount > 2 &&
          cfg?.colorMode === 'CLASS_BASED'
        );
      });

    if (eventChecked && key) {
      const targetItem = info.find(
        (item) => item._id === key || item.feedName === key || item.name === key
      );
      if (!targetItem) return false;
      const cfg = feedsConfig[targetItem._id];
      
      // Check for Vessel feeds
      const isVesselFeed = cfg && ['ship', 'vessel'].includes(cfg.type?.toLowerCase());
      if (isVesselFeed) return true;
      
      // Check for CLASS_BASED feeds
      const colorMap = cfg?.color;
      const classCount = colorMap ? Object.keys(colorMap).length : 0;
      const isSupportedFeed = cfg && classCount > 2 && cfg?.colorMode === 'CLASS_BASED';

      if (isSupportedFeed) return true;

      return hasCheckedSupportedFeed();
    }
    return hasCheckedSupportedFeed();
  }

  checkType() {
    return this.imageType == 'png' ? 'png' : 'tiff';
  }
  toggleImageType(
    collection: any,
    event: any,
    collectionIndex: any,
    scene: any,
    scenesIndex: any,
    sensorIndex: any,
    InfoServices
  ) {
    let imageType = 'png';
    this.removeDynamicLayer();
    this.removeVectorOverlay();
    this.clearAllFeedPanels();
    this.clearComparisonFeedPanels();
    this.resetObservationSelection();
    this.feedUi = { showFilterIcon: false };
    if (event.checked) {
      this.imageType = 'tif';
      imageType = 'tif';
      scene.tif = true;
    } else {
      this.imageType = 'png';
      imageType = 'png';
      scene.tif = false;
    }
    InfoServices.forEach((InfoService) => {
      if (InfoService.checked) {
        InfoService.checked = false;
      }
    });
    scene.imageType = imageType;
    if (scene.checked) {
      let sceneIndex = this.scenesNew.findIndex(
        (sceneNew) => sceneNew.id == scene.id
      );
      if (sceneIndex != -1) {
        event.checked = false;
        if (this.selectedCheckboxesNew.length > 0 && this.isCompare) {
          this.toggleRecurrentSceneNew(
            collection,
            collectionIndex,
            sensorIndex,
            scenesIndex,
            scene,
            event
          );
        } else if (this.subDailyFinalArray.length > 0 && this.isCompare) {
          this.toggleRecurrentSubdailySceneNew(
            collection,
            collectionIndex,
            sensorIndex,
            scenesIndex,
            event
          );
        } else {
          this.toggleSceneNew(
            collection,
            collectionIndex,
            sensorIndex,
            scenesIndex,
            event
          );
        }
      }
      event.checked = true;
      scene.imageType = imageType;
      scene.tif = imageType == 'png' ? false : true;
      if (this.selectedCheckboxesNew.length > 0 && this.isCompare) {
        this.toggleRecurrentSceneNew(
          collection,
          collectionIndex,
          sensorIndex,
          scenesIndex,
          scene,
          event
        );
      } else if (this.subDailyFinalArray.length > 0 && this.isCompare) {
        this.toggleRecurrentSubdailySceneNew(
          collection,
          collectionIndex,
          sensorIndex,
          scenesIndex,
          event
        );
      } else {
        this.toggleSceneNew(
          collection,
          collectionIndex,
          sensorIndex,
          scenesIndex,
          event
        );
      }
    }
  }
  controlImageType(event) {
    this.cancelViewportGeojsonLoads();
    this.resetPredictionDriftPanel();
    this.loadTiff = event.checked;
    this.clearActiveChangeDetectionCurrentWeekTab();
    this.uncheckAll(event.checked);
    if (this.isChangeDetectionTask(this.collection?.taskStrategy)) {
      this.collection?.sensors?.forEach((sensor: any) =>
        this.clearChangeHistoryForSensor(sensor)
      );
      this.changeDetectionHistorySelections = [];
      this.resetChangeDetectionCompareDisplayState();
      this.isCompareRecurrency = false;
      this.isCompareClicked = false;
      this.needsCompareResetToCenter = false;
    }
    this.resetMapNew();
    this.syncChangeHistoryOverlayOpacity();
    let imageType = 'png';
    this.filterInfoVisible = false;
    this.removeDynamicLayer();
    this.removeVectorOverlay();
    this.clearAllFeedPanels();
    this.clearComparisonFeedPanels();
    this.resetObservationSelection();
    this.spinnerService.hide();
    this.feedUi = { showFilterIcon: false };
    this.combinedScenes = false;
    this.isCompare = false;
    if (event.checked) {
      this.imageType = 'tif';
      imageType = 'tif';
    } else {
      this.imageType = 'png';
      imageType = 'png';
    }
    this.collection.sensors.forEach((sensor: any) => {
      sensor.InfoServices?.forEach((InfoService: any) => {
        InfoService.checked = false;
        InfoService.isDisable = true;
      });

      sensor.AssociatedFeeds?.forEach((associatedFeed: any) => {
        associatedFeed.checked = false;
        associatedFeed.isDisable = true;
      });
    });
  }

  private clearActiveChangeDetectionCurrentWeekTab(): void {
    if (
      !this.isChangeDetectionTask(this.collection?.taskStrategy) ||
      this.selectedChangeDetectionTab.length === 0
    ) {
      return;
    }

    this.selectedChangeDetectionTab = [];
    this.clearChangeDetectionTabLayers();
  }

  clearSelectedBands(event) {
    this.isBandApplied = false;
    this.selectedBands = [];
    this.resetMapNew();
    this.collection.sensors?.forEach(sensor => {
     sensor.checked = false;

     sensor.scenes?.forEach(scene => {
     scene.checked = false;
    });
   });
  }

  mapProperties(properties) {
    return {
      ID: properties?.ID,
      'Timestamp UTC': properties?.timestamp_utc,
      'RF Frequency MHz': properties?.RF_Frequency_MHz,
      Lng: properties?.longitude_deg,
      Lat: properties?.latitude_deg,
      'Accuracy Level': properties?.accuracy_level,
      'Pulses Duration ns': properties?.pulses_duration_ns,
      'Pulses Repetition Frequency Hz':
        properties?.pulses_repetition_frequency_Hz,
    };
  }

  formatProperties(properties: any): string {
    let formattedProps = '';
    for (let key in properties) {
      if (key != 'class' && properties[key] != 'Undefined') {
        formattedProps += `<strong>${key}</strong>  :  ${properties[key]}<br>`;
      }
    }
    return formattedProps;
  }

  /* Init geoSearchControl */
  private initGeoSearchControl(): void {
    const provider = new OpenStreetMapProvider();
    const originalProviderSearch = provider.search.bind(provider);
    provider.search = ((searchArguments: any) => {
      const rawQuery =
        typeof searchArguments === 'string'
          ? searchArguments
          : searchArguments?.query;
      const mgrsCoordinate =
        typeof rawQuery === 'string'
          ? this.mgrsHelperService.convertMGRSToLatLng(rawQuery)
          : null;

      if (!mgrsCoordinate) {
        return originalProviderSearch(searchArguments);
      }

      const convertedQuery = `${mgrsCoordinate.lng}, ${mgrsCoordinate.lat}`;
      return originalProviderSearch(
        typeof searchArguments === 'string'
          ? convertedQuery
          : { ...searchArguments, query: convertedQuery }
      );
    }) as typeof provider.search;
    const searchControl = (GeoSearchControl as any)({
      provider: provider,
      showMarker: false,
      style: 'button',
      position: 'topright',
      size: 5,
      searchLabel: 'Enter an address or landmark...',
      keepResult: true,
      autoClose: false,
    });
    this.map.addControl(searchControl);
    const searchFormEl = document.querySelector(
      '.leaflet-geosearch-button form'
    ) as HTMLFormElement;
    const searchInputEl = searchFormEl.querySelector(
      'input'
    ) as HTMLInputElement;
    const leafletBarElement = document.querySelector(
      '.leaflet-bar-part.leaflet-bar-part-single'
    );
    if (leafletBarElement) {
      leafletBarElement.setAttribute(
        'title',
        '• Search by location\n• Input Lng, Lat for a point\n• Input Lng, Lat pairs separated by semicolon for an area\n• Search by 15-character MGRS coordinate system'
      );
    }
    let searchBtnParentEl: any;
    searchInputEl.addEventListener('keydown', (event: any) => {
      if (event.key === 'Enter') {
        const query = event.target.value;
        const mgrsCoordinate = this.mgrsHelperService.convertMGRSToLatLng(query);

        if (mgrsCoordinate) {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation?.();

          this.resultHandler({
            location: {
              raw: {
                lat: mgrsCoordinate.lat,
                lon: mgrsCoordinate.lng,
              },
            },
          }, false);
          return;
        }

        const coordinate = this.helperService.parseCoordinatePair(query,'lng-lat');
        if (coordinate) {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation?.();

          this.resultHandler({
            location: { raw: { lat: coordinate.lat, lon: coordinate.lng } },
          }, true);
          return;
        }

        // Non-coordinate Enter searches should continue using hover DMS.
        this.isCoordinateSearchActive = false;
        this.searchedCoordinate = null;
      }

      const query = event.target.value;
      const coords = event.target.value
        .trim()
        .split(',')
        .map((coord) => coord.trim());
      if (coords.length === 2) {
        searchBtnParentEl = document.querySelector('.results');
        if (searchBtnParentEl) {
          searchBtnParentEl.style.display = 'none';
        }
        const lat = parseFloat(coords[0]);
        const lng = parseFloat(coords[1]);
        if (!isNaN(lat) && !isNaN(lng) && event.key == 'Enter') {
          provider.search({ query: `${lng}, ${lat}` }).then((results) => {
            if (!results?.[0]) {
              return;
            }
            const res: object = { location: results[0] };
            this.resultHandler(res, true);
          });
        }
      } else {
        if (searchBtnParentEl) {
          searchBtnParentEl.style.display = 'block';
        }
      }
    });
    searchInputEl.addEventListener('input', () => {
      if (!(searchInputEl.value || '').trim()) {
        this.isCoordinateSearchActive = false;
        this.searchedCoordinate = null;
      }
    });

    /* Custom reset button */
    const resetBtn = L.DomUtil.create('button');
    resetBtn.setAttribute('class', 'reset_btn');
    resetBtn.setAttribute('type', 'button');
    resetBtn.innerHTML = 'x';
    const formEl = document.querySelector(
      '.leaflet-geosearch-button form'
    ) as HTMLFormElement;
    formEl?.appendChild(resetBtn);
    resetBtn.addEventListener('click', (event: any) => {
      event.preventDefault();
      event.stopPropagation();
      this.resetSearchInput();
    });
    this.initHoverOnSearchBox();
    const searchEl = document.querySelector(
      '.leaflet-control-geosearch'
    ) as HTMLFormElement;
    const searchInput = formEl.querySelector('input') as HTMLInputElement;
    const searchBtnEl = L.DomUtil.create('button');
    searchBtnEl.setAttribute('class', 'searchBtn');
    searchBtnEl.setAttribute('type', 'button');
    searchEl.append(searchBtnEl);
    const handleSearchIconClick = (event: Event) => {
      event.preventDefault();
      event.stopPropagation();

      const query = (searchInput.value || '').trim();
      if (!query) {
        this.showAndHideSearchInput(true);
        searchInput.classList.add('active');
        searchInput.focus();
        return;
      }

      searchInput.dispatchEvent(
        new KeyboardEvent('keydown', {
          key: 'Enter',
          code: 'Enter',
          bubbles: true,
          cancelable: true,
        })
      );
      this.showAndHideSearchInput(true);
      searchInput.classList.add('active');
      searchInput.focus();
    };
    searchBtnEl.addEventListener('click', handleSearchIconClick);
    const searchIconTrigger = document.querySelector(
      '.leaflet-geosearch-button > a.leaflet-bar-part.leaflet-bar-part-single'
    ) as HTMLElement;
    searchIconTrigger?.addEventListener('click', handleSearchIconClick, true);
    searchInput.addEventListener('focus', (event: any) => {
      searchInput.classList.add('active');
      const resetBtn = formEl.querySelector('.reset_btn') as HTMLButtonElement;
      resetBtn.style.display = 'block';
    });
    this.map.on('geosearch/showlocation', () => {
      const query = (searchInputEl.value || '').trim();
      const isMgrs = !!this.mgrsHelperService.convertMGRSToLatLng(query);
      const isCoordinate = !!this.helperService.parseCoordinatePair(query, 'lng-lat');
      if (!isMgrs && !isCoordinate) {
        this.isCoordinateSearchActive = false;
        this.searchedCoordinate = null;
      }
    });
  }

  private resultHandler(e, keepSearchedDms = false): void {
    const lat = e?.location?.raw?.lat;
    const lon = e?.location?.raw?.lon;
    if (typeof lat !== 'number' || typeof lon !== 'number') {
      return;
    }
    this.zoomLevel = 7;
    this.removeISLayers();
    this.map.flyTo([lat, lon], this.zoomLevel);
    if (keepSearchedDms) {
      const normalizedLng = this.normalizeLng(lon);
      this.searchedCoordinate = { lat, lng: normalizedLng };
      this.isCoordinateSearchActive = true;
      this.latLngDMS = this.decimalToDMS(lat, normalizedLng);
      return;
    }
    this.isCoordinateSearchActive = false;
    this.searchedCoordinate = null;
  }

  initHoverOnSearchBox() {
    const searchBtnParentEl = document.querySelector(
      '.leaflet-geosearch-button'
    ) as HTMLElement;
    searchBtnParentEl.addEventListener('mouseenter', (event: any) => {
      if (!searchBtnParentEl.classList.contains('active')) {
        this.showAndHideSearchInput(true);
      }
    });
  }

  showAndHideSearchInput(show: boolean): void {
    const searchBtnParentEl = document.querySelector(
      '.leaflet-geosearch-button'
    ) as HTMLElement;
    if (show) {
      var controlContainer = document.getElementsByClassName(
        'leaflet-control-layers-expanded'
      )[0];
      if (
        controlContainer &&
        controlContainer.classList.contains('leaflet-control-layers-expanded')
      ) {
        controlContainer.classList.remove('leaflet-control-layers-expanded');
        document
          .querySelector('.leaflet-control-layers-toggle')
          ?.setAttribute('style', 'top:0px !important');
      }
      searchBtnParentEl.classList.add('active');
      return;
    }
    const searchInput = document.querySelector(
      '.leaflet-geosearch-button form input'
    ) as HTMLInputElement;
    if (!searchInput.value && !searchInput.classList.contains('active')) {
      searchBtnParentEl.classList.remove('active');
    }
  }

  /* Reset search input field */
  private resetSearchInput(): void {
    const searchFormEL = document.querySelector(
      '.leaflet-geosearch-button form'
    ) as HTMLElement;
    const searchInput = searchFormEL.querySelector('input') as HTMLInputElement;
    if (!searchInput) {
      return;
    }

    searchInput.value = '';
    this.isCoordinateSearchActive = false;
    this.searchedCoordinate = null;
    const resultEl = searchFormEL.querySelector('.results') as HTMLElement;
    if (resultEl) {
      resultEl.innerHTML = '';
      resultEl.classList.remove('active');
    }
    this.showAndHideSearchInput(true);
    searchInput.classList.add('active');
    searchInput.focus();
  }

  setValueAddedOption(
    valAdOption,
    sensor,
    event,
    collectionIndex,
    sensorIndex,
    valAdOptionIndex
  ) {
    sensor.valueAddedOption ??= [];

    sensor.valueAddedOption[valAdOptionIndex] ??= {
      checked: false,
    };
    this.collections[collectionIndex].sensors[sensorIndex].valueAddedOption.map(
      (valueAddedOption) => {
        valueAddedOption.checked = false;
      }
    );
    sensor.valueAddedOption[valAdOptionIndex].checked = event.checked;
    if (this.imageType !== 'tif') {
      this.handleOptionError(
        event,
        `Value-added data products can only be downloaded now and cannot be visualised on the map here.`
      );
    } else {
      if (event.checked) {
        this.clearVdapImageLayer();
        this.isVadapSelected = true;
        this.isScenSelected = false;
        const scen =
          sensor.scenes.find((scene) => scene.id === this.sceneSelected) ??
          sensor.scenes[0];
        this.selectvdap = valAdOption.product;
        const sensorObj = {
          customerid: this.currentUser?.id,
          sensorId: sensor.id,
          product: valAdOption.product,
          taskId: this.collection.taskId,
        };
        this.tifPopupShown = 0;
        this.fetchImageFromServer(this.collection, sensorObj, scen, true);
      } else {
        this.isVadapSelected = false;
        this.clearVdapImageLayer();
      }
    }
  }

  clearVdapImageLayer() {
    this.scenesNew.forEach((sceneItem) => {
      if (sceneItem?.leftImageLayer && sceneItem?.pane == 'left') {
        this.map.removeLayer(sceneItem?.leftImageLayer);
      }
      if (sceneItem?.rightImageLayer && sceneItem?.pane == 'right') {
        this.map.removeLayer(sceneItem?.rightImageLayer);
      }
    });
  }

  handleOptionError(event, message) {
    event.source.checked = false;
    this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
    this.spinnerService.hide();
  }

  isValueAddedOptionChecked(sensor, option) {
    if (this.selectedSensors.length !== 1) {
      return false;
    }
    return this.isSensorInList(sensor.id) && this.isOptionInList(option);
  }

  isOptionInList(option: string): boolean {
    return this.selectedOptions.some((item) => item === option);
  }

  isSensorInList(sensorId: number): boolean {
    return this.sensorsNew.some((sensor) => sensor.id === sensorId);
  }

  selectColorisation(sensor, colorisation, event) {
    toggleColorisationLayer(this, sensor, colorisation, event.checked);
  }

  shouldDisableColorisation(sensor, colorisation) {
    return isColorisationDisabled(this, sensor, colorisation);
  }

  showColorisationLegend(show: boolean) {
    if (show) {
      this.addColorLegend('COLORISATION');
      this.colorisationLegendControl = this.colorLegendControl;
      return;
    }
    // Only drop the legend while it is still the colorisation one (indices share colorLegendControl)
    if (this.colorLegendControl && this.colorLegendControl === this.colorisationLegendControl) {
      this.map.removeControl(this.colorLegendControl);
      this.colorLegendControl = null;
    }
    this.colorisationLegendControl = null;
  }

  shouldDisableValueAddedOption(sensor, type) {
    if (!this.isSensorInList(sensor.id)) {
      this.clearVdapImageLayer();
      return true;
    }
    if (this.sensorsNew.length > 0) {
      if (this.sensorsNew.length > 1) return true;
      if (this.sensorsNew.length === 1) {
        if (
          sensor.scenes.filter((scene) => scene.checked === true).length === 0
        ) {
          this.clearVdapImageLayer();
          return true;
        }
        if (
          sensor.scenes.filter((scene) => scene.checked === true).length >= 1 &&
          sensor.scenes.length === 1
        ) {
          this.clearVdapImageLayer();
        } else {
          return false;
        }
      }
    }
    this.clearVdapImageLayer();
    return true;
  }

  shouldDisableSuperResolution(
    collectionIndex,
    sensorIndex,
    scene: any,
    superResolution
  ) {
    return false;
  }

  shouldcheckValueAddedOptionEnabled(sensor, valAdOption, valAdOptionIndex) {
    const isScenchecked = sensor.scenes.filter(
      (scene) => scene.checked === true
    );
    if (
      sensor.valueAddedOption[valAdOptionIndex].checked &&
      isScenchecked.length > 0
    ) {
      sensor.valueAddedOption[valAdOptionIndex].checked = true;
      return true;
    } else {
      sensor.valueAddedOption[valAdOptionIndex].checked = false;
      return false;
    }
  }

  isDownloadedSR(superResolution, sensor, scene) {
    let currentScene = sensor.scenes.filter((scene) => scene.checked === true);
    if (currentScene.length > 1) return false;
    return superResolution.products.some((element) => {
      return element.sceneId === currentScene[0]?.id && element.isDownloaded;
    });
  }

  async downloadSR(superResolution, collectionIndex, sensor, sensorIndex) {
    const currentScene = sensor.scenes.find((scene) => scene.checked === true);
    let isDownloaded = superResolution.products.some((element) => {
      return element.sceneId === currentScene.id && element.isDownloaded;
    });
    if (this.freeze) {
      const message =
        'A download is in progress. Please wait until the current download finishes to continue downloading others.';
      this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
      return;
    } else if (isDownloaded) {
      const message = 'download_vadp';
      this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
      return;
    } else {
      this.spinnerService.show();
      this.freeze = true;
      this.fail = 0;
      this.progress = 0;
      this.downloadClick = true;
      this.currentDownloadingSR = {
        collectionIndex: collectionIndex,
        sensorIndex: sensorIndex,
        sceneId: currentScene.id,
        product: superResolution.product,
      };

      let sensorObj = {
        taskId: this.taskid,
        sensorId: superResolution.sensorId,
        sceneId: currentScene.id,
        product: superResolution.product,
        type: 'download',
      };

      this.apiService
        .getValueAddedDataImgUrl(sensorObj)
        .subscribe(async (res: any) => {
          let url = res.response.imageUrl;

          if (url) {
            const fileName = this.getFileNameFromS3SignedUrl(url);
            const downloadTarget = await this.resolveDownloadTarget(fileName);
            if (!downloadTarget) {
              this.resetDownload();
              return;
            }

            const xhr = new XMLHttpRequest();
            xhr.open('GET', url);
            xhr.responseType = 'blob';

            xhr.onprogress = (event) => {
              if (event.lengthComputable) {
                const percentComplete = (event.loaded / event.total) * 100;
                this.progress = percentComplete.toFixed(2);
                const sensorObj = {
                  progress: this.progress,
                  taskId: this.collections[collectionIndex].taskId,
                  sensorId: sensor.id,
                  sceneId: currentScene.id,
                  download: this.downloadClick,
                  product: superResolution.product,
                };
                this.downloadService.setProgress(sensorObj);
              }
            };

            xhr.onload = () => {
              if (xhr.status === 200) {
                const blob = xhr.response;
                this.downloadService.saveBlob(blob, fileName, downloadTarget).then((saveResult) => {
                  if (saveResult.status === 'cancelled') {
                    this.resetDownload();
                    return;
                  }

                  if (saveResult.status !== 'saved') {
                    this.popupService.openPopup(
                      CollectionPopupComponent,
                      saveResult.message,
                      '',
                      '40%'
                    );
                    this.resetDownload();
                    return;
                  }

                  this.progress = 0;
                  this.spinnerService.hide();
                  this.freeze = false;
                  this.disable = false;
                });
              } else {
                this.showDownloadError();
              }
            };

            xhr.onerror = () => {
              // Handle errors
              this.showDownloadError();
            };
            xhr.send();
          }
        });
    }
  }

  downloadedWarning() {
    const message = 'download_vadp';
    this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
  }

  async downloadValueAddedData(valAdOption, collectionIndex, sensor, sensorIndex) {
    if (this.freeze) {
      const message =
        'A download is in progress. Please wait until the current download finishes to continue downloading others.';
      this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
      return;
    } else if (valAdOption?.isDownloaded) {
      const message = 'download_vadp';
      this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
      return;
    } else {
      this.currentDownloadingVADP = {
        collectionIndex: collectionIndex,
        sensorIndex: sensorIndex,
        product: valAdOption.product,
      };
      this.spinnerService.show();
      this.freeze = true;
      this.fail = 0;
      this.progress = 0;
      this.downloadClick = true;
      let sensorObj = {
        product: valAdOption.product,
        id: valAdOption.product_id,
      };
      this.apiService
        .getValueAddedData(sensorObj)
        .subscribe(async (res: any) => {
          let url = res.response.imageUrl;
          if (url) {
            const fileName = this.getFileNameFromS3SignedUrl(url);
            const downloadTarget = await this.resolveDownloadTarget(fileName);
            if (!downloadTarget) {
              this.resetDownload();
              return;
            }

            const xhr = new XMLHttpRequest();
            xhr.open('GET', url);
            xhr.responseType = 'blob';
            xhr.onprogress = (event) => {
              if (event.lengthComputable) {
                const percentComplete = (event.loaded / event.total) * 100;
                this.progress = percentComplete.toFixed(2);
                const sensorObj = {
                  progress: this.progress,
                  taskId: this.collections[collectionIndex].taskId,
                  sensorId: sensor.id,
                  download: this.downloadClick,
                  product: valAdOption.product,
                };
                this.downloadService.setProgress(sensorObj);
              }
            };
            xhr.onload = () => {
              if (xhr.status === 200) {
                const blob = xhr.response;
                this.downloadService.saveBlob(blob, fileName, downloadTarget).then((saveResult) => {
                  if (saveResult.status === 'cancelled') {
                    this.resetDownload();
                    return;
                  }

                  if (saveResult.status !== 'saved') {
                    this.popupService.openPopup(
                      CollectionPopupComponent,
                      saveResult.message,
                      '',
                      '40%'
                    );
                    this.resetDownload();
                    return;
                  }

                  this.progress = 0;
                  valAdOption.isDownloaded = true;
                  this.spinnerService.hide();
                  this.freeze = false;
                  this.disable = false;
                });
              }
            };
            xhr.send();
          }
        });
    }
  }

  refundValueAddedData(collectionIndex, sensorIndex, valAdOption) {
    this.OpenReturnRequestVADP(
      collectionIndex,
      sensorIndex,
      null,
      null,
      valAdOption.product,
      valAdOption
    );
  }

  refundValueAddedStatus(valAdOption: any) {
    if (
      valAdOption?.refundRequest &&
      (valAdOption?.returnRefundAccept || valAdOption?.returnRefundReject)
    ) {
      let message = 'return-refund-accepted';
      if (valAdOption?.returnRefundReject) {
        message = 'return-refund-rejected';
      }
      this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
      return;
    }
  }

  shouldDisableIndices(collectionIndex, sensorIndex, scene, indices): boolean {
    const sensor = this.collections?.[collectionIndex]?.sensors?.[sensorIndex];
    if (!sensor?.scenes) {
      return true;
    }

    const selectedScenes = sensor.scenes.filter((s) => s.checked);

    if (
      selectedScenes.length !== 1 &&
      sensor.operatorKey !== OPERATORS.AXELSPACE
    ) {
      return true;
    }

    const hasValidScene = selectedScenes.some((selected) =>
      indices.products.some(
        (product) =>
          product.sceneId === selected.id && product.status === 'success'
      )
    );

    return !hasValidScene;
  }

  isDownloadedIndices(indices, sensor, scene) {
    let currentScene = sensor.scenes.filter((scene) => scene.checked === true);
    if (currentScene.length > 1) return false;
    return indices.products.some((element) => {
      return element.sceneId === currentScene[0]?.id && element.isDownloaded;
    });
  }

  OpenReturnRequestVADP(
    i: any,
    j: any,
    k: any,
    scene: any,
    product: string = '',
    vadpData: any
  ) {
    const sensor = this.collections[i].sensors[j];
    const taskId = this.collections[i]?.taskId;
    let sceneId: any = scene?.id;
    let sensorId: any = sensor?.id;

    let sensorObj = {
      taskId,
      sensorId,
      sceneId,
      product,
    };

    this.apiService.returnRefundStatus(sensorObj).subscribe((res: any) => {
      if (this.isPartialDelivery(res)) {
        return;
      }
      if (res?.status === 'found') {
        let message = 'return-refund-accepted';
        if (res?.returnRefundReject) {
          message = 'return-refund-rejected';
        }

        if (res?.returnRefundReject || res?.returnRefundAccept) {
          this.popupService.openPopup(
            CollectionPopupComponent,
            message,
            '',
            '40%'
          );
          return;
        } else {
          this.handleRefundRequestVADP(
            scene,
            taskId,
            sensorId,
            sceneId,
            product,
            vadpData
          );
        }
      } else {
        const message = 'return-refund-vadp';
        this.popupService.openPopup(
          CollectionPopupComponent,
          message,
          '',
          '40%'
        );
        return;
      }
    });
  }

  handleRefundRequestVADP(
    scene: any,
    taskId: any,
    sensorId: any,
    sceneId: any,
    product: any = '',
    vadpData: any
  ) {
    const dialog = this.matdialog.open(ReturnRefundComponent, {
      minWidth: '50%',
      data: {
        type: 'return',
        taskId: taskId,
        sensorId: sensorId,
        sceneId: sceneId,
        product: product,
      },
      backdropClass: 'blurred',
      disableClose: true,
    });

    dialog.afterClosed().subscribe((result) => {
      if (result != 'close') {
        const message = 'return-refund-success';
        this.popupService.openPopup(
          CollectionPopupComponent,
          message,
          '',
          '40%'
        );
        this.refundRequestVADP.push({
          sensorId: sensorId,
          product: vadpData?.product,
        });
        this.valueAddedProductLocalUpdate(sensorId, vadpData?.product);
      }
    });
  }

  valueAddedProductLocalUpdate(sensorId: any, product: any) {
    (this.collections || []).forEach((item) => {
      (item.sensors || []).forEach((sensor) => {
        if (sensor.id === sensorId) {
          (sensor.valueAddedOption || []).forEach((element) => {
            if (element.product === product) {
              element.refundRequest = true;
            }
          });
        }
      });
    });
  }

  isEnableSR(superResolution, sensor, scene) {
    let currentScene = sensor.scenes.filter((scene) => scene.checked === true);
    if (currentScene.length > 1) return false;
    return superResolution.products.some((element) => {
      return element.sceneId === currentScene[0]?.id;
    });
  }

  refundStatusCheckSR(superResolution, sensor) {
    let currentScene = this.getCurrentScene(sensor);
    return superResolution.products.some((i) => {
      return (
        i.sceneId === currentScene?.id &&
        (i?.returnRefundAccept || i?.returnRefundReject)
      );
    });
  }

  refundSRStatus(superResolution: any, sensor: any) {
    let currentScene = this.getCurrentScene(sensor);
    let message = '';
    superResolution.products.forEach((i) => {
      if (i.sceneId === currentScene?.id) {
        if (
          i?.refundRequest &&
          (i?.returnRefundAccept || i?.returnRefundReject)
        ) {
          let message = 'return-refund-accepted';
          if (i?.returnRefundReject) {
            message = 'return-refund-rejected';
          }
        }
      }
    });
    if (message) {
      this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
    }
    return;
  }

  OpenReturnRequestSR(collectionIndex, sensorIndex, superResolution) {
    const sensor = this.collections[collectionIndex].sensors[sensorIndex];
    const taskId = this.collections[collectionIndex]?.taskId;
    let currentScene = this.getCurrentScene(sensor);
    let sceneId: any = currentScene?.id;
    let sensorId: any = sensor?.id;
    let product = superResolution.product;
    let sensorObj = {
      taskId,
      sensorId,
      sceneId,
      product,
    };
    this.apiService.returnRefundStatus(sensorObj).subscribe((res: any) => {
      if (this.isPartialDelivery(res)) {
        return;
      }
      if (res?.status === 'found') {
        let message = 'return-refund-accepted';
        if (res?.returnRefundReject) {
          message = 'return-refund-rejected';
        }
        if (res?.returnRefundReject || res?.returnRefundAccept) {
          this.popupService.openPopup(
            CollectionPopupComponent,
            message,
            '',
            '40%'
          );
          return;
        } else {
          this.handleRefundRequestSR(
            currentScene,
            taskId,
            sensorId,
            sceneId,
            product,
            superResolution
          );
        }
      } else {
        const message = 'return-refund-vadp';
        this.popupService.openPopup(
          CollectionPopupComponent,
          message,
          '',
          '40%'
        );
      }
    });
  }

  handleRefundRequestSR(
    scene,
    taskId,
    sensorId,
    sceneId,
    product,
    superResolution
  ) {
    const dialog = this.matdialog.open(ReturnRefundComponent, {
      minWidth: '50%',
      data: {
        type: 'return',
        taskId: taskId,
        sensorId: sensorId,
        sceneId: sceneId,
        product: product,
        action: 'vadp',
      },
      backdropClass: 'blurred',
      disableClose: true,
    });
    dialog.afterClosed().subscribe((result) => {
      if (result != 'close') {
        const message = 'return-refund-success';
        this.popupService.openPopup(
          CollectionPopupComponent,
          message,
          '',
          '40%'
        );
        this.refundRequestSR.push({
          sensorId: sensorId,
          sceneId: sceneId,
          product: superResolution?.product,
        });
        this.valueAddedProductLocalUpdateSR(
          sensorId,
          sceneId,
          superResolution?.product
        );
      }
    });
  }

  valueAddedProductLocalUpdateSR(sensorId: any, sceneId: any, product: any) {
    (this.collections || []).forEach((item) => {
      (item.sensors || []).forEach((sensor) => {
        if (sensor.id === sensorId) {
          (sensor.superResolutions || []).forEach((element) => {
            if (element.product === product) {
              (element.products || []).forEach((row) => {
                if (row.sceneId === sceneId) {
                  row.refundRequest = true;
                }
              });
            }
          });
        }
      });
    });
  }

  getCurrentScene(sensor) {
    let currentScene;
    currentScene = sensor.scenes.find((scene) => scene.checked === true);
    return currentScene;
  }

  private getCheckedSceneIds(sensor: any): string[] {
    const checkedSceneIds = (sensor?.scenes || [])
      .filter((scene: any) => scene?.checked && scene?.id)
      .map((scene: any) => scene.id);

    if (checkedSceneIds.length > 0) {
      return checkedSceneIds;
    }

    if (this.selectedSceneNew?.id) {
      return [this.selectedSceneNew.id];
    }

    return [];
  }

  selectIndices(
    collectionIndex,
    sensorIndex,
    indicesIndex,
    event,
    indices,
    isSelected
  ) {
    if (event.checked) {
      if (isSelected) {
        this.indiceType = 'display';
        this.collections[collectionIndex].sensors[
          sensorIndex
        ].indicesDetails.map((indicesDetails) => {
          indicesDetails.checked = false;
          indicesDetails.loadTif = false;
        });
      }
      this.removeAnnotationMarkers();
      this.removeIndices();
      this.newTaskButtonClicked = false;
      this.annotateClicked = false;
      this.collections[collectionIndex].sensors[sensorIndex].indicesDetails.map(
        (indicesDetails) => {
          indicesDetails.checked = false;
        }
      );
      this.collections[collectionIndex].sensors[sensorIndex].indicesDetails[
        indicesIndex
      ].checked = true;
      this.mapLoad = true;
      const imageLoadPromises: Promise<any>[] = [];
      if (this.imageType === 'png') {
        this.displayIndices(
          indices,
          this.collections[collectionIndex].sensors[sensorIndex],
          event,
          collectionIndex,
          sensorIndex,
          imageLoadPromises
        );
      } else if (this.imageType === 'tif') {
        this.loadIndicesOnTiff(
          collectionIndex,
          sensorIndex,
          indicesIndex,
          event,
          indices
        );
      }
    } else {
      let selectedSceneIndex = this.collection.sensors[
        sensorIndex
      ].scenes.findIndex((scene) => scene.checked == true);
      this.collections[collectionIndex].sensors[
        sensorIndex
      ].indicesDetails.forEach((indicesDetails) => {
        indicesDetails.checked = false;
      });
      this.removeIndices();
    }
  }

  async loadIndicesOnTiff(
    collectionIndex,
    sensorIndex,
    indicesIndex,
    event,
    indices
  ) {
    if (!this.map) return;
    const loadKey = `indices::${indices?.product}`;
    const cancel$ = this.beginTiffWfsLoad(loadKey);
    const createdLayers: L.GeoJSON[] = [];
    const paneName = 'indicesPane';

    if (!this.map.getPane(paneName)) {
      const pane = this.map.createPane(paneName);
      pane.style.zIndex = '650';
    }

    this.ensureTooltipPane();

    const sensor = this.collections?.[collectionIndex]?.sensors?.[sensorIndex];
    const sceneIds = this.getCheckedSceneIds(sensor);
    const taskId =
      this.collections?.[collectionIndex]?.taskId ??
      this.collection?.taskId ??
      this.taskid;

    this.spinnerService.show();
    try {
      if (!sensor?.id || !taskId || sceneIds.length === 0) {
        return;
      }

      const payload = {
        sensorId: indices?.sensorId ?? sensor.id,
        sceneIds,
        product: String(indices?.product ?? '').toLowerCase(),
        taskId,
        userId: this.currentUser?.id,
      };

      const geoCollectionResponse: any = await firstValueFrom(
        this.apiService.getIndicesFromGeoCollection(payload).pipe(takeUntil(cancel$))
      );
      const result =
        geoCollectionResponse?.result ??
        geoCollectionResponse?.responseResult ??
        geoCollectionResponse;

      if (cancel$.isStopped) return;
      this.responseResult = result;
      if (!result?.layer?.product?.length) {
        return;
      }

      const shapeList = result.layer.product.filter(
        (p) => p.product_type?.toLowerCase() === indices.product?.toLowerCase()
      );
      if (!shapeList.length) {
        return;
      }

      const selectedIndexProducts = (indices?.products || []).filter(
        (product: any) => sceneIds.includes(product?.sceneId)
      );

      const categoryMap = {
        CWSI: cwsiCategories,
        MBSI: mbsiCategories,
        NCCI: ncciCategories,
        OSI: osiCategories,
        NDTI: ndtiCategories,
        NDMI: ndmiCategories,
        NDRE: ndreCategories,
        NDVI: ndviCategories,
        TVDI: tvdiCategories,
      };

      const loadedLayers = (
        await Promise.all(
          shapeList.map(async (matchedShape, shapeIndex) => {
            const matchedIndexProduct =
              selectedIndexProducts.find(
                (product: any) => product?.sceneId === matchedShape?.sceneId
              ) ??
              selectedIndexProducts[0] ??
              indices?.products?.[0];
            const layerName = matchedShape.layerName ?? matchedShape.layername;
            if (!layerName) {
              return null;
            }

            const geojson = await this.loadViewportGeojson(
              layerName, matchedShape.cql ?? '', undefined, cancel$, 'immediate'
            );
            if (cancel$.isStopped) return null;

            const feedResults =
              matchedIndexProduct?.feed_results ??
              geojson?.feed_results ??
              matchedShape?.feed_results;
            const hasFeedResults =
              !!feedResults && Object.keys(feedResults).length > 0;

            const layer = L.geoJSON(geojson, {
              pane: 'indicesPane',
              style: (feature) => {
                const value = feature?.properties?.value ?? 0;
                return {
                  fillColor: getIndicesColor(value, indices.product),
                  color: '#000',
                  weight: 1,
                  fillOpacity: 0.95,
                };
              },
              onEachFeature: (feature, layer) => {
                const classValue = feature?.properties?.value;
                if (classValue == null || !hasFeedResults) {
                  return;
                }

                const areaPercent = feedResults?.[String(classValue)];
                if (areaPercent == null) {
                  return;
                }
                const classLabel = (categoryMap[indices?.product] || []).find(
                  (item: any) => item.value === Number(classValue)
                )?.label ?? `Class ${classValue}`;

                layer.bindTooltip(`${classLabel}: ${areaPercent}%`, {
                  sticky: true,
                  direction: 'top',
                  className: 'indices-tooltip',
                  pane: 'eeTooltipPane',
                  offset: L.point(0, -12),
                });
                layer.on('mousedown', (e: L.LeafletMouseEvent) => {
                  L.DomEvent.preventDefault(e.originalEvent);
                });
              },
            }).addTo(this.map);

            layer.bringToFront();
            createdLayers.push(layer);
            this.indicesLayers.push(layer);
            this.registerIndicesViewportGeojsonSession(
              indices,
              matchedShape,
              layerName,
              shapeIndex,
              layer
            );
            return layer;
          })
        )
      ).filter((layer): layer is L.GeoJSON => !!layer);

      if (cancel$.isStopped) return;
      if (!loadedLayers.length) {
        this.addColorLegend(
          indices.product,
          selectedIndexProducts[0]?.message ?? indices?.products?.[0]?.message
        );
        return;
      }

      this.indicesLayer = loadedLayers[loadedLayers.length - 1];
      this.addColorLegend(
        indices.product,
        selectedIndexProducts[0]?.message ?? indices?.products?.[0]?.message
      );

    } catch (error) {
      if (!cancel$.isStopped && (error as any)?.name !== 'EmptyError') {
        cancel$.next();
        cancel$.complete();
        this.notifyViewportGeojsonLoadError(error);
      }
      // Roll back this initial group only; other active index layers keep their sessions.
      for (const [key, layer] of this.indicesViewportLayers) {
        if (!createdLayers.includes(layer)) continue;
        this.viewportGeojson.endSession(key);
        this.viewportGeojsonRender.delete(key);
        this.indicesViewportLayers.delete(key);
      }
      createdLayers.forEach((layer) => this.map.removeLayer(layer));
      this.indicesLayers = this.indicesLayers.filter((layer) => !createdLayers.includes(layer));
    } finally {
      this.finishTiffWfsLoad(loadKey, cancel$);
      this.spinnerService.hide();
      this.mapLoad = false;
    }
  }

  private registerIndicesViewportGeojsonSession(
    indices: any,
    matchedShape: any,
    layerName: string,
    shapeIndex: number,
    layer: L.GeoJSON
  ): void {
    if (!layerName || !this.map) {
      return;
    }

    const storageKey = [
      'indices',
      String(indices?.product ?? 'unknown'),
      String(matchedShape?.sceneId ?? shapeIndex),
      layerName,
    ].join('::');

    this.indicesViewportLayers.set(storageKey, layer);
    this.viewportGeojsonRender.set(storageKey, {
      geoKey: storageKey,
      layer,
    });
    this.viewportGeojson.startSession({
      storageKey,
      layerName,
      baseCql: matchedShape.cql || null,
      renderMode: 'immediate',
    });
  }

  selectSuperResolution(
    collectionIndex: number,
    sensorIndex: number,
    superResolutionIndex: number,
    event,
    superResolution: any
  ) {
    if (event.checked) {
      this.newTaskButtonClicked = false;
      this.annotateClicked = false;
      this.removeAnnotationMarkers();
      this.displaySuperResolutions(
        superResolution,
        this.collections[collectionIndex].sensors[sensorIndex],
        event,
        collectionIndex,
        sensorIndex
      );
    } else {
      let selectedSceneIndex = this.collection.sensors[
        sensorIndex
      ].scenes.findIndex((scene) => scene.checked == true);
      this.collections[collectionIndex].sensors[
        sensorIndex
      ].superResolutions.forEach((superResolutions) => {
        superResolutions.checked = false;
      });
      this.removeSuperResolutions();
    }
  }

  toggleIndicesImageType(
    collectionIndex: any,
    sensorIndex: any,
    indicesIndex: any,
    event: any,
    indices: any
  ) {
    if (event.checked) {
      this.indiceType = 'tiff';
    } else {
      this.indiceType = 'display';
    }
    indices.loadTif = event.checked;
    this.removeIndices();
    event.checked = true;
    this.selectIndices(
      collectionIndex,
      sensorIndex,
      indicesIndex,
      event,
      indices,
      false
    );
  }

  displayIndices(
    indices,
    sensor,
    event,
    collectionIndex,
    sensorIndex,
    imageLoadPromises
  ) {
    let selectedSceneId = sensor.scenes[this.selectedSceneIndex].id;
    let selectedScene = this.scenesNew.find(
      (sceneNew) => sceneNew.id == selectedSceneId
    );
    let selectedSceneIndex = this.scenesNew.find(
      (sceneNew) => sceneNew.id == selectedSceneId
    );
    indices.checked = true;
    let sensorObj
    if(sensor.operatorKey === OPERATORS.AXELSPACE) {
      const checkedSceneIds = sensor.scenes
      .filter(scene => scene.checked)
      .map(scene => scene.scene_id);
      sensorObj = {
      taskId: this.taskid,
      sensorId: indices.sensorId,
      sceneId: checkedSceneIds,
      product: indices.product,
      type: this.indiceType,
      };
    } else {
      sensorObj = {
      taskId: this.taskid,
      sensorId: indices.sensorId,
      sceneId: selectedScene.id,
      product: indices.product,
      type: this.indiceType,
      };
    }
    let ndviObj = JSON.parse(
      JSON.stringify(
        this.collections[collectionIndex].sensors[sensorIndex].indicesDetails
      )
    ).find((item: any) => item.product === 'NDVI');
    if (ndviObj) {
      let ndviScene = ndviObj.products.find(
        (scene: any) => scene.sceneId === selectedScene.id
      );
    }
    let footprintcordinates: any[] = [];
    footprintcordinates = selectedScene?.scene?.footprint?.coordinates[0].map(
      (sub) => {
        return [sub[1], sub[0]];
      }
    );
    this.spinnerService.show();
    this.apiService.getIndicesDataImgUrl(sensorObj).subscribe(
      async (res: any) => {
        let feedDatas = res?.response?.signedUrls;
        this.fetchAndCombineIndesisGeoJson(feedDatas, indices);
      },
      (err) => {
        this.spinnerService.hide();
        this.mapLoad = false;
      }
    );
  }

  displaySuperResolutions(
    superResolution,
    sensor,
    event,
    collectionIndex,
    sensorIndex
  ) {
    let selectedSceneId = sensor.scenes[this.selectedSceneIndex].id;
    let selectedScene = this.scenesNew.find(
      (sceneNew) => sceneNew.id == selectedSceneId
    );
    let selectedSceneIndex = this.scenesNew.find(
      (sceneNew) => sceneNew.id == selectedSceneId
    );
    superResolution.checked = true;
    let sensorObj = {
      taskId: this.taskid,
      sensorId: superResolution.sensorId,
      sceneId: this.selectedSceneNew.id,
      product: superResolution.product,
      type: 'display',
    };
    let footprintcordinates: any[] = [];
    footprintcordinates = this.selectedSceneNew?.footprint?.coordinates[0].map(
      (sub) => {
        return [sub[1], sub[0]];
      }
    );
    this.apiService
      .getValueAddedDataImgUrl(sensorObj)
      .subscribe(async (res: any) => {
        this.superResolutionLayer = L.imageOverlay(
          res.response.imageUrl,
          footprintcordinates,
          { pane: this.mapPane, crossOrigin: true }
        ).addTo(this.map);
        this.spinnerService.hide();
        this.mapLoad = false;
      });
  }

  resetAllFeedPanels(): void {
    this.unregisterPredictionTimeseries(false);
    this.resetPredictionDriftPanel();
    for (const layer of Object.values(this.feedLayers)) {
      try {
        this.removeVesselLabelLayer(layer);
        this.map.removeLayer(layer);
      } catch (e) {
      }
    }
    Object.values(this.currentFilteredLayers || {}).forEach((layer) => {
        if (this.map.hasLayer(layer)) {
          this.removeVesselLabelLayer(layer);
          this.map.removeLayer(layer);
        }
      });
      this.currentFilteredLayers = {};

    this.feedLayers = {};
    this.cancelAllPngGeoJsonLoads();
    this.viewportGeojson.endAll();
    this.legendController?.clear();
    this.cancelViewportGeojsonLoads();
    this.viewportGeojsonRender.clear();
    this.viewportGeojsonLoadErrorShown = false;
    this.feedPanels.clear();
    this.clearComparisonFeedPanels();
    this.feedSections = [];
    this.feedLoaded = false;
    this.combinedFeedSections = [];
    this.feedInfo = false;
    this.activeFeedKeys.clear();
    // Sync feed checkbox state with cleared panel
    this.collection?.sensors?.forEach((sensor: any) => {
      this.getCombinedFeedsForSensor(sensor).forEach((feed: any) => {
        feed.checked = false;
      });
    });
    try {
      this.map.invalidateSize();
    } catch (e) {
    }
  }

  downloadIndices(indices, collectionIndex, sensor, sensorIndex) {
    this.currentDownloadingIndices = {
      collectionIndex: collectionIndex,
      sensorIndex: sensorIndex,
      product: indices.product,
    };
    this.downloadIndicesService.downloadIndices(
      indices,
      collectionIndex,
      sensor,
      sensorIndex,
      this.taskid
    );
  }

  setDownloadedIndices() {
    const { product } = this.currentDownloadingIndices;
    if (!product) return;
    this.collections.forEach((collection) => {
      collection.sensors.forEach((sensor) => {
        const matchedRow = sensor.indicesDetails.find(
          (row) => row.product === product
        );

        if (matchedRow) {
          (matchedRow.products || []).forEach((item) => {
            item.isDownloaded = true;
          });
        }
      });
    });

    this.currentDownloadingIndices = {};
  }

  //----------------------------------------
  getLegend(operator: any, type: any) {
    this.selectedOperator = operator;
    if (operator === OPERATORS.SPIRE) {
      this.shipTypes = this.utilsService.getShips();
      if (type === 0) this.refreshData = false;
      else this.refreshData = true;
      this.shipTypes = this.shipTypes.sort((a, b) => {
        if (a.type === 'OTHER') return 1; // Move "OTHER" to the end
        if (b.type === 'OTHER') return -1;
        return a.type.localeCompare(b.type); // Sort the rest alphabetically
      });
    }
  }
  async displayChangeData(
    event,
    scene,
    sensor,
    action,
    refreshData,
    downloadTarget?: DownloadTarget | null,
    pane?: 'left' | 'right'
  ) {
    if (event?.checked || action === 'download') {
      if (sensor?.operatorKey === OPERATORS.WEATHEREX) {
        // Single-selection: this history row is now the active WeatherEx selection.
        this.resetWeatherExForecastSelection(undefined, refreshData.refreshId);
        await this.displayWeatherExHistoricalData(sensor, refreshData);
      } else {
        await this.displayRecalledSnapshot(
          scene,
          action,
          sensor,
          refreshData,
          downloadTarget
        );
      }
    } else {
      if (sensor?.operatorKey === OPERATORS.WEATHEREX) {
        // Unchecking a WeatherEx history item clears the forecast layer but keeps the target polygon.
        this.weatherEx.clearLayer(true);
      } else {
        this.removeDataSourceById(refreshData.refreshId);
        if (pane === 'left') {
          this.clearComparisonObjectLayer('left');
        }
        if (pane === 'right') {
          this.clearComparisonObjectLayer('right');
        }
        this.filterData = [];
        if (this.isObservation(sensor)) {
          delete this.selectedHistory[refreshData.refreshId];
        }
      }
    }
    if (action === 'display') {
      for (const [index, history] of sensor.refreshHistory.entries()) {
        if (history.refreshId === refreshData.refreshId) {
          history.checked = event.checked;
          break;
        }
      }
    }
  }
  private displayWeatherExHistoricalData(sensor: any, refreshData: any) {
    this.weatherEx.displayHistoricalData(sensor, refreshData);
  }

  private getHistoryComparePane(sensor: any): 'left' | 'right' {
    if (this.leftImageNew && !this.rightImageNew) {
      return 'right';
    }

    if (this.rightImageNew && !this.leftImageNew) {
      return 'left';
    }

    if (this.leftComparisonObjectLayer && !this.rightComparisonObjectLayer) {
      return 'right';
    }

    if (this.rightComparisonObjectLayer && !this.leftComparisonObjectLayer) {
      return 'left';
    }

    if (sensor?.pane === 'left') {
      return 'right';
    }

    if (sensor?.pane === 'right') {
      return 'left';
    }

    return 'left';
  }

  /**
   * Recalls a STORED snapshot — a refresh-history row — and draws or downloads
   * it. Serves every operator except WeatherEx, which `displayChangeData`
   * peels off before reaching here.
   *
   * Only the endpoint differs by operator (Voyage Radar has its own recall;
   * Spire and ClydeSpace share `/tasks/getHistory`); everything downstream is
   * common. Was `displaySpireRefreshData` — see the note on the layer fields
   * for what that name cost.
   */
  async displayRecalledSnapshot(
    scene: any,
    type: any,
    sensor: any,
    refreshData: any,
    downloadTarget?: DownloadTarget | null
  ) {
    let resolvedDownloadTarget: DownloadTarget | null = downloadTarget ?? null;

    let sensorId;
    let taskId;
    let currentCrossImage: any, boundingBox, item;
    sensorId = sensor.id;

    if (sensor.operatorKey === OPERATORS.SPIRE) {
      currentCrossImage = 'assets/images/hot-pink.png';
      item = 'SPIRE';
    } else if (sensor.operatorKey === OPERATORS.VOYAGERADAR) {
      currentCrossImage = 'assets/images/light-blue.png';
      item = 'VOYAGERADAR';
    } else {
      currentCrossImage = 'assets/images/light-blue.png';
      item = 'CLYDE';
    }

    taskId = this.collection?.taskId;
    const aisReq = {
      sensorId: sensorId,
      refreshId: refreshData?.refreshId,
      taskid: taskId,
      action: type,
    };
    if (type !== 'download') {
      this.spinnerService.show();
      this.mapLoad = true;
    }

    // One exit for every way the recall can fail. Previously only one of these
    // was reachable, and it was spelled wrong — see below.
    const failRecall = () => {
      this.popupService.openPopup(
        CollectionPopupComponent,
        'An error occurred during processing and ingestion of the request. Please try after sometime.',
        '',
        '40%'
      );
      this.spinnerService.hide();
      this.mapLoad = false;
      this.freeze = false;
    };

    // Voyage Radar recall has its own endpoint; Spire and ClydeSpace stay on the
    // shared /tasks/getHistory. Both answer the same `{result:{imageUrl}}`
    // envelope, so everything downstream of here is common to all three.
    const recall$ =
      sensor?.operatorKey === OPERATORS.VOYAGERADAR
        ? this.apiService.getVoyageRadarSnapshot({
            taskid: taskId,
            sensorId,
            refreshId: refreshData?.refreshId,
            action: type === 'download' ? 'download' : 'display',
          })
        : this.apiService.getAISRefreshData(aisReq);

    recall$.subscribe({
      next: (res: any) => {
        // The spinner is already up from before the request was issued; showing
        // it again here did nothing.

        // Compared case-insensitively: /tasks/getHistory answers `{msg:"Failed"}`
        // with a capital F, so the old `=== 'failed'` test never matched and a
        // failed recall fell through to the success path below.
        if (`${res?.msg ?? ''}`.toLowerCase() === 'failed') {
          failRecall();
          return;
        }

        // /tasks/getHistory answers 200 with an undefined imageUrl when nothing
        // resolved (unknown sensor, unknown refreshId, missing S3 object). That
        // used to reach `httpClient.get(undefined)`, which requests the current
        // page URL and then fails to parse it as JSON. The Voyage Radar endpoint
        // answers a real 404 instead, which the error handler below catches.
        if (!res?.result?.imageUrl) {
          failRecall();
          return;
        }

        if (type === 'download' && !resolvedDownloadTarget) {
          const fileName = res.result.imageUrl.split('/').pop().split('?')[0];
          this.resolveDownloadTarget(fileName).then((target) => {
            if (!target) {
              this.resetDownload();
              return;
            }

            resolvedDownloadTarget = target;
            this.fetchRecalledSnapshot(
              res,
              scene,
              sensor,
              refreshData,
              type,
              taskId,
              sensorId,
              item,
              currentCrossImage,
              resolvedDownloadTarget
            );
          });
          return;
        }

        this.fetchRecalledSnapshot(
          res,
          scene,
          sensor,
          refreshData,
          type,
          taskId,
          sensorId,
          item,
          currentCrossImage,
          resolvedDownloadTarget
        );
      },
      // Load-bearing for Voyage Radar, whose endpoint reports a bad request or a
      // missing record as a real 4xx rather than a 200 carrying {msg:"Failed"}.
      // Without it the observable would error unhandled and strand the spinner.
      error: () => failRecall(),
    });
  }

  private fetchRecalledSnapshot(
    res: any,
    scene: any,
    sensor: any,
    refreshData: any,
    type: any,
    taskId: any,
    sensorId: any,
    item: any,
    currentCrossImage: any,
    resolvedDownloadTarget: DownloadTarget | null
  ) {
    this.httpClient.get(res?.result?.imageUrl).subscribe(
      (data) => {
        // A response for a snapshot the user has already moved off must not
        // draw. Picking two rows in quick succession leaves both requests in
        // flight, and the slower one would land a second layer on the map —
        // exactly what `clearVoyageSnapshot` exists to prevent. Scoped to
        // Voyage Radar because it is the only operator with a single-selection
        // active id to compare against.
        if (
          sensor?.operatorKey === OPERATORS.VOYAGERADAR &&
          type === 'display' &&
          this.voyageActiveRefreshId !== refreshData?.refreshId
        ) {
          this.spinnerService.hide();
          this.mapLoad = false;
          return;
        }
        // A POI refresh row stores the positionless nearby LIST — reopen it as
        // the target popup instead of feeding it to the GeoJSON path, which
        // would find nothing in it to draw. Download hands back the stored
        // list verbatim.
        if (
          sensor?.operatorKey === OPERATORS.VOYAGERADAR &&
          refreshData?.area?.type === 'Point'
        ) {
          this.spinnerService.hide();
          this.mapLoad = false;
          if (type === 'download') {
            const blob = new Blob([JSON.stringify(data)], { type: 'application/json' });
            const fileName = res?.result?.imageUrl.split('/').pop().split('?')[0];
            this.downloadService
              .saveBlob(blob, fileName, resolvedDownloadTarget!)
              .then((saveResult) => {
                if (saveResult.status !== 'saved') {
                  if (saveResult.status !== 'cancelled') {
                    this.popupService.openPopup(CollectionPopupComponent, saveResult.message, '', '40%');
                  }
                  this.resetDownload();
                  return;
                }
                this.progress = 0;
                this.freeze = false;
                this.disable = false;
              });
            return;
          }
          // `httpClient.get` types the payload as Object; the stored artifact
          // is the list array. showPoiNearby array-guards, so a corrupt
          // artifact degrades to an empty list rather than a crash.
          this.voyage.showPoiNearby(scene, data as any[]);
          return;
        }
        this.filterData.push(refreshData.refreshId);
        this.filterVesselData = true;
        const updatedAis = this.convertToGeoJSONNew(data, item);
        if (this.isObservation(sensor)) {
          this.observationChecked = true;
          this.selectedHistory[refreshData.refreshId] = updatedAis;
        }
        // Add the bounding box as a new feature to the existing GeoJSON FeatureCollection
        let BBpoints: number[] = scene?.footprint?.coordinates[0] || [];
        if (type === 'download') {
          // Check if the bounding-box feature is already added
          const boundingBoxExists = updatedAis.features.some(
            (feature) => feature.id === 'bounding-box'
          );

          if (!boundingBoxExists) {
            updatedAis.features.push({
              type: 'Feature',
              id: 'bounding-box',
              geometry: {
                type: 'Polygon',
                coordinates: [BBpoints],
              },
              properties: {
                ID: 'bounding-box',
                Lng: BBpoints[0]?.[0] || 0,
                Lat: BBpoints[0]?.[1] || 0,
                MMSI: 'N/A',
                'Timestamp UTC': '',
              },
            });
          }
        } else if (type === 'display') {
          updatedAis.features = updatedAis.features.filter(
            (feature) => feature.id !== 'bounding-box'
          );
        }

        if (type === 'display') {
          // OBSERVATIONS MODE draws the snapshot's ANSWER, not the snapshot: the
          // hulls its observations match, and nothing else. Filtered here rather
          // than after the layer is built so no marker is ever created for a
          // vessel that is not being shown, and the unfiltered set is kept so the
          // section can still say how many were searched — see
          // `voyageObservationFeatures`.
          let displayFeatures: any[] = updatedAis.features || [];
          if (
            sensor?.operatorKey === OPERATORS.VOYAGERADAR &&
            this.voyageMapSource === 'observations'
          ) {
            this.voyageObservationSource = displayFeatures;
            displayFeatures = this.voyageObservationMatches(sensor, displayFeatures);
          }
          const geoJsonData = {
            type: 'FeatureCollection',
            features: displayFeatures,
          } as GeoJSON.FeatureCollection;

          this.taskScene = 'history';
          const markersLayer = L.geoJSON(geoJsonData, {
            pointToLayer: (feature, latlng) => {
              return this.displayDirectionInMap(feature, latlng, sensor);
            },
            onEachFeature: (feature, layer) => {
              if (sensor?.operatorKey === OPERATORS.VOYAGERADAR) {
                // Same track-mode entry as the live layer: popup carries the
                // actions, the click selects the vessel.
                layer.bindPopup(
                  () => buildVesselPopup(
                    feature.properties,
                    this.voyage.popupOptsFor(String(feature.properties?.['MMSI'] ?? feature.properties?.mmsi ?? '')),
                  ),
                  {
                    className: 'ais-vessel-popup',
                    closeButton: false,
                    offset: L.point(0, -6),
                    autoPanPadding: L.point(40, 90),
                  }
                );
                layer.on('click', () =>
                  this.voyage.activateVessel(feature.properties, layer)
                );
              } else {
                const tooltipContents = `<div>${this.formatProperties(
                  feature.properties
                )}</div>`;
                this.attachTooltip(layer, tooltipContents);
              }
              (layer as any).type = 'spire';
            },
          }) as CustomGeoJsonLayer;

          markersLayer.refreshId = refreshData.refreshId; // Attach custom refreshId property
          markersLayer.type = 'spire';
          markersLayer.name = 'refreshDataSource';
          markersLayer.addTo(this.map); // Add to map

          // Voyage Radar only: this refresh-history display path renders vessels
          // into `markersLayer` (not aisVesselLayer), so wire it into the
          // on-map toolbar here the same way the sensor-click path does.
          if (sensor?.operatorKey === OPERATORS.VOYAGERADAR) {
            this.voyage.adoptLiveLayer(markersLayer, geoJsonData.features || []);
            // A recalled snapshot shows when it was CAPTURED, not "now".
            this.playback.markUpdated(undefined, refreshData?.name);
          }

          // Voyage Radar frames the tasked TARGET, not the vessels.
          //
          // The vessels of a snapshot sit INSIDE the AOI, so fitting them zooms
          // past the ring — with 50px of padding it lands just outside the
          // viewport and reads as "the bounding box disappeared", which is what
          // it looked like. Every other Voyage Radar path already frames the
          // target (the checkbox, a live pull, a POI recall), so this was also
          // the one place the view jumped somewhere else.
          //
          // The flyTo is skipped for the same reason: it aims at the FIRST
          // vessel in the collection at a fixed zoom 10, which is neither the
          // target nor a considered view.
          const isVoyageRecall = sensor?.operatorKey === OPERATORS.VOYAGERADAR;
          if (isVoyageRecall) {
            // Re-asserted after the vessels land, and lifted above them: the
            // recall is async, so anything that swept the map while it was in
            // flight would otherwise leave the target off until the next click.
            this.voyage.showTarget({ fit: true });
          } else {
            if (geoJsonData.features.length > 0) {
              const firstFeature = geoJsonData.features[0];
              if (firstFeature.geometry.type === 'Point') {
                const [lng, lat] = firstFeature.geometry.coordinates;
                this.map.flyTo([lat, lng], 10);
              }
            }

            // Fit map to markers
            const bounds = markersLayer.getBounds();
            if (bounds.isValid()) {
              this.map.fitBounds(bounds, { padding: [50, 50] });
            }
          }

          // Bounding Box (Rectangle)
          //
          // Voyage Radar draws no box here. This is the shared recall path, so
          // a snapshot click used to add a THIRD drawing of the tasked area —
          // one tagged with the snapshot's refreshId, which is why the outline
          // appeared on a recall and left again with it. VR's target is the
          // controller's, owned by the sensor checkbox and already on the map;
          // Spire and ClydeSpace keep this box exactly as it was.
          if (BBpoints && sensor?.operatorKey !== OPERATORS.VOYAGERADAR) {
            const boundingBox = BBpoints.toString().split(',').map(Number);
            const polylineCoords: [number, number][] = [];

            for (let i = 0; i < boundingBox.length; i += 2) {
              polylineCoords.push([boundingBox[i + 1], boundingBox[i]]); // Leaflet uses [lat, lng]
            }

            // Spire/ClydeSpace behaviour is deliberately left exactly as it was.
            // (Their random string is short — fewer than six hex digits —
            // roughly one time in sixteen, which is not a valid CSS colour, so
            // those boxes occasionally fall back to the renderer's default
            // stroke. Same fix applies whenever that is wanted.)
            const boundingBoxLayer = L.polyline(polylineCoords, {
              color: `#${Math.floor(Math.random() * 16777215).toString(16)}`,
              weight: 3,
              opacity: 1,
            }).addTo(this.map);

            (boundingBoxLayer as any).refreshId = refreshData.refreshId;
          }
          this.spinnerService.hide();
          this.mapLoad = false;
          this.taskScene = null;
        } else if (type === 'download') {
          const sensorObj = {
            progress: 100,
            taskId,
            sensorId: sensorId,
            sceneId: scene.id,
            download: this.downloadClick,
            action: 'aisDownload',
          };
          this.downloadService.setProgress(sensorObj);
          const blob = new Blob([JSON.stringify(updatedAis)], {
            type: 'application/json',
          });
          const fileName = res?.result?.imageUrl
            .split('/')
            .pop()
            .split('?')[0];
          this.downloadService
            .saveBlob(blob, fileName, resolvedDownloadTarget!)
            .then((saveResult) => {
              if (saveResult.status === 'cancelled') {
                this.resetDownload();
                return;
              }

              if (saveResult.status !== 'saved') {
                this.popupService.openPopup(
                  CollectionPopupComponent,
                  saveResult.message,
                  '',
                  '40%'
                );
                this.resetDownload();
                return;
              }

              this.progress = 0;
              this.spinnerService.hide();
              this.freeze = false;
              this.disable = false;
            });
        }
      },
      (error) => {}
    );
  }
  removeDataSourceById(id: any) {
    // A nullish id would match every UNTAGGED layer on the map — `undefined ===
    // undefined` — and sweep off things no refresh ever put there: the Voyage
    // Radar target ring (an L.Polygon, so the Polyline test below catches it),
    // and any Spire/ClydeSpace outline drawn outside a refresh. Callers reach
    // here from `refreshHistory` rows, whose refreshId is not guaranteed, so
    // this is a real path rather than a theoretical one. Removing nothing is
    // the only correct answer to "remove the layers tagged with no id".
    if (id === undefined || id === null) return;

    let layersToRemove: L.Layer[] = [];

    this.map.eachLayer((layer) => {
      if (layer instanceof L.GeoJSON && (layer as any).refreshId === id) {
        layersToRemove.push(layer);
      }

      if (
        (layer instanceof L.Polyline || layer instanceof L.Rectangle) &&
        (layer as any).refreshId === id
      ) {
        layersToRemove.push(layer);
      }
    });
    layersToRemove.forEach((layer) => this.map.removeLayer(layer));
    this.filterVesselData = false;
    // Voyage Radar only: if the removed refresh-history layer was the one
    // feeding the on-map toolbar, dismiss the toolbar (unless playback
    // is active, which owns its own layer).
    if (
      this.voyage.dataActive &&
      this.voyage.liveLayer &&
      this.playback.mode !== 'playback' &&
      !this.map.hasLayer(this.voyage.liveLayer)
    ) {
      this.voyage.releaseLiveLayer();
    }
  }
  displayDirectionInMap(feature: any, latlng: any, sensor: any) {
    const mmsi = feature.properties.MMSI;
    let typeOfShip =
      !feature.properties['Ship Type'] ||
      feature.properties['Ship Type'] === 'N/A'
        ? 'OTHER'
        : feature.properties['Ship Type'];

    if (!mmsi) {
      return L.marker(latlng, {
        // icon: this.createArrowIcon(0, typeOfShip)
      });
    }
    const heading = feature.properties['Course']
      ? parseFloat(feature.properties['Course'])
      : 0;
    const color = feature.properties['Color'];
    const vesselMarker = L.marker(latlng, {
      icon: this.createArrowIcon(heading, typeOfShip, sensor, color),
      /* rotationAngle: heading, */
    } as any);

    return vesselMarker;
  }
  createArrowIcon(heading: number, shipType: string, sensor: any, color?: string) {
    const size = 24;
    const iconUrl = this.getIconUrl(shipType, sensor, color);
    return L.divIcon({
      className: 'vessel-icon',
      html: `
      <span
        class="vessel-icon-img"
        style="
          display:inline-block;
          width:${size}px;height:${size}px;
          background-image:url('${iconUrl}');
          background-size:${size}px ${size}px;
          transform: rotate(${heading}deg);
          transform-origin: 50% 50%;
          cursor: pointer;  
        ">
      </span>`,
      iconSize: [size, size],
      iconAnchor: [size / 2, size / 2],
    });
  }
  getIconUrl(shipType: string, sensor: any, color?: string) {
    // Voyage Radar takes its colour straight from the feed and caches the
    // encoded PNG (playback asks for one per vessel per frame), so it resolves
    // entirely in its own controller. Everything below is Spire/ClydeSpace.
    if (sensor?.operatorKey === OPERATORS.VOYAGERADAR) {
      return this.voyage.vesselIconUrl(this.taskScene === 'history', color);
    }
    let iconColor;
    let iconCanvas;
    if (this.taskScene == 'history') {
      if (sensor.operatorKey === OPERATORS.SPIRE) {
        iconColor = this.utilsService.getHistoricalShipColor(shipType);
      } else {
        iconColor = 'YELLOW';
      }

      iconCanvas = this.createHistoricalNavigationIcon(iconColor);
    } else {
      if (sensor.operatorKey === OPERATORS.SPIRE) {
        iconColor = 'YELLOW';
      } else {
        iconColor = 'ORANGE';
      }
      iconCanvas = this.createNavigationIcon(iconColor);
    }
    return iconCanvas.toDataURL('image/png'); // Convert canvas to base64
  }
  createHistoryNavigationIcon(color: string) {
    let iconCanvas = this.createNavigationIcon(color);
    return iconCanvas.toDataURL('image/png');
  }
  createHistoricalNavigationIcon(color: string): HTMLCanvasElement {
    const canvas = document.createElement('canvas');
    const size = 24; // Material icon default size
    canvas.width = size;
    canvas.height = size;

    const ctx = canvas.getContext('2d');
    if (!ctx) return canvas;

    // Set up the canvas for material icons
    ctx.font = '20px Material Icons';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';

    ctx.lineWidth = 3;
    ctx.strokeStyle = color;
    ctx.strokeText('\ue55d', size / 2, size / 2);

    return canvas;
  }
  createNavigationIcon(color: string): HTMLCanvasElement {
    const canvas = document.createElement('canvas');
    const size = 24; // Material icon default size
    canvas.width = size;
    canvas.height = size;

    const ctx = canvas.getContext('2d');
    if (!ctx) return canvas;

    // Set up the canvas for material icons
    ctx.font = '20px Material Icons';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillStyle = color;

    // Draw the navigation icon (Unicode for Material Icons 'navigation')
    ctx.fillText('\ue55d', size / 2, size / 2);
    return canvas;
  }
  createNavigationIconSpire(
    color: string,
    courseDeg: number,
    history: string
  ): HTMLCanvasElement {
    const canvas = document.createElement('canvas');
    const baseSize = 50;
    const histSize = 24;
    const size = history === 'historySpire' ? histSize : baseSize;
    canvas.width = size;
    canvas.height = size;

    const ctx = canvas.getContext('2d');
    if (!ctx) return canvas;

    ctx.clearRect(0, 0, size, size);
    ctx.save();
    ctx.translate(size / 2, size / 2);
    ctx.rotate((courseDeg * Math.PI) / 180);

    // Set font for Material Icons
    ctx.font = '20px "Material Icons"';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillStyle = color;

    // Draw the Material “navigation” glyph (uE55D)
    ctx.fillText('\ue55d', 0, 0);

    ctx.restore();
    return canvas;
  }

  async AISDownload(sensor: any) {
    let sensorId;
    let taskId;
    let currentCrossImage: any;
    let downloadAction: any;

    sensorId = sensor.id;
    taskId = this.collection?.taskId;
    const aisReq = {
      sensorId: sensorId,
      taskid: taskId,
      action: 'zipDownload',
    };

    if (sensor?.operatorKey === OPERATORS.CLYDE) downloadAction = 'aisDownload';
    else downloadAction = '';

    this.apiService.getAISRefreshData(aisReq).subscribe((res: any) => {
      if (res?.msg === 'failed') {
        const message =
          'An error occurred during processing and ingestion of the request. Please try after sometime.';
        this.popupService.openPopup(
          CollectionPopupComponent,
          message,
          '',
          '40%'
        );
        this.spinnerService.hide();
        this.mapLoad = false;
        this.freeze = false;
      } else {
        let url = res.result?.imageUrl;
        const fileName = this.getFileNameFromS3SignedUrl(url);

        this.resolveDownloadTarget(fileName).then((downloadTarget) => {
          if (!downloadTarget) {
            this.resetDownload();
            return;
          }

          const xhr = new XMLHttpRequest();
          xhr.open('GET', url);
          xhr.responseType = 'blob';

          xhr.onprogress = (event) => {
            if (event.lengthComputable) {
              const percentComplete = (event.loaded / event.total) * 100;
              this.progress = percentComplete.toFixed(2);
              const sensorObj = {
                progress: 100,
                taskId,
                sensorId: sensorId,
                sceneId: sensor.scenes[0].id,
                download: this.downloadClick,
                action: downloadAction,
              };
              this.downloadService.setProgress(sensorObj);
            }
          };

          xhr.onload = () => {
            if (xhr.status === 200) {
              const blob = xhr.response;
              this.downloadService.saveBlob(blob, fileName, downloadTarget).then((saveResult) => {
                if (saveResult.status === 'cancelled') {
                  this.resetDownload();
                  return;
                }

                if (saveResult.status !== 'saved') {
                  this.popupService.openPopup(
                    CollectionPopupComponent,
                    saveResult.message,
                    '',
                    '40%'
                  );
                  this.resetDownload();
                  return;
                }

                this.progress = 0;
                this.spinnerService.hide();
                this.freeze = false;
                this.disable = false;
              });
            }
          };

          xhr.onerror = () => {
            // Handle errors
          };
          xhr.send();
        });
      }
    });
  }

  hasSensorsExist(operatorKey) {
    let checkedSensors: any[] = this.collection?.sensors.filter(
      (sensor) => sensor?.operatorKey === operatorKey
    );
    if(checkedSensors && checkedSensors?.length === 0) {
      return false;
    }
    if (this.subDailyFinalArray.length > 0) {
      let checkedScenes = this.subDailyFinalArray.flatMap((sensor) =>
        sensor.scenes ? sensor.scenes.filter((scene) => scene.checked) : []
      );
      return checkedScenes.length > 0;
    }
    // Get all checked scenes inside the sensors
    else if (checkedSensors?.length > 0) {
      let checkedScenes = checkedSensors.flatMap((sensor) =>
        sensor.scenes ? sensor.scenes.filter((scene) => scene.checked) : []
      );
      return checkedScenes.length > 0;
    }
    return false;
  }

  removeDynamicLayer() {
    this.dynamicLayers.forEach((layer) => {
      this.removeVesselLabelLayer(layer);
      this.map.removeLayer(layer);
    });
    this.dynamicLayers = [];
    this.feedInfo = false;
    this.oilSpil = false;
  }

  shouldShowRawIqRow(scene) {
    return (
      this.currentUser?.raw_iq_approved && scene.operatorKey == OPERATORS.LBAND
    );
  }

  getAvailableSignals(scene: any): string {
    if (scene?.signalOfInterest?.length) {
      return scene.signalOfInterest
        .map((s: any) => s.product)
        .filter((p: string) => !!p) // removes falsy values like undefined/null
        .join(', ');
    }
    return scene?.name || 'N/A';
  }

  getDownloadImage(i: any, j: any, k: any) {
    let sensor = this.collections[i].sensors[j];
    let scene = sensor.scenes[k];
    return scene?.rawIQDownloaded
      ? this.downloadedImage
      : this.checkDownloaded(scene) && scene?.rawIQIncluded
      ? this.downloadImage
      : '../../../assets/images/cloud.png';
  }

  isGrayedOut(scene: any, sensor: any): boolean {
    if (!scene?.id) return true;
    if (scene?.status === 'failed') return true;
    if (sensor?.status === 'archived') return true;
    if (sensor?.status === 'restored' && sensor?.restoreOption === 'view')
      return true;
    return false;
  }
  hasAnnotationFeature(): boolean {
    return this.hasFeature(ANNOTATION);
  }
  
  hasCollectionPointTaskingFeature(): boolean {

    // Plan must include the feature regardless of user type
    if (!this.hasFeature(POINT_TASKING)) {
      return false;
    }

    // Superuser and non-restricted main users always have access
    if (this.currentUser?.userType === 'Super user' || !this.currentUser?.permission_based) {
      return true;
    }

    // Permission-based sub-user: must have BOTH level 5 AND level 6
    return this.currentUser?.permissions?.includes(5) && this.currentUser?.permissions?.includes(6);
  }

  hasPdfReportFeature(): boolean {
    return this.hasFeature(PDF_REPORT);
  }
  
  hasFeature(featureKey: string): boolean {
    return (
      this.currentUser?.planDetails?.features?.some(
        (feature) => feature.key.toLowerCase() === featureKey.toLowerCase()
      ) || false
    );
  }

  filterByDateTime(sensor) {
    const dialogRef = this.matdialog.open(FilterPopupComponent, {
      width: '35%',
      backdropClass: 'blurr',
      disableClose: true,
      data: {
        type: 'refreshDateFilter',
        refreshHistory: sensor.refreshHistory,
        currentUser: this.currentUser,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.applyFilter(result, sensor);
      } else {
      }
    });
  }
  applyFilter(selectedDates, sensor) {
    if (!selectedDates.startDateTime || !selectedDates.endDateTime) {
      return;
    }

    const startTimestamp = selectedDates.startDateTime;
    const endTimestamp = selectedDates.endDateTime;
    const result = this.filterClosestTimestamp(
      sensor.refreshHistory,
      startTimestamp,
      endTimestamp
    );
    if (result) {
      // Voyage Radar no longer arrives here. It browses its snapshots through
      // `openVoyageHistoryBrowser`, which picks a record directly instead of
      // asking for a range and silently collapsing it to whichever snapshot sat
      // nearest the range's END — the behaviour that made this path surprising.
      let currentEvent = {
        checked: true,
      };
      this.displayChangeData(
        currentEvent,
        sensor.scenes[0],
        sensor,
        'display',
        result
      );
    } else {
      const message = `There are no vessels meeting the search criteria.`;
      this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
    }
  }
  resetRefreshData(sensor) {
    // Voyage Radar tracks its single selection outside the row flags — clear it
    // here too so any other caller of this reset leaves consistent state behind.
    if (sensor?.operatorKey === OPERATORS.VOYAGERADAR) {
      this.voyageActiveRefreshId = null;
      this.voyageMapSource = null;
      this.voyageObservationSource = [];
    }
    if (sensor.refreshHistory) {
      for (const [index, history] of sensor.refreshHistory.entries()) {
        history.checked = false;
        this.removeDataSourceById(history.refreshId);
        this.filterData = [];
        // this.removeEntitiesByName(history.refreshId);
        if (this.isObservation(sensor)) {
          delete this.selectedHistory[history.refreshId];
        }
      }
    }
  }
  //  removeEntitiesByName(name) {
  //   let entitiesToRemove: any = [];

  //   this.viewer.entities.values.forEach((entity) => {
  //     if (entity.name === name) {
  //       entitiesToRemove.push(entity);
  //     }
  //   });

  //   entitiesToRemove.forEach((entity) => {
  //     this.viewer.entities.remove(entity);
  //   });
  // }
  filterClosestTimestamp(history: any[], start: string, end: string): any {
    // Convert start and end times to UTC timestamps
    const startTime = new Date(start).getTime();
    const endTime = new Date(end).getTime();

    // Filter timestamps within the range
    const filtered = history
      .map((item) => ({
        ...item,
        timestamp: new Date(item.name).getTime(), // Convert to UTC timestamp
      }))
      .filter(
        (item) => item.timestamp >= startTime && item.timestamp <= endTime
      );

    // Find the closest timestamp to the end time
    if (filtered.length === 0) return null; // No results in the range

    return filtered.reduce((closest, item) =>
      Math.abs(item.timestamp - endTime) < Math.abs(closest.timestamp - endTime)
        ? item
        : closest
    );
  }

  filterHistoricalData(operator) {
    const uniqueFlags = new Set<string>();
    const uniqueDestination = new Set<string>();
    const uniquevesselTypes = new Set<string>();
    const uniqueIMONumbers = new Set<string>();
    const uniqueMMSIList = new Set<string>();
    const uniquevesselNames = new Set<string>();

    // Iterate over all Leaflet layers
    this.map.eachLayer((layer: any) => {
      // Check if layer is a marker/feature with the correct operator type
      if (layer.type === operator.toLowerCase()) {
        // If it's a layer group, iterate through its layers
        if (layer.getLayers) {
          layer.eachLayer((entity: any) => {
            this.collectUniqueValues(
              entity,
              uniqueFlags,
              uniqueDestination,
              uniquevesselTypes,
              uniqueIMONumbers,
              uniqueMMSIList,
              uniquevesselNames
            );
          });
        } else {
          // Single marker/feature
          this.collectUniqueValues(
            layer,
            uniqueFlags,
            uniqueDestination,
            uniquevesselTypes,
            uniqueIMONumbers,
            uniqueMMSIList,
            uniquevesselNames
          );
        }
      }
    });

    // Convert Set to arrays
    const flagArray = Array.from(uniqueFlags);
    const detinationArray = Array.from(uniqueDestination);
    const vesselTypeArray = Array.from(uniquevesselTypes);
    const IMONumbers = Array.from(uniqueIMONumbers);
    const MMSIList = Array.from(uniqueMMSIList);
    const vesselNames = Array.from(uniquevesselNames);

    const dialogRef = this.matdialog.open(FilterPopupComponent, {
      backdropClass: 'blurr',
      disableClose: true,
      data: {
        type: 'aisVessel',
        refreshData: true,
        flagArray: flagArray,
        detinationArray: detinationArray,
        filterObject: this.refreshFilterObject,
        vesselTypeArray: vesselTypeArray,
        IMONumbers,
        MMSIList,
        vesselNames,
        currentUser: this.currentUser,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        let hasVisibleEntities = false;
        let currentVisibleEntities: any[] = [];

        this.refreshFilterObject = result;
        const filters: FilterCriteria = {
          destination: result.destination,
          flag: result.flag,
          length: result.length,
          isGreater: result.isGreater,
          vesselType: result.vesselType,
          vesselSpeed: result.vesselSpeed,
          isSpeedGreater: result.isSpeedGreaterThan,
          vesselName: result.vesselName,
          MMSI: result.MMSI,
          IMO: result.IMO,
        };

        // Iterate over all Leaflet layers and apply filters
        this.map.eachLayer((layer: any) => {
          if (layer.type === operator.toLowerCase()) {
            if (layer.getLayers) {
              layer.eachLayer((entity: any) => {
                const isVisible = this.checkEntityExist(entity, filters);

                if (isVisible) {
                  if (!this.map.hasLayer(entity)) {
                    entity.addTo(this.map);
                  }
                  hasVisibleEntities = true;
                  currentVisibleEntities.push(entity);
                } else {
                  if (this.map.hasLayer(entity)) {
                    this.map.removeLayer(entity);
                  }
                }
              });
            } else {
              const isVisible = this.checkEntityExist(layer, filters);

              if (isVisible) {
                if (!this.map.hasLayer(layer)) {
                  layer.addTo(this.map);
                }
                hasVisibleEntities = true;
                currentVisibleEntities.push(layer);
              } else {
                if (this.map.hasLayer(layer)) {
                  this.map.removeLayer(layer);
                }
              }
            }
          }
        });

        if (hasVisibleEntities) {
          this.lastVisibleEntities = [...currentVisibleEntities];
          this.filterVesselDataValue = true;
        } else {
          const message = `There are no vessels meeting the search criteria.`;
          this.popupService.openPopup(
            CollectionPopupComponent,
            message,
            '',
            '40%'
          );

          // Restore previous state
          if (this.lastVisibleEntities?.length === 0) {
            // Show all entities
            this.map.eachLayer((layer: any) => {
              if (layer.type === operator.toLowerCase()) {
                if (layer.getLayers) {
                  layer.eachLayer((entity: any) => {
                    if (!this.map.hasLayer(entity)) {
                      entity.addTo(this.map);
                    }
                  });
                } else {
                  if (!this.map.hasLayer(layer)) {
                    layer.addTo(this.map);
                  }
                }
              }
            });
          } else {
            // Show only last visible entities
            this.map.eachLayer((layer: any) => {
              if (layer.type === operator.toLowerCase()) {
                if (layer.getLayers) {
                  layer.eachLayer((entity: any) => {
                    if (this.lastVisibleEntities.includes(entity)) {
                      if (!this.map.hasLayer(entity)) {
                        entity.addTo(this.map);
                      }
                    } else {
                      if (this.map.hasLayer(entity)) {
                        this.map.removeLayer(entity);
                      }
                    }
                  });
                } else {
                  if (this.lastVisibleEntities.includes(layer)) {
                    if (!this.map.hasLayer(layer)) {
                      layer.addTo(this.map);
                    }
                  } else {
                    if (this.map.hasLayer(layer)) {
                      this.map.removeLayer(layer);
                    }
                  }
                }
              }
            });
          }
        }
      }
    });
  }

  // Helper method to collect unique values from layer properties
  collectUniqueValues(
    entity: any,
    uniqueFlags: Set<string>,
    uniqueDestination: Set<string>,
    uniquevesselTypes: Set<string>,
    uniqueIMONumbers: Set<string>,
    uniqueMMSIList: Set<string>,
    uniquevesselNames: Set<string>
  ) {
    // Access properties from layer's custom data
    const props =
      entity.options?.properties || entity.feature?.properties || {};

    const flag = props.Flag;
    const destination = props.Destination;
    const vesselType = props['Ship Type'];
    const MMSI = props.MMSI;
    const vesselName = props.Name;
    const IMO = props.IMO;

    if (flag && flag !== 'N/A') {
      uniqueFlags.add(flag);
    }

    if (destination && destination !== 'N/A') {
      uniqueDestination.add(destination);
    }

    if (vesselType && vesselType !== 'N/A') {
      uniquevesselTypes.add(vesselType);
    }

    if (IMO && IMO !== 'N/A') {
      uniqueIMONumbers.add(IMO);
    }

    if (MMSI && MMSI !== 'N/A') {
      uniqueMMSIList.add(MMSI);
    }

    if (vesselName && vesselName !== 'N/A') {
      uniquevesselNames.add(vesselName);
    }
  }

  checkEntityExist(entity: any, filters: any): boolean {
    let isVisible = true;

    // Access properties from layer's custom data
    const props =
      entity.options?.properties || entity.feature?.properties || {};

    const flag = props.Flag;
    const destination = props.Destination;
    const vesselLength = Number(props['Vessel Length']);
    const vesselType = props['Ship Type'];
    const MMSI = props.MMSI;
    const vesselName = props.Name;
    const IMO = props.IMO;

    let speed;
    let speedValue = props.Speed;
    if (
      speedValue !== 'N/A' &&
      speedValue !== null &&
      speedValue !== undefined
    ) {
      speed = Number(speedValue);
    }

    // Apply Flag filter
    if (filters.flag) {
      isVisible = isVisible && flag === filters.flag;
    }

    // Apply Destination filter
    if (filters.destination) {
      isVisible = isVisible && destination === filters.destination;
    }

    // Apply Vessel Type filter
    if (filters.vesselType) {
      isVisible =
        isVisible &&
        (vesselType === filters.vesselType ||
          (filters.vesselType === 'OTHER' && vesselType === null));
    }

    // Apply MMSI filter
    if (filters.MMSI) {
      isVisible = isVisible && MMSI === filters.MMSI;
    }

    // Apply IMO filter
    if (filters.IMO) {
      isVisible = isVisible && IMO === filters.IMO;
    }

    // Apply Vessel Name filter
    if (filters.vesselName) {
      isVisible = isVisible && vesselName === filters.vesselName;
    }

    // Apply Length filter
    if (!isNaN(filters.length) && !isNaN(vesselLength)) {
      if (filters.isGreater) {
        isVisible = isVisible && vesselLength > filters.length;
      } else {
        isVisible = isVisible && vesselLength < filters.length;
      }
    }

    // Apply Speed filter
    if (
      !isNaN(filters.vesselSpeed) &&
      typeof filters.vesselSpeed === 'number'
    ) {
      if (!isNaN(speed)) {
        if (filters.isSpeedGreater) {
          isVisible = isVisible && speed > filters.vesselSpeed;
        } else {
          isVisible = isVisible && speed < filters.vesselSpeed;
        }
      } else if (speedValue === 'N/A') {
        isVisible = false;
      }
    }

    return isVisible;
  }

  resetRefreshFilter(operator) {
    this.map.eachLayer((layer: any) => {
      if (layer.type === operator.toLowerCase()) {
        // If it's a layer group, iterate through its layers
        if (layer.getLayers) {
          layer.eachLayer((entity: any) => {
            if (!this.map.hasLayer(entity)) {
              entity.addTo(this.map);
            }
          });
        } else {
          // Single marker/feature
          if (!this.map.hasLayer(layer)) {
            layer.addTo(this.map);
          }
        }
      }
    });
    this.refreshFilterObject = undefined;
    this.lastVisibleEntities = [];
    this.filterVesselDataValue = false;
  }

  openFilterPopup(sensor?: any) {
    const vessels = this.vesselJsonData;

    const dialogRef = this.matdialog.open(FilterPopupComponent, {
      backdropClass: 'blurr',
      disableClose: true,
      data: {
        type: 'aisVessel',
        vesselData: vessels,
        filterObject: this.filterObject,
        refreshData: false,
        currentUser: this.currentUser,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.filterObject = result;
        const filters: FilterCriteria = {
          destination: result.destination,
          flag: result.flag,
          length: result.length,
          isGreater: result.isGreater,
          vesselType: result.vesselType,
          vesselSpeed: result.vesselSpeed,
          isSpeedGreater: result.isSpeedGreaterThan,
          vesselName: result.vesselName,
          MMSI: result.MMSI,
          IMO: result.IMO,
        };
        let filteredFeatures = this.applyVesselFilters(vessels, filters);

        if (filteredFeatures.length === 0) {
          const message = `There are no vessels meeting the search criteria.`;
          this.popupService.openPopup(
            CollectionPopupComponent,
            message,
            '',
            '40%'
          );
        } else {
          const updatedFeatures = {
            type: 'FeatureCollection',
            features: filteredFeatures,
          };
          this.sceneFilterData = true;
          this.clearSpireLayers();
          // this.removeLayerByName('spireDataSource');
          this.updateSpire(updatedFeatures, sensor);
          // this.vesselFilter = true;
        }
      }
    });
  }
  removeLayerByName(layerName: string) {
    if (this.spireLayerRef) {
      this.map.removeLayer(this.spireLayerRef);
      this.spireLayerRef = null;
    }

    // Alternative: iterate through all layers
    this.map.eachLayer((layer: any) => {
      if (layer.layerName === layerName) {
        this.map.removeLayer(layer);
      }
    });
  }

  applyVesselFilters(data: any, filterCriteria: FilterCriteria) {
    return data.features.filter((feature) => {
      const properties = feature.properties;

      // Check all filter criteria
      for (const [key, value] of Object.entries(filterCriteria)) {
        if (value === undefined || value === null || value === '') continue; // Skip empty values

        switch (key) {
          case 'destination':
            if (properties.Destination !== value) return false;
            break;

          case 'flag':
            if (properties.Flag !== value) return false;
            break;

          case 'vesselType':
            if (value === 'OTHER') {
              if (
                properties['Ship Type'] !== null &&
                properties['Ship Type'] !== 'OTHERS'
              ) {
                return false;
              }
            } else if (properties['Ship Type'] !== value) {
              return false;
            }
            break;

          case 'length':
            if (
              properties['Vessel Length'] === 'N/A' ||
              properties['Vessel Length'] === null ||
              properties['Vessel Length'] === undefined
            ) {
              return false;
            }
            const vesselLength = Number(properties['Vessel Length']);
            const filterLength = Number(value);

            if (!isNaN(vesselLength) && !isNaN(filterLength)) {
              if (filterCriteria.isGreater) {
                if (vesselLength <= filterLength) return false;
              } else {
                if (vesselLength >= filterLength) return false;
              }
            }
            break;

          case 'vesselSpeed':
            if (
              properties.Speed === 'N/A' ||
              properties.Speed === null ||
              properties.Speed === undefined
            ) {
              return false;
            }
            const speed = Number(properties.Speed);
            const filterValue = Number(value);

            if (!isNaN(speed) && !isNaN(filterValue)) {
              if (filterCriteria.isSpeedGreater) {
                if (speed <= filterValue) return false;
              } else {
                if (speed >= filterValue) return false;
              }
            }
            break;

          case 'vesselName':
            if (properties.Name !== value) return false;
            break;

          case 'MMSI':
            if (properties.MMSI !== value) return false;
            break;

          case 'IMO':
            if (properties.IMO !== value) return false;
            break;
        }
      }

      return true;
    });
  }

  private clearSpireLayers() {
    if (this.spireGroup) this.spireGroup.clearLayers();

    // defensive: remove any loose layers/markers you may have added before
    this.map.eachLayer((layer: any) => {
      if (layer?.layerName === 'spireDataSource' || layer?.type === 'spire') {
        this.map.removeLayer(layer);
      }
    });

    // if you stored markers individually, remove & reset
    if (Array.isArray(this.spireHistoricalLayer)) {
      this.spireHistoricalLayer.forEach((e: any) => {
        try {
          this.map.removeLayer(e.marker);
        } catch {}
      });
      this.spireHistoricalLayer = [];
    }

    this.spireLayerRef = null;
  }

  updateSpire(filteredGeoJson: any, sensorobj?: any) {
    const type = 'SPIRE';
    const isHistorical = false;
    const sensor = sensorobj;

    // Ensure we're working with a proper FeatureCollection
    const filteredData: GeoJSON.FeatureCollection = {
      type: 'FeatureCollection',
      features: Array.isArray(filteredGeoJson.features)
        ? filteredGeoJson.features
        : Array.isArray(filteredGeoJson)
        ? filteredGeoJson
        : [],
    };

    const spireLayer = L.geoJSON(filteredData, {
      pointToLayer: (feature, latlng) => {
        const icon = this.makeNavIconFromFeature(feature);
        const m = L.marker(latlng, {
          icon,
          zIndexOffset: 100000,
          riseOnHover: true,
          opacity: 1,
        }) as any;
        m.type = 'spire';
        m.layerName = 'spireDataSource';
        m.sensorId = this.vesselSensorId;
        m.name = 'vessel';
        return m;
      },
      onEachFeature: (ftr, lyr: any) => {
        lyr.sensorId = this.vesselSensorId;
        lyr.name = 'vessel';
        lyr.type = 'spire';
        lyr.layerName = 'spireDataSource';
        const iconOpts = (lyr as any)?.options?.icon?.options;
        const iconW = iconOpts?.iconSize?.[0] ?? 24;
        const offsetX = Math.round(iconW / 2 + 6);
        this.attachTooltip(
          lyr,
          `<span style="text-transform: capitalize;">
           ${this.formatProperties(ftr.properties)}
        </span>`
        );
        {
          sensorobj?.noOfHistoricalData &&
            lyr.on('click', () => {
              this.clickedMarker = lyr;
              if (this.clickedMarker) this.clickedMarker.closeTooltip();
              this.handleLayerClick(
                ftr,
                isHistorical,
                sensor,
                this.clickedMarker
              );
            });
        }

        this.spireHistoricalLayer.push({ marker: lyr, type });
      },
    });

    // Add to the spire group
    if (this.spireGroup) {
      spireLayer.addTo(this.spireGroup);
    } else {
      // Fallback: add directly to map if group doesn't exist
      spireLayer.addTo(this.map);
    }

    // Store reference
    this.spireLayerRef = spireLayer as any;
    (this.spireLayerRef as any).layerName = 'spireDataSource';

    // Fit bounds to filtered vessels
    if (filteredData.features.length > 0) {
      const bounds = (spireLayer as any).getBounds();
      if (bounds?.isValid?.()) {
        this.map.flyToBounds(bounds, { padding: [50, 50], duration: 3 });
      }
    }
  }

 safeDate(v: any) {
  return new Date(v);
 }
  clearFilter(sensorobj: any) {
    this.updateSpire(this.vesselJsonData, sensorobj);
    this.sceneFilterData = false;
    this.filterObject = undefined;
  }

  uncheckAll(isChecked: boolean) {
    this.jump = false;
    this.timeseries = false;
    this.showDailyRecurrencyCheckboxes = false;
    if (this.collection?.opportunities) {
      this.collection.opportunities.forEach((o) => (o.checked = false));
    }
    if (this.collection?.recurrencyArray) {
      this.collection.recurrencyArray.forEach((r) => (r.checked = false));
    }
    if (this.selectedSubDailyItemsNew) {
      this.selectedSubDailyItemsNew.forEach((i) => (i.checked = false));
    }
    if (this.selectedSites) {
      this.selectedSites.forEach((s) => {
        if (s) {
          s.checked = false;
        }
      });
    }
    this.uncheckDeepInPlace(this.collection);
    this.uncheckDeepInPlace(this.collections);
    this.uncheckDeepInPlace(this.selectedSites);
    this.uncheckDeepInPlace(this.selectedSubDailyItemsNew);
  }
  // flips every `checked` it finds to false, recursively (arrays + plain objects)
  uncheckDeepInPlace(value: any): void {
    if (Array.isArray(value)) {
      for (const v of value) this.uncheckDeepInPlace(v);
      return;
    }
    if (value && typeof value === 'object') {
      if ('checked' in value) (value as any).checked = false;
      for (const k of Object.keys(value)) {
        const child = (value as any)[k];
        if (child && (Array.isArray(child) || typeof child === 'object')) {
          this.uncheckDeepInPlace(child);
        }
      }
    }
  }
  getMessage() {
    let message =
      'The scene does not have metadata mapped. However, full metadata is included in the zip with the download.';
    this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
    this.spinnerService.hide();
  }
  showDownloadError() {
    const message =
      'Something interrupted your previous download and prevented its completion. Please download again.';
    this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
    this.resetDownload();
    this.spinnerService.hide();
  }
  resetDownload() {
    this.downloadService.unsubscribeProgress();
    this.spinnerService.hide();
    this.mapLoad = false;
    this.freeze = false;
  }
  getRefundStatus(sensor) {
    let status = sensor?.operatorKey == OPERATORS.AZISTA && sensor.downloaded;
    return status;
  }
  inactivateRefundStatus(sensor) {
    let status = sensor?.operatorKey == OPERATORS.AZISTA && !sensor.downloaded;
    return status;
  }

  onObservationToggle(event: any, info: any): void {
    const isChecked = !!event?.checked;
    this.checkedObservation = isChecked;
    this.observationEnabled = isChecked;
    if (isChecked) {
      this.renderObservation(info);
    } else {
      this.removeObservationMarker();
    }
  }

  private isVesselLengthObservation(info: any): boolean {
    const observationName = String(
      info?.observationName ?? info?.name ?? ''
    ).trim();
    return observationName.toLowerCase() === 'vessel length';
  }

  private parseVesselLengthObservationThreshold(info: any): number | null {
    const rawValue = String(info?.observationValue ?? '').trim();
    if (!rawValue) {
      return null;
    }

    const threshold = Number.parseFloat(rawValue);
    if (!Number.isFinite(threshold)) {
      return null;
    }

    return threshold;
  }

  private parseVesselLengthObservationOperator(info: any): boolean {
    const operator = String(info?.action ?? info?.operator ?? '')
      .trim()
      .toLowerCase();

    if (operator === 'lesser') {
      return false;
    }

    if (operator === 'greater') {
      return true;
    }

    return true;
  }

  private showObservationError(message: string): void {
    this.spinnerService.hide();
    this.mapLoad = false;
    const dialog = this.popupService.openPopup(
      CollectionPopupComponent,
      message,
      '',
      '40%'
    );
    dialog.afterClosed().subscribe(() => {
      this.resetObservationSelection();
    });
  }

  private async applyVesselLengthObservationOverlay(info: any): Promise<void> {
    const isTiffObservation = this.imageType !== 'png';
    const threshold = this.parseVesselLengthObservationThreshold(info);
    if (threshold === null) {
      this.showObservationError(
        'The vessel length observation value is not available for this scene.'
      );
      return;
    }
    const keepGreater = this.parseVesselLengthObservationOperator(info);
    const cancel$ = isTiffObservation ? this.beginTiffWfsLoad('observation') : undefined;

    this.spinnerService.show();
    this.mapLoad = true;

    try {
      const result: VesselObservationResult =
        await this.observationVesselService.resolveVesselLengthObservation(
          {
            collection: this.collection,
            collections: this.collections,
            collectionIndex: this.collectionIndex,
            currentTaskId: this.currentTaskId,
            taskId: this.taskid,
            currentUserId: this.currentUser?.id,
            imageType: this.imageType,
            combinedScenes: this.combinedScenes,
            sceneIdList: this.scenIdList,
            infoserviceModelType: this.infoserviceModelType,
            cachedTiffResult: this.responseResult,
            cancel$: cancel$ ? merge(this.destroy$, cancel$) : this.destroy$,
            loadSceneTiffResult: async (sensorObj, selectedScene) => {
              await this.fetchImageFromServerWithResult(
                this.collection,
                sensorObj,
                selectedScene
              );
              return this.responseResult;
            },
          },
          threshold,
          keepGreater
        );

      if (cancel$?.isStopped) return;
      if (result.status !== 'success') {
        if (result.status === 'observationUnavailable') {
          this.showObservationError(
            'The vessel length observation is not available for this scene.'
          );
          return;
        }

        if (result.status === 'dataUnavailable') {
          this.showObservationError(
            'The vessel length observation data is not available for this scene.'
          );
          return;
        }

        this.showObservationError(
          'There are no vessels meeting the vessel length observation criteria.'
        );
        return;
      }

      const matchedFeatures = result.matchedFeatures;
      const observationPanelConfig = result.panelConfig;

      this.clearObservationFeedPanel();

      if (observationPanelConfig) {
        const resultKey = this.feedFilterService.getResultKey(
          observationPanelConfig?.type
        );
        const feedResults = { [resultKey]: matchedFeatures.length };
        const panelColor = '#D32F2F';
        const vm = this.helperService.buildFeedSections(
          observationPanelConfig,
          feedResults,
          panelColor
        );
        const observationSections = vm.sections.map((section: any) => ({
          ...section,
          items: (section?.items || []).map((item: any) => ({
            ...item,
            text:
              typeof item?.text === 'string'
                ? item.text.replace(
                    /^Vessel count\s*:/i,
                    'Observation vessel count :'
                  )
                : item?.text,
          })),
        }));
        const title = info?.observationName || info?.name || 'Observation';
        this.addFeedPanel(
          this.getObservationFeedPanelKey(),
          title,
          panelColor,
          observationSections
        );
      }

      this.ensureVectorPane(11000);

      const overlayLayer = (L as any).geoJSON(
        {
          type: 'FeatureCollection',
          features: matchedFeatures,
        },
        {
          pane: 'vector-overlays',
          style: (feature: any) => ({
            color: feature?.properties?._color || '#D32F2F',
            fillColor: feature?.properties?._color || '#D32F2F',
            opacity: 1,
            fillOpacity: 0.18,
            weight: 3,
          }),
          pointToLayer: (feature: any, latlng: any) =>
            L.circleMarker(latlng, {
              pane: 'vector-overlays',
              radius: 6,
              color: feature?.properties?._color || '#D32F2F',
              fillColor: feature?.properties?._color || '#D32F2F',
              opacity: 1,
              fillOpacity: 0.9,
              weight: 3,
            }),
          onEachFeature: (feature: any, layer: any) => {
            attachVesselHoverPopup({
              layer,
              feature,
              feedName: info?.observationName || info?.name || 'Observation',
              map: this.map,
              nonVesselFeed: this.nonVesselFeed,
              helperService: this.helperService,
              nudgeInsideView: this.nudgeInsideView.bind(this),
              pickDirection: this.pickDirection.bind(this),
              showEeTooltip: this.showFeatureTooltip.bind(this),
            });
          },
        }
      ).addTo(this.map);
      overlayLayer.bringToFront?.();

      this.observationMarkerEntity = overlayLayer as L.Layer;
      const bounds = overlayLayer.getBounds?.();
      if (bounds?.isValid?.()) {
        this.map.fitBounds(bounds, { padding: [20, 20] });
      }
      if (isTiffObservation) {
        this.observationViewport = new ObservationViewportController(this.map, overlayLayer, matchedFeatures);
      }
    } finally {
      if (cancel$) this.finishTiffWfsLoad('observation', cancel$);
      this.spinnerService.hide();
      this.mapLoad = false;
    }
  }

  async renderObservation(info: any) {
    const observationSensor = this.findSensorForObservation(info);
    const observationScene = this.getCheckedValidScenes(observationSensor)[0] ?? null;

    if (
      info?.thermal_observation === true &&
      info?.data_type === 'area' &&
      (this.imageType === 'tiff' || this.imageType === 'tif')
    ) {
      const matchedShape =
        (this.responseResult?.layer?.shapes ?? []).find((shape: any) => {
          const layerName = String(shape?.layerName ?? shape?.layername ?? '').trim();
          const infoLayerName = String(info?.layerName ?? info?.layername ?? '').trim();
          const shapeId = String(shape?.id ?? '').trim();
          const infoId = String(info?.id ?? '').trim();

          if (infoLayerName && layerName && layerName === infoLayerName) return true;
          if (infoId && shapeId && shapeId === infoId) return true;
          if (!infoLayerName && !infoId && layerName) return true;
          return false;
        }) ?? null;

      const layerName = matchedShape?.layerName ?? matchedShape?.layername;
      if (layerName) {
        const storageKey = 'thermal-observation';
        const baseCql = matchedShape?.cql ?? null;
        const cancel$ = this.beginTiffWfsLoad(storageKey);
        try {
          const geojson = await this.loadViewportGeojson(
            layerName,
            baseCql,
            undefined,
            cancel$,
            'immediate'
          );

          const features = Array.isArray(geojson?.features) ? geojson.features : [];

          if (features.length) {
            this.removeThermalObservationLayer();

            const featureCollection: GeoJSON.FeatureCollection = {
              type: 'FeatureCollection',
              features,
            };

            this.ensureVectorPane(11000);

            const layer = L.geoJSON(featureCollection, {
              pane: 'vector-overlays',
              style: {
                color: '#ff4500',
                weight: 1,
                fillColor: '#ff4500',
                fillOpacity: 1,
              },
              onEachFeature: (feature: any, lyr: any) => {
                const temperature = feature?.properties?.min_temp_K;
                const coordinates = feature?.geometry?.coordinates;
                const centroidCoordinates = coordinates?.[0]?.[0];

                const loc = Array.isArray(centroidCoordinates)
                  ? centroidCoordinates.join(', ')
                  : '';

                const locParts = String(loc).split(',').map((p) => p.trim());

                lyr.on('mouseover', (e: any) => {
                  const tooltipDiv = this.thermalTooltipDiv ?? this.createTooltipDiv();
                  this.thermalTooltipDiv = tooltipDiv;
                  tooltipDiv.innerHTML = `
                    <div style="line-height:1.6;">
                      <div><strong>Mean Temperature:</strong> ${temperature}K</div>
                      <div><strong>Lng:</strong> ${loc !== '' ? locParts[0] : ''}</div>
                      <div><strong>Lat:</strong> ${loc !== '' ? locParts[1] : ''}</div>
                    </div>`;
                  tooltipDiv.style.display = 'block';
                  this.updateTooltipPosition(e, tooltipDiv);
                });

                lyr.on('mousemove', (e: any) => {
                  if (this.thermalTooltipDiv) this.updateTooltipPosition(e, this.thermalTooltipDiv);
                });

                lyr.on('mouseout', () => {
                  if (this.thermalTooltipDiv) this.thermalTooltipDiv.style.display = 'none';
                });
              },
            }).addTo(this.map);

            layer.bringToFront?.();
            this.thermalObservationLayer = layer as L.Layer;

            this.feedLayers[storageKey] = layer;
            this.viewportGeojsonRender.set(storageKey, { geoKey: storageKey, layer });
            this.viewportGeojson.startSession({
              storageKey,
              layerName,
              baseCql,
              renderMode: 'immediate',
            });

            const bounds = layer.getBounds?.();
            if (bounds?.isValid?.()) {
              this.map.fitBounds(bounds, { padding: [20, 20] });
            }
            this.applyThermalObservationOpacity();
            return;
          }
        } finally {
          this.finishTiffWfsLoad(storageKey, cancel$);
        }
      }

      this.showObservationError('The thermal observation is not available for this scene.' );
      return;
    }

    if (info?.thermal_observation === true && info?.data_type === 'area') {
      if (!observationSensor || !observationScene) {
        this.showObservationError( 'The thermal observation is not available for this scene.' );
        return;
      }
    }

    if (renderThermalObservation(this, observationSensor, observationScene, info, this.imageType)) {
      return;
    }

    if (this.isVesselLengthObservation(info)) {
      this.removeObservationMarker();
      await this.applyVesselLengthObservationOverlay(info);
      return;
    }

    this.removeObservationMarker();

    const raw = (info?.observationValue ?? '').trim();
    const parts = raw.split(',').map((s) => parseFloat(s));

    const addCrossMarker = (lon: number, lat: number , className?: string) => {
      // Remove existing marker if any
      if (this.observationMarkerEntity) {
        this.map.removeLayer(this.observationMarkerEntity);
      }

      // Create custom icon
      const customIcon = !className ? L.icon({
        iconUrl: 'assets/images/marker-icon.png',
        iconSize: [20, 30],
        iconAnchor: [10, 30],
        popupAnchor: [0, -30],
      }) : L.divIcon({
        className: className,
        html: '<span class="cross-icon"></span>',
        iconSize: [20, 20],
        iconAnchor: [10, 10],
      });

      // Add marker to map
      this.observationMarkerEntity = L.marker([lat, lon], {
        icon: customIcon,
      }).addTo(this.map);
    };

    if (
      parts.length === 2 &&
      Number.isFinite(parts[0]) &&
      Number.isFinite(parts[1])
    ) {
      const [lon, lat] = parts;

      addCrossMarker(lon, lat);

      // Fly to location with animation
      this.map.flyTo([lat, lon], 15, {
        duration: 2.5, // duration in seconds
      });
    }

    try {
      const getClosedPolygonGeometry = (value: string): any | null => {
        try {
          const pairStrings = value
            .split(';')
            .map((v) => v.trim())
            .filter((v) => v.length > 0);

          if (pairStrings.length >= 4) {
            const ring = pairStrings
              .map((pair) => pair.split(',').map((n) => Number(n.trim())))
              .filter(
                (coords) =>
                  coords.length >= 2 &&
                  Number.isFinite(coords[0]) &&
                  Number.isFinite(coords[1])
              )
              .map((coords) => [coords[0], coords[1]]);

            if (ring.length >= 4) {
              const first = ring[0];
              const last = ring[ring.length - 1];
              const isClosed =
                first[0] === last[0] && first[1] === last[1];

              if (isClosed) {
                return { type: 'Polygon', coordinates: [ring] };
              }
            }
          }

          const parsed = JSON.parse(value);
          let geometry = parsed?.type === 'Feature' ? parsed.geometry : parsed;

          if (Array.isArray(parsed)) {
            if (Array.isArray(parsed?.[0]?.[0]?.[0])) {
              geometry = { type: 'MultiPolygon', coordinates: parsed };
            } else {
              geometry = {
                type: 'Polygon',
                coordinates: Array.isArray(parsed?.[0]?.[0]) ? parsed : [parsed],
              };
            }
          }

          const isClosedRing = (ring: any): boolean => {
            if (!Array.isArray(ring) || ring.length < 4) return false;
            const first = ring[0];
            const last = ring[ring.length - 1];
            return (
              Array.isArray(first) &&
              Array.isArray(last) &&
              first.length >= 2 &&
              last.length >= 2 &&
              Number(first[0]) === Number(last[0]) &&
              Number(first[1]) === Number(last[1])
            );
          };

          if (geometry?.type === 'Polygon') {
            const rings = geometry?.coordinates || [];
            if (rings.some((ring: any) => isClosedRing(ring))) {
              return geometry;
            }
          }

          if (geometry?.type === 'MultiPolygon') {
            const polygons = geometry?.coordinates || [];
            const hasClosedRing = polygons.some((polygon: any) =>
              Array.isArray(polygon) &&
              polygon.some((ring: any) => isClosedRing(ring))
            );
            if (hasClosedRing) {
              return geometry;
            }
          }
        } catch (e) {}

        return null;
      };

      const polygonGeometry = getClosedPolygonGeometry(raw);
      if (polygonGeometry) {
        this.removeObservationMarker();
        const layer = L.geoJSON(
          { type: 'Feature', geometry: polygonGeometry, properties: {} } as any,
          {
            style: {
              color: '#1059A9',
              weight: 2,
              fillColor: '#1059A9',
              fillOpacity: 0.18,
            },
          }
        ).addTo(this.map);

        this.observationMarkerEntity = layer as any;
        const bounds = layer.getBounds();
        if (bounds.isValid()) {
          this.map.fitBounds(bounds, { padding: [20, 20] });
        }
        return;
      }

      const coordinates = this.getCoordinatesByUnknownKey(
        this.selectedHistory,
        raw
      );
      if (coordinates) {
        const [lon, lat] = coordinates;

        addCrossMarker(lon, lat);

        // Fly to location with animation
        this.map.flyTo([lat, lon], 15, {
          duration: 2.5,
        });
        return;
      } else if(info?.thermal_observation === true && info?.data_type === 'location'){
        const [lon, lat] = raw.replace(";", "").split(",").map(Number);

        let className = 'thermal-observation-marker';
        addCrossMarker(lon, lat , className);

        this.attachTooltip(
          this.observationMarkerEntity,
          buildObservationTooltipContent(info, this.datePipe)
        );

        this.applyThermalObservationOpacity();

        // Fly to location with animation
        this.map.flyTo([lat, lon], 15, {
          duration: 2.5,
        });
        return;

      } else {
        this.spinnerService.hide();
        this.mapLoad = false;
        let message =
          'The observation of interest is not present in the area of interest.';
        const dialog = this.popupService.openPopup(
          CollectionPopupComponent,
          message,
          '',
          '40%'
        );
        dialog.afterClosed().subscribe((res) => {
          this.resetObservationSelection();
          return;
        });
      }
    } catch (err) {
      const message =
        'An error occurred during processing and ingestion of the request. Please try after sometime.';
      const dialog = this.popupService.openPopup(
        CollectionPopupComponent,
        message,
        '',
        '40%'
      );
      dialog.afterClosed().subscribe((res) => {
        this.resetObservationSelection();
      });
    }
  }

  getCoordinatesByUnknownKey(historyMap: any, searchValue: any) {
    const allFeatures: any[] = [];

    for (const key in historyMap) {
      if (historyMap[key]?.features) {
        allFeatures.push(...historyMap[key].features);
      }
    }

    const match = allFeatures.find((feature) => {
      const props = feature.properties ?? {};
      return Object.values(props).some((val) => val == searchValue);
    });
    return match?.geometry?.coordinates ?? null;
  }

  resetObservationSelection(): void {
    this.checkedObservation = false;
    this.observationEnabled = false;
    this.removeObservationMarker();
  }

  removeObservationMarker(): void {
    this.cancelTiffWfsLoads((key) => key === 'observation');
    this.observationViewport?.destroy();
    this.observationViewport = undefined;
    this.clearObservationFeedPanel();
    this.removeThermalObservationLayer();
    if (this.observationMarkerEntity) {
      this.map.removeLayer(this.observationMarkerEntity);
      this.observationMarkerEntity = null;
    }
    this.restoreThermalObservationOpacity();
  }
  isObservation(sensor: any) {
    return (
      sensor?.tnqSensorType === 'Tipping' &&
      sensor?.Observation.length > 0 &&
      (sensor?.Observation[0]?.ais_observation == true ||
        sensor?.Observation[0]?.rf_observation == true
      )
    );
  }

  createTooltipDiv(): HTMLDivElement {
    const tooltipDiv = document.createElement('div');

    tooltipDiv.className = 'custom-tooltip';
    tooltipDiv.style.position = 'absolute';
    tooltipDiv.style.pointerEvents = 'none';
    tooltipDiv.style.background = '#000';
    tooltipDiv.style.color = 'white';
    tooltipDiv.style.padding = '10px';
    tooltipDiv.style.border = '1px solid black';
    tooltipDiv.style.fontSize = '15px';
    tooltipDiv.style.display = 'none';
    tooltipDiv.style.zIndex = '1000';
    tooltipDiv.style.maxWidth = '300px';
    tooltipDiv.style.minWidth = '200px';
    tooltipDiv.style.lineHeight = '1.8';
    tooltipDiv.style.fontFamily = 'Barlow, sans-serif';
    const mapEl = document.getElementById('map')!;
    mapEl.style.position = 'relative';
    mapEl.appendChild(tooltipDiv);

    return tooltipDiv;
  }

  updateTooltipPosition(e: any, tooltipDiv: HTMLDivElement) {
    const mapEl = document.getElementById('map')!;
    const mapRect = mapEl.getBoundingClientRect();
    const tooltipRect = tooltipDiv.getBoundingClientRect();

    let x = e.originalEvent.clientX - mapRect.left + 10;
    let y = e.originalEvent.clientY - mapRect.top + 10;

    // Flip if overflowing
    if (x + tooltipRect.width > mapRect.width) {
      x = e.originalEvent.clientX - mapRect.left - tooltipRect.width - 10;
    }
    if (y + tooltipRect.height > mapRect.height) {
      y = e.originalEvent.clientY - mapRect.top - tooltipRect.height - 10;
    }

    // Clamp
    x = Math.max(5, Math.min(x, mapRect.width - tooltipRect.width - 5));
    y = Math.max(5, Math.min(y, mapRect.height - tooltipRect.height - 5));

    tooltipDiv.style.left = `${x}px`;
    tooltipDiv.style.top = `${y}px`;
  }

  attachTooltip(layer: any, content: string) {
    const tooltipDiv = this.createTooltipDiv();
    tooltipDiv.innerHTML = content;

    layer.on('mouseover', (e: any) => {
      tooltipDiv.style.display = 'block';
      this.updateTooltipPosition(e, tooltipDiv);
    });

    layer.on('mouseout', () => {
      tooltipDiv.style.display = 'none';
    });

    layer.on('mousemove', (e: any) => {
      this.updateTooltipPosition(e, tooltipDiv);
    });
  }

  isPartialDelivery(res: any) {
    if (res?.isPartialApproved === false && res?.partialPayment === true) {
      this.popupService.openPopup(
        CollectionPopupComponent,
        'partial-delivery',
        '',
        '40%'
      );
      return true;
    }
    return false;
  }

loadTimeSeriesDataObject(info: any, index: number) {
  const recurrencyItem = info?.recurrencyArray?.[index];
  const infoService = recurrencyItem?.InfoServices?.[0];
  const cached = infoService?.insightDatas ?? [];
  const sceneSelected = recurrencyItem?.scenes?.[0]?.id;

  if (!cached.length || !infoService) {
    this.spinnerService.hide();
    this.mapLoad = false;
    this.opManager.completeOperation();
    return;
  }

  // AXELSPACE – take first insight directly
  if (info.sensors?.[0]?.operatorKey === OPERATORS.AXELSPACE) {
    const insight = cached[0];
    this.displayISNew(insight, infoService);
    this.displayedIS = JSON.parse(JSON.stringify(insight));
    this.opManager.completeOperation();
    return;
  }

  // Scene-based selection
  if (sceneSelected) {
    const insight = cached.find(
      (sc: any) => sc.sceneId === sceneSelected
    );

    if (insight) {
      insight._id = infoService._id;
      this.displayISNew(insight, infoService);
      this.displayedIS = JSON.parse(JSON.stringify(insight));
    }

    this.opManager.completeOperation();
    return;
  }

  // Multiple scenes case
  if (this.scenIdList?.length) {
    this.scenIdList.forEach((sceneId) => {
      const insight = cached.find(
        (sc: any) => sc.sceneId === sceneId
      );

      if (insight) {
        insight._id = infoService._id;
        this.displayISNew(insight, infoService);
        this.displayedIS = JSON.parse(JSON.stringify(insight));
      }
    });
  }

  this.opManager.completeOperation();
}

sameDay(start?: string | Date, end?: string | Date): boolean {
  if (!start || !end) return false;

  const s = new Date(start);
  const e = new Date(end);

  return (
    s.getUTCDate() === e.getUTCDate() &&
    s.getUTCMonth() === e.getUTCMonth() &&
    s.getUTCFullYear() === e.getUTCFullYear()
  );
  }

  getBandMinMax(workspace: string, sceneId: string, bands: any) {
  const bandId = bands.map((bandValue: any) => bandValue?.id);
  return this.apiService
    .getBandMinMax(workspace, sceneId, bandId)
    .pipe(take(1));
  }

  private shouldLoadBandInfoForScene(scene: any): boolean {
    if (this.selectedBands.length === 0) {
      return false;
    }

    return (
      scene?.operatorKey == this.OPERATOR.OSK ||
      scene?.isChangeDetectionCurrentWeekTab
    );
  }

  removeVesselLabelLayer(layer: any) {
        const vesselLabels = (layer as any)._vesselLabels;
      if (vesselLabels && Array.isArray(vesselLabels)) {
        vesselLabels.forEach((labelMarker) => {
          if (this.map.hasLayer(labelMarker)) {
            this.map.removeLayer(labelMarker);
          }
        });
      }
  }

  setDownloadedStatusForSensors(sensorObj: any, taskId: string){
    const collection = this.collections.find((c: any) => c.taskId === taskId);
      if (collection) {
        const sensor = collection.sensors.find((s: any) =>
          s.id === sensorObj.sensorId ||
          (Array.isArray(sensorObj.sceneId)
            ? sensorObj.sceneId.some((scId: string) => s.scenes?.some((sc: any) => sc.id === scId))
            : s.scenes?.some((sc: any) => sc.id === sensorObj.sceneId))
        );
        if (sensor && !this.downloadedSensor.includes(sensor.id)) {
          this.downloadedSensor.push(sensor.id);
        }
      }
  }


}
